webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	__webpack_require__(3);
	__webpack_require__(5);
	__webpack_require__(7);
	__webpack_require__(9);
	__webpack_require__(15);
	__webpack_require__(16);
	__webpack_require__(17);
	__webpack_require__(18);
	__webpack_require__(22);
	__webpack_require__(24);
	__webpack_require__(29);
	__webpack_require__(31);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	__webpack_require__(39);
	__webpack_require__(40);
	__webpack_require__(41);
	var api_module_1 = __webpack_require__(42);
	var auth_module_1 = __webpack_require__(189);
	var discharge_module_1 = __webpack_require__(199);
	var error_module_1 = __webpack_require__(243);
	var hydromet_module_1 = __webpack_require__(245);
	var login_module_1 = __webpack_require__(329);
	var news_module_1 = __webpack_require__(342);
	var operational_module_1 = __webpack_require__(347);
	var forecasting_module_1 = __webpack_require__(430);
	var snackbar_module_1 = __webpack_require__(450);
	var station_module_1 = __webpack_require__(456);
	var meteostation_module_1 = __webpack_require__(515);
	var utils_module_1 = __webpack_require__(554);
	var locales_1 = __webpack_require__(566);
	var moment = __webpack_require__(45);
	var angulartics = __webpack_require__(569);
	var angularticsGA = __webpack_require__(571);
	angular.module('imomo', [
	    'ngSanitize',
	    'ngCookies',
	    'ngMessages',
	    'ngMaterial',
	    'pascalprecht.translate',
	    'md.data.table',
	    'uiGmapgoogle-maps',
	    'nemLogging',
	    'ngFileUpload',
	    'ui.router',
	    'highcharts-ng',
	    angulartics,
	    angularticsGA,
	    api_module_1.default,
	    auth_module_1.default,
	    discharge_module_1.default,
	    error_module_1.default,
	    hydromet_module_1.default,
	    login_module_1.default,
	    news_module_1.default,
	    operational_module_1.default,
	    forecasting_module_1.default,
	    snackbar_module_1.default,
	    station_module_1.default,
	    meteostation_module_1.default,
	    utils_module_1.default
	]).config(['$translateProvider', '$mdDateLocaleProvider', 'uiGmapGoogleMapApiProvider',
	    function config($translateProvider, $mdDateLocaleProvider, uiGmapGoogleMapApiProvider) {
	        locales_1.translateSources($translateProvider);
	        $mdDateLocaleProvider.formatDate = function (date) {
	            return moment(date).format('MMMM DD, YYYY');
	        };
	        uiGmapGoogleMapApiProvider.configure({ key: 'AIzaSyDd0kS2obTjliCgtb3bMbmlIaYWMlEg2Ps' });
	    }
	]).run(runFunction);
	angular.element(document).ready(function () {
	    angular.bootstrap(document, ['imomo'], { strictDi: true });
	});
	function runFunction(organizationApi, $window, $rootScope, $translate, $log) {
	    adjustMomentTimezone(organizationApi, $window);
	    locales_1.adjustMomentLocale($rootScope, $translate, $log);
	}
	function adjustMomentTimezone(organizationApi, $window) {
	    var timezone = $window.localStorage.getItem('orgTimezone');
	    if (timezone) {
	        moment.tz.setDefault(timezone);
	    }
	    else {
	        organizationApi.getOrganization(parseInt($window.localStorage.getItem('currentOrgId'), 10))
	            .then(function (org) {
	            moment.tz.setDefault(org.timezone);
	            $window.localStorage.setItem('orgTimezone', org.timezone);
	        });
	    }
	}
	runFunction.$inject = ['organizationApi', '$window', '$rootScope', '$translate', '$log'];


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * highcharts-ng
	 * @version v1.2.1 - 2018-05-14
	 * @link https://github.com/pablojim/highcharts-ng
	 * @author Barry Fitzgerald <>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports){
	  module.exports = 'highcharts-ng';
	}
	
	(function () {
	  'use strict';
	  /*global angular: false*/
	  var Highcharts = null;
	
	  if (window && window.Highcharts) {
	    Highcharts = window.Highcharts;
	  } else if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
	    module.exports === 'highcharts-ng'
	  ) {
	        Highcharts = __webpack_require__(32);
	  }
	
	
	  angular.module('highcharts-ng', [])
	    .component('highchart', {
	      bindings: {
	        config: '<',
	        changeDetection: '<',
	        disableChangeDetection: '<'
	      },
	      controller: HighChartNGController
	    });
	
	  HighChartNGController.$inject = ['$element', '$timeout'];
	
	  function HighChartNGController($element, $timeout) {
	    var initialized = false;
	    var seriesId = 0;
	    var yAxisId = 0;
	    var xAxisId = 0;
	    var ctrl = this;
	    var prevConfig = {};
	    var mergedConfig = {};
	    var detector = ctrl.changeDetection || angular.equals;
	
	    this.$onInit = function () {
	      initChart();
	      initialized = true;
	    };
	
	    this.$onChanges = function(changesObject) {
	      if (changesObject.config && changesObject.config.currentValue !== undefined) {
	        if (!initialized) {
	          return;
	        }
	        initChart();
	      }
	    };
	
	    this.removeItems = function (newItems, chartItems, id, toIgnore) {
	      if (newItems && Array.isArray(newItems)) {
	        var ids = ensureIds(newItems, id);
	        for (var i = chartItems.length - 1; i >= 0; i -= 1) {
	          var a = chartItems[i];
	          if ((toIgnore.indexOf(a.options.id) < 0) && (ids.indexOf(a.options.id) < 0)) {
	            //if we don't set redraw to true, it can create
	            //glitches in the chart's rendering where the series
	            //doesn't completely re-render
	            a.remove(true);
	          }
	        }
	      }
	
	    };
	
	    this.removeUnlinkedObjects = function (mergedConfig) {
	      /*
	       Removes unlinked objects, items that have been removed in the config,
	       but not yet removed from the HighChart object
	       */
	      //First check to see if there are any axes that need to be removed
	      //If a series is linked to the axis, it will be removed by HighCharts
	      this.removeItems(mergedConfig.yAxis, ctrl.chart.yAxis, yAxisId, 'navigator-y-axis');
	      this.removeItems(mergedConfig.xAxis, ctrl.chart.xAxis, xAxisId, 'navigator-x-axis');
	      this.removeItems(mergedConfig.series, ctrl.chart.series, seriesId, 'highcharts-navigator-series');
	      //TODO do we need to handle removing series from the config that highcharts has removed as part
	      //of removing axes?
	    };
	
	    this.addAnyNewAxes = function (configAxes, chart, isX) {
	      if (configAxes && Array.isArray(configAxes)) {
	          angular.forEach(configAxes, function (s) {
	            if (!chart.get(s.id)) {
	              chart.addAxis(s, isX);
	            }
	          });
	        }
	    };
	
	    this.$doCheck = function () {
	      if (ctrl.disableChangeDetection === true) {
	        return;
	      }
	      if (!detector(ctrl.config, prevConfig)) {
	        prevConfig = angular.merge({}, ctrl.config);
	        mergedConfig = getMergedOptions($element, ctrl.config, seriesId);
	
	        //Remove any unlinked objects before adding
	        this.removeUnlinkedObjects(mergedConfig);
	
	        //Allows dynamic adding Axes
	        this.addAnyNewAxes(mergedConfig.yAxis, ctrl.chart, false);
	        this.addAnyNewAxes(mergedConfig.xAxis, ctrl.chart, true);
	
	        //Allows dynamic adding of series
	        if (mergedConfig.series) {
	          // Add any new series
	          angular.forEach(ctrl.config.series, function (s) {
	            if (!ctrl.chart.get(s.id)) {
	              ctrl.chart.addSeries(s);
	            }
	          });
	        }
	
	        ctrl.chart.update(mergedConfig, true);
	      }
	    };
	
	    this.$onDestroy = function () {
	      if (ctrl.chart) {
	        try {
	          ctrl.chart.destroy();
	        } catch (ex) {
	          // fail silently as highcharts will throw exception if element doesn't exist
	        }
	
	        $timeout(function () {
	          $element.remove();
	        }, 0);
	      }
	    };
	
	    function initChart() {
	      prevConfig = angular.merge({}, ctrl.config);
	      mergedConfig = getMergedOptions($element, ctrl.config, seriesId);
	      ctrl.chart = new Highcharts[getChartType(mergedConfig)](mergedConfig);
	      ctrl.config.getChartObj = function () {
	        return ctrl.chart;
	      };
	
	      // Fix resizing bug
	      // https://github.com/pablojim/highcharts-ng/issues/550
	      var originalWidth = $element[0].clientWidth;
	      var originalHeight = $element[0].clientHeight;
	      $timeout(function () {
	        if ($element[0].clientWidth !== 0 && $element[0].clientHeight !== 0 && ($element[0].clientWidth !== originalWidth || $element[0].clientHeight !== originalHeight)) {
	          ctrl.chart.reflow();
	        }
	      }, 0, false);
	    }
	  }
	
	
	  function getMergedOptions(element, config, seriesId) {
	    var mergedOptions = {};
	
	    var defaultOptions = {
	      chart: {
	        events: {}
	      },
	      title: {},
	      subtitle: {},
	      series: [],
	      credits: {},
	      plotOptions: {},
	      navigator: {},
	    };
	
	    if (config) {
	      //check all series and axis ids are set
	      if (config.series) {
	        ensureIds(config.series, seriesId);
	      }
	
	      mergedOptions = angular.merge(defaultOptions, config);
	    } else {
	      mergedOptions = defaultOptions;
	    }
	    mergedOptions.chart.renderTo = element[0];
	
	    //check chart type is set
	    return mergedOptions;
	  }
	
	  var chartTypeMap = {
	    'stock': 'StockChart',
	    'map': 'Map',
	    'chart': 'Chart'
	  };
	
	  function getChartType(config) {
	    if (config === undefined || config.chartType === undefined) return 'Chart';
	    return chartTypeMap[('' + config.chartType).toLowerCase()];
	  }
	
	  function ensureIds(chartCollection, collectionId) {
	    /*
	     Ensures each item in the iteratble chartCollection has an id,
	     and if not auto-generates one incrementing collectionId
	     */
	    var ids = [];
	    angular.forEach(chartCollection, function (s) {
	      if (!angular.isDefined(s.id)) {
	        collectionId += 1;
	        s.id = 'cc-' + collectionId;
	      }
	      ids.push(s.id);
	    });
	
	    return ids;
	  }
	
	
	}());


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Highcharts JS v7.2.2 (2020-08-24)
	
	 (c) 2009-2018 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(P,M){"object"===typeof module&&module.exports?(M["default"]=M,module.exports=P.document?M(P):M): true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return M(P)}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):(P.Highcharts&&P.Highcharts.error(16,!0),P.Highcharts=M(P))})("undefined"!==typeof window?window:this,function(P){function M(c,f,F,G){c.hasOwnProperty(f)||(c[f]=G.apply(null,F))}var I={};M(I,"parts/Globals.js",[],function(){var c="undefined"!==typeof P?P:"undefined"!==typeof window?window:{},f=c.document,
	F=c.navigator&&c.navigator.userAgent||"",G=f&&f.createElementNS&&!!f.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,z=/(edge|msie|trident)/i.test(F)&&!c.opera,B=-1!==F.indexOf("Firefox"),t=-1!==F.indexOf("Chrome"),v=B&&4>parseInt(F.split("Firefox/")[1],10);return{product:"Highcharts",version:"7.2.2",deg2rad:2*Math.PI/360,doc:f,hasBidiBug:v,hasTouch:!!c.TouchEvent,isMS:z,isWebKit:-1!==F.indexOf("AppleWebKit"),isFirefox:B,isChrome:t,isSafari:!t&&-1!==F.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(F),
	SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:G,win:c,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[],dateFormats:{}}});M(I,"parts/Utilities.js",[I["parts/Globals.js"]],function(c){function f(a,d){return parseInt(a,d||10)}function F(a){return"string"===typeof a}function G(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a}function z(a,d){return!!a&&"object"===typeof a&&(!d||
	!G(a))}function B(a){return z(a)&&"number"===typeof a.nodeType}function t(a){var d=a&&a.constructor;return!(!z(a,!0)||B(a)||!d||!d.name||"Object"===d.name)}function v(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a}function C(a){return"undefined"!==typeof a&&null!==a}function H(a,d,e){var b;F(d)?C(e)?a.setAttribute(d,e):a&&a.getAttribute&&((b=a.getAttribute(d))||"class"!==d||(b=a.getAttribute(d+"Name"))):n(d,function(d,e){a.setAttribute(e,d)});return b}function y(a,d){var e;a||(a=
	{});for(e in d)a[e]=d[e];return a}function h(){for(var a=arguments,d=a.length,e=0;e<d;e++){var b=a[e];if("undefined"!==typeof b&&null!==b)return b}}function n(a,d,e){for(var b in a)Object.hasOwnProperty.call(a,b)&&d.call(e||a[b],a[b],b,a)}c.timers=[];var q=c.charts,g=c.doc,b=c.win;c.error=function(a,d,e,l){var g=v(a),h=g?"Highcharts error #"+a+": www.highcharts.com/errors/"+a+"/":a.toString(),p=function(){if(d)throw Error(h);b.console&&console.log(h)};if("undefined"!==typeof l){var u="";g&&(h+="?");
	c.objectEach(l,function(a,d){u+="\n"+d+": "+a;g&&(h+=encodeURI(d)+"="+encodeURI(a))});h+=u}e?c.fireEvent(e,"displayError",{code:a,message:h,params:l},p):p()};c.Fx=function(a,d,e){this.options=d;this.elem=a;this.prop=e};c.Fx.prototype={dSetter:function(){var a=this.paths[0],d=this.paths[1],e=[],b=this.now,g=a.length;if(1===b)e=this.toD;else if(g===d.length&&1>b)for(;g--;){var c=parseFloat(a[g]);e[g]=isNaN(c)||"A"===d[g-4]||"A"===d[g-5]?d[g]:b*parseFloat(""+(d[g]-c))+c}else e=d;this.elem.attr("d",e,
	null,!0)},update:function(){var a=this.elem,d=this.prop,e=this.now,b=this.options.step;if(this[d+"Setter"])this[d+"Setter"]();else a.attr?a.element&&a.attr(d,e,null,!0):a.style[d]=e+this.unit;b&&b.call(a,e,this)},run:function(a,d,e){var l=this,g=l.options,h=function(a){return h.stopped?!1:l.step(a)},p=b.requestAnimationFrame||function(a){setTimeout(a,13)},u=function(){for(var a=0;a<c.timers.length;a++)c.timers[a]()||c.timers.splice(a--,1);c.timers.length&&p(u)};a!==d||this.elem["forceAnimate:"+this.prop]?
	(this.startTime=+new Date,this.start=a,this.end=d,this.unit=e,this.now=this.start,this.pos=0,h.elem=this.elem,h.prop=this.prop,h()&&1===c.timers.push(h)&&p(u)):(delete g.curAnim[this.prop],g.complete&&0===Object.keys(g.curAnim).length&&g.complete.call(this.elem))},step:function(a){var d=+new Date,e=this.options,b=this.elem,g=e.complete,c=e.duration,p=e.curAnim;if(b.attr&&!b.element)a=!1;else if(a||d>=c+this.startTime){this.now=this.end;this.pos=1;this.update();var u=p[this.prop]=!0;n(p,function(a){!0!==
	a&&(u=!1)});u&&g&&g.call(b);a=!1}else this.pos=e.easing((d-this.startTime)/c),this.now=this.start+(this.end-this.start)*this.pos,this.update(),a=!0;return a},initPath:function(a,d,e){function b(a){for(A=a.length;A--;){var d="M"===a[A]||"L"===a[A];var e=/[a-zA-Z]/.test(a[A+3]);d&&e&&a.splice(A+1,0,a[A+1],a[A+2],a[A+1],a[A+2])}}function g(a,d){for(;a.length<h;){a[0]=d[h-a.length];var e=a.slice(0,r);[].splice.apply(a,[0,0].concat(e));w&&(e=a.slice(a.length-r),[].splice.apply(a,[a.length,0].concat(e)),
	A--)}a[0]="M"}function c(a,d){for(var e=(h-a.length)/r;0<e&&e--;)x=a.slice().splice(a.length/m-r,r*m),x[0]=d[h-r-e*r],k&&(x[r-6]=x[r-2],x[r-5]=x[r-1]),[].splice.apply(a,[a.length/m,0].concat(x)),w&&e--}d=d||"";var p=a.startX,u=a.endX,k=-1<d.indexOf("C"),r=k?7:3,x,A;d=d.split(" ");e=e.slice();var w=a.isArea,m=w?2:1;k&&(b(d),b(e));if(p&&u){for(A=0;A<p.length;A++)if(p[A]===u[0]){var K=A;break}else if(p[0]===u[u.length-p.length+A]){K=A;var J=!0;break}else if(p[p.length-1]===u[u.length-p.length+A]){K=
	p.length-A;break}"undefined"===typeof K&&(d=[])}if(d.length&&v(K)){var h=e.length+K*m*r;J?(g(d,e),c(e,d)):(g(e,d),c(d,e))}return[d,e]},fillSetter:function(){c.Fx.prototype.strokeSetter.apply(this,arguments)},strokeSetter:function(){this.elem.attr(this.prop,c.color(this.start).tweenTo(c.color(this.end),this.pos),null,!0)}};c.merge=function(){var a,d=arguments,e={},b=function(a,d){"object"!==typeof a&&(a={});n(d,function(e,k){!z(e,!0)||t(e)||B(e)?a[k]=d[k]:a[k]=b(a[k]||{},e)});return a};!0===d[0]&&
	(e=d[1],d=Array.prototype.slice.call(d,2));var g=d.length;for(a=0;a<g;a++)e=b(e,d[a]);return e};c.clearTimeout=function(a){C(a)&&clearTimeout(a)};c.css=function(a,d){c.isMS&&!c.svg&&d&&"undefined"!==typeof d.opacity&&(d.filter="alpha(opacity="+100*d.opacity+")");y(a.style,d)};c.createElement=function(a,d,e,b,L){a=g.createElement(a);var l=c.css;d&&y(a,d);L&&l(a,{padding:"0",border:"none",margin:"0"});e&&l(a,e);b&&b.appendChild(a);return a};c.extendClass=function(a,d){var e=function(){};e.prototype=
	new a;y(e.prototype,d);return e};c.pad=function(a,d,e){return Array((d||2)+1-String(a).replace("-","").length).join(e||"0")+a};c.relativeLength=function(a,d,e){return/%$/.test(a)?d*parseFloat(a)/100+(e||0):parseFloat(a)};c.wrap=function(a,d,e){var b=a[d];a[d]=function(){var a=Array.prototype.slice.call(arguments),d=arguments,l=this;l.proceed=function(){b.apply(l,arguments.length?arguments:d)};a.unshift(b);a=e.apply(this,a);l.proceed=null;return a}};c.datePropsToTimestamps=function(a){n(a,function(d,
	e){z(d)&&"function"===typeof d.getTime?a[e]=d.getTime():(z(d)||G(d))&&c.datePropsToTimestamps(d)})};c.formatSingle=function(a,d,e){var b=/\.([0-9])/,g=c.defaultOptions.lang;/f$/.test(a)?(e=(e=a.match(b))?e[1]:-1,null!==d&&(d=c.numberFormat(d,e,g.decimalPoint,-1<a.indexOf(",")?g.thousandsSep:""))):d=(e||c.time).dateFormat(a,d);return d};c.format=function(a,d,e){for(var b="{",g=!1,h,p,u,k,r=[],x;a;){b=a.indexOf(b);if(-1===b)break;h=a.slice(0,b);if(g){h=h.split(":");p=h.shift().split(".");k=p.length;
	x=d;for(u=0;u<k;u++)x&&(x=x[p[u]]);h.length&&(x=c.formatSingle(h.join(":"),x,e));r.push(x)}else r.push(h);a=a.slice(b+1);b=(g=!g)?"}":"{"}r.push(a);return r.join("")};c.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};c.normalizeTickInterval=function(a,d,e,b,g){var l=a;e=h(e,1);var p=a/e;d||(d=g?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===b&&(1===e?d=d.filter(function(a){return 0===a%1}):.1>=e&&(d=[1/e])));for(b=0;b<d.length&&!(l=d[b],g&&l*e>=a||!g&&p<=(d[b]+
	(d[b+1]||d[b]))/2);b++);return l=c.correctFloat(l*e,-Math.round(Math.log(.001)/Math.LN10))};c.stableSort=function(a,d){var b=a.length,l,g;for(g=0;g<b;g++)a[g].safeI=g;a.sort(function(a,b){l=d(a,b);return 0===l?a.safeI-b.safeI:l});for(g=0;g<b;g++)delete a[g].safeI};c.correctFloat=function(a,d){return parseFloat(a.toPrecision(d||14))};c.animObject=function(a){return z(a)?c.merge(a):{duration:a?500:0}};c.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};
	c.numberFormat=function(a,d,b,l){a=+a||0;d=+d;var e=c.defaultOptions.lang,g=(a.toString().split(".")[1]||"").split("e")[0].length,p=a.toString().split("e");if(-1===d)d=Math.min(g,20);else if(!v(d))d=2;else if(d&&p[1]&&0>p[1]){var u=d+ +p[1];0<=u?(p[0]=(+p[0]).toExponential(u).split("e")[0],d=u):(p[0]=p[0].split(".")[0]||0,a=20>d?(p[0]*Math.pow(10,p[1])).toFixed(d):0,p[1]=0)}var k=(Math.abs(p[1]?p[0]:a)+Math.pow(10,-Math.max(d,g)-1)).toFixed(d);g=String(f(k));u=3<g.length?g.length%3:0;b=h(b,e.decimalPoint);
	l=h(l,e.thousandsSep);a=(0>a?"-":"")+(u?g.substr(0,u)+l:"");a+=g.substr(u).replace(/(\d{3})(?=\d)/g,"$1"+l);d&&(a+=b+k.slice(-d));p[1]&&0!==+a&&(a+="e"+p[1]);return a};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};c.getStyle=function(a,d,e){if("width"===d)return d=Math.min(a.offsetWidth,a.scrollWidth),e=a.getBoundingClientRect&&a.getBoundingClientRect().width,e<d&&e>=d-1&&(d=Math.floor(e)),Math.max(0,d-c.getStyle(a,"padding-left")-c.getStyle(a,"padding-right"));if("height"===d)return Math.max(0,
	Math.min(a.offsetHeight,a.scrollHeight)-c.getStyle(a,"padding-top")-c.getStyle(a,"padding-bottom"));b.getComputedStyle||c.error(27,!0);if(a=b.getComputedStyle(a,void 0))a=a.getPropertyValue(d),h(e,"opacity"!==d)&&(a=f(a));return a};c.inArray=function(a,d,b){return d.indexOf(a,b)};c.find=Array.prototype.find?function(a,d){return a.find(d)}:function(a,d){var b,l=a.length;for(b=0;b<l;b++)if(d(a[b],b))return a[b]};c.keys=Object.keys;c.offset=function(a){var d=g.documentElement;a=a.parentElement||a.parentNode?
	a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(b.pageYOffset||d.scrollTop)-(d.clientTop||0),left:a.left+(b.pageXOffset||d.scrollLeft)-(d.clientLeft||0)}};c.stop=function(a,b){for(var d=c.timers.length;d--;)c.timers[d].elem!==a||b&&b!==c.timers[d].prop||(c.timers[d].stopped=!0)};n({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(a,b){c[b]=function(b){return Array.prototype[a].apply(b,[].slice.call(arguments,1))}});c.addEvent=function(a,b,e,l){void 0===l&&(l=
	{});var d=a.addEventListener||c.addEventListenerPolyfill;var g="function"===typeof a&&a.prototype?a.prototype.protoEvents=a.prototype.protoEvents||{}:a.hcEvents=a.hcEvents||{};c.Point&&a instanceof c.Point&&a.series&&a.series.chart&&(a.series.chart.runTrackerClick=!0);d&&d.call(a,b,e,!1);g[b]||(g[b]=[]);g[b].push({fn:e,order:"number"===typeof l.order?l.order:Infinity});g[b].sort(function(a,b){return a.order-b.order});return function(){c.removeEvent(a,b,e)}};c.removeEvent=function(a,b,e){function d(b,
	d){var e=a.removeEventListener||c.removeEventListenerPolyfill;e&&e.call(a,b,d,!1)}function g(e){var l;if(a.nodeName){if(b){var k={};k[b]=!0}else k=e;n(k,function(a,b){if(e[b])for(l=e[b].length;l--;)d(b,e[b][l].fn)})}}var h;["protoEvents","hcEvents"].forEach(function(l,c){var k=(c=c?a:a.prototype)&&c[l];k&&(b?(h=k[b]||[],e?(k[b]=h.filter(function(a){return e!==a.fn}),d(b,e)):(g(k),k[b]=[])):(g(k),c[l]={}))})};c.fireEvent=function(a,b,e,l){var d;e=e||{};if(g.createEvent&&(a.dispatchEvent||a.fireEvent)){var c=
	g.createEvent("Events");c.initEvent(b,!0,!0);y(c,e);a.dispatchEvent?a.dispatchEvent(c):a.fireEvent(b,c)}else e.target||y(e,{preventDefault:function(){e.defaultPrevented=!0},target:a,type:b}),function(b,l){void 0===b&&(b=[]);void 0===l&&(l=[]);var k=0,r=0,g=b.length+l.length;for(d=0;d<g;d++)!1===(b[k]?l[r]?b[k].order<=l[r].order?b[k++]:l[r++]:b[k++]:l[r++]).fn.call(a,e)&&e.preventDefault()}(a.protoEvents&&a.protoEvents[b],a.hcEvents&&a.hcEvents[b]);l&&!e.defaultPrevented&&l.call(a,e)};c.animate=function(a,
	b,e){var d,g="",h,p;if(!z(e)){var u=arguments;e={duration:u[2],easing:u[3],complete:u[4]}}v(e.duration)||(e.duration=400);e.easing="function"===typeof e.easing?e.easing:Math[e.easing]||Math.easeInOutSine;e.curAnim=c.merge(b);n(b,function(k,l){c.stop(a,l);p=new c.Fx(a,e,l);h=null;"d"===l?(p.paths=p.initPath(a,a.d,b.d),p.toD=b.d,d=0,h=1):a.attr?d=a.attr(l):(d=parseFloat(c.getStyle(a,l))||0,"opacity"!==l&&(g="px"));h||(h=k);h&&h.match&&h.match("px")&&(h=h.replace(/px/g,""));p.run(d,h,g)})};c.seriesType=
	function(a,b,e,l,g){var d=c.getOptions(),p=c.seriesTypes;d.plotOptions[a]=c.merge(d.plotOptions[b],e);p[a]=c.extendClass(p[b]||function(){},l);p[a].prototype.type=a;g&&(p[a].prototype.pointClass=c.extendClass(c.Point,g));return p[a]};c.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),b=0;return function(){return"highcharts-"+a+"-"+b++}}();c.isFunction=function(a){return"function"===typeof a};b.jQuery&&(b.jQuery.fn.highcharts=function(){var a=[].slice.call(arguments);if(this[0])return a[0]?
	(new (c[F(a[0])?a.shift():"Chart"])(this[0],a[0],a[1]),this):q[H(this[0],"data-highcharts-chart")]});return{arrayMax:function(a){for(var b=a.length,e=a[0];b--;)a[b]>e&&(e=a[b]);return e},arrayMin:function(a){for(var b=a.length,e=a[0];b--;)a[b]<e&&(e=a[b]);return e},attr:H,defined:C,destroyObjectProperties:function(a,b){n(a,function(d,l){d&&d!==b&&d.destroy&&d.destroy();delete a[l]})},discardElement:function(a){var b=c.garbageBin;b||(b=c.createElement("div"));a&&b.appendChild(a);b.innerHTML=""},erase:function(a,
	b){for(var d=a.length;d--;)if(a[d]===b){a.splice(d,1);break}},extend:y,isArray:G,isClass:t,isDOMElement:B,isNumber:v,isObject:z,isString:F,objectEach:n,pick:h,pInt:f,setAnimation:function(a,b){b.renderer.globalAnimation=h(a,b.options.chart.animation,!0)},splat:function(a){return G(a)?a:[a]},syncTimeout:function(a,b,e){if(0<b)return setTimeout(a,b,e);a.call(0,e);return-1}}});M(I,"parts/Color.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.isNumber,G=f.pInt,z=c.merge;c.Color=
	function(f){if(!(this instanceof c.Color))return new c.Color(f);this.init(f)};c.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(c){return[G(c[1]),G(c[2]),G(c[3]),parseFloat(c[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(c){return[G(c[1]),G(c[2]),G(c[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(f){var t,v;if((this.input=f=this.names[f&&
	f.toLowerCase?f.toLowerCase():""]||f)&&f.stops)this.stops=f.stops.map(function(f){return new c.Color(f[1])});else{if(f&&f.charAt&&"#"===f.charAt()){var C=f.length;f=parseInt(f.substr(1),16);7===C?t=[(f&16711680)>>16,(f&65280)>>8,f&255,1]:4===C&&(t=[(f&3840)>>4|(f&3840)>>8,(f&240)>>4|f&240,(f&15)<<4|f&15,1])}if(!t)for(v=this.parsers.length;v--&&!t;){var B=this.parsers[v];(C=B.regex.exec(f))&&(t=B.parse(C))}}this.rgba=t||[]},get:function(c){var f=this.input,v=this.rgba;if(this.stops){var C=z(f);C.stops=
	[].concat(C.stops);this.stops.forEach(function(f,v){C.stops[v]=[C.stops[v][0],f.get(c)]})}else C=v&&F(v[0])?"rgb"===c||!c&&1===v[3]?"rgb("+v[0]+","+v[1]+","+v[2]+")":"a"===c?v[3]:"rgba("+v.join(",")+")":f;return C},brighten:function(c){var f,v=this.rgba;if(this.stops)this.stops.forEach(function(f){f.brighten(c)});else if(F(c)&&0!==c)for(f=0;3>f;f++)v[f]+=G(255*c),0>v[f]&&(v[f]=0),255<v[f]&&(v[f]=255);return this},setOpacity:function(c){this.rgba[3]=c;return this},tweenTo:function(c,f){var v=this.rgba,
	t=c.rgba;t.length&&v&&v.length?(c=1!==t[3]||1!==v[3],f=(c?"rgba(":"rgb(")+Math.round(t[0]+(v[0]-t[0])*(1-f))+","+Math.round(t[1]+(v[1]-t[1])*(1-f))+","+Math.round(t[2]+(v[2]-t[2])*(1-f))+(c?","+(t[3]+(v[3]-t[3])*(1-f)):"")+")"):f=c.input||"none";return f}};c.color=function(f){return new c.Color(f)}});M(I,"parts/SvgRenderer.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.attr,G=f.defined,z=f.destroyObjectProperties,B=f.erase,t=f.extend,v=f.isArray,C=f.isNumber,H=f.isObject,
	y=f.isString,h=f.objectEach,n=f.pick,q=f.pInt,g=f.splat,b=c.addEvent,a=c.animate,d=c.charts,e=c.color,l=c.css,L=c.createElement,E=c.deg2rad,p=c.doc,u=c.hasTouch,k=c.isFirefox,r=c.isMS,x=c.isWebKit,A=c.merge,w=c.noop,m=c.removeEvent,K=c.stop,J=c.svg,U=c.SVG_NS,S=c.symbolSizes,Q=c.win;var O=c.SVGElement=function(){return this};t(O.prototype,{opacity:1,SVG_NS:U,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),
	init:function(a,b){this.element="span"===b?L(b):p.createElementNS(this.SVG_NS,b);this.renderer=a;c.fireEvent(this,"afterInit")},animate:function(b,d,m){var D=c.animObject(n(d,this.renderer.globalAnimation,!0));n(p.hidden,p.msHidden,p.webkitHidden,!1)&&(D.duration=0);0!==D.duration?(m&&(D.complete=m),a(this,b,D)):(this.attr(b,void 0,m),h(b,function(a,b){D.step&&D.step.call(this,a,{prop:b,pos:1})},this));return this},complexColor:function(a,b,d){var D=this.renderer,m,e,w,N,k,l,g,r,x,p,K,J=[],T;c.fireEvent(this.renderer,
	"complexColor",{args:arguments},function(){a.radialGradient?e="radialGradient":a.linearGradient&&(e="linearGradient");e&&(w=a[e],k=D.gradients,g=a.stops,p=d.radialReference,v(w)&&(a[e]=w={x1:w[0],y1:w[1],x2:w[2],y2:w[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===e&&p&&!G(w.gradientUnits)&&(N=w,w=A(w,D.getRadialAttr(p,N),{gradientUnits:"userSpaceOnUse"})),h(w,function(a,b){"id"!==b&&J.push(b,a)}),h(g,function(a){J.push(a)}),J=J.join(","),k[J]?K=k[J].attr("id"):(w.id=K=c.uniqueKey(),k[J]=l=
	D.createElement(e).attr(w).add(D.defs),l.radAttr=N,l.stops=[],g.forEach(function(a){0===a[1].indexOf("rgba")?(m=c.color(a[1]),r=m.get("rgb"),x=m.get("a")):(r=a[1],x=1);a=D.createElement("stop").attr({offset:a[0],"stop-color":r,"stop-opacity":x}).add(l);l.stops.push(a)})),T="url("+D.url+"#"+K+")",d.setAttribute(b,T),d.gradient=J,a.toString=function(){return T})})},applyTextOutline:function(a){var b=this.element,D;-1!==a.indexOf("contrast")&&(a=a.replace(/contrast/g,this.renderer.getContrast(b.style.fill)));
	a=a.split(" ");var d=a[a.length-1];if((D=a[0])&&"none"!==D&&c.svg){this.fakeTS=!0;a=[].slice.call(b.getElementsByTagName("tspan"));this.ySetter=this.xSetter;D=D.replace(/(^[\d\.]+)(.*?)$/g,function(a,b,D){return 2*b+D});this.removeTextOutline(a);var m=b.firstChild;a.forEach(function(a,e){0===e&&(a.setAttribute("x",b.getAttribute("x")),e=b.getAttribute("y"),a.setAttribute("y",e||0),null===e&&b.setAttribute("y",0));a=a.cloneNode(1);F(a,{"class":"highcharts-text-outline",fill:d,stroke:d,"stroke-width":D,
	"stroke-linejoin":"round"});b.insertBefore(a,m)})}},removeTextOutline:function(a){for(var b=a.length,D;b--;)D=a[b],"highcharts-text-outline"===D.getAttribute("class")&&B(a,this.element.removeChild(D))},symbolCustomAttribs:"x y width height r start end innerR anchorX anchorY rounded".split(" "),attr:function(a,b,d,e){var D=this.element,m,w=this,N,k,l=this.symbolCustomAttribs;if("string"===typeof a&&void 0!==b){var g=a;a={};a[g]=b}"string"===typeof a?w=(this[a+"Getter"]||this._defaultGetter).call(this,
	a,D):(h(a,function(b,d){N=!1;e||K(this,d);this.symbolName&&-1!==c.inArray(d,l)&&(m||(this.symbolAttr(a),m=!0),N=!0);!this.rotation||"x"!==d&&"y"!==d||(this.doTransform=!0);N||(k=this[d+"Setter"]||this._defaultSetter,k.call(this,b,d,D),!this.styledMode&&this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(d)&&this.updateShadows(d,b,k))},this),this.afterSetters());d&&d.call(this);return w},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,
	b,d){for(var D=this.shadows,e=D.length;e--;)d.call(D[e],"height"===a?Math.max(b-(D[e].cutHeight||0),0):"d"===a?this.d:b,a,D[e])},addClass:function(a,b){var D=b?"":this.attr("class")||"";a=(a||"").split(/ /g).reduce(function(a,b){-1===D.indexOf(b)&&a.push(b);return a},D?[D]:[]).join(" ");a!==D&&this.attr("class",a);return this},hasClass:function(a){return-1!==(this.attr("class")||"").split(" ").indexOf(a)},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(y(a)?new RegExp(" ?"+
	a+" ?"):a,""))},symbolAttr:function(a){var b=this;"x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(D){b[D]=n(a[D],b[D])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,b){b=b||a.strokeWidth||0;var D=Math.round(b)%2/2;a.x=Math.floor(a.x||this.x||0)+D;a.y=Math.floor(a.y||this.y||0)+D;a.width=Math.floor((a.width||this.width||
	0)-2*D);a.height=Math.floor((a.height||this.height||0)-2*D);G(a.strokeWidth)&&(a.strokeWidth=b);return a},css:function(a){var b=this.styles,D={},d=this.element,e="",m=!b,w=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);b&&h(a,function(a,d){a!==b[d]&&(D[d]=a,m=!0)});if(m){b&&(a=t(b,D));if(a)if(null===a.width||"auto"===a.width)delete this.textWidth;else if("text"===d.nodeName.toLowerCase()&&a.width)var k=this.textWidth=q(a.width);this.styles=a;k&&!J&&this.renderer.forExport&&delete a.width;
	if(d.namespaceURI===this.SVG_NS){var g=function(a,b){return"-"+b.toLowerCase()};h(a,function(a,b){-1===w.indexOf(b)&&(e+=b.replace(/([A-Z])/g,g)+":"+a+";")});e&&F(d,"style",e)}else l(d,a);this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline))}return this},getStyle:function(a){return Q.getComputedStyle(this.element||this,"").getPropertyValue(a)},strokeWidth:function(){if(!this.renderer.styledMode)return this["stroke-width"]||
	0;var a=this.getStyle("stroke-width");if(a.indexOf("px")===a.length-2)a=q(a);else{var b=p.createElementNS(U,"rect");F(b,{width:a,"stroke-width":0});this.element.parentNode.appendChild(b);a=b.getBBox().width;b.parentNode.removeChild(b)}return a},on:function(a,b){var d=this,D=d.element;u&&"click"===a?(D.ontouchstart=function(a){d.touchEventFired=Date.now();a.preventDefault();b.call(D,a)},D.onclick=function(a){(-1===Q.navigator.userAgent.indexOf("Android")||1100<Date.now()-(d.touchEventFired||0))&&b.call(D,
	a)}):D["on"+a]=b;return this},setRadialReference:function(a){var b=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;b&&b.radAttr&&b.animate(this.renderer.getRadialAttr(a,b.radAttr));return this},translate:function(a,b){return this.attr({translateX:a,translateY:b})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,b=this.translateY||0,d=this.scaleX,e=this.scaleY,m=this.inverted,w=this.rotation,k=
	this.matrix,l=this.element;m&&(a+=this.width,b+=this.height);a=["translate("+a+","+b+")"];G(k)&&a.push("matrix("+k.join(",")+")");m?a.push("rotate(90) scale(-1,1)"):w&&a.push("rotate("+w+" "+n(this.rotationOriginX,l.getAttribute("x"),0)+" "+n(this.rotationOriginY,l.getAttribute("y")||0)+")");(G(d)||G(e))&&a.push("scale("+n(d,1)+" "+n(e,1)+")");a.length&&l.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,b,d){var e,
	m={};var D=this.renderer;var w=D.alignedObjects;var k,l;if(a){if(this.alignOptions=a,this.alignByTranslate=b,!d||y(d))this.alignTo=e=d||"renderer",B(w,this),w.push(this),d=null}else a=this.alignOptions,b=this.alignByTranslate,e=this.alignTo;d=n(d,D[e],D);e=a.align;D=a.verticalAlign;w=(d.x||0)+(a.x||0);var N=(d.y||0)+(a.y||0);"right"===e?k=1:"center"===e&&(k=2);k&&(w+=(d.width-(a.width||0))/k);m[b?"translateX":"x"]=Math.round(w);"bottom"===D?l=1:"middle"===D&&(l=2);l&&(N+=(d.height-(a.height||0))/
	l);m[b?"translateY":"y"]=Math.round(N);this[this.placed?"animate":"attr"](m);this.placed=!0;this.alignAttr=m;return this},getBBox:function(a,b){var d,e=this.renderer,m=this.element,D=this.styles,w=this.textStr,k,l=e.cache,N=e.cacheKeys,g=m.namespaceURI===this.SVG_NS;b=n(b,this.rotation,0);var r=e.styledMode?m&&O.prototype.getStyle.call(m,"font-size"):D&&D.fontSize;if(G(w)){var c=w.toString();-1===c.indexOf("<")&&(c=c.replace(/[0-9]/g,"0"));c+=["",b,r,this.textWidth,D&&D.textOverflow].join()}c&&!a&&
	(d=l[c]);if(!d){if(g||e.forExport){try{(k=this.fakeTS&&function(a){[].forEach.call(m.querySelectorAll(".highcharts-text-outline"),function(b){b.style.display=a})})&&k("none"),d=m.getBBox?t({},m.getBBox()):{width:m.offsetWidth,height:m.offsetHeight},k&&k("")}catch(aa){""}if(!d||0>d.width)d={width:0,height:0}}else d=this.htmlGetBBox();e.isSVG&&(a=d.width,e=d.height,g&&(d.height=e={"11px,17":14,"13px,20":16}[D&&D.fontSize+","+Math.round(e)]||e),b&&(D=b*E,d.width=Math.abs(e*Math.sin(D))+Math.abs(a*Math.cos(D)),
	d.height=Math.abs(e*Math.cos(D))+Math.abs(a*Math.sin(D))));if(c&&0<d.height){for(;250<N.length;)delete l[N.shift()];l[c]||N.push(c);l[c]=d}}return d},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(a){a?this.attr({y:-9999}):this.attr({visibility:"hidden"});return this},fadeOut:function(a){var b=this;b.animate({opacity:0},{duration:a||150,complete:function(){b.attr({y:-9999})}})},add:function(a){var b=this.renderer,d=this.element;a&&(this.parentGroup=a);this.parentInverted=
	a&&a.inverted;void 0!==this.textStr&&b.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)var e=this.zIndexSetter();e||(a?a.element:b.box).appendChild(d);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var b=a.parentNode;b&&b.removeChild(a)},destroy:function(){var a=this,b=a.element||{},d=a.renderer,e=d.isSVG&&"SPAN"===b.nodeName&&a.parentGroup,m=b.ownerSVGElement,w=a.clipPath;b.onclick=b.onmouseout=b.onmouseover=b.onmousemove=b.point=null;K(a);w&&m&&([].forEach.call(m.querySelectorAll("[clip-path],[CLIP-PATH]"),
	function(a){-1<a.getAttribute("clip-path").indexOf(w.element.id)&&a.removeAttribute("clip-path")}),a.clipPath=w.destroy());if(a.stops){for(m=0;m<a.stops.length;m++)a.stops[m]=a.stops[m].destroy();a.stops=null}a.safeRemoveChild(b);for(d.styledMode||a.destroyShadows();e&&e.div&&0===e.div.childNodes.length;)b=e.parentGroup,a.safeRemoveChild(e.div),delete e.div,e=b;a.alignTo&&B(d.alignedObjects,a);h(a,function(b,d){a[d]&&a[d].parentGroup===a&&a[d].destroy&&a[d].destroy();delete a[d]})},shadow:function(a,
	b,d){var e=[],m,w=this.element;if(!a)this.destroyShadows();else if(!this.shadows){var D=n(a.width,3);var k=(a.opacity||.15)/D;var l=this.parentInverted?"(-1,-1)":"("+n(a.offsetX,1)+", "+n(a.offsetY,1)+")";for(m=1;m<=D;m++){var g=w.cloneNode(0);var r=2*D+1-2*m;F(g,{stroke:a.color||"#000000","stroke-opacity":k*m,"stroke-width":r,transform:"translate"+l,fill:"none"});g.setAttribute("class",(g.getAttribute("class")||"")+" highcharts-shadow");d&&(F(g,"height",Math.max(F(g,"height")-r,0)),g.cutHeight=r);
	b?b.element.appendChild(g):w.parentNode&&w.parentNode.insertBefore(g,w);e.push(g)}this.shadows=e}return this},destroyShadows:function(){(this.shadows||[]).forEach(function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=n(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},
	dSetter:function(a,b,d){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[b]!==a&&(d.setAttribute(b,a),this[b]=a)},dashstyleSetter:function(a){var b,d=this["stroke-width"];"inherit"===d&&(d=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=q(a[b])*
	d;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){var b={left:"start",center:"middle",right:"end"};b[a]&&(this.alignValue=a,this.element.setAttribute("text-anchor",b[a]))},opacitySetter:function(a,b,d){this[b]=a;d.setAttribute(b,a)},titleSetter:function(a){var b=this.element.getElementsByTagName("title")[0];b||(b=p.createElementNS(this.SVG_NS,"title"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);b.appendChild(p.createTextNode(String(n(a,
	"")).replace(/<[^>]*>/g,"").replace(/&lt;/g,"<").replace(/&gt;/g,">")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,delete this.textPxLength,this.textStr=a,this.added&&this.renderer.buildText(this))},setTextPath:function(a,b){var d=this.element,e={textAnchor:"text-anchor"},m=!1,D=this.textPathWrapper,k=!D;b=A(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},b);var l=b.attributes;if(a&&b&&b.enabled){this.options&&this.options.padding&&(l.dx=-this.options.padding);
	D||(this.textPathWrapper=D=this.renderer.createElement("textPath"),m=!0);var g=D.element;(b=a.element.getAttribute("id"))||a.element.setAttribute("id",b=c.uniqueKey());if(k)for(a=d.getElementsByTagName("tspan");a.length;)a[0].setAttribute("y",0),g.appendChild(a[0]);m&&D.add({element:this.text?this.text.element:d});g.setAttributeNS("http://www.w3.org/1999/xlink","href",this.renderer.url+"#"+b);G(l.dy)&&(g.parentNode.setAttribute("dy",l.dy),delete l.dy);G(l.dx)&&(g.parentNode.setAttribute("dx",l.dx),
	delete l.dx);h(l,function(a,b){g.setAttribute(e[b]||b,a)});d.removeAttribute("transform");this.removeTextOutline.call(D,[].slice.call(d.getElementsByTagName("tspan")));this.text&&!this.renderer.styledMode&&this.attr({fill:"none","stroke-width":0});this.applyTextOutline=this.updateTransform=w}else D&&(delete this.updateTransform,delete this.applyTextOutline,this.destroyTextPath(d,a));return this},destroyTextPath:function(a,b){var d;b.element.setAttribute("id","");for(d=this.textPathWrapper.element.childNodes;d.length;)a.firstChild.appendChild(d[0]);
	a.firstChild.removeChild(this.textPathWrapper.element);delete b.textPathWrapper},fillSetter:function(a,b,d){"string"===typeof a?d.setAttribute(b,a):a&&this.complexColor(a,b,d)},visibilitySetter:function(a,b,d){"inherit"===a?d.removeAttribute(b):this[b]!==a&&d.setAttribute(b,a);this[b]=a},zIndexSetter:function(a,b){var d=this.renderer,e=this.parentGroup,m=(e||d).element||d.box,w=this.element,k=!1;d=m===d.box;var D=this.added;var l;G(a)?(w.setAttribute("data-z-index",a),a=+a,this[b]===a&&(D=!1)):G(this[b])&&
	w.removeAttribute("data-z-index");this[b]=a;if(D){(a=this.zIndex)&&e&&(e.handleZ=!0);b=m.childNodes;for(l=b.length-1;0<=l&&!k;l--){e=b[l];D=e.getAttribute("data-z-index");var g=!G(D);if(e!==w)if(0>a&&g&&!d&&!l)m.insertBefore(w,b[l]),k=!0;else if(q(D)<=a||g&&(!G(a)||0<=a))m.insertBefore(w,b[l+1]||null),k=!0}k||(m.insertBefore(w,b[d?3:0]||null),k=!0)}return k},_defaultSetter:function(a,b,d){d.setAttribute(b,a)}});O.prototype.yGetter=O.prototype.xGetter;O.prototype.translateXSetter=O.prototype.translateYSetter=
	O.prototype.rotationSetter=O.prototype.verticalAlignSetter=O.prototype.rotationOriginXSetter=O.prototype.rotationOriginYSetter=O.prototype.scaleXSetter=O.prototype.scaleYSetter=O.prototype.matrixSetter=function(a,b){this[b]=a;this.doTransform=!0};O.prototype["stroke-widthSetter"]=O.prototype.strokeSetter=function(a,b,d){this[b]=a;this.stroke&&this["stroke-width"]?(O.prototype.fillSetter.call(this,this.stroke,"stroke",d),d.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===
	b&&0===a&&this.hasStroke?(d.removeAttribute("stroke"),this.hasStroke=!1):this.renderer.styledMode&&this["stroke-width"]&&(d.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0)};f=c.SVGRenderer=function(){this.init.apply(this,arguments)};t(f.prototype,{Element:O,SVG_NS:U,init:function(a,d,e,m,w,g,r){var D=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"});r||D.css(this.getStyle(m));m=D.element;a.appendChild(m);F(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&
	F(m,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=m;this.boxWrapper=D;this.alignedObjects=[];this.url=(k||x)&&p.getElementsByTagName("base").length?Q.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 7.2.2"));this.defs=this.createElement("defs").add();this.allowHTML=g;this.forExport=w;this.styledMode=r;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=
	0;this.setSize(d,e,!1);var c;k&&a.getBoundingClientRect&&(d=function(){l(a,{left:0,top:0});c=a.getBoundingClientRect();l(a,{left:Math.ceil(c.left)-c.left+"px",top:Math.ceil(c.top)-c.top+"px"})},d(),this.unSubPixelFix=b(Q,"resize",d))},definition:function(a){function b(a,e){var m;g(a).forEach(function(a){var w=d.createElement(a.tagName),k={};h(a,function(a,b){"tagName"!==b&&"children"!==b&&"textContent"!==b&&(k[b]=a)});w.attr(k);w.add(e||d.defs);a.textContent&&w.element.appendChild(p.createTextNode(a.textContent));
	b(a.children||[],w);m=w});return m}var d=this;return b(a)},getStyle:function(a){return this.style=t({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();z(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&
	this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var b=new this.Element;b.init(this,a);return b},draw:w,getRadialAttr:function(a,b){return{cx:a[0]-a[2]/2+b.cx*a[2],cy:a[1]-a[2]/2+b.cy*a[2],r:b.r*a[2]}},truncate:function(a,b,d,e,m,w,k){var l=this,D=a.rotation,g,r=e?1:0,c=(d||e).length,x=c,J=[],K=function(a){b.firstChild&&b.removeChild(b.firstChild);a&&b.appendChild(p.createTextNode(a))},N=function(w,D){D=D||w;if(void 0===J[D])if(b.getSubStringLength)try{J[D]=m+b.getSubStringLength(0,
	e?D+1:D)}catch(ba){""}else l.getSpanWidth&&(K(k(d||e,w)),J[D]=m+l.getSpanWidth(a,b));return J[D]},A;a.rotation=0;var h=N(b.textContent.length);if(A=m+h>w){for(;r<=c;)x=Math.ceil((r+c)/2),e&&(g=k(e,x)),h=N(x,g&&g.length-1),r===c?r=c+1:h>w?c=x-1:r=x;0===c?K(""):d&&c===d.length-1||K(g||k(d||e,x))}e&&e.splice(0,x);a.actualWidth=h;a.rotation=D;return A},escapes:{"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},buildText:function(a){var b=a.element,d=this,e=d.forExport,m=n(a.textStr,"").toString(),
	w=-1!==m.indexOf("<"),k=b.childNodes,D,g=F(b,"x"),r=a.styles,c=a.textWidth,x=r&&r.lineHeight,K=r&&r.textOutline,A=r&&"ellipsis"===r.textOverflow,u=r&&"nowrap"===r.whiteSpace,L=r&&r.fontSize,E,f=k.length;r=c&&!a.added&&this.box;var S=function(a){var m;d.styledMode||(m=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:L||d.style.fontSize||12);return x?q(x):d.fontMetrics(m,a.getAttribute("style")?a:b).h},v=function(a,b){h(d.escapes,function(d,m){b&&-1!==b.indexOf(d)||(a=a.toString().replace(new RegExp(d,
	"g"),m))});return a},O=function(a,b){var d=a.indexOf("<");a=a.substring(d,a.indexOf(">")-d);d=a.indexOf(b+"=");if(-1!==d&&(d=d+b.length+1,b=a.charAt(d),'"'===b||"'"===b))return a=a.substring(d+1),a.substring(0,a.indexOf(b))},Q=/<br.*?>/g;var t=[m,A,u,x,K,L,c].join();if(t!==a.textCache){for(a.textCache=t;f--;)b.removeChild(k[f]);w||K||A||c||-1!==m.indexOf(" ")&&(!u||Q.test(m))?(r&&r.appendChild(b),w?(m=d.styledMode?m.replace(/<(b|strong)>/g,'<span class="highcharts-strong">').replace(/<(i|em)>/g,'<span class="highcharts-emphasized">'):
	m.replace(/<(b|strong)>/g,'<span style="font-weight:bold">').replace(/<(i|em)>/g,'<span style="font-style:italic">'),m=m.replace(/<a/g,"<span").replace(/<\/(b|strong|i|em|a)>/g,"</span>").split(Q)):m=[m],m=m.filter(function(a){return""!==a}),m.forEach(function(m,w){var k=0,r=0;m=m.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||<span").replace(/<\/span>/g,"</span>|||");var x=m.split("|||");x.forEach(function(m){if(""!==m||1===x.length){var K={},N=p.createElementNS(d.SVG_NS,"tspan"),h,n;(h=O(m,"class"))&&
	F(N,"class",h);if(h=O(m,"style"))h=h.replace(/(;| |^)color([ :])/,"$1fill$2"),F(N,"style",h);if((n=O(m,"href"))&&!e&&-1===n.split(":")[0].toLowerCase().indexOf("javascript")){var T=p.createElementNS(d.SVG_NS,"a");F(T,"href",n);F(N,"class","highcharts-anchor");T.appendChild(N);d.styledMode||l(N,{cursor:"pointer"})}m=v(m.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==m){N.appendChild(p.createTextNode(m));k?K.dx=0:w&&null!==g&&(K.x=g);F(N,K);b.appendChild(T||N);!k&&E&&(!J&&e&&l(N,{display:"block"}),
	F(N,"dy",S(N)));if(c){var f=m.replace(/([^\^])-/g,"$1- ").split(" ");K=!u&&(1<x.length||w||1<f.length);T=0;n=S(N);if(A)D=d.truncate(a,N,m,void 0,0,Math.max(0,c-parseInt(L||12,10)),function(a,b){return a.substring(0,b)+"\u2026"});else if(K)for(;f.length;)f.length&&!u&&0<T&&(N=p.createElementNS(U,"tspan"),F(N,{dy:n,x:g}),h&&F(N,"style",h),N.appendChild(p.createTextNode(f.join(" ").replace(/- /g,"-"))),b.appendChild(N)),d.truncate(a,N,null,f,0===T?r:0,c,function(a,b){return f.slice(0,b).join(" ").replace(/- /g,
	"-")}),r=a.actualWidth,T++}k++}}});E=E||b.childNodes.length}),A&&D&&a.attr("title",v(a.textStr,["&lt;","&gt;"])),r&&r.removeChild(b),K&&a.applyTextOutline&&a.applyTextOutline(K)):b.appendChild(p.createTextNode(v(m)))}},getContrast:function(a){a=e(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,d,m,e,w,k,l,g,c,x){var D=this.label(a,d,m,c,null,null,x,null,"button"),p=0,K=this.styledMode;D.attr(A({padding:8,r:2},w));if(!K){w=A({fill:"#f7f7f7",stroke:"#cccccc",
	"stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},w);var J=w.style;delete w.style;k=A(w,{fill:"#e6e6e6"},k);var N=k.style;delete k.style;l=A(w,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},l);var h=l.style;delete l.style;g=A(w,{style:{color:"#cccccc"}},g);var u=g.style;delete g.style}b(D.element,r?"mouseover":"mouseenter",function(){3!==p&&D.setState(1)});b(D.element,r?"mouseout":"mouseleave",function(){3!==p&&D.setState(p)});D.setState=function(a){1!==a&&
	(D.state=p=a);D.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);K||D.attr([w,k,l,g][a||0]).css([J,N,h,u][a||0])};K||D.attr(w).css(t({cursor:"default"},J));return D.on("click",function(a){3!==p&&e.call(D,a)})},crispLine:function(a,b){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-b%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+b%2/2);return a},path:function(a){var b=this.styledMode?{}:{fill:"none"};v(a)?b.d=a:H(a)&&
	t(b,a);return this.createElement("path").attr(b)},circle:function(a,b,d){a=H(a)?a:void 0===a?{}:{x:a,y:b,r:d};b=this.createElement("circle");b.xSetter=b.ySetter=function(a,b,d){d.setAttribute("c"+b,a)};return b.attr(a)},arc:function(a,b,d,m,e,w){H(a)?(m=a,b=m.y,d=m.r,a=m.x):m={innerR:m,start:e,end:w};a=this.symbol("arc",a,b,d,d,m);a.r=d;return a},rect:function(a,b,d,m,e,w){e=H(a)?a.r:e;var k=this.createElement("rect");a=H(a)?a:void 0===a?{}:{x:a,y:b,width:Math.max(d,0),height:Math.max(m,0)};this.styledMode||
	(void 0!==w&&(a.strokeWidth=w,a=k.crisp(a)),a.fill="none");e&&(a.r=e);k.rSetter=function(a,b,d){k.r=a;F(d,{rx:a,ry:a})};k.rGetter=function(){return k.r};return k.attr(a)},setSize:function(a,b,d){var m=this.alignedObjects,e=m.length;this.width=a;this.height=b;for(this.boxWrapper.animate({width:a,height:b},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:n(d,!0)?void 0:0});e--;)m[e].align()},g:function(a){var b=this.createElement("g");return a?b.attr({"class":"highcharts-"+
	a}):b},image:function(a,d,m,e,w,k){var l={preserveAspectRatio:"none"},g=function(a,b){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",b):a.setAttribute("hc-svg-href",b)},r=function(b){g(c.element,a);k.call(c,b)};1<arguments.length&&t(l,{x:d,y:m,width:e,height:w});var c=this.createElement("image").attr(l);k?(g(c.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),l=new Q.Image,b(l,"load",r),l.src=a,l.complete&&r({})):g(c.element,a);return c},
	symbol:function(a,b,m,e,w,k){var g=this,r=/^url\((.*?)\)$/,c=r.test(a),D=!c&&(this.symbols[a]?a:"circle"),x=D&&this.symbols[D],K=G(b)&&x&&x.call(this.symbols,Math.round(b),Math.round(m),e,w,k);if(x){var J=this.path(K);g.styledMode||J.attr("fill","none");t(J,{symbolName:D,x:b,y:m,width:e,height:w});k&&t(J,k)}else if(c){var A=a.match(r)[1];J=this.image(A);J.imgwidth=n(S[A]&&S[A].width,k&&k.width);J.imgheight=n(S[A]&&S[A].height,k&&k.height);var h=function(){J.attr({width:J.width,height:J.height})};
	["width","height"].forEach(function(a){J[a+"Setter"]=function(a,b){var d={},m=this["img"+b],e="width"===b?"translateX":"translateY";this[b]=a;G(m)&&(k&&"within"===k.backgroundSize&&this.width&&this.height&&(m=Math.round(m*Math.min(this.width/this.imgwidth,this.height/this.imgheight))),this.element&&this.element.setAttribute(b,m),this.alignByTranslate||(d[e]=((this[b]||0)-m)/2,this.attr(d)))}});G(b)&&J.attr({x:b,y:m});J.isImg=!0;G(J.imgwidth)&&G(J.imgheight)?h():(J.attr({width:0,height:0}),L("img",
	{onload:function(){var a=d[g.chartIndex];0===this.width&&(l(this,{position:"absolute",top:"-999em"}),p.body.appendChild(this));S[A]={width:this.width,height:this.height};J.imgwidth=this.width;J.imgheight=this.height;J.element&&h();this.parentNode&&this.parentNode.removeChild(this);g.imgCount--;if(!g.imgCount&&a&&a.onload)a.onload()},src:A}),this.imgCount++)}return J},symbols:{circle:function(a,b,d,m){return this.arc(a+d/2,b+m/2,d/2,m/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},square:function(a,
	b,d,m){return["M",a,b,"L",a+d,b,a+d,b+m,a,b+m,"Z"]},triangle:function(a,b,d,m){return["M",a+d/2,b,"L",a+d,b+m,a,b+m,"Z"]},"triangle-down":function(a,b,d,m){return["M",a,b,"L",a+d,b,a+d/2,b+m,"Z"]},diamond:function(a,b,d,m){return["M",a+d/2,b,"L",a+d,b+m/2,a+d/2,b+m,a,b+m/2,"Z"]},arc:function(a,b,d,m,e){var w=e.start,k=e.r||d,l=e.r||m||d,g=e.end-.001;d=e.innerR;m=n(e.open,.001>Math.abs(e.end-e.start-2*Math.PI));var r=Math.cos(w),c=Math.sin(w),x=Math.cos(g);g=Math.sin(g);w=.001>e.end-w-Math.PI?0:1;
	e=["M",a+k*r,b+l*c,"A",k,l,0,w,n(e.clockwise,1),a+k*x,b+l*g];G(d)&&e.push(m?"M":"L",a+d*x,b+d*g,"A",d,d,0,w,0,a+d*r,b+d*c);e.push(m?"":"Z");return e},callout:function(a,b,d,m,e){var w=Math.min(e&&e.r||0,d,m),k=w+6,l=e&&e.anchorX;e=e&&e.anchorY;var g=["M",a+w,b,"L",a+d-w,b,"C",a+d,b,a+d,b,a+d,b+w,"L",a+d,b+m-w,"C",a+d,b+m,a+d,b+m,a+d-w,b+m,"L",a+w,b+m,"C",a,b+m,a,b+m,a,b+m-w,"L",a,b+w,"C",a,b,a,b,a+w,b];l&&l>d?e>b+k&&e<b+m-k?g.splice(13,3,"L",a+d,e-6,a+d+6,e,a+d,e+6,a+d,b+m-w):g.splice(13,3,"L",a+
	d,m/2,l,e,a+d,m/2,a+d,b+m-w):l&&0>l?e>b+k&&e<b+m-k?g.splice(33,3,"L",a,e+6,a-6,e,a,e-6,a,b+w):g.splice(33,3,"L",a,m/2,l,e,a,m/2,a,b+w):e&&e>m&&l>a+k&&l<a+d-k?g.splice(23,3,"L",l+6,b+m,l,b+m+6,l-6,b+m,a+w,b+m):e&&0>e&&l>a+k&&l<a+d-k&&g.splice(3,3,"L",l-6,b,l,b-6,l+6,b,d-w,b);return g}},clipRect:function(a,b,d,m){var e=c.uniqueKey()+"-",w=this.createElement("clipPath").attr({id:e}).add(this.defs);a=this.rect(a,b,d,m,0).add(w);a.id=e;a.clipPath=w;a.count=0;return a},text:function(a,b,d,m){var e={};if(m&&
	(this.allowHTML||!this.forExport))return this.html(a,b,d);e.x=Math.round(b||0);d&&(e.y=Math.round(d));G(a)&&(e.text=a);a=this.createElement("text").attr(e);m||(a.xSetter=function(a,b,d){var m=d.getElementsByTagName("tspan"),e=d.getAttribute(b),w;for(w=0;w<m.length;w++){var k=m[w];k.getAttribute(b)===e&&k.setAttribute(b,a)}d.setAttribute(b,a)});return a},fontMetrics:function(a,b){a=!this.styledMode&&/px/.test(a)||!Q.getComputedStyle?a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize:
	b&&O.prototype.getStyle.call(b,"font-size");a=/px/.test(a)?q(a):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,b,d){var m=a;b&&d&&(m=Math.max(m*Math.cos(b*E),4));return{x:-a/3*Math.sin(b*E),y:m}},label:function(a,b,d,e,w,k,l,g,r){var c=this,x=c.styledMode,J=c.g("button"!==r&&"label"),p=J.text=c.text("",0,0,l).attr({zIndex:1}),K,h,D=0,u=3,L=0,n,N,E,U,f,q={},T,S,v=/^url\((.*?)\)$/.test(e),Q=x||v,y=function(){return x?K.strokeWidth()%2/2:(T?parseInt(T,10):0)%2/
	2};r&&J.addClass("highcharts-"+r);var R=function(){var a=p.element.style,b={};h=(void 0===n||void 0===N||f)&&G(p.textStr)&&p.getBBox();J.width=(n||h.width||0)+2*u+L;J.height=(N||h.height||0)+2*u;S=u+Math.min(c.fontMetrics(a&&a.fontSize,p).b,h?h.height:Infinity);Q&&(K||(J.box=K=c.symbols[e]||v?c.symbol(e):c.rect(),K.addClass(("button"===r?"":"highcharts-label-box")+(r?" highcharts-"+r+"-box":"")),K.add(J),a=y(),b.x=a,b.y=(g?-S:0)+a),b.width=Math.round(J.width),b.height=Math.round(J.height),K.attr(t(b,
	q)),q={})};var B=function(){var a=L+u;var b=g?0:S;G(n)&&h&&("center"===f||"right"===f)&&(a+={center:.5,right:1}[f]*(n-h.width));if(a!==p.x||b!==p.y)p.attr("x",a),p.hasBoxWidthChanged&&(h=p.getBBox(!0),R()),void 0!==b&&p.attr("y",b);p.x=a;p.y=b};var V=function(a,b){K?K.attr(a,b):q[a]=b};J.onAdd=function(){p.add(J);J.attr({text:a||0===a?a:"",x:b,y:d});K&&G(w)&&J.attr({anchorX:w,anchorY:k})};J.widthSetter=function(a){n=C(a)?a:null};J.heightSetter=function(a){N=a};J["text-alignSetter"]=function(a){f=
	a};J.paddingSetter=function(a){G(a)&&a!==u&&(u=J.padding=a,B())};J.paddingLeftSetter=function(a){G(a)&&a!==L&&(L=a,B())};J.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==D&&(D=a,h&&J.attr({x:E}))};J.textSetter=function(a){void 0!==a&&p.attr({text:a});R();B()};J["stroke-widthSetter"]=function(a,b){a&&(Q=!0);T=this["stroke-width"]=a;V(b,a)};x?J.rSetter=function(a,b){V(b,a)}:J.strokeSetter=J.fillSetter=J.rSetter=function(a,b){"r"!==b&&("fill"===b&&a&&(Q=!0),J[b]=a);V(b,a)};J.anchorXSetter=
	function(a,b){w=J.anchorX=a;V(b,Math.round(a)-y()-E)};J.anchorYSetter=function(a,b){k=J.anchorY=a;V(b,a-U)};J.xSetter=function(a){J.x=a;D&&(a-=D*((n||h.width)+2*u),J["forceAnimate:x"]=!0);E=Math.round(a);J.attr("translateX",E)};J.ySetter=function(a){U=J.y=Math.round(a);J.attr("translateY",U)};var H=J.css;l={css:function(a){if(a){var b={};a=A(a);J.textProps.forEach(function(d){void 0!==a[d]&&(b[d]=a[d],delete a[d])});p.css(b);"width"in b&&R();"fontSize"in b&&(R(),B())}return H.call(J,a)},getBBox:function(){return{width:h.width+
	2*u,height:h.height+2*u,x:h.x-u,y:h.y-u}},destroy:function(){m(J.element,"mouseenter");m(J.element,"mouseleave");p&&(p=p.destroy());K&&(K=K.destroy());O.prototype.destroy.call(J);J=c=R=B=V=null}};x||(l.shadow=function(a){a&&(R(),K&&K.shadow(a));return J});return t(J,l)}});c.Renderer=f});M(I,"parts/Html.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.attr,G=f.defined,z=f.extend,B=f.pick,t=f.pInt,v=c.createElement,C=c.css,H=c.isFirefox,y=c.isMS,h=c.isWebKit,n=c.SVGElement;
	f=c.SVGRenderer;var q=c.win;z(n.prototype,{htmlCss:function(g){var b="SPAN"===this.element.tagName&&g&&"width"in g,a=B(b&&g.width,void 0);if(b){delete g.width;this.textWidth=a;var d=!0}g&&"ellipsis"===g.textOverflow&&(g.whiteSpace="nowrap",g.overflow="hidden");this.styles=z(this.styles,g);C(this.element,g);d&&this.htmlUpdateTransform();return this},htmlGetBBox:function(){var g=this.element;return{x:g.offsetLeft,y:g.offsetTop,width:g.offsetWidth,height:g.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var g=
	this.renderer,b=this.element,a=this.translateX||0,d=this.translateY||0,e=this.x||0,l=this.y||0,c=this.textAlign||"left",h={left:0,center:.5,right:1}[c],p=this.styles,u=p&&p.whiteSpace;C(b,{marginLeft:a,marginTop:d});!g.styledMode&&this.shadows&&this.shadows.forEach(function(b){C(b,{marginLeft:a+1,marginTop:d+1})});this.inverted&&[].forEach.call(b.childNodes,function(a){g.invertChild(a,b)});if("SPAN"===b.tagName){p=this.rotation;var k=this.textWidth&&t(this.textWidth),r=[p,c,b.innerHTML,this.textWidth,
	this.textAlign].join(),x;(x=k!==this.oldTextWidth)&&!(x=k>this.oldTextWidth)&&((x=this.textPxLength)||(C(b,{width:"",whiteSpace:u||"nowrap"}),x=b.offsetWidth),x=x>k);x&&(/[ \-]/.test(b.textContent||b.innerText)||"ellipsis"===b.style.textOverflow)?(C(b,{width:k+"px",display:"block",whiteSpace:u||"normal"}),this.oldTextWidth=k,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;r!==this.cTT&&(u=g.fontMetrics(b.style.fontSize,b).b,!G(p)||p===(this.oldRotation||0)&&c===this.oldAlign||this.setSpanRotation(p,
	h,u),this.getSpanCorrection(!G(p)&&this.textPxLength||b.offsetWidth,u,h,p,c));C(b,{left:e+(this.xCorr||0)+"px",top:l+(this.yCorr||0)+"px"});this.cTT=r;this.oldRotation=p;this.oldAlign=c}}else this.alignOnAdd=!0},setSpanRotation:function(g,b,a){var d={},e=this.renderer.getTransformKey();d[e]=d.transform="rotate("+g+"deg)";d[e+(H?"Origin":"-origin")]=d.transformOrigin=100*b+"% "+a+"px";C(this.element,d)},getSpanCorrection:function(g,b,a){this.xCorr=-g*a;this.yCorr=-b}});z(f.prototype,{getTransformKey:function(){return y&&
	!/Edge/.test(q.navigator.userAgent)?"-ms-transform":h?"-webkit-transform":H?"MozTransform":q.opera?"-o-transform":""},html:function(g,b,a){var d=this.createElement("span"),e=d.element,l=d.renderer,c=l.isSVG,h=function(a,b){["opacity","visibility"].forEach(function(d){a[d+"Setter"]=function(e,k,l){var w=a.div?a.div.style:b;n.prototype[d+"Setter"].call(this,e,k,l);w&&(w[k]=e)}});a.addedSetters=!0};d.textSetter=function(a){a!==e.innerHTML&&(delete this.bBox,delete this.oldTextWidth);this.textStr=a;e.innerHTML=
	B(a,"");d.doTransform=!0};c&&h(d,d.element.style);d.xSetter=d.ySetter=d.alignSetter=d.rotationSetter=function(a,b){"align"===b&&(b="textAlign");d[b]=a;d.doTransform=!0};d.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};d.attr({text:g,x:Math.round(b),y:Math.round(a)}).css({position:"absolute"});l.styledMode||d.css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize});e.style.whiteSpace="nowrap";d.css=d.htmlCss;c&&(d.add=function(a){var b=l.box.parentNode,
	k=[];if(this.parentGroup=a){var g=a.div;if(!g){for(;a;)k.push(a),a=a.parentGroup;k.reverse().forEach(function(a){function e(b,d){a[d]=b;"translateX"===d?m.left=b+"px":m.top=b+"px";a.doTransform=!0}var w=F(a.element,"class");g=a.div=a.div||v("div",w?{className:w}:void 0,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},g||b);var m=g.style;z(a,{classSetter:function(a){return function(b){this.element.setAttribute("class",
	b);a.className=b}}(g),on:function(){k[0].div&&d.on.apply({element:k[0].div},arguments);return a},translateXSetter:e,translateYSetter:e});a.addedSetters||h(a)})}}else g=b;g.appendChild(e);d.added=!0;d.alignOnAdd&&d.htmlUpdateTransform();return d});return d}})});M(I,"parts/Time.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.extend,z=f.isObject,B=f.objectEach,t=f.pick,v=f.splat,C=c.merge,H=c.timeUnits,y=c.win;c.Time=function(c){this.update(c,!1)};c.Time.prototype=
	{defaultOptions:{Date:void 0,getTimezoneOffset:void 0,timezone:void 0,timezoneOffset:0,useUTC:!0},update:function(c){var h=t(c&&c.useUTC,!0),f=this;this.options=c=C(!0,this.options||{},c);this.Date=c.Date||y.Date||Date;this.timezoneOffset=(this.useUTC=h)&&c.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();(this.variableTimezone=!(h&&!c.getTimezoneOffset&&!c.timezone))||this.timezoneOffset?(this.get=function(g,b){var a=b.getTime(),d=a-f.getTimezoneOffset(b);b.setTime(d);g=b["getUTC"+
	g]();b.setTime(a);return g},this.set=function(g,b,a){if("Milliseconds"===g||"Seconds"===g||"Minutes"===g&&0===b.getTimezoneOffset()%60)b["set"+g](a);else{var d=f.getTimezoneOffset(b);d=b.getTime()-d;b.setTime(d);b["setUTC"+g](a);g=f.getTimezoneOffset(b);d=b.getTime()+g;b.setTime(d)}}):h?(this.get=function(g,b){return b["getUTC"+g]()},this.set=function(g,b,a){return b["setUTC"+g](a)}):(this.get=function(g,b){return b["get"+g]()},this.set=function(g,b,a){return b["set"+g](a)})},makeTime:function(h,
	n,f,g,b,a){if(this.useUTC){var d=this.Date.UTC.apply(0,arguments);var e=this.getTimezoneOffset(d);d+=e;var l=this.getTimezoneOffset(d);e!==l?d+=l-e:e-36E5!==this.getTimezoneOffset(d-36E5)||c.isSafari||(d-=36E5)}else d=(new this.Date(h,n,t(f,1),t(g,0),t(b,0),t(a,0))).getTime();return d},timezoneOffsetFunction:function(){var h=this,n=this.options,f=y.moment;if(!this.useUTC)return function(g){return 6E4*(new Date(g)).getTimezoneOffset()};if(n.timezone){if(f)return function(g){return 6E4*-f.tz(g,n.timezone).utcOffset()};
	c.error(25)}return this.useUTC&&n.getTimezoneOffset?function(g){return 6E4*n.getTimezoneOffset(g)}:function(){return 6E4*(h.timezoneOffset||0)}},dateFormat:function(h,n,f){if(!F(n)||isNaN(n))return c.defaultOptions.lang.invalidDate||"";h=t(h,"%Y-%m-%d %H:%M:%S");var g=this,b=new this.Date(n),a=this.get("Hours",b),d=this.get("Day",b),e=this.get("Date",b),l=this.get("Month",b),L=this.get("FullYear",b),E=c.defaultOptions.lang,p=E.weekdays,u=E.shortWeekdays,k=c.pad;b=G({a:u?u[d]:p[d].substr(0,3),A:p[d],
	d:k(e),e:k(e,2," "),w:d,b:E.shortMonths[l],B:E.months[l],m:k(l+1),o:l+1,y:L.toString().substr(2,2),Y:L,H:k(a),k:a,I:k(a%12||12),l:a%12||12,M:k(g.get("Minutes",b)),p:12>a?"AM":"PM",P:12>a?"am":"pm",S:k(b.getSeconds()),L:k(Math.floor(n%1E3),3)},c.dateFormats);B(b,function(a,b){for(;-1!==h.indexOf("%"+b);)h=h.replace("%"+b,"function"===typeof a?a.call(g,n):a)});return f?h.substr(0,1).toUpperCase()+h.substr(1):h},resolveDTLFormat:function(c){return z(c,!0)?c:(c=v(c),{main:c[0],from:c[1],to:c[2]})},getTimeTicks:function(c,
	n,f,g){var b=this,a=[],d={};var e=new b.Date(n);var l=c.unitRange,h=c.count||1,E;g=t(g,1);if(F(n)){b.set("Milliseconds",e,l>=H.second?0:h*Math.floor(b.get("Milliseconds",e)/h));l>=H.second&&b.set("Seconds",e,l>=H.minute?0:h*Math.floor(b.get("Seconds",e)/h));l>=H.minute&&b.set("Minutes",e,l>=H.hour?0:h*Math.floor(b.get("Minutes",e)/h));l>=H.hour&&b.set("Hours",e,l>=H.day?0:h*Math.floor(b.get("Hours",e)/h));l>=H.day&&b.set("Date",e,l>=H.month?1:Math.max(1,h*Math.floor(b.get("Date",e)/h)));if(l>=H.month){b.set("Month",
	e,l>=H.year?0:h*Math.floor(b.get("Month",e)/h));var p=b.get("FullYear",e)}l>=H.year&&b.set("FullYear",e,p-p%h);l===H.week&&(p=b.get("Day",e),b.set("Date",e,b.get("Date",e)-p+g+(p<g?-7:0)));p=b.get("FullYear",e);g=b.get("Month",e);var u=b.get("Date",e),k=b.get("Hours",e);n=e.getTime();b.variableTimezone&&(E=f-n>4*H.month||b.getTimezoneOffset(n)!==b.getTimezoneOffset(f));n=e.getTime();for(e=1;n<f;)a.push(n),n=l===H.year?b.makeTime(p+e*h,0):l===H.month?b.makeTime(p,g+e*h):!E||l!==H.day&&l!==H.week?E&&
	l===H.hour&&1<h?b.makeTime(p,g,u,k+e*h):n+l*h:b.makeTime(p,g,u+e*h*(l===H.day?1:7)),e++;a.push(n);l<=H.hour&&1E4>a.length&&a.forEach(function(a){0===a%18E5&&"000000000"===b.dateFormat("%H%M%S%L",a)&&(d[a]="day")})}a.info=G(c,{higherRanks:d,totalRange:l*h});return a}}});M(I,"parts/Options.js",[I["parts/Globals.js"]],function(c){var f=c.color,F=c.merge;c.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square",
	"triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:c.Time.prototype.defaultOptions,chart:{styledMode:!1,
	borderRadius:0,colorCount:10,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},caption:{margin:15,text:"",align:"left",verticalAlign:"bottom"},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},
	legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",
	x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:c.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:c.isTouchDevice?
	25:10,headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',backgroundColor:f("#f7f7f7").setOpacity(.85).get(),borderWidth:1,shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com?credits",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",
	fontSize:"9px"},text:"Highcharts.com"}};c.setOptions=function(f){c.defaultOptions=F(!0,c.defaultOptions,f);(f.time||f.global)&&c.time.update(F(c.defaultOptions.global,c.defaultOptions.time,f.global,f.time));return c.defaultOptions};c.getOptions=function(){return c.defaultOptions};c.defaultPlotOptions=c.defaultOptions.plotOptions;c.time=new c.Time(F(c.defaultOptions.global,c.defaultOptions.time));c.dateFormat=function(f,z,B){return c.time.dateFormat(f,z,B)};""});M(I,"parts/Tick.js",[I["parts/Globals.js"],
	I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.destroyObjectProperties,z=f.extend,B=f.isNumber,t=f.pick,v=c.correctFloat,C=c.fireEvent,H=c.merge,y=c.deg2rad;c.Tick=function(c,n,f,g,b){this.axis=c;this.pos=n;this.type=f||"";this.isNewLabel=this.isNew=!0;this.parameters=b||{};this.tickmarkOffset=this.parameters.tickmarkOffset;this.options=this.parameters.options;f||g||this.addLabel()};c.Tick.prototype={addLabel:function(){var c=this,n=c.axis,f=n.options,g=n.chart,b=n.categories,a=n.names,
	d=c.pos,e=t(c.options&&c.options.labels,f.labels),l=n.tickPositions,L=d===l[0],E=d===l[l.length-1];b=this.parameters.category||(b?t(b[d],a[d],d):d);var p=c.label;l=l.info;var u,k;if(n.isDatetimeAxis&&l){var r=g.time.resolveDTLFormat(f.dateTimeLabelFormats[!f.grid&&l.higherRanks[d]||l.unitName]);var x=r.main}c.isFirst=L;c.isLast=E;c.formatCtx={axis:n,chart:g,isFirst:L,isLast:E,dateTimeLabelFormat:x,tickPositionInfo:l,value:n.isLog?v(n.lin2log(b)):b,pos:d};f=n.labelFormatter.call(c.formatCtx,this.formatCtx);
	if(k=r&&r.list)c.shortenLabel=function(){for(u=0;u<k.length;u++)if(p.attr({text:n.labelFormatter.call(z(c.formatCtx,{dateTimeLabelFormat:k[u]}))}),p.getBBox().width<n.getSlotWidth(c)-2*t(e.padding,5))return;p.attr({text:""})};if(F(p))p&&p.textStr!==f&&(!p.textWidth||e.style&&e.style.width||p.styles.width||p.css({width:null}),p.attr({text:f}),p.textPxLength=p.getBBox().width);else{if(c.label=p=F(f)&&e.enabled?g.renderer.text(f,0,0,e.useHTML).add(n.labelGroup):null)g.styledMode||p.css(H(e.style)),p.textPxLength=
	p.getBBox().width;c.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(c){var h=this.axis,f=h.options.labels,g=c.x,b=h.chart.chartWidth,a=h.chart.spacing,d=t(h.labelLeft,Math.min(h.pos,a[3]));a=t(h.labelRight,Math.max(h.isRadial?0:h.pos+h.len,b-a[1]));var e=this.label,l=this.rotation,L={left:0,center:.5,right:1}[h.labelAlign||e.attr("align")],E=e.getBBox().width,p=h.getSlotWidth(this),u=p,k=1,r,x={};if(l||"justify"!==
	t(f.overflow,"justify"))0>l&&g-L*E<d?r=Math.round(g/Math.cos(l*y)-d):0<l&&g+L*E>a&&(r=Math.round((b-g)/Math.cos(l*y)));else if(b=g+(1-L)*E,g-L*E<d?u=c.x+u*(1-L)-d:b>a&&(u=a-c.x+u*L,k=-1),u=Math.min(p,u),u<p&&"center"===h.labelAlign&&(c.x+=k*(p-u-L*(p-Math.min(E,u)))),E>u||h.autoRotation&&(e.styles||{}).width)r=u;r&&(this.shortenLabel?this.shortenLabel():(x.width=Math.floor(r),(f.style||{}).textOverflow||(x.textOverflow="ellipsis"),e.css(x)))},getPosition:function(h,n,f,g){var b=this.axis,a=b.chart,
	d=g&&a.oldChartHeight||a.chartHeight;h={x:h?c.correctFloat(b.translate(n+f,null,null,g)+b.transB):b.left+b.offset+(b.opposite?(g&&a.oldChartWidth||a.chartWidth)-b.right-b.left:0),y:h?d-b.bottom+b.offset-(b.opposite?b.height:0):c.correctFloat(d-b.translate(n+f,null,null,g)-b.transB)};h.y=Math.max(Math.min(h.y,1E5),-1E5);C(this,"afterGetPosition",{pos:h});return h},getLabelPosition:function(c,n,f,g,b,a,d,e){var l=this.axis,h=l.transA,E=l.isLinked&&l.linkedParent?l.linkedParent.reversed:l.reversed,p=
	l.staggerLines,u=l.tickRotCorr||{x:0,y:0},k=b.y,r=g||l.reserveSpaceDefault?0:-l.labelOffset*("center"===l.labelAlign?.5:1),x={};F(k)||(k=0===l.side?f.rotation?-8:-f.getBBox().height:2===l.side?u.y+8:Math.cos(f.rotation*y)*(u.y-f.getBBox(!1,0).height/2));c=c+b.x+r+u.x-(a&&g?a*h*(E?-1:1):0);n=n+k-(a&&!g?a*h*(E?1:-1):0);p&&(f=d/(e||1)%p,l.opposite&&(f=p-f-1),n+=l.labelOffset/p*f);x.x=c;x.y=Math.round(n);C(this,"afterGetLabelPosition",{pos:x,tickmarkOffset:a,index:d});return x},getMarkPath:function(c,
	n,f,g,b,a){return a.crispLine(["M",c,n,"L",c+(b?0:-f),n+(b?f:0)],g)},renderGridLine:function(c,n,f){var g=this.axis,b=g.options,a=this.gridLine,d={},e=this.pos,l=this.type,h=t(this.tickmarkOffset,g.tickmarkOffset),E=g.chart.renderer,p=l?l+"Grid":"grid",u=b[p+"LineWidth"],k=b[p+"LineColor"];b=b[p+"LineDashStyle"];a||(g.chart.styledMode||(d.stroke=k,d["stroke-width"]=u,b&&(d.dashstyle=b)),l||(d.zIndex=1),c&&(n=0),this.gridLine=a=E.path().attr(d).addClass("highcharts-"+(l?l+"-":"")+"grid-line").add(g.gridGroup));
	if(a&&(f=g.getPlotLinePath({value:e+h,lineWidth:a.strokeWidth()*f,force:"pass",old:c})))a[c||this.isNew?"attr":"animate"]({d:f,opacity:n})},renderMark:function(c,n,f){var g=this.axis,b=g.options,a=g.chart.renderer,d=this.type,e=d?d+"Tick":"tick",l=g.tickSize(e),h=this.mark,E=!h,p=c.x;c=c.y;var u=t(b[e+"Width"],!d&&g.isXAxis?1:0);b=b[e+"Color"];l&&(g.opposite&&(l[0]=-l[0]),E&&(this.mark=h=a.path().addClass("highcharts-"+(d?d+"-":"")+"tick").add(g.axisGroup),g.chart.styledMode||h.attr({stroke:b,"stroke-width":u})),
	h[E?"attr":"animate"]({d:this.getMarkPath(p,c,l[0],h.strokeWidth()*f,g.horiz,a),opacity:n}))},renderLabel:function(c,n,f,g){var b=this.axis,a=b.horiz,d=b.options,e=this.label,l=d.labels,h=l.step;b=t(this.tickmarkOffset,b.tickmarkOffset);var E=!0,p=c.x;c=c.y;e&&B(p)&&(e.xy=c=this.getLabelPosition(p,c,e,a,l,b,g,h),this.isFirst&&!this.isLast&&!t(d.showFirstLabel,1)||this.isLast&&!this.isFirst&&!t(d.showLastLabel,1)?E=!1:!a||l.step||l.rotation||n||0===f||this.handleOverflow(c),h&&g%h&&(E=!1),E&&B(c.y)?
	(c.opacity=f,e[this.isNewLabel?"attr":"animate"](c),this.isNewLabel=!1):(e.attr("y",-9999),this.isNewLabel=!0))},render:function(h,n,f){var g=this.axis,b=g.horiz,a=this.pos,d=t(this.tickmarkOffset,g.tickmarkOffset);a=this.getPosition(b,a,d,n);d=a.x;var e=a.y;g=b&&d===g.pos+g.len||!b&&e===g.pos?-1:1;f=t(f,1);this.isActive=!0;this.renderGridLine(n,f,g);this.renderMark(a,f,g);this.renderLabel(a,n,f,h);this.isNew=!1;c.fireEvent(this,"afterRender")},destroy:function(){G(this,this.axis)}}});M(I,"parts/Axis.js",
	[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.arrayMax,G=f.arrayMin,z=f.defined,B=f.destroyObjectProperties,t=f.extend,v=f.isArray,C=f.isNumber,H=f.isString,y=f.objectEach,h=f.pick,n=f.splat,q=f.syncTimeout,g=c.addEvent,b=c.animObject,a=c.color,d=c.correctFloat,e=c.defaultOptions,l=c.deg2rad,L=c.fireEvent,E=c.format,p=c.getMagnitude,u=c.merge,k=c.normalizeTickInterval,r=c.removeEvent,x=c.seriesTypes,A=c.Tick;f=function(){this.init.apply(this,arguments)};t(f.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",
	range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,showEmpty:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",
	style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,crop:!0,overflow:"justify",formatter:function(){return c.numberFormat(this.total,-1)},style:{color:"#000000",
	fontSize:"11px",fontWeight:"bold",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},init:function(a,b){var d=b.isX,m=this;m.chart=a;m.horiz=a.inverted&&!m.isZAxis?!d:d;m.isXAxis=d;m.coll=m.coll||(d?"xAxis":
	"yAxis");L(this,"init",{userOptions:b});m.opposite=b.opposite;m.side=b.side||(m.horiz?m.opposite?0:2:m.opposite?1:3);m.setOptions(b);var e=this.options,w=e.type;m.labelFormatter=e.labels.formatter||m.defaultLabelFormatter;m.userOptions=b;m.minPixelPadding=0;m.reversed=e.reversed;m.visible=!1!==e.visible;m.zoomEnabled=!1!==e.zoomEnabled;m.hasNames="category"===w||!0===e.categories;m.categories=e.categories||m.hasNames;m.names||(m.names=[],m.names.keys={});m.plotLinesAndBandsGroups={};m.isLog="logarithmic"===
	w;m.isDatetimeAxis="datetime"===w;m.positiveValuesOnly=m.isLog&&!m.allowNegativeLog;m.isLinked=z(e.linkedTo);m.ticks={};m.labelEdge=[];m.minorTicks={};m.plotLinesAndBands=[];m.alternateBands={};m.len=0;m.minRange=m.userMinRange=e.minRange||e.maxZoom;m.range=e.range;m.offset=e.offset||0;m.stacks={};m.oldStacks={};m.stacksTouched=0;m.max=null;m.min=null;m.crosshair=h(e.crosshair,n(a.options.tooltip.crosshairs)[d?0:1],!1);b=m.options.events;-1===a.axes.indexOf(m)&&(d?a.axes.splice(a.xAxis.length,0,m):
	a.axes.push(m),a[m.coll].push(m));m.series=m.series||[];a.inverted&&!m.isZAxis&&d&&void 0===m.reversed&&(m.reversed=!0);y(b,function(a,b){c.isFunction(a)&&g(m,b,a)});m.lin2log=e.linearToLogConverter||m.lin2log;m.isLog&&(m.val2lin=m.log2lin,m.lin2val=m.lin2log);L(this,"afterInit")},setOptions:function(a){this.options=u(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],
	u(e[this.coll],a));L(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var a=this.axis,b=this.value,d=a.chart.time,k=a.categories,l=this.dateTimeLabelFormat,g=e.lang,r=g.numericSymbols;g=g.numericSymbolMagnitude||1E3;var x=r&&r.length,p=a.options.labels.format;a=a.isLog?Math.abs(b):a.tickInterval;if(p)var h=E(p,this,d);else if(k)h=b;else if(l)h=d.dateFormat(l,b);else if(x&&1E3<=a)for(;x--&&void 0===h;)d=Math.pow(g,x+1),a>=d&&0===10*b%d&&null!==r[x]&&0!==b&&(h=c.numberFormat(b/
	d,-1)+r[x]);void 0===h&&(h=1E4<=Math.abs(b)?c.numberFormat(b,-1):c.numberFormat(b,-1,void 0,""));return h},getSeriesExtremes:function(){var a=this,b=a.chart,d;L(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();a.series.forEach(function(m){if(m.visible||!b.options.chart.ignoreHiddenSeries){var e=m.options,w=e.threshold;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=w&&(w=null);if(a.isXAxis){if(e=
	m.xData,e.length){d=m.getXExtremes(e);var k=d.min;var c=d.max;C(k)||k instanceof Date||(e=e.filter(C),d=m.getXExtremes(e),k=d.min,c=d.max);e.length&&(a.dataMin=Math.min(h(a.dataMin,k),k),a.dataMax=Math.max(h(a.dataMax,c),c))}}else if(m.getExtremes(),c=m.dataMax,k=m.dataMin,z(k)&&z(c)&&(a.dataMin=Math.min(h(a.dataMin,k),k),a.dataMax=Math.max(h(a.dataMax,c),c)),z(w)&&(a.threshold=w),!e.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});L(this,"afterGetSeriesExtremes")},translate:function(a,
	b,d,e,k,c){var m=this.linkedParent||this,w=1,l=0,g=e?m.oldTransA:m.transA;e=e?m.oldMin:m.min;var r=m.minPixelPadding;k=(m.isOrdinal||m.isBroken||m.isLog&&k)&&m.lin2val;g||(g=m.transA);d&&(w*=-1,l=m.len);m.reversed&&(w*=-1,l-=w*(m.sector||m.len));b?(a=(a*w+l-r)/g+e,k&&(a=m.lin2val(a))):(k&&(a=m.val2lin(a)),a=C(e)?w*(a-e)*g+l+w*r+(C(c)?g*c:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),
	!0,!this.horiz,null,!0)},getPlotLinePath:function(a){var b=this,d=b.chart,e=b.left,w=b.top,k=a.old,c=a.value,l=a.translatedValue,g=a.lineWidth,r=a.force,x,p,A,u,f=k&&d.oldChartHeight||d.chartHeight,n=k&&d.oldChartWidth||d.chartWidth,E,q=b.transB,v=function(a,b,d){if("pass"!==r&&a<b||a>d)r?a=Math.min(Math.max(b,a),d):E=!0;return a};a={value:c,lineWidth:g,old:k,force:r,acrossPanes:a.acrossPanes,translatedValue:l};L(this,"getPlotLinePath",a,function(a){l=h(l,b.translate(c,null,null,k));l=Math.min(Math.max(-1E5,
	l),1E5);x=A=Math.round(l+q);p=u=Math.round(f-l-q);C(l)?b.horiz?(p=w,u=f-b.bottom,x=A=v(x,e,e+b.width)):(x=e,A=n-b.right,p=u=v(p,w,w+b.height)):(E=!0,r=!1);a.path=E&&!r?null:d.renderer.crispLine(["M",x,p,"L",A,u],g||1)});return a.path},getLinearTickPositions:function(a,b,e){var m=d(Math.floor(b/a)*a);e=d(Math.ceil(e/a)*a);var w=[],k;d(m+a)===m&&(k=20);if(this.single)return[b];for(b=m;b<=e;){w.push(b);b=d(b+a,k);if(b===c)break;var c=b}return w},getMinorTickInterval:function(){var a=this.options;return!0===
	a.minorTicks?h(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,d=a.tickPositions,e=a.minorTickInterval,k=[],c=a.pointRangePadding||0,l=a.min-c;c=a.max+c;var g=c-l;if(g&&g/e<a.len/3)if(a.isLog)this.paddedTicks.forEach(function(b,d,m){d&&k.push.apply(k,a.getLogTickPositions(e,m[d-1],m[d],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())k=k.concat(a.getTimeTicks(a.normalizeTimeTickInterval(e),l,c,b.startOfWeek));
	else for(b=l+(d[0]-l)%e;b<=c&&b!==k[0];b+=e)k.push(b);0!==k.length&&a.trimTicks(k);return k},adjustForMinRange:function(){var a=this.options,b=this.min,d=this.max,e,k,c,l,g;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(z(a.min)||z(a.max)?this.minRange=null:(this.series.forEach(function(a){l=a.xData;for(k=g=a.xIncrement?1:l.length-1;0<k;k--)if(c=l[k]-l[k-1],void 0===e||c<e)e=c}),this.minRange=Math.min(5*e,this.dataMax-this.dataMin)));if(d-b<this.minRange){var r=this.dataMax-this.dataMin>=this.minRange;
	var x=this.minRange;var p=(x-d+b)/2;p=[b-p,h(a.min,b-p)];r&&(p[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin);b=F(p);d=[b+x,h(a.max,b+x)];r&&(d[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax);d=G(d);d-b<x&&(p[0]=d-x,p[1]=h(a.min,d-x),b=F(p))}this.min=b;this.max=d},getClosest:function(){var a;this.categories?a=1:this.series.forEach(function(b){var d=b.closestPointRange,m=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&z(d)&&m&&(a=z(a)?Math.min(a,d):d)});return a},
	nameToX:function(a){var b=v(this.categories),d=b?this.categories:this.names,e=a.options.x;a.series.requireSorting=!1;z(e)||(e=!1===this.options.uniqueNames?a.series.autoIncrement():b?d.indexOf(a.name):h(d.keys[a.name],-1));if(-1===e){if(!b)var k=d.length}else k=e;void 0!==k&&(this.names[k]=a.name,this.names.keys[a.name]=k);return k},updateNames:function(){var a=this,b=this.names;0<b.length&&(Object.keys(b.keys).forEach(function(a){delete b.keys[a]}),b.length=0,this.minRange=this.userMinRange,(this.series||
	[]).forEach(function(b){b.xIncrement=null;if(!b.points||b.isDirtyData)a.max=Math.max(a.max,b.xData.length-1),b.processData(),b.generatePoints();b.data.forEach(function(d,e){if(d&&d.options&&void 0!==d.name){var m=a.nameToX(d);void 0!==m&&m!==d.x&&(d.x=m,b.xData[e]=m)}})}))},setAxisTranslation:function(a){var b=this,d=b.max-b.min,e=b.axisPointRange||0,k=0,w=0,c=b.linkedParent,l=!!b.categories,g=b.transA,r=b.isXAxis;if(r||l||e){var p=b.getClosest();c?(k=c.minPointOffset,w=c.pointRangePadding):b.series.forEach(function(a){var d=
	l?1:r?h(a.options.pointRange,p,0):b.axisPointRange||0,m=a.options.pointPlacement;e=Math.max(e,d);if(!b.single||l)a=x.xrange&&a instanceof x.xrange?!r:r,k=Math.max(k,a&&H(m)?0:d/2),w=Math.max(w,a&&"on"===m?0:d)});c=b.ordinalSlope&&p?b.ordinalSlope/p:1;b.minPointOffset=k*=c;b.pointRangePadding=w*=c;b.pointRange=Math.min(e,b.single&&l?1:d);r&&(b.closestPointRange=p)}a&&(b.oldTransA=g);b.translationSlope=b.transA=g=b.staticScale||b.len/(d+w||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=g*k;L(this,
	"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(a){var b=this,e=b.chart,w=b.options,l=b.isLog,g=b.isDatetimeAxis,r=b.isXAxis,x=b.isLinked,A=w.maxPadding,u=w.minPadding,f=w.tickInterval,n=w.tickPixelInterval,E=b.categories,q=C(b.threshold)?b.threshold:null,v=b.softThreshold;g||E||x||this.getTickAmount();var t=h(b.userMin,w.min);var y=h(b.userMax,w.max);if(x){b.linkedParent=e[b.coll][w.linkedTo];var B=b.linkedParent.getExtremes();b.min=h(B.min,
	B.dataMin);b.max=h(B.max,B.dataMax);w.type!==b.linkedParent.options.type&&c.error(11,1,e)}else{if(!v&&z(q))if(b.dataMin>=q)B=q,u=0;else if(b.dataMax<=q){var H=q;A=0}b.min=h(t,B,b.dataMin);b.max=h(y,H,b.dataMax)}l&&(b.positiveValuesOnly&&!a&&0>=Math.min(b.min,h(b.dataMin,b.min))&&c.error(10,1,e),b.min=d(b.log2lin(b.min),16),b.max=d(b.log2lin(b.max),16));b.range&&z(b.max)&&(b.userMin=b.min=t=Math.max(b.dataMin,b.minFromRange()),b.userMax=y=b.max,b.range=null);L(b,"foundExtremes");b.beforePadding&&b.beforePadding();
	b.adjustForMinRange();!(E||b.axisPointRange||b.usePercentage||x)&&z(b.min)&&z(b.max)&&(e=b.max-b.min)&&(!z(t)&&u&&(b.min-=e*u),!z(y)&&A&&(b.max+=e*A));C(w.softMin)&&!C(b.userMin)&&w.softMin<b.min&&(b.min=t=w.softMin);C(w.softMax)&&!C(b.userMax)&&w.softMax>b.max&&(b.max=y=w.softMax);C(w.floor)&&(b.min=Math.min(Math.max(b.min,w.floor),Number.MAX_VALUE));C(w.ceiling)&&(b.max=Math.max(Math.min(b.max,w.ceiling),h(b.userMax,-Number.MAX_VALUE)));v&&z(b.dataMin)&&(q=q||0,!z(t)&&b.min<q&&b.dataMin>=q?b.min=
	b.options.minRange?Math.min(q,b.max-b.minRange):q:!z(y)&&b.max>q&&b.dataMax<=q&&(b.max=b.options.minRange?Math.max(q,b.min+b.minRange):q));b.tickInterval=b.min===b.max||void 0===b.min||void 0===b.max?1:x&&!f&&n===b.linkedParent.options.tickPixelInterval?f=b.linkedParent.tickInterval:h(f,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,E?1:(b.max-b.min)*n/Math.max(b.len,n));r&&!a&&b.series.forEach(function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);
	b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!f&&(b.tickInterval=Math.max(b.pointRange,b.tickInterval));a=h(w.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);!f&&b.tickInterval<a&&(b.tickInterval=a);g||l||f||(b.tickInterval=k(b.tickInterval,null,p(b.tickInterval),h(w.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=
	b.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b=a.tickPositions;var d=this.getMinorTickInterval();var e=a.tickPositioner,k=a.startOnTick,l=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===d&&this.tickInterval?this.tickInterval/5:d;this.single=this.min===this.max&&z(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=
	d=b&&b.slice();!d&&(!this.ordinalPositions&&(this.max-this.min)/this.tickInterval>Math.max(2*this.len,200)?(d=[this.min,this.max],c.error(19,!1,this.chart)):d=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),d.length>this.len&&(d=[d[0],
	d.pop()],d[0]===d[1]&&(d.length=1)),this.tickPositions=d,e&&(e=e.apply(this,[this.min,this.max])))&&(this.tickPositions=d=e);this.paddedTicks=d.slice(0);this.trimTicks(d,k,l);this.isLinked||(this.single&&2>d.length&&!this.categories&&(this.min-=.5,this.max+=.5),b||e||this.adjustTickAmount());L(this,"afterSetTickPositions")},trimTicks:function(a,b,d){var e=a[0],m=a[a.length-1],k=this.minPointOffset||0;L(this,"trimTicks");if(!this.isLinked){if(b&&-Infinity!==e)this.min=e;else for(;this.min-k>a[0];)a.shift();
	if(d)this.max=m;else for(;this.max+k<a[a.length-1];)a.pop();0===a.length&&z(e)&&!this.options.tickPositions&&a.push((m+e)/2)}},alignToOthers:function(){var a={},b,d=this.options;!1===this.chart.options.chart.alignTicks||!1===d.alignTicks||!1===d.startOnTick||!1===d.endOnTick||this.isLog||this.chart[this.coll].forEach(function(d){var e=d.options;e=[d.horiz?e.left:e.top,e.width,e.height,e.pane].join();d.series.length&&(a[e]?b=!0:a[e]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,
	d=a.tickPixelInterval;!z(a.tickInterval)&&this.len<d&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/d)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.options,b=this.tickInterval,e=this.tickPositions,k=this.tickAmount,c=this.finalTickAmt,l=e&&e.length,g=h(this.threshold,this.softThreshold?0:null),r;if(this.hasData()){if(l<k){for(r=this.min;e.length<k;)e.length%2||r===g?e.push(d(e[e.length-
	1]+b)):e.unshift(d(e[0]-b));this.transA*=(l-1)/(k-1);this.min=a.startOnTick?e[0]:Math.min(this.min,e[0]);this.max=a.endOnTick?e[e.length-1]:Math.max(this.max,e[e.length-1])}else l>k&&(this.tickInterval*=2,this.setTickPositions());if(z(c)){for(b=a=e.length;b--;)(3===c&&1===b%2||2>=c&&0<b&&b<a-1)&&e.splice(b,1);this.finalTickAmt=void 0}}},setScale:function(){var a=this.series.some(function(a){return a.isDirtyData||a.isDirty||a.xAxis&&a.xAxis.isDirty}),b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=
	this.len;this.setAxisSize();(b=this.len!==this.oldAxisLength)||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();L(this,"afterSetScale")},setExtremes:function(a,
	b,d,e,k){var m=this,w=m.chart;d=h(d,!0);m.series.forEach(function(a){delete a.kdTree});k=t(k,{min:a,max:b});L(m,"setExtremes",k,function(){m.userMin=a;m.userMax=b;m.eventArgs=k;d&&w.redraw(e)})},zoom:function(a,b){var d=this.dataMin,e=this.dataMax,m=this.options,k=Math.min(d,h(m.min,d)),w=Math.max(e,h(m.max,e));a={newMin:a,newMax:b};L(this,"zoom",a,function(a){var b=a.newMin,m=a.newMax;if(b!==this.min||m!==this.max)this.allowZoomOutside||(z(d)&&(b<k&&(b=k),b>w&&(b=w)),z(e)&&(m<k&&(m=k),m>w&&(m=w))),
	this.displayBtn=void 0!==b||void 0!==m,this.setExtremes(b,m,!1,void 0,{trigger:"zoom"});a.zoomed=!0});return a.zoomed},setAxisSize:function(){var a=this.chart,b=this.options,d=b.offsets||[0,0,0,0],e=this.horiz,k=this.width=Math.round(c.relativeLength(h(b.width,a.plotWidth-d[3]+d[1]),a.plotWidth)),l=this.height=Math.round(c.relativeLength(h(b.height,a.plotHeight-d[0]+d[2]),a.plotHeight)),g=this.top=Math.round(c.relativeLength(h(b.top,a.plotTop+d[0]),a.plotHeight,a.plotTop));b=this.left=Math.round(c.relativeLength(h(b.left,
	a.plotLeft+d[3]),a.plotWidth,a.plotLeft));this.bottom=a.chartHeight-l-g;this.right=a.chartWidth-k-b;this.len=Math.max(e?k:l,0);this.pos=e?b:g},getExtremes:function(){var a=this.isLog;return{min:a?d(this.lin2log(this.min)):this.min,max:a?d(this.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,d=b?this.lin2log(this.min):this.min;b=b?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=d:Infinity===
	a?a=b:d>a?a=d:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){var b=(h(a,0)-90*this.side+720)%360;a={align:"center"};L(this,"autoLabelAlign",a,function(a){15<b&&165>b?a.align="right":195<b&&345>b&&(a.align="left")});return a.align},tickSize:function(a){var b=this.options,d=b[a+"Length"],e=h(b[a+"Width"],"tick"===a&&this.isXAxis&&!this.categories?1:0);if(e&&d){"inside"===b[a+"Position"]&&(d=-d);var k=[d,e]}a={tickSize:k};L(this,"afterTickSize",a);return a.tickSize},labelMetrics:function(){var a=
	this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,e=this.tickInterval,k=e,c=this.len/(((this.categories?1:0)+this.max-this.min)/e),g,r=a.rotation,x=this.labelMetrics(),p,A=Number.MAX_VALUE,u,f=this.max-this.min,n=function(a){var b=a/(c||1);b=1<b?Math.ceil(b):1;b*e>f&&Infinity!==a&&Infinity!==c&&f&&(b=Math.ceil(f/
	e));return d(b*e)};b?(u=!a.staggerLines&&!a.step&&(z(r)?[r]:c<h(a.autoRotationLimit,80)&&a.autoRotation))&&u.forEach(function(a){if(a===r||a&&-90<=a&&90>=a){p=n(Math.abs(x.h/Math.sin(l*a)));var b=p+Math.abs(a/360);b<A&&(A=b,g=a,k=p)}}):a.step||(k=n(x.h));this.autoRotation=u;this.labelRotation=h(g,r);return k},getSlotWidth:function(a){var b=this.chart,d=this.horiz,e=this.options.labels,k=Math.max(this.tickPositions.length-(this.categories?0:1),1),c=b.margin[3];return a&&a.slotWidth||d&&2>(e.step||
	0)&&!e.rotation&&(this.staggerLines||1)*this.len/k||!d&&(e.style&&parseInt(e.style.width,10)||c&&c-b.spacing[3]||.33*b.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,d=this.tickPositions,e=this.ticks,k=this.options.labels,c=k&&k.style||{},l=this.horiz,g=this.getSlotWidth(),r=Math.max(1,Math.round(g-2*(k.padding||5))),x={},p=this.labelMetrics(),h=k.style&&k.style.textOverflow,A=0;H(k.rotation)||(x.rotation=k.rotation||0);d.forEach(function(a){(a=e[a])&&a.label&&a.label.textPxLength>
	A&&(A=a.label.textPxLength)});this.maxLabelLength=A;if(this.autoRotation)A>r&&A>p.h?x.rotation=this.labelRotation:this.labelRotation=0;else if(g){var u=r;if(!h){var f="clip";for(r=d.length;!l&&r--;){var n=d[r];if(n=e[n].label)n.styles&&"ellipsis"===n.styles.textOverflow?n.css({textOverflow:"clip"}):n.textPxLength>g&&n.css({width:g+"px"}),n.getBBox().height>this.len/d.length-(p.h-p.f)&&(n.specificTextOverflow="ellipsis")}}}x.rotation&&(u=A>.5*a.chartHeight?.33*a.chartHeight:A,h||(f="ellipsis"));if(this.labelAlign=
	k.align||this.autoLabelAlign(this.labelRotation))x.align=this.labelAlign;d.forEach(function(a){var b=(a=e[a])&&a.label,d=c.width,k={};b&&(b.attr(x),a.shortenLabel?a.shortenLabel():u&&!d&&"nowrap"!==c.whiteSpace&&(u<b.textPxLength||"SPAN"===b.element.tagName)?(k.width=u,h||(k.textOverflow=b.specificTextOverflow||f),b.css(k)):b.styles&&b.styles.width&&!k.width&&!d&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=x.rotation)},this);this.tickRotCorr=b.rotCorr(p.b,this.labelRotation||0,0!==
	this.side)},hasData:function(){return this.series.some(function(a){return a.hasData()})||this.options.showEmpty&&z(this.min)&&z(this.max)},addTitle:function(a){var b=this.chart.renderer,d=this.horiz,e=this.opposite,k=this.options.title,c,l=this.chart.styledMode;this.axisTitle||((c=k.textAlign)||(c=(d?{low:"left",middle:"center",high:"right"}:{low:e?"right":"left",middle:"center",high:e?"left":"right"})[k.align]),this.axisTitle=b.text(k.text,0,0,k.useHTML).attr({zIndex:7,rotation:k.rotation||0,align:c}).addClass("highcharts-axis-title"),
	l||this.axisTitle.css(u(k.style)),this.axisTitle.add(this.axisGroup),this.axisTitle.isNew=!0);l||k.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](a)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new A(this,a)},getOffset:function(){var a=this,b=a.chart,d=b.renderer,e=a.options,k=a.tickPositions,c=a.ticks,l=a.horiz,g=a.side,r=b.inverted&&!a.isZAxis?[1,0,3,2][g]:g,x,p=0,A=0,u=e.title,n=e.labels,f=0,E=b.axisOffset;b=b.clipOffset;
	var q=[-1,1,1,-1][g],v=e.className,t=a.axisParent;var C=a.hasData();a.showAxis=x=C||h(e.showEmpty,!0);a.staggerLines=a.horiz&&n.staggerLines;a.axisGroup||(a.gridGroup=d.g("grid").attr({zIndex:e.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(v||"")).add(t),a.axisGroup=d.g("axis").attr({zIndex:e.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(v||"")).add(t),a.labelGroup=d.g("axis-labels").attr({zIndex:n.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+
	"-labels "+(v||"")).add(t));C||a.isLinked?(k.forEach(function(b,d){a.generateTick(b,d)}),a.renderUnsquish(),a.reserveSpaceDefault=0===g||2===g||{1:"left",3:"right"}[g]===a.labelAlign,h(n.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&k.forEach(function(a){f=Math.max(c[a].getLabelSize(),f)}),a.staggerLines&&(f*=a.staggerLines),a.labelOffset=f*(a.opposite?-1:1)):y(c,function(a,b){a.destroy();delete c[b]});if(u&&u.text&&!1!==u.enabled&&(a.addTitle(x),x&&!1!==u.reserveSpace)){a.titleOffset=
	p=a.axisTitle.getBBox()[l?"height":"width"];var B=u.offset;A=z(B)?0:h(u.margin,l?5:10)}a.renderLine();a.offset=q*h(e.offset,E[g]?E[g]+(e.margin||0):0);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};d=0===g?-a.labelMetrics().h:2===g?a.tickRotCorr.y:0;A=Math.abs(f)+A;f&&(A=A-d+q*(l?h(n.y,a.tickRotCorr.y+8*q):n.x));a.axisTitleMargin=h(B,A);a.getMaxLabelDimensions&&(a.maxLabelDimensions=a.getMaxLabelDimensions(c,k));l=this.tickSize("tick");E[g]=Math.max(E[g],a.axisTitleMargin+p+q*a.offset,A,k&&k.length&&l?l[0]+
	q*a.offset:0);e=e.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[r]=Math.max(b[r],e);L(this,"afterGetOffset")},getLinePath:function(a){var b=this.chart,d=this.opposite,e=this.offset,k=this.horiz,c=this.left+(d?this.width:0)+e;e=b.chartHeight-this.bottom-(d?this.height:0)+e;d&&(a*=-1);return b.renderer.crispLine(["M",k?this.left:c,k?e:this.top,"L",k?b.chartWidth-this.right:c,k?e:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),
	this.chart.styledMode||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,d=this.top,e=this.len,k=this.options.title,c=a?b:d,l=this.opposite,g=this.offset,r=k.x||0,x=k.y||0,p=this.axisTitle,A=this.chart.renderer.fontMetrics(k.style&&k.style.fontSize,p);p=Math.max(p.getBBox(null,0).height-A.h-1,0);e={low:c+(a?0:e),middle:c+e/2,high:c+(a?e:0)}[k.align];b=(a?d+this.height:b)+(a?1:-1)*(l?-1:1)*this.axisTitleMargin+
	[-p,p,A.f,-p][this.side];a={x:a?e+r:b+(l?this.width:0)+g+r,y:a?b+x-(l?this.height:0)+g:e+x};L(this,"afterGetTitlePosition",{titlePosition:a});return a},renderMinorTick:function(a){var b=this.chart.hasRendered&&C(this.oldMin),d=this.minorTicks;d[a]||(d[a]=new A(this,a,"minor"));b&&d[a].isNew&&d[a].render(null,!0);d[a].render(null,!1,1)},renderTick:function(a,b){var d=this.isLinked,e=this.ticks,k=this.chart.hasRendered&&C(this.oldMin);if(!d||a>=this.min&&a<=this.max)e[a]||(e[a]=new A(this,a)),k&&e[a].isNew&&
	e[a].render(b,!0,-1),e[a].render(b)},render:function(){var a=this,d=a.chart,e=a.options,k=a.isLog,l=a.isLinked,g=a.tickPositions,r=a.axisTitle,x=a.ticks,p=a.minorTicks,h=a.alternateBands,u=e.stackLabels,f=e.alternateGridColor,n=a.tickmarkOffset,E=a.axisLine,v=a.showAxis,t=b(d.renderer.globalAnimation),B,H;a.labelEdge.length=0;a.overlap=!1;[x,p,h].forEach(function(a){y(a,function(a){a.isActive=!1})});if(a.hasData()||l)a.minorTickInterval&&!a.categories&&a.getMinorTickPositions().forEach(function(b){a.renderMinorTick(b)}),
	g.length&&(g.forEach(function(b,d){a.renderTick(b,d)}),n&&(0===a.min||a.single)&&(x[-1]||(x[-1]=new A(a,-1,null,!0)),x[-1].render(-1))),f&&g.forEach(function(b,e){H=void 0!==g[e+1]?g[e+1]+n:a.max-n;0===e%2&&b<a.max&&H<=a.max+(d.polar?-n:n)&&(h[b]||(h[b]=new c.PlotLineOrBand(a)),B=b+n,h[b].options={from:k?a.lin2log(B):B,to:k?a.lin2log(H):H,color:f},h[b].render(),h[b].isActive=!0)}),a._addedPlotLB||((e.plotLines||[]).concat(e.plotBands||[]).forEach(function(b){a.addPlotBandOrLine(b)}),a._addedPlotLB=
	!0);[x,p,h].forEach(function(a){var b,e=[],k=t.duration;y(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,e.push(b))});q(function(){for(b=e.length;b--;)a[e[b]]&&!a[e[b]].isActive&&(a[e[b]].destroy(),delete a[e[b]])},a!==h&&d.hasRendered&&k?k:0)});E&&(E[E.isPlaced?"animate":"attr"]({d:this.getLinePath(E.strokeWidth())}),E.isPlaced=!0,E[v?"show":"hide"](v));r&&v&&(e=a.getTitlePosition(),C(e.y)?(r[r.isNew?"attr":"animate"](e),r.isNew=!1):(r.attr("y",-9999),r.isNew=!0));u&&u.enabled&&a.renderStackTotals();
	a.isDirty=!1;L(this,"afterRender")},redraw:function(){this.visible&&(this.render(),this.plotLinesAndBands.forEach(function(a){a.render()}));this.series.forEach(function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,d=b.stacks,e=b.plotLinesAndBands,k;L(this,"destroy",{keepEvents:a});a||r(b);y(d,function(a,b){B(a);d[b]=null});[b.ticks,b.minorTicks,b.alternateBands].forEach(function(a){B(a)});if(e)for(a=e.length;a--;)e[a].destroy();
	"stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(a){b[a]&&(b[a]=b[a].destroy())});for(k in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[k]=b.plotLinesAndBandsGroups[k].destroy();y(b,function(a,d){-1===b.keepProps.indexOf(d)&&delete b[d]})},drawCrosshair:function(b,d){var e,k=this.crosshair,c=h(k.snap,!0),l,g=this.cross;L(this,"drawCrosshair",{e:b,point:d});b||(b=this.cross&&this.cross.e);if(this.crosshair&&!1!==(z(d)||!c)){c?z(d)&&
	(l=h("colorAxis"!==this.coll?d.crosshairPos:null,this.isXAxis?d.plotX:this.len-d.plotY)):l=b&&(this.horiz?b.chartX-this.pos:this.len-b.chartY+this.pos);z(l)&&(e=this.getPlotLinePath({value:d&&(this.isXAxis?d.x:h(d.stackY,d.y)),translatedValue:l})||null);if(!z(e)){this.hideCrosshair();return}c=this.categories&&!this.isRadial;g||(this.cross=g=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(c?"category ":"thin ")+k.className).attr({zIndex:h(k.zIndex,2)}).add(),this.chart.styledMode||
	(g.attr({stroke:k.color||(c?a("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":h(k.width,1)}).css({"pointer-events":"none"}),k.dashStyle&&g.attr({dashstyle:k.dashStyle})));g.show().attr({d:e});c&&!k.width&&g.attr({"stroke-width":this.transA});this.cross.e=b}else this.hideCrosshair();L(this,"afterDrawCrosshair",{e:b,point:d})},hideCrosshair:function(){this.cross&&this.cross.hide();L(this,"afterHideCrosshair")}});return c.Axis=f});M(I,"parts/DateTimeAxis.js",[I["parts/Globals.js"]],function(c){var f=
	c.Axis,F=c.getMagnitude,G=c.normalizeTickInterval,z=c.timeUnits;f.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};f.prototype.normalizeTimeTickInterval=function(c,f){var v=f||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];f=v[v.length-1];var t=z[f[0]],B=f[1],y;for(y=0;y<v.length&&!(f=v[y],t=z[f[0]],
	B=f[1],v[y+1]&&c<=(t*B[B.length-1]+z[v[y+1][0]])/2);y++);t===z.year&&c<5*t&&(B=[1,2,5]);c=G(c/t,B,"year"===f[0]?Math.max(F(c/t),1):1);return{unitRange:t,count:c,unitName:f[0]}}});M(I,"parts/LogarithmicAxis.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.pick;f=c.Axis;var G=c.getMagnitude,z=c.normalizeTickInterval;f.prototype.getLogTickPositions=function(c,f,v,C){var t=this.options,y=this.len,h=[];C||(this._minorAutoInterval=null);if(.5<=c)c=Math.round(c),h=this.getLinearTickPositions(c,
	f,v);else if(.08<=c){y=Math.floor(f);var n,q;for(t=.3<c?[1,2,4]:.15<c?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];y<v+1&&!q;y++){var g=t.length;for(n=0;n<g&&!q;n++){var b=this.log2lin(this.lin2log(y)*t[n]);b>f&&(!C||a<=v)&&void 0!==a&&h.push(a);a>v&&(q=!0);var a=b}}}else f=this.lin2log(f),v=this.lin2log(v),c=C?this.getMinorTickInterval():t.tickInterval,c=F("auto"===c?null:c,this._minorAutoInterval,t.tickPixelInterval/(C?5:1)*(v-f)/((C?y/this.tickPositions.length:y)||1)),c=z(c,null,G(c)),h=this.getLinearTickPositions(c,
	f,v).map(this.log2lin),C||(this._minorAutoInterval=c/5);C||(this.tickInterval=c);return h};f.prototype.log2lin=function(c){return Math.log(c)/Math.LN10};f.prototype.lin2log=function(c){return Math.pow(10,c)}});M(I,"parts/PlotLineOrBand.js",[I["parts/Globals.js"],I["parts/Axis.js"],I["parts/Utilities.js"]],function(c,f,F){var G=F.arrayMax,z=F.arrayMin,B=F.defined,t=F.destroyObjectProperties,v=F.erase,C=F.extend,H=F.objectEach,y=F.pick,h=c.merge;c.PlotLineOrBand=function(c,h){this.axis=c;h&&(this.options=
	h,this.id=h.id)};c.PlotLineOrBand.prototype={render:function(){c.fireEvent(this,"render");var f=this,q=f.axis,g=q.horiz,b=f.options,a=b.label,d=f.label,e=b.to,l=b.from,L=b.value,E=B(l)&&B(e),p=B(L),u=f.svgElem,k=!u,r=[],x=b.color,A=y(b.zIndex,0),w=b.events;r={"class":"highcharts-plot-"+(E?"band ":"line ")+(b.className||"")};var m={},K=q.chart.renderer,J=E?"bands":"lines";q.isLog&&(l=q.log2lin(l),e=q.log2lin(e),L=q.log2lin(L));q.chart.styledMode||(p?(r.stroke=x||"#999999",r["stroke-width"]=y(b.width,
	1),b.dashStyle&&(r.dashstyle=b.dashStyle)):E&&(r.fill=x||"#e6ebf5",b.borderWidth&&(r.stroke=b.borderColor,r["stroke-width"]=b.borderWidth)));m.zIndex=A;J+="-"+A;(x=q.plotLinesAndBandsGroups[J])||(q.plotLinesAndBandsGroups[J]=x=K.g("plot-"+J).attr(m).add());k&&(f.svgElem=u=K.path().attr(r).add(x));if(p)r=q.getPlotLinePath({value:L,lineWidth:u.strokeWidth(),acrossPanes:b.acrossPanes});else if(E)r=q.getPlotBandPath(l,e,b);else return;(k||!u.d)&&r&&r.length?(u.attr({d:r}),w&&H(w,function(a,b){u.on(b,
	function(a){w[b].apply(f,[a])})})):u&&(r?(u.show(!0),u.animate({d:r})):u.d&&(u.hide(),d&&(f.label=d=d.destroy())));a&&(B(a.text)||B(a.formatter))&&r&&r.length&&0<q.width&&0<q.height&&!r.isFlat?(a=h({align:g&&E&&"center",x:g?!E&&4:10,verticalAlign:!g&&E&&"middle",y:g?E?16:10:E?6:-4,rotation:g&&!E&&90},a),this.renderLabel(a,r,E,A)):d&&d.hide();return f},renderLabel:function(c,h,g,b){var a=this.label,d=this.axis.chart.renderer;a||(a={align:c.textAlign||c.align,rotation:c.rotation,"class":"highcharts-plot-"+
	(g?"band":"line")+"-label "+(c.className||"")},a.zIndex=b,b=this.getLabelText(c),this.label=a=d.text(b,0,0,c.useHTML).attr(a).add(),this.axis.chart.styledMode||a.css(c.style));d=h.xBounds||[h[1],h[4],g?h[6]:h[1]];h=h.yBounds||[h[2],h[5],g?h[7]:h[2]];g=z(d);b=z(h);a.align(c,!1,{x:g,y:b,width:G(d)-g,height:G(h)-b});a.show(!0)},getLabelText:function(c){return B(c.formatter)?c.formatter.call(this):c.text},destroy:function(){v(this.axis.plotLinesAndBands,this);delete this.axis;t(this)}};C(f.prototype,
	{getPlotBandPath:function(c,h){var g=this.getPlotLinePath({value:h,force:!0,acrossPanes:this.options.acrossPanes}),b=this.getPlotLinePath({value:c,force:!0,acrossPanes:this.options.acrossPanes}),a=[],d=this.horiz,e=1;c=c<this.min&&h<this.min||c>this.max&&h>this.max;if(b&&g){if(c){var l=b.toString()===g.toString();e=0}for(c=0;c<b.length;c+=6)d&&g[c+1]===b[c+1]?(g[c+1]+=e,g[c+4]+=e):d||g[c+2]!==b[c+2]||(g[c+2]+=e,g[c+5]+=e),a.push("M",b[c+1],b[c+2],"L",b[c+4],b[c+5],g[c+4],g[c+5],g[c+1],g[c+2],"z"),
	a.isFlat=l}return a},addPlotBand:function(c){return this.addPlotBandOrLine(c,"plotBands")},addPlotLine:function(c){return this.addPlotBandOrLine(c,"plotLines")},addPlotBandOrLine:function(h,f){var g=(new c.PlotLineOrBand(this,h)).render(),b=this.userOptions;if(g){if(f){var a=b[f]||[];a.push(h);b[f]=a}this.plotLinesAndBands.push(g)}return g},removePlotBandOrLine:function(c){for(var h=this.plotLinesAndBands,g=this.options,b=this.userOptions,a=h.length;a--;)h[a].id===c&&h[a].destroy();[g.plotLines||
	[],b.plotLines||[],g.plotBands||[],b.plotBands||[]].forEach(function(b){for(a=b.length;a--;)b[a].id===c&&v(b,b[a])})},removePlotBand:function(c){this.removePlotBandOrLine(c)},removePlotLine:function(c){this.removePlotBandOrLine(c)}})});M(I,"parts/Tooltip.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.discardElement,z=f.extend,B=f.isNumber,t=f.isString,v=f.pick,C=f.splat,H=f.syncTimeout;"";var y=c.doc,h=c.format,n=c.merge,q=c.timeUnits;c.Tooltip=function(){this.init.apply(this,
	arguments)};c.Tooltip.prototype={init:function(c,b){this.chart=c;this.options=b;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=b.split&&!c.inverted;this.shared=b.shared||this.split;this.outside=v(b.outside,!(!c.scrollablePixelsX&&!c.scrollablePixelsY))},cleanSplit:function(c){this.chart.series.forEach(function(b){var a=b&&b.tt;a&&(!a.isActive||c?b.tt=a.destroy():a.isActive=!1)})},applyFilter:function(){var c=this.chart;c.renderer.definition({tagName:"filter",id:"drop-shadow-"+c.index,
	opacity:.5,children:[{tagName:"feGaussianBlur","in":"SourceAlpha",stdDeviation:1},{tagName:"feOffset",dx:1,dy:1},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",type:"linear",slope:.3}]},{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]});c.renderer.definition({tagName:"style",textContent:".highcharts-tooltip-"+c.index+"{filter:url(#drop-shadow-"+c.index+")}"})},getLabel:function(){var g=this,b=this.chart.renderer,a=this.chart.styledMode,
	d=this.options,e="tooltip"+(F(d.className)?" "+d.className:""),l;if(!this.label){this.outside&&(this.container=l=c.doc.createElement("div"),l.className="highcharts-tooltip-container",c.css(l,{position:"absolute",top:"1px",pointerEvents:d.style&&d.style.pointerEvents,zIndex:3}),c.doc.body.appendChild(l),this.renderer=b=new c.Renderer(l,0,0,{},void 0,void 0,b.styledMode));this.split?this.label=b.g(e):(this.label=b.label("",0,0,d.shape||"callout",null,null,d.useHTML,null,e).attr({padding:d.padding,r:d.borderRadius}),
	a||this.label.attr({fill:d.backgroundColor,"stroke-width":d.borderWidth}).css(d.style).shadow(d.shadow));a&&(this.applyFilter(),this.label.addClass("highcharts-tooltip-"+this.chart.index));if(g.outside&&!g.split){var h={x:this.label.xSetter,y:this.label.ySetter};this.label.xSetter=function(a,b){h[b].call(this.label,g.distance);l.style.left=a+"px"};this.label.ySetter=function(a,b){h[b].call(this.label,g.distance);l.style.top=a+"px"}}this.label.attr({zIndex:8}).add()}return this.label},update:function(c){this.destroy();
	n(!0,this.chart.options.tooltip.userOptions,c);this.init(this.chart,n(!0,this.options,c))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),G(this.container));c.clearTimeout(this.hideTimer);c.clearTimeout(this.tooltipTimeout)},move:function(g,b,a,d){var e=this,l=e.now,h=!1!==e.options.animation&&!e.isHidden&&(1<Math.abs(g-l.x)||1<Math.abs(b-l.y)),f=
	e.followPointer||1<e.len;z(l,{x:h?(2*l.x+g)/3:g,y:h?(l.y+b)/2:b,anchorX:f?void 0:h?(2*l.anchorX+a)/3:a,anchorY:f?void 0:h?(l.anchorY+d)/2:d});e.getLabel().attr(l);h&&(c.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){e&&e.move(g,b,a,d)},32))},hide:function(g){var b=this;c.clearTimeout(this.hideTimer);g=v(g,this.options.hideDelay,500);this.isHidden||(this.hideTimer=H(function(){b.getLabel()[g?"fadeOut":"hide"]();b.isHidden=!0},g))},getAnchor:function(c,b){var a=this.chart,
	d=a.pointer,e=a.inverted,l=a.plotTop,g=a.plotLeft,h=0,p=0,f,k;c=C(c);this.followPointer&&b?(void 0===b.chartX&&(b=d.normalize(b)),c=[b.chartX-a.plotLeft,b.chartY-l]):c[0].tooltipPos?c=c[0].tooltipPos:(c.forEach(function(a){f=a.series.yAxis;k=a.series.xAxis;h+=a.plotX+(!e&&k?k.left-g:0);p+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!e&&f?f.top-l:0)}),h/=c.length,p/=c.length,c=[e?a.plotWidth-p:h,this.shared&&!e&&1<c.length&&b?b.chartY-l:e?a.plotHeight-h:p]);return c.map(Math.round)},getPosition:function(c,
	b,a){var d=this.chart,e=this.distance,l={},g=d.inverted&&a.h||0,h,p=this.outside,f=p?y.documentElement.clientWidth-2*e:d.chartWidth,k=p?Math.max(y.body.scrollHeight,y.documentElement.scrollHeight,y.body.offsetHeight,y.documentElement.offsetHeight,y.documentElement.clientHeight):d.chartHeight,r=d.pointer.getChartPosition(),x=d.containerScaling,A=function(a){return x?a*x.scaleX:a},w=function(a){return x?a*x.scaleY:a},m=function(l){var m="x"===l;return[l,m?f:k,m?c:b].concat(p?[m?A(c):w(b),m?r.left-e+
	A(a.plotX+d.plotLeft):r.top-e+w(a.plotY+d.plotTop),0,m?f:k]:[m?c:b,m?a.plotX+d.plotLeft:a.plotY+d.plotTop,m?d.plotLeft:d.plotTop,m?d.plotLeft+d.plotWidth:d.plotTop+d.plotHeight])},n=m("y"),J=m("x"),q=!this.followPointer&&v(a.ttBelow,!d.inverted===!!a.negative),t=function(a,b,d,c,k,m,r){var x="y"===a?w(e):A(e),p=(d-c)/2,h=c<k-e,f=k+e+c<b,u=k-x-d+p;k=k+x-p;if(q&&f)l[a]=k;else if(!q&&h)l[a]=u;else if(h)l[a]=Math.min(r-c,0>u-g?u:u-g);else if(f)l[a]=Math.max(m,k+g+d>b?k:k+g);else return!1},C=function(a,
	b,d,k,c){var m;c<e||c>b-e?m=!1:l[a]=c<d/2?1:c>b-k/2?b-k-2:c-d/2;return m},O=function(a){var b=n;n=J;J=b;h=a},D=function(){!1!==t.apply(0,n)?!1!==C.apply(0,J)||h||(O(!0),D()):h?l.x=l.y=0:(O(!0),D())};(d.inverted||1<this.len)&&O();D();return l},defaultFormatter:function(c){var b=this.points||C(this);var a=[c.tooltipFooterHeaderFormatter(b[0])];a=a.concat(c.bodyFormatter(b));a.push(c.tooltipFooterHeaderFormatter(b[0],!0));return a},refresh:function(g,b){var a=this.chart,d=this.options,e=g,l={},h=[],
	f=d.formatter||this.defaultFormatter;l=this.shared;var p=a.styledMode;if(d.enabled){c.clearTimeout(this.hideTimer);this.followPointer=C(e)[0].series.tooltipOptions.followPointer;var u=this.getAnchor(e,b);b=u[0];var k=u[1];!l||e.series&&e.series.noSharedTooltip?l=e.getLabelConfig():(a.pointer.applyInactiveState(e),e.forEach(function(a){a.setState("hover");h.push(a.getLabelConfig())}),l={x:e[0].category,y:e[0].y},l.points=h,e=e[0]);this.len=h.length;a=f.call(l,this);f=e.series;this.distance=v(f.tooltipOptions.distance,
	16);!1===a?this.hide():(this.split?this.renderSplit(a,C(g)):(g=this.getLabel(),d.style.width&&!p||g.css({width:this.chart.spacingBox.width}),g.attr({text:a&&a.join?a.join(""):a}),g.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+v(e.colorIndex,f.colorIndex)),p||g.attr({stroke:d.borderColor||e.color||f.color||"#666666"}),this.updatePosition({plotX:b,plotY:k,negative:e.negative,ttBelow:e.ttBelow,h:u[2]||0})),this.isHidden&&this.label&&this.label.attr({opacity:1}).show(),this.isHidden=
	!1);c.fireEvent(this,"refresh")}},renderSplit:function(g,b){var a=this,d=[],e=this.chart,l=e.renderer,h=!0,f=this.options,p=0,u,k=this.getLabel(),r=e.plotTop;t(g)&&(g=[!1,g]);g.slice(0,b.length+1).forEach(function(c,m){if(!1!==c&&""!==c){m=b[m-1]||{isHeader:!0,plotX:b[0].plotX,plotY:e.plotHeight};var g=m.series||a,x=g.tt,w=m.series||{},A="highcharts-color-"+v(m.colorIndex,w.colorIndex,"none");x||(x={padding:f.padding,r:f.borderRadius},e.styledMode||(x.fill=f.backgroundColor,x["stroke-width"]=f.borderWidth),
	g.tt=x=l.label(null,null,null,(m.isHeader?f.headerShape:f.shape)||"callout",null,null,f.useHTML).addClass(m.isHeader?"highcharts-tooltip-header ":"highcharts-tooltip-box "+A).attr(x).add(k));x.isActive=!0;x.attr({text:c});e.styledMode||x.css(f.style).shadow(f.shadow).attr({stroke:f.borderColor||m.color||w.color||"#333333"});c=x.getBBox();A=c.width+x.strokeWidth();m.isHeader?(p=c.height,e.xAxis[0].opposite&&(u=!0,r-=p),c=Math.max(0,Math.min(m.plotX+e.plotLeft-A/2,e.chartWidth+(e.scrollablePixelsX?
	e.scrollablePixelsX-e.marginRight:0)-A))):c=m.plotX+e.plotLeft-v(f.distance,16)-A;0>c&&(h=!1);m.isHeader?w=u?-p:e.plotHeight+p:(w=w.yAxis,w=w.pos-r+Math.max(0,Math.min(m.plotY||0,w.len)));d.push({target:w,rank:m.isHeader?1:0,size:g.tt.getBBox().height+1,point:m,x:c,tt:x})}});this.cleanSplit();f.positioner&&d.forEach(function(b){var d=f.positioner.call(a,b.tt.getBBox().width,b.size,b.point);b.x=d.x;b.align=0;b.target=d.y;b.rank=v(d.rank,b.rank)});c.distribute(d,e.plotHeight+p);d.forEach(function(b){var d=
	b.point,c=d.series,k=c&&c.yAxis;b.tt.attr({visibility:void 0===b.pos?"hidden":"inherit",x:h||d.isHeader||f.positioner?b.x:d.plotX+e.plotLeft+a.distance,y:b.pos+r,anchorX:d.isHeader?d.plotX+e.plotLeft:d.plotX+c.xAxis.pos,anchorY:d.isHeader?e.plotTop+e.plotHeight/2:k.pos+Math.max(0,Math.min(d.plotY,k.len))})});var x=a.container;g=a.renderer;if(a.outside&&x&&g){var A=e.pointer.getChartPosition();x.style.left=A.left+"px";x.style.top=A.top+"px";x=k.getBBox();g.setSize(x.width+x.x,x.height+x.y,!1)}},updatePosition:function(g){var b=
	this.chart,a=b.pointer,d=this.getLabel(),e=g.plotX+b.plotLeft,l=g.plotY+b.plotTop;a=a.getChartPosition();g=(this.options.positioner||this.getPosition).call(this,d.width,d.height,g);if(this.outside){var h=(this.options.borderWidth||0)+2*this.distance;this.renderer.setSize(d.width+h,d.height+h,!1);if(b=b.containerScaling)c.css(this.container,{transform:"scale("+b.scaleX+", "+b.scaleY+")"}),e*=b.scaleX,l*=b.scaleY;e+=a.left-g.x;l+=a.top-g.y}this.move(Math.round(g.x),Math.round(g.y||0),e,l)},getDateFormat:function(c,
	b,a,d){var e=this.chart.time,l=e.dateFormat("%m-%d %H:%M:%S.%L",b),g={millisecond:15,second:12,minute:9,hour:6,day:3},h="millisecond";for(p in q){if(c===q.week&&+e.dateFormat("%w",b)===a&&"00:00:00.000"===l.substr(6)){var p="week";break}if(q[p]>c){p=h;break}if(g[p]&&l.substr(g[p])!=="01-01 00:00:00.000".substr(g[p]))break;"week"!==p&&(h=p)}if(p)var f=e.resolveDTLFormat(d[p]).main;return f},getXDateFormat:function(c,b,a){b=b.dateTimeLabelFormats;var d=a&&a.closestPointRange;return(d?this.getDateFormat(d,
	c.x,a.options.startOfWeek,b):b.day)||b.year},tooltipFooterHeaderFormatter:function(g,b){var a=b?"footer":"header",d=g.series,e=d.tooltipOptions,l=e.xDateFormat,f=d.xAxis,n=f&&"datetime"===f.options.type&&B(g.key),p=e[a+"Format"];b={isFooter:b,labelConfig:g};c.fireEvent(this,"headerFormatter",b,function(a){n&&!l&&(l=this.getXDateFormat(g,e,f));n&&l&&(g.point&&g.point.tooltipDateKeys||["key"]).forEach(function(a){p=p.replace("{point."+a+"}","{point."+a+":"+l+"}")});d.chart.styledMode&&(p=this.styledModeFormat(p));
	a.text=h(p,{point:g,series:d},this.chart.time)});return b.text},bodyFormatter:function(c){return c.map(function(b){var a=b.series.tooltipOptions;return(a[(b.point.formatPrefix||"point")+"Formatter"]||b.point.tooltipFormatter).call(b.point,a[(b.point.formatPrefix||"point")+"Format"]||"")})},styledModeFormat:function(c){return c.replace('style="font-size: 10px"','class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class="highcharts-color-{$1.colorIndex}"')}}});M(I,"parts/Pointer.js",
	[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.attr,G=f.defined,z=f.extend,B=f.isNumber,t=f.isObject,v=f.objectEach,C=f.pick,H=f.splat,y=c.addEvent,h=c.charts,n=c.color,q=c.css,g=c.find,b=c.fireEvent,a=c.offset,d=c.Tooltip;c.Pointer=function(a,b){this.init(a,b)};c.Pointer.prototype={init:function(a,b){this.options=b;this.chart=a;this.runChartClick=b.chart.events&&!!b.chart.events.click;this.pinchDown=[];this.lastValidTouch={};d&&(a.tooltip=new d(a,b.tooltip),this.followTouchMove=
	C(b.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,d=b.options.chart,e=d.zoomType||"";b=b.inverted;/touch/.test(a.type)&&(e=C(d.pinchType,e));this.zoomX=a=/x/.test(e);this.zoomY=e=/y/.test(e);this.zoomHor=a&&!b||e&&b;this.zoomVert=e&&!b||a&&b;this.hasZoom=a||e},getChartPosition:function(){return this.chartPosition||(this.chartPosition=a(this.chart.container))},normalize:function(a,b){var d=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:
	a;b||(b=this.getChartPosition());var e=d.pageX-b.left;b=d.pageY-b.top;if(d=this.chart.containerScaling)e/=d.scaleX,b/=d.scaleY;return z(a,{chartX:Math.round(e),chartY:Math.round(b)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};this.chart.axes.forEach(function(d){b[d.isXAxis?"xAxis":"yAxis"].push({axis:d,value:d.toValue(a[d.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,b,d){var e;a.forEach(function(a){var c=!(a.noSharedTooltip&&b)&&0>a.options.findNearestPointBy.indexOf("y");
	a=a.searchPoint(d,c);if((c=t(a,!0))&&!(c=!t(e,!0))){c=e.distX-a.distX;var k=e.dist-a.dist,l=(a.series.group&&a.series.group.zIndex)-(e.series.group&&e.series.group.zIndex);c=0<(0!==c&&b?c:0!==k?k:0!==l?l:e.series.index>a.series.index?-1:1)}c&&(e=a)});return e},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,b){var d=a.series,e=d.xAxis;d=d.yAxis;var c=C(a.clientX,a.plotX),l=a.shapeArgs;if(e&&d)return b?{chartX:e.len+
	e.pos-c,chartY:d.len+d.pos-a.plotY}:{chartX:c+e.pos,chartY:a.plotY+d.pos};if(l&&l.x&&l.y)return{chartX:l.x,chartY:l.y}},getHoverData:function(a,b,d,c,h,f){var e,l=[];c=!(!c||!a);var x=b&&!b.stickyTracking?[b]:d.filter(function(a){return a.visible&&!(!h&&a.directTouch)&&C(a.options.enableMouseTracking,!0)&&a.stickyTracking});b=(e=c||!f?a:this.findNearestKDPoint(x,h,f))&&e.series;e&&(h&&!b.noSharedTooltip?(x=d.filter(function(a){return a.visible&&!(!h&&a.directTouch)&&C(a.options.enableMouseTracking,
	!0)&&!a.noSharedTooltip}),x.forEach(function(a){var b=g(a.points,function(a){return a.x===e.x&&!a.isNull});t(b)&&(a.chart.isBoosting&&(b=a.getPoint(b)),l.push(b))})):l.push(e));return{hoverPoint:e,hoverSeries:b,hoverPoints:l}},runPointActions:function(a,b){var d=this.chart,e=d.tooltip&&d.tooltip.options.enabled?d.tooltip:void 0,l=e?e.shared:!1,g=b||d.hoverPoint,k=g&&g.series||d.hoverSeries;k=this.getHoverData(g,k,d.series,(!a||"touchmove"!==a.type)&&(!!b||k&&k.directTouch&&this.isDirectTouch),l,a);
	g=k.hoverPoint;var r=k.hoverPoints;b=(k=k.hoverSeries)&&k.tooltipOptions.followPointer;l=l&&k&&!k.noSharedTooltip;if(g&&(g!==d.hoverPoint||e&&e.isHidden)){(d.hoverPoints||[]).forEach(function(a){-1===r.indexOf(a)&&a.setState()});if(d.hoverSeries!==k)k.onMouseOver();this.applyInactiveState(r);(r||[]).forEach(function(a){a.setState("hover")});d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");if(!g.series)return;g.firePointEvent("mouseOver");d.hoverPoints=r;d.hoverPoint=g;e&&e.refresh(l?r:g,a)}else b&&
	e&&!e.isHidden&&(g=e.getAnchor([{}],a),e.updatePosition({plotX:g[0],plotY:g[1]}));this.unDocMouseMove||(this.unDocMouseMove=y(d.container.ownerDocument,"mousemove",function(a){var b=h[c.hoverChartIndex];if(b)b.pointer.onDocumentMouseMove(a)}));d.axes.forEach(function(b){var d=C(b.crosshair.snap,!0),e=d?c.find(r,function(a){return a.series[b.coll]===b}):void 0;e||!d?b.drawCrosshair(a,e):b.hideCrosshair()})},applyInactiveState:function(a){var b=[],d;(a||[]).forEach(function(a){d=a.series;b.push(d);
	d.linkedParent&&b.push(d.linkedParent);d.linkedSeries&&(b=b.concat(d.linkedSeries));d.navigatorSeries&&b.push(d.navigatorSeries)});this.chart.series.forEach(function(a){-1===b.indexOf(a)?a.setState("inactive",!0):a.options.inactiveOtherPoints&&a.setAllPointsToState("inactive")})},reset:function(a,b){var d=this.chart,e=d.hoverSeries,c=d.hoverPoint,g=d.hoverPoints,k=d.tooltip,l=k&&k.shared?g:c;a&&l&&H(l).forEach(function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)k&&l&&H(l).length&&(k.refresh(l),
	k.shared&&g?g.forEach(function(a){a.setState(a.state,!0);a.series.isCartesian&&(a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a),a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a))}):c&&(c.setState(c.state,!0),d.axes.forEach(function(a){a.crosshair&&a.drawCrosshair(null,c)})));else{if(c)c.onMouseOut();g&&g.forEach(function(a){a.setState()});if(e)e.onMouseOut();k&&k.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());d.axes.forEach(function(a){a.hideCrosshair()});
	this.hoverX=d.hoverPoints=d.hoverPoint=null}},scaleGroups:function(a,b){var d=this.chart,e;d.series.forEach(function(c){e=a||c.getPlotBox();c.xAxis&&c.xAxis.zoomEnabled&&c.group&&(c.group.attr(e),c.markerGroup&&(c.markerGroup.attr(e),c.markerGroup.clip(b?d.clipRect:null)),c.dataLabelsGroup&&c.dataLabelsGroup.attr(e))});d.clipRect.attr(b||d.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},
	drag:function(a){var b=this.chart,d=b.options.chart,e=a.chartX,c=a.chartY,g=this.zoomHor,k=this.zoomVert,r=b.plotLeft,h=b.plotTop,A=b.plotWidth,w=b.plotHeight,m=this.selectionMarker,f=this.mouseDownX,J=this.mouseDownY,v=d.panKey&&a[d.panKey+"Key"];if(!m||!m.touch)if(e<r?e=r:e>r+A&&(e=r+A),c<h?c=h:c>h+w&&(c=h+w),this.hasDragged=Math.sqrt(Math.pow(f-e,2)+Math.pow(J-c,2)),10<this.hasDragged){var q=b.isInsidePlot(f-r,J-h);b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&q&&!v&&!m&&(this.selectionMarker=
	m=b.renderer.rect(r,h,g?1:A,k?1:w,0).attr({"class":"highcharts-selection-marker",zIndex:7}).add(),b.styledMode||m.attr({fill:d.selectionMarkerFill||n("#335cad").setOpacity(.25).get()}));m&&g&&(e-=f,m.attr({width:Math.abs(e),x:(0<e?0:e)+f}));m&&k&&(e=c-J,m.attr({height:Math.abs(e),y:(0<e?0:e)+J}));q&&!m&&d.panning&&b.pan(a,d.panning)}},drop:function(a){var d=this,e=this.chart,c=this.hasPinched;if(this.selectionMarker){var g={originalEvent:a,xAxis:[],yAxis:[]},h=this.selectionMarker,k=h.attr?h.attr("x"):
	h.x,r=h.attr?h.attr("y"):h.y,x=h.attr?h.attr("width"):h.width,A=h.attr?h.attr("height"):h.height,w;if(this.hasDragged||c)e.axes.forEach(function(b){if(b.zoomEnabled&&G(b.min)&&(c||d[{xAxis:"zoomX",yAxis:"zoomY"}[b.coll]])){var e=b.horiz,m="touchend"===a.type?b.minPixelPadding:0,l=b.toValue((e?k:r)+m);e=b.toValue((e?k+x:r+A)-m);g[b.coll].push({axis:b,min:Math.min(l,e),max:Math.max(l,e)});w=!0}}),w&&b(e,"selection",g,function(a){e.zoom(z(a,c?{animation:!1}:null))});B(e.index)&&(this.selectionMarker=
	this.selectionMarker.destroy());c&&this.scaleGroups()}e&&B(e.index)&&(q(e.container,{cursor:e._cursor}),e.cancelClick=10<this.hasDragged,e.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(a){h[c.hoverChartIndex]&&h[c.hoverChartIndex].pointer.drop(a)},onDocumentMouseMove:function(a){var b=this.chart,d=this.chartPosition;
	a=this.normalize(a,d);!d||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(a){var b=h[c.hoverChartIndex];b&&(a.relatedTarget||a.toElement)&&(b.pointer.reset(),b.pointer.chartPosition=void 0)},onContainerMouseMove:function(a){var b=this.chart;G(c.hoverChartIndex)&&h[c.hoverChartIndex]&&h[c.hoverChartIndex].mouseIsDown||(c.hoverChartIndex=b.index);a=this.normalize(a);a.preventDefault||(a.returnValue=!1);
	"mousedown"===b.mouseIsDown&&this.drag(a);!this.inClass(a.target,"highcharts-tracker")&&!b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||b.openMenu||this.runPointActions(a)},inClass:function(a,b){for(var d;a;){if(d=F(a,"class")){if(-1!==d.indexOf(b))return!0;if(-1!==d.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||
	this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var d=this.chart,e=d.hoverPoint,c=d.plotLeft,g=d.plotTop;a=this.normalize(a);d.cancelClick||(e&&this.inClass(a.target,"highcharts-tracker")?(b(e.series,"click",z(a,{point:e})),d.hoverPoint&&e.firePointEvent("click",a)):(z(a,this.getCoordinates(a)),d.isInsidePlot(a.chartX-c,a.chartY-g)&&b(d,"click",a)))},setDOMEvents:function(){var a=this,b=a.chart.container,d=b.ownerDocument;
	b.onmousedown=function(b){a.onContainerMouseDown(b)};b.onmousemove=function(b){a.onContainerMouseMove(b)};b.onclick=function(b){a.onContainerClick(b)};this.unbindContainerMouseLeave=y(b,"mouseleave",a.onContainerMouseLeave);c.unbindDocumentMouseUp||(c.unbindDocumentMouseUp=y(d,"mouseup",a.onDocumentMouseUp));c.hasTouch&&(y(b,"touchstart",function(b){a.onContainerTouchStart(b)}),y(b,"touchmove",function(b){a.onContainerTouchMove(b)}),c.unbindDocumentTouchEnd||(c.unbindDocumentTouchEnd=y(d,"touchend",
	a.onDocumentTouchEnd)))},destroy:function(){var a=this;a.unDocMouseMove&&a.unDocMouseMove();this.unbindContainerMouseLeave();c.chartCount||(c.unbindDocumentMouseUp&&(c.unbindDocumentMouseUp=c.unbindDocumentMouseUp()),c.unbindDocumentTouchEnd&&(c.unbindDocumentTouchEnd=c.unbindDocumentTouchEnd()));clearInterval(a.tooltipTimeout);v(a,function(b,d){a[d]=null})}}});M(I,"parts/TouchPointer.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.extend,G=f.pick,z=c.charts,B=c.noop;F(c.Pointer.prototype,
	{pinchTranslate:function(c,f,C,B,y,h){this.zoomHor&&this.pinchTranslateDirection(!0,c,f,C,B,y,h);this.zoomVert&&this.pinchTranslateDirection(!1,c,f,C,B,y,h)},pinchTranslateDirection:function(c,f,C,B,y,h,n,q){var g=this.chart,b=c?"x":"y",a=c?"X":"Y",d="chart"+a,e=c?"width":"height",l=g["plot"+(c?"Left":"Top")],v,t,p=q||1,u=g.inverted,k=g.bounds[c?"h":"v"],r=1===f.length,x=f[0][d],A=C[0][d],w=!r&&f[1][d],m=!r&&C[1][d];C=function(){!r&&20<Math.abs(x-w)&&(p=q||Math.abs(A-m)/Math.abs(x-w));t=(l-A)/p+x;
	v=g["plot"+(c?"Width":"Height")]/p};C();f=t;if(f<k.min){f=k.min;var K=!0}else f+v>k.max&&(f=k.max-v,K=!0);K?(A-=.8*(A-n[b][0]),r||(m-=.8*(m-n[b][1])),C()):n[b]=[A,m];u||(h[b]=t-l,h[e]=v);h=u?1/p:p;y[e]=v;y[b]=f;B[u?c?"scaleY":"scaleX":"scale"+a]=p;B["translate"+a]=h*l+(A-h*x)},pinch:function(c){var f=this,t=f.chart,z=f.pinchDown,y=c.touches,h=y.length,n=f.lastValidTouch,q=f.hasZoom,g=f.selectionMarker,b={},a=1===h&&(f.inClass(c.target,"highcharts-tracker")&&t.runTrackerClick||f.runChartClick),d={};
	1<h&&(f.initiated=!0);q&&f.initiated&&!a&&c.preventDefault();[].map.call(y,function(a){return f.normalize(a)});"touchstart"===c.type?([].forEach.call(y,function(a,b){z[b]={chartX:a.chartX,chartY:a.chartY}}),n.x=[z[0].chartX,z[1]&&z[1].chartX],n.y=[z[0].chartY,z[1]&&z[1].chartY],t.axes.forEach(function(a){if(a.zoomEnabled){var b=t.bounds[a.horiz?"h":"v"],d=a.minPixelPadding,e=a.toPixels(Math.min(G(a.options.min,a.dataMin),a.dataMin)),c=a.toPixels(Math.max(G(a.options.max,a.dataMax),a.dataMax)),g=Math.max(e,
	c);b.min=Math.min(a.pos,Math.min(e,c)-d);b.max=Math.max(a.pos+a.len,g+d)}}),f.res=!0):f.followTouchMove&&1===h?this.runPointActions(f.normalize(c)):z.length&&(g||(f.selectionMarker=g=F({destroy:B,touch:!0},t.plotBox)),f.pinchTranslate(z,y,b,g,d,n),f.hasPinched=q,f.scaleGroups(b,d),f.res&&(f.res=!1,this.reset(!1,0)))},touch:function(f,v){var t=this.chart,z;if(t.index!==c.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});c.hoverChartIndex=t.index;if(1===f.touches.length)if(f=this.normalize(f),
	(z=t.isInsidePlot(f.chartX-t.plotLeft,f.chartY-t.plotTop))&&!t.openMenu){v&&this.runPointActions(f);if("touchmove"===f.type){v=this.pinchDown;var y=v[0]?4<=Math.sqrt(Math.pow(v[0].chartX-f.chartX,2)+Math.pow(v[0].chartY-f.chartY,2)):!1}G(y,!0)&&this.pinch(f)}else v&&this.reset();else 2===f.touches.length&&this.pinch(f)},onContainerTouchStart:function(c){this.zoomOption(c);this.touch(c,!0)},onContainerTouchMove:function(c){this.touch(c)},onDocumentTouchEnd:function(f){z[c.hoverChartIndex]&&z[c.hoverChartIndex].pointer.drop(f)}})});
	M(I,"parts/MSPointer.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.extend,G=f.objectEach,z=c.addEvent,B=c.charts,t=c.css,v=c.doc,C=c.noop;f=c.Pointer;var H=c.removeEvent,y=c.win,h=c.wrap;if(!c.hasTouch&&(y.PointerEvent||y.MSPointerEvent)){var n={},q=!!y.PointerEvent,g=function(){var a=[];a.item=function(a){return this[a]};G(n,function(b){a.push({pageX:b.pageX,pageY:b.pageY,target:b.target})});return a},b=function(a,b,e,l){"touch"!==a.pointerType&&a.pointerType!==a.MSPOINTER_TYPE_TOUCH||
	!B[c.hoverChartIndex]||(l(a),l=B[c.hoverChartIndex].pointer,l[b]({type:e,target:a.currentTarget,preventDefault:C,touches:g()}))};F(f.prototype,{onContainerPointerDown:function(a){b(a,"onContainerTouchStart","touchstart",function(a){n[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){b(a,"onContainerTouchMove","touchmove",function(a){n[a.pointerId]={pageX:a.pageX,pageY:a.pageY};n[a.pointerId].target||(n[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){b(a,
	"onDocumentTouchEnd","touchend",function(a){delete n[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,q?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,q?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(v,q?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});h(f.prototype,"init",function(a,b,e){a.call(this,b,e);this.hasZoom&&t(b.container,{"-ms-touch-action":"none","touch-action":"none"})});h(f.prototype,"setDOMEvents",function(a){a.apply(this);
	(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(z)});h(f.prototype,"destroy",function(a){this.batchMSEvents(H);a.call(this)})}});M(I,"parts/Legend.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.discardElement,z=f.isNumber,B=f.pick,t=f.setAnimation,v=c.addEvent,C=c.css,H=c.fireEvent;f=c.isFirefox;var y=c.marginNames,h=c.merge,n=c.stableSort,q=c.win,g=c.wrap;c.Legend=function(b,a){this.init(b,a)};c.Legend.prototype={init:function(b,a){this.chart=b;this.setOptions(a);
	a.enabled&&(this.render(),v(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=v(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(b){var a=B(b.padding,8);this.options=b;this.chart.styledMode||(this.itemStyle=b.itemStyle,this.itemHiddenStyle=h(this.itemStyle,b.itemHiddenStyle));this.itemMarginTop=b.itemMarginTop||0;this.itemMarginBottom=b.itemMarginBottom||
	0;this.padding=a;this.initialItemY=a-5;this.symbolWidth=B(b.symbolWidth,16);this.pages=[];this.proximate="proximate"===b.layout&&!this.chart.inverted},update:function(b,a){var d=this.chart;this.setOptions(h(!0,this.options,b));this.destroy();d.isDirtyLegend=d.isDirtyBox=!0;B(a,!0)&&d.redraw();H(this,"afterUpdate")},colorizeItem:function(b,a){b.legendGroup[a?"removeClass":"addClass"]("highcharts-legend-item-hidden");if(!this.chart.styledMode){var d=this.options,e=b.legendItem,c=b.legendLine,g=b.legendSymbol,
	h=this.itemHiddenStyle.color;d=a?d.itemStyle.color:h;var f=a?b.color||h:h,u=b.options&&b.options.marker,k={fill:f};e&&e.css({fill:d,color:d});c&&c.attr({stroke:f});g&&(u&&g.isMarker&&(k=b.pointAttribs(),a||(k.stroke=k.fill=h)),g.attr(k))}H(this,"afterColorizeItem",{item:b,visible:a})},positionItems:function(){this.allItems.forEach(this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(b){var a=this.options,d=a.symbolPadding;a=!a.rtl;var e=b._legendItemPos,
	c=e[0];e=e[1];var g=b.checkbox;if((b=b.legendGroup)&&b.element)b[F(b.translateY)?"animate":"attr"]({translateX:a?c:this.legendWidth-c-2*d-4,translateY:e});g&&(g.x=c,g.y=e)},destroyItem:function(b){var a=b.checkbox;["legendItem","legendLine","legendSymbol","legendGroup"].forEach(function(a){b[a]&&(b[a]=b[a].destroy())});a&&G(b.checkbox)},destroy:function(){function b(a){this[a]&&(this[a]=this[a].destroy())}this.getAllItems().forEach(function(a){["legendItem","legendGroup"].forEach(b,a)});"clipRect up down pager nav box title group".split(" ").forEach(b,
	this);this.display=null},positionCheckboxes:function(){var b=this.group&&this.group.alignAttr,a=this.clipHeight||this.legendHeight,d=this.titleHeight;if(b){var e=b.translateY;this.allItems.forEach(function(c){var g=c.checkbox;if(g){var l=e+d+g.y+(this.scrollOffset||0)+3;C(g,{left:b.translateX+c.checkboxOffset+g.x-20+"px",top:l+"px",display:this.proximate||l>e-6&&l<e+a-6?"":"none"})}},this)}},renderTitle:function(){var b=this.options,a=this.padding,d=b.title,e=0;d.text&&(this.title||(this.title=this.chart.renderer.label(d.text,
	a-3,a-4,null,null,null,b.useHTML,null,"legend-title").attr({zIndex:1}),this.chart.styledMode||this.title.css(d.style),this.title.add(this.group)),d.width||this.title.css({width:this.maxLegendWidth+"px"}),b=this.title.getBBox(),e=b.height,this.offsetWidth=b.width,this.contentGroup.attr({translateY:e}));this.titleHeight=e},setText:function(b){var a=this.options;b.legendItem.attr({text:a.labelFormat?c.format(a.labelFormat,b,this.chart.time):a.labelFormatter.call(b)})},renderItem:function(b){var a=this.chart,
	d=a.renderer,e=this.options,c=this.symbolWidth,g=e.symbolPadding,f=this.itemStyle,p=this.itemHiddenStyle,u="horizontal"===e.layout?B(e.itemDistance,20):0,k=!e.rtl,r=b.legendItem,x=!b.series,A=!x&&b.series.drawLegendSymbol?b.series:b,w=A.options;w=this.createCheckboxForItem&&w&&w.showCheckbox;u=c+g+u+(w?20:0);var m=e.useHTML,n=b.options.className;r||(b.legendGroup=d.g("legend-item").addClass("highcharts-"+A.type+"-series highcharts-color-"+b.colorIndex+(n?" "+n:"")+(x?" highcharts-series-"+b.index:
	"")).attr({zIndex:1}).add(this.scrollGroup),b.legendItem=r=d.text("",k?c+g:-g,this.baseline||0,m),a.styledMode||r.css(h(b.visible?f:p)),r.attr({align:k?"left":"right",zIndex:2}).add(b.legendGroup),this.baseline||(this.fontMetrics=d.fontMetrics(a.styledMode?12:f.fontSize,r),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,r.attr("y",this.baseline)),this.symbolHeight=e.symbolHeight||this.fontMetrics.f,A.drawLegendSymbol(this,b),this.setItemEvents&&this.setItemEvents(b,r,m));w&&!b.checkbox&&this.createCheckboxForItem(b);
	this.colorizeItem(b,b.visible);!a.styledMode&&f.width||r.css({width:(e.itemWidth||this.widthOption||a.spacingBox.width)-u});this.setText(b);a=r.getBBox();b.itemWidth=b.checkboxOffset=e.itemWidth||b.legendItemWidth||a.width+u;this.maxItemWidth=Math.max(this.maxItemWidth,b.itemWidth);this.totalItemWidth+=b.itemWidth;this.itemHeight=b.itemHeight=Math.round(b.legendItemHeight||a.height||this.symbolHeight)},layoutItem:function(b){var a=this.options,d=this.padding,e="horizontal"===a.layout,c=b.itemHeight,
	g=this.itemMarginBottom,h=this.itemMarginTop,f=e?B(a.itemDistance,20):0,u=this.maxLegendWidth;a=a.alignColumns&&this.totalItemWidth>u?this.maxItemWidth:b.itemWidth;e&&this.itemX-d+a>u&&(this.itemX=d,this.lastLineHeight&&(this.itemY+=h+this.lastLineHeight+g),this.lastLineHeight=0);this.lastItemY=h+this.itemY+g;this.lastLineHeight=Math.max(c,this.lastLineHeight);b._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=a:(this.itemY+=h+c+g,this.lastLineHeight=c);this.offsetWidth=this.widthOption||Math.max((e?
	this.itemX-d-(b.checkbox?0:f):a)+d,this.offsetWidth)},getAllItems:function(){var b=[];this.chart.series.forEach(function(a){var d=a&&a.options;a&&B(d.showInLegend,F(d.linkedTo)?!1:void 0,!0)&&(b=b.concat(a.legendItems||("point"===d.legendType?a.data:a)))});H(this,"afterGetAllItems",{allItems:b});return b},getAlignment:function(){var b=this.options;return this.proximate?b.align.charAt(0)+"tv":b.floating?"":b.align.charAt(0)+b.verticalAlign.charAt(0)+b.layout.charAt(0)},adjustMargins:function(b,a){var d=
	this.chart,e=this.options,c=this.getAlignment();c&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(g,l){g.test(c)&&!F(b[l])&&(d[y[l]]=Math.max(d[y[l]],d.legend[(l+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][l]*e[l%2?"x":"y"]+B(e.margin,12)+a[l]+(d.titleOffset[l]||0)))})},proximatePositions:function(){var b=this.chart,a=[],d="left"===this.options.align;this.allItems.forEach(function(e){var g=d;if(e.yAxis&&e.points){e.xAxis.options.reversed&&(g=!g);var h=c.find(g?e.points:
	e.points.slice(0).reverse(),function(a){return z(a.plotY)});g=this.itemMarginTop+e.legendItem.getBBox().height+this.itemMarginBottom;var f=e.yAxis.top-b.plotTop;e.visible?(h=h?h.plotY:e.yAxis.height,h+=f-.3*g):h=f+e.yAxis.height;a.push({target:h,size:g,item:e})}},this);c.distribute(a,b.plotHeight);a.forEach(function(a){a.item._legendItemPos[1]=b.plotTop-b.spacing[0]+a.pos})},render:function(){var b=this.chart,a=b.renderer,d=this.group,e,g=this.box,f=this.options,q=this.padding;this.itemX=q;this.itemY=
	this.initialItemY;this.lastItemY=this.offsetWidth=0;this.widthOption=c.relativeLength(f.width,b.spacingBox.width-q);var p=b.spacingBox.width-2*q-f.x;-1<["rm","lm"].indexOf(this.getAlignment().substring(0,2))&&(p/=2);this.maxLegendWidth=this.widthOption||p;d||(this.group=d=a.g("legend").attr({zIndex:7}).add(),this.contentGroup=a.g().attr({zIndex:1}).add(d),this.scrollGroup=a.g().add(this.contentGroup));this.renderTitle();p=this.getAllItems();n(p,function(a,b){return(a.options&&a.options.legendIndex||
	0)-(b.options&&b.options.legendIndex||0)});f.reversed&&p.reverse();this.allItems=p;this.display=e=!!p.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;p.forEach(this.renderItem,this);p.forEach(this.layoutItem,this);p=(this.widthOption||this.offsetWidth)+q;var u=this.lastItemY+this.lastLineHeight+this.titleHeight;u=this.handleOverflow(u);u+=q;g||(this.box=g=a.rect().addClass("highcharts-legend-box").attr({r:f.borderRadius}).add(d),g.isNew=!0);b.styledMode||g.attr({stroke:f.borderColor,
	"stroke-width":f.borderWidth||0,fill:f.backgroundColor||"none"}).shadow(f.shadow);0<p&&0<u&&(g[g.isNew?"attr":"animate"](g.crisp.call({},{x:0,y:0,width:p,height:u},g.strokeWidth())),g.isNew=!1);g[e?"show":"hide"]();b.styledMode&&"none"===d.getStyle("display")&&(p=u=0);this.legendWidth=p;this.legendHeight=u;e&&(a=b.spacingBox,g=a.y,/(lth|ct|rth)/.test(this.getAlignment())&&0<b.titleOffset[0]?g+=b.titleOffset[0]:/(lbh|cb|rbh)/.test(this.getAlignment())&&0<b.titleOffset[2]&&(g-=b.titleOffset[2]),g!==
	a.y&&(a=h(a,{y:g})),d.align(h(f,{width:p,height:u,verticalAlign:this.proximate?"top":f.verticalAlign}),!0,a));this.proximate||this.positionItems();H(this,"afterRender")},handleOverflow:function(b){var a=this,d=this.chart,e=d.renderer,c=this.options,g=c.y,h=this.padding;g=d.spacingBox.height+("top"===c.verticalAlign?-g:g)-h;var f=c.maxHeight,u,k=this.clipRect,r=c.navigation,x=B(r.animation,!0),A=r.arrowSize||12,w=this.nav,m=this.pages,n,J=this.allItems,q=function(b){"number"===typeof b?k.attr({height:b}):
	k&&(a.clipRect=k.destroy(),a.contentGroup.clip());a.contentGroup.div&&(a.contentGroup.div.style.clip=b?"rect("+h+"px,9999px,"+(h+b)+"px,0)":"auto")},v=function(b){a[b]=e.circle(0,0,1.3*A).translate(A/2,A/2).add(w);d.styledMode||a[b].attr("fill","rgba(0,0,0,0.0001)");return a[b]};"horizontal"!==c.layout||"middle"===c.verticalAlign||c.floating||(g/=2);f&&(g=Math.min(g,f));m.length=0;b>g&&!1!==r.enabled?(this.clipHeight=u=Math.max(g-20-this.titleHeight-h,0),this.currentPage=B(this.currentPage,1),this.fullHeight=
	b,J.forEach(function(a,b){var d=a._legendItemPos[1],e=Math.round(a.legendItem.getBBox().height),c=m.length;if(!c||d-m[c-1]>u&&(n||d)!==m[c-1])m.push(n||d),c++;a.pageIx=c-1;n&&(J[b-1].pageIx=c-1);b===J.length-1&&d+e-m[c-1]>u&&d!==n&&(m.push(d),a.pageIx=c);d!==n&&(n=d)}),k||(k=a.clipRect=e.clipRect(0,h,9999,0),a.contentGroup.clip(k)),q(u),w||(this.nav=w=e.g().attr({zIndex:1}).add(this.group),this.up=e.symbol("triangle",0,0,A,A).add(w),v("upTracker").on("click",function(){a.scroll(-1,x)}),this.pager=
	e.text("",15,10).addClass("highcharts-legend-navigation"),d.styledMode||this.pager.css(r.style),this.pager.add(w),this.down=e.symbol("triangle-down",0,0,A,A).add(w),v("downTracker").on("click",function(){a.scroll(1,x)})),a.scroll(0),b=g):w&&(q(),this.nav=w.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return b},scroll:function(b,a){var d=this.pages,e=d.length,c=this.currentPage+b;b=this.clipHeight;var g=this.options.navigation,h=this.pager,f=this.padding;c>e&&(c=e);0<c&&(void 0!==
	a&&t(a,this.chart),this.nav.attr({translateX:f,translateY:b+this.padding+7+this.titleHeight,visibility:"visible"}),[this.up,this.upTracker].forEach(function(a){a.attr({"class":1===c?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),h.attr({text:c+"/"+e}),[this.down,this.downTracker].forEach(function(a){a.attr({x:18+this.pager.getBBox().width,"class":c===e?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})},this),this.chart.styledMode||(this.up.attr({fill:1===c?g.inactiveColor:
	g.activeColor}),this.upTracker.css({cursor:1===c?"default":"pointer"}),this.down.attr({fill:c===e?g.inactiveColor:g.activeColor}),this.downTracker.css({cursor:c===e?"default":"pointer"})),this.scrollOffset=-d[c-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=c,this.positionCheckboxes())}};c.LegendSymbolMixin={drawRectangle:function(b,a){var d=b.symbolHeight,e=b.options.squareSymbol;a.legendSymbol=this.chart.renderer.rect(e?(b.symbolWidth-d)/2:0,b.baseline-
	d+1,e?d:b.symbolWidth,d,B(b.options.symbolRadius,d/2)).addClass("highcharts-point").attr({zIndex:3}).add(a.legendGroup)},drawLineMarker:function(b){var a=this.options,d=a.marker,e=b.symbolWidth,c=b.symbolHeight,g=c/2,f=this.chart.renderer,p=this.legendGroup;b=b.baseline-Math.round(.3*b.fontMetrics.b);var u={};this.chart.styledMode||(u={"stroke-width":a.lineWidth||0},a.dashStyle&&(u.dashstyle=a.dashStyle));this.legendLine=f.path(["M",0,b,"L",e,b]).addClass("highcharts-graph").attr(u).add(p);d&&!1!==
	d.enabled&&e&&(a=Math.min(B(d.radius,g),g),0===this.symbol.indexOf("url")&&(d=h(d,{width:c,height:c}),a=0),this.legendSymbol=d=f.symbol(this.symbol,e/2-a,b-a,2*a,2*a,d).addClass("highcharts-point").add(p),d.isMarker=!0)}};(/Trident\/7\.0/.test(q.navigator&&q.navigator.userAgent)||f)&&g(c.Legend.prototype,"positionItem",function(b,a){var d=this,e=function(){a._legendItemPos&&b.call(d,a)};e();d.bubbleLegend||setTimeout(e)})});M(I,"parts/Chart.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,
	f){var F=f.attr,G=f.defined,z=f.discardElement,B=f.erase,t=f.extend,v=f.isArray,C=f.isNumber,H=f.isObject,y=f.isString,h=f.objectEach,n=f.pick,q=f.pInt,g=f.setAnimation,b=f.splat,a=f.syncTimeout,d=c.addEvent,e=c.animate,l=c.animObject,L=c.doc,E=c.Axis,p=c.createElement,u=c.defaultOptions,k=c.charts,r=c.css,x=c.find,A=c.fireEvent,w=c.Legend,m=c.marginNames,K=c.merge,J=c.Pointer,U=c.removeEvent,S=c.seriesTypes,Q=c.win,O=c.Chart=function(){this.getArgs.apply(this,arguments)};c.chart=function(a,b,d){return new O(a,
	b,d)};t(O.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(y(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(a,b){var e,g=a.series,m=a.plotOptions||{};A(this,"init",{args:arguments},function(){a.series=null;e=K(u,a);h(e.plotOptions,function(a,b){H(a)&&(a.tooltip=m[b]&&K(m[b].tooltip)||void 0)});e.tooltip.userOptions=a.chart&&a.chart.forExport&&a.tooltip.userOptions||a.tooltip;e.series=a.series=g;this.userOptions=a;var r=e.chart,l=r.events;
	this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=b;this.isResizing=0;this.options=e;this.axes=[];this.series=[];this.time=a.time&&Object.keys(a.time).length?new c.Time(a.time):c.time;this.styledMode=r.styledMode;this.hasCartesianSeries=r.showAxes;var f=this;f.index=k.length;k.push(f);c.chartCount++;l&&h(l,function(a,b){c.isFunction(a)&&d(f,b,a)});f.xAxis=[];f.yAxis=[];f.pointCount=f.colorCounter=f.symbolCounter=0;A(f,"afterInit");f.firstRender()})},initSeries:function(a){var b=
	this.options.chart;b=a.type||b.type||b.defaultSeriesType;var d=S[b];d||c.error(17,!0,this,{missingModuleFor:b});b=new d;b.init(this,a);return b},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,d){var e=d?b:a;a=d?a:b;return 0<=e&&e<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(a){A(this,"beforeRedraw");var b=this.axes,d=this.series,e=this.pointer,c=this.legend,k=this.userOptions.legend,m=this.isDirtyLegend,
	r=this.hasCartesianSeries,h=this.isDirtyBox,l=this.renderer,f=l.isHidden(),x=[];this.setResponsive&&this.setResponsive(!1);g(a,this);f&&this.temporaryDisplay();this.layOutTitles();for(a=d.length;a--;){var w=d[a];if(w.options.stacking){var p=!0;if(w.isDirty){var u=!0;break}}}if(u)for(a=d.length;a--;)w=d[a],w.options.stacking&&(w.isDirty=!0);d.forEach(function(a){a.isDirty&&("point"===a.options.legendType?(a.updateTotals&&a.updateTotals(),m=!0):k&&(k.labelFormatter||k.labelFormat)&&(m=!0));a.isDirtyData&&
	A(a,"updatedData")});m&&c&&c.options.enabled&&(c.render(),this.isDirtyLegend=!1);p&&this.getStacks();r&&b.forEach(function(a){a.updateNames();a.setScale()});this.getMargins();r&&(b.forEach(function(a){a.isDirty&&(h=!0)}),b.forEach(function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,x.push(function(){A(a,"afterSetExtremes",t(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(h||p)&&a.redraw()}));h&&this.drawChartBox();A(this,"predraw");d.forEach(function(a){(h||a.isDirty)&&a.visible&&a.redraw();
	a.isDirtyData=!1});e&&e.reset(!0);l.draw();A(this,"redraw");A(this,"render");f&&this.temporaryDisplay(!0);x.forEach(function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var d=this.series,e;var c=x(this.axes,b)||x(this.series,b);for(e=0;!c&&e<d.length;e++)c=x(d[e].points||[],b);return c},getAxes:function(){var a=this,d=this.options,e=d.xAxis=b(d.xAxis||{});d=d.yAxis=b(d.yAxis||{});A(this,"getAxes");e.forEach(function(a,b){a.index=b;a.isX=!0});d.forEach(function(a,
	b){a.index=b});e.concat(d).forEach(function(b){new E(a,b)});A(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];this.series.forEach(function(b){a=a.concat((b[b.hasGroupedData?"points":"data"]||[]).filter(function(a){return n(a.selectedStaging,a.selected)}))});return a},getSelectedSeries:function(){return this.series.filter(function(a){return a.selected})},setTitle:function(a,b,d){this.applyDescription("title",a);this.applyDescription("subtitle",b);this.applyDescription("caption",void 0);
	this.layOutTitles(d)},applyDescription:function(a,b){var d=this,e="title"===a?{color:"#333333",fontSize:this.options.isStock?"16px":"18px"}:{color:"#666666"};e=this.options[a]=K(!this.styledMode&&{style:e},this.options[a],b);var c=this[a];c&&b&&(this[a]=c=c.destroy());e&&!c&&(c=this.renderer.text(e.text,0,0,e.useHTML).attr({align:e.align,"class":"highcharts-"+a,zIndex:e.zIndex||4}).add(),c.update=function(b){d[{title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"}[a]](b)},this.styledMode||
	c.css(e.style),this[a]=c)},layOutTitles:function(a){var b=[0,0,0],d=this.renderer,e=this.spacingBox;["title","subtitle","caption"].forEach(function(a){var c=this[a],k=this.options[a],g=k.verticalAlign||"top";a="title"===a?-3:"top"===g?b[0]+2:0;if(c){if(!this.styledMode)var m=k.style.fontSize;m=d.fontMetrics(m,c).b;c.css({width:(k.width||e.width+(k.widthAdjust||0))+"px"});var r=Math.round(c.getBBox(k.useHTML).height);c.align(t({y:"bottom"===g?m:a+m,height:r},k),!1,"spacingBox");k.floating||("top"===
	g?b[0]=Math.ceil(b[0]+r):"bottom"===g&&(b[2]=Math.ceil(b[2]+r)))}},this);b[0]&&"top"===(this.options.title.verticalAlign||"top")&&(b[0]+=this.options.title.margin);b[2]&&"bottom"===this.options.caption.verticalAlign&&(b[2]+=this.options.caption.margin);var c=!this.titleOffset||this.titleOffset.join(",")!==b.join(",");this.titleOffset=b;A(this,"afterLayOutTitles");!this.isDirtyBox&&c&&(this.isDirtyBox=this.isDirtyLegend=c,this.hasRendered&&n(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var a=
	this.options.chart,b=a.width;a=a.height;var d=this.renderTo;G(b)||(this.containerWidth=c.getStyle(d,"width"));G(a)||(this.containerHeight=c.getStyle(d,"height"));this.chartWidth=Math.max(0,b||this.containerWidth||600);this.chartHeight=Math.max(0,c.relativeLength(a,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(a){var b=this.renderTo;if(a)for(;b&&b.style;)b.hcOrigStyle&&(c.css(b,b.hcOrigStyle),delete b.hcOrigStyle),b.hcOrigDetached&&(L.body.removeChild(b),
	b.hcOrigDetached=!1),b=b.parentNode;else for(;b&&b.style;){L.body.contains(b)||b.parentNode||(b.hcOrigDetached=!0,L.body.appendChild(b));if("none"===c.getStyle(b,"display",!1)||b.hcOricDetached)b.hcOrigStyle={display:b.style.display,height:b.style.height,overflow:b.style.overflow},a={display:"block",overflow:"hidden"},b!==this.renderTo&&(a.height=0),c.css(b,a),b.offsetWidth||b.style.setProperty("display","block","important");b=b.parentNode;if(b===L.body)break}},setClassName:function(a){this.container.className=
	"highcharts-container "+(a||"")},getContainer:function(){var a=this.options,b=a.chart;var d=this.renderTo;var e=c.uniqueKey(),g,m;d||(this.renderTo=d=b.renderTo);y(d)&&(this.renderTo=d=L.getElementById(d));d||c.error(13,!0,this);var h=q(F(d,"data-highcharts-chart"));C(h)&&k[h]&&k[h].hasRendered&&k[h].destroy();F(d,"data-highcharts-chart",this.index);d.innerHTML="";b.skipClone||d.offsetWidth||this.temporaryDisplay();this.getChartSize();h=this.chartWidth;var l=this.chartHeight;r(d,{overflow:"hidden"});
	this.styledMode||(g=t({position:"relative",overflow:"hidden",width:h+"px",height:l+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},b.style));this.container=d=p("div",{id:e},g,d);this._cursor=d.style.cursor;this.renderer=new (c[b.renderer]||c.Renderer)(d,h,l,null,b.forExport,a.exporting&&a.exporting.allowHTML,this.styledMode);this.setClassName(b.className);if(this.styledMode)for(m in a.defs)this.renderer.definition(a.defs[m]);else this.renderer.setStyle(b.style);
	this.renderer.chartIndex=this.index;A(this,"afterGetContainer")},getMargins:function(a){var b=this.spacing,d=this.margin,e=this.titleOffset;this.resetMargins();e[0]&&!G(d[0])&&(this.plotTop=Math.max(this.plotTop,e[0]+b[0]));e[2]&&!G(d[2])&&(this.marginBottom=Math.max(this.marginBottom,e[2]+b[2]));this.legend&&this.legend.display&&this.legend.adjustMargins(d,b);A(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],d=a.colorAxis,e=a.margin,c=function(a){a.forEach(function(a){a.visible&&
	a.getOffset()})};a.hasCartesianSeries?c(a.axes):d&&d.length&&c(d);m.forEach(function(d,c){G(e[c])||(a[d]+=b[c])});a.setChartSize()},reflow:function(b){var d=this,e=d.options.chart,k=d.renderTo,g=G(e.width)&&G(e.height),m=e.width||c.getStyle(k,"width");e=e.height||c.getStyle(k,"height");k=b?b.target:Q;if(!g&&!d.isPrinting&&m&&e&&(k===Q||k===L)){if(m!==d.containerWidth||e!==d.containerHeight)c.clearTimeout(d.reflowTimeout),d.reflowTimeout=a(function(){d.container&&d.setSize(void 0,void 0,!1)},b?100:
	0);d.containerWidth=m;d.containerHeight=e}},setReflow:function(a){var b=this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=d(Q,"resize",function(a){b.options&&b.reflow(a)}),d(this,"destroy",this.unbindReflow))},setSize:function(b,d,c){var k=this,m=k.renderer;k.isResizing+=1;g(c,k);k.oldChartHeight=k.chartHeight;k.oldChartWidth=k.chartWidth;void 0!==b&&(k.options.chart.width=b);void 0!==d&&(k.options.chart.height=d);k.getChartSize();
	if(!k.styledMode){var h=m.globalAnimation;(h?e:r)(k.container,{width:k.chartWidth+"px",height:k.chartHeight+"px"},h)}k.setChartSize(!0);m.setSize(k.chartWidth,k.chartHeight,c);k.axes.forEach(function(a){a.isDirty=!0;a.setScale()});k.isDirtyLegend=!0;k.isDirtyBox=!0;k.layOutTitles();k.getMargins();k.redraw(c);k.oldChartHeight=null;A(k,"resize");a(function(){k&&A(k,"endResize",null,function(){--k.isResizing})},l(h).duration||0)},setChartSize:function(a){var b=this.inverted,d=this.renderer,e=this.chartWidth,
	c=this.chartHeight,k=this.options.chart,g=this.spacing,m=this.clipOffset,r,h,l,f;this.plotLeft=r=Math.round(this.plotLeft);this.plotTop=h=Math.round(this.plotTop);this.plotWidth=l=Math.max(0,Math.round(e-r-this.marginRight));this.plotHeight=f=Math.max(0,Math.round(c-h-this.marginBottom));this.plotSizeX=b?f:l;this.plotSizeY=b?l:f;this.plotBorderWidth=k.plotBorderWidth||0;this.spacingBox=d.spacingBox={x:g[3],y:g[0],width:e-g[3]-g[1],height:c-g[0]-g[2]};this.plotBox=d.plotBox={x:r,y:h,width:l,height:f};
	e=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(e,m[3])/2);d=Math.ceil(Math.max(e,m[0])/2);this.clipBox={x:b,y:d,width:Math.floor(this.plotSizeX-Math.max(e,m[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(e,m[2])/2-d))};a||this.axes.forEach(function(a){a.setAxisSize();a.setAxisTranslation()});A(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){A(this,"resetMargins");var a=this,b=a.options.chart;["margin","spacing"].forEach(function(d){var e=b[d],c=H(e)?e:[e,
	e,e,e];["Top","Right","Bottom","Left"].forEach(function(e,k){a[d][k]=n(b[d+e],c[k])})});m.forEach(function(b,d){a[b]=n(a.margin[d],a.spacing[d])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,d=this.chartWidth,e=this.chartHeight,c=this.chartBackground,k=this.plotBackground,g=this.plotBorder,m=this.styledMode,r=this.plotBGImage,h=a.backgroundColor,l=a.plotBackgroundColor,f=a.plotBackgroundImage,x,w=this.plotLeft,p=this.plotTop,u=this.plotWidth,
	n=this.plotHeight,J=this.plotBox,K=this.clipRect,q=this.clipBox,v="animate";c||(this.chartBackground=c=b.rect().addClass("highcharts-background").add(),v="attr");if(m)var y=x=c.strokeWidth();else{y=a.borderWidth||0;x=y+(a.shadow?8:0);h={fill:h||"none"};if(y||c["stroke-width"])h.stroke=a.borderColor,h["stroke-width"]=y;c.attr(h).shadow(a.shadow)}c[v]({x:x/2,y:x/2,width:d-x-y%2,height:e-x-y%2,r:a.borderRadius});v="animate";k||(v="attr",this.plotBackground=k=b.rect().addClass("highcharts-plot-background").add());
	k[v](J);m||(k.attr({fill:l||"none"}).shadow(a.plotShadow),f&&(r?r.animate(J):this.plotBGImage=b.image(f,w,p,u,n).add()));K?K.animate({width:q.width,height:q.height}):this.clipRect=b.clipRect(q);v="animate";g||(v="attr",this.plotBorder=g=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());m||g.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});g[v](g.crisp({x:w,y:p,width:u,height:n},-g.strokeWidth()));this.isDirtyBox=!1;A(this,"afterDrawChartBox")},propFromSeries:function(){var a=
	this,b=a.options.chart,d,e=a.options.series,c,k;["inverted","angular","polar"].forEach(function(g){d=S[b.type||b.defaultSeriesType];k=b[g]||d&&d.prototype[g];for(c=e&&e.length;!k&&c--;)(d=S[e[c].type])&&d.prototype[g]&&(k=!0);a[g]=k})},linkSeries:function(){var a=this,b=a.series;b.forEach(function(a){a.linkedSeries.length=0});b.forEach(function(b){var d=b.options.linkedTo;y(d)&&(d=":previous"===d?a.series[b.index-1]:a.get(d))&&d.linkedParent!==b&&(d.linkedSeries.push(b),b.linkedParent=d,b.visible=
	n(b.options.visible,d.options.visible,b.visible))});A(this,"afterLinkSeries")},renderSeries:function(){this.series.forEach(function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&b.items.forEach(function(d){var e=t(b.style,d.style),c=q(e.left)+a.plotLeft,k=q(e.top)+a.plotTop+12;delete e.left;delete e.top;a.renderer.text(d.html,c,k).attr({zIndex:2}).css(e).add()})},render:function(){var a=this.axes,b=this.colorAxis,d=this.renderer,e=this.options,c=0,k=
	function(a){a.forEach(function(a){a.visible&&a.render()})};this.setTitle();this.legend=new w(this,e.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();e=this.plotWidth;a.some(function(a){if(a.horiz&&a.visible&&a.options.labels.enabled&&a.series.length)return c=21,!0});var g=this.plotHeight=Math.max(this.plotHeight-c,0);a.forEach(function(a){a.setScale()});this.getAxisMargins();var m=1.1<e/this.plotWidth;var r=1.05<g/this.plotHeight;if(m||r)a.forEach(function(a){(a.horiz&&
	m||!a.horiz&&r)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries?k(a):b&&b.length&&k(b);this.seriesGroup||(this.seriesGroup=d.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.updateContainerScaling();this.hasRendered=!0},addCredits:function(a){var b=this;a=K(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||
	""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(Q.location.href=a.href)}).attr({align:a.position.align,zIndex:8}),b.styledMode||this.credits.css(a.style),this.credits.add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},updateContainerScaling:function(){var a=this.container;if(a.offsetWidth&&a.offsetHeight&&a.getBoundingClientRect){var b=a.getBoundingClientRect(),d=b.width/a.offsetWidth;a=b.height/a.offsetHeight;1!==d||1!==
	a?this.containerScaling={scaleX:d,scaleY:a}:delete this.containerScaling}},destroy:function(){var a=this,b=a.axes,d=a.series,e=a.container,g,m=e&&e.parentNode;A(a,"destroy");a.renderer.forExport?B(k,a):k[a.index]=void 0;c.chartCount--;a.renderTo.removeAttribute("data-highcharts-chart");U(a);for(g=b.length;g--;)b[g]=b[g].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(g=d.length;g--;)d[g]=d[g].destroy();"title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(b){var d=
	a[b];d&&d.destroy&&(a[b]=d.destroy())});e&&(e.innerHTML="",U(e),m&&z(e));h(a,function(b,d){delete a[d]})},firstRender:function(){var a=this,b=a.options;if(!a.isReadyToRender||a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();(v(b.series)?b.series:[]).forEach(function(b){a.initSeries(b)});a.linkSeries();A(a,"beforeRender");J&&(a.pointer=new J(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){this.callbacks.concat([this.callback]).forEach(function(a){a&&
	void 0!==this.index&&a.apply(this,[this])},this);A(this,"load");A(this,"render");G(this.index)&&this.setReflow(this.options.chart.reflow);this.onload=null}})});M(I,"parts/ScrollablePlotArea.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.pick,G=c.addEvent;f=c.Chart;"";G(f,"afterSetChartSize",function(f){var z=this.options.chart.scrollablePlotArea,t=z&&z.minWidth;z=z&&z.minHeight;if(!this.renderer.forExport){if(t){if(this.scrollablePixelsX=t=Math.max(0,t-this.chartWidth)){this.plotWidth+=
	t;this.inverted?(this.clipBox.height+=t,this.plotBox.height+=t):(this.clipBox.width+=t,this.plotBox.width+=t);var v={1:{name:"right",value:t}}}}else z&&(this.scrollablePixelsY=t=Math.max(0,z-this.chartHeight))&&(this.plotHeight+=t,this.inverted?(this.clipBox.width+=t,this.plotBox.width+=t):(this.clipBox.height+=t,this.plotBox.height+=t),v={2:{name:"bottom",value:t}});v&&!f.skipAxes&&this.axes.forEach(function(f){v[f.side]?f.getPlotLinePath=function(){var t=v[f.side].name,y=this[t];this[t]=y-v[f.side].value;
	var h=c.Axis.prototype.getPlotLinePath.apply(this,arguments);this[t]=y;return h}:(f.setAxisSize(),f.setAxisTranslation())})}});G(f,"render",function(){this.scrollablePixelsX||this.scrollablePixelsY?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});f.prototype.setUpScrolling=function(){var f={WebkitOverflowScrolling:"touch",overflowX:"hidden",overflowY:"hidden"};this.scrollablePixelsX&&(f.overflowX="auto");this.scrollablePixelsY&&(f.overflowY="auto");
	this.scrollingContainer=c.createElement("div",{className:"highcharts-scrolling"},f,this.renderTo);this.innerContainer=c.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=null};f.prototype.moveFixedElements=function(){var c=this.container,f=this.fixedRenderer,t=".highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "),
	v;this.scrollablePixelsX&&!this.inverted?v=".highcharts-yaxis":this.scrollablePixelsX&&this.inverted?v=".highcharts-xaxis":this.scrollablePixelsY&&!this.inverted?v=".highcharts-xaxis":this.scrollablePixelsY&&this.inverted&&(v=".highcharts-yaxis");t.push(v,v+"-labels");t.forEach(function(v){[].forEach.call(c.querySelectorAll(v),function(c){(c.namespaceURI===f.SVG_NS?f.box:f.box.parentNode).appendChild(c);c.style.pointerEvents="auto"})})};f.prototype.applyFixed=function(){var f,B=!this.fixedDiv,t=this.options.chart.scrollablePlotArea;
	B?(this.fixedDiv=c.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.renderTo.style.overflow="visible",this.fixedRenderer=f=new c.Renderer(this.fixedDiv,this.chartWidth,this.chartHeight),this.scrollableMask=f.path().attr({fill:c.color(this.options.chart.backgroundColor||"#fff").setOpacity(F(t.opacity,.85)).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),
	this.moveFixedElements(),G(this,"afterShowResetZoom",this.moveFixedElements),G(this,"afterLayOutTitles",this.moveFixedElements)):this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);f=this.chartWidth+(this.scrollablePixelsX||0);var v=this.chartHeight+(this.scrollablePixelsY||0);c.stop(this.container);this.container.style.width=f+"px";this.container.style.height=v+"px";this.renderer.boxWrapper.attr({width:f,height:v,viewBox:[0,0,f,v].join(" ")});this.chartBackground.attr({width:f,height:v});
	this.scrollablePixelsY&&(this.scrollingContainer.style.height=this.chartHeight+"px");B&&(t.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixelsX*t.scrollPositionX),t.scrollPositionY&&(this.scrollingContainer.scrollTop=this.scrollablePixelsY*t.scrollPositionY));v=this.axisOffset;B=this.plotTop-v[0]-1;t=this.plotLeft-v[3]-1;f=this.plotTop+this.plotHeight+v[2]+1;v=this.plotLeft+this.plotWidth+v[1]+1;var C=this.plotLeft+this.plotWidth-(this.scrollablePixelsX||0),H=this.plotTop+this.plotHeight-
	(this.scrollablePixelsY||0);B=this.scrollablePixelsX?["M",0,B,"L",this.plotLeft-1,B,"L",this.plotLeft-1,f,"L",0,f,"Z","M",C,B,"L",this.chartWidth,B,"L",this.chartWidth,f,"L",C,f,"Z"]:this.scrollablePixelsY?["M",t,0,"L",t,this.plotTop-1,"L",v,this.plotTop-1,"L",v,0,"Z","M",t,H,"L",t,this.chartHeight,"L",v,this.chartHeight,"L",v,H,"Z"]:["M",0,0];"adjustHeight"!==this.redrawTrigger&&this.scrollableMask.attr({d:B})}});M(I,"parts/Point.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=
	f.defined,G=f.erase,z=f.extend,B=f.isArray,t=f.isNumber,v=f.isObject,C=f.pick,H,y=c.fireEvent,h=c.format,n=c.uniqueKey,q=c.removeEvent;c.Point=H=function(){};c.Point.prototype={init:function(c,b,a){this.series=c;this.applyOptions(b,a);this.id=F(this.id)?this.id:n();this.resolveColor();c.chart.pointCount++;y(this,"afterInit");return this},resolveColor:function(){var c=this.series;var b=c.chart.options.chart.colorCount;var a=c.chart.styledMode;a||this.options.color||(this.color=c.color);c.options.colorByPoint?
	(a||(b=c.options.colors||c.chart.options.colors,this.color=this.color||b[c.colorCounter],b=b.length),a=c.colorCounter,c.colorCounter++,c.colorCounter===b&&(c.colorCounter=0)):a=c.colorIndex;this.colorIndex=C(this.colorIndex,a)},applyOptions:function(c,b){var a=this.series,d=a.options.pointValKey||a.pointValKey;c=H.prototype.optionsToObject.call(this,c);z(this,c);this.options=this.options?z(this.options,c):c;c.group&&delete this.group;c.dataLabels&&delete this.dataLabels;d&&(this.y=this[d]);this.formatPrefix=
	(this.isNull=C(this.isValid&&!this.isValid(),null===this.x||!t(this.y)))?"null":"point";this.selected&&(this.state="select");"name"in this&&void 0===b&&a.xAxis&&a.xAxis.hasNames&&(this.x=a.xAxis.nameToX(this));void 0===this.x&&a&&(this.x=void 0===b?a.autoIncrement(this):b);return this},setNestedProperty:function(c,b,a){a.split(".").reduce(function(a,e,c,g){a[e]=g.length-1===c?b:v(a[e],!0)?a[e]:{};return a[e]},c);return c},optionsToObject:function(g){var b={},a=this.series,d=a.options.keys,e=d||a.pointArrayMap||
	["y"],h=e.length,f=0,n=0;if(t(g)||null===g)b[e[0]]=g;else if(B(g))for(!d&&g.length>h&&(a=typeof g[0],"string"===a?b.name=g[0]:"number"===a&&(b.x=g[0]),f++);n<h;)d&&void 0===g[f]||(0<e[n].indexOf(".")?c.Point.prototype.setNestedProperty(b,g[f],e[n]):b[e[n]]=g[f]),f++,n++;else"object"===typeof g&&(b=g,g.dataLabels&&(a._hasPointLabels=!0),g.marker&&(a._hasPointMarkers=!0));return b},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":
	"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var c=this.series,b=c.zones;c=c.zoneAxis||"y";var a=0,d;for(d=b[a];this[c]>=d.value;)d=b[++a];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=d&&d.color&&!this.options.color?d.color:this.nonZonedColor;return d},
	hasNewShapeType:function(){return this.graphic&&this.graphic.element.nodeName!==this.shapeType},destroy:function(){var c=this.series.chart,b=c.hoverPoints,a;c.pointCount--;b&&(this.setState(),G(b,this),b.length||(c.hoverPoints=null));if(this===c.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel||this.dataLabels)q(this),this.destroyElements();this.legendItem&&c.legend.destroyItem(this);for(a in this)this[a]=null},destroyElements:function(c){var b=this,a=[],d;c=c||{graphic:1,dataLabel:1};
	c.graphic&&a.push("graphic","shadowGroup");c.dataLabel&&a.push("dataLabel","dataLabelUpper","connector");for(d=a.length;d--;){var e=a[d];b[e]&&(b[e]=b[e].destroy())}["dataLabel","connector"].forEach(function(a){var d=a+"s";c[a]&&b[d]&&(b[d].forEach(function(a){a.element&&a.destroy()}),delete b[d])})},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||
	this.stackTotal}},tooltipFormatter:function(c){var b=this.series,a=b.tooltipOptions,d=C(a.valueDecimals,""),e=a.valuePrefix||"",g=a.valueSuffix||"";b.chart.styledMode&&(c=b.chart.tooltip.styledModeFormat(c));(b.pointArrayMap||["y"]).forEach(function(a){a="{point."+a;if(e||g)c=c.replace(RegExp(a+"}","g"),e+a+"}"+g);c=c.replace(RegExp(a+"}","g"),a+":,."+d+"f}")});return h(c,{point:this,series:this.series},b.chart.time)},firePointEvent:function(c,b,a){var d=this,e=this.series.options;(e.point.events[c]||
	d.options&&d.options.events&&d.options.events[c])&&this.importEvents();"click"===c&&e.allowPointSelect&&(a=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});y(this,c,b,a)},visible:!0}});M(I,"parts/Series.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.arrayMax,G=f.arrayMin,z=f.defined,B=f.erase,t=f.extend,v=f.isArray,C=f.isNumber,H=f.isString,y=f.objectEach,h=f.pick,n=f.splat,q=f.syncTimeout,g=c.addEvent,b=c.animObject,a=c.correctFloat,d=c.defaultOptions,
	e=c.defaultPlotOptions,l=c.fireEvent,L=c.merge,E=c.removeEvent,p=c.SVGElement,u=c.win;c.Series=c.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===
	this.y?"":c.numberFormat(this.y,-1)},padding:5,style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},inactive:{animation:{duration:50},opacity:.2}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{axisTypes:["xAxis","yAxis"],
	coll:"series",colorCounter:0,cropShoulder:1,directTouch:!1,isCartesian:!0,parallelArrays:["x","y"],pointClass:c.Point,requireSorting:!0,sorted:!0,init:function(a,b){l(this,"init",{options:b});var d=this,e=a.series,k;this.eventOptions=this.eventOptions||{};d.chart=a;d.options=b=d.setOptions(b);d.linkedSeries=[];d.bindAxes();t(d,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});var m=b.events;y(m,function(a,b){c.isFunction(a)&&d.eventOptions[b]!==a&&(c.isFunction(d.eventOptions[b])&&
	E(d,b,d.eventOptions[b]),d.eventOptions[b]=a,g(d,b,a))});if(m&&m.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;d.getColor();d.getSymbol();d.parallelArrays.forEach(function(a){d[a+"Data"]||(d[a+"Data"]=[])});d.points||d.data||d.setData(b.data,!1);d.isCartesian&&(a.hasCartesianSeries=!0);e.length&&(k=e[e.length-1]);d._i=h(k&&k._i,-1)+1;a.orderSeries(this.insert(e));l(this,"afterInit")},insert:function(a){var b=this.options.index,d;if(C(b)){for(d=a.length;d--;)if(b>=
	h(a[d].options.index,a[d]._i)){a.splice(d+1,0,this);break}-1===d&&a.unshift(this);d+=1}else a.push(this);return h(d,a.length-1)},bindAxes:function(){var a=this,b=a.options,d=a.chart,e;l(this,"bindAxes",null,function(){(a.axisTypes||[]).forEach(function(k){d[k].forEach(function(d){e=d.options;if(b[k]===e.index||void 0!==b[k]&&b[k]===e.id||void 0===b[k]&&0===e.index)a.insert(d.series),a[k]=d,d.isDirty=!0});a[k]||a.optionalAxis===k||c.error(18,!0,d)})})},updateParallelArrays:function(a,b){var d=a.series,
	c=arguments,e=C(b)?function(c){var e="y"===c&&d.toYData?d.toYData(a):a[c];d[c+"Data"][b]=e}:function(a){Array.prototype[b].apply(d[a+"Data"],Array.prototype.slice.call(c,2))};d.parallelArrays.forEach(e)},hasData:function(){return this.visible&&void 0!==this.dataMax&&void 0!==this.dataMin||this.visible&&this.yData&&0<this.yData.length},autoIncrement:function(){var a=this.options,b=this.xIncrement,d,c=a.pointIntervalUnit,e=this.chart.time;b=h(b,a.pointStart,0);this.pointInterval=d=h(this.pointInterval,
	a.pointInterval,1);c&&(a=new e.Date(b),"day"===c?e.set("Date",a,e.get("Date",a)+d):"month"===c?e.set("Month",a,e.get("Month",a)+d):"year"===c&&e.set("FullYear",a,e.get("FullYear",a)+d),d=a.getTime()-b);this.xIncrement=b+d;return b},setOptions:function(a){var b=this.chart,c=b.options,e=c.plotOptions,k=b.userOptions||{};a=L(a);b=b.styledMode;var g={plotOptions:e,userOptions:a};l(this,"setOptions",g);var f=g.plotOptions[this.type],p=k.plotOptions||{};this.userOptions=g.userOptions;k=L(f,e.series,k.plotOptions&&
	k.plotOptions[this.type],a);this.tooltipOptions=L(d.tooltip,d.plotOptions.series&&d.plotOptions.series.tooltip,d.plotOptions[this.type].tooltip,c.tooltip.userOptions,e.series&&e.series.tooltip,e[this.type].tooltip,a.tooltip);this.stickyTracking=h(a.stickyTracking,p[this.type]&&p[this.type].stickyTracking,p.series&&p.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:k.stickyTracking);null===f.marker&&delete k.marker;this.zoneAxis=k.zoneAxis;c=this.zones=(k.zones||[]).slice();
	!k.negativeColor&&!k.negativeFillColor||k.zones||(e={value:k[this.zoneAxis+"Threshold"]||k.threshold||0,className:"highcharts-negative"},b||(e.color=k.negativeColor,e.fillColor=k.negativeFillColor),c.push(e));c.length&&z(c[c.length-1].value)&&c.push(b?{}:{color:this.color,fillColor:this.fillColor});l(this,"afterSetOptions",{options:k});return k},getName:function(){return h(this.options.name,"Series "+(this.index+1))},getCyclic:function(a,b,d){var c=this.chart,e=this.userOptions,k=a+"Index",g=a+"Counter",
	f=d?d.length:h(c.options.chart[a+"Count"],c[a+"Count"]);if(!b){var r=h(e[k],e["_"+k]);z(r)||(c.series.length||(c[g]=0),e["_"+k]=r=c[g]%f,c[g]+=1);d&&(b=d[r])}void 0!==r&&(this[k]=r);this[a]=b},getColor:function(){this.chart.styledMode?this.getCyclic("color"):this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||e[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},findPointIndex:function(a,
	b){var d=a.id;a=a.x;var c=this.points,e;if(d){var k=(d=this.chart.get(d))&&d.index;void 0!==k&&(e=!0)}void 0===k&&C(a)&&(k=this.xData.indexOf(a,b));-1!==k&&void 0!==k&&this.cropped&&(k=k>=this.cropStart?k-this.cropStart:k);!e&&c[k]&&c[k].touched&&(k=void 0);return k},drawLegendSymbol:c.LegendSymbolMixin.drawLineMarker,updateData:function(a){var b=this.options,d=this.points,c=[],e,k,g,h=this.requireSorting,f=a.length===d.length,l=!0;this.xIncrement=null;a.forEach(function(a,k){var m=z(a)&&this.pointClass.prototype.optionsToObject.call({series:this},
	a)||{};var r=m.x;if(m.id||C(r))if(r=this.findPointIndex(m,g),-1===r||void 0===r?c.push(a):d[r]&&a!==b.data[r]?(d[r].update(a,!1,null,!1),d[r].touched=!0,h&&(g=r+1)):d[r]&&(d[r].touched=!0),!f||k!==r||this.hasDerivedData)e=!0},this);if(e)for(a=d.length;a--;)(k=d[a])&&!k.touched&&k.remove(!1);else f?a.forEach(function(a,b){d[b].update&&a!==d[b].y&&d[b].update(a,!1,null,!1)}):l=!1;d.forEach(function(a){a&&(a.touched=!1)});if(!l)return!1;c.forEach(function(a){this.addPoint(a,!1,null,null,!1)},this);return!0},
	setData:function(a,b,d,e){var k=this,g=k.points,f=g&&g.length||0,r,l=k.options,p=k.chart,x=null,A=k.xAxis;x=l.turboThreshold;var u=this.xData,n=this.yData,q=(r=k.pointArrayMap)&&r.length,y=l.keys,t=0,E=1,L;a=a||[];r=a.length;b=h(b,!0);!1!==e&&r&&f&&!k.cropped&&!k.hasGroupedData&&k.visible&&!k.isSeriesBoosting&&(L=this.updateData(a));if(!L){k.xIncrement=null;k.colorCounter=0;this.parallelArrays.forEach(function(a){k[a+"Data"].length=0});if(x&&r>x)if(x=k.getFirstValidPoint(a),C(x))for(d=0;d<r;d++)u[d]=
	this.autoIncrement(),n[d]=a[d];else if(v(x))if(q)for(d=0;d<r;d++)e=a[d],u[d]=e[0],n[d]=e.slice(1,q+1);else for(y&&(t=y.indexOf("x"),E=y.indexOf("y"),t=0<=t?t:0,E=0<=E?E:1),d=0;d<r;d++)e=a[d],u[d]=e[t],n[d]=e[E];else c.error(12,!1,p);else for(d=0;d<r;d++)void 0!==a[d]&&(e={series:k},k.pointClass.prototype.applyOptions.apply(e,[a[d]]),k.updateParallelArrays(e,d));n&&H(n[0])&&c.error(14,!0,p);k.data=[];k.options.data=k.userOptions.data=a;for(d=f;d--;)g[d]&&g[d].destroy&&g[d].destroy();A&&(A.minRange=
	A.userMinRange);k.isDirty=p.isDirtyBox=!0;k.isDirtyData=!!g;d=!1}"point"===l.legendType&&(this.processData(),this.generatePoints());b&&p.redraw(d)},processData:function(a){var b=this.xData,d=this.yData,e=b.length;var k=0;var g=this.xAxis,h=this.options;var f=h.cropThreshold;var l=this.getExtremesFromAll||h.getExtremesFromAll,p=this.isCartesian;h=g&&g.val2lin;var u=g&&g.isLog,n=this.requireSorting;if(p&&!this.isDirty&&!g.isDirty&&!this.yAxis.isDirty&&!a)return!1;if(g){a=g.getExtremes();var q=a.min;
	var v=a.max}if(p&&this.sorted&&!l&&(!f||e>f||this.forceCrop))if(b[e-1]<q||b[0]>v)b=[],d=[];else if(this.yData&&(b[0]<q||b[e-1]>v)){k=this.cropData(this.xData,this.yData,q,v);b=k.xData;d=k.yData;k=k.start;var y=!0}for(f=b.length||1;--f;)if(e=u?h(b[f])-h(b[f-1]):b[f]-b[f-1],0<e&&(void 0===t||e<t))var t=e;else 0>e&&n&&(c.error(15,!1,this.chart),n=!1);this.cropped=y;this.cropStart=k;this.processedXData=b;this.processedYData=d;this.closestPointRange=this.basePointRange=t},cropData:function(a,b,d,e,c){var k=
	a.length,g=0,f=k,r;c=h(c,this.cropShoulder);for(r=0;r<k;r++)if(a[r]>=d){g=Math.max(0,r-c);break}for(d=r;d<k;d++)if(a[d]>e){f=d+c;break}return{xData:a.slice(g,f),yData:b.slice(g,f),start:g,end:f}},generatePoints:function(){var a=this.options,b=a.data,d=this.data,e,c=this.processedXData,g=this.processedYData,f=this.pointClass,h=c.length,p=this.cropStart||0,u=this.hasGroupedData;a=a.keys;var q=[],v;d||u||(d=[],d.length=b.length,d=this.data=d);a&&u&&(this.options.keys=!1);for(v=0;v<h;v++){var y=p+v;if(u){var E=
	(new f).init(this,[c[v]].concat(n(g[v])));E.dataGroup=this.groupMap[v];E.dataGroup.options&&(E.options=E.dataGroup.options,t(E,E.dataGroup.options),delete E.dataLabels)}else(E=d[y])||void 0===b[y]||(d[y]=E=(new f).init(this,b[y],c[v]));E&&(E.index=y,q[v]=E)}this.options.keys=a;if(d&&(h!==(e=d.length)||u))for(v=0;v<e;v++)v!==p||u||(v+=h),d[v]&&(d[v].destroyElements(),d[v].plotX=void 0);this.data=d;this.points=q;l(this,"afterGeneratePoints")},getXExtremes:function(a){return{min:G(a),max:F(a)}},getExtremes:function(a){var b=
	this.xAxis,d=this.yAxis,e=this.processedXData||this.xData,c=[],k=0,g=0;var f=0;var h=this.requireSorting?this.cropShoulder:0,p=d?d.positiveValuesOnly:!1,u;a=a||this.stackedYData||this.processedYData||[];d=a.length;b&&(f=b.getExtremes(),g=f.min,f=f.max);for(u=0;u<d;u++){var n=e[u];var q=a[u];var y=(C(q)||v(q))&&(q.length||0<q||!p);n=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||!b||(e[u+h]||n)>=g&&(e[u-h]||n)<=f;if(y&&n)if(y=q.length)for(;y--;)C(q[y])&&(c[k++]=q[y]);else c[k++]=
	q}this.dataMin=G(c);this.dataMax=F(c);l(this,"afterGetExtremes")},getFirstValidPoint:function(a){for(var b=null,d=a.length,e=0;null===b&&e<d;)b=a[e],e++;return b},translate:function(){this.processedXData||this.processData();this.generatePoints();var b=this.options,d=b.stacking,e=this.xAxis,c=e.categories,g=this.yAxis,m=this.points,f=m.length,p=!!this.modifyValue,u,n=this.pointPlacementToXValue(),q=C(n),y=b.threshold,t=b.startFromThreshold?y:0,E,L=this.zoneAxis||"y",B=Number.MAX_VALUE;for(u=0;u<f;u++){var H=
	m[u],G=H.x;var F=H.y;var I=H.low,M=d&&g.stacks[(this.negStacks&&F<(t?0:y)?"-":"")+this.stackKey];g.positiveValuesOnly&&null!==F&&0>=F&&(H.isNull=!0);H.plotX=E=a(Math.min(Math.max(-1E5,e.translate(G,0,0,0,1,n,"flags"===this.type)),1E5));if(d&&this.visible&&M&&M[G]){var X=this.getStackIndicator(X,G,this.index);if(!H.isNull){var P=M[G];var Y=P.points[X.key]}}v(Y)&&(I=Y[0],F=Y[1],I===t&&X.key===M[G].base&&(I=h(C(y)&&y,g.min)),g.positiveValuesOnly&&0>=I&&(I=null),H.total=H.stackTotal=P.total,H.percentage=
	P.total&&H.y/P.total*100,H.stackY=F,this.irregularWidths||P.setOffset(this.pointXOffset||0,this.barW||0));H.yBottom=z(I)?Math.min(Math.max(-1E5,g.translate(I,0,1,0,1)),1E5):null;p&&(F=this.modifyValue(F,H));H.plotY=F="number"===typeof F&&Infinity!==F?Math.min(Math.max(-1E5,g.translate(F,0,1,0,1)),1E5):void 0;H.isInside=void 0!==F&&0<=F&&F<=g.len&&0<=E&&E<=e.len;H.clientX=q?a(e.translate(G,0,0,0,1,n)):E;H.negative=H[L]<(b[L+"Threshold"]||y||0);H.category=c&&void 0!==c[H.x]?c[H.x]:H.x;if(!H.isNull){void 0!==
	Z&&(B=Math.min(B,Math.abs(E-Z)));var Z=E}H.zone=this.zones.length&&H.getZone()}this.closestPointRangePx=B;l(this,"afterTranslate")},getValidPoints:function(a,b,d){var e=this.chart;return(a||this.points||[]).filter(function(a){return b&&!e.isInsidePlot(a.plotX,a.plotY,e.inverted)?!1:d||!a.isNull})},getClipBox:function(a,b){var d=this.options,e=this.chart,c=e.inverted,k=this.xAxis,g=k&&this.yAxis;a&&!1===d.clip&&g?a=c?{y:-e.chartWidth+g.len+g.pos,height:e.chartWidth,width:e.chartHeight,x:-e.chartHeight+
	k.len+k.pos}:{y:-g.pos,height:e.chartHeight,width:e.chartWidth,x:-k.pos}:(a=this.clipBox||e.clipBox,b&&(a.width=e.plotSizeX,a.x=0));return b?{width:a.width,x:a.x}:a},setClip:function(a){var b=this.chart,d=this.options,e=b.renderer,c=b.inverted,k=this.clipBox,g=this.getClipBox(a),f=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,g.height,d.xAxis,d.yAxis].join(),h=b[f],l=b[f+"m"];h||(a&&(g.width=0,c&&(g.x=b.plotSizeX+(!1!==d.clip?0:b.plotTop)),b[f+"m"]=l=e.clipRect(c?b.plotSizeX+99:-99,
	c?-b.plotLeft:-b.plotTop,99,c?b.chartWidth:b.chartHeight)),b[f]=h=e.clipRect(g),h.count={length:0});a&&!h.count[this.index]&&(h.count[this.index]=!0,h.count.length+=1);if(!1!==d.clip||a)this.group.clip(a||k?h:b.clipRect),this.markerGroup.clip(l),this.sharedClipKey=f;a||(h.count[this.index]&&(delete h.count[this.index],--h.count.length),0===h.count.length&&f&&b[f]&&(k||(b[f]=b[f].destroy()),b[f+"m"]&&(b[f+"m"]=b[f+"m"].destroy())))},animate:function(a){var d=this.chart,e=b(this.options.animation);
	if(a)this.setClip(e);else{var c=this.sharedClipKey;a=d[c];var k=this.getClipBox(e,!0);a&&a.animate(k,e);d[c+"m"]&&d[c+"m"].animate({width:k.width+99,x:k.x-(d.inverted?0:99)},e);this.animate=null}},afterAnimate:function(){this.setClip();l(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,d,e=this.options.marker,c=this[this.specialGroup]||this.markerGroup;var g=this.xAxis;var f=h(e.enabled,!g||g.isRadial?!0:null,this.closestPointRangePx>=e.enabledThreshold*
	e.radius);if(!1!==e.enabled||this._hasPointMarkers)for(g=0;g<a.length;g++){var l=a[g];var p=(d=l.graphic)?"animate":"attr";var u=l.marker||{};var n=!!l.marker;var q=f&&void 0===u.enabled||u.enabled;var v=!1!==l.isInside;if(q&&!l.isNull){var y=h(u.symbol,this.symbol);q=this.markerAttribs(l,l.selected&&"select");d?d[v?"show":"hide"](v).animate(q):v&&(0<q.width||l.hasImage)&&(l.graphic=d=b.renderer.symbol(y,q.x,q.y,q.width,q.height,n?u:e).add(c));if(d&&!b.styledMode)d[p](this.pointAttribs(l,l.selected&&
	"select"));d&&d.addClass(l.getClassName(),!0)}else d&&(l.graphic=d.destroy())}},markerAttribs:function(a,b){var d=this.options.marker,e=a.marker||{},c=e.symbol||d.symbol,k=h(e.radius,d.radius);b&&(d=d.states[b],b=e.states&&e.states[b],k=h(b&&b.radius,d&&d.radius,k+(d&&d.radiusPlus||0)));a.hasImage=c&&0===c.indexOf("url");a.hasImage&&(k=0);a={x:Math.floor(a.plotX)-k,y:a.plotY-k};k&&(a.width=a.height=2*k);return a},pointAttribs:function(a,b){var d=this.options.marker,e=a&&a.options,c=e&&e.marker||{},
	k=this.color,g=e&&e.color,f=a&&a.color;e=h(c.lineWidth,d.lineWidth);var l=a&&a.zone&&a.zone.color;a=1;k=g||l||f||k;g=c.fillColor||d.fillColor||k;k=c.lineColor||d.lineColor||k;b=b||"normal";d=d.states[b];b=c.states&&c.states[b]||{};e=h(b.lineWidth,d.lineWidth,e+h(b.lineWidthPlus,d.lineWidthPlus,0));g=b.fillColor||d.fillColor||g;k=b.lineColor||d.lineColor||k;a=h(b.opacity,d.opacity,a);return{stroke:k,"stroke-width":e,fill:g,opacity:a}},destroy:function(a){var b=this,d=b.chart,e=/AppleWebKit\/533/.test(u.navigator.userAgent),
	k,g,f=b.data||[],h,n;l(b,"destroy");a||E(b);(b.axisTypes||[]).forEach(function(a){(n=b[a])&&n.series&&(B(n.series,b),n.isDirty=n.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(g=f.length;g--;)(h=f[g])&&h.destroy&&h.destroy();b.points=null;c.clearTimeout(b.animationTimeout);y(b,function(a,b){a instanceof p&&!a.survive&&(k=e&&"group"===b?"hide":"destroy",a[k]())});d.hoverSeries===b&&(d.hoverSeries=null);B(d.series,b);d.orderSeries();y(b,function(d,e){a&&"hcEvents"===e||delete b[e]})},
	getGraphPath:function(a,b,d){var e=this,c=e.options,k=c.step,g,f=[],h=[],l;a=a||e.points;(g=a.reversed)&&a.reverse();(k={right:1,center:2}[k]||k&&3)&&g&&(k=4-k);!c.connectNulls||b||d||(a=this.getValidPoints(a));a.forEach(function(g,m){var r=g.plotX,p=g.plotY,u=a[m-1];(g.leftCliff||u&&u.rightCliff)&&!d&&(l=!0);g.isNull&&!z(b)&&0<m?l=!c.connectNulls:g.isNull&&!b?l=!0:(0===m||l?m=["M",g.plotX,g.plotY]:e.getPointSpline?m=e.getPointSpline(a,g,m):k?(m=1===k?["L",u.plotX,p]:2===k?["L",(u.plotX+r)/2,u.plotY,
	"L",(u.plotX+r)/2,p]:["L",r,u.plotY],m.push("L",r,p)):m=["L",r,p],h.push(g.x),k&&(h.push(g.x),2===k&&h.push(g.x)),f.push.apply(f,m),l=!1)});f.xMap=h;return e.graphPath=f},drawGraph:function(){var a=this,b=this.options,d=(this.gappedPath||this.getGraphPath).call(this),e=this.chart.styledMode,c=[["graph","highcharts-graph"]];e||c[0].push(b.lineColor||this.color||"#cccccc",b.dashStyle);c=a.getZonesGraphs(c);c.forEach(function(c,k){var g=c[0],f=a[g],h=f?"animate":"attr";f?(f.endX=a.preventGraphAnimation?
	null:d.xMap,f.animate({d:d})):d.length&&(a[g]=f=a.chart.renderer.path(d).addClass(c[1]).attr({zIndex:1}).add(a.group));f&&!e&&(g={stroke:c[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},c[3]?g.dashstyle=c[3]:"square"!==b.linecap&&(g["stroke-linecap"]=g["stroke-linejoin"]="round"),f[h](g).shadow(2>k&&b.shadow));f&&(f.startX=d.xMap,f.isArea=d.isArea)})},getZonesGraphs:function(a){this.zones.forEach(function(b,d){d=["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+(b.className||
	"")];this.chart.styledMode||d.push(b.color||this.color,b.dashStyle||this.options.dashStyle);a.push(d)},this);return a},applyZones:function(){var a=this,b=this.chart,d=b.renderer,e=this.zones,c,g,f=this.clips||[],l,p=this.graph,u=this.area,n=Math.max(b.chartWidth,b.chartHeight),q=this[(this.zoneAxis||"y")+"Axis"],v=b.inverted,y,t,E,C=!1;if(e.length&&(p||u)&&q&&void 0!==q.min){var L=q.reversed;var z=q.horiz;p&&!this.showLine&&p.hide();u&&u.hide();var B=q.getExtremes();e.forEach(function(e,k){c=L?z?
	b.plotWidth:0:z?0:q.toPixels(B.min)||0;c=Math.min(Math.max(h(g,c),0),n);g=Math.min(Math.max(Math.round(q.toPixels(h(e.value,B.max),!0)||0),0),n);C&&(c=g=q.toPixels(B.max));y=Math.abs(c-g);t=Math.min(c,g);E=Math.max(c,g);q.isXAxis?(l={x:v?E:t,y:0,width:y,height:n},z||(l.x=b.plotHeight-l.x)):(l={x:0,y:v?E:t,width:n,height:y},z&&(l.y=b.plotWidth-l.y));v&&d.isVML&&(l=q.isXAxis?{x:0,y:L?t:E,height:l.width,width:b.chartWidth}:{x:l.y-b.plotLeft-b.spacingBox.x,y:0,width:l.height,height:b.chartHeight});f[k]?
	f[k].animate(l):f[k]=d.clipRect(l);p&&a["zone-graph-"+k].clip(f[k]);u&&a["zone-area-"+k].clip(f[k]);C=e.value>B.max;a.resetZones&&0===g&&(g=void 0)});this.clips=f}else a.visible&&(p&&p.show(!0),u&&u.show(!0))},invertGroups:function(a){function b(){["group","markerGroup"].forEach(function(b){d[b]&&(e.renderer.isVML&&d[b].attr({width:d.yAxis.len,height:d.xAxis.len}),d[b].width=d.yAxis.len,d[b].height=d.xAxis.len,d[b].invert(a))})}var d=this,e=d.chart;if(d.xAxis){var c=g(e,"resize",b);g(d,"destroy",
	c);b(a);d.invertGroups=b}},plotGroup:function(a,b,d,e,c){var k=this[a],g=!k;g&&(this[a]=k=this.chart.renderer.g().attr({zIndex:e||.1}).add(c));k.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(z(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(k.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);k.attr({visibility:d})[g?"attr":"animate"](this.getPlotBox());return k},getPlotBox:function(){var a=this.chart,
	b=this.xAxis,d=this.yAxis;a.inverted&&(b=d,d=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:d?d.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,d=a.chart,e=a.options,c=!!a.animate&&d.renderer.isSVG&&b(e.animation).duration,g=a.visible?"inherit":"hidden",f=e.zIndex,h=a.hasRendered,p=d.seriesGroup,u=d.inverted;l(this,"render");var n=a.plotGroup("group","series",g,f,p);a.markerGroup=a.plotGroup("markerGroup","markers",g,f,p);c&&a.animate(!0);n.inverted=a.isCartesian||a.invertable?
	u:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.visible&&a.drawPoints();a.drawDataLabels&&a.drawDataLabels();a.redrawPoints&&a.redrawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(u);!1===e.clip||a.sharedClipKey||h||n.clip(d.clipRect);c&&a.animate();h||(a.animationTimeout=q(function(){a.afterAnimate()},c||0));a.isDirty=!1;a.hasRendered=!0;l(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,d=this.group,e=this.xAxis,
	c=this.yAxis;d&&(a.inverted&&d.attr({width:a.plotWidth,height:a.plotHeight}),d.animate({translateX:h(e&&e.left,a.plotLeft),translateY:h(c&&c.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var d=this.xAxis,e=this.yAxis,c=this.chart.inverted;return this.searchKDTree({clientX:c?d.len-a.chartY+d.pos:a.chartX-d.pos,plotY:c?e.len-a.chartX+e.pos:a.chartY-e.pos},b,a)},buildKDTree:function(a){function b(a,e,c){var g;if(g=a&&
	a.length){var k=d.kdAxisArray[e%c];a.sort(function(a,b){return a[k]-b[k]});g=Math.floor(g/2);return{point:a[g],left:b(a.slice(0,g),e+1,c),right:b(a.slice(g+1),e+1,c)}}}this.buildingKdTree=!0;var d=this,e=-1<d.options.findNearestPointBy.indexOf("y")?2:1;delete d.kdTree;q(function(){d.kdTree=b(d.getValidPoints(null,!d.directTouch),e,e);d.buildingKdTree=!1},d.options.kdNow||a&&"touchstart"===a.type?0:1)},searchKDTree:function(a,b,d){function e(a,b,d,h){var l=b.point,m=c.kdAxisArray[d%h],p=l;var r=z(a[g])&&
	z(l[g])?Math.pow(a[g]-l[g],2):null;var u=z(a[k])&&z(l[k])?Math.pow(a[k]-l[k],2):null;u=(r||0)+(u||0);l.dist=z(u)?Math.sqrt(u):Number.MAX_VALUE;l.distX=z(r)?Math.sqrt(r):Number.MAX_VALUE;m=a[m]-l[m];u=0>m?"left":"right";r=0>m?"right":"left";b[u]&&(u=e(a,b[u],d+1,h),p=u[f]<p[f]?u:l);b[r]&&Math.sqrt(m*m)<p[f]&&(a=e(a,b[r],d+1,h),p=a[f]<p[f]?a:p);return p}var c=this,g=this.kdAxisArray[0],k=this.kdAxisArray[1],f=b?"distX":"dist";b=-1<c.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||
	this.buildKDTree(d);if(this.kdTree)return e(a,this.kdTree,b,b)},pointPlacementToXValue:function(){var a=this.xAxis,b=this.options.pointPlacement;"between"===b&&(b=a.reversed?-.5:.5);C(b)&&(b*=h(this.options.pointRange||a.pointRange));return b}});""});M(I,"parts/Stacking.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.destroyObjectProperties,z=f.objectEach,B=f.pick;f=c.Axis;var t=c.Chart,v=c.correctFloat,C=c.format,H=c.Series;c.StackItem=function(c,f,n,q,g){var b=
	c.chart.inverted;this.axis=c;this.isNegative=n;this.options=f=f||{};this.x=q;this.total=null;this.points={};this.stack=g;this.rightCliff=this.leftCliff=0;this.alignOptions={align:f.align||(b?n?"left":"right":"center"),verticalAlign:f.verticalAlign||(b?"middle":n?"bottom":"top"),y:f.y,x:f.x};this.textAlign=f.textAlign||(b?n?"right":"left":"center")};c.StackItem.prototype={destroy:function(){G(this,this.axis)},render:function(c){var f=this.axis.chart,n=this.options,q=n.format;q=q?C(q,this,f.time):n.formatter.call(this);
	this.label?this.label.attr({text:q,visibility:"hidden"}):(this.label=f.renderer.label(q,null,null,n.shape,null,null,n.useHTML,!1,"stack-labels"),q={text:q,align:this.textAlign,rotation:n.rotation,padding:B(n.padding,0),visibility:"hidden"},this.label.attr(q),f.styledMode||this.label.css(n.style),this.label.added||this.label.add(c));this.label.labelrank=f.plotHeight},setOffset:function(c,f,n,q,g){var b=this.axis,a=b.chart;q=b.translate(b.usePercentage?100:q?q:this.total,0,0,0,1);n=b.translate(n?n:
	0);n=F(q)&&Math.abs(q-n);c=B(g,a.xAxis[0].translate(this.x))+c;b=F(q)&&this.getStackBox(a,this,c,q,f,n,b);f=this.label;c=this.isNegative;g="justify"===B(this.options.overflow,"justify");if(f&&b){n=f.getBBox();var d=a.inverted?c?n.width:0:n.width/2,e=a.inverted?n.height/2:c?-4:n.height+4;this.alignOptions.x=B(this.options.x,0);f.align(this.alignOptions,null,b);q=f.alignAttr;f.show();q.y-=e;g&&(q.x-=d,H.prototype.justifyDataLabel.call(this.axis,f,this.alignOptions,q,n,b),q.x+=d);q.x=f.alignAttr.x;f.attr({x:q.x,
	y:q.y});B(!g&&this.options.crop,!0)&&((a=a.isInsidePlot(f.x+(a.inverted?0:-n.width/2),f.y)&&a.isInsidePlot(f.x+(a.inverted?c?-n.width:n.width:n.width/2),f.y+n.height))||f.hide())}},getStackBox:function(c,f,n,q,g,b,a){var d=f.axis.reversed,e=c.inverted;c=a.height+a.pos-(e?c.plotLeft:c.plotTop);f=f.isNegative&&!d||!f.isNegative&&d;return{x:e?f?q:q-b:n,y:e?c-n-g:f?c-q-b:c-q,width:e?b:g,height:e?g:b}}};t.prototype.getStacks=function(){var c=this,f=c.inverted;c.yAxis.forEach(function(c){c.stacks&&c.hasVisibleSeries&&
	(c.oldStacks=c.stacks)});c.series.forEach(function(h){var n=h.xAxis&&h.xAxis.options||{};!h.options.stacking||!0!==h.visible&&!1!==c.options.chart.ignoreHiddenSeries||(h.stackKey=[h.type,B(h.options.stack,""),f?n.top:n.left,f?n.height:n.width].join())})};f.prototype.buildStacks=function(){var c=this.series,f=B(this.options.reversedStacks,!0),n=c.length,q;if(!this.isXAxis){this.usePercentage=!1;for(q=n;q--;)c[f?q:n-q-1].setStackedPoints();for(q=0;q<n;q++)c[q].modifyStacks()}};f.prototype.renderStackTotals=
	function(){var c=this.chart,f=c.renderer,n=this.stacks,q=this.stackTotalGroup;q||(this.stackTotalGroup=q=f.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());q.translate(c.plotLeft,c.plotTop);z(n,function(c){z(c,function(b){b.render(q)})})};f.prototype.resetStacks=function(){var c=this,f=c.stacks;c.isXAxis||z(f,function(f){z(f,function(h,g){h.touched<c.stacksTouched?(h.destroy(),delete f[g]):(h.total=null,h.cumulative=null)})})};f.prototype.cleanStacks=function(){if(!this.isXAxis){if(this.oldStacks)var c=
	this.stacks=this.oldStacks;z(c,function(c){z(c,function(c){c.cumulative=c.total})})}};H.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var f=this.processedXData,h=this.processedYData,n=[],q=h.length,g=this.options,b=g.threshold,a=B(g.startFromThreshold&&b,0),d=g.stack;g=g.stacking;var e=this.stackKey,l="-"+e,t=this.negStacks,E=this.yAxis,p=E.stacks,u=E.oldStacks,k,r;E.stacksTouched+=1;for(r=0;r<q;r++){var x=f[r];
	var A=h[r];var w=this.getStackIndicator(w,x,this.index);var m=w.key;var K=(k=t&&A<(a?0:b))?l:e;p[K]||(p[K]={});p[K][x]||(u[K]&&u[K][x]?(p[K][x]=u[K][x],p[K][x].total=null):p[K][x]=new c.StackItem(E,E.options.stackLabels,k,x,d));K=p[K][x];null!==A?(K.points[m]=K.points[this.index]=[B(K.cumulative,a)],F(K.cumulative)||(K.base=m),K.touched=E.stacksTouched,0<w.index&&!1===this.singleStacks&&(K.points[m][0]=K.points[this.index+","+x+",0"][0])):K.points[m]=K.points[this.index]=null;"percent"===g?(k=k?e:
	l,t&&p[k]&&p[k][x]?(k=p[k][x],K.total=k.total=Math.max(k.total,K.total)+Math.abs(A)||0):K.total=v(K.total+(Math.abs(A)||0))):K.total=v(K.total+(A||0));K.cumulative=B(K.cumulative,a)+(A||0);null!==A&&(K.points[m].push(K.cumulative),n[r]=K.cumulative)}"percent"===g&&(E.usePercentage=!0);this.stackedYData=n;E.oldStacks={}}};H.prototype.modifyStacks=function(){var c=this,f=c.stackKey,n=c.yAxis.stacks,q=c.processedXData,g,b=c.options.stacking;c[b+"Stacker"]&&[f,"-"+f].forEach(function(a){for(var d=q.length,
	e,f;d--;)if(e=q[d],g=c.getStackIndicator(g,e,c.index,a),f=(e=n[a]&&n[a][e])&&e.points[g.key])c[b+"Stacker"](f,e,d)})};H.prototype.percentStacker=function(c,f,n){f=f.total?100/f.total:0;c[0]=v(c[0]*f);c[1]=v(c[1]*f);this.stackedYData[n]=c[1]};H.prototype.getStackIndicator=function(c,f,n,q){!F(c)||c.x!==f||q&&c.key!==q?c={x:f,index:0,key:q}:c.index++;c.key=[n,f,c.index].join();return c}});M(I,"parts/Dynamics.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.erase,
	z=f.extend,B=f.isArray,t=f.isNumber,v=f.isObject,C=f.isString,H=f.objectEach,y=f.pick,h=f.setAnimation,n=f.splat,q=c.addEvent,g=c.animate,b=c.Axis;f=c.Chart;var a=c.createElement,d=c.css,e=c.fireEvent,l=c.merge,L=c.Point,E=c.Series,p=c.seriesTypes;c.cleanRecursively=function(a,b){var d={};H(a,function(e,g){if(v(a[g],!0)&&!a.nodeType&&b[g])e=c.cleanRecursively(a[g],b[g]),Object.keys(e).length&&(d[g]=e);else if(v(a[g])||a[g]!==b[g])d[g]=a[g]});return d};z(f.prototype,{addSeries:function(a,b,d){var c,
	g=this;a&&(b=y(b,!0),e(g,"addSeries",{options:a},function(){c=g.initSeries(a);g.isDirtyLegend=!0;g.linkSeries();e(g,"afterAddSeries",{series:c});b&&g.redraw(d)}));return c},addAxis:function(a,b,d,c){return this.createAxis(b?"xAxis":"yAxis",{axis:a,redraw:d,animation:c})},addColorAxis:function(a,b,d){return this.createAxis("colorAxis",{axis:a,redraw:b,animation:d})},createAxis:function(a,d){var e=this.options,g="colorAxis"===a,k=d.redraw,f=d.animation;d=l(d.axis,{index:this[a].length,isX:"xAxis"===
	a});var h=g?new c.ColorAxis(this,d):new b(this,d);e[a]=n(e[a]||{});e[a].push(d);g&&(this.isDirtyLegend=!0,this.axes.forEach(function(a){a.series=[]}),this.series.forEach(function(a){a.bindAxes();a.isDirtyData=!0}));y(k,!0)&&this.redraw(f);return h},showLoading:function(b){var c=this,e=c.options,f=c.loadingDiv,h=e.loading,l=function(){f&&d(f,{left:c.plotLeft+"px",top:c.plotTop+"px",width:c.plotWidth+"px",height:c.plotHeight+"px"})};f||(c.loadingDiv=f=a("div",{className:"highcharts-loading highcharts-loading-hidden"},
	null,c.container),c.loadingSpan=a("span",{className:"highcharts-loading-inner"},null,f),q(c,"redraw",l));f.className="highcharts-loading";c.loadingSpan.innerHTML=y(b,e.lang.loading,"");c.styledMode||(d(f,z(h.style,{zIndex:10})),d(c.loadingSpan,h.labelStyle),c.loadingShown||(d(f,{opacity:0,display:""}),g(f,{opacity:h.style.opacity||.5},{duration:h.showDuration||0})));c.loadingShown=!0;l()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",
	this.styledMode||g(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){d(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireReflow:"margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),
	collectionsWithUpdate:"xAxis yAxis zAxis colorAxis series pane".split(" "),update:function(a,b,d,g){var k=this,f={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"},h,p,r,u=a.isResponsiveOptions,q=[];e(k,"update",{options:a});u||k.setResponsive(!1,!0);a=c.cleanRecursively(a,k.options);l(!0,k.userOptions,a);if(h=a.chart){l(!0,k.options.chart,h);"className"in h&&k.setClassName(h.className);"reflow"in h&&k.setReflow(h.reflow);if("inverted"in h||"polar"in h||"type"in h){k.propFromSeries();
	var x=!0}"alignTicks"in h&&(x=!0);H(h,function(a,b){-1!==k.propsRequireUpdateSeries.indexOf("chart."+b)&&(p=!0);-1!==k.propsRequireDirtyBox.indexOf(b)&&(k.isDirtyBox=!0);u||-1===k.propsRequireReflow.indexOf(b)||(r=!0)});!k.styledMode&&"style"in h&&k.renderer.setStyle(h.style)}!k.styledMode&&a.colors&&(this.options.colors=a.colors);a.plotOptions&&l(!0,this.options.plotOptions,a.plotOptions);a.time&&this.time===c.time&&(this.time=new c.Time(a.time));H(a,function(a,b){if(k[b]&&"function"===typeof k[b].update)k[b].update(a,
	!1);else if("function"===typeof k[f[b]])k[f[b]](a);"chart"!==b&&-1!==k.propsRequireUpdateSeries.indexOf(b)&&(p=!0)});this.collectionsWithUpdate.forEach(function(b){if(a[b]){if("series"===b){var c=[];k[b].forEach(function(a,b){a.options.isInternal||c.push(y(a.options.index,b))})}n(a[b]).forEach(function(a,e){(e=F(a.id)&&k.get(a.id)||k[b][c?c[e]:e])&&e.coll===b&&(e.update(a,!1),d&&(e.touched=!0));!e&&d&&k.collectionsWithInit[b]&&(k.collectionsWithInit[b][0].apply(k,[a].concat(k.collectionsWithInit[b][1]||
	[]).concat([!1])).touched=!0)});d&&k[b].forEach(function(a){a.touched||a.options.isInternal?delete a.touched:q.push(a)})}});q.forEach(function(a){a.remove&&a.remove(!1)});x&&k.axes.forEach(function(a){a.update({},!1)});p&&k.series.forEach(function(a){a.update({},!1)});a.loading&&l(!0,k.options.loading,a.loading);x=h&&h.width;h=h&&h.height;C(h)&&(h=c.relativeLength(h,x||k.chartWidth));r||t(x)&&x!==k.chartWidth||t(h)&&h!==k.chartHeight?k.setSize(x,h,g):y(b,!0)&&k.redraw(g);e(k,"afterUpdate",{options:a,
	redraw:b,animation:g})},setSubtitle:function(a,b){this.applyDescription("subtitle",a);this.layOutTitles(b)},setCaption:function(a,b){this.applyDescription("caption",a);this.layOutTitles(b)}});f.prototype.collectionsWithInit={xAxis:[f.prototype.addAxis,[!0]],yAxis:[f.prototype.addAxis,[!1]],colorAxis:[f.prototype.addColorAxis,[!1]],series:[f.prototype.addSeries]};z(L.prototype,{update:function(a,b,d,c){function e(){g.applyOptions(a);null===g.y&&f&&(g.graphic=f.destroy());v(a,!0)&&(f&&f.element&&a&&
	a.marker&&void 0!==a.marker.symbol&&(g.graphic=f.destroy()),a&&a.dataLabels&&g.dataLabel&&(g.dataLabel=g.dataLabel.destroy()),g.connector&&(g.connector=g.connector.destroy()));h=g.index;k.updateParallelArrays(g,h);p.data[h]=v(p.data[h],!0)||v(a,!0)?g.options:y(a,p.data[h]);k.isDirty=k.isDirtyData=!0;!k.fixedBox&&k.hasCartesianSeries&&(l.isDirtyBox=!0);"point"===p.legendType&&(l.isDirtyLegend=!0);b&&l.redraw(d)}var g=this,k=g.series,f=g.graphic,h,l=k.chart,p=k.options;b=y(b,!0);!1===c?e():g.firePointEvent("update",
	{options:a},e)},remove:function(a,b){this.series.removePoint(this.series.data.indexOf(this),a,b)}});z(E.prototype,{addPoint:function(a,b,d,c,g){var k=this.options,f=this.data,h=this.chart,l=this.xAxis;l=l&&l.hasNames&&l.names;var p=k.data,r=this.xData,n;b=y(b,!0);var u={series:this};this.pointClass.prototype.applyOptions.apply(u,[a]);var q=u.x;var x=r.length;if(this.requireSorting&&q<r[x-1])for(n=!0;x&&r[x-1]>q;)x--;this.updateParallelArrays(u,"splice",x,0,0);this.updateParallelArrays(u,x);l&&u.name&&
	(l[q]=u.name);p.splice(x,0,a);n&&(this.data.splice(x,0,null),this.processData());"point"===k.legendType&&this.generatePoints();d&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(u,"shift"),p.shift()));!1!==g&&e(this,"addPoint",{point:u});this.isDirtyData=this.isDirty=!0;b&&h.redraw(c)},removePoint:function(a,b,d){var c=this,e=c.data,g=e[a],k=c.points,f=c.chart,l=function(){k&&k.length===e.length&&k.splice(a,1);e.splice(a,1);c.options.data.splice(a,1);c.updateParallelArrays(g||
	{series:c},"splice",a,1);g&&g.destroy();c.isDirty=!0;c.isDirtyData=!0;b&&f.redraw()};h(d,f);b=y(b,!0);g?g.firePointEvent("remove",null,l):l()},remove:function(a,b,d,c){function g(){k.destroy(c);k.remove=null;f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();y(a,!0)&&f.redraw(b)}var k=this,f=k.chart;!1!==d?e(k,"remove",null,g):g()},update:function(a,b){a=c.cleanRecursively(a,this.userOptions);e(this,"update",{options:a});var d=this,g=d.chart,k=d.userOptions,f=d.initialType||d.type,h=a.type||k.type||g.options.chart.type,
	n=!(this.hasDerivedData||a.dataGrouping||h&&h!==this.type||void 0!==a.pointStart||a.pointInterval||a.pointIntervalUnit||a.keys),u=p[f].prototype,q,v=["group","markerGroup","dataLabelsGroup","transformGroup"],t=["eventOptions","navigatorSeries","baseSeries"],E=d.finishedAnimating&&{animation:!1},C={};n&&(t.push("data","isDirtyData","points","processedXData","processedYData","xIncrement","_hasPointMarkers","_hasPointLabels","mapMap","mapData","minY","maxY","minX","maxX"),!1!==a.visible&&t.push("area",
	"graph"),d.parallelArrays.forEach(function(a){t.push(a+"Data")}),a.data&&this.setData(a.data,!1));a=l(k,E,{index:void 0===k.index?d.index:k.index,pointStart:y(k.pointStart,d.xData[0])},!n&&{data:d.options.data},a);n&&a.data&&(a.data=d.options.data);t=v.concat(t);t.forEach(function(a){t[a]=d[a];delete d[a]});d.remove(!1,null,!1,!0);for(q in u)d[q]=void 0;p[h||f]?z(d,p[h||f].prototype):c.error(17,!0,g,{missingModuleFor:h||f});t.forEach(function(a){d[a]=t[a]});d.init(g,a);if(n&&this.points){var L=d.options;
	!1===L.visible?(C.graphic=1,C.dataLabel=1):d._hasPointLabels||(h=L.marker,u=L.dataLabels,h&&(!1===h.enabled||"symbol"in h)&&(C.graphic=1),u&&!1===u.enabled&&(C.dataLabel=1));this.points.forEach(function(a){a&&a.series&&(a.resolveColor(),Object.keys(C).length&&a.destroyElements(C),!1===L.showInLegend&&a.legendItem&&g.legend.destroyItem(a))},this)}a.zIndex!==k.zIndex&&v.forEach(function(b){d[b]&&d[b].attr({zIndex:a.zIndex})});d.initialType=f;g.linkSeries();e(this,"afterUpdate");y(b,!0)&&g.redraw(n?
	void 0:!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});z(b.prototype,{update:function(a,b){var d=this.chart,c=a&&a.events||{};a=l(this.userOptions,a);d.options[this.coll].indexOf&&(d.options[this.coll][d.options[this.coll].indexOf(this.userOptions)]=a);H(d.options[this.coll].events,function(a,b){"undefined"===typeof c[b]&&(c[b]=void 0)});this.destroy(!0);this.init(d,z(a,{events:c}));d.isDirtyBox=!0;y(b,!0)&&d.redraw()},remove:function(a){for(var b=
	this.chart,d=this.coll,c=this.series,e=c.length;e--;)c[e]&&c[e].remove(!1);G(b.axes,this);G(b[d],this);B(b.options[d])?b.options[d].splice(this.options.index,1):delete b.options[d];b[d].forEach(function(a,b){a.options.index=a.userOptions.index=b});this.destroy();b.isDirtyBox=!0;y(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})});M(I,"parts/AreaSeries.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=
	f.objectEach,G=f.pick,z=c.color,B=c.Series;f=c.seriesType;f("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(c){var f=[],t=[],z=this.xAxis,y=this.yAxis,h=y.stacks[this.stackKey],n={},q=this.index,g=y.series,b=g.length,a=G(y.options.reversedStacks,!0)?1:-1,d;c=c||this.points;if(this.options.stacking){for(d=0;d<c.length;d++)c[d].leftNull=c[d].rightNull=void 0,n[c[d].x]=c[d];F(h,function(a,b){null!==a.total&&t.push(b)});t.sort(function(a,b){return a-b});var e=g.map(function(a){return a.visible});
	t.forEach(function(c,g){var l=0,p,u;if(n[c]&&!n[c].isNull)f.push(n[c]),[-1,1].forEach(function(k){var f=1===k?"rightNull":"leftNull",l=0,v=h[t[g+k]];if(v)for(d=q;0<=d&&d<b;)p=v.points[d],p||(d===q?n[c][f]=!0:e[d]&&(u=h[c].points[d])&&(l-=u[1]-u[0])),d+=a;n[c][1===k?"rightCliff":"leftCliff"]=l});else{for(d=q;0<=d&&d<b;){if(p=h[c].points[d]){l=p[1];break}d+=a}l=y.translate(l,0,1,0,1);f.push({isNull:!0,plotX:z.translate(c,0,0,0,1),x:c,plotY:l,yBottom:l})}})}return f},getGraphPath:function(c){var f=B.prototype.getGraphPath,
	t=this.options,z=t.stacking,y=this.yAxis,h,n=[],q=[],g=this.index,b=y.stacks[this.stackKey],a=t.threshold,d=Math.round(y.getThreshold(t.threshold));t=G(t.connectNulls,"percent"===z);var e=function(e,f,k){var h=c[e];e=z&&b[h.x].points[g];var l=h[k+"Null"]||0;k=h[k+"Cliff"]||0;h=!0;if(k||l){var p=(l?e[0]:e[1])+k;var u=e[0]+k;h=!!l}else!z&&c[f]&&c[f].isNull&&(p=u=a);void 0!==p&&(q.push({plotX:L,plotY:null===p?d:y.getThreshold(p),isNull:h,isCliff:!0}),n.push({plotX:L,plotY:null===u?d:y.getThreshold(u),
	doCurve:!1}))};c=c||this.points;z&&(c=this.getStackPoints(c));for(h=0;h<c.length;h++){z||(c[h].leftCliff=c[h].rightCliff=c[h].leftNull=c[h].rightNull=void 0);var l=c[h].isNull;var L=G(c[h].rectPlotX,c[h].plotX);var E=G(c[h].yBottom,d);if(!l||t)t||e(h,h-1,"left"),l&&!z&&t||(q.push(c[h]),n.push({x:h,plotX:L,plotY:E})),t||e(h,h+1,"right")}h=f.call(this,q,!0,!0);n.reversed=!0;l=f.call(this,n,!0,!0);l.length&&(l[0]="L");l=h.concat(l);f=f.call(this,q,!1,t);l.xMap=h.xMap;this.areaPath=l;return f},drawGraph:function(){this.areaPath=
	[];B.prototype.drawGraph.apply(this);var c=this,f=this.areaPath,C=this.options,H=[["area","highcharts-area",this.color,C.fillColor]];this.zones.forEach(function(f,h){H.push(["zone-area-"+h,"highcharts-area highcharts-zone-area-"+h+" "+f.className,f.color||c.color,f.fillColor||C.fillColor])});H.forEach(function(v){var h=v[0],n=c[h],q=n?"animate":"attr",g={};n?(n.endX=c.preventGraphAnimation?null:f.xMap,n.animate({d:f})):(g.zIndex=0,n=c[h]=c.chart.renderer.path(f).addClass(v[1]).add(c.group),n.isArea=
	!0);c.chart.styledMode||(g.fill=G(v[3],z(v[2]).setOpacity(G(C.fillOpacity,.75)).get()));n[q](g);n.startX=f.xMap;n.shiftUnit=C.step?2:1})},drawLegendSymbol:c.LegendSymbolMixin.drawRectangle});""});M(I,"parts/SplineSeries.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.pick;c=c.seriesType;c("spline","line",{},{getPointSpline:function(c,f,B){var t=f.plotX,v=f.plotY,C=c[B-1];B=c[B+1];if(C&&!C.isNull&&!1!==C.doCurve&&!f.isCliff&&B&&!B.isNull&&!1!==B.doCurve&&!f.isCliff){c=C.plotY;
	var z=B.plotX;B=B.plotY;var y=0;var h=(1.5*t+C.plotX)/2.5;var n=(1.5*v+c)/2.5;z=(1.5*t+z)/2.5;var q=(1.5*v+B)/2.5;z!==h&&(y=(q-n)*(z-t)/(z-h)+v-q);n+=y;q+=y;n>c&&n>v?(n=Math.max(c,v),q=2*v-n):n<c&&n<v&&(n=Math.min(c,v),q=2*v-n);q>B&&q>v?(q=Math.max(B,v),n=2*v-q):q<B&&q<v&&(q=Math.min(B,v),n=2*v-q);f.rightContX=z;f.rightContY=q}f=["C",F(C.rightContX,C.plotX),F(C.rightContY,C.plotY),F(h,t),F(n,v),t,v];C.rightContX=C.rightContY=null;return f}});""});M(I,"parts/AreaSplineSeries.js",[I["parts/Globals.js"]],
	function(c){var f=c.seriesTypes.area.prototype,F=c.seriesType;F("areaspline","spline",c.defaultPlotOptions.area,{getStackPoints:f.getStackPoints,getGraphPath:f.getGraphPath,drawGraph:f.drawGraph,drawLegendSymbol:c.LegendSymbolMixin.drawRectangle});""});M(I,"parts/ColumnSeries.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.extend,z=f.isNumber,B=f.pick,t=c.animObject,v=c.color,C=c.merge,H=c.Series;f=c.seriesType;var y=c.svg;f("column","line",{borderRadius:0,crisp:!0,
	groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){H.prototype.init.apply(this,arguments);var c=this,f=c.chart;
	f.hasRendered&&f.series.forEach(function(f){f.type===c.type&&(f.isDirty=!0)})},getColumnMetrics:function(){var c=this,f=c.options,q=c.xAxis,g=c.yAxis,b=q.options.reversedStacks;b=q.reversed&&!b||!q.reversed&&b;var a,d={},e=0;!1===f.grouping?e=1:c.chart.series.forEach(function(b){var f=b.yAxis,k=b.options;if(b.type===c.type&&(b.visible||!c.chart.options.chart.ignoreHiddenSeries)&&g.len===f.len&&g.pos===f.pos){if(k.stacking){a=b.stackKey;void 0===d[a]&&(d[a]=e++);var h=d[a]}else!1!==k.grouping&&(h=
	e++);b.columnIndex=h}});var l=Math.min(Math.abs(q.transA)*(q.ordinalSlope||f.pointRange||q.closestPointRange||q.tickInterval||1),q.len),v=l*f.groupPadding,t=(l-2*v)/(e||1);f=Math.min(f.maxPointWidth||q.len,B(f.pointWidth,t*(1-2*f.pointPadding)));c.columnMetrics={width:f,offset:(t-f)/2+(v+((c.columnIndex||0)+(b?1:0))*t-l/2)*(b?-1:1)};return c.columnMetrics},crispCol:function(c,f,q,g){var b=this.chart,a=this.borderWidth,d=-(a%2?.5:0);a=a%2?.5:1;b.inverted&&b.renderer.isVML&&(a+=1);this.options.crisp&&
	(q=Math.round(c+q)+d,c=Math.round(c)+d,q-=c);g=Math.round(f+g)+a;d=.5>=Math.abs(f)&&.5<g;f=Math.round(f)+a;g-=f;d&&g&&(--f,g+=1);return{x:c,y:f,width:q,height:g}},translate:function(){var c=this,f=c.chart,q=c.options,g=c.dense=2>c.closestPointRange*c.xAxis.transA;g=c.borderWidth=B(q.borderWidth,g?0:1);var b=c.yAxis,a=q.threshold,d=c.translatedThreshold=b.getThreshold(a),e=B(q.minPointLength,5),l=c.getColumnMetrics(),v=l.width,t=c.barW=Math.max(v,1+2*g),p=c.pointXOffset=l.offset,u=c.dataMin,k=c.dataMax;
	f.inverted&&(d-=.5);q.pointPadding&&(t=Math.ceil(t));H.prototype.translate.apply(c);c.points.forEach(function(g){var h=B(g.yBottom,d),l=999+Math.abs(h),r=v;l=Math.min(Math.max(-l,g.plotY),b.len+l);var m=g.plotX+p,n=t,q=Math.min(l,h),y=Math.max(l,h)-q;if(e&&Math.abs(y)<e){y=e;var E=!b.reversed&&!g.negative||b.reversed&&g.negative;g.y===a&&c.dataMax<=a&&b.min<a&&u!==k&&(E=!E);q=Math.abs(q-d)>e?h-e:d-(E?e:0)}F(g.options.pointWidth)&&(r=n=Math.ceil(g.options.pointWidth),m-=Math.round((r-v)/2));g.barX=
	m;g.pointWidth=r;g.tooltipPos=f.inverted?[b.len+b.pos-f.plotLeft-l,c.xAxis.len-m-n/2,y]:[m+n/2,l+b.pos-f.plotTop,y];g.shapeType=c.pointClass.prototype.shapeType||"rect";g.shapeArgs=c.crispCol.apply(c,g.isNull?[m,d,n,0]:[m,q,n,y])})},getSymbol:c.noop,drawLegendSymbol:c.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(c,f){var h=this.options,g=this.pointAttrToOptions||{};var b=g.stroke||"borderColor";
	var a=g["stroke-width"]||"borderWidth",d=c&&c.color||this.color,e=c&&c[b]||h[b]||this.color||d,l=c&&c[a]||h[a]||this[a]||0;g=c&&c.options.dashStyle||h.dashStyle;var n=B(h.opacity,1);if(c&&this.zones.length){var t=c.getZone();d=c.options.color||t&&(t.color||c.nonZonedColor)||this.color;t&&(e=t.borderColor||e,g=t.dashStyle||g,l=t.borderWidth||l)}f&&(c=C(h.states[f],c.options.states&&c.options.states[f]||{}),f=c.brightness,d=c.color||void 0!==f&&v(d).brighten(c.brightness).get()||d,e=c[b]||e,l=c[a]||
	l,g=c.dashStyle||g,n=B(c.opacity,n));b={fill:d,stroke:e,"stroke-width":l,opacity:n};g&&(b.dashstyle=g);return b},drawPoints:function(){var c=this,f=this.chart,q=c.options,g=f.renderer,b=q.animationLimit||250,a;c.points.forEach(function(d){var e=d.graphic,l=e&&f.pointCount<b?"animate":"attr";if(z(d.plotY)&&null!==d.y){a=d.shapeArgs;e&&d.hasNewShapeType()&&(e=e.destroy());if(e)e[l](C(a));else d.graphic=e=g[d.shapeType](a).add(d.group||c.group);if(q.borderRadius)e[l]({r:q.borderRadius});f.styledMode||
	e[l](c.pointAttribs(d,d.selected&&"select")).shadow(!1!==d.allowShadow&&q.shadow,null,q.stacking&&!q.borderRadius);e.addClass(d.getClassName(),!0)}else e&&(d.graphic=e.destroy())})},animate:function(c){var f=this,h=this.yAxis,g=f.options,b=this.chart.inverted,a={},d=b?"translateX":"translateY";if(y)if(c)a.scaleY=.001,c=Math.min(h.pos+h.len,Math.max(h.pos,h.toPixels(g.threshold))),b?a.translateX=c-h.len:a.translateY=c,f.clipBox&&f.setClip(),f.group.attr(a);else{var e=f.group.attr(d);f.group.animate({scaleY:1},
	G(t(f.options.animation),{step:function(b,c){a[d]=e+c.pos*(h.pos-e);f.group.attr(a)}}));f.animate=null}},remove:function(){var c=this,f=c.chart;f.hasRendered&&f.series.forEach(function(f){f.type===c.type&&(f.isDirty=!0)});H.prototype.remove.apply(c,arguments)}});""});M(I,"parts/BarSeries.js",[I["parts/Globals.js"]],function(c){c=c.seriesType;c("bar","column",null,{inverted:!0});""});M(I,"parts/ScatterSeries.js",[I["parts/Globals.js"]],function(c){var f=c.Series,F=c.seriesType;F("scatter","line",{lineWidth:0,
	findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px"> {series.name}</span><br/>',pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&f.prototype.drawGraph.call(this)},applyJitter:function(){var c=this,f=this.options.jitter,
	B=this.points.length;f&&this.points.forEach(function(t,v){["x","y"].forEach(function(C,z){var y="plot"+C.toUpperCase();if(f[C]&&!t.isNull){var h=c[C+"Axis"];var n=f[C]*h.transA;if(h&&!h.isLog){var q=Math.max(0,t[y]-n);h=Math.min(h.len,t[y]+n);z=1E4*Math.sin(v+z*B);t[y]=q+(h-q)*(z-Math.floor(z));"x"===C&&(t.clientX=t.plotX)}}})})}});c.addEvent(f,"afterTranslate",function(){this.applyJitter&&this.applyJitter()});""});M(I,"mixins/centered-series.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,
	f){var F=f.isNumber,G=f.pick,z=c.deg2rad,B=c.relativeLength;c.CenteredSeriesMixin={getCenter:function(){var c=this.options,f=this.chart,C=2*(c.slicedOffset||0),z=f.plotWidth-2*C;f=f.plotHeight-2*C;var y=c.center;y=[G(y[0],"50%"),G(y[1],"50%"),c.size||"100%",c.innerSize||0];var h=Math.min(z,f),n;for(n=0;4>n;++n){var q=y[n];c=2>n||2===n&&/%$/.test(q);y[n]=B(q,[z,f,h,y[2]][n])+(c?C:0)}y[3]>y[2]&&(y[3]=y[2]);return y},getStartAndEndRadians:function(c,f){c=F(c)?c:0;f=F(f)&&f>c&&360>f-c?f:c+360;return{start:z*
	(c+-90),end:z*(f+-90)}}}});M(I,"parts/PieSeries.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.isNumber,z=f.pick,B=f.setAnimation,t=c.addEvent;f=c.CenteredSeriesMixin;var v=f.getStartAndEndRadians,C=c.merge,H=c.noop,y=c.Point,h=c.Series,n=c.seriesType,q=c.fireEvent;n("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,connectorPadding:5,distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},
	softConnector:!0,x:0,connectorShape:"fixedOffset",crookDistance:"70%"},fillColor:void 0,ignoreHiddenPoint:!0,inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,lineWidth:void 0,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:c.seriesTypes.column.prototype.pointAttribs,
	animate:function(c){var b=this,a=b.points,d=b.startAngleRad;c||(a.forEach(function(a){var c=a.graphic,e=a.shapeArgs;c&&(c.attr({r:a.startR||b.center[3]/2,start:d,end:d}),c.animate({r:e.r,start:e.start,end:e.end},b.options.animation))}),b.animate=null)},hasData:function(){return!!this.processedXData.length},updateTotals:function(){var c,b=0,a=this.points,d=a.length,e=this.options.ignoreHiddenPoint;for(c=0;c<d;c++){var f=a[c];b+=e&&!f.visible?0:f.isNull?0:f.y}this.total=b;for(c=0;c<d;c++)f=a[c],f.percentage=
	0<b&&(f.visible||!e)?f.y/b*100:0,f.total=b},generatePoints:function(){h.prototype.generatePoints.call(this);this.updateTotals()},getX:function(c,b,a){var d=this.center,e=this.radii?this.radii[a.index]:d[2]/2;return d[0]+(b?-1:1)*Math.cos(Math.asin(Math.max(Math.min((c-d[1])/(e+a.labelDistance),1),-1)))*(e+a.labelDistance)+(0<a.labelDistance?(b?-1:1)*this.options.dataLabels.padding:0)},translate:function(g){this.generatePoints();var b=0,a=this.options,d=a.slicedOffset,e=d+(a.borderWidth||0),f=v(a.startAngle,
	a.endAngle),h=this.startAngleRad=f.start;f=(this.endAngleRad=f.end)-h;var n=this.points,p=a.dataLabels.distance;a=a.ignoreHiddenPoint;var u,k=n.length;g||(this.center=g=this.getCenter());for(u=0;u<k;u++){var r=n[u];var x=h+b*f;if(!a||r.visible)b+=r.percentage/100;var A=h+b*f;r.shapeType="arc";r.shapeArgs={x:g[0],y:g[1],r:g[2]/2,innerR:g[3]/2,start:Math.round(1E3*x)/1E3,end:Math.round(1E3*A)/1E3};r.labelDistance=z(r.options.dataLabels&&r.options.dataLabels.distance,p);r.labelDistance=c.relativeLength(r.labelDistance,
	r.shapeArgs.r);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,r.labelDistance);A=(A+x)/2;A>1.5*Math.PI?A-=2*Math.PI:A<-Math.PI/2&&(A+=2*Math.PI);r.slicedTranslation={translateX:Math.round(Math.cos(A)*d),translateY:Math.round(Math.sin(A)*d)};var w=Math.cos(A)*g[2]/2;var m=Math.sin(A)*g[2]/2;r.tooltipPos=[g[0]+.7*w,g[1]+.7*m];r.half=A<-Math.PI/2||A>Math.PI/2?1:0;r.angle=A;x=Math.min(e,r.labelDistance/5);r.labelPosition={natural:{x:g[0]+w+Math.cos(A)*r.labelDistance,y:g[1]+m+Math.sin(A)*r.labelDistance},
	"final":{},alignment:0>r.labelDistance?"center":r.half?"right":"left",connectorPosition:{breakAt:{x:g[0]+w+Math.cos(A)*x,y:g[1]+m+Math.sin(A)*x},touchingSliceAt:{x:g[0]+w,y:g[1]+m}}}}q(this,"afterTranslate")},drawEmpty:function(){var c=this.options;if(0===this.total){var b=this.center[0];var a=this.center[1];this.graph||(this.graph=this.chart.renderer.circle(b,a,0).addClass("highcharts-graph").add(this.group));this.graph.animate({"stroke-width":c.borderWidth,cx:b,cy:a,r:this.center[2]/2,fill:c.fillColor||
	"none",stroke:c.color||"#cccccc"})}else this.graph&&(this.graph=this.graph.destroy())},redrawPoints:function(){var c=this,b=c.chart,a=b.renderer,d,e,f,h,n=c.options.shadow;this.drawEmpty();!n||c.shadowGroup||b.styledMode||(c.shadowGroup=a.g("shadow").attr({zIndex:-1}).add(c.group));c.points.forEach(function(g){var l={};e=g.graphic;if(!g.isNull&&e){h=g.shapeArgs;d=g.getTranslate();if(!b.styledMode){var k=g.shadowGroup;n&&!k&&(k=g.shadowGroup=a.g("shadow").add(c.shadowGroup));k&&k.attr(d);f=c.pointAttribs(g,
	g.selected&&"select")}g.delayedRendering?(e.setRadialReference(c.center).attr(h).attr(d),b.styledMode||e.attr(f).attr({"stroke-linejoin":"round"}).shadow(n,k),g.delayedRendering=!1):(e.setRadialReference(c.center),b.styledMode||C(!0,l,f),C(!0,l,h,d),e.animate(l));e.attr({visibility:g.visible?"inherit":"hidden"});e.addClass(g.getClassName())}else e&&(g.graphic=e.destroy())})},drawPoints:function(){var c=this.chart.renderer;this.points.forEach(function(b){b.graphic||(b.graphic=c[b.shapeType](b.shapeArgs).add(b.series.group),
	b.delayedRendering=!0)})},searchPoint:H,sortByAngle:function(c,b){c.sort(function(a,d){return void 0!==a.angle&&(d.angle-a.angle)*b})},drawLegendSymbol:c.LegendSymbolMixin.drawRectangle,getCenter:f.getCenter,getSymbol:H,drawGraph:null},{init:function(){y.prototype.init.apply(this,arguments);var c=this;c.name=z(c.name,"Slice");var b=function(a){c.slice("select"===a.type)};t(c,"select",b);t(c,"unselect",b);return c},isValid:function(){return G(this.y)&&0<=this.y},setVisible:function(c,b){var a=this,
	d=a.series,e=d.chart,f=d.options.ignoreHiddenPoint;b=z(b,f);c!==a.visible&&(a.visible=a.options.visible=c=void 0===c?!a.visible:c,d.options.data[d.data.indexOf(a)]=a.options,["graphic","dataLabel","connector","shadowGroup"].forEach(function(b){if(a[b])a[b][c?"show":"hide"](!0)}),a.legendItem&&e.legend.colorizeItem(a,c),c||"hover"!==a.state||a.setState(""),f&&(d.isDirty=!0),b&&e.redraw())},slice:function(c,b,a){var d=this.series;B(a,d.chart);z(b,!0);this.sliced=this.options.sliced=F(c)?c:!this.sliced;
	d.options.data[d.data.indexOf(this)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(c){var b=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(b.x,b.y,b.r+c,b.r+c,{innerR:b.r-1,start:b.start,end:b.end})},connectorShapes:{fixedOffset:function(c,b,a){var d=b.breakAt;b=b.touchingSliceAt;
	return["M",c.x,c.y].concat(a.softConnector?["C",c.x+("left"===c.alignment?-5:5),c.y,2*d.x-b.x,2*d.y-b.y,d.x,d.y]:["L",d.x,d.y]).concat(["L",b.x,b.y])},straight:function(c,b){b=b.touchingSliceAt;return["M",c.x,c.y,"L",b.x,b.y]},crookedLine:function(f,b,a){b=b.touchingSliceAt;var d=this.series,e=d.center[0],g=d.chart.plotWidth,h=d.chart.plotLeft;d=f.alignment;var n=this.shapeArgs.r;a=c.relativeLength(a.crookDistance,1);a="left"===d?e+n+(g+h-e-n)*(1-a):h+(e-n)*a;e=["L",a,f.y];if("left"===d?a>f.x||a<
	b.x:a<f.x||a>b.x)e=[];return["M",f.x,f.y].concat(e).concat(["L",b.x,b.y])}},getConnectorPath:function(){var c=this.labelPosition,b=this.series.options.dataLabels,a=b.connectorShape,d=this.connectorShapes;d[a]&&(a=d[a]);return a.call(this,{x:c.final.x,y:c.final.y,alignment:c.alignment},c.connectorPosition,b)}});""});M(I,"parts/DataLabels.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.arrayMax,G=f.defined,z=f.extend,B=f.isArray,t=f.objectEach,v=f.pick,C=f.splat,H=c.format,
	y=c.merge;f=c.noop;var h=c.relativeLength,n=c.Series,q=c.seriesTypes,g=c.stableSort;c.distribute=function(b,a,d){function e(a,b){return a.target-b.target}var f,h=!0,n=b,p=[];var u=0;var k=n.reducedLen||a;for(f=b.length;f--;)u+=b[f].size;if(u>k){g(b,function(a,b){return(b.rank||0)-(a.rank||0)});for(u=f=0;u<=k;)u+=b[f].size,f++;p=b.splice(f-1,b.length)}g(b,e);for(b=b.map(function(a){return{size:a.size,targets:[a.target],align:v(a.align,.5)}});h;){for(f=b.length;f--;)h=b[f],u=(Math.min.apply(0,h.targets)+
	Math.max.apply(0,h.targets))/2,h.pos=Math.min(Math.max(0,u-h.size*h.align),a-h.size);f=b.length;for(h=!1;f--;)0<f&&b[f-1].pos+b[f-1].size>b[f].pos&&(b[f-1].size+=b[f].size,b[f-1].targets=b[f-1].targets.concat(b[f].targets),b[f-1].align=.5,b[f-1].pos+b[f-1].size>a&&(b[f-1].pos=a-b[f-1].size),b.splice(f,1),h=!0)}n.push.apply(n,p);f=0;b.some(function(b){var e=0;if(b.targets.some(function(){n[f].pos=b.pos+e;if(Math.abs(n[f].pos-n[f].target)>d)return n.slice(0,f+1).forEach(function(a){delete a.pos}),n.reducedLen=
	(n.reducedLen||a)-.1*a,n.reducedLen>.1*a&&c.distribute(n,a,d),!0;e+=n[f].size;f++}))return!0});g(n,e)};n.prototype.drawDataLabels=function(){function b(a,b){var d=b.filter;return d?(b=d.operator,a=a[d.property],d=d.value,">"===b&&a>d||"<"===b&&a<d||">="===b&&a>=d||"<="===b&&a<=d||"=="===b&&a==d||"==="===b&&a===d?!0:!1):!0}function a(a,b){var d=[],c;if(B(a)&&!B(b))d=a.map(function(a){return y(a,b)});else if(B(b)&&!B(a))d=b.map(function(b){return y(a,b)});else if(B(a)||B(b))for(c=Math.max(a.length,
	b.length);c--;)d[c]=y(a[c],b[c]);else d=y(a,b);return d}var d=this,e=d.chart,f=d.options,g=f.dataLabels,h=d.points,p,n=d.hasRendered||0,k=c.animObject(f.animation).duration,r=Math.min(k,200),q=!e.renderer.forExport&&v(g.defer,0<r),A=e.renderer;g=a(a(e.options.plotOptions&&e.options.plotOptions.series&&e.options.plotOptions.series.dataLabels,e.options.plotOptions&&e.options.plotOptions[d.type]&&e.options.plotOptions[d.type].dataLabels),g);c.fireEvent(this,"drawDataLabels");if(B(g)||g.enabled||d._hasPointLabels){var w=
	d.plotGroup("dataLabelsGroup","data-labels",q&&!n?"hidden":"inherit",g.zIndex||6);q&&(w.attr({opacity:+n}),n||setTimeout(function(){var a=d.dataLabelsGroup;a&&(d.visible&&w.show(!0),a[f.animation?"animate":"attr"]({opacity:1},{duration:r}))},k-r));h.forEach(function(c){p=C(a(g,c.dlOptions||c.options&&c.options.dataLabels));p.forEach(function(a,g){var k=a.enabled&&(!c.isNull||c.dataLabelOnNull)&&b(c,a),h=c.dataLabels?c.dataLabels[g]:c.dataLabel,l=c.connectors?c.connectors[g]:c.connector,p=v(a.distance,
	c.labelDistance),m=!h;if(k){var n=c.getLabelConfig();var r=v(a[c.formatPrefix+"Format"],a.format);n=G(r)?H(r,n,e.time):(a[c.formatPrefix+"Formatter"]||a.formatter).call(n,a);r=a.style;var u=a.rotation;e.styledMode||(r.color=v(a.color,r.color,d.color,"#000000"),"contrast"===r.color&&(c.contrastColor=A.getContrast(c.color||d.color),r.color=!G(p)&&a.inside||0>p||f.stacking?c.contrastColor:"#000000"),f.cursor&&(r.cursor=f.cursor));var q={r:a.borderRadius||0,rotation:u,padding:a.padding,zIndex:1};e.styledMode||
	(q.fill=a.backgroundColor,q.stroke=a.borderColor,q["stroke-width"]=a.borderWidth);t(q,function(a,b){void 0===a&&delete q[b]})}!h||k&&G(n)?k&&G(n)&&(h?q.text=n:(c.dataLabels=c.dataLabels||[],h=c.dataLabels[g]=u?A.text(n,0,-9999).addClass("highcharts-data-label"):A.label(n,0,-9999,a.shape,null,null,a.useHTML,null,"data-label"),g||(c.dataLabel=h),h.addClass(" highcharts-data-label-color-"+c.colorIndex+" "+(a.className||"")+(a.useHTML?" highcharts-tracker":""))),h.options=a,h.attr(q),e.styledMode||h.css(r).shadow(a.shadow),
	h.added||h.add(w),a.textPath&&!a.useHTML&&h.setTextPath(c.getDataLabelPath&&c.getDataLabelPath(h)||c.graphic,a.textPath),d.alignDataLabel(c,h,a,null,m)):(c.dataLabel=c.dataLabel&&c.dataLabel.destroy(),c.dataLabels&&(1===c.dataLabels.length?delete c.dataLabels:delete c.dataLabels[g]),g||delete c.dataLabel,l&&(c.connector=c.connector.destroy(),c.connectors&&(1===c.connectors.length?delete c.connectors:delete c.connectors[g])))})})}c.fireEvent(this,"afterDrawDataLabels")};n.prototype.alignDataLabel=
	function(b,a,d,c,f){var e=this.chart,g=this.isCartesian&&e.inverted,h=v(b.dlBox&&b.dlBox.centerX,b.plotX,-9999),l=v(b.plotY,-9999),k=a.getBBox(),n=d.rotation,q=d.align,A=this.visible&&(b.series.forceDL||e.isInsidePlot(h,Math.round(l),g)||c&&e.isInsidePlot(h,g?c.x+1:c.y+c.height-1,g)),w="justify"===v(d.overflow,"justify");if(A){var m=e.renderer.fontMetrics(e.styledMode?void 0:d.style.fontSize,a).b;c=z({x:g?this.yAxis.len-l:h,y:Math.round(g?this.xAxis.len-h:l),width:0,height:0},c);z(d,{width:k.width,
	height:k.height});n?(w=!1,h=e.renderer.rotCorr(m,n),h={x:c.x+d.x+c.width/2+h.x,y:c.y+d.y+{top:0,middle:.5,bottom:1}[d.verticalAlign]*c.height},a[f?"attr":"animate"](h).attr({align:q}),l=(n+720)%360,l=180<l&&360>l,"left"===q?h.y-=l?k.height:0:"center"===q?(h.x-=k.width/2,h.y-=k.height/2):"right"===q&&(h.x-=k.width,h.y-=l?0:k.height),a.placed=!0,a.alignAttr=h):(a.align(d,null,c),h=a.alignAttr);w&&0<=c.height?this.justifyDataLabel(a,d,h,k,c,f):v(d.crop,!0)&&(A=e.isInsidePlot(h.x,h.y)&&e.isInsidePlot(h.x+
	k.width,h.y+k.height));if(d.shape&&!n)a[f?"attr":"animate"]({anchorX:g?e.plotWidth-b.plotY:b.plotX,anchorY:g?e.plotHeight-b.plotX:b.plotY})}A||(a.hide(!0),a.placed=!1)};n.prototype.justifyDataLabel=function(b,a,d,c,f,g){var e=this.chart,h=a.align,l=a.verticalAlign,k=b.box?0:b.padding||0;var n=d.x+k;if(0>n){"right"===h?(a.align="left",a.inside=!0):a.x=-n;var q=!0}n=d.x+c.width-k;n>e.plotWidth&&("left"===h?(a.align="right",a.inside=!0):a.x=e.plotWidth-n,q=!0);n=d.y+k;0>n&&("bottom"===l?(a.verticalAlign=
	"top",a.inside=!0):a.y=-n,q=!0);n=d.y+c.height-k;n>e.plotHeight&&("top"===l?(a.verticalAlign="bottom",a.inside=!0):a.y=e.plotHeight-n,q=!0);q&&(b.placed=!g,b.align(a,null,f));return q};q.pie&&(q.pie.prototype.dataLabelPositioners={radialDistributionY:function(b){return b.top+b.distributeBox.pos},radialDistributionX:function(b,a,d,c){return b.getX(d<a.top+2||d>a.bottom-2?c:d,a.half,a)},justify:function(b,a,d){return d[0]+(b.half?-1:1)*(a+b.labelDistance)},alignToPlotEdges:function(b,a,d,c){b=b.getBBox().width;
	return a?b+c:d-b-c},alignToConnectors:function(b,a,d,c){var e=0,f;b.forEach(function(a){f=a.dataLabel.getBBox().width;f>e&&(e=f)});return a?e+c:d-e-c}},q.pie.prototype.drawDataLabels=function(){var b=this,a=b.data,d,e=b.chart,f=b.options.dataLabels,g=f.connectorPadding,h,p=e.plotWidth,u=e.plotHeight,k=e.plotLeft,r=Math.round(e.chartWidth/3),q,A=b.center,w=A[2]/2,m=A[1],t,z,C,B,H=[[],[]],I,D,N,M,R=[0,0,0,0],P=b.dataLabelPositioners,W;b.visible&&(f.enabled||b._hasPointLabels)&&(a.forEach(function(a){a.dataLabel&&
	a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),n.prototype.drawDataLabels.apply(b),a.forEach(function(a){a.dataLabel&&(a.visible?(H[a.half].push(a),a.dataLabel._pos=null,!G(f.style.width)&&!G(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>r&&(a.dataLabel.css({width:.7*r}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&
	1===a.dataLabels.length&&delete a.dataLabels))}),H.forEach(function(a,h){var l=a.length,n=[],r;if(l){b.sortByAngle(a,h-.5);if(0<b.maxLabelDistance){var q=Math.max(0,m-w-b.maxLabelDistance);var x=Math.min(m+w+b.maxLabelDistance,e.plotHeight);a.forEach(function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,m-w-a.labelDistance),a.bottom=Math.min(m+w+a.labelDistance,e.plotHeight),r=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPosition.natural.y-a.top+r/2,size:r,rank:a.y},n.push(a.distributeBox))});
	q=x+r-q;c.distribute(n,q,q/5)}for(M=0;M<l;M++){d=a[M];C=d.labelPosition;t=d.dataLabel;N=!1===d.visible?"hidden":"inherit";D=q=C.natural.y;n&&G(d.distributeBox)&&(void 0===d.distributeBox.pos?N="hidden":(B=d.distributeBox.size,D=P.radialDistributionY(d)));delete d.positionIndex;if(f.justify)I=P.justify(d,w,A);else switch(f.alignTo){case "connectors":I=P.alignToConnectors(a,h,p,k);break;case "plotEdges":I=P.alignToPlotEdges(t,h,p,k);break;default:I=P.radialDistributionX(b,d,D,q)}t._attr={visibility:N,
	align:C.alignment};t._pos={x:I+f.x+({left:g,right:-g}[C.alignment]||0),y:D+f.y-10};C.final.x=I;C.final.y=D;v(f.crop,!0)&&(z=t.getBBox().width,q=null,I-z<g&&1===h?(q=Math.round(z-I+g),R[3]=Math.max(q,R[3])):I+z>p-g&&0===h&&(q=Math.round(I+z-p+g),R[1]=Math.max(q,R[1])),0>D-B/2?R[0]=Math.max(Math.round(-D+B/2),R[0]):D+B/2>u&&(R[2]=Math.max(Math.round(D+B/2-u),R[2])),t.sideOverflow=q)}}}),0===F(R)||this.verifyDataLabelOverflow(R))&&(this.placeDataLabels(),this.points.forEach(function(a){W=y(f,a.options.dataLabels);
	if(h=v(W.connectorWidth,1)){var d;q=a.connector;if((t=a.dataLabel)&&t._pos&&a.visible&&0<a.labelDistance){N=t._attr.visibility;if(d=!q)a.connector=q=e.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+a.colorIndex+(a.className?" "+a.className:"")).add(b.dataLabelsGroup),e.styledMode||q.attr({"stroke-width":h,stroke:W.connectorColor||a.color||"#666666"});q[d?"attr":"animate"]({d:a.getConnectorPath()});q.attr("visibility",N)}else q&&(a.connector=q.destroy())}}))},q.pie.prototype.placeDataLabels=
	function(){this.points.forEach(function(b){var a=b.dataLabel,d;a&&b.visible&&((d=a._pos)?(a.sideOverflow&&(a._attr.width=Math.max(a.getBBox().width-a.sideOverflow,0),a.css({width:a._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),a.shortened=!0),a.attr(a._attr),a[a.moved?"animate":"attr"](d),a.moved=!0):a&&a.attr({y:-9999}));delete b.distributeBox},this)},q.pie.prototype.alignDataLabel=f,q.pie.prototype.verifyDataLabelOverflow=function(b){var a=this.center,
	d=this.options,c=d.center,f=d.minSize||80,g=null!==d.size;if(!g){if(null!==c[0])var n=Math.max(a[2]-Math.max(b[1],b[3]),f);else n=Math.max(a[2]-b[1]-b[3],f),a[0]+=(b[3]-b[1])/2;null!==c[1]?n=Math.max(Math.min(n,a[2]-Math.max(b[0],b[2])),f):(n=Math.max(Math.min(n,a[2]-b[0]-b[2]),f),a[1]+=(b[0]-b[2])/2);n<a[2]?(a[2]=n,a[3]=Math.min(h(d.innerSize||0,n),n),this.translate(a),this.drawDataLabels&&this.drawDataLabels()):g=!0}return g});q.column&&(q.column.prototype.alignDataLabel=function(b,a,d,c,f){var e=
	this.chart.inverted,g=b.series,h=b.dlBox||b.shapeArgs,l=v(b.below,b.plotY>v(this.translatedThreshold,g.yAxis.len)),k=v(d.inside,!!this.options.stacking);h&&(c=y(h),0>c.y&&(c.height+=c.y,c.y=0),h=c.y+c.height-g.yAxis.len,0<h&&(c.height-=h),e&&(c={x:g.yAxis.len-c.y-c.height,y:g.xAxis.len-c.x-c.width,width:c.height,height:c.width}),k||(e?(c.x+=l?0:c.width,c.width=0):(c.y+=l?c.height:0,c.height=0)));d.align=v(d.align,!e||k?"center":l?"right":"left");d.verticalAlign=v(d.verticalAlign,e||k?"middle":l?"top":
	"bottom");n.prototype.alignDataLabel.call(this,b,a,d,c,f);d.inside&&b.contrastColor&&a.css({color:b.contrastColor})})});M(I,"modules/overlapping-datalabels.src.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.isArray,G=f.objectEach,z=f.pick;f=c.Chart;var B=c.addEvent,t=c.fireEvent;B(f,"render",function(){var c=[];(this.labelCollectors||[]).forEach(function(f){c=c.concat(f())});(this.yAxis||[]).forEach(function(f){f.options.stackLabels&&!f.options.stackLabels.allowOverlap&&
	G(f.stacks,function(f){G(f,function(f){c.push(f.label)})})});(this.series||[]).forEach(function(f){var v=f.options.dataLabels;f.visible&&(!1!==v.enabled||f._hasPointLabels)&&f.points.forEach(function(f){f.visible&&(F(f.dataLabels)?f.dataLabels:f.dataLabel?[f.dataLabel]:[]).forEach(function(h){var n=h.options;h.labelrank=z(n.labelrank,f.labelrank,f.shapeArgs&&f.shapeArgs.height);n.allowOverlap||c.push(h)})})});this.hideOverlappingLabels(c)});f.prototype.hideOverlappingLabels=function(c){var f=this,
	v=c.length,y=f.renderer,h,n,q;var g=function(a){var b=a.box?0:a.padding||0;var d=0;if(a&&(!a.alignAttr||a.placed)){var c=a.attr("x");var f=a.attr("y");c="number"===typeof c&&"number"===typeof f?{x:c,y:f}:a.alignAttr;f=a.parentGroup;a.width||(d=a.getBBox(),a.width=d.width,a.height=d.height,d=y.fontMetrics(null,a.element).h);return{x:c.x+(f.translateX||0)+b,y:c.y+(f.translateY||0)+b-d,width:a.width-2*b,height:a.height-2*b}}};for(n=0;n<v;n++)if(h=c[n])h.oldOpacity=h.opacity,h.newOpacity=1,h.absoluteBox=
	g(h);c.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(n=0;n<v;n++){var b=(g=c[n])&&g.absoluteBox;for(h=n+1;h<v;++h){var a=(q=c[h])&&q.absoluteBox;!b||!a||g===q||0===g.newOpacity||0===q.newOpacity||a.x>b.x+b.width||a.x+a.width<b.x||a.y>b.y+b.height||a.y+a.height<b.y||((g.labelrank<q.labelrank?g:q).newOpacity=0)}}c.forEach(function(a){var b;if(a){var d=a.newOpacity;a.oldOpacity!==d&&(a.alignAttr&&a.placed?(d?a.show(!0):b=function(){a.hide(!0);a.placed=!1},a.alignAttr.opacity=d,a[a.isOld?
	"animate":"attr"](a.alignAttr,null,b),t(f,"afterHideOverlappingLabels")):a.attr({opacity:d}));a.isOld=!0}})}});M(I,"parts/Interaction.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.extend,z=f.isArray,B=f.isObject,t=f.objectEach,v=f.pick,C=c.addEvent;f=c.Chart;var H=c.createElement,y=c.css,h=c.defaultOptions,n=c.defaultPlotOptions,q=c.fireEvent,g=c.hasTouch,b=c.Legend,a=c.merge,d=c.Point,e=c.Series,l=c.seriesTypes,I=c.svg;var E=c.TrackerMixin={drawTrackerPoint:function(){var a=
	this,b=a.chart,d=b.pointer,c=function(a){var b=d.getPointFromEvent(a);void 0!==b&&(d.isDirectTouch=!0,b.onMouseOver(a))},e;a.points.forEach(function(a){e=z(a.dataLabels)?a.dataLabels:a.dataLabel?[a.dataLabel]:[];a.graphic&&(a.graphic.element.point=a);e.forEach(function(b){b.div?b.div.point=a:b.element.point=a})});a._hasTracking||(a.trackerGroups.forEach(function(e){if(a[e]){a[e].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",function(a){d.onTrackerMouseOut(a)});if(g)a[e].on("touchstart",
	c);!b.styledMode&&a.options.cursor&&a[e].css(y).css({cursor:a.options.cursor})}}),a._hasTracking=!0);q(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,d=b.trackByArea,c=[].concat(d?a.areaPath:a.graphPath),e=c.length,f=a.chart,h=f.pointer,l=f.renderer,n=f.options.tooltip.snap,v=a.tracker,t,y=function(){if(f.hoverSeries!==a)a.onMouseOver()},z="rgba(192,192,192,"+(I?.0001:.002)+")";if(e&&!d)for(t=e+1;t--;)"M"===c[t]&&c.splice(t+1,0,c[t+1]-n,c[t+2],"L"),(t&&"M"===c[t]||t===
	e)&&c.splice(t,0,"L",c[t-2]+n,c[t-1]);v?v.attr({d:c}):a.graph&&(a.tracker=l.path(c).attr({visibility:a.visible?"visible":"hidden",zIndex:2}).addClass(d?"highcharts-tracker-area":"highcharts-tracker-line").add(a.group),f.styledMode||a.tracker.attr({"stroke-linejoin":"round",stroke:z,fill:d?z:"none","stroke-width":a.graph.strokeWidth()+(d?0:2*n)}),[a.tracker,a.markerGroup].forEach(function(a){a.addClass("highcharts-tracker").on("mouseover",y).on("mouseout",function(a){h.onTrackerMouseOut(a)});b.cursor&&
	!f.styledMode&&a.css({cursor:b.cursor});if(g)a.on("touchstart",y)}));q(this,"afterDrawTracker")}};l.column&&(l.column.prototype.drawTracker=E.drawTrackerPoint);l.pie&&(l.pie.prototype.drawTracker=E.drawTrackerPoint);l.scatter&&(l.scatter.prototype.drawTracker=E.drawTrackerPoint);G(b.prototype,{setItemEvents:function(b,c,e){var f=this,g=f.chart.renderer.boxWrapper,k=b instanceof d,h="highcharts-legend-"+(k?"point":"series")+"-active",l=f.chart.styledMode;(e?c:b.legendGroup).on("mouseover",function(){b.visible&&
	f.allItems.forEach(function(a){b!==a&&a.setState("inactive",!k)});b.setState("hover");b.visible&&g.addClass(h);l||c.css(f.options.itemHoverStyle)}).on("mouseout",function(){f.chart.styledMode||c.css(a(b.visible?f.itemStyle:f.itemHiddenStyle));f.allItems.forEach(function(a){b!==a&&a.setState("",!k)});g.removeClass(h);b.setState()}).on("click",function(a){var c=function(){b.setVisible&&b.setVisible();f.allItems.forEach(function(a){b!==a&&a.setState(b.visible?"inactive":"",!k)})};g.removeClass(h);a=
	{browserEvent:a};b.firePointEvent?b.firePointEvent("legendItemClick",a,c):q(b,"legendItemClick",a,c)})},createCheckboxForItem:function(a){a.checkbox=H("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){q(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});G(f.prototype,{showResetZoom:function(){function a(){b.zoomOut()}
	var b=this,c=h.lang,d=b.options.chart.resetZoomButton,e=d.theme,f=e.states,g="chart"===d.relativeTo||"spaceBox"===d.relativeTo?null:"plotBox";q(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,e,f&&f.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,g)});q(this,"afterShowResetZoom")},zoomOut:function(){q(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b=
	this,c,d=b.pointer,e=!1,f=b.inverted?d.mouseDownX:d.mouseDownY;!a||a.resetSelection?(b.axes.forEach(function(a){c=a.zoom()}),d.initiated=!1):a.xAxis.concat(a.yAxis).forEach(function(a){var g=a.axis,k=b.inverted?g.left:g.top,h=b.inverted?k+g.width:k+g.height,l=g.isXAxis,m=!1;if(!l&&f>=k&&f<=h||l||!F(f))m=!0;d[l?"zoomX":"zoomY"]&&m&&(c=g.zoom(a.min,a.max),g.displayBtn&&(e=!0))});var g=b.resetZoomButton;e&&!g?b.showResetZoom():!e&&B(g)&&(b.resetZoomButton=g.destroy());c&&b.redraw(v(b.options.chart.animation,
	a&&a.animation,100>b.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;q(this,"pan",{originalEvent:a},function(){d&&d.forEach(function(a){a.setState()});("xy"===b?[1,0]:[1]).forEach(function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"];d=d?"mouseDownX":"mouseDownY";var g=c[d],k=(b.pointRange||0)/2,h=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,l=b.getExtremes(),n=b.toValue(g-f,!0)+k*h;h=b.toValue(g+b.len-f,!0)-k*h;var p=h<n;g=p?h:n;n=p?n:h;h=Math.min(l.dataMin,
	k?l.min:b.toValue(b.toPixels(l.min)-b.minPixelPadding));k=Math.max(l.dataMax,k?l.max:b.toValue(b.toPixels(l.max)+b.minPixelPadding));p=h-g;0<p&&(n+=p,g=h);p=n-k;0<p&&(n=k,g-=p);b.series.length&&g!==l.min&&n!==l.max&&(b.setExtremes(g,n,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);y(c.container,{cursor:"move"})})}});G(d.prototype,{select:function(a,b){var c=this,d=c.series,e=d.chart;this.selectedStaging=a=v(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=
	c.options.selected=a;d.options.data[d.data.indexOf(c)]=c.options;c.setState(a&&"select");b||e.getSelectedPoints().forEach(function(a){var b=a.series;a.selected&&a!==c&&(a.selected=a.options.selected=!1,b.options.data[b.data.indexOf(a)]=a.options,a.setState(e.hoverPoints&&b.options.inactiveOtherPoints?"inactive":""),a.firePointEvent("unselect"))})});delete this.selectedStaging},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);
	c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");this.series.options.inactiveOtherPoints||(a.hoverPoints||[]).forEach(function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,d=a(b.series.options.point,b.options).events;b.events=d;t(d,function(a,d){c.isFunction(a)&&C(b,d,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=this.series,d=this.state,e=c.options.states[a||
	"normal"]||{},f=n[c.type].marker&&c.options.marker,g=f&&!1===f.enabled,h=f&&f.states&&f.states[a||"normal"]||{},l=!1===h.enabled,p=c.stateMarkerGraphic,u=this.marker||{},t=c.chart,y=c.halo,z,B=f&&c.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===e.enabled||a&&(l||g&&!1===h.enabled)||a&&u.states&&u.states[a]&&!1===u.states[a].enabled)){this.state=a;B&&(z=c.markerAttribs(this,a));if(this.graphic){d&&this.graphic.removeClass("highcharts-point-"+d);a&&this.graphic.addClass("highcharts-point-"+
	a);if(!t.styledMode){var C=c.pointAttribs(this,a);var H=v(t.options.chart.animation,e.animation);c.options.inactiveOtherPoints&&((this.dataLabels||[]).forEach(function(a){a&&a.animate({opacity:C.opacity},H)}),this.connector&&this.connector.animate({opacity:C.opacity},H));this.graphic.animate(C,H)}z&&this.graphic.animate(z,v(t.options.chart.animation,h.animation,f.animation));p&&p.hide()}else{if(a&&h){d=u.symbol||c.symbol;p&&p.currentSymbol!==d&&(p=p.destroy());if(z)if(p)p[b?"animate":"attr"]({x:z.x,
	y:z.y});else d&&(c.stateMarkerGraphic=p=t.renderer.symbol(d,z.x,z.y,z.width,z.height).add(c.markerGroup),p.currentSymbol=d);!t.styledMode&&p&&p.attr(c.pointAttribs(this,a))}p&&(p[a&&this.isInside?"show":"hide"](),p.element.point=this)}a=e.halo;e=(p=this.graphic||p)&&p.visibility||"inherit";a&&a.size&&p&&"hidden"!==e?(y||(c.halo=y=t.renderer.path().add(p.parentGroup)),y.show()[b?"animate":"attr"]({d:this.haloPath(a.size)}),y.attr({"class":"highcharts-halo highcharts-color-"+v(this.colorIndex,c.colorIndex)+
	(this.className?" "+this.className:""),visibility:e,zIndex:-1}),y.point=this,t.styledMode||y.attr(G({fill:this.color||c.color,"fill-opacity":a.opacity},a.attributes))):y&&y.point&&y.point.haloPath&&y.animate({d:y.point.haloPath(0)},null,y.hide);q(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});G(e.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&
	q(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&q(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();b.series.forEach(function(a){a.setState("",!0)})},setState:function(a,b){var c=this,d=c.options,e=c.graph,f=d.inactiveOtherPoints,g=d.states,h=d.lineWidth,l=d.opacity,n=v(g[a||"normal"]&&g[a||"normal"].animation,
	c.chart.options.chart.animation);d=0;a=a||"";if(c.state!==a&&([c.group,c.markerGroup,c.dataLabelsGroup].forEach(function(b){b&&(c.state&&b.removeClass("highcharts-series-"+c.state),a&&b.addClass("highcharts-series-"+a))}),c.state=a,!c.chart.styledMode)){if(g[a]&&!1===g[a].enabled)return;a&&(h=g[a].lineWidth||h+(g[a].lineWidthPlus||0),l=v(g[a].opacity,l));if(e&&!e.dashstyle)for(g={"stroke-width":h},e.animate(g,n);c["zone-graph-"+d];)c["zone-graph-"+d].attr(g),d+=1;f||[c.group,c.markerGroup,c.dataLabelsGroup,
	c.labelBySeries].forEach(function(a){a&&a.animate({opacity:l},n)})}b&&f&&c.points&&c.setAllPointsToState(a)},setAllPointsToState:function(a){this.points.forEach(function(b){b.setState&&b.setState(a)})},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f=d.options.chart.ignoreHiddenSeries,g=c.visible;var h=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!g:a)?"show":"hide";["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(function(a){if(c[a])c[a][h]()});if(d.hoverSeries===
	c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&d.series.forEach(function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});c.linkedSeries.forEach(function(b){b.setVisible(a,!1)});f&&(d.isDirtyBox=!0);q(c,h);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=this.options.selected=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);
	q(this,a?"select":"unselect")},drawTracker:E.drawTrackerGraph})});M(I,"parts/Responsive.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.isArray,G=f.isObject,z=f.objectEach,B=f.pick,t=f.splat;f=c.Chart;f.prototype.setResponsive=function(f,t){var v=this.options.responsive,y=[],h=this.currentResponsive;!t&&v&&v.rules&&v.rules.forEach(function(f){void 0===f._id&&(f._id=c.uniqueKey());this.matchResponsiveRule(f,y)},this);t=c.merge.apply(0,y.map(function(f){return c.find(v.rules,
	function(c){return c._id===f}).chartOptions}));t.isResponsiveOptions=!0;y=y.toString()||void 0;y!==(h&&h.ruleIds)&&(h&&this.update(h.undoOptions,f,!0),y?(h=this.currentOptions(t),h.isResponsiveOptions=!0,this.currentResponsive={ruleIds:y,mergedOptions:t,undoOptions:h},this.update(t,f,!0)):this.currentResponsive=void 0)};f.prototype.matchResponsiveRule=function(c,f){var t=c.condition;(t.callback||function(){return this.chartWidth<=B(t.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=B(t.maxHeight,Number.MAX_VALUE)&&
	this.chartWidth>=B(t.minWidth,0)&&this.chartHeight>=B(t.minHeight,0)}).call(this)&&f.push(c._id)};f.prototype.currentOptions=function(c){function f(c,n,q,g){var b;z(c,function(a,c){if(!g&&-1<v.collectionsWithUpdate.indexOf(c))for(a=t(a),q[c]=[],b=0;b<a.length;b++)n[c][b]&&(q[c][b]={},f(a[b],n[c][b],q[c][b],g+1));else G(a)?(q[c]=F(a)?[]:{},f(a,n[c]||{},q[c],g+1)):q[c]=void 0===n[c]?null:n[c]})}var v=this,y={};f(c,this.options,y,0);return y}});M(I,"masters/highcharts.src.js",[I["parts/Globals.js"],
	I["parts/Utilities.js"]],function(c,f){var F=f.extend;F(c,{arrayMax:f.arrayMax,arrayMin:f.arrayMin,attr:f.attr,defined:f.defined,erase:f.erase,extend:f.extend,isArray:f.isArray,isClass:f.isClass,isDOMElement:f.isDOMElement,isNumber:f.isNumber,isObject:f.isObject,isString:f.isString,objectEach:f.objectEach,pick:f.pick,pInt:f.pInt,setAnimation:f.setAnimation,splat:f.splat,syncTimeout:f.syncTimeout});return c});I["masters/highcharts.src.js"]._modules=I;return I["masters/highcharts.src.js"]});
	//# sourceMappingURL=highcharts.js.map

/***/ },
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 38 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 39 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 40 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 41 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var access_token_api_service_1 = __webpack_require__(43);
	var data_value_api_service_1 = __webpack_require__(44);
	var discharge_model_api_service_1 = __webpack_require__(180);
	var organization_api_service_1 = __webpack_require__(181);
	var station_api_service_1 = __webpack_require__(182);
	var meteostation_api_service_1 = __webpack_require__(183);
	var user_api_service_1 = __webpack_require__(184);
	var curve_settings_api_service_1 = __webpack_require__(185);
	var request_access_api_service_1 = __webpack_require__(186);
	var contact_email_api_service_1 = __webpack_require__(187);
	var cms_api_service_1 = __webpack_require__(188);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.api', [])
	    .constant('backendUrl', ("https://api.ieasyhydro.org"))
	    .service('organizationApi', organization_api_service_1.default)
	    .service('userApi', user_api_service_1.default)
	    .service('stationApi', station_api_service_1.default)
	    .service('meteostationApi', meteostation_api_service_1.default)
	    .service('accessTokenApi', access_token_api_service_1.default)
	    .service('dischargeModelApi', discharge_model_api_service_1.default)
	    .service('dataValueApi', data_value_api_service_1.default)
	    .service('curveSettingsApi', curve_settings_api_service_1.default)
	    .service('contactEmailApi', contact_email_api_service_1.default)
	    .service('requestAccessApi', request_access_api_service_1.default)
	    .service('cmsApi', cms_api_service_1.default)
	    .name;


/***/ },
/* 43 */
/***/ function(module, exports) {

	"use strict";
	var AccessTokenApi = (function () {
	    function AccessTokenApi($http, backendUrl) {
	        this.$http = $http;
	        this.endpoint = backendUrl + "/access_tokens";
	    }
	    AccessTokenApi.prototype.getAwsFormData = function () {
	        return this.$http({
	            url: this.endpoint + "/awsform",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    AccessTokenApi.prototype.getUserToken = function (username, password) {
	        return this.$http({
	            url: this.endpoint,
	            method: 'POST',
	            data: {
	                usernameOrEmail: username,
	                password: password
	            }
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    AccessTokenApi.$inject = ['$http', 'backendUrl'];
	    return AccessTokenApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = AccessTokenApi;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var DataValueApi = (function () {
	    function DataValueApi(backendUrl, $http) {
	        this.$http = $http;
	        this.endpoint = backendUrl + "/data_values";
	    }
	    DataValueApi.prototype.getDischargePairs = function (stationId, year) {
	        return this.$http({
	            url: this.endpoint + "/discharge",
	            method: 'GET',
	            params: {
	                year: year,
	                hydroYear: false,
	                siteId: stationId
	            }
	        }).then(function (httpData) { return httpData.data.resources; });
	    };
	    DataValueApi.prototype.getMaximumDischarge = function (stationId) {
	        return this.$http({
	            url: this.endpoint + "/safe_discharge",
	            method: 'GET',
	            params: {
	                siteId: stationId
	            }
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    DataValueApi.prototype.getYearDailyAverageData = function (stationId, year, dataType) {
	        return this.$http({
	            url: this.endpoint + "/year_average_data",
	            method: 'GET',
	            params: {
	                year: year,
	                hydroYear: false,
	                siteId: stationId,
	                dataType: dataType
	            }
	        }).then(function (httpData) { return httpData.data.resources; });
	    };
	    DataValueApi.prototype.getDailyData = function (stationId, startDate, endDate) {
	        return this.$http({
	            url: this.endpoint + "/daily_data",
	            method: 'GET',
	            params: {
	                siteId: stationId,
	                startDate: startDate.format(),
	                endDate: endDate.format()
	            }
	        }).then(function (httpData) { return httpData.data.resources; });
	    };
	    DataValueApi.prototype.editDailyData = function (stationId, date, waterLevelMorning, waterLevelEvening, waterLevelAverage) {
	        return this.$http({
	            url: this.endpoint + "/daily_data",
	            method: 'PUT',
	            data: {
	                siteId: stationId,
	                date: date,
	                waterLevelMorning: waterLevelMorning,
	                waterLevelEvening: waterLevelEvening,
	                waterLevelAverage: waterLevelAverage,
	                sourceId: 1
	            }
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    DataValueApi.prototype.storeDailyData = function (_a) {
	        var dischargeData = _a.dischargeData, meteoData = _a.meteoData;
	        var dischargeModel = dischargeData && dischargeData.dischargeModelParams && dischargeData.dischargeModelParams.createdDischargeModel
	            ? dischargeData.dischargeModelParams.dischargeModel
	            : null;
	        if (dischargeModel) {
	            dischargeModel = angular.copy(dischargeModel);
	            dischargeModel.validFrom = moment.unix(dischargeModel.validFrom);
	        }
	        return this.$http({
	            url: this.endpoint + "/daily_data_new",
	            method: 'POST',
	            data: {
	                dischargeData: dischargeData,
	                meteoData: meteoData
	            }
	        }).then(function (httpData) { return console.log(); });
	    };
	    DataValueApi.prototype.checkDailyData = function (_a) {
	        var dischargeData = _a.dischargeData, meteoData = _a.meteoData;
	        var dischargeModel = dischargeData && dischargeData.dischargeModelParams && dischargeData.dischargeModelParams.createdDischargeModel
	            ? dischargeData.dischargeModelParams.dischargeModel
	            : null;
	        if (dischargeModel) {
	            dischargeModel = angular.copy(dischargeModel);
	            dischargeModel.validFrom = moment.unix(dischargeModel.validFrom);
	        }
	        return this.$http({
	            url: this.endpoint + "/check_daily_data_new",
	            method: 'POST',
	            data: {
	                dischargeData: dischargeData,
	                meteoData: meteoData
	            }
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    DataValueApi.prototype.getJournalData = function (month, year, stationIds) {
	        return this.$http({
	            url: this.endpoint + "/journal",
	            method: 'GET',
	            params: {
	                month: month + 1,
	                year: year,
	                siteIds: stationIds
	            }
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    DataValueApi.prototype.editDischargeData = function (stationId, waterLevel, discharge, freeRiverArea) {
	        return this.$http({
	            url: this.endpoint + "/discharge_data",
	            method: 'PUT',
	            data: {
	                waterLevel: waterLevel, discharge: discharge, freeRiverArea: freeRiverArea
	            }
	        }).then(function () {
	        });
	    };
	    DataValueApi.prototype.editMeteoDecadalData = function (stationId, year, month, decadeInMonth, temperature, precipitation) {
	        return this.$http({
	            url: this.endpoint + "/edit_meteo_site_data_value",
	            method: 'POST',
	            data: {
	                siteId: stationId,
	                year: year,
	                month: month,
	                decadeInMonth: decadeInMonth,
	                temperature: temperature,
	                precipitation: precipitation
	            }
	        }).then(function () { });
	    };
	    DataValueApi.prototype.deleteDischargeData = function (stationId, waterLevelId, dischargeId) {
	        return this.$http({
	            url: this.endpoint + "/discharge_data",
	            method: 'DELETE',
	            params: {
	                siteId: stationId,
	                waterLevelId: waterLevelId, dischargeId: dischargeId
	            }
	        }).then(function () {
	        });
	    };
	    DataValueApi.prototype.getBulletin = function (stationIds, date) {
	        return this.$http({
	            url: this.endpoint + "/bulletin",
	            method: 'GET',
	            params: {
	                siteIds: stationIds,
	                year: date.year(),
	                month: date.month() + 1,
	                day: date.date()
	            }
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    DataValueApi.prototype.getStationNorm = function (stationId, dataType) {
	        return this.$http({
	            url: this.endpoint + "/norm",
	            method: 'GET',
	            params: {
	                siteId: stationId,
	                dataType: dataType
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    DataValueApi.prototype.getBulkData = function (stationIds) {
	        return this.$http({
	            url: this.endpoint + "/bulk_download",
	            method: 'POST',
	            data: {
	                siteIds: stationIds
	            }
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    DataValueApi.$inject = ['backendUrl', '$http'];
	    return DataValueApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DataValueApi;


/***/ },
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ function(module, exports) {

	"use strict";
	var DischargeModelApi = (function () {
	    function DischargeModelApi(backendUrl, $http) {
	        this.$http = $http;
	        this.endpoint = backendUrl + "/discharge_models";
	    }
	    DischargeModelApi.prototype.createDischargeModel = function (dischargeModelRequest) {
	        return this.$http({
	            url: this.endpoint,
	            method: 'POST',
	            data: dischargeModelRequest
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    DischargeModelApi.prototype.getDischargeModels = function (stationId, year) {
	        return this.$http({
	            url: this.endpoint,
	            method: 'GET',
	            params: {
	                year: year,
	                hydroYear: false,
	                siteId: stationId
	            }
	        }).then(function (httpData) { return httpData.data.resources; });
	    };
	    DischargeModelApi.prototype.deleteDischargeModel = function (dischargeModelId) {
	        return this.$http({
	            url: this.endpoint + "/" + dischargeModelId,
	            method: 'DELETE'
	        }).then(function (httpData) {
	        });
	    };
	    DischargeModelApi.$inject = ['backendUrl', '$http'];
	    return DischargeModelApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DischargeModelApi;


/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	var OrganizationApi = (function () {
	    function OrganizationApi($http, backendUrl) {
	        this.$http = $http;
	        this.backendUrl = backendUrl;
	        this.endpoint = backendUrl + "/organizations";
	        this.organizationReportsEndpoint = backendUrl + "/reports";
	    }
	    OrganizationApi.prototype.getOrganizations = function () {
	        return this.$http({
	            url: this.endpoint,
	            method: 'GET'
	        }).then(function (httpRes) { return httpRes.data.resources; });
	    };
	    OrganizationApi.prototype.getOrganization = function (id) {
	        return this.$http({
	            url: (this.endpoint + "/") + id,
	            method: 'GET'
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    OrganizationApi.prototype.deleteOrganization = function (id) {
	        return this.$http({
	            url: (this.endpoint + "/") + id,
	            method: 'DELETE'
	        }).then(function (data) {
	        });
	    };
	    OrganizationApi.prototype.saveOrganization = function (organization) {
	        return this.$http({
	            url: ("" + this.endpoint) + (organization.id ? "/" + organization.id : ''),
	            method: organization.id ? 'PUT' : 'POST',
	            data: organization
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    OrganizationApi.prototype.createForecastType = function (orgId, forecastType) {
	        return this.$http({
	            url: this.endpoint + "/" + orgId + "/forecast_types",
	            method: 'POST',
	            data: forecastType
	        }).then(function (httpData) {
	        });
	    };
	    OrganizationApi.prototype.updateForecastType = function (orgId, forecastType) {
	        return this.$http({
	            url: this.endpoint + "/" + orgId + "/forecast_types/" + forecastType.id,
	            method: 'PUT',
	            data: forecastType
	        }).then(function (httpData) {
	        });
	    };
	    OrganizationApi.prototype.deleteForecastType = function (orgId, forecastType) {
	        return this.$http({
	            url: this.endpoint + "/" + orgId + "/forecast_types/" + forecastType.id,
	            method: 'DELETE',
	            data: forecastType
	        }).then(function (httpData) {
	        });
	    };
	    OrganizationApi.prototype.getForecastTypes = function (orgId) {
	        return this.$http({
	            url: this.endpoint + "/" + orgId + "/forecast_types",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    OrganizationApi.prototype.generateForecastBulletin = function (id, siteIds) {
	        return this.$http({
	            url: this.endpoint + "/" + id + "/forecast_bulletin",
	            method: 'POST',
	            data: {
	                date: new Date(),
	                siteIds: siteIds
	            }
	        }).then(function (httpData) { return httpData.data.resources[0].url; });
	    };
	    OrganizationApi.prototype.getReportingTemplateTags = function (reportType) {
	        return this.$http({
	            url: this.organizationReportsEndpoint + "/" + reportType + "/template_tags",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    OrganizationApi.prototype.saveReportingTemplate = function (reportType, data) {
	        return this.$http({
	            url: this.organizationReportsEndpoint + "/" + reportType + "/template",
	            method: 'POST',
	            data: data
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    OrganizationApi.prototype.deleteReportingTemplate = function (reportType) {
	        return this.$http({
	            url: this.organizationReportsEndpoint + "/" + reportType + "/template",
	            method: 'DELETE'
	        }).then(function (httpData) {
	        });
	    };
	    OrganizationApi.prototype.getReportingTemplateDefault = function (reportType) {
	        return this.$http({
	            url: this.organizationReportsEndpoint + "/" + reportType + "/template/default",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0].url;
	        });
	    };
	    OrganizationApi.prototype.getReportingTemplate = function (reportType) {
	        return this.$http({
	            url: this.organizationReportsEndpoint + "/" + reportType + "/template",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    OrganizationApi.prototype.renewPayment = function (id) {
	        return this.$http({
	            url: (this.endpoint + "/") + id + '/renew',
	            method: 'POST'
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    OrganizationApi.prototype.generateBulletin = function (reportType, stationIds, date) {
	        return this.$http({
	            url: this.organizationReportsEndpoint + "/" + reportType + "/generate",
	            method: 'POST',
	            data: {
	                date: date,
	                siteIds: stationIds
	            }
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    OrganizationApi.prototype.saveDecadalBulletinSettings = function (settings) {
	        return this.$http({
	            url: this.organizationReportsEndpoint + "/decadal_bulletin/schedule",
	            method: 'POST',
	            data: settings
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    OrganizationApi.prototype.deleteDecadalBulletinSettings = function () {
	        return this.$http({
	            url: this.organizationReportsEndpoint + "/decadal_bulletin/schedule",
	            method: 'DELETE'
	        }).then(function (httpData) {
	        });
	    };
	    OrganizationApi.prototype.getDecadalBulletinSettings = function () {
	        return this.$http({
	            url: this.organizationReportsEndpoint + "/decadal_bulletin/schedule",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    OrganizationApi.$inject = ['$http', 'backendUrl'];
	    return OrganizationApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OrganizationApi;


/***/ },
/* 182 */
/***/ function(module, exports) {

	"use strict";
	var StationApi = (function () {
	    function StationApi($http, $q, backendUrl) {
	        this.$http = $http;
	        this.$q = $q;
	        this.backendUrl = backendUrl;
	        this.dischargeSitesEndpoint = this.backendUrl + "/discharge_sites";
	        this.meteoSitesEndpoint = this.backendUrl + "/meteo_sites";
	    }
	    StationApi.prototype.createDischargeStation = function (stationDetailsRequest, dischargeModelRequest, historicalDataFile, maxDischarge) {
	        var _this = this;
	        var deferred = this.$q.defer();
	        var reader = new FileReader();
	        // Check if historicalDataFile is defined
	        if (historicalDataFile) {
	            reader.onload = function () {
	                var arrayBuffer = reader.result;
	                var fileContent = new Uint8Array(arrayBuffer);
	                _this.$http({
	                    url: _this.dischargeSitesEndpoint,
	                    method: 'POST',
	                    data: {
	                        siteDetails: stationDetailsRequest,
	                        dischargeModel: dischargeModelRequest,
	                        historicalDataFileContent: fileContent,
	                        maxDischarge: maxDischarge
	                    }
	                }).then(function (httpData) {
	                    return httpData.data.resources[0];
	                }).then(function (response) {
	                    deferred.resolve(response);
	                });
	            };
	            reader.onerror = function (error) {
	                deferred.reject(error); // Reject the deferred if there's an error reading the file
	            };
	            reader.readAsArrayBuffer(historicalDataFile);
	        }
	        else {
	            // If historicalDataFile is undefined, proceed without attaching file content
	            this.$http({
	                url: this.dischargeSitesEndpoint,
	                method: 'POST',
	                data: {
	                    siteDetails: stationDetailsRequest,
	                    dischargeModel: dischargeModelRequest,
	                    maxDischarge: maxDischarge
	                }
	            }).then(function (httpData) {
	                return httpData.data.resources[0];
	            }).then(function (response) {
	                deferred.resolve(response);
	            });
	        }
	        return deferred.promise;
	    };
	    StationApi.prototype.deleteDischargeStation = function (stationId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId,
	            method: 'DELETE'
	        }).then(function (httpData) {
	        });
	    };
	    StationApi.prototype.createMeteoStation = function (stationDetailsRequest, historicalDataFile) {
	        var _this = this;
	        var deferred = this.$q.defer();
	        var reader = new FileReader();
	        // Check if historicalDataFile is defined
	        if (historicalDataFile) {
	            reader.onload = function () {
	                var arrayBuffer = reader.result;
	                var fileContent = new Uint8Array(arrayBuffer);
	                _this.$http({
	                    url: _this.meteoSitesEndpoint,
	                    method: 'POST',
	                    data: {
	                        siteDetails: stationDetailsRequest,
	                        historicalDataFileContent: fileContent
	                    }
	                }).then(function (httpData) {
	                    return httpData.data;
	                }).then(function (response) {
	                    deferred.resolve(response);
	                });
	            };
	            reader.onerror = function (error) {
	                deferred.reject(error); // Reject the deferred if there's an error reading the file
	            };
	            reader.readAsArrayBuffer(historicalDataFile);
	        }
	        else {
	            // If historicalDataFile is undefined, proceed without attaching file content
	            this.$http({
	                url: this.meteoSitesEndpoint,
	                method: 'POST',
	                data: {
	                    siteDetails: stationDetailsRequest
	                }
	            }).then(function (httpData) {
	                return httpData.data;
	            }).then(function (response) {
	                deferred.resolve(response);
	            });
	        }
	        return deferred.promise;
	    };
	    StationApi.prototype.deleteMeteoStation = function (stationId) {
	        return this.$http({
	            url: this.meteoSitesEndpoint + "/" + stationId,
	            method: 'DELETE'
	        }).then(function (httpData) {
	        });
	    };
	    StationApi.prototype.getDischargeStationsWithForecast = function () {
	        return this.$http({
	            url: this.dischargeSitesEndpoint,
	            method: 'GET',
	            params: {
	                hasForecastResult: true
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.getDischargeStationsWithAcceptedForecast = function () {
	        return this.$http({
	            url: this.dischargeSitesEndpoint,
	            method: 'GET',
	            params: {
	                hasAcceptedForecastResult: true
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.searchDischargeStations = function (searchText) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint,
	            method: 'GET',
	            params: {
	                search: searchText
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.searchMeteoStations = function (searchText) {
	        return this.$http({
	            url: this.meteoSitesEndpoint,
	            method: 'GET',
	            params: {
	                search: searchText
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.getDischargeStations = function () {
	        return this.$http({
	            url: this.dischargeSitesEndpoint,
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.getPaginatedDischargeStations = function (pageSize, offset, orderBy) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint,
	            method: 'GET',
	            params: {
	                paginate: true,
	                page_size: pageSize,
	                offset: offset,
	                order_by: orderBy
	            }
	        }).then(function (httpData) {
	            return httpData.data;
	        });
	    };
	    StationApi.prototype.getMeteoStations = function () {
	        return this.$http({
	            url: this.meteoSitesEndpoint,
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.getPaginatedMeteoStations = function (pageSize, offset, orderBy) {
	        return this.$http({
	            url: this.meteoSitesEndpoint,
	            method: 'GET',
	            params: {
	                paginate: true,
	                page_size: pageSize,
	                offset: offset,
	                order_by: orderBy
	            }
	        }).then(function (httpData) {
	            return httpData.data;
	        });
	    };
	    StationApi.prototype.getDischargeStationsWithTelegramByDate = function (date, hasTelegram) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/check_telegram",
	            method: 'GET',
	            params: {
	                date: date.format(),
	                hasTelegram: hasTelegram
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.getMeteoStationsWithTelegramByDate = function (date, hasTelegram) {
	        return this.$http({
	            url: this.meteoSitesEndpoint + "/check_telegram",
	            method: 'GET',
	            params: {
	                date: date.format(),
	                hasTelegram: hasTelegram
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.getDischargeStation = function (_a) {
	        var stationCode = _a.stationCode, stationId = _a.stationId;
	        var promise;
	        if (stationCode) {
	            promise = this.$http({
	                url: this.dischargeSitesEndpoint,
	                method: 'GET',
	                params: {
	                    siteCode: stationCode
	                }
	            });
	        }
	        else if (stationId) {
	            promise = this.$http({
	                url: this.dischargeSitesEndpoint + "/" + stationId,
	                method: 'GET'
	            });
	        }
	        return promise.then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.getMeteoStation = function (_a) {
	        var stationCode = _a.stationCode, stationId = _a.stationId;
	        var promise;
	        if (stationCode) {
	            promise = this.$http({
	                url: this.meteoSitesEndpoint,
	                method: 'GET',
	                params: {
	                    siteCode: stationCode
	                }
	            });
	        }
	        else if (stationId) {
	            promise = this.$http({
	                url: this.meteoSitesEndpoint + "/" + stationId,
	                method: 'GET'
	            });
	        }
	        return promise.then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.isDischargeStationCodeUnique = function (stationCode, isVirtual) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/check",
	            method: 'POST',
	            data: {
	                siteCode: stationCode,
	                isVirtual: isVirtual
	            }
	        }).then(function (httpData) {
	            return httpData.data;
	        }).catch(function (errData) {
	            return errData;
	        });
	    };
	    StationApi.prototype.isMeteoStationCodeUnique = function (stationCode) {
	        return this.$http({
	            url: this.meteoSitesEndpoint + "/check",
	            method: 'POST',
	            data: {
	                siteCode: stationCode
	            }
	        }).then(function (httpData) {
	            return httpData.data;
	        }).catch(function (errData) {
	            return errData;
	        });
	    };
	    StationApi.prototype.getStationHistoricDischargeDataXLSX = function (stationId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/historic_data_file",
	            method: 'GET'
	        }).then(function (response) {
	            var byteArray = new Uint8Array(response.data.fileContent);
	            var filename = response.data.filename;
	            var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
	            // Create a link element and click it to trigger the download
	            var downloadLink = document.createElement('a');
	            downloadLink.href = window.URL.createObjectURL(blob);
	            downloadLink.download = filename;
	            downloadLink.click();
	        }, function (error) {
	            // Handle error
	            console.error('Error downloading Excel file:', error);
	        });
	    };
	    StationApi.prototype.getStationHistoricMeteoDataXLSX = function (stationId) {
	        return this.$http({
	            url: this.meteoSitesEndpoint + "/" + stationId + "/historic_data_file",
	            method: 'GET'
	        }).then(function (response) {
	            var byteArray = new Uint8Array(response.data.fileContent);
	            var filename = response.data.filename;
	            var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
	            // Create a link element and click it to trigger the download
	            var downloadLink = document.createElement('a');
	            downloadLink.href = window.URL.createObjectURL(blob);
	            downloadLink.download = filename;
	            downloadLink.click();
	        }, function (error) {
	            // Handle error
	            console.error('Error downloading Excel file:', error);
	        });
	    };
	    StationApi.prototype.getStationHistoricMeteoDataUrl = function (stationId) {
	        return this.$http({
	            url: this.meteoSitesEndpoint + "/" + stationId + "/historic_data_file",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0].url;
	        });
	    };
	    StationApi.prototype.getForecast = function (stationId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/forecast",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.postFileContent = function (file, url) {
	        var _this = this;
	        var deferred = this.$q.defer();
	        var reader = new FileReader();
	        reader.onload = function () {
	            var arrayBuffer = reader.result;
	            var fileContent = new Uint8Array(arrayBuffer);
	            _this.$http({
	                url: url,
	                method: 'POST',
	                data: {
	                    fileContent: fileContent
	                }
	            }).then(function () {
	                deferred.resolve(); // Resolve the deferred when upload is successful
	            }).catch(function (error) {
	                deferred.reject(error); // Reject the deferred if there's an error during HTTP request
	            });
	        };
	        reader.onerror = function (error) {
	            deferred.reject(error); // Reject the deferred if there's an error reading the file
	        };
	        reader.readAsArrayBuffer(file);
	        return deferred.promise;
	    };
	    StationApi.prototype.uploadHistoricDischargeData = function (stationId, file) {
	        return this.postFileContent(file, this.dischargeSitesEndpoint + "/" + stationId + "/historic_data_file");
	    };
	    StationApi.prototype.uploadHistoricMeteoData = function (stationId, file) {
	        return this.postFileContent(file, this.meteoSitesEndpoint + "/" + stationId + "/historic_data_file");
	    };
	    StationApi.prototype.validateDischargeData = function (file) {
	        return this.postFileContent(file, this.dischargeSitesEndpoint + "/validate_historic_data_file");
	    };
	    StationApi.prototype.validateMeteoData = function (file) {
	        return this.postFileContent(file, this.meteoSitesEndpoint + "/validate_historic_data_file");
	    };
	    StationApi.prototype.updateDischargeStation = function (stationId, stationUpdateDetailsRequest, maxDischarge) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId,
	            method: 'PUT',
	            data: {
	                siteDetails: stationUpdateDetailsRequest,
	                maxDischarge: maxDischarge
	            }
	        }).then(function () {
	        });
	    };
	    StationApi.prototype.updateMeteoStation = function (stationId, stationUpdateDetailsRequest) {
	        return this.$http({
	            url: this.meteoSitesEndpoint + "/" + stationId,
	            method: 'PUT',
	            data: {
	                siteDetails: stationUpdateDetailsRequest
	            }
	        }).then(function () {
	        });
	    };
	    StationApi.prototype.saveForecastModel = function (stationId, forecastModel) {
	        return this.$http({
	            url: (this.dischargeSitesEndpoint + "/" + stationId + "/forecast_models") + (forecastModel.id || forecastModel.id === 0 ? "/" + forecastModel.id : ''),
	            method: forecastModel.id || forecastModel.id === 0 ? 'PUT' : 'POST',
	            data: forecastModel
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.getForecastModels = function (stationId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/forecast_models",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    StationApi.prototype.getForecastModel = function (stationId, forecastModelId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/forecast_models/" + forecastModelId,
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.deleteForecastModel = function (stationId, forecastModelId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/forecast_models/" + forecastModelId,
	            method: 'DELETE'
	        }).then(function (httpData) {
	        });
	    };
	    StationApi.prototype.trainForecastModel = function (stationId, forecastModelId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/forecast_models/" + forecastModelId + "/train",
	            method: 'POST',
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.makeForecastPrediction = function (stationId, forecastModelId, date) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/forecast_models/" + forecastModelId + "/predict",
	            method: 'POST',
	            data: {
	                date: date
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.cancelForecastModelTraining = function (stationId, forecastModelId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/forecast_models/" + forecastModelId + "/cancel",
	            method: 'POST',
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.acceptForecast = function (stationId, forecastId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/forecasts/" + forecastId + "/accept",
	            method: 'POST',
	        }).then(function (httpData) {
	        });
	    };
	    StationApi.prototype.getForecasts = function (stationId, frequency, date, previous) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/forecasts",
	            method: 'GET',
	            params: {
	                date: date,
	                frequency: frequency,
	                previous: previous
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources[0].frequencies;
	        });
	    };
	    StationApi.prototype.uploadSnowData = function (stationId, geojson) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/catchment_area",
	            method: 'POST',
	            data: {
	                geojson: geojson,
	            }
	        }).then(function () {
	        });
	    };
	    StationApi.prototype.deleteCatchmentArea = function (stationId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/catchment_area",
	            method: 'DELETE'
	        }).then(function () {
	        });
	    };
	    StationApi.prototype.getSnowData = function (stationId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/snow_data",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.getSnowDataFile = function (stationId, year) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/snow_data_file",
	            method: 'GET',
	            params: {
	                year: year
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.getCatchmentAreaGeojson = function (stationId, inResponse) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/catchment_area_geojson",
	            method: 'GET',
	            params: {
	                in_response: inResponse
	            }
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.getSnowCoverGeotiff = function (stationId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/snow_cover_geotiff",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources && httpData.data.resources[0];
	        });
	    };
	    StationApi.prototype.getSnowDataNorm = function (stationId) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/snow_data_norm",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0].resources[0];
	        });
	    };
	    StationApi.prototype.createManualForecast = function (stationId, forecastResult) {
	        return this.$http({
	            url: this.dischargeSitesEndpoint + "/" + stationId + "/manual_forecast",
	            method: 'POST',
	            data: {
	                forecastResult: forecastResult,
	            }
	        }).then(function () {
	        });
	    };
	    StationApi.$inject = ['$http', '$q', 'backendUrl'];
	    return StationApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationApi;


/***/ },
/* 183 */
/***/ function(module, exports) {

	"use strict";
	var MeteostationApi = (function () {
	    function MeteostationApi($http, $q, backendUrl) {
	        this.$http = $http;
	        this.$q = $q;
	        this.backendUrl = backendUrl;
	        this.endpoint = this.backendUrl + "/sites";
	    }
	    MeteostationApi.prototype.createStation = function (stationDetailsRequest, historicalDataFilename) {
	        return this.$http({
	            url: this.endpoint + "/new",
	            method: 'POST',
	            data: {
	                siteDetails: stationDetailsRequest,
	                historicalDataFilename: historicalDataFilename
	            }
	        }).then(function (httpData) {
	        });
	    };
	    MeteostationApi.prototype.getStations = function () {
	        return this.$http({
	            url: this.endpoint,
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    MeteostationApi.prototype.getStation = function (_a) {
	        var stationCode = _a.stationCode, stationId = _a.stationId;
	        var promise;
	        if (stationCode) {
	            promise = this.$http({
	                url: this.endpoint,
	                method: 'GET',
	                params: {
	                    siteCode: stationCode,
	                    ready: false
	                }
	            });
	        }
	        else if (stationId) {
	            promise = this.$http({
	                url: this.endpoint + "/" + stationId,
	                method: 'GET',
	            });
	        }
	        return promise.then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    MeteostationApi.prototype.isStationCodeUnique = function (stationCode) {
	        var deferred = this.$q.defer();
	        this.$http({
	            url: this.endpoint,
	            method: 'GET',
	            params: {
	                siteCode: stationCode,
	                ready: false
	            }
	        }).then(function () {
	            deferred.reject();
	        }).catch(function () {
	            deferred.resolve();
	        });
	        return deferred.promise;
	    };
	    MeteostationApi.prototype.getStationPrecipitationNorm = function (stationId) {
	        return this.$http({
	            url: this.endpoint + "/" + stationId + "/precipitation_norm",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    MeteostationApi.prototype.getStationHistoricPrecipitationDataUrl = function (stationId) {
	        return this.$http({
	            url: this.endpoint + "/" + stationId + "/average_historic_precipitation",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0].url;
	        });
	    };
	    MeteostationApi.prototype.uploadHistoricPrecipitationData = function (stationId, filename) {
	        return this.$http({
	            url: this.endpoint + "/" + stationId + "/average_historic_precipitation",
	            method: 'POST',
	            data: {
	                filename: filename
	            }
	        }).then(function (httpData) {
	        });
	    };
	    MeteostationApi.prototype.getStationTemperatureNorm = function (stationId) {
	        return this.$http({
	            url: this.endpoint + "/" + stationId + "/temperature_norm",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0];
	        });
	    };
	    MeteostationApi.prototype.getStationHistoricTemperatureDataUrl = function (stationId) {
	        return this.$http({
	            url: this.endpoint + "/" + stationId + "/average_historic_temperature",
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources[0].url;
	        });
	    };
	    MeteostationApi.prototype.uploadHistoricTemperatureData = function (stationId, filename) {
	        return this.$http({
	            url: this.endpoint + "/" + stationId + "/average_historic_temperature",
	            method: 'POST',
	            data: {
	                filename: filename
	            }
	        }).then(function (httpData) {
	        });
	    };
	    MeteostationApi.prototype.validatePrecipitationData = function (filename) {
	        return this.$http({
	            url: this.endpoint + "/average_historic_precipitation",
	            method: 'GET',
	            params: {
	                validate: true,
	                filename: filename
	            }
	        }).then(function () {
	        });
	    };
	    MeteostationApi.prototype.validateTemperatureData = function (filename) {
	        return this.$http({
	            url: this.endpoint + "/average_historic_temperature",
	            method: 'GET',
	            params: {
	                validate: true,
	                filename: filename
	            }
	        }).then(function () {
	        });
	    };
	    MeteostationApi.prototype.updateStation = function (stationId, stationUpdateDetailsRequest) {
	        return this.$http({
	            url: this.endpoint + "/" + stationId,
	            method: 'PUT',
	            data: stationUpdateDetailsRequest
	        }).then(function () {
	        });
	    };
	    MeteostationApi.$inject = ['$http', '$q', 'backendUrl'];
	    return MeteostationApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = MeteostationApi;


/***/ },
/* 184 */
/***/ function(module, exports) {

	"use strict";
	var UserApi = (function () {
	    function UserApi($http, backendUrl) {
	        this.$http = $http;
	        this.backendUrl = backendUrl;
	        this.usersEndpoint = backendUrl + "/users";
	    }
	    UserApi.prototype.getCurrentUser = function () {
	        return this.$http({
	            url: this.usersEndpoint + "/me",
	            method: 'GET'
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    UserApi.prototype.getUser = function (id) {
	        return this.$http({
	            url: (this.usersEndpoint + "/") + id,
	            method: 'GET'
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    UserApi.prototype.deleteUser = function (id) {
	        return this.$http({
	            url: (this.usersEndpoint + "/") + id,
	            method: 'DELETE'
	        }).then(function (data) {
	        });
	    };
	    UserApi.prototype.getUserList = function () {
	        return this.$http({
	            url: "" + this.usersEndpoint,
	            method: 'GET'
	        }).then(function (httpData) { return httpData.data.resources; });
	    };
	    UserApi.prototype.saveUser = function (user) {
	        return this.$http({
	            url: ("" + this.usersEndpoint) + (user.id || user.id === 0 ? "/" + user.id : ''),
	            method: user.id || user.id === 0 ? 'PUT' : 'POST',
	            data: user
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    UserApi.prototype.requestResetPassword = function (data) {
	        return this.$http({
	            url: this.usersEndpoint + "/request_reset_password",
	            method: 'POST',
	            data: data
	        }).then(function (data) {
	        });
	    };
	    UserApi.prototype.resetPassword = function (data) {
	        return this.$http({
	            url: this.usersEndpoint + "/reset_password",
	            method: 'POST',
	            data: data
	        }).then(function (data) {
	        });
	    };
	    UserApi.prototype.changePassword = function (data) {
	        return this.$http({
	            url: this.usersEndpoint + "/change_password",
	            method: 'POST',
	            data: data
	        }).then(function (data) {
	        });
	    };
	    UserApi.prototype.sendInvitation = function (data) {
	        return this.$http({
	            url: this.usersEndpoint + "/invitations",
	            method: 'POST',
	            data: data
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    UserApi.prototype.getInvitationDetails = function (uuid) {
	        return this.$http({
	            url: this.usersEndpoint + "/invitations/" + uuid,
	            method: 'GET'
	        }).then(function (httpData) { return httpData.data.resources[0]; });
	    };
	    UserApi.prototype.createUserFromInvitation = function (data, uuid) {
	        return this.$http({
	            url: this.usersEndpoint + "/invitations/" + uuid + "/register",
	            method: 'POST',
	            data: data
	        }).then(function (data) {
	        });
	    };
	    UserApi.$inject = ['$http', 'backendUrl'];
	    return UserApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = UserApi;


/***/ },
/* 185 */
/***/ function(module, exports) {

	"use strict";
	var CurveSettingsApi = (function () {
	    function CurveSettingsApi(backendUrl, $http) {
	        this.$http = $http;
	        this.endpoint = backendUrl + "/discharge_curve_settings";
	    }
	    CurveSettingsApi.prototype.createCurveSettings = function (curveSettings, siteId) {
	        return this.$http({
	            url: this.endpoint,
	            method: 'POST',
	            data: {
	                minWaterLevel: curveSettings.minWaterLevel,
	                maxWaterLevel: curveSettings.maxWaterLevel,
	                minDischarge: curveSettings.minDischarge,
	                maxDischarge: curveSettings.maxDischarge,
	                fitViewportToData: curveSettings.fitViewportToData,
	                siteId: siteId
	            }
	        }).then(function (httpData) {
	        });
	    };
	    CurveSettingsApi.prototype.getCurveSettings = function (siteId) {
	        return this.$http({
	            url: this.endpoint,
	            method: 'GET',
	            params: {
	                siteId: siteId
	            }
	        }).then(function (httpData) { return httpData.data.resources; });
	    };
	    CurveSettingsApi.$inject = ['backendUrl', '$http'];
	    return CurveSettingsApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = CurveSettingsApi;


/***/ },
/* 186 */
/***/ function(module, exports) {

	"use strict";
	var RequestAccessApi = (function () {
	    function RequestAccessApi(backendUrl, $http) {
	        this.$http = $http;
	        this.endpoint = backendUrl + "/users/request_access";
	    }
	    RequestAccessApi.prototype.sendAccessData = function (newUserData) {
	        return this.$http({
	            url: this.endpoint,
	            method: 'POST',
	            data: newUserData
	        }).then(function (httpData) {
	        });
	    };
	    RequestAccessApi.$inject = ['backendUrl', '$http'];
	    return RequestAccessApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = RequestAccessApi;


/***/ },
/* 187 */
/***/ function(module, exports) {

	"use strict";
	var ContactEmailApi = (function () {
	    function ContactEmailApi(backendUrl, $http) {
	        this.$http = $http;
	        this.endpoint = backendUrl + "/email";
	    }
	    ContactEmailApi.prototype.sendContactEmail = function (contactFormData) {
	        return this.$http({
	            url: this.endpoint,
	            method: 'POST',
	            data: contactFormData
	        }).then(function (httpData) {
	        });
	    };
	    ContactEmailApi.$inject = ['backendUrl', '$http'];
	    return ContactEmailApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ContactEmailApi;


/***/ },
/* 188 */
/***/ function(module, exports) {

	"use strict";
	var CmsApi = (function () {
	    function CmsApi($http, backendUrl) {
	        this.$http = $http;
	        this.backendUrl = backendUrl;
	        this.cmsEndpoint = this.backendUrl + "/content";
	    }
	    CmsApi.prototype.getCmsContent = function (name) {
	        return this.$http({
	            url: this.cmsEndpoint + "/" + name,
	            method: 'GET'
	        }).then(function (httpData) {
	            return httpData.data.resources;
	        });
	    };
	    CmsApi.prototype.saveCmsContent = function (name, content) {
	        return this.$http({
	            url: this.cmsEndpoint + "/" + name,
	            method: 'POST',
	            data: content
	        }).then(function (httpData) {
	            return httpData.data;
	        }).catch(function (errData) {
	            return errData;
	        });
	    };
	    CmsApi.$inject = ['$http', 'backendUrl'];
	    return CmsApi;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = CmsApi;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var token_storage_service_1 = __webpack_require__(190);
	var interceptor_module_1 = __webpack_require__(191);
	var login_service_1 = __webpack_require__(194);
	var auth_guard_1 = __webpack_require__(198);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.auth', [interceptor_module_1.default])
	    .service('loginService', login_service_1.default)
	    .service('tokenStorageService', token_storage_service_1.default)
	    .run(auth_guard_1.AuthGuard.configureEnterGuard)
	    .name;


/***/ },
/* 190 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Default implementation of the token storage service.
	 */
	var TokenStorageService = (function () {
	    function TokenStorageService($window, $log) {
	        var _this = this;
	        this.$window = $window;
	        this.$log = $log;
	        try {
	            this.$window.localStorage.getItem(TokenStorageService.STORAGE_KEY);
	            this.enabledLocalStorage = true;
	        }
	        catch (error) {
	            $log.error('Local storage is not enabled.', error);
	            this.enabledLocalStorage = false;
	        }
	        this.loadToken();
	        $window.addEventListener('storage', function (storageEvent) {
	            _this.onStorageEvent(storageEvent);
	        });
	    }
	    TokenStorageService.prototype.getToken = function () {
	        return this.accessToken;
	    };
	    TokenStorageService.prototype.setToken = function (token) {
	        this.accessToken = token;
	        this.$window.localStorage.setItem(TokenStorageService.STORAGE_KEY, JSON.stringify(this.accessToken));
	    };
	    TokenStorageService.prototype.clearToken = function () {
	        this.accessToken = null;
	        this.$window.localStorage
	            .removeItem(TokenStorageService.STORAGE_KEY);
	    };
	    TokenStorageService.prototype.verifyToken = function () {
	        // TODO: Implement
	        return this.getToken() != null;
	    };
	    /**
	     * When the local storage changes, load the token if the value under
	     * the access token storage key changed.
	     */
	    TokenStorageService.prototype.onStorageEvent = function (storageEvent) {
	        if (storageEvent.key == TokenStorageService.STORAGE_KEY) {
	            this.loadToken();
	        }
	    };
	    /**
	     * Load and parsed the token from local storage, if invalid then clear
	     * the stored value.
	     */
	    TokenStorageService.prototype.loadToken = function () {
	        if (this.enabledLocalStorage) {
	            var storedToken = this.$window.localStorage
	                .getItem(TokenStorageService.STORAGE_KEY);
	            try {
	                this.accessToken = JSON.parse(storedToken);
	            }
	            catch (e) {
	                this.$log.error('Stored text is not valid.', e);
	                this.clearToken();
	            }
	        }
	    };
	    TokenStorageService.$inject = ['$window', '$log'];
	    TokenStorageService.STORAGE_KEY = 'imomo.accessToken';
	    return TokenStorageService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = TokenStorageService;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var token_sender_1 = __webpack_require__(192);
	var unauthorized_error_1 = __webpack_require__(193);
	var organization_update_1 = __webpack_require__(196);
	var localization_1 = __webpack_require__(197);
	var interceptorConfig = function ($httpProvider) {
	    $httpProvider.interceptors.push(token_sender_1.tokenSenderInterceptorFactory);
	    $httpProvider.interceptors.push(unauthorized_error_1.unauthorizedInterceptorFactory);
	    $httpProvider.interceptors.push(organization_update_1.organizationUpdateInterceptorFactory);
	    $httpProvider.interceptors.push(localization_1.localizationInterceptorFactory);
	};
	interceptorConfig.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.auth.interceptor', [])
	    .config(interceptorConfig)
	    .name;


/***/ },
/* 192 */
/***/ function(module, exports) {

	"use strict";
	exports.tokenSenderInterceptorFactory = function (tokenStorageService, backendUrl) {
	    return {
	        request: function (config) {
	            if (config.url.indexOf(backendUrl) == 0) {
	                config.headers = config.headers || {};
	                var storedToken = tokenStorageService.getToken();
	                if (storedToken != null) {
	                    config.headers['Authorization'] = "Bearer " + storedToken.tokenString;
	                }
	            }
	            return config;
	        }
	    };
	};
	exports.tokenSenderInterceptorFactory.$inject = ['tokenStorageService', 'backendUrl'];


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var login_service_1 = __webpack_require__(194);
	exports.unauthorizedInterceptorFactory = function ($q, $rootScope) {
	    return {
	        responseError: function (rejection) {
	            if (rejection.status && rejection.status == 401) {
	                $rootScope.$emit(login_service_1.ILoginService.UNAUTHORIZED_EVENT_NAME);
	            }
	            return $q.reject(rejection);
	        }
	    };
	};
	exports.unauthorizedInterceptorFactory.$inject = ['$q', '$rootScope'];


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var ILoginService;
	(function (ILoginService) {
	    ILoginService.UNAUTHORIZED_EVENT_NAME = 'imomo-unauthorized';
	    ILoginService.LOGIN_EVENT_NAME = 'imomo-login';
	    ILoginService.LOGOUT_EVENT_NAME = 'imomo-logout';
	})(ILoginService = exports.ILoginService || (exports.ILoginService = {}));
	var LoginService = (function () {
	    function LoginService(tokenStorageService, accessTokenApi, $log, $q, $rootScope, $state) {
	        var _this = this;
	        this.tokenStorageService = tokenStorageService;
	        this.accessTokenApi = accessTokenApi;
	        this.$log = $log;
	        this.$q = $q;
	        this.$rootScope = $rootScope;
	        this.$state = $state;
	        this.accessTokenPromise = null;
	        this.accessTokenPromiseInProgress = false;
	        this.loginStateChangeListeners = immutable_1.Set();
	        this.$rootScope.$on(ILoginService.UNAUTHORIZED_EVENT_NAME, function () {
	            _this.onUnauthorizedError();
	        });
	    }
	    LoginService.prototype.isLoggedIn = function () {
	        return this.tokenStorageService.verifyToken();
	    };
	    LoginService.prototype.onLoginStateChange = function (listener) {
	        var _this = this;
	        this.loginStateChangeListeners =
	            this.loginStateChangeListeners.add(listener);
	        return function () {
	            _this.loginStateChangeListeners =
	                _this.loginStateChangeListeners.delete(listener);
	        };
	    };
	    LoginService.prototype.logInUser = function (username, password) {
	        var _this = this;
	        var result = this.$q.defer();
	        if (this.accessTokenPromiseInProgress) {
	            this.accessTokenPromise
	                .then(function () { return result.resolve(); })
	                .catch(function () { return result.reject(); });
	        }
	        else if (this.tokenStorageService.verifyToken()) {
	            result.reject();
	        }
	        else {
	            this.accessTokenPromiseInProgress = true;
	            this.accessTokenPromise = this.accessTokenApi
	                .getUserToken(username, password)
	                .then(function (accessToken) {
	                _this.tokenStorageService.setToken(accessToken);
	                _this.notifyListeners(true);
	                result.resolve();
	            })
	                .catch(function (reason) {
	                result.reject(reason);
	            })
	                .finally(function () {
	                _this.accessTokenPromiseInProgress = false;
	            });
	        }
	        return result.promise;
	    };
	    LoginService.prototype.logOutUser = function () {
	        this.$rootScope.$broadcast(ILoginService.LOGOUT_EVENT_NAME);
	        this.tokenStorageService.clearToken();
	        this.notifyListeners(false);
	        return this.$q.when();
	    };
	    LoginService.prototype.notifyListeners = function (loggedIn) {
	        this.loginStateChangeListeners.forEach(function (listener) { return listener(loggedIn); });
	    };
	    LoginService.prototype.onUnauthorizedError = function () {
	        var _this = this;
	        this.logOutUser().then(function () {
	            _this.$state.go('home');
	        });
	    };
	    LoginService.$inject = ['tokenStorageService', 'accessTokenApi',
	        '$log', '$q', '$rootScope', '$state'];
	    return LoginService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = LoginService;


/***/ },
/* 195 */,
/* 196 */
/***/ function(module, exports) {

	"use strict";
	exports.organizationUpdateInterceptorFactory = function ($window) {
	    return {
	        request: function (config) {
	            config.headers = config.headers || {};
	            config.headers['Organization'] = $window.localStorage
	                .getItem('currentOrgId');
	            ;
	            return config;
	        }
	    };
	};
	exports.organizationUpdateInterceptorFactory.$inject = ['$window'];


/***/ },
/* 197 */
/***/ function(module, exports) {

	"use strict";
	exports.localizationInterceptorFactory = function ($translate) {
	    return {
	        request: function (config) {
	            config.headers = config.headers || {};
	            config.headers['Language'] = $translate.proposedLanguage();
	            return config;
	        }
	    };
	};
	exports.localizationInterceptorFactory.$inject = ['$translate'];


/***/ },
/* 198 */
/***/ function(module, exports) {

	"use strict";
	var AuthGuard;
	(function (AuthGuard) {
	    AuthGuard.REQUIRES_AUTH_KEY = 'requiresAuth';
	    AuthGuard.configureEnterGuard = function ($transitions) {
	        var onEnterGuard = function (transition, state) {
	            var toState = transition.to();
	            var loginService = transition.injector()
	                .get('loginService');
	            if (toState.data && toState.data[AuthGuard.REQUIRES_AUTH_KEY]) {
	                if (!loginService.isLoggedIn()) {
	                    return transition.router
	                        .stateService.target('login', {}, { location: 'replace' });
	                }
	            }
	            return true;
	        };
	        $transitions.onEnter({}, onEnterGuard);
	    };
	    AuthGuard.configureEnterGuard.$inject = ['$transitions'];
	})(AuthGuard = exports.AuthGuard || (exports.AuthGuard = {}));


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var curve_component_1 = __webpack_require__(200);
	var table_component_1 = __webpack_require__(223);
	var discharge_data_list_component_1 = __webpack_require__(226);
	var model_list_component_1 = __webpack_require__(231);
	var fitting_service_1 = __webpack_require__(237);
	var discharge_data_list_curve_directive_1 = __webpack_require__(239);
	var model_list_curve_directive_1 = __webpack_require__(240);
	var model_creator_service_1 = __webpack_require__(241);
	var model_formatter_1 = __webpack_require__(242);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.discharge', [])
	    .component('imomoDischargeCurve', curve_component_1.default)
	    .component('imomoDischargeTable', table_component_1.default)
	    .component('imomoDischargeDataList', discharge_data_list_component_1.default)
	    .component('imomoDischargeModelList', model_list_component_1.default)
	    .directive('imomoDischargeDataListCurve', discharge_data_list_curve_directive_1.default)
	    .directive('imomoDischargeModelListCurve', model_list_curve_directive_1.default)
	    .service('dischargeCurveFittingService', fitting_service_1.default)
	    .service('modelCreatorService', model_creator_service_1.default)
	    .filter('dischargeModelFormatter', model_formatter_1.default)
	    .name;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var curve_controller_1 = __webpack_require__(201);
	__webpack_require__(221);
	var template = __webpack_require__(222);
	var dischargeCurveComponent = {
	    bindings: {
	        dischargeModels: '<',
	        dischargeData: '<',
	        curveSettings: '<',
	        onBoundsChange: '&'
	    },
	    controller: curve_controller_1.default,
	    require: {
	        dischargeDataListCurveController: '^^?imomoDischargeDataListCurve',
	        dischargeModelListCurveController: '^^?imomoDischargeModelListCurve'
	    },
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = dischargeCurveComponent;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var d3_axis_1 = __webpack_require__(202);
	var d3_scale_1 = __webpack_require__(203);
	var d3_shape_1 = __webpack_require__(211);
	var d3_force_1 = __webpack_require__(213);
	var d3_selection_1 = __webpack_require__(217);
	var immutable_1 = __webpack_require__(195);
	var utils_1 = __webpack_require__(218);
	var curve_settings_dialog_controller_1 = __webpack_require__(219);
	var curveSettingsDialogTemplate = __webpack_require__(220);
	var DischargeCurveController = (function () {
	    function DischargeCurveController($element, $scope, $mdDialog) {
	        var _this = this;
	        this.$element = $element;
	        this.$scope = $scope;
	        this.$mdDialog = $mdDialog;
	        this.onMousemove = function ($event) {
	            var rect = $event.target;
	            _this.referencePoint.x = $event.clientX;
	            _this.referencePoint.y = $event.clientY;
	            _this.referencePoint = _this.referencePoint.matrixTransform(rect.getScreenCTM().inverse());
	            _this.cursor.discharge = _this.xScale.invert(_this.referencePoint.x);
	            _this.cursor.waterLevel = _this.yScale.invert(_this.referencePoint.y);
	        };
	        this.onMouseout = function () {
	            _this.cursor.discharge = 0;
	            _this.cursor.waterLevel = 0;
	        };
	        this.showChartSettings = function ($event) {
	            _this.$mdDialog.show({
	                targetEvent: $event,
	                template: curveSettingsDialogTemplate,
	                controller: curve_settings_dialog_controller_1.DischargeCurveSettingsDialog,
	                bindToController: true,
	                controllerAs: '$ctrl',
	                locals: {
	                    curveSettings: angular.copy(_this.curveSettings)
	                }
	            }).then(function (settings) {
	                if (settings.fitViewportToData) {
	                    _this.curveSettings.fitViewportToData = settings.fitViewportToData;
	                    _this.computeBounds();
	                    _this.updateViewElements();
	                }
	                else {
	                    _this.curveSettings = settings;
	                    _this.updateViewElements();
	                }
	                _this.onBoundsChange({
	                    curveSettings: _this.curveSettings,
	                    userChange: true
	                });
	            });
	        };
	        this.xScale = d3_scale_1.scaleLinear().range([0, this.innerWidth]);
	        this.yScale = d3_scale_1.scaleLinear().range([this.innerHeight, 0]);
	        this.xAxis = d3_axis_1.axisBottom(this.xScale).ticks(5)
	            .tickSizeInner(this.innerHeight).tickSizeOuter(0);
	        this.yAxis = d3_axis_1.axisLeft(this.yScale).ticks(5)
	            .tickSizeInner(this.innerWidth).tickSizeOuter(0);
	        this.lineGenerator = d3_shape_1.line()
	            .x(function (p) { return _this.xScale(p.discharge); })
	            .y(function (p) { return _this.yScale(p.waterLevel); }).curve(d3_shape_1.curveCardinal);
	        this.cursor = {
	            discharge: 0,
	            waterLevel: 0
	        };
	        if (!this.curveSettings) {
	            this.curveSettings = {
	                fitViewportToData: true,
	                minWaterLevel: 0,
	                maxWaterLevel: 100,
	                minDischarge: 0,
	                maxDischarge: 100
	            };
	        }
	    }
	    Object.defineProperty(DischargeCurveController.prototype, "height", {
	        get: function () {
	            return DischargeCurveController.HEIGHT;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DischargeCurveController.prototype, "width", {
	        get: function () {
	            return DischargeCurveController.WIDTH;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DischargeCurveController.prototype, "minorMargin", {
	        get: function () {
	            return DischargeCurveController.MINOR_MARGIN;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DischargeCurveController.prototype, "majorMargin", {
	        get: function () {
	            return DischargeCurveController.MAJOR_MARGIN;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DischargeCurveController.prototype, "innerHeight", {
	        get: function () {
	            return this.height - this.minorMargin - this.majorMargin;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DischargeCurveController.prototype, "innerWidth", {
	        get: function () {
	            return this.width - this.minorMargin - this.majorMargin;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DischargeCurveController.prototype.$onInit = function () {
	        if (this.dischargeDataListCurveController) {
	            this.dischargeDataListCurveController.addDischargeCurveController(this);
	        }
	        if (this.dischargeModelListCurveController) {
	            this.dischargeModelListCurveController.addDischargeCurveController(this);
	        }
	    };
	    DischargeCurveController.prototype.$onChanges = function (changes) {
	        if (changes.hasOwnProperty('curveSettings') && changes['curveSettings'].currentValue) {
	            this.curveSettings = changes['curveSettings'].currentValue;
	        }
	        this.dischargeData = this.dischargeData || immutable_1.List();
	        this.dischargeModels = this.dischargeModels || immutable_1.List();
	        this.updateViewportAndElements();
	    };
	    DischargeCurveController.prototype.onDischargeChartPointsChange = function (dischargeChartPoints) {
	        this.dischargeData = dischargeChartPoints || immutable_1.List();
	        this.updateViewportAndElements();
	    };
	    DischargeCurveController.prototype.onDischargeModelItemsChange = function (dischargeModelItems) {
	        this.dischargeModels = dischargeModelItems || immutable_1.List();
	        this.updateViewportAndElements();
	    };
	    DischargeCurveController.prototype.$postLink = function () {
	        this.postLinkDone = true;
	        this.drawAxis('x');
	        this.drawAxis('y');
	        var svg = this.$element[0].querySelector('svg');
	        this.referencePoint = svg.createSVGPoint();
	    };
	    DischargeCurveController.prototype.updateViewportAndElements = function () {
	        if (this.curveSettings.fitViewportToData) {
	            this.computeBounds();
	            this.onBoundsChange({
	                curveSettings: this.curveSettings,
	                userChange: false
	            });
	        }
	        this.updateViewElements();
	    };
	    DischargeCurveController.prototype.updateViewElements = function () {
	        this.updateAxes();
	        this.updateCurves();
	        this.updatePoints();
	    };
	    DischargeCurveController.prototype.updateAxes = function () {
	        this.yScale.domain([this.curveSettings.minWaterLevel,
	            this.curveSettings.maxWaterLevel]);
	        this.yAxis.scale(this.yScale);
	        this.drawAxis('y');
	        this.xScale.domain([this.curveSettings.minDischarge,
	            this.curveSettings.maxDischarge]);
	        this.xAxis.scale(this.xScale);
	        this.drawAxis('x');
	    };
	    DischargeCurveController.prototype.drawAxis = function (axis) {
	        if (this.postLinkDone) {
	            var element = d3_selection_1.select(this.$element[0]);
	            element.select("." + axis + ".axis")
	                .call(axis == 'x' ? this.xAxis : this.yAxis);
	        }
	    };
	    DischargeCurveController.prototype.updateCurves = function () {
	        var _this = this;
	        this.dischargeCurves = this.dischargeModels.map(function (dischargeModelItem, index) {
	            return {
	                path: _this.lineGenerator(utils_1.getDischargePoints(_this.curveSettings.minWaterLevel, _this.curveSettings.maxWaterLevel, dischargeModelItem.dischargeModel, DischargeCurveController.DISCHARGE_CURVE_RESOLUTION)),
	                strokeColor: dischargeModelItem.colors.backgroundColor
	            };
	        }).toArray();
	    };
	    DischargeCurveController.prototype.updatePoints = function () {
	        var _this = this;
	        this.dischargePoints = this.dischargeData.map(function (datum) {
	            return {
	                x: _this.xScale(datum.discharge),
	                y: _this.yScale(datum.waterLevel),
	                fx: _this.xScale(datum.discharge),
	                fy: _this.yScale(datum.waterLevel),
	                selected: datum.selected
	            };
	        }).toArray();
	        this.dischargeLabels = this.dischargeData.map(function (datum) {
	            return {
	                x: _this.xScale(datum.discharge),
	                y: _this.yScale(datum.waterLevel),
	                label: datum.label
	            };
	        }).toArray();
	        var forceNodes = [].concat(this.dischargePoints, this.dischargeLabels);
	        var links = _.zip(this.dischargePoints, this.dischargeLabels)
	            .map(function (_a) {
	            var point = _a[0], label = _a[1];
	            return {
	                source: point,
	                target: label
	            };
	        });
	        if (this.forceSimulator) {
	            this.forceSimulator.stop();
	        }
	        var link = d3_force_1.forceLink(links).distance(30).iterations(10);
	        var collide = d3_force_1.forceCollide().radius(20).iterations(5);
	        this.forceSimulator = d3_force_1.forceSimulation(forceNodes)
	            .force('link', link)
	            .force('collide', collide)
	            .on('tick', function () {
	            _this.$scope.$applyAsync();
	        })
	            .on('end', function () {
	        });
	    };
	    DischargeCurveController.prototype.computeBounds = function () {
	        var bounds = {
	            minWaterLevel: 0,
	            maxWaterLevel: 100,
	            minDischarge: 0,
	            maxDischarge: 0
	        };
	        if (this.dischargeData.size == 0 && this.dischargeModels.size == 0) {
	            bounds.maxDischarge = 100;
	        }
	        if (this.dischargeData.size == 1) {
	            bounds.minWaterLevel = 0;
	            bounds.maxWaterLevel = 2 * this.dischargeData.get(0).waterLevel;
	            bounds.minDischarge = 0;
	            bounds.maxDischarge = 2 * this.dischargeData.get(0).discharge;
	        }
	        else if (this.dischargeData.size > 1) {
	            bounds = {
	                minWaterLevel: Number.MAX_VALUE,
	                maxWaterLevel: Number.MIN_VALUE,
	                minDischarge: Number.MAX_VALUE,
	                maxDischarge: Number.MIN_VALUE
	            };
	            bounds = this.dischargeData.reduce(function (prevBounds, datum) {
	                return {
	                    minWaterLevel: Math
	                        .min(prevBounds.minWaterLevel, datum.waterLevel),
	                    maxWaterLevel: Math
	                        .max(prevBounds.maxWaterLevel, datum.waterLevel),
	                    minDischarge: Math.min(prevBounds.minDischarge, datum.discharge),
	                    maxDischarge: Math.max(prevBounds.maxDischarge, datum.discharge)
	                };
	            }, bounds);
	            bounds.minWaterLevel = Math.max(0, bounds.minWaterLevel * 0.98);
	            bounds.maxWaterLevel *= 1.02;
	            bounds.minDischarge = Math.max(0, bounds.minDischarge * 0.98);
	            bounds.maxDischarge *= 1.02;
	        }
	        bounds = this.dischargeModels.reduce(function (prevBounds, dischargeModelItem) {
	            var minModelDischarge = utils_1.getDischargeValue(prevBounds.minWaterLevel, dischargeModelItem.dischargeModel);
	            var maxModelDischarge = utils_1.getDischargeValue(prevBounds.maxWaterLevel, dischargeModelItem.dischargeModel);
	            if (minModelDischarge > maxModelDischarge) {
	                var tmp = minModelDischarge;
	                minModelDischarge = maxModelDischarge;
	                maxModelDischarge = tmp;
	            }
	            return {
	                minWaterLevel: prevBounds.minWaterLevel,
	                maxWaterLevel: prevBounds.maxWaterLevel,
	                minDischarge: Math.min(prevBounds.minDischarge, minModelDischarge),
	                maxDischarge: Math.max(prevBounds.maxDischarge, maxModelDischarge)
	            };
	        }, bounds);
	        this.curveSettings.minWaterLevel = bounds.minWaterLevel;
	        this.curveSettings.maxWaterLevel = bounds.maxWaterLevel;
	        this.curveSettings.minDischarge = bounds.minDischarge;
	        this.curveSettings.maxDischarge = bounds.maxDischarge;
	    };
	    DischargeCurveController.$inject = ['$element', '$scope', '$mdDialog'];
	    DischargeCurveController.HEIGHT = 450;
	    DischargeCurveController.WIDTH = 800;
	    DischargeCurveController.MINOR_MARGIN = 20;
	    DischargeCurveController.MAJOR_MARGIN = 60;
	    DischargeCurveController.DISCHARGE_CURVE_RESOLUTION = 100;
	    return DischargeCurveController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DischargeCurveController;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-axis/ Version 1.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var slice = Array.prototype.slice;
	
	  function identity(x) {
	    return x;
	  }
	
	  var top = 1;
	  var right = 2;
	  var bottom = 3;
	  var left = 4;
	  var epsilon = 1e-6;
	  function translateX(scale0, scale1, d) {
	    var x = scale0(d);
	    return "translate(" + (isFinite(x) ? x : scale1(d)) + ",0)";
	  }
	
	  function translateY(scale0, scale1, d) {
	    var y = scale0(d);
	    return "translate(0," + (isFinite(y) ? y : scale1(d)) + ")";
	  }
	
	  function center(scale) {
	    var offset = scale.bandwidth() / 2;
	    if (scale.round()) offset = Math.round(offset);
	    return function(d) {
	      return scale(d) + offset;
	    };
	  }
	
	  function entering() {
	    return !this.__axis;
	  }
	
	  function axis(orient, scale) {
	    var tickArguments = [],
	        tickValues = null,
	        tickFormat = null,
	        tickSizeInner = 6,
	        tickSizeOuter = 6,
	        tickPadding = 3;
	
	    function axis(context) {
	      var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	          format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity) : tickFormat,
	          spacing = Math.max(tickSizeInner, 0) + tickPadding,
	          transform = orient === top || orient === bottom ? translateX : translateY,
	          range = scale.range(),
	          range0 = range[0] + 0.5,
	          range1 = range[range.length - 1] + 0.5,
	          position = (scale.bandwidth ? center : identity)(scale.copy()),
	          selection = context.selection ? context.selection() : context,
	          path = selection.selectAll(".domain").data([null]),
	          tick = selection.selectAll(".tick").data(values, scale).order(),
	          tickExit = tick.exit(),
	          tickEnter = tick.enter().append("g").attr("class", "tick"),
	          line = tick.select("line"),
	          text = tick.select("text"),
	          k = orient === top || orient === left ? -1 : 1,
	          x, y = orient === left || orient === right ? (x = "x", "y") : (x = "y", "x");
	
	      path = path.merge(path.enter().insert("path", ".tick")
	          .attr("class", "domain")
	          .attr("stroke", "#000"));
	
	      tick = tick.merge(tickEnter);
	
	      line = line.merge(tickEnter.append("line")
	          .attr("stroke", "#000")
	          .attr(x + "2", k * tickSizeInner)
	          .attr(y + "1", 0.5)
	          .attr(y + "2", 0.5));
	
	      text = text.merge(tickEnter.append("text")
	          .attr("fill", "#000")
	          .attr(x, k * spacing)
	          .attr(y, 0.5)
	          .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	      if (context !== selection) {
	        path = path.transition(context);
	        tick = tick.transition(context);
	        line = line.transition(context);
	        text = text.transition(context);
	
	        tickExit = tickExit.transition(context)
	            .attr("opacity", epsilon)
	            .attr("transform", function(d) { return transform(position, this.parentNode.__axis || position, d); });
	
	        tickEnter
	            .attr("opacity", epsilon)
	            .attr("transform", function(d) { return transform(this.parentNode.__axis || position, position, d); });
	      }
	
	      tickExit.remove();
	
	      path
	          .attr("d", orient === left || orient == right
	              ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	              : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	      tick
	          .attr("opacity", 1)
	          .attr("transform", function(d) { return transform(position, position, d); });
	
	      line
	          .attr(x + "2", k * tickSizeInner);
	
	      text
	          .attr(x, k * spacing)
	          .text(format);
	
	      selection.filter(entering)
	          .attr("fill", "none")
	          .attr("font-size", 10)
	          .attr("font-family", "sans-serif")
	          .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	      selection
	          .each(function() { this.__axis = position; });
	    }
	
	    axis.scale = function(_) {
	      return arguments.length ? (scale = _, axis) : scale;
	    };
	
	    axis.ticks = function() {
	      return tickArguments = slice.call(arguments), axis;
	    };
	
	    axis.tickArguments = function(_) {
	      return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
	    };
	
	    axis.tickValues = function(_) {
	      return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
	    };
	
	    axis.tickFormat = function(_) {
	      return arguments.length ? (tickFormat = _, axis) : tickFormat;
	    };
	
	    axis.tickSize = function(_) {
	      return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	    };
	
	    axis.tickSizeInner = function(_) {
	      return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	    };
	
	    axis.tickSizeOuter = function(_) {
	      return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	    };
	
	    axis.tickPadding = function(_) {
	      return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	    };
	
	    return axis;
	  }
	
	  function axisTop(scale) {
	    return axis(top, scale);
	  }
	
	  function axisRight(scale) {
	    return axis(right, scale);
	  }
	
	  function axisBottom(scale) {
	    return axis(bottom, scale);
	  }
	
	  function axisLeft(scale) {
	    return axis(left, scale);
	  }
	
	  exports.axisTop = axisTop;
	  exports.axisRight = axisRight;
	  exports.axisBottom = axisBottom;
	  exports.axisLeft = axisLeft;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(204), __webpack_require__(205), __webpack_require__(206), __webpack_require__(208), __webpack_require__(209), __webpack_require__(210), __webpack_require__(207)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	  var array = Array.prototype;
	
	  var map$1 = array.map;
	  var slice = array.slice;
	
	  var implicit = {name: "implicit"};
	
	  function ordinal(range) {
	    var index = d3Collection.map(),
	        domain = [],
	        unknown = implicit;
	
	    range = range == null ? [] : slice.call(range);
	
	    function scale(d) {
	      var key = d + "", i = index.get(key);
	      if (!i) {
	        if (unknown !== implicit) return unknown;
	        index.set(key, i = domain.push(d));
	      }
	      return range[(i - 1) % range.length];
	    }
	
	    scale.domain = function(_) {
	      if (!arguments.length) return domain.slice();
	      domain = [], index = d3Collection.map();
	      var i = -1, n = _.length, d, key;
	      while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	      return scale;
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), scale) : range.slice();
	    };
	
	    scale.unknown = function(_) {
	      return arguments.length ? (unknown = _, scale) : unknown;
	    };
	
	    scale.copy = function() {
	      return ordinal()
	          .domain(domain)
	          .range(range)
	          .unknown(unknown);
	    };
	
	    return scale;
	  }
	
	  function band() {
	    var scale = ordinal().unknown(undefined),
	        domain = scale.domain,
	        ordinalRange = scale.range,
	        range = [0, 1],
	        step,
	        bandwidth,
	        round = false,
	        paddingInner = 0,
	        paddingOuter = 0,
	        align = 0.5;
	
	    delete scale.unknown;
	
	    function rescale() {
	      var n = domain().length,
	          reverse = range[1] < range[0],
	          start = range[reverse - 0],
	          stop = range[1 - reverse];
	      step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	      if (round) step = Math.floor(step);
	      start += (stop - start - step * (n - paddingInner)) * align;
	      bandwidth = step * (1 - paddingInner);
	      if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	      var values = d3Array.range(n).map(function(i) { return start + step * i; });
	      return ordinalRange(reverse ? values.reverse() : values);
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain(_), rescale()) : domain();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	    };
	
	    scale.rangeRound = function(_) {
	      return range = [+_[0], +_[1]], round = true, rescale();
	    };
	
	    scale.bandwidth = function() {
	      return bandwidth;
	    };
	
	    scale.step = function() {
	      return step;
	    };
	
	    scale.round = function(_) {
	      return arguments.length ? (round = !!_, rescale()) : round;
	    };
	
	    scale.padding = function(_) {
	      return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	    };
	
	    scale.paddingInner = function(_) {
	      return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	    };
	
	    scale.paddingOuter = function(_) {
	      return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	    };
	
	    scale.align = function(_) {
	      return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	    };
	
	    scale.copy = function() {
	      return band()
	          .domain(domain())
	          .range(range)
	          .round(round)
	          .paddingInner(paddingInner)
	          .paddingOuter(paddingOuter)
	          .align(align);
	    };
	
	    return rescale();
	  }
	
	  function pointish(scale) {
	    var copy = scale.copy;
	
	    scale.padding = scale.paddingOuter;
	    delete scale.paddingInner;
	    delete scale.paddingOuter;
	
	    scale.copy = function() {
	      return pointish(copy());
	    };
	
	    return scale;
	  }
	
	  function point() {
	    return pointish(band().paddingInner(1));
	  }
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function number(x) {
	    return +x;
	  }
	
	  var unit = [0, 1];
	
	  function deinterpolate(a, b) {
	    return (b -= (a = +a))
	        ? function(x) { return (x - a) / b; }
	        : constant(b);
	  }
	
	  function deinterpolateClamp(deinterpolate) {
	    return function(a, b) {
	      var d = deinterpolate(a = +a, b = +b);
	      return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	    };
	  }
	
	  function reinterpolateClamp(reinterpolate) {
	    return function(a, b) {
	      var r = reinterpolate(a = +a, b = +b);
	      return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	    };
	  }
	
	  function bimap(domain, range, deinterpolate, reinterpolate) {
	    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	    if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	    else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	    return function(x) { return r0(d0(x)); };
	  }
	
	  function polymap(domain, range, deinterpolate, reinterpolate) {
	    var j = Math.min(domain.length, range.length) - 1,
	        d = new Array(j),
	        r = new Array(j),
	        i = -1;
	
	    // Reverse descending domains.
	    if (domain[j] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	
	    while (++i < j) {
	      d[i] = deinterpolate(domain[i], domain[i + 1]);
	      r[i] = reinterpolate(range[i], range[i + 1]);
	    }
	
	    return function(x) {
	      var i = d3Array.bisect(domain, x, 1, j) - 1;
	      return r[i](d[i](x));
	    };
	  }
	
	  function copy(source, target) {
	    return target
	        .domain(source.domain())
	        .range(source.range())
	        .interpolate(source.interpolate())
	        .clamp(source.clamp());
	  }
	
	  // deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	  // reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	  function continuous(deinterpolate$$, reinterpolate) {
	    var domain = unit,
	        range = unit,
	        interpolate = d3Interpolate.interpolate,
	        clamp = false,
	        piecewise,
	        output,
	        input;
	
	    function rescale() {
	      piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	      output = input = null;
	      return scale;
	    }
	
	    function scale(x) {
	      return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate$$) : deinterpolate$$, interpolate)))(+x);
	    }
	
	    scale.invert = function(y) {
	      return (input || (input = piecewise(range, domain, deinterpolate, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	    };
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	    };
	
	    scale.rangeRound = function(_) {
	      return range = slice.call(_), interpolate = d3Interpolate.interpolateRound, rescale();
	    };
	
	    scale.clamp = function(_) {
	      return arguments.length ? (clamp = !!_, rescale()) : clamp;
	    };
	
	    scale.interpolate = function(_) {
	      return arguments.length ? (interpolate = _, rescale()) : interpolate;
	    };
	
	    return rescale();
	  }
	
	  function tickFormat(domain, count, specifier) {
	    var start = domain[0],
	        stop = domain[domain.length - 1],
	        step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	        precision;
	    specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	    switch (specifier.type) {
	      case "s": {
	        var value = Math.max(Math.abs(start), Math.abs(stop));
	        if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	        return d3Format.formatPrefix(specifier, value);
	      }
	      case "":
	      case "e":
	      case "g":
	      case "p":
	      case "r": {
	        if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	        break;
	      }
	      case "f":
	      case "%": {
	        if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	        break;
	      }
	    }
	    return d3Format.format(specifier);
	  }
	
	  function linearish(scale) {
	    var domain = scale.domain;
	
	    scale.ticks = function(count) {
	      var d = domain();
	      return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	    };
	
	    scale.tickFormat = function(count, specifier) {
	      return tickFormat(domain(), count, specifier);
	    };
	
	    scale.nice = function(count) {
	      var d = domain(),
	          i = d.length - 1,
	          n = count == null ? 10 : count,
	          start = d[0],
	          stop = d[i],
	          step = d3Array.tickStep(start, stop, n);
	
	      if (step) {
	        step = d3Array.tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	        d[0] = Math.floor(start / step) * step;
	        d[i] = Math.ceil(stop / step) * step;
	        domain(d);
	      }
	
	      return scale;
	    };
	
	    return scale;
	  }
	
	  function linear() {
	    var scale = continuous(deinterpolate, d3Interpolate.interpolateNumber);
	
	    scale.copy = function() {
	      return copy(scale, linear());
	    };
	
	    return linearish(scale);
	  }
	
	  function identity() {
	    var domain = [0, 1];
	
	    function scale(x) {
	      return +x;
	    }
	
	    scale.invert = scale;
	
	    scale.domain = scale.range = function(_) {
	      return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	    };
	
	    scale.copy = function() {
	      return identity().domain(domain);
	    };
	
	    return linearish(scale);
	  }
	
	  function nice(domain, interval) {
	    domain = domain.slice();
	
	    var i0 = 0,
	        i1 = domain.length - 1,
	        x0 = domain[i0],
	        x1 = domain[i1],
	        t;
	
	    if (x1 < x0) {
	      t = i0, i0 = i1, i1 = t;
	      t = x0, x0 = x1, x1 = t;
	    }
	
	    domain[i0] = interval.floor(x0);
	    domain[i1] = interval.ceil(x1);
	    return domain;
	  }
	
	  function deinterpolate$1(a, b) {
	    return (b = Math.log(b / a))
	        ? function(x) { return Math.log(x / a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    return a < 0
	        ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	        : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	  }
	
	  function pow10(x) {
	    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	  }
	
	  function powp(base) {
	    return base === 10 ? pow10
	        : base === Math.E ? Math.exp
	        : function(x) { return Math.pow(base, x); };
	  }
	
	  function logp(base) {
	    return base === Math.E ? Math.log
	        : base === 10 && Math.log10
	        || base === 2 && Math.log2
	        || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	  }
	
	  function reflect(f) {
	    return function(x) {
	      return -f(-x);
	    };
	  }
	
	  function log() {
	    var scale = continuous(deinterpolate$1, reinterpolate).domain([1, 10]),
	        domain = scale.domain,
	        base = 10,
	        logs = logp(10),
	        pows = powp(10);
	
	    function rescale() {
	      logs = logp(base), pows = powp(base);
	      if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	      return scale;
	    }
	
	    scale.base = function(_) {
	      return arguments.length ? (base = +_, rescale()) : base;
	    };
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain(_), rescale()) : domain();
	    };
	
	    scale.ticks = function(count) {
	      var d = domain(),
	          u = d[0],
	          v = d[d.length - 1],
	          r;
	
	      if (r = v < u) i = u, u = v, v = i;
	
	      var i = logs(u),
	          j = logs(v),
	          p,
	          k,
	          t,
	          n = count == null ? 10 : +count,
	          z = [];
	
	      if (!(base % 1) && j - i < n) {
	        i = Math.round(i) - 1, j = Math.round(j) + 1;
	        if (u > 0) for (; i < j; ++i) {
	          for (k = 1, p = pows(i); k < base; ++k) {
	            t = p * k;
	            if (t < u) continue;
	            if (t > v) break;
	            z.push(t);
	          }
	        } else for (; i < j; ++i) {
	          for (k = base - 1, p = pows(i); k >= 1; --k) {
	            t = p * k;
	            if (t < u) continue;
	            if (t > v) break;
	            z.push(t);
	          }
	        }
	      } else {
	        z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	      }
	
	      return r ? z.reverse() : z;
	    };
	
	    scale.tickFormat = function(count, specifier) {
	      if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	      if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	      if (count === Infinity) return specifier;
	      if (count == null) count = 10;
	      var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	      return function(d) {
	        var i = d / pows(Math.round(logs(d)));
	        if (i * base < base - 0.5) i *= base;
	        return i <= k ? specifier(d) : "";
	      };
	    };
	
	    scale.nice = function() {
	      return domain(nice(domain(), {
	        floor: function(x) { return pows(Math.floor(logs(x))); },
	        ceil: function(x) { return pows(Math.ceil(logs(x))); }
	      }));
	    };
	
	    scale.copy = function() {
	      return copy(scale, log().base(base));
	    };
	
	    return scale;
	  }
	
	  function raise(x, exponent) {
	    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	  }
	
	  function pow() {
	    var exponent = 1,
	        scale = continuous(deinterpolate, reinterpolate),
	        domain = scale.domain;
	
	    function deinterpolate(a, b) {
	      return (b = raise(b, exponent) - (a = raise(a, exponent)))
	          ? function(x) { return (raise(x, exponent) - a) / b; }
	          : constant(b);
	    }
	
	    function reinterpolate(a, b) {
	      b = raise(b, exponent) - (a = raise(a, exponent));
	      return function(t) { return raise(a + b * t, 1 / exponent); };
	    }
	
	    scale.exponent = function(_) {
	      return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	    };
	
	    scale.copy = function() {
	      return copy(scale, pow().exponent(exponent));
	    };
	
	    return linearish(scale);
	  }
	
	  function sqrt() {
	    return pow().exponent(0.5);
	  }
	
	  function quantile$1() {
	    var domain = [],
	        range = [],
	        thresholds = [];
	
	    function rescale() {
	      var i = 0, n = Math.max(1, range.length);
	      thresholds = new Array(n - 1);
	      while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	      return scale;
	    }
	
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3Array.bisect(thresholds, x)];
	    }
	
	    scale.invertExtent = function(y) {
	      var i = range.indexOf(y);
	      return i < 0 ? [NaN, NaN] : [
	        i > 0 ? thresholds[i - 1] : domain[0],
	        i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	      ];
	    };
	
	    scale.domain = function(_) {
	      if (!arguments.length) return domain.slice();
	      domain = [];
	      for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	      domain.sort(d3Array.ascending);
	      return rescale();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	    };
	
	    scale.quantiles = function() {
	      return thresholds.slice();
	    };
	
	    scale.copy = function() {
	      return quantile$1()
	          .domain(domain)
	          .range(range);
	    };
	
	    return scale;
	  }
	
	  function quantize() {
	    var x0 = 0,
	        x1 = 1,
	        n = 1,
	        domain = [0.5],
	        range = [0, 1];
	
	    function scale(x) {
	      if (x <= x) return range[d3Array.bisect(domain, x, 0, n)];
	    }
	
	    function rescale() {
	      var i = -1;
	      domain = new Array(n);
	      while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	      return scale;
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
	    };
	
	    scale.invertExtent = function(y) {
	      var i = range.indexOf(y);
	      return i < 0 ? [NaN, NaN]
	          : i < 1 ? [x0, domain[0]]
	          : i >= n ? [domain[n - 1], x1]
	          : [domain[i - 1], domain[i]];
	    };
	
	    scale.copy = function() {
	      return quantize()
	          .domain([x0, x1])
	          .range(range);
	    };
	
	    return linearish(scale);
	  }
	
	  function threshold() {
	    var domain = [0.5],
	        range = [0, 1],
	        n = 1;
	
	    function scale(x) {
	      if (x <= x) return range[d3Array.bisect(domain, x, 0, n)];
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	    };
	
	    scale.invertExtent = function(y) {
	      var i = range.indexOf(y);
	      return [domain[i - 1], domain[i]];
	    };
	
	    scale.copy = function() {
	      return threshold()
	          .domain(domain)
	          .range(range);
	    };
	
	    return scale;
	  }
	
	  var durationSecond = 1000;
	  var durationMinute = durationSecond * 60;
	  var durationHour = durationMinute * 60;
	  var durationDay = durationHour * 24;
	  var durationWeek = durationDay * 7;
	  var durationMonth = durationDay * 30;
	  var durationYear = durationDay * 365;
	  function date(t) {
	    return new Date(t);
	  }
	
	  function number$1(t) {
	    return t instanceof Date ? +t : +new Date(+t);
	  }
	
	  function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	    var scale = continuous(deinterpolate, d3Interpolate.interpolateNumber),
	        invert = scale.invert,
	        domain = scale.domain;
	
	    var formatMillisecond = format(".%L"),
	        formatSecond = format(":%S"),
	        formatMinute = format("%I:%M"),
	        formatHour = format("%I %p"),
	        formatDay = format("%a %d"),
	        formatWeek = format("%b %d"),
	        formatMonth = format("%B"),
	        formatYear = format("%Y");
	
	    var tickIntervals = [
	      [second,  1,      durationSecond],
	      [second,  5,  5 * durationSecond],
	      [second, 15, 15 * durationSecond],
	      [second, 30, 30 * durationSecond],
	      [minute,  1,      durationMinute],
	      [minute,  5,  5 * durationMinute],
	      [minute, 15, 15 * durationMinute],
	      [minute, 30, 30 * durationMinute],
	      [  hour,  1,      durationHour  ],
	      [  hour,  3,  3 * durationHour  ],
	      [  hour,  6,  6 * durationHour  ],
	      [  hour, 12, 12 * durationHour  ],
	      [   day,  1,      durationDay   ],
	      [   day,  2,  2 * durationDay   ],
	      [  week,  1,      durationWeek  ],
	      [ month,  1,      durationMonth ],
	      [ month,  3,  3 * durationMonth ],
	      [  year,  1,      durationYear  ]
	    ];
	
	    function tickFormat(date) {
	      return (second(date) < date ? formatMillisecond
	          : minute(date) < date ? formatSecond
	          : hour(date) < date ? formatMinute
	          : day(date) < date ? formatHour
	          : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	          : year(date) < date ? formatMonth
	          : formatYear)(date);
	    }
	
	    function tickInterval(interval, start, stop, step) {
	      if (interval == null) interval = 10;
	
	      // If a desired tick count is specified, pick a reasonable tick interval
	      // based on the extent of the domain and a rough estimate of tick size.
	      // Otherwise, assume interval is already a time interval and use it.
	      if (typeof interval === "number") {
	        var target = Math.abs(stop - start) / interval,
	            i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	        if (i === tickIntervals.length) {
	          step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	          interval = year;
	        } else if (i) {
	          i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	          step = i[1];
	          interval = i[0];
	        } else {
	          step = d3Array.tickStep(start, stop, interval);
	          interval = millisecond;
	        }
	      }
	
	      return step == null ? interval : interval.every(step);
	    }
	
	    scale.invert = function(y) {
	      return new Date(invert(y));
	    };
	
	    scale.domain = function(_) {
	      return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	    };
	
	    scale.ticks = function(interval, step) {
	      var d = domain(),
	          t0 = d[0],
	          t1 = d[d.length - 1],
	          r = t1 < t0,
	          t;
	      if (r) t = t0, t0 = t1, t1 = t;
	      t = tickInterval(interval, t0, t1, step);
	      t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	      return r ? t.reverse() : t;
	    };
	
	    scale.tickFormat = function(count, specifier) {
	      return specifier == null ? tickFormat : format(specifier);
	    };
	
	    scale.nice = function(interval, step) {
	      var d = domain();
	      return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	          ? domain(nice(d, interval))
	          : scale;
	    };
	
	    scale.copy = function() {
	      return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	    };
	
	    return scale;
	  }
	
	  function time() {
	    return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	  }
	
	  function utcTime() {
	    return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	  }
	
	  function colors(s) {
	    return s.match(/.{6}/g).map(function(x) {
	      return "#" + x;
	    });
	  }
	
	  var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	  var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	  var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	  var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	  var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	  var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	  var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	  var rainbow = d3Color.cubehelix();
	
	  function rainbow$1(t) {
	    if (t < 0 || t > 1) t -= Math.floor(t);
	    var ts = Math.abs(t - 0.5);
	    rainbow.h = 360 * t - 100;
	    rainbow.s = 1.5 - 1.5 * ts;
	    rainbow.l = 0.8 - 0.9 * ts;
	    return rainbow + "";
	  }
	
	  function ramp(range) {
	    var n = range.length;
	    return function(t) {
	      return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	    };
	  }
	
	  var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	  var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	  var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	  var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	  function sequential(interpolator) {
	    var x0 = 0,
	        x1 = 1,
	        clamp = false;
	
	    function scale(x) {
	      var t = (x - x0) / (x1 - x0);
	      return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	    };
	
	    scale.clamp = function(_) {
	      return arguments.length ? (clamp = !!_, scale) : clamp;
	    };
	
	    scale.interpolator = function(_) {
	      return arguments.length ? (interpolator = _, scale) : interpolator;
	    };
	
	    scale.copy = function() {
	      return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	    };
	
	    return linearish(scale);
	  }
	
	  exports.scaleBand = band;
	  exports.scalePoint = point;
	  exports.scaleIdentity = identity;
	  exports.scaleLinear = linear;
	  exports.scaleLog = log;
	  exports.scaleOrdinal = ordinal;
	  exports.scaleImplicit = implicit;
	  exports.scalePow = pow;
	  exports.scaleSqrt = sqrt;
	  exports.scaleQuantile = quantile$1;
	  exports.scaleQuantize = quantize;
	  exports.scaleThreshold = threshold;
	  exports.scaleTime = time;
	  exports.scaleUtc = utcTime;
	  exports.schemeCategory10 = category10;
	  exports.schemeCategory20b = category20b;
	  exports.schemeCategory20c = category20c;
	  exports.schemeCategory20 = category20;
	  exports.interpolateCubehelixDefault = cubehelix$1;
	  exports.interpolateRainbow = rainbow$1;
	  exports.interpolateWarm = warm;
	  exports.interpolateCool = cool;
	  exports.interpolateViridis = viridis;
	  exports.interpolateMagma = magma;
	  exports.interpolateInferno = inferno;
	  exports.interpolatePlasma = plasma;
	  exports.scaleSequential = sequential;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  function ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	
	  function bisector(compare) {
	    if (compare.length === 1) compare = ascendingComparator(compare);
	    return {
	      left: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1;
	          else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid;
	          else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	
	  function ascendingComparator(f) {
	    return function(d, x) {
	      return ascending(f(d), x);
	    };
	  }
	
	  var ascendingBisect = bisector(ascending);
	  var bisectRight = ascendingBisect.right;
	  var bisectLeft = ascendingBisect.left;
	
	  function descending(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  }
	
	  function number(x) {
	    return x === null ? NaN : +x;
	  }
	
	  function variance(array, f) {
	    var n = array.length,
	        m = 0,
	        a,
	        d,
	        s = 0,
	        i = -1,
	        j = 0;
	
	    if (f == null) {
	      while (++i < n) {
	        if (!isNaN(a = number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    else {
	      while (++i < n) {
	        if (!isNaN(a = number(f(array[i], i, array)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    if (j > 1) return s / (j - 1);
	  }
	
	  function deviation(array, f) {
	    var v = variance(array, f);
	    return v ? Math.sqrt(v) : v;
	  }
	
	  function extent(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b,
	        c;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    return [a, c];
	  }
	
	  var array = Array.prototype;
	
	  var slice = array.slice;
	  var map = array.map;
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function identity(x) {
	    return x;
	  }
	
	  function range(start, stop, step) {
	    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	    var i = -1,
	        n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	        range = new Array(n);
	
	    while (++i < n) {
	      range[i] = start + i * step;
	    }
	
	    return range;
	  }
	
	  var e10 = Math.sqrt(50);
	  var e5 = Math.sqrt(10);
	  var e2 = Math.sqrt(2);
	  function ticks(start, stop, count) {
	    var step = tickStep(start, stop, count);
	    return range(
	      Math.ceil(start / step) * step,
	      Math.floor(stop / step) * step + step / 2, // inclusive
	      step
	    );
	  }
	
	  function tickStep(start, stop, count) {
	    var step0 = Math.abs(stop - start) / Math.max(0, count),
	        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	        error = step0 / step1;
	    if (error >= e10) step1 *= 10;
	    else if (error >= e5) step1 *= 5;
	    else if (error >= e2) step1 *= 2;
	    return stop < start ? -step1 : step1;
	  }
	
	  function sturges(values) {
	    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	  }
	
	  function histogram() {
	    var value = identity,
	        domain = extent,
	        threshold = sturges;
	
	    function histogram(data) {
	      var i,
	          n = data.length,
	          x,
	          values = new Array(n);
	
	      for (i = 0; i < n; ++i) {
	        values[i] = value(data[i], i, data);
	      }
	
	      var xz = domain(values),
	          x0 = xz[0],
	          x1 = xz[1],
	          tz = threshold(values, x0, x1);
	
	      // Convert number of thresholds into uniform thresholds.
	      if (!Array.isArray(tz)) tz = ticks(x0, x1, tz);
	
	      // Remove any thresholds outside the domain.
	      var m = tz.length;
	      while (tz[0] <= x0) tz.shift(), --m;
	      while (tz[m - 1] >= x1) tz.pop(), --m;
	
	      var bins = new Array(m + 1),
	          bin;
	
	      // Initialize bins.
	      for (i = 0; i <= m; ++i) {
	        bin = bins[i] = [];
	        bin.x0 = i > 0 ? tz[i - 1] : x0;
	        bin.x1 = i < m ? tz[i] : x1;
	      }
	
	      // Assign data to bins by value, ignoring any outside the domain.
	      for (i = 0; i < n; ++i) {
	        x = values[i];
	        if (x0 <= x && x <= x1) {
	          bins[bisectRight(tz, x, 0, m)].push(data[i]);
	        }
	      }
	
	      return bins;
	    }
	
	    histogram.value = function(_) {
	      return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	    };
	
	    histogram.domain = function(_) {
	      return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	    };
	
	    histogram.thresholds = function(_) {
	      return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	    };
	
	    return histogram;
	  }
	
	  function quantile(array, p, f) {
	    if (f == null) f = number;
	    if (!(n = array.length)) return;
	    if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	    if (p >= 1) return +f(array[n - 1], n - 1, array);
	    var n,
	        h = (n - 1) * p,
	        i = Math.floor(h),
	        a = +f(array[i], i, array),
	        b = +f(array[i + 1], i + 1, array);
	    return a + (b - a) * (h - i);
	  }
	
	  function freedmanDiaconis(values, min, max) {
	    values = map.call(values, number).sort(ascending);
	    return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function scott(values, min, max) {
	    return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function max(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	    }
	
	    return a;
	  }
	
	  function mean(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1,
	        j = n;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number(array[i]))) s += a; else --j;
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) s += a; else --j;
	    }
	
	    if (j) return s / j;
	  }
	
	  function median(array, f) {
	    var numbers = [],
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number(array[i]))) numbers.push(a);
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) numbers.push(a);
	    }
	
	    return quantile(numbers.sort(ascending), 0.5);
	  }
	
	  function merge(arrays) {
	    var n = arrays.length,
	        m,
	        i = -1,
	        j = 0,
	        merged,
	        array;
	
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	
	    return merged;
	  }
	
	  function min(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	    }
	
	    return a;
	  }
	
	  function pairs(array) {
	    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [p, p = array[++i]];
	    return pairs;
	  }
	
	  function permute(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  }
	
	  function scan(array, compare) {
	    if (!(n = array.length)) return;
	    var i = 0,
	        n,
	        j = 0,
	        xi,
	        xj = array[j];
	
	    if (!compare) compare = ascending;
	
	    while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	    if (compare(xj, xj) === 0) return j;
	  }
	
	  function shuffle(array, i0, i1) {
	    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	        t,
	        i;
	
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0];
	      array[m + i0] = array[i + i0];
	      array[i + i0] = t;
	    }
	
	    return array;
	  }
	
	  function sum(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	    }
	
	    else {
	      while (++i < n) if (a = +f(array[i], i, array)) s += a;
	    }
	
	    return s;
	  }
	
	  function transpose(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  }
	
	  function length(d) {
	    return d.length;
	  }
	
	  function zip() {
	    return transpose(arguments);
	  }
	
	  exports.bisect = bisectRight;
	  exports.bisectRight = bisectRight;
	  exports.bisectLeft = bisectLeft;
	  exports.ascending = ascending;
	  exports.bisector = bisector;
	  exports.descending = descending;
	  exports.deviation = deviation;
	  exports.extent = extent;
	  exports.histogram = histogram;
	  exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	  exports.thresholdScott = scott;
	  exports.thresholdSturges = sturges;
	  exports.max = max;
	  exports.mean = mean;
	  exports.median = median;
	  exports.merge = merge;
	  exports.min = min;
	  exports.pairs = pairs;
	  exports.permute = permute;
	  exports.quantile = quantile;
	  exports.range = range;
	  exports.scan = scan;
	  exports.shuffle = shuffle;
	  exports.sum = sum;
	  exports.ticks = ticks;
	  exports.tickStep = tickStep;
	  exports.transpose = transpose;
	  exports.variance = variance;
	  exports.zip = zip;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var prefix = "$";
	
	  function Map() {}
	
	  Map.prototype = map.prototype = {
	    constructor: Map,
	    has: function(key) {
	      return (prefix + key) in this;
	    },
	    get: function(key) {
	      return this[prefix + key];
	    },
	    set: function(key, value) {
	      this[prefix + key] = value;
	      return this;
	    },
	    remove: function(key) {
	      var property = prefix + key;
	      return property in this && delete this[property];
	    },
	    clear: function() {
	      for (var property in this) if (property[0] === prefix) delete this[property];
	    },
	    keys: function() {
	      var keys = [];
	      for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	      return keys;
	    },
	    values: function() {
	      var values = [];
	      for (var property in this) if (property[0] === prefix) values.push(this[property]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	      return entries;
	    },
	    size: function() {
	      var size = 0;
	      for (var property in this) if (property[0] === prefix) ++size;
	      return size;
	    },
	    empty: function() {
	      for (var property in this) if (property[0] === prefix) return false;
	      return true;
	    },
	    each: function(f) {
	      for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	    }
	  };
	
	  function map(object, f) {
	    var map = new Map;
	
	    // Copy constructor.
	    if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	    // Index array by numeric index or specified key function.
	    else if (Array.isArray(object)) {
	      var i = -1,
	          n = object.length,
	          o;
	
	      if (f == null) while (++i < n) map.set(i, object[i]);
	      else while (++i < n) map.set(f(o = object[i], i, object), o);
	    }
	
	    // Convert object to map.
	    else if (object) for (var key in object) map.set(key, object[key]);
	
	    return map;
	  }
	
	  function nest() {
	    var keys = [],
	        sortKeys = [],
	        sortValues,
	        rollup,
	        nest;
	
	    function apply(array, depth, createResult, setResult) {
	      if (depth >= keys.length) return rollup != null
	          ? rollup(array) : (sortValues != null
	          ? array.sort(sortValues)
	          : array);
	
	      var i = -1,
	          n = array.length,
	          key = keys[depth++],
	          keyValue,
	          value,
	          valuesByKey = map(),
	          values,
	          result = createResult();
	
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	          values.push(value);
	        } else {
	          valuesByKey.set(keyValue, [value]);
	        }
	      }
	
	      valuesByKey.each(function(values, key) {
	        setResult(result, key, apply(values, depth, createResult, setResult));
	      });
	
	      return result;
	    }
	
	    function entries(map, depth) {
	      if (++depth > keys.length) return map;
	      var array, sortKey = sortKeys[depth - 1];
	      if (rollup != null && depth >= keys.length) array = map.entries();
	      else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	      return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	    }
	
	    return nest = {
	      object: function(array) { return apply(array, 0, createObject, setObject); },
	      map: function(array) { return apply(array, 0, createMap, setMap); },
	      entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	      key: function(d) { keys.push(d); return nest; },
	      sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	      sortValues: function(order) { sortValues = order; return nest; },
	      rollup: function(f) { rollup = f; return nest; }
	    };
	  }
	
	  function createObject() {
	    return {};
	  }
	
	  function setObject(object, key, value) {
	    object[key] = value;
	  }
	
	  function createMap() {
	    return map();
	  }
	
	  function setMap(map, key, value) {
	    map.set(key, value);
	  }
	
	  function Set() {}
	
	  var proto = map.prototype;
	
	  Set.prototype = set.prototype = {
	    constructor: Set,
	    has: proto.has,
	    add: function(value) {
	      value += "";
	      this[prefix + value] = value;
	      return this;
	    },
	    remove: proto.remove,
	    clear: proto.clear,
	    values: proto.keys,
	    size: proto.size,
	    empty: proto.empty,
	    each: proto.each
	  };
	
	  function set(object, f) {
	    var set = new Set;
	
	    // Copy constructor.
	    if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	    // Otherwise, assume it’s an array.
	    else if (object) {
	      var i = -1, n = object.length;
	      if (f == null) while (++i < n) set.add(object[i]);
	      else while (++i < n) set.add(f(object[i], i, object));
	    }
	
	    return set;
	  }
	
	  function keys(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  }
	
	  function values(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  }
	
	  function entries(map) {
	    var entries = [];
	    for (var key in map) entries.push({key: key, value: map[key]});
	    return entries;
	  }
	
	  exports.nest = nest;
	  exports.set = set;
	  exports.map = map;
	  exports.keys = keys;
	  exports.values = values;
	  exports.entries = entries;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(207)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, function (exports,d3Color) { 'use strict';
	
	  function basis(t1, v0, v1, v2, v3) {
	    var t2 = t1 * t1, t3 = t2 * t1;
	    return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	        + (4 - 6 * t2 + 3 * t3) * v1
	        + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	        + t3 * v3) / 6;
	  }
	
	  function basis$1(values) {
	    var n = values.length - 1;
	    return function(t) {
	      var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	          v1 = values[i],
	          v2 = values[i + 1],
	          v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	          v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	      return basis((t - i / n) * n, v0, v1, v2, v3);
	    };
	  }
	
	  function basisClosed(values) {
	    var n = values.length;
	    return function(t) {
	      var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	          v0 = values[(i + n - 1) % n],
	          v1 = values[i % n],
	          v2 = values[(i + 1) % n],
	          v3 = values[(i + 2) % n];
	      return basis((t - i / n) * n, v0, v1, v2, v3);
	    };
	  }
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function linear(a, d) {
	    return function(t) {
	      return a + t * d;
	    };
	  }
	
	  function exponential(a, b, y) {
	    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	      return Math.pow(a + t * b, y);
	    };
	  }
	
	  function hue(a, b) {
	    var d = b - a;
	    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	  }
	
	  function gamma(y) {
	    return (y = +y) === 1 ? nogamma : function(a, b) {
	      return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	    };
	  }
	
	  function nogamma(a, b) {
	    var d = b - a;
	    return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	  }
	
	  var rgb$1 = (function rgbGamma(y) {
	    var color = gamma(y);
	
	    function rgb(start, end) {
	      var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	          g = color(start.g, end.g),
	          b = color(start.b, end.b),
	          opacity = color(start.opacity, end.opacity);
	      return function(t) {
	        start.r = r(t);
	        start.g = g(t);
	        start.b = b(t);
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    rgb.gamma = rgbGamma;
	
	    return rgb;
	  })(1);
	
	  function rgbSpline(spline) {
	    return function(colors) {
	      var n = colors.length,
	          r = new Array(n),
	          g = new Array(n),
	          b = new Array(n),
	          i, color;
	      for (i = 0; i < n; ++i) {
	        color = d3Color.rgb(colors[i]);
	        r[i] = color.r || 0;
	        g[i] = color.g || 0;
	        b[i] = color.b || 0;
	      }
	      r = spline(r);
	      g = spline(g);
	      b = spline(b);
	      color.opacity = 1;
	      return function(t) {
	        color.r = r(t);
	        color.g = g(t);
	        color.b = b(t);
	        return color + "";
	      };
	    };
	  }
	
	  var rgbBasis = rgbSpline(basis$1);
	  var rgbBasisClosed = rgbSpline(basisClosed);
	
	  function array(a, b) {
	    var nb = b ? b.length : 0,
	        na = a ? Math.min(nb, a.length) : 0,
	        x = new Array(nb),
	        c = new Array(nb),
	        i;
	
	    for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	    for (; i < nb; ++i) c[i] = b[i];
	
	    return function(t) {
	      for (i = 0; i < na; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	
	  function date(a, b) {
	    var d = new Date;
	    return a = +a, b -= a, function(t) {
	      return d.setTime(a + b * t), d;
	    };
	  }
	
	  function number(a, b) {
	    return a = +a, b -= a, function(t) {
	      return a + b * t;
	    };
	  }
	
	  function object(a, b) {
	    var i = {},
	        c = {},
	        k;
	
	    if (a === null || typeof a !== "object") a = {};
	    if (b === null || typeof b !== "object") b = {};
	
	    for (k in b) {
	      if (k in a) {
	        i[k] = value(a[k], b[k]);
	      } else {
	        c[k] = b[k];
	      }
	    }
	
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	
	  var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	  var reB = new RegExp(reA.source, "g");
	  function zero(b) {
	    return function() {
	      return b;
	    };
	  }
	
	  function one(b) {
	    return function(t) {
	      return b(t) + "";
	    };
	  }
	
	  function string(a, b) {
	    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	        am, // current match in a
	        bm, // current match in b
	        bs, // string preceding current number in b, if any
	        i = -1, // index in s
	        s = [], // string constants and placeholders
	        q = []; // number interpolators
	
	    // Coerce inputs to strings.
	    a = a + "", b = b + "";
	
	    // Interpolate pairs of numbers in a & b.
	    while ((am = reA.exec(a))
	        && (bm = reB.exec(b))) {
	      if ((bs = bm.index) > bi) { // a string precedes the next number in b
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; // coalesce with previous string
	        else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	        if (s[i]) s[i] += bm; // coalesce with previous string
	        else s[++i] = bm;
	      } else { // interpolate non-matching numbers
	        s[++i] = null;
	        q.push({i: i, x: number(am, bm)});
	      }
	      bi = reB.lastIndex;
	    }
	
	    // Add remains of b.
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	
	    // Special optimization for only a single match.
	    // Otherwise, interpolate each of the numbers and rejoin the string.
	    return s.length < 2 ? (q[0]
	        ? one(q[0].x)
	        : zero(b))
	        : (b = q.length, function(t) {
	            for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	            return s.join("");
	          });
	  }
	
	  function value(a, b) {
	    var t = typeof b, c;
	    return b == null || t === "boolean" ? constant(b)
	        : (t === "number" ? number
	        : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	        : b instanceof d3Color.color ? rgb$1
	        : b instanceof Date ? date
	        : Array.isArray(b) ? array
	        : isNaN(b) ? object
	        : number)(a, b);
	  }
	
	  function round(a, b) {
	    return a = +a, b -= a, function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	
	  var degrees = 180 / Math.PI;
	
	  var identity = {
	    translateX: 0,
	    translateY: 0,
	    rotate: 0,
	    skewX: 0,
	    scaleX: 1,
	    scaleY: 1
	  };
	
	  function decompose(a, b, c, d, e, f) {
	    var scaleX, scaleY, skewX;
	    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	    return {
	      translateX: e,
	      translateY: f,
	      rotate: Math.atan2(b, a) * degrees,
	      skewX: Math.atan(skewX) * degrees,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	
	  var cssNode;
	  var cssRoot;
	  var cssView;
	  var svgNode;
	  function parseCss(value) {
	    if (value === "none") return identity;
	    if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	    cssNode.style.transform = value;
	    value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	    cssRoot.removeChild(cssNode);
	    value = value.slice(7, -1).split(",");
	    return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	  }
	
	  function parseSvg(value) {
	    if (value == null) return identity;
	    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	    svgNode.setAttribute("transform", value);
	    if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	    value = value.matrix;
	    return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	  }
	
	  function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	    function pop(s) {
	      return s.length ? s.pop() + " " : "";
	    }
	
	    function translate(xa, ya, xb, yb, s, q) {
	      if (xa !== xb || ya !== yb) {
	        var i = s.push("translate(", null, pxComma, null, pxParen);
	        q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	      } else if (xb || yb) {
	        s.push("translate(" + xb + pxComma + yb + pxParen);
	      }
	    }
	
	    function rotate(a, b, s, q) {
	      if (a !== b) {
	        if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	        q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	      } else if (b) {
	        s.push(pop(s) + "rotate(" + b + degParen);
	      }
	    }
	
	    function skewX(a, b, s, q) {
	      if (a !== b) {
	        q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	      } else if (b) {
	        s.push(pop(s) + "skewX(" + b + degParen);
	      }
	    }
	
	    function scale(xa, ya, xb, yb, s, q) {
	      if (xa !== xb || ya !== yb) {
	        var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	        q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	      } else if (xb !== 1 || yb !== 1) {
	        s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	      }
	    }
	
	    return function(a, b) {
	      var s = [], // string constants and placeholders
	          q = []; // number interpolators
	      a = parse(a), b = parse(b);
	      translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	      rotate(a.rotate, b.rotate, s, q);
	      skewX(a.skewX, b.skewX, s, q);
	      scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	      a = b = null; // gc
	      return function(t) {
	        var i = -1, n = q.length, o;
	        while (++i < n) s[(o = q[i]).i] = o.x(t);
	        return s.join("");
	      };
	    };
	  }
	
	  var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	  var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	  var rho = Math.SQRT2;
	  var rho2 = 2;
	  var rho4 = 4;
	  var epsilon2 = 1e-12;
	  function cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	
	  function sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	
	  function tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	
	  // p0 = [ux0, uy0, w0]
	  // p1 = [ux1, uy1, w1]
	  function zoom(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	        ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	        dx = ux1 - ux0,
	        dy = uy1 - uy0,
	        d2 = dx * dx + dy * dy,
	        i,
	        S;
	
	    // Special case for u0 ≅ u1.
	    if (d2 < epsilon2) {
	      S = Math.log(w1 / w0) / rho;
	      i = function(t) {
	        return [
	          ux0 + t * dx,
	          uy0 + t * dy,
	          w0 * Math.exp(rho * t * S)
	        ];
	      }
	    }
	
	    // General case.
	    else {
	      var d1 = Math.sqrt(d2),
	          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / rho;
	      i = function(t) {
	        var s = t * S,
	            coshr0 = cosh(r0),
	            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	        return [
	          ux0 + u * dx,
	          uy0 + u * dy,
	          w0 * coshr0 / cosh(rho * s + r0)
	        ];
	      }
	    }
	
	    i.duration = S * 1000;
	
	    return i;
	  }
	
	  function hsl$1(hue) {
	    return function(start, end) {
	      var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(t);
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	  }
	
	  var hsl$2 = hsl$1(hue);
	  var hslLong = hsl$1(nogamma);
	
	  function lab$1(start, end) {
	    var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	        a = nogamma(start.a, end.a),
	        b = nogamma(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.l = l(t);
	      start.a = a(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  function hcl$1(hue) {
	    return function(start, end) {
	      var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	          c = nogamma(start.c, end.c),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.c = c(t);
	        start.l = l(t);
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	  }
	
	  var hcl$2 = hcl$1(hue);
	  var hclLong = hcl$1(nogamma);
	
	  function cubehelix$1(hue) {
	    return (function cubehelixGamma(y) {
	      y = +y;
	
	      function cubehelix(start, end) {
	        var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	            s = nogamma(start.s, end.s),
	            l = nogamma(start.l, end.l),
	            opacity = nogamma(start.opacity, end.opacity);
	        return function(t) {
	          start.h = h(t);
	          start.s = s(t);
	          start.l = l(Math.pow(t, y));
	          start.opacity = opacity(t);
	          return start + "";
	        };
	      }
	
	      cubehelix.gamma = cubehelixGamma;
	
	      return cubehelix;
	    })(1);
	  }
	
	  var cubehelix$2 = cubehelix$1(hue);
	  var cubehelixLong = cubehelix$1(nogamma);
	
	  function quantize(interpolator, n) {
	    var samples = new Array(n);
	    for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	    return samples;
	  }
	
	  exports.interpolate = value;
	  exports.interpolateArray = array;
	  exports.interpolateBasis = basis$1;
	  exports.interpolateBasisClosed = basisClosed;
	  exports.interpolateDate = date;
	  exports.interpolateNumber = number;
	  exports.interpolateObject = object;
	  exports.interpolateRound = round;
	  exports.interpolateString = string;
	  exports.interpolateTransformCss = interpolateTransformCss;
	  exports.interpolateTransformSvg = interpolateTransformSvg;
	  exports.interpolateZoom = zoom;
	  exports.interpolateRgb = rgb$1;
	  exports.interpolateRgbBasis = rgbBasis;
	  exports.interpolateRgbBasisClosed = rgbBasisClosed;
	  exports.interpolateHsl = hsl$2;
	  exports.interpolateHslLong = hslLong;
	  exports.interpolateLab = lab$1;
	  exports.interpolateHcl = hcl$2;
	  exports.interpolateHclLong = hclLong;
	  exports.interpolateCubehelix = cubehelix$2;
	  exports.interpolateCubehelixLong = cubehelixLong;
	  exports.quantize = quantize;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  function define(constructor, factory, prototype) {
	    constructor.prototype = factory.prototype = prototype;
	    prototype.constructor = constructor;
	  }
	
	  function extend(parent, definition) {
	    var prototype = Object.create(parent.prototype);
	    for (var key in definition) prototype[key] = definition[key];
	    return prototype;
	  }
	
	  function Color() {}
	
	  var darker = 0.7;
	  var brighter = 1 / darker;
	
	  var reHex3 = /^#([0-9a-f]{3})$/;
	  var reHex6 = /^#([0-9a-f]{6})$/;
	  var reRgbInteger = /^rgb\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*\)$/;
	  var reRgbPercent = /^rgb\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var reRgbaInteger = /^rgba\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	  var reRgbaPercent = /^rgba\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	  var reHslPercent = /^hsl\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var reHslaPercent = /^hsla\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	  var named = {
	    aliceblue: 0xf0f8ff,
	    antiquewhite: 0xfaebd7,
	    aqua: 0x00ffff,
	    aquamarine: 0x7fffd4,
	    azure: 0xf0ffff,
	    beige: 0xf5f5dc,
	    bisque: 0xffe4c4,
	    black: 0x000000,
	    blanchedalmond: 0xffebcd,
	    blue: 0x0000ff,
	    blueviolet: 0x8a2be2,
	    brown: 0xa52a2a,
	    burlywood: 0xdeb887,
	    cadetblue: 0x5f9ea0,
	    chartreuse: 0x7fff00,
	    chocolate: 0xd2691e,
	    coral: 0xff7f50,
	    cornflowerblue: 0x6495ed,
	    cornsilk: 0xfff8dc,
	    crimson: 0xdc143c,
	    cyan: 0x00ffff,
	    darkblue: 0x00008b,
	    darkcyan: 0x008b8b,
	    darkgoldenrod: 0xb8860b,
	    darkgray: 0xa9a9a9,
	    darkgreen: 0x006400,
	    darkgrey: 0xa9a9a9,
	    darkkhaki: 0xbdb76b,
	    darkmagenta: 0x8b008b,
	    darkolivegreen: 0x556b2f,
	    darkorange: 0xff8c00,
	    darkorchid: 0x9932cc,
	    darkred: 0x8b0000,
	    darksalmon: 0xe9967a,
	    darkseagreen: 0x8fbc8f,
	    darkslateblue: 0x483d8b,
	    darkslategray: 0x2f4f4f,
	    darkslategrey: 0x2f4f4f,
	    darkturquoise: 0x00ced1,
	    darkviolet: 0x9400d3,
	    deeppink: 0xff1493,
	    deepskyblue: 0x00bfff,
	    dimgray: 0x696969,
	    dimgrey: 0x696969,
	    dodgerblue: 0x1e90ff,
	    firebrick: 0xb22222,
	    floralwhite: 0xfffaf0,
	    forestgreen: 0x228b22,
	    fuchsia: 0xff00ff,
	    gainsboro: 0xdcdcdc,
	    ghostwhite: 0xf8f8ff,
	    gold: 0xffd700,
	    goldenrod: 0xdaa520,
	    gray: 0x808080,
	    green: 0x008000,
	    greenyellow: 0xadff2f,
	    grey: 0x808080,
	    honeydew: 0xf0fff0,
	    hotpink: 0xff69b4,
	    indianred: 0xcd5c5c,
	    indigo: 0x4b0082,
	    ivory: 0xfffff0,
	    khaki: 0xf0e68c,
	    lavender: 0xe6e6fa,
	    lavenderblush: 0xfff0f5,
	    lawngreen: 0x7cfc00,
	    lemonchiffon: 0xfffacd,
	    lightblue: 0xadd8e6,
	    lightcoral: 0xf08080,
	    lightcyan: 0xe0ffff,
	    lightgoldenrodyellow: 0xfafad2,
	    lightgray: 0xd3d3d3,
	    lightgreen: 0x90ee90,
	    lightgrey: 0xd3d3d3,
	    lightpink: 0xffb6c1,
	    lightsalmon: 0xffa07a,
	    lightseagreen: 0x20b2aa,
	    lightskyblue: 0x87cefa,
	    lightslategray: 0x778899,
	    lightslategrey: 0x778899,
	    lightsteelblue: 0xb0c4de,
	    lightyellow: 0xffffe0,
	    lime: 0x00ff00,
	    limegreen: 0x32cd32,
	    linen: 0xfaf0e6,
	    magenta: 0xff00ff,
	    maroon: 0x800000,
	    mediumaquamarine: 0x66cdaa,
	    mediumblue: 0x0000cd,
	    mediumorchid: 0xba55d3,
	    mediumpurple: 0x9370db,
	    mediumseagreen: 0x3cb371,
	    mediumslateblue: 0x7b68ee,
	    mediumspringgreen: 0x00fa9a,
	    mediumturquoise: 0x48d1cc,
	    mediumvioletred: 0xc71585,
	    midnightblue: 0x191970,
	    mintcream: 0xf5fffa,
	    mistyrose: 0xffe4e1,
	    moccasin: 0xffe4b5,
	    navajowhite: 0xffdead,
	    navy: 0x000080,
	    oldlace: 0xfdf5e6,
	    olive: 0x808000,
	    olivedrab: 0x6b8e23,
	    orange: 0xffa500,
	    orangered: 0xff4500,
	    orchid: 0xda70d6,
	    palegoldenrod: 0xeee8aa,
	    palegreen: 0x98fb98,
	    paleturquoise: 0xafeeee,
	    palevioletred: 0xdb7093,
	    papayawhip: 0xffefd5,
	    peachpuff: 0xffdab9,
	    peru: 0xcd853f,
	    pink: 0xffc0cb,
	    plum: 0xdda0dd,
	    powderblue: 0xb0e0e6,
	    purple: 0x800080,
	    rebeccapurple: 0x663399,
	    red: 0xff0000,
	    rosybrown: 0xbc8f8f,
	    royalblue: 0x4169e1,
	    saddlebrown: 0x8b4513,
	    salmon: 0xfa8072,
	    sandybrown: 0xf4a460,
	    seagreen: 0x2e8b57,
	    seashell: 0xfff5ee,
	    sienna: 0xa0522d,
	    silver: 0xc0c0c0,
	    skyblue: 0x87ceeb,
	    slateblue: 0x6a5acd,
	    slategray: 0x708090,
	    slategrey: 0x708090,
	    snow: 0xfffafa,
	    springgreen: 0x00ff7f,
	    steelblue: 0x4682b4,
	    tan: 0xd2b48c,
	    teal: 0x008080,
	    thistle: 0xd8bfd8,
	    tomato: 0xff6347,
	    turquoise: 0x40e0d0,
	    violet: 0xee82ee,
	    wheat: 0xf5deb3,
	    white: 0xffffff,
	    whitesmoke: 0xf5f5f5,
	    yellow: 0xffff00,
	    yellowgreen: 0x9acd32
	  };
	
	  define(Color, color, {
	    displayable: function() {
	      return this.rgb().displayable();
	    },
	    toString: function() {
	      return this.rgb() + "";
	    }
	  });
	
	  function color(format) {
	    var m;
	    format = (format + "").trim().toLowerCase();
	    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	        : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	        : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	        : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	        : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	        : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	        : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	        : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	        : named.hasOwnProperty(format) ? rgbn(named[format])
	        : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	        : null;
	  }
	
	  function rgbn(n) {
	    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	  }
	
	  function rgba(r, g, b, a) {
	    if (a <= 0) r = g = b = NaN;
	    return new Rgb(r, g, b, a);
	  }
	
	  function rgbConvert(o) {
	    if (!(o instanceof Color)) o = color(o);
	    if (!o) return new Rgb;
	    o = o.rgb();
	    return new Rgb(o.r, o.g, o.b, o.opacity);
	  }
	
	  function rgb(r, g, b, opacity) {
	    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	  }
	
	  function Rgb(r, g, b, opacity) {
	    this.r = +r;
	    this.g = +g;
	    this.b = +b;
	    this.opacity = +opacity;
	  }
	
	  define(Rgb, rgb, extend(Color, {
	    brighter: function(k) {
	      k = k == null ? brighter : Math.pow(brighter, k);
	      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	    },
	    darker: function(k) {
	      k = k == null ? darker : Math.pow(darker, k);
	      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	    },
	    rgb: function() {
	      return this;
	    },
	    displayable: function() {
	      return (0 <= this.r && this.r <= 255)
	          && (0 <= this.g && this.g <= 255)
	          && (0 <= this.b && this.b <= 255)
	          && (0 <= this.opacity && this.opacity <= 1);
	    },
	    toString: function() {
	      var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	      return (a === 1 ? "rgb(" : "rgba(")
	          + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	          + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	          + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	          + (a === 1 ? ")" : ", " + a + ")");
	    }
	  }));
	
	  function hsla(h, s, l, a) {
	    if (a <= 0) h = s = l = NaN;
	    else if (l <= 0 || l >= 1) h = s = NaN;
	    else if (s <= 0) h = NaN;
	    return new Hsl(h, s, l, a);
	  }
	
	  function hslConvert(o) {
	    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	    if (!(o instanceof Color)) o = color(o);
	    if (!o) return new Hsl;
	    if (o instanceof Hsl) return o;
	    o = o.rgb();
	    var r = o.r / 255,
	        g = o.g / 255,
	        b = o.b / 255,
	        min = Math.min(r, g, b),
	        max = Math.max(r, g, b),
	        h = NaN,
	        s = max - min,
	        l = (max + min) / 2;
	    if (s) {
	      if (r === max) h = (g - b) / s + (g < b) * 6;
	      else if (g === max) h = (b - r) / s + 2;
	      else h = (r - g) / s + 4;
	      s /= l < 0.5 ? max + min : 2 - max - min;
	      h *= 60;
	    } else {
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new Hsl(h, s, l, o.opacity);
	  }
	
	  function hsl(h, s, l, opacity) {
	    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	  }
	
	  function Hsl(h, s, l, opacity) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	    this.opacity = +opacity;
	  }
	
	  define(Hsl, hsl, extend(Color, {
	    brighter: function(k) {
	      k = k == null ? brighter : Math.pow(brighter, k);
	      return new Hsl(this.h, this.s, this.l * k, this.opacity);
	    },
	    darker: function(k) {
	      k = k == null ? darker : Math.pow(darker, k);
	      return new Hsl(this.h, this.s, this.l * k, this.opacity);
	    },
	    rgb: function() {
	      var h = this.h % 360 + (this.h < 0) * 360,
	          s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	          l = this.l,
	          m2 = l + (l < 0.5 ? l : 1 - l) * s,
	          m1 = 2 * l - m2;
	      return new Rgb(
	        hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	        hsl2rgb(h, m1, m2),
	        hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	        this.opacity
	      );
	    },
	    displayable: function() {
	      return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	          && (0 <= this.l && this.l <= 1)
	          && (0 <= this.opacity && this.opacity <= 1);
	    }
	  }));
	
	  /* From FvD 13.37, CSS Color Module Level 3 */
	  function hsl2rgb(h, m1, m2) {
	    return (h < 60 ? m1 + (m2 - m1) * h / 60
	        : h < 180 ? m2
	        : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	        : m1) * 255;
	  }
	
	  var deg2rad = Math.PI / 180;
	  var rad2deg = 180 / Math.PI;
	
	  var Kn = 18;
	  var Xn = 0.950470;
	  var Yn = 1;
	  var Zn = 1.088830;
	  var t0 = 4 / 29;
	  var t1 = 6 / 29;
	  var t2 = 3 * t1 * t1;
	  var t3 = t1 * t1 * t1;
	  function labConvert(o) {
	    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	    if (o instanceof Hcl) {
	      var h = o.h * deg2rad;
	      return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	    }
	    if (!(o instanceof Rgb)) o = rgbConvert(o);
	    var b = rgb2xyz(o.r),
	        a = rgb2xyz(o.g),
	        l = rgb2xyz(o.b),
	        x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	        y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	        z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	  }
	
	  function lab(l, a, b, opacity) {
	    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	  }
	
	  function Lab(l, a, b, opacity) {
	    this.l = +l;
	    this.a = +a;
	    this.b = +b;
	    this.opacity = +opacity;
	  }
	
	  define(Lab, lab, extend(Color, {
	    brighter: function(k) {
	      return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	    },
	    darker: function(k) {
	      return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	    },
	    rgb: function() {
	      var y = (this.l + 16) / 116,
	          x = isNaN(this.a) ? y : y + this.a / 500,
	          z = isNaN(this.b) ? y : y - this.b / 200;
	      y = Yn * lab2xyz(y);
	      x = Xn * lab2xyz(x);
	      z = Zn * lab2xyz(z);
	      return new Rgb(
	        xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	        xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	        xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	        this.opacity
	      );
	    }
	  }));
	
	  function xyz2lab(t) {
	    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	  }
	
	  function lab2xyz(t) {
	    return t > t1 ? t * t * t : t2 * (t - t0);
	  }
	
	  function xyz2rgb(x) {
	    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	  }
	
	  function rgb2xyz(x) {
	    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	  }
	
	  function hclConvert(o) {
	    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	    if (!(o instanceof Lab)) o = labConvert(o);
	    var h = Math.atan2(o.b, o.a) * rad2deg;
	    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	  }
	
	  function hcl(h, c, l, opacity) {
	    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	  }
	
	  function Hcl(h, c, l, opacity) {
	    this.h = +h;
	    this.c = +c;
	    this.l = +l;
	    this.opacity = +opacity;
	  }
	
	  define(Hcl, hcl, extend(Color, {
	    brighter: function(k) {
	      return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	    },
	    darker: function(k) {
	      return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	    },
	    rgb: function() {
	      return labConvert(this).rgb();
	    }
	  }));
	
	  var A = -0.14861;
	  var B = +1.78277;
	  var C = -0.29227;
	  var D = -0.90649;
	  var E = +1.97294;
	  var ED = E * D;
	  var EB = E * B;
	  var BC_DA = B * C - D * A;
	  function cubehelixConvert(o) {
	    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	    if (!(o instanceof Rgb)) o = rgbConvert(o);
	    var r = o.r / 255,
	        g = o.g / 255,
	        b = o.b / 255,
	        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	        bl = b - l,
	        k = (E * (g - l) - C * bl) / D,
	        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	        h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	  }
	
	  function cubehelix(h, s, l, opacity) {
	    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	  }
	
	  function Cubehelix(h, s, l, opacity) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	    this.opacity = +opacity;
	  }
	
	  define(Cubehelix, cubehelix, extend(Color, {
	    brighter: function(k) {
	      k = k == null ? brighter : Math.pow(brighter, k);
	      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	    },
	    darker: function(k) {
	      k = k == null ? darker : Math.pow(darker, k);
	      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	    },
	    rgb: function() {
	      var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	          l = +this.l,
	          a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	          cosh = Math.cos(h),
	          sinh = Math.sin(h);
	      return new Rgb(
	        255 * (l + a * (A * cosh + B * sinh)),
	        255 * (l + a * (C * cosh + D * sinh)),
	        255 * (l + a * (E * cosh)),
	        this.opacity
	      );
	    }
	  }));
	
	  exports.color = color;
	  exports.rgb = rgb;
	  exports.hsl = hsl;
	  exports.lab = lab;
	  exports.hcl = hcl;
	  exports.cubehelix = cubehelix;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  // Computes the decimal coefficient and exponent of the specified number x with
	  // significant digits p, where x is positive and p is in [1, 21] or undefined.
	  // For example, formatDecimal(1.23) returns ["123", 0].
	  function formatDecimal(x, p) {
	    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	    var i, coefficient = x.slice(0, i);
	
	    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	    return [
	      coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	      +x.slice(i + 1)
	    ];
	  }
	
	  function exponent(x) {
	    return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	  }
	
	  function formatGroup(grouping, thousands) {
	    return function(value, width) {
	      var i = value.length,
	          t = [],
	          j = 0,
	          g = grouping[0],
	          length = 0;
	
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = grouping[j = (j + 1) % grouping.length];
	      }
	
	      return t.reverse().join(thousands);
	    };
	  }
	
	  function formatDefault(x, p) {
	    x = x.toPrecision(p);
	
	    out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	      switch (x[i]) {
	        case ".": i0 = i1 = i; break;
	        case "0": if (i0 === 0) i0 = i; i1 = i; break;
	        case "e": break out;
	        default: if (i0 > 0) i0 = 0; break;
	      }
	    }
	
	    return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	  }
	
	  var prefixExponent;
	
	  function formatPrefixAuto(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1],
	        i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	        n = coefficient.length;
	    return i === n ? coefficient
	        : i > n ? coefficient + new Array(i - n + 1).join("0")
	        : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	        : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	  }
	
	  function formatRounded(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1];
	    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	        : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	        : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	  }
	
	  var formatTypes = {
	    "": formatDefault,
	    "%": function(x, p) { return (x * 100).toFixed(p); },
	    "b": function(x) { return Math.round(x).toString(2); },
	    "c": function(x) { return x + ""; },
	    "d": function(x) { return Math.round(x).toString(10); },
	    "e": function(x, p) { return x.toExponential(p); },
	    "f": function(x, p) { return x.toFixed(p); },
	    "g": function(x, p) { return x.toPrecision(p); },
	    "o": function(x) { return Math.round(x).toString(8); },
	    "p": function(x, p) { return formatRounded(x * 100, p); },
	    "r": formatRounded,
	    "s": formatPrefixAuto,
	    "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	    "x": function(x) { return Math.round(x).toString(16); }
	  };
	
	  // [[fill]align][sign][symbol][0][width][,][.precision][type]
	  var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	  function formatSpecifier(specifier) {
	    return new FormatSpecifier(specifier);
	  }
	
	  function FormatSpecifier(specifier) {
	    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	    var match,
	        fill = match[1] || " ",
	        align = match[2] || ">",
	        sign = match[3] || "-",
	        symbol = match[4] || "",
	        zero = !!match[5],
	        width = match[6] && +match[6],
	        comma = !!match[7],
	        precision = match[8] && +match[8].slice(1),
	        type = match[9] || "";
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // Map invalid types to the default format.
	    else if (!formatTypes[type]) type = "";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    this.fill = fill;
	    this.align = align;
	    this.sign = sign;
	    this.symbol = symbol;
	    this.zero = zero;
	    this.width = width;
	    this.comma = comma;
	    this.precision = precision;
	    this.type = type;
	  }
	
	  FormatSpecifier.prototype.toString = function() {
	    return this.fill
	        + this.align
	        + this.sign
	        + this.symbol
	        + (this.zero ? "0" : "")
	        + (this.width == null ? "" : Math.max(1, this.width | 0))
	        + (this.comma ? "," : "")
	        + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	        + this.type;
	  };
	
	  var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	  function identity(x) {
	    return x;
	  }
	
	  function formatLocale(locale) {
	    var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	        currency = locale.currency,
	        decimal = locale.decimal;
	
	    function newFormat(specifier) {
	      specifier = formatSpecifier(specifier);
	
	      var fill = specifier.fill,
	          align = specifier.align,
	          sign = specifier.sign,
	          symbol = specifier.symbol,
	          zero = specifier.zero,
	          width = specifier.width,
	          comma = specifier.comma,
	          precision = specifier.precision,
	          type = specifier.type;
	
	      // Compute the prefix and suffix.
	      // For SI-prefix, the suffix is lazily computed.
	      var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	          suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? "%" : "";
	
	      // What format function should we use?
	      // Is this an integer type?
	      // Can this type generate exponential notation?
	      var formatType = formatTypes[type],
	          maybeSuffix = !type || /[defgprs%]/.test(type);
	
	      // Set the default precision if not specified,
	      // or clamp the specified precision to the supported range.
	      // For significant precision, it must be in [1, 21].
	      // For fixed precision, it must be in [0, 20].
	      precision = precision == null ? (type ? 6 : 12)
	          : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	          : Math.max(0, Math.min(20, precision));
	
	      function format(value) {
	        var valuePrefix = prefix,
	            valueSuffix = suffix,
	            i, n, c;
	
	        if (type === "c") {
	          valueSuffix = formatType(value) + valueSuffix;
	          value = "";
	        } else {
	          value = +value;
	
	          // Convert negative to positive, and compute the prefix.
	          // Note that -0 is not less than 0, but 1 / -0 is!
	          var valueNegative = (value < 0 || 1 / value < 0) && (value *= -1, true);
	
	          // Perform the initial formatting.
	          value = formatType(value, precision);
	
	          // If the original value was negative, it may be rounded to zero during
	          // formatting; treat this as (positive) zero.
	          if (valueNegative) {
	            i = -1, n = value.length;
	            valueNegative = false;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), (48 < c && c < 58)
	                  || (type === "x" && 96 < c && c < 103)
	                  || (type === "X" && 64 < c && c < 71)) {
	                valueNegative = true;
	                break;
	              }
	            }
	          }
	
	          // Compute the prefix and suffix.
	          valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	          valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	          // Break the formatted value into the integer “value” part that can be
	          // grouped, and fractional or exponential “suffix” part that is not.
	          if (maybeSuffix) {
	            i = -1, n = value.length;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), 48 > c || c > 57) {
	                valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	                value = value.slice(0, i);
	                break;
	              }
	            }
	          }
	        }
	
	        // If the fill character is not "0", grouping is applied before padding.
	        if (comma && !zero) value = group(value, Infinity);
	
	        // Compute the padding.
	        var length = valuePrefix.length + value.length + valueSuffix.length,
	            padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	        // If the fill character is "0", grouping is applied after padding.
	        if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	        // Reconstruct the final output based on the desired alignment.
	        switch (align) {
	          case "<": return valuePrefix + value + valueSuffix + padding;
	          case "=": return valuePrefix + padding + value + valueSuffix;
	          case "^": return padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
	        }
	        return padding + valuePrefix + value + valueSuffix;
	      }
	
	      format.toString = function() {
	        return specifier + "";
	      };
	
	      return format;
	    }
	
	    function formatPrefix(specifier, value) {
	      var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	          e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	          k = Math.pow(10, -e),
	          prefix = prefixes[8 + e / 3];
	      return function(value) {
	        return f(k * value) + prefix;
	      };
	    }
	
	    return {
	      format: newFormat,
	      formatPrefix: formatPrefix
	    };
	  }
	
	  var locale;
	  defaultLocale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [3],
	    currency: ["$", ""]
	  });
	
	  function defaultLocale(definition) {
	    locale = formatLocale(definition);
	    exports.format = locale.format;
	    exports.formatPrefix = locale.formatPrefix;
	    return locale;
	  }
	
	  function precisionFixed(step) {
	    return Math.max(0, -exponent(Math.abs(step)));
	  }
	
	  function precisionPrefix(step, value) {
	    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	  }
	
	  function precisionRound(step, max) {
	    step = Math.abs(step), max = Math.abs(max) - step;
	    return Math.max(0, exponent(max) - exponent(step)) + 1;
	  }
	
	  exports.formatDefaultLocale = defaultLocale;
	  exports.formatLocale = formatLocale;
	  exports.formatSpecifier = formatSpecifier;
	  exports.precisionFixed = precisionFixed;
	  exports.precisionPrefix = precisionPrefix;
	  exports.precisionRound = precisionRound;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var t0 = new Date;
	  var t1 = new Date;
	  function newInterval(floori, offseti, count, field) {
	
	    function interval(date) {
	      return floori(date = new Date(+date)), date;
	    }
	
	    interval.floor = interval;
	
	    interval.ceil = function(date) {
	      return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	    };
	
	    interval.round = function(date) {
	      var d0 = interval(date),
	          d1 = interval.ceil(date);
	      return date - d0 < d1 - date ? d0 : d1;
	    };
	
	    interval.offset = function(date, step) {
	      return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	    };
	
	    interval.range = function(start, stop, step) {
	      var range = [];
	      start = interval.ceil(start);
	      step = step == null ? 1 : Math.floor(step);
	      if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	      do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	      return range;
	    };
	
	    interval.filter = function(test) {
	      return newInterval(function(date) {
	        while (floori(date), !test(date)) date.setTime(date - 1);
	      }, function(date, step) {
	        while (--step >= 0) while (offseti(date, 1), !test(date));
	      });
	    };
	
	    if (count) {
	      interval.count = function(start, end) {
	        t0.setTime(+start), t1.setTime(+end);
	        floori(t0), floori(t1);
	        return Math.floor(count(t0, t1));
	      };
	
	      interval.every = function(step) {
	        step = Math.floor(step);
	        return !isFinite(step) || !(step > 0) ? null
	            : !(step > 1) ? interval
	            : interval.filter(field
	                ? function(d) { return field(d) % step === 0; }
	                : function(d) { return interval.count(0, d) % step === 0; });
	      };
	    }
	
	    return interval;
	  }
	
	  var millisecond = newInterval(function() {
	    // noop
	  }, function(date, step) {
	    date.setTime(+date + step);
	  }, function(start, end) {
	    return end - start;
	  });
	
	  // An optimized implementation for this simple case.
	  millisecond.every = function(k) {
	    k = Math.floor(k);
	    if (!isFinite(k) || !(k > 0)) return null;
	    if (!(k > 1)) return millisecond;
	    return newInterval(function(date) {
	      date.setTime(Math.floor(date / k) * k);
	    }, function(date, step) {
	      date.setTime(+date + step * k);
	    }, function(start, end) {
	      return (end - start) / k;
	    });
	  };
	
	  var milliseconds = millisecond.range;
	
	  var durationSecond = 1e3;
	  var durationMinute = 6e4;
	  var durationHour = 36e5;
	  var durationDay = 864e5;
	  var durationWeek = 6048e5;
	
	  var second = newInterval(function(date) {
	    date.setTime(Math.floor(date / durationSecond) * durationSecond);
	  }, function(date, step) {
	    date.setTime(+date + step * durationSecond);
	  }, function(start, end) {
	    return (end - start) / durationSecond;
	  }, function(date) {
	    return date.getUTCSeconds();
	  });
	
	  var seconds = second.range;
	
	  var minute = newInterval(function(date) {
	    date.setTime(Math.floor(date / durationMinute) * durationMinute);
	  }, function(date, step) {
	    date.setTime(+date + step * durationMinute);
	  }, function(start, end) {
	    return (end - start) / durationMinute;
	  }, function(date) {
	    return date.getMinutes();
	  });
	
	  var minutes = minute.range;
	
	  var hour = newInterval(function(date) {
	    var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	    if (offset < 0) offset += durationHour;
	    date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	  }, function(date, step) {
	    date.setTime(+date + step * durationHour);
	  }, function(start, end) {
	    return (end - start) / durationHour;
	  }, function(date) {
	    return date.getHours();
	  });
	
	  var hours = hour.range;
	
	  var day = newInterval(function(date) {
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	
	  var days = day.range;
	
	  function weekday(i) {
	    return newInterval(function(date) {
	      date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	      date.setHours(0, 0, 0, 0);
	    }, function(date, step) {
	      date.setDate(date.getDate() + step * 7);
	    }, function(start, end) {
	      return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	    });
	  }
	
	  var sunday = weekday(0);
	  var monday = weekday(1);
	  var tuesday = weekday(2);
	  var wednesday = weekday(3);
	  var thursday = weekday(4);
	  var friday = weekday(5);
	  var saturday = weekday(6);
	
	  var sundays = sunday.range;
	  var mondays = monday.range;
	  var tuesdays = tuesday.range;
	  var wednesdays = wednesday.range;
	  var thursdays = thursday.range;
	  var fridays = friday.range;
	  var saturdays = saturday.range;
	
	  var month = newInterval(function(date) {
	    date.setDate(1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setMonth(date.getMonth() + step);
	  }, function(start, end) {
	    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	  }, function(date) {
	    return date.getMonth();
	  });
	
	  var months = month.range;
	
	  var year = newInterval(function(date) {
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step);
	  }, function(start, end) {
	    return end.getFullYear() - start.getFullYear();
	  }, function(date) {
	    return date.getFullYear();
	  });
	
	  // An optimized implementation for this simple case.
	  year.every = function(k) {
	    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	      date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	      date.setMonth(0, 1);
	      date.setHours(0, 0, 0, 0);
	    }, function(date, step) {
	      date.setFullYear(date.getFullYear() + step * k);
	    });
	  };
	
	  var years = year.range;
	
	  var utcMinute = newInterval(function(date) {
	    date.setUTCSeconds(0, 0);
	  }, function(date, step) {
	    date.setTime(+date + step * durationMinute);
	  }, function(start, end) {
	    return (end - start) / durationMinute;
	  }, function(date) {
	    return date.getUTCMinutes();
	  });
	
	  var utcMinutes = utcMinute.range;
	
	  var utcHour = newInterval(function(date) {
	    date.setUTCMinutes(0, 0, 0);
	  }, function(date, step) {
	    date.setTime(+date + step * durationHour);
	  }, function(start, end) {
	    return (end - start) / durationHour;
	  }, function(date) {
	    return date.getUTCHours();
	  });
	
	  var utcHours = utcHour.range;
	
	  var utcDay = newInterval(function(date) {
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step);
	  }, function(start, end) {
	    return (end - start) / durationDay;
	  }, function(date) {
	    return date.getUTCDate() - 1;
	  });
	
	  var utcDays = utcDay.range;
	
	  function utcWeekday(i) {
	    return newInterval(function(date) {
	      date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	      date.setUTCHours(0, 0, 0, 0);
	    }, function(date, step) {
	      date.setUTCDate(date.getUTCDate() + step * 7);
	    }, function(start, end) {
	      return (end - start) / durationWeek;
	    });
	  }
	
	  var utcSunday = utcWeekday(0);
	  var utcMonday = utcWeekday(1);
	  var utcTuesday = utcWeekday(2);
	  var utcWednesday = utcWeekday(3);
	  var utcThursday = utcWeekday(4);
	  var utcFriday = utcWeekday(5);
	  var utcSaturday = utcWeekday(6);
	
	  var utcSundays = utcSunday.range;
	  var utcMondays = utcMonday.range;
	  var utcTuesdays = utcTuesday.range;
	  var utcWednesdays = utcWednesday.range;
	  var utcThursdays = utcThursday.range;
	  var utcFridays = utcFriday.range;
	  var utcSaturdays = utcSaturday.range;
	
	  var utcMonth = newInterval(function(date) {
	    date.setUTCDate(1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCMonth(date.getUTCMonth() + step);
	  }, function(start, end) {
	    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	  }, function(date) {
	    return date.getUTCMonth();
	  });
	
	  var utcMonths = utcMonth.range;
	
	  var utcYear = newInterval(function(date) {
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step);
	  }, function(start, end) {
	    return end.getUTCFullYear() - start.getUTCFullYear();
	  }, function(date) {
	    return date.getUTCFullYear();
	  });
	
	  // An optimized implementation for this simple case.
	  utcYear.every = function(k) {
	    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	      date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	      date.setUTCMonth(0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	    }, function(date, step) {
	      date.setUTCFullYear(date.getUTCFullYear() + step * k);
	    });
	  };
	
	  var utcYears = utcYear.range;
	
	  exports.timeInterval = newInterval;
	  exports.timeMillisecond = millisecond;
	  exports.timeMilliseconds = milliseconds;
	  exports.utcMillisecond = millisecond;
	  exports.utcMilliseconds = milliseconds;
	  exports.timeSecond = second;
	  exports.timeSeconds = seconds;
	  exports.utcSecond = second;
	  exports.utcSeconds = seconds;
	  exports.timeMinute = minute;
	  exports.timeMinutes = minutes;
	  exports.timeHour = hour;
	  exports.timeHours = hours;
	  exports.timeDay = day;
	  exports.timeDays = days;
	  exports.timeWeek = sunday;
	  exports.timeWeeks = sundays;
	  exports.timeSunday = sunday;
	  exports.timeSundays = sundays;
	  exports.timeMonday = monday;
	  exports.timeMondays = mondays;
	  exports.timeTuesday = tuesday;
	  exports.timeTuesdays = tuesdays;
	  exports.timeWednesday = wednesday;
	  exports.timeWednesdays = wednesdays;
	  exports.timeThursday = thursday;
	  exports.timeThursdays = thursdays;
	  exports.timeFriday = friday;
	  exports.timeFridays = fridays;
	  exports.timeSaturday = saturday;
	  exports.timeSaturdays = saturdays;
	  exports.timeMonth = month;
	  exports.timeMonths = months;
	  exports.timeYear = year;
	  exports.timeYears = years;
	  exports.utcMinute = utcMinute;
	  exports.utcMinutes = utcMinutes;
	  exports.utcHour = utcHour;
	  exports.utcHours = utcHours;
	  exports.utcDay = utcDay;
	  exports.utcDays = utcDays;
	  exports.utcWeek = utcSunday;
	  exports.utcWeeks = utcSundays;
	  exports.utcSunday = utcSunday;
	  exports.utcSundays = utcSundays;
	  exports.utcMonday = utcMonday;
	  exports.utcMondays = utcMondays;
	  exports.utcTuesday = utcTuesday;
	  exports.utcTuesdays = utcTuesdays;
	  exports.utcWednesday = utcWednesday;
	  exports.utcWednesdays = utcWednesdays;
	  exports.utcThursday = utcThursday;
	  exports.utcThursdays = utcThursdays;
	  exports.utcFriday = utcFriday;
	  exports.utcFridays = utcFridays;
	  exports.utcSaturday = utcSaturday;
	  exports.utcSaturdays = utcSaturdays;
	  exports.utcMonth = utcMonth;
	  exports.utcMonths = utcMonths;
	  exports.utcYear = utcYear;
	  exports.utcYears = utcYears;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(209)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, function (exports,d3Time) { 'use strict';
	
	  function localDate(d) {
	    if (0 <= d.y && d.y < 100) {
	      var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	      date.setFullYear(d.y);
	      return date;
	    }
	    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	  }
	
	  function utcDate(d) {
	    if (0 <= d.y && d.y < 100) {
	      var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	      date.setUTCFullYear(d.y);
	      return date;
	    }
	    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	  }
	
	  function newYear(y) {
	    return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	  }
	
	  function formatLocale(locale) {
	    var locale_dateTime = locale.dateTime,
	        locale_date = locale.date,
	        locale_time = locale.time,
	        locale_periods = locale.periods,
	        locale_weekdays = locale.days,
	        locale_shortWeekdays = locale.shortDays,
	        locale_months = locale.months,
	        locale_shortMonths = locale.shortMonths;
	
	    var periodRe = formatRe(locale_periods),
	        periodLookup = formatLookup(locale_periods),
	        weekdayRe = formatRe(locale_weekdays),
	        weekdayLookup = formatLookup(locale_weekdays),
	        shortWeekdayRe = formatRe(locale_shortWeekdays),
	        shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	        monthRe = formatRe(locale_months),
	        monthLookup = formatLookup(locale_months),
	        shortMonthRe = formatRe(locale_shortMonths),
	        shortMonthLookup = formatLookup(locale_shortMonths);
	
	    var formats = {
	      "a": formatShortWeekday,
	      "A": formatWeekday,
	      "b": formatShortMonth,
	      "B": formatMonth,
	      "c": null,
	      "d": formatDayOfMonth,
	      "e": formatDayOfMonth,
	      "H": formatHour24,
	      "I": formatHour12,
	      "j": formatDayOfYear,
	      "L": formatMilliseconds,
	      "m": formatMonthNumber,
	      "M": formatMinutes,
	      "p": formatPeriod,
	      "S": formatSeconds,
	      "U": formatWeekNumberSunday,
	      "w": formatWeekdayNumber,
	      "W": formatWeekNumberMonday,
	      "x": null,
	      "X": null,
	      "y": formatYear,
	      "Y": formatFullYear,
	      "Z": formatZone,
	      "%": formatLiteralPercent
	    };
	
	    var utcFormats = {
	      "a": formatUTCShortWeekday,
	      "A": formatUTCWeekday,
	      "b": formatUTCShortMonth,
	      "B": formatUTCMonth,
	      "c": null,
	      "d": formatUTCDayOfMonth,
	      "e": formatUTCDayOfMonth,
	      "H": formatUTCHour24,
	      "I": formatUTCHour12,
	      "j": formatUTCDayOfYear,
	      "L": formatUTCMilliseconds,
	      "m": formatUTCMonthNumber,
	      "M": formatUTCMinutes,
	      "p": formatUTCPeriod,
	      "S": formatUTCSeconds,
	      "U": formatUTCWeekNumberSunday,
	      "w": formatUTCWeekdayNumber,
	      "W": formatUTCWeekNumberMonday,
	      "x": null,
	      "X": null,
	      "y": formatUTCYear,
	      "Y": formatUTCFullYear,
	      "Z": formatUTCZone,
	      "%": formatLiteralPercent
	    };
	
	    var parses = {
	      "a": parseShortWeekday,
	      "A": parseWeekday,
	      "b": parseShortMonth,
	      "B": parseMonth,
	      "c": parseLocaleDateTime,
	      "d": parseDayOfMonth,
	      "e": parseDayOfMonth,
	      "H": parseHour24,
	      "I": parseHour24,
	      "j": parseDayOfYear,
	      "L": parseMilliseconds,
	      "m": parseMonthNumber,
	      "M": parseMinutes,
	      "p": parsePeriod,
	      "S": parseSeconds,
	      "U": parseWeekNumberSunday,
	      "w": parseWeekdayNumber,
	      "W": parseWeekNumberMonday,
	      "x": parseLocaleDate,
	      "X": parseLocaleTime,
	      "y": parseYear,
	      "Y": parseFullYear,
	      "Z": parseZone,
	      "%": parseLiteralPercent
	    };
	
	    // These recursive directive definitions must be deferred.
	    formats.x = newFormat(locale_date, formats);
	    formats.X = newFormat(locale_time, formats);
	    formats.c = newFormat(locale_dateTime, formats);
	    utcFormats.x = newFormat(locale_date, utcFormats);
	    utcFormats.X = newFormat(locale_time, utcFormats);
	    utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	    function newFormat(specifier, formats) {
	      return function(date) {
	        var string = [],
	            i = -1,
	            j = 0,
	            n = specifier.length,
	            c,
	            pad,
	            format;
	
	        if (!(date instanceof Date)) date = new Date(+date);
	
	        while (++i < n) {
	          if (specifier.charCodeAt(i) === 37) {
	            string.push(specifier.slice(j, i));
	            if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	            else pad = c === "e" ? " " : "0";
	            if (format = formats[c]) c = format(date, pad);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	
	        string.push(specifier.slice(j, i));
	        return string.join("");
	      };
	    }
	
	    function newParse(specifier, newDate) {
	      return function(string) {
	        var d = newYear(1900),
	            i = parseSpecifier(d, specifier, string += "", 0);
	        if (i != string.length) return null;
	
	        // The am-pm flag is 0 for AM, and 1 for PM.
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	        // Convert day-of-week and week-of-year to day-of-year.
	        if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	          d.m = 0;
	          d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	        }
	
	        // If a time zone is specified, all fields are interpreted as UTC and then
	        // offset according to the specified time zone.
	        if ("Z" in d) {
	          d.H += d.Z / 100 | 0;
	          d.M += d.Z % 100;
	          return utcDate(d);
	        }
	
	        // Otherwise, all fields are in local time.
	        return newDate(d);
	      };
	    }
	
	    function parseSpecifier(d, specifier, string, j) {
	      var i = 0,
	          n = specifier.length,
	          m = string.length,
	          c,
	          parse;
	
	      while (i < n) {
	        if (j >= m) return -1;
	        c = specifier.charCodeAt(i++);
	        if (c === 37) {
	          c = specifier.charAt(i++);
	          parse = parses[c in pads ? specifier.charAt(i++) : c];
	          if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	
	      return j;
	    }
	
	    function parsePeriod(d, string, i) {
	      var n = periodRe.exec(string.slice(i));
	      return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseShortWeekday(d, string, i) {
	      var n = shortWeekdayRe.exec(string.slice(i));
	      return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseWeekday(d, string, i) {
	      var n = weekdayRe.exec(string.slice(i));
	      return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseShortMonth(d, string, i) {
	      var n = shortMonthRe.exec(string.slice(i));
	      return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseMonth(d, string, i) {
	      var n = monthRe.exec(string.slice(i));
	      return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseLocaleDateTime(d, string, i) {
	      return parseSpecifier(d, locale_dateTime, string, i);
	    }
	
	    function parseLocaleDate(d, string, i) {
	      return parseSpecifier(d, locale_date, string, i);
	    }
	
	    function parseLocaleTime(d, string, i) {
	      return parseSpecifier(d, locale_time, string, i);
	    }
	
	    function formatShortWeekday(d) {
	      return locale_shortWeekdays[d.getDay()];
	    }
	
	    function formatWeekday(d) {
	      return locale_weekdays[d.getDay()];
	    }
	
	    function formatShortMonth(d) {
	      return locale_shortMonths[d.getMonth()];
	    }
	
	    function formatMonth(d) {
	      return locale_months[d.getMonth()];
	    }
	
	    function formatPeriod(d) {
	      return locale_periods[+(d.getHours() >= 12)];
	    }
	
	    function formatUTCShortWeekday(d) {
	      return locale_shortWeekdays[d.getUTCDay()];
	    }
	
	    function formatUTCWeekday(d) {
	      return locale_weekdays[d.getUTCDay()];
	    }
	
	    function formatUTCShortMonth(d) {
	      return locale_shortMonths[d.getUTCMonth()];
	    }
	
	    function formatUTCMonth(d) {
	      return locale_months[d.getUTCMonth()];
	    }
	
	    function formatUTCPeriod(d) {
	      return locale_periods[+(d.getUTCHours() >= 12)];
	    }
	
	    return {
	      format: function(specifier) {
	        var f = newFormat(specifier += "", formats);
	        f.toString = function() { return specifier; };
	        return f;
	      },
	      parse: function(specifier) {
	        var p = newParse(specifier += "", localDate);
	        p.toString = function() { return specifier; };
	        return p;
	      },
	      utcFormat: function(specifier) {
	        var f = newFormat(specifier += "", utcFormats);
	        f.toString = function() { return specifier; };
	        return f;
	      },
	      utcParse: function(specifier) {
	        var p = newParse(specifier, utcDate);
	        p.toString = function() { return specifier; };
	        return p;
	      }
	    };
	  }
	
	  var pads = {"-": "", "_": " ", "0": "0"};
	  var numberRe = /^\s*\d+/;
	  var percentRe = /^%/;
	  var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  function pad(value, fill, width) {
	    var sign = value < 0 ? "-" : "",
	        string = (sign ? -value : value) + "",
	        length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	
	  function requote(s) {
	    return s.replace(requoteRe, "\\$&");
	  }
	
	  function formatRe(names) {
	    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	  }
	
	  function formatLookup(names) {
	    var map = {}, i = -1, n = names.length;
	    while (++i < n) map[names[i].toLowerCase()] = i;
	    return map;
	  }
	
	  function parseWeekdayNumber(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 1));
	    return n ? (d.w = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseWeekNumberSunday(d, string, i) {
	    var n = numberRe.exec(string.slice(i));
	    return n ? (d.U = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseWeekNumberMonday(d, string, i) {
	    var n = numberRe.exec(string.slice(i));
	    return n ? (d.W = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseFullYear(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 4));
	    return n ? (d.y = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseYear(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	  }
	
	  function parseZone(d, string, i) {
	    var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	  }
	
	  function parseMonthNumber(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	  }
	
	  function parseDayOfMonth(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.d = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseDayOfYear(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 3));
	    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseHour24(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.H = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseMinutes(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.M = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseSeconds(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.S = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseMilliseconds(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 3));
	    return n ? (d.L = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseLiteralPercent(d, string, i) {
	    var n = percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	
	  function formatDayOfMonth(d, p) {
	    return pad(d.getDate(), p, 2);
	  }
	
	  function formatHour24(d, p) {
	    return pad(d.getHours(), p, 2);
	  }
	
	  function formatHour12(d, p) {
	    return pad(d.getHours() % 12 || 12, p, 2);
	  }
	
	  function formatDayOfYear(d, p) {
	    return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	  }
	
	  function formatMilliseconds(d, p) {
	    return pad(d.getMilliseconds(), p, 3);
	  }
	
	  function formatMonthNumber(d, p) {
	    return pad(d.getMonth() + 1, p, 2);
	  }
	
	  function formatMinutes(d, p) {
	    return pad(d.getMinutes(), p, 2);
	  }
	
	  function formatSeconds(d, p) {
	    return pad(d.getSeconds(), p, 2);
	  }
	
	  function formatWeekNumberSunday(d, p) {
	    return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	  }
	
	  function formatWeekdayNumber(d) {
	    return d.getDay();
	  }
	
	  function formatWeekNumberMonday(d, p) {
	    return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	  }
	
	  function formatYear(d, p) {
	    return pad(d.getFullYear() % 100, p, 2);
	  }
	
	  function formatFullYear(d, p) {
	    return pad(d.getFullYear() % 10000, p, 4);
	  }
	
	  function formatZone(d) {
	    var z = d.getTimezoneOffset();
	    return (z > 0 ? "-" : (z *= -1, "+"))
	        + pad(z / 60 | 0, "0", 2)
	        + pad(z % 60, "0", 2);
	  }
	
	  function formatUTCDayOfMonth(d, p) {
	    return pad(d.getUTCDate(), p, 2);
	  }
	
	  function formatUTCHour24(d, p) {
	    return pad(d.getUTCHours(), p, 2);
	  }
	
	  function formatUTCHour12(d, p) {
	    return pad(d.getUTCHours() % 12 || 12, p, 2);
	  }
	
	  function formatUTCDayOfYear(d, p) {
	    return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	  }
	
	  function formatUTCMilliseconds(d, p) {
	    return pad(d.getUTCMilliseconds(), p, 3);
	  }
	
	  function formatUTCMonthNumber(d, p) {
	    return pad(d.getUTCMonth() + 1, p, 2);
	  }
	
	  function formatUTCMinutes(d, p) {
	    return pad(d.getUTCMinutes(), p, 2);
	  }
	
	  function formatUTCSeconds(d, p) {
	    return pad(d.getUTCSeconds(), p, 2);
	  }
	
	  function formatUTCWeekNumberSunday(d, p) {
	    return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	  }
	
	  function formatUTCWeekdayNumber(d) {
	    return d.getUTCDay();
	  }
	
	  function formatUTCWeekNumberMonday(d, p) {
	    return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	  }
	
	  function formatUTCYear(d, p) {
	    return pad(d.getUTCFullYear() % 100, p, 2);
	  }
	
	  function formatUTCFullYear(d, p) {
	    return pad(d.getUTCFullYear() % 10000, p, 4);
	  }
	
	  function formatUTCZone() {
	    return "+0000";
	  }
	
	  function formatLiteralPercent() {
	    return "%";
	  }
	
	  var locale;
	  defaultLocale({
	    dateTime: "%x, %X",
	    date: "%-m/%-d/%Y",
	    time: "%-I:%M:%S %p",
	    periods: ["AM", "PM"],
	    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	  });
	
	  function defaultLocale(definition) {
	    locale = formatLocale(definition);
	    exports.timeFormat = locale.format;
	    exports.timeParse = locale.parse;
	    exports.utcFormat = locale.utcFormat;
	    exports.utcParse = locale.utcParse;
	    return locale;
	  }
	
	  var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	  function formatIsoNative(date) {
	    return date.toISOString();
	  }
	
	  var formatIso = Date.prototype.toISOString
	      ? formatIsoNative
	      : exports.utcFormat(isoSpecifier);
	
	  function parseIsoNative(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  }
	
	  var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	      ? parseIsoNative
	      : exports.utcParse(isoSpecifier);
	
	  exports.timeFormatDefaultLocale = defaultLocale;
	  exports.timeFormatLocale = formatLocale;
	  exports.isoFormat = formatIso;
	  exports.isoParse = parseIso;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(212)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, function (exports,d3Path) { 'use strict';
	
	  function constant(x) {
	    return function constant() {
	      return x;
	    };
	  }
	
	  var epsilon = 1e-12;
	  var pi = Math.PI;
	  var halfPi = pi / 2;
	  var tau = 2 * pi;
	
	  function arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	
	  function arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	
	  function arcStartAngle(d) {
	    return d.startAngle;
	  }
	
	  function arcEndAngle(d) {
	    return d.endAngle;
	  }
	
	  function arcPadAngle(d) {
	    return d && d.padAngle; // Note: optional!
	  }
	
	  function asin(x) {
	    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	  }
	
	  function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	    var x10 = x1 - x0, y10 = y1 - y0,
	        x32 = x3 - x2, y32 = y3 - y2,
	        t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	    return [x0 + t * x10, y0 + t * y10];
	  }
	
	  // Compute perpendicular offset line of length rc.
	  // http://mathworld.wolfram.com/Circle-LineIntersection.html
	  function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	    var x01 = x0 - x1,
	        y01 = y0 - y1,
	        lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	        ox = lo * y01,
	        oy = -lo * x01,
	        x11 = x0 + ox,
	        y11 = y0 + oy,
	        x10 = x1 + ox,
	        y10 = y1 + oy,
	        x00 = (x11 + x10) / 2,
	        y00 = (y11 + y10) / 2,
	        dx = x10 - x11,
	        dy = y10 - y11,
	        d2 = dx * dx + dy * dy,
	        r = r1 - rc,
	        D = x11 * y10 - x10 * y11,
	        d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	        cx0 = (D * dy - dx * d) / d2,
	        cy0 = (-D * dx - dy * d) / d2,
	        cx1 = (D * dy + dx * d) / d2,
	        cy1 = (-D * dx + dy * d) / d2,
	        dx0 = cx0 - x00,
	        dy0 = cy0 - y00,
	        dx1 = cx1 - x00,
	        dy1 = cy1 - y00;
	
	    // Pick the closer of the two intersection points.
	    // TODO Is there a faster way to determine which intersection to use?
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	    return {
	      cx: cx0,
	      cy: cy0,
	      x01: -ox,
	      y01: -oy,
	      x11: cx0 * (r1 / r - 1),
	      y11: cy0 * (r1 / r - 1)
	    };
	  }
	
	  function arc() {
	    var innerRadius = arcInnerRadius,
	        outerRadius = arcOuterRadius,
	        cornerRadius = constant(0),
	        padRadius = null,
	        startAngle = arcStartAngle,
	        endAngle = arcEndAngle,
	        padAngle = arcPadAngle,
	        context = null;
	
	    function arc() {
	      var buffer,
	          r,
	          r0 = +innerRadius.apply(this, arguments),
	          r1 = +outerRadius.apply(this, arguments),
	          a0 = startAngle.apply(this, arguments) - halfPi,
	          a1 = endAngle.apply(this, arguments) - halfPi,
	          da = Math.abs(a1 - a0),
	          cw = a1 > a0;
	
	      if (!context) context = buffer = d3Path.path();
	
	      // Ensure that the outer radius is always larger than the inner radius.
	      if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	      // Is it a point?
	      if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	      // Or is it a circle or annulus?
	      else if (da > tau - epsilon) {
	        context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	        context.arc(0, 0, r1, a0, a1, !cw);
	        if (r0 > epsilon) {
	          context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	          context.arc(0, 0, r0, a1, a0, cw);
	        }
	      }
	
	      // Or is it a circular or annular sector?
	      else {
	        var a01 = a0,
	            a11 = a1,
	            a00 = a0,
	            a10 = a1,
	            da0 = da,
	            da1 = da,
	            ap = padAngle.apply(this, arguments) / 2,
	            rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	            rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	            rc0 = rc,
	            rc1 = rc,
	            t0,
	            t1;
	
	        // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	        if (rp > epsilon) {
	          var p0 = asin(rp / r0 * Math.sin(ap)),
	              p1 = asin(rp / r1 * Math.sin(ap));
	          if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	          else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	          if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	          else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	        }
	
	        var x01 = r1 * Math.cos(a01),
	            y01 = r1 * Math.sin(a01),
	            x10 = r0 * Math.cos(a10),
	            y10 = r0 * Math.sin(a10);
	
	        // Apply rounded corners?
	        if (rc > epsilon) {
	          var x11 = r1 * Math.cos(a11),
	              y11 = r1 * Math.sin(a11),
	              x00 = r0 * Math.cos(a00),
	              y00 = r0 * Math.sin(a00);
	
	          // Restrict the corner radius according to the sector angle.
	          if (da < pi) {
	            var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	                ax = x01 - oc[0],
	                ay = y01 - oc[1],
	                bx = x11 - oc[0],
	                by = y11 - oc[1],
	                kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	                lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	            rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	            rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	          }
	        }
	
	        // Is the sector collapsed to a line?
	        if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	        // Does the sector’s outer ring have rounded corners?
	        else if (rc1 > epsilon) {
	          t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	          t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	          context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	          // Have the corners merged?
	          if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	          // Otherwise, draw the two corners and the ring.
	          else {
	            context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	            context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	            context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	          }
	        }
	
	        // Or is the outer ring just a circular arc?
	        else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	        // Is there no inner ring, and it’s a circular sector?
	        // Or perhaps it’s an annular sector collapsed due to padding?
	        if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	        // Does the sector’s inner ring (or point) have rounded corners?
	        else if (rc0 > epsilon) {
	          t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	          t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	          context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	          // Have the corners merged?
	          if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	          // Otherwise, draw the two corners and the ring.
	          else {
	            context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	            context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	            context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	          }
	        }
	
	        // Or is the inner ring just a circular arc?
	        else context.arc(0, 0, r0, a10, a00, cw);
	      }
	
	      context.closePath();
	
	      if (buffer) return context = null, buffer + "" || null;
	    }
	
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	          a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	      return [Math.cos(a) * r, Math.sin(a) * r];
	    };
	
	    arc.innerRadius = function(_) {
	      return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	    };
	
	    arc.outerRadius = function(_) {
	      return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	    };
	
	    arc.cornerRadius = function(_) {
	      return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	    };
	
	    arc.padRadius = function(_) {
	      return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	    };
	
	    arc.startAngle = function(_) {
	      return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	    };
	
	    arc.endAngle = function(_) {
	      return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	    };
	
	    arc.padAngle = function(_) {
	      return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	    };
	
	    arc.context = function(_) {
	      return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	    };
	
	    return arc;
	  }
	
	  function Linear(context) {
	    this._context = context;
	  }
	
	  Linear.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._point = 0;
	    },
	    lineEnd: function() {
	      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	      this._line = 1 - this._line;
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	      switch (this._point) {
	        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	        case 1: this._point = 2; // proceed
	        default: this._context.lineTo(x, y); break;
	      }
	    }
	  };
	
	  function curveLinear(context) {
	    return new Linear(context);
	  }
	
	  function x(p) {
	    return p[0];
	  }
	
	  function y(p) {
	    return p[1];
	  }
	
	  function line() {
	    var x$$ = x,
	        y$$ = y,
	        defined = constant(true),
	        context = null,
	        curve = curveLinear,
	        output = null;
	
	    function line(data) {
	      var i,
	          n = data.length,
	          d,
	          defined0 = false,
	          buffer;
	
	      if (context == null) output = curve(buffer = d3Path.path());
	
	      for (i = 0; i <= n; ++i) {
	        if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	          if (defined0 = !defined0) output.lineStart();
	          else output.lineEnd();
	        }
	        if (defined0) output.point(+x$$(d, i, data), +y$$(d, i, data));
	      }
	
	      if (buffer) return output = null, buffer + "" || null;
	    }
	
	    line.x = function(_) {
	      return arguments.length ? (x$$ = typeof _ === "function" ? _ : constant(+_), line) : x$$;
	    };
	
	    line.y = function(_) {
	      return arguments.length ? (y$$ = typeof _ === "function" ? _ : constant(+_), line) : y$$;
	    };
	
	    line.defined = function(_) {
	      return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	    };
	
	    line.curve = function(_) {
	      return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	    };
	
	    line.context = function(_) {
	      return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	    };
	
	    return line;
	  }
	
	  function area() {
	    var x0 = x,
	        x1 = null,
	        y0 = constant(0),
	        y1 = y,
	        defined = constant(true),
	        context = null,
	        curve = curveLinear,
	        output = null;
	
	    function area(data) {
	      var i,
	          j,
	          k,
	          n = data.length,
	          d,
	          defined0 = false,
	          buffer,
	          x0z = new Array(n),
	          y0z = new Array(n);
	
	      if (context == null) output = curve(buffer = d3Path.path());
	
	      for (i = 0; i <= n; ++i) {
	        if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	          if (defined0 = !defined0) {
	            j = i;
	            output.areaStart();
	            output.lineStart();
	          } else {
	            output.lineEnd();
	            output.lineStart();
	            for (k = i - 1; k >= j; --k) {
	              output.point(x0z[k], y0z[k]);
	            }
	            output.lineEnd();
	            output.areaEnd();
	          }
	        }
	        if (defined0) {
	          x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	          output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	        }
	      }
	
	      if (buffer) return output = null, buffer + "" || null;
	    }
	
	    function arealine() {
	      return line().defined(defined).curve(curve).context(context);
	    }
	
	    area.x = function(_) {
	      return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	    };
	
	    area.x0 = function(_) {
	      return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	    };
	
	    area.x1 = function(_) {
	      return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	    };
	
	    area.y = function(_) {
	      return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	    };
	
	    area.y0 = function(_) {
	      return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	    };
	
	    area.y1 = function(_) {
	      return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	    };
	
	    area.lineX0 =
	    area.lineY0 = function() {
	      return arealine().x(x0).y(y0);
	    };
	
	    area.lineY1 = function() {
	      return arealine().x(x0).y(y1);
	    };
	
	    area.lineX1 = function() {
	      return arealine().x(x1).y(y0);
	    };
	
	    area.defined = function(_) {
	      return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	    };
	
	    area.curve = function(_) {
	      return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	    };
	
	    area.context = function(_) {
	      return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	    };
	
	    return area;
	  }
	
	  function descending(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  }
	
	  function identity(d) {
	    return d;
	  }
	
	  function pie() {
	    var value = identity,
	        sortValues = descending,
	        sort = null,
	        startAngle = constant(0),
	        endAngle = constant(tau),
	        padAngle = constant(0);
	
	    function pie(data) {
	      var i,
	          n = data.length,
	          j,
	          k,
	          sum = 0,
	          index = new Array(n),
	          arcs = new Array(n),
	          a0 = +startAngle.apply(this, arguments),
	          da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	          a1,
	          p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	          pa = p * (da < 0 ? -1 : 1),
	          v;
	
	      for (i = 0; i < n; ++i) {
	        if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	          sum += v;
	        }
	      }
	
	      // Optionally sort the arcs by previously-computed values or by data.
	      if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	      else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	      // Compute the arcs! They are stored in the original data's order.
	      for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	        j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	          data: data[j],
	          index: i,
	          value: v,
	          startAngle: a0,
	          endAngle: a1,
	          padAngle: p
	        };
	      }
	
	      return arcs;
	    }
	
	    pie.value = function(_) {
	      return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	    };
	
	    pie.sortValues = function(_) {
	      return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	    };
	
	    pie.sort = function(_) {
	      return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	    };
	
	    pie.startAngle = function(_) {
	      return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	    };
	
	    pie.endAngle = function(_) {
	      return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	    };
	
	    pie.padAngle = function(_) {
	      return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	    };
	
	    return pie;
	  }
	
	  var curveRadialLinear = curveRadial(curveLinear);
	
	  function Radial(curve) {
	    this._curve = curve;
	  }
	
	  Radial.prototype = {
	    areaStart: function() {
	      this._curve.areaStart();
	    },
	    areaEnd: function() {
	      this._curve.areaEnd();
	    },
	    lineStart: function() {
	      this._curve.lineStart();
	    },
	    lineEnd: function() {
	      this._curve.lineEnd();
	    },
	    point: function(a, r) {
	      this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	    }
	  };
	
	  function curveRadial(curve) {
	
	    function radial(context) {
	      return new Radial(curve(context));
	    }
	
	    radial._curve = curve;
	
	    return radial;
	  }
	
	  function radialLine(l) {
	    var c = l.curve;
	
	    l.angle = l.x, delete l.x;
	    l.radius = l.y, delete l.y;
	
	    l.curve = function(_) {
	      return arguments.length ? c(curveRadial(_)) : c()._curve;
	    };
	
	    return l;
	  }
	
	  function radialLine$1() {
	    return radialLine(line().curve(curveRadialLinear));
	  }
	
	  function radialArea() {
	    var a = area().curve(curveRadialLinear),
	        c = a.curve,
	        x0 = a.lineX0,
	        x1 = a.lineX1,
	        y0 = a.lineY0,
	        y1 = a.lineY1;
	
	    a.angle = a.x, delete a.x;
	    a.startAngle = a.x0, delete a.x0;
	    a.endAngle = a.x1, delete a.x1;
	    a.radius = a.y, delete a.y;
	    a.innerRadius = a.y0, delete a.y0;
	    a.outerRadius = a.y1, delete a.y1;
	    a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	    a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	    a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	    a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	    a.curve = function(_) {
	      return arguments.length ? c(curveRadial(_)) : c()._curve;
	    };
	
	    return a;
	  }
	
	  var circle = {
	    draw: function(context, size) {
	      var r = Math.sqrt(size / pi);
	      context.moveTo(r, 0);
	      context.arc(0, 0, r, 0, tau);
	    }
	  };
	
	  var cross = {
	    draw: function(context, size) {
	      var r = Math.sqrt(size / 5) / 2;
	      context.moveTo(-3 * r, -r);
	      context.lineTo(-r, -r);
	      context.lineTo(-r, -3 * r);
	      context.lineTo(r, -3 * r);
	      context.lineTo(r, -r);
	      context.lineTo(3 * r, -r);
	      context.lineTo(3 * r, r);
	      context.lineTo(r, r);
	      context.lineTo(r, 3 * r);
	      context.lineTo(-r, 3 * r);
	      context.lineTo(-r, r);
	      context.lineTo(-3 * r, r);
	      context.closePath();
	    }
	  };
	
	  var tan30 = Math.sqrt(1 / 3);
	  var tan30_2 = tan30 * 2;
	  var diamond = {
	    draw: function(context, size) {
	      var y = Math.sqrt(size / tan30_2),
	          x = y * tan30;
	      context.moveTo(0, -y);
	      context.lineTo(x, 0);
	      context.lineTo(0, y);
	      context.lineTo(-x, 0);
	      context.closePath();
	    }
	  };
	
	  var ka = 0.89081309152928522810;
	  var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	  var kx = Math.sin(tau / 10) * kr;
	  var ky = -Math.cos(tau / 10) * kr;
	  var star = {
	    draw: function(context, size) {
	      var r = Math.sqrt(size * ka),
	          x = kx * r,
	          y = ky * r;
	      context.moveTo(0, -r);
	      context.lineTo(x, y);
	      for (var i = 1; i < 5; ++i) {
	        var a = tau * i / 5,
	            c = Math.cos(a),
	            s = Math.sin(a);
	        context.lineTo(s * r, -c * r);
	        context.lineTo(c * x - s * y, s * x + c * y);
	      }
	      context.closePath();
	    }
	  };
	
	  var square = {
	    draw: function(context, size) {
	      var w = Math.sqrt(size),
	          x = -w / 2;
	      context.rect(x, x, w, w);
	    }
	  };
	
	  var sqrt3 = Math.sqrt(3);
	
	  var triangle = {
	    draw: function(context, size) {
	      var y = -Math.sqrt(size / (sqrt3 * 3));
	      context.moveTo(0, y * 2);
	      context.lineTo(-sqrt3 * y, -y);
	      context.lineTo(sqrt3 * y, -y);
	      context.closePath();
	    }
	  };
	
	  var c = -0.5;
	  var s = Math.sqrt(3) / 2;
	  var k = 1 / Math.sqrt(12);
	  var a = (k / 2 + 1) * 3;
	  var wye = {
	    draw: function(context, size) {
	      var r = Math.sqrt(size / a),
	          x0 = r / 2,
	          y0 = r * k,
	          x1 = x0,
	          y1 = r * k + r,
	          x2 = -x1,
	          y2 = y1;
	      context.moveTo(x0, y0);
	      context.lineTo(x1, y1);
	      context.lineTo(x2, y2);
	      context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	      context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	      context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	      context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	      context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	      context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	      context.closePath();
	    }
	  };
	
	  var symbols = [
	    circle,
	    cross,
	    diamond,
	    square,
	    star,
	    triangle,
	    wye
	  ];
	
	  function symbol() {
	    var type = constant(circle),
	        size = constant(64),
	        context = null;
	
	    function symbol() {
	      var buffer;
	      if (!context) context = buffer = d3Path.path();
	      type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	      if (buffer) return context = null, buffer + "" || null;
	    }
	
	    symbol.type = function(_) {
	      return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	    };
	
	    symbol.size = function(_) {
	      return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	    };
	
	    symbol.context = function(_) {
	      return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	    };
	
	    return symbol;
	  }
	
	  function noop() {}
	
	  function point(that, x, y) {
	    that._context.bezierCurveTo(
	      (2 * that._x0 + that._x1) / 3,
	      (2 * that._y0 + that._y1) / 3,
	      (that._x0 + 2 * that._x1) / 3,
	      (that._y0 + 2 * that._y1) / 3,
	      (that._x0 + 4 * that._x1 + x) / 6,
	      (that._y0 + 4 * that._y1 + y) / 6
	    );
	  }
	
	  function Basis(context) {
	    this._context = context;
	  }
	
	  Basis.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._x0 = this._x1 =
	      this._y0 = this._y1 = NaN;
	      this._point = 0;
	    },
	    lineEnd: function() {
	      switch (this._point) {
	        case 3: point(this, this._x1, this._y1); // proceed
	        case 2: this._context.lineTo(this._x1, this._y1); break;
	      }
	      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	      this._line = 1 - this._line;
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	      switch (this._point) {
	        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	        case 1: this._point = 2; break;
	        case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	        default: point(this, x, y); break;
	      }
	      this._x0 = this._x1, this._x1 = x;
	      this._y0 = this._y1, this._y1 = y;
	    }
	  };
	
	  function basis(context) {
	    return new Basis(context);
	  }
	
	  function BasisClosed(context) {
	    this._context = context;
	  }
	
	  BasisClosed.prototype = {
	    areaStart: noop,
	    areaEnd: noop,
	    lineStart: function() {
	      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	      this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	      this._point = 0;
	    },
	    lineEnd: function() {
	      switch (this._point) {
	        case 1: {
	          this._context.moveTo(this._x2, this._y2);
	          this._context.closePath();
	          break;
	        }
	        case 2: {
	          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	          this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	          this._context.closePath();
	          break;
	        }
	        case 3: {
	          this.point(this._x2, this._y2);
	          this.point(this._x3, this._y3);
	          this.point(this._x4, this._y4);
	          break;
	        }
	      }
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	      switch (this._point) {
	        case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	        case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	        case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	        default: point(this, x, y); break;
	      }
	      this._x0 = this._x1, this._x1 = x;
	      this._y0 = this._y1, this._y1 = y;
	    }
	  };
	
	  function basisClosed(context) {
	    return new BasisClosed(context);
	  }
	
	  function BasisOpen(context) {
	    this._context = context;
	  }
	
	  BasisOpen.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._x0 = this._x1 =
	      this._y0 = this._y1 = NaN;
	      this._point = 0;
	    },
	    lineEnd: function() {
	      if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	      this._line = 1 - this._line;
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	      switch (this._point) {
	        case 0: this._point = 1; break;
	        case 1: this._point = 2; break;
	        case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	        case 3: this._point = 4; // proceed
	        default: point(this, x, y); break;
	      }
	      this._x0 = this._x1, this._x1 = x;
	      this._y0 = this._y1, this._y1 = y;
	    }
	  };
	
	  function basisOpen(context) {
	    return new BasisOpen(context);
	  }
	
	  function Bundle(context, beta) {
	    this._basis = new Basis(context);
	    this._beta = beta;
	  }
	
	  Bundle.prototype = {
	    lineStart: function() {
	      this._x = [];
	      this._y = [];
	      this._basis.lineStart();
	    },
	    lineEnd: function() {
	      var x = this._x,
	          y = this._y,
	          j = x.length - 1;
	
	      if (j > 0) {
	        var x0 = x[0],
	            y0 = y[0],
	            dx = x[j] - x0,
	            dy = y[j] - y0,
	            i = -1,
	            t;
	
	        while (++i <= j) {
	          t = i / j;
	          this._basis.point(
	            this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	            this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	          );
	        }
	      }
	
	      this._x = this._y = null;
	      this._basis.lineEnd();
	    },
	    point: function(x, y) {
	      this._x.push(+x);
	      this._y.push(+y);
	    }
	  };
	
	  var bundle = (function custom(beta) {
	
	    function bundle(context) {
	      return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	    }
	
	    bundle.beta = function(beta) {
	      return custom(+beta);
	    };
	
	    return bundle;
	  })(0.85);
	
	  function point$1(that, x, y) {
	    that._context.bezierCurveTo(
	      that._x1 + that._k * (that._x2 - that._x0),
	      that._y1 + that._k * (that._y2 - that._y0),
	      that._x2 + that._k * (that._x1 - x),
	      that._y2 + that._k * (that._y1 - y),
	      that._x2,
	      that._y2
	    );
	  }
	
	  function Cardinal(context, tension) {
	    this._context = context;
	    this._k = (1 - tension) / 6;
	  }
	
	  Cardinal.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._x0 = this._x1 = this._x2 =
	      this._y0 = this._y1 = this._y2 = NaN;
	      this._point = 0;
	    },
	    lineEnd: function() {
	      switch (this._point) {
	        case 2: this._context.lineTo(this._x2, this._y2); break;
	        case 3: point$1(this, this._x1, this._y1); break;
	      }
	      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	      this._line = 1 - this._line;
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	      switch (this._point) {
	        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	        case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	        case 2: this._point = 3; // proceed
	        default: point$1(this, x, y); break;
	      }
	      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	    }
	  };
	
	  var cardinal = (function custom(tension) {
	
	    function cardinal(context) {
	      return new Cardinal(context, tension);
	    }
	
	    cardinal.tension = function(tension) {
	      return custom(+tension);
	    };
	
	    return cardinal;
	  })(0);
	
	  function CardinalClosed(context, tension) {
	    this._context = context;
	    this._k = (1 - tension) / 6;
	  }
	
	  CardinalClosed.prototype = {
	    areaStart: noop,
	    areaEnd: noop,
	    lineStart: function() {
	      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	      this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	      this._point = 0;
	    },
	    lineEnd: function() {
	      switch (this._point) {
	        case 1: {
	          this._context.moveTo(this._x3, this._y3);
	          this._context.closePath();
	          break;
	        }
	        case 2: {
	          this._context.lineTo(this._x3, this._y3);
	          this._context.closePath();
	          break;
	        }
	        case 3: {
	          this.point(this._x3, this._y3);
	          this.point(this._x4, this._y4);
	          this.point(this._x5, this._y5);
	          break;
	        }
	      }
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	      switch (this._point) {
	        case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	        case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	        case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	        default: point$1(this, x, y); break;
	      }
	      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	    }
	  };
	
	  var cardinalClosed = (function custom(tension) {
	
	    function cardinal(context) {
	      return new CardinalClosed(context, tension);
	    }
	
	    cardinal.tension = function(tension) {
	      return custom(+tension);
	    };
	
	    return cardinal;
	  })(0);
	
	  function CardinalOpen(context, tension) {
	    this._context = context;
	    this._k = (1 - tension) / 6;
	  }
	
	  CardinalOpen.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._x0 = this._x1 = this._x2 =
	      this._y0 = this._y1 = this._y2 = NaN;
	      this._point = 0;
	    },
	    lineEnd: function() {
	      if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	      this._line = 1 - this._line;
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	      switch (this._point) {
	        case 0: this._point = 1; break;
	        case 1: this._point = 2; break;
	        case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	        case 3: this._point = 4; // proceed
	        default: point$1(this, x, y); break;
	      }
	      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	    }
	  };
	
	  var cardinalOpen = (function custom(tension) {
	
	    function cardinal(context) {
	      return new CardinalOpen(context, tension);
	    }
	
	    cardinal.tension = function(tension) {
	      return custom(+tension);
	    };
	
	    return cardinal;
	  })(0);
	
	  function point$2(that, x, y) {
	    var x1 = that._x1,
	        y1 = that._y1,
	        x2 = that._x2,
	        y2 = that._y2;
	
	    if (that._l01_a > epsilon) {
	      var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	          n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	      x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	      y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	    }
	
	    if (that._l23_a > epsilon) {
	      var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	          m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	      x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	      y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	    }
	
	    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	  }
	
	  function CatmullRom(context, alpha) {
	    this._context = context;
	    this._alpha = alpha;
	  }
	
	  CatmullRom.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._x0 = this._x1 = this._x2 =
	      this._y0 = this._y1 = this._y2 = NaN;
	      this._l01_a = this._l12_a = this._l23_a =
	      this._l01_2a = this._l12_2a = this._l23_2a =
	      this._point = 0;
	    },
	    lineEnd: function() {
	      switch (this._point) {
	        case 2: this._context.lineTo(this._x2, this._y2); break;
	        case 3: this.point(this, this._x2, this._y2); break;
	      }
	      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	      this._line = 1 - this._line;
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	
	      if (this._point) {
	        var x23 = this._x2 - x,
	            y23 = this._y2 - y;
	        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	      }
	
	      switch (this._point) {
	        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	        case 1: this._point = 2; break;
	        case 2: this._point = 3; // proceed
	        default: point$2(this, x, y); break;
	      }
	
	      this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	      this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	    }
	  };
	
	  var catmullRom = (function custom(alpha) {
	
	    function catmullRom(context) {
	      return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	    }
	
	    catmullRom.alpha = function(alpha) {
	      return custom(+alpha);
	    };
	
	    return catmullRom;
	  })(0.5);
	
	  function CatmullRomClosed(context, alpha) {
	    this._context = context;
	    this._alpha = alpha;
	  }
	
	  CatmullRomClosed.prototype = {
	    areaStart: noop,
	    areaEnd: noop,
	    lineStart: function() {
	      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	      this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	      this._l01_a = this._l12_a = this._l23_a =
	      this._l01_2a = this._l12_2a = this._l23_2a =
	      this._point = 0;
	    },
	    lineEnd: function() {
	      switch (this._point) {
	        case 1: {
	          this._context.moveTo(this._x3, this._y3);
	          this._context.closePath();
	          break;
	        }
	        case 2: {
	          this._context.lineTo(this._x3, this._y3);
	          this._context.closePath();
	          break;
	        }
	        case 3: {
	          this.point(this._x3, this._y3);
	          this.point(this._x4, this._y4);
	          this.point(this._x5, this._y5);
	          break;
	        }
	      }
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	
	      if (this._point) {
	        var x23 = this._x2 - x,
	            y23 = this._y2 - y;
	        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	      }
	
	      switch (this._point) {
	        case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	        case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	        case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	        default: point$2(this, x, y); break;
	      }
	
	      this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	      this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	    }
	  };
	
	  var catmullRomClosed = (function custom(alpha) {
	
	    function catmullRom(context) {
	      return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	    }
	
	    catmullRom.alpha = function(alpha) {
	      return custom(+alpha);
	    };
	
	    return catmullRom;
	  })(0.5);
	
	  function CatmullRomOpen(context, alpha) {
	    this._context = context;
	    this._alpha = alpha;
	  }
	
	  CatmullRomOpen.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._x0 = this._x1 = this._x2 =
	      this._y0 = this._y1 = this._y2 = NaN;
	      this._l01_a = this._l12_a = this._l23_a =
	      this._l01_2a = this._l12_2a = this._l23_2a =
	      this._point = 0;
	    },
	    lineEnd: function() {
	      if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	      this._line = 1 - this._line;
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	
	      if (this._point) {
	        var x23 = this._x2 - x,
	            y23 = this._y2 - y;
	        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	      }
	
	      switch (this._point) {
	        case 0: this._point = 1; break;
	        case 1: this._point = 2; break;
	        case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	        case 3: this._point = 4; // proceed
	        default: point$2(this, x, y); break;
	      }
	
	      this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	      this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	    }
	  };
	
	  var catmullRomOpen = (function custom(alpha) {
	
	    function catmullRom(context) {
	      return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	    }
	
	    catmullRom.alpha = function(alpha) {
	      return custom(+alpha);
	    };
	
	    return catmullRom;
	  })(0.5);
	
	  function LinearClosed(context) {
	    this._context = context;
	  }
	
	  LinearClosed.prototype = {
	    areaStart: noop,
	    areaEnd: noop,
	    lineStart: function() {
	      this._point = 0;
	    },
	    lineEnd: function() {
	      if (this._point) this._context.closePath();
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	      if (this._point) this._context.lineTo(x, y);
	      else this._point = 1, this._context.moveTo(x, y);
	    }
	  };
	
	  function linearClosed(context) {
	    return new LinearClosed(context);
	  }
	
	  function sign(x) {
	    return x < 0 ? -1 : 1;
	  }
	
	  // Calculate the slopes of the tangents (Hermite-type interpolation) based on
	  // the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	  // Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	  // NOV(II), P. 443, 1990.
	  function slope3(that, x2, y2) {
	    var h0 = that._x1 - that._x0,
	        h1 = x2 - that._x1,
	        s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	        s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	        p = (s0 * h1 + s1 * h0) / (h0 + h1);
	    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	  }
	
	  // Calculate a one-sided slope.
	  function slope2(that, t) {
	    var h = that._x1 - that._x0;
	    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	  }
	
	  // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	  // "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	  // with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	  function point$3(that, t0, t1) {
	    var x0 = that._x0,
	        y0 = that._y0,
	        x1 = that._x1,
	        y1 = that._y1,
	        dx = (x1 - x0) / 3;
	    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	  }
	
	  function MonotoneX(context) {
	    this._context = context;
	  }
	
	  MonotoneX.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._x0 = this._x1 =
	      this._y0 = this._y1 =
	      this._t0 = NaN;
	      this._point = 0;
	    },
	    lineEnd: function() {
	      switch (this._point) {
	        case 2: this._context.lineTo(this._x1, this._y1); break;
	        case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	      }
	      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	      this._line = 1 - this._line;
	    },
	    point: function(x, y) {
	      var t1 = NaN;
	
	      x = +x, y = +y;
	      if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	      switch (this._point) {
	        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	        case 1: this._point = 2; break;
	        case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	        default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	      }
	
	      this._x0 = this._x1, this._x1 = x;
	      this._y0 = this._y1, this._y1 = y;
	      this._t0 = t1;
	    }
	  }
	
	  function MonotoneY(context) {
	    this._context = new ReflectContext(context);
	  }
	
	  (MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	    MonotoneX.prototype.point.call(this, y, x);
	  };
	
	  function ReflectContext(context) {
	    this._context = context;
	  }
	
	  ReflectContext.prototype = {
	    moveTo: function(x, y) { this._context.moveTo(y, x); },
	    closePath: function() { this._context.closePath(); },
	    lineTo: function(x, y) { this._context.lineTo(y, x); },
	    bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	  };
	
	  function monotoneX(context) {
	    return new MonotoneX(context);
	  }
	
	  function monotoneY(context) {
	    return new MonotoneY(context);
	  }
	
	  function Natural(context) {
	    this._context = context;
	  }
	
	  Natural.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._x = [];
	      this._y = [];
	    },
	    lineEnd: function() {
	      var x = this._x,
	          y = this._y,
	          n = x.length;
	
	      if (n) {
	        this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	        if (n === 2) {
	          this._context.lineTo(x[1], y[1]);
	        } else {
	          var px = controlPoints(x),
	              py = controlPoints(y);
	          for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	            this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	          }
	        }
	      }
	
	      if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	      this._line = 1 - this._line;
	      this._x = this._y = null;
	    },
	    point: function(x, y) {
	      this._x.push(+x);
	      this._y.push(+y);
	    }
	  };
	
	  // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	  function controlPoints(x) {
	    var i,
	        n = x.length - 1,
	        m,
	        a = new Array(n),
	        b = new Array(n),
	        r = new Array(n);
	    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	    for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	    for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	    a[n - 1] = r[n - 1] / b[n - 1];
	    for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	    b[n - 1] = (x[n] + a[n - 1]) / 2;
	    for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	    return [a, b];
	  }
	
	  function natural(context) {
	    return new Natural(context);
	  }
	
	  function Step(context, t) {
	    this._context = context;
	    this._t = t;
	  }
	
	  Step.prototype = {
	    areaStart: function() {
	      this._line = 0;
	    },
	    areaEnd: function() {
	      this._line = NaN;
	    },
	    lineStart: function() {
	      this._x = this._y = NaN;
	      this._point = 0;
	    },
	    lineEnd: function() {
	      if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	      if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	    },
	    point: function(x, y) {
	      x = +x, y = +y;
	      switch (this._point) {
	        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	        case 1: this._point = 2; // proceed
	        default: {
	          if (this._t <= 0) {
	            this._context.lineTo(this._x, y);
	            this._context.lineTo(x, y);
	          } else {
	            var x1 = this._x * (1 - this._t) + x * this._t;
	            this._context.lineTo(x1, this._y);
	            this._context.lineTo(x1, y);
	          }
	          break;
	        }
	      }
	      this._x = x, this._y = y;
	    }
	  };
	
	  function step(context) {
	    return new Step(context, 0.5);
	  }
	
	  function stepBefore(context) {
	    return new Step(context, 0);
	  }
	
	  function stepAfter(context) {
	    return new Step(context, 1);
	  }
	
	  var slice = Array.prototype.slice;
	
	  function none(series, order) {
	    if (!((n = series.length) > 1)) return;
	    for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	      s0 = s1, s1 = series[order[i]];
	      for (var j = 0; j < m; ++j) {
	        s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	      }
	    }
	  }
	
	  function none$1(series) {
	    var n = series.length, o = new Array(n);
	    while (--n >= 0) o[n] = n;
	    return o;
	  }
	
	  function stackValue(d, key) {
	    return d[key];
	  }
	
	  function stack() {
	    var keys = constant([]),
	        order = none$1,
	        offset = none,
	        value = stackValue;
	
	    function stack(data) {
	      var kz = keys.apply(this, arguments),
	          i,
	          m = data.length,
	          n = kz.length,
	          sz = new Array(n),
	          oz;
	
	      for (i = 0; i < n; ++i) {
	        for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	          si[j] = sij = [0, +value(data[j], ki, j, data)];
	          sij.data = data[j];
	        }
	        si.key = ki;
	      }
	
	      for (i = 0, oz = order(sz); i < n; ++i) {
	        sz[oz[i]].index = i;
	      }
	
	      offset(sz, oz);
	      return sz;
	    }
	
	    stack.keys = function(_) {
	      return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	    };
	
	    stack.value = function(_) {
	      return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	    };
	
	    stack.order = function(_) {
	      return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	    };
	
	    stack.offset = function(_) {
	      return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	    };
	
	    return stack;
	  }
	
	  function expand(series, order) {
	    if (!((n = series.length) > 0)) return;
	    for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	      for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	      if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	    }
	    none(series, order);
	  }
	
	  function silhouette(series, order) {
	    if (!((n = series.length) > 0)) return;
	    for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	      for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	      s0[j][1] += s0[j][0] = -y / 2;
	    }
	    none(series, order);
	  }
	
	  function wiggle(series, order) {
	    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	    for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	      for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	        var si = series[order[i]],
	            sij0 = si[j][1] || 0,
	            sij1 = si[j - 1][1] || 0,
	            s3 = (sij0 - sij1) / 2;
	        for (var k = 0; k < i; ++k) {
	          var sk = series[order[k]],
	              skj0 = sk[j][1] || 0,
	              skj1 = sk[j - 1][1] || 0;
	          s3 += skj0 - skj1;
	        }
	        s1 += sij0, s2 += s3 * sij0;
	      }
	      s0[j - 1][1] += s0[j - 1][0] = y;
	      if (s1) y -= s2 / s1;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    none(series, order);
	  }
	
	  function ascending(series) {
	    var sums = series.map(sum);
	    return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	  }
	
	  function sum(series) {
	    var s = 0, i = -1, n = series.length, v;
	    while (++i < n) if (v = +series[i][1]) s += v;
	    return s;
	  }
	
	  function descending$1(series) {
	    return ascending(series).reverse();
	  }
	
	  function insideOut(series) {
	    var n = series.length,
	        i,
	        j,
	        sums = series.map(sum),
	        order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	        top = 0,
	        bottom = 0,
	        tops = [],
	        bottoms = [];
	
	    for (i = 0; i < n; ++i) {
	      j = order[i];
	      if (top < bottom) {
	        top += sums[j];
	        tops.push(j);
	      } else {
	        bottom += sums[j];
	        bottoms.push(j);
	      }
	    }
	
	    return bottoms.reverse().concat(tops);
	  }
	
	  function reverse(series) {
	    return none$1(series).reverse();
	  }
	
	  exports.arc = arc;
	  exports.area = area;
	  exports.line = line;
	  exports.pie = pie;
	  exports.radialArea = radialArea;
	  exports.radialLine = radialLine$1;
	  exports.symbol = symbol;
	  exports.symbols = symbols;
	  exports.symbolCircle = circle;
	  exports.symbolCross = cross;
	  exports.symbolDiamond = diamond;
	  exports.symbolSquare = square;
	  exports.symbolStar = star;
	  exports.symbolTriangle = triangle;
	  exports.symbolWye = wye;
	  exports.curveBasisClosed = basisClosed;
	  exports.curveBasisOpen = basisOpen;
	  exports.curveBasis = basis;
	  exports.curveBundle = bundle;
	  exports.curveCardinalClosed = cardinalClosed;
	  exports.curveCardinalOpen = cardinalOpen;
	  exports.curveCardinal = cardinal;
	  exports.curveCatmullRomClosed = catmullRomClosed;
	  exports.curveCatmullRomOpen = catmullRomOpen;
	  exports.curveCatmullRom = catmullRom;
	  exports.curveLinearClosed = linearClosed;
	  exports.curveLinear = curveLinear;
	  exports.curveMonotoneX = monotoneX;
	  exports.curveMonotoneY = monotoneY;
	  exports.curveNatural = natural;
	  exports.curveStep = step;
	  exports.curveStepAfter = stepAfter;
	  exports.curveStepBefore = stepBefore;
	  exports.stack = stack;
	  exports.stackOffsetExpand = expand;
	  exports.stackOffsetNone = none;
	  exports.stackOffsetSilhouette = silhouette;
	  exports.stackOffsetWiggle = wiggle;
	  exports.stackOrderAscending = ascending;
	  exports.stackOrderDescending = descending$1;
	  exports.stackOrderInsideOut = insideOut;
	  exports.stackOrderNone = none$1;
	  exports.stackOrderReverse = reverse;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var pi = Math.PI;
	  var tau = 2 * pi;
	  var epsilon = 1e-6;
	  var tauEpsilon = tau - epsilon;
	  function Path() {
	    this._x0 = this._y0 = // start of current subpath
	    this._x1 = this._y1 = null; // end of current subpath
	    this._ = [];
	  }
	
	  function path() {
	    return new Path;
	  }
	
	  Path.prototype = path.prototype = {
	    constructor: Path,
	    moveTo: function(x, y) {
	      this._.push("M", this._x0 = this._x1 = +x, ",", this._y0 = this._y1 = +y);
	    },
	    closePath: function() {
	      if (this._x1 !== null) {
	        this._x1 = this._x0, this._y1 = this._y0;
	        this._.push("Z");
	      }
	    },
	    lineTo: function(x, y) {
	      this._.push("L", this._x1 = +x, ",", this._y1 = +y);
	    },
	    quadraticCurveTo: function(x1, y1, x, y) {
	      this._.push("Q", +x1, ",", +y1, ",", this._x1 = +x, ",", this._y1 = +y);
	    },
	    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	      this._.push("C", +x1, ",", +y1, ",", +x2, ",", +y2, ",", this._x1 = +x, ",", this._y1 = +y);
	    },
	    arcTo: function(x1, y1, x2, y2, r) {
	      x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	      var x0 = this._x1,
	          y0 = this._y1,
	          x21 = x2 - x1,
	          y21 = y2 - y1,
	          x01 = x0 - x1,
	          y01 = y0 - y1,
	          l01_2 = x01 * x01 + y01 * y01;
	
	      // Is the radius negative? Error.
	      if (r < 0) throw new Error("negative radius: " + r);
	
	      // Is this path empty? Move to (x1,y1).
	      if (this._x1 === null) {
	        this._.push(
	          "M", this._x1 = x1, ",", this._y1 = y1
	        );
	      }
	
	      // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	      else if (!(l01_2 > epsilon));
	
	      // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	      // Equivalently, is (x1,y1) coincident with (x2,y2)?
	      // Or, is the radius zero? Line to (x1,y1).
	      else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	        this._.push(
	          "L", this._x1 = x1, ",", this._y1 = y1
	        );
	      }
	
	      // Otherwise, draw an arc!
	      else {
	        var x20 = x2 - x0,
	            y20 = y2 - y0,
	            l21_2 = x21 * x21 + y21 * y21,
	            l20_2 = x20 * x20 + y20 * y20,
	            l21 = Math.sqrt(l21_2),
	            l01 = Math.sqrt(l01_2),
	            l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	            t01 = l / l01,
	            t21 = l / l21;
	
	        // If the start tangent is not coincident with (x0,y0), line to.
	        if (Math.abs(t01 - 1) > epsilon) {
	          this._.push(
	            "L", x1 + t01 * x01, ",", y1 + t01 * y01
	          );
	        }
	
	        this._.push(
	          "A", r, ",", r, ",0,0,", +(y01 * x20 > x01 * y20), ",", this._x1 = x1 + t21 * x21, ",", this._y1 = y1 + t21 * y21
	        );
	      }
	    },
	    arc: function(x, y, r, a0, a1, ccw) {
	      x = +x, y = +y, r = +r;
	      var dx = r * Math.cos(a0),
	          dy = r * Math.sin(a0),
	          x0 = x + dx,
	          y0 = y + dy,
	          cw = 1 ^ ccw,
	          da = ccw ? a0 - a1 : a1 - a0;
	
	      // Is the radius negative? Error.
	      if (r < 0) throw new Error("negative radius: " + r);
	
	      // Is this path empty? Move to (x0,y0).
	      if (this._x1 === null) {
	        this._.push(
	          "M", x0, ",", y0
	        );
	      }
	
	      // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	      else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	        this._.push(
	          "L", x0, ",", y0
	        );
	      }
	
	      // Is this arc empty? We’re done.
	      if (!r) return;
	
	      // Is this a complete circle? Draw two arcs to complete the circle.
	      if (da > tauEpsilon) {
	        this._.push(
	          "A", r, ",", r, ",0,1,", cw, ",", x - dx, ",", y - dy,
	          "A", r, ",", r, ",0,1,", cw, ",", this._x1 = x0, ",", this._y1 = y0
	        );
	      }
	
	      // Otherwise, draw an arc!
	      else {
	        if (da < 0) da = da % tau + tau;
	        this._.push(
	          "A", r, ",", r, ",0,", +(da >= pi), ",", cw, ",", this._x1 = x + r * Math.cos(a1), ",", this._y1 = y + r * Math.sin(a1)
	        );
	      }
	    },
	    rect: function(x, y, w, h) {
	      this._.push("M", this._x0 = this._x1 = +x, ",", this._y0 = this._y1 = +y, "h", +w, "v", +h, "h", -w, "Z");
	    },
	    toString: function() {
	      return this._.join("");
	    }
	  };
	
	  exports.path = path;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-force/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(214), __webpack_require__(205), __webpack_require__(215), __webpack_require__(216)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-quadtree', 'd3-collection', 'd3-dispatch', 'd3-timer'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3));
	}(this, function (exports,d3Quadtree,d3Collection,d3Dispatch,d3Timer) { 'use strict';
	
	  function center(x, y) {
	    var nodes;
	
	    if (x == null) x = 0;
	    if (y == null) y = 0;
	
	    function force() {
	      var i,
	          n = nodes.length,
	          node,
	          sx = 0,
	          sy = 0;
	
	      for (i = 0; i < n; ++i) {
	        node = nodes[i], sx += node.x, sy += node.y;
	      }
	
	      for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
	        node = nodes[i], node.x -= sx, node.y -= sy;
	      }
	    }
	
	    force.initialize = function(_) {
	      nodes = _;
	    };
	
	    force.x = function(_) {
	      return arguments.length ? (x = +_, force) : x;
	    };
	
	    force.y = function(_) {
	      return arguments.length ? (y = +_, force) : y;
	    };
	
	    return force;
	  }
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function jiggle() {
	    return (Math.random() - 0.5) * 1e-6;
	  }
	
	  function x(d) {
	    return d.x + d.vx;
	  }
	
	  function y(d) {
	    return d.y + d.vy;
	  }
	
	  function collide(radius) {
	    var nodes,
	        radii,
	        strength = 1,
	        iterations = 1;
	
	    if (typeof radius !== "function") radius = constant(radius == null ? 1 : +radius);
	
	    function force() {
	      var i, n = nodes.length,
	          tree,
	          node,
	          xi,
	          yi,
	          ri,
	          ri2;
	
	      for (var k = 0; k < iterations; ++k) {
	        tree = d3Quadtree.quadtree(nodes, x, y).visitAfter(prepare);
	        for (i = 0; i < n; ++i) {
	          node = nodes[i];
	          ri = radii[i], ri2 = ri * ri;
	          xi = node.x + node.vx;
	          yi = node.y + node.vy;
	          tree.visit(apply);
	        }
	      }
	
	      function apply(quad, x0, y0, x1, y1) {
	        var data = quad.data, rj = quad.r, r = ri + rj;
	        if (data) {
	          if (data.index > i) {
	            var x = xi - data.x - data.vx,
	                y = yi - data.y - data.vy,
	                l = x * x + y * y;
	            if (l < r * r) {
	              if (x === 0) x = jiggle(), l += x * x;
	              if (y === 0) y = jiggle(), l += y * y;
	              l = (r - (l = Math.sqrt(l))) / l * strength;
	              node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
	              node.vy += (y *= l) * r;
	              data.vx -= x * (r = 1 - r);
	              data.vy -= y * r;
	            }
	          }
	          return;
	        }
	        return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	      }
	    }
	
	    function prepare(quad) {
	      if (quad.data) return quad.r = radii[quad.data.index];
	      for (var i = quad.r = 0; i < 4; ++i) {
	        if (quad[i] && quad[i].r > quad.r) {
	          quad.r = quad[i].r;
	        }
	      }
	    }
	
	    force.initialize = function(_) {
	      var i, n = (nodes = _).length; radii = new Array(n);
	      for (i = 0; i < n; ++i) radii[i] = +radius(nodes[i], i, nodes);
	    };
	
	    force.iterations = function(_) {
	      return arguments.length ? (iterations = +_, force) : iterations;
	    };
	
	    force.strength = function(_) {
	      return arguments.length ? (strength = +_, force) : strength;
	    };
	
	    force.radius = function(_) {
	      return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), force) : radius;
	    };
	
	    return force;
	  }
	
	  function index(d, i) {
	    return i;
	  }
	
	  function link(links) {
	    var id = index,
	        strength = defaultStrength,
	        strengths,
	        distance = constant(30),
	        distances,
	        nodes,
	        count,
	        bias,
	        iterations = 1;
	
	    if (links == null) links = [];
	
	    function defaultStrength(link) {
	      return 1 / Math.min(count[link.source.index], count[link.target.index]);
	    }
	
	    function force(alpha) {
	      for (var k = 0, n = links.length; k < iterations; ++k) {
	        for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
	          link = links[i], source = link.source, target = link.target;
	          x = target.x + target.vx - source.x - source.vx || jiggle();
	          y = target.y + target.vy - source.y - source.vy || jiggle();
	          l = Math.sqrt(x * x + y * y);
	          l = (l - distances[i]) / l * alpha * strengths[i];
	          x *= l, y *= l;
	          target.vx -= x * (b = bias[i]);
	          target.vy -= y * b;
	          source.vx += x * (b = 1 - b);
	          source.vy += y * b;
	        }
	      }
	    }
	
	    function initialize() {
	      if (!nodes) return;
	
	      var i,
	          n = nodes.length,
	          m = links.length,
	          nodeById = d3Collection.map(nodes, id),
	          link;
	
	      for (i = 0, count = new Array(n); i < n; ++i) {
	        count[i] = 0;
	      }
	
	      for (i = 0; i < m; ++i) {
	        link = links[i], link.index = i;
	        if (typeof link.source !== "object") link.source = nodeById.get(link.source);
	        if (typeof link.target !== "object") link.target = nodeById.get(link.target);
	        ++count[link.source.index], ++count[link.target.index];
	      }
	
	      for (i = 0, bias = new Array(m); i < m; ++i) {
	        link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	      }
	
	      strengths = new Array(m), initializeStrength();
	      distances = new Array(m), initializeDistance();
	    }
	
	    function initializeStrength() {
	      if (!nodes) return;
	
	      for (var i = 0, n = links.length; i < n; ++i) {
	        strengths[i] = +strength(links[i], i, links);
	      }
	    }
	
	    function initializeDistance() {
	      if (!nodes) return;
	
	      for (var i = 0, n = links.length; i < n; ++i) {
	        distances[i] = +distance(links[i], i, links);
	      }
	    }
	
	    force.initialize = function(_) {
	      nodes = _;
	      initialize();
	    };
	
	    force.links = function(_) {
	      return arguments.length ? (links = _, initialize(), force) : links;
	    };
	
	    force.id = function(_) {
	      return arguments.length ? (id = _, force) : id;
	    };
	
	    force.iterations = function(_) {
	      return arguments.length ? (iterations = +_, force) : iterations;
	    };
	
	    force.strength = function(_) {
	      return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initializeStrength(), force) : strength;
	    };
	
	    force.distance = function(_) {
	      return arguments.length ? (distance = typeof _ === "function" ? _ : constant(+_), initializeDistance(), force) : distance;
	    };
	
	    return force;
	  }
	
	  function x$1(d) {
	    return d.x;
	  }
	
	  function y$1(d) {
	    return d.y;
	  }
	
	  var initialRadius = 10;
	  var initialAngle = Math.PI * (3 - Math.sqrt(5));
	  function simulation(nodes) {
	    var simulation,
	        alpha = 1,
	        alphaMin = 0.001,
	        alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
	        alphaTarget = 0,
	        velocityDecay = 0.6,
	        forces = d3Collection.map(),
	        stepper = d3Timer.timer(step),
	        event = d3Dispatch.dispatch("tick", "end");
	
	    if (nodes == null) nodes = [];
	
	    function step() {
	      tick();
	      event.call("tick", simulation);
	      if (alpha < alphaMin) {
	        stepper.stop();
	        event.call("end", simulation);
	      }
	    }
	
	    function tick() {
	      var i, n = nodes.length, node;
	
	      alpha += (alphaTarget - alpha) * alphaDecay;
	
	      forces.each(function(force) {
	        force(alpha);
	      });
	
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        if (node.fx == null) node.x += node.vx *= velocityDecay;
	        else node.x = node.fx, node.vx = 0;
	        if (node.fy == null) node.y += node.vy *= velocityDecay;
	        else node.y = node.fy, node.vy = 0;
	      }
	    }
	
	    function initializeNodes() {
	      for (var i = 0, n = nodes.length, node; i < n; ++i) {
	        node = nodes[i], node.index = i;
	        if (isNaN(node.x) || isNaN(node.y)) {
	          var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
	          node.x = radius * Math.cos(angle);
	          node.y = radius * Math.sin(angle);
	        }
	        if (isNaN(node.vx) || isNaN(node.vy)) {
	          node.vx = node.vy = 0;
	        }
	      }
	    }
	
	    function initializeForce(force) {
	      if (force.initialize) force.initialize(nodes);
	      return force;
	    }
	
	    initializeNodes();
	
	    return simulation = {
	      tick: tick,
	
	      restart: function() {
	        return stepper.restart(step), simulation;
	      },
	
	      stop: function() {
	        return stepper.stop(), simulation;
	      },
	
	      nodes: function(_) {
	        return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
	      },
	
	      alpha: function(_) {
	        return arguments.length ? (alpha = +_, simulation) : alpha;
	      },
	
	      alphaMin: function(_) {
	        return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
	      },
	
	      alphaDecay: function(_) {
	        return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
	      },
	
	      alphaTarget: function(_) {
	        return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
	      },
	
	      velocityDecay: function(_) {
	        return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
	      },
	
	      force: function(name, _) {
	        return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
	      },
	
	      find: function(x, y, radius) {
	        var i = 0,
	            n = nodes.length,
	            dx,
	            dy,
	            d2,
	            node,
	            closest;
	
	        if (radius == null) radius = Infinity;
	        else radius *= radius;
	
	        for (i = 0; i < n; ++i) {
	          node = nodes[i];
	          dx = x - node.x;
	          dy = y - node.y;
	          d2 = dx * dx + dy * dy;
	          if (d2 < radius) closest = node, radius = d2;
	        }
	
	        return closest;
	      },
	
	      on: function(name, _) {
	        return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
	      }
	    };
	  }
	
	  function manyBody() {
	    var nodes,
	        node,
	        alpha,
	        strength = constant(-30),
	        strengths,
	        distanceMin2 = 1,
	        distanceMax2 = Infinity,
	        theta2 = 0.81;
	
	    function force(_) {
	      var i, n = nodes.length, tree = d3Quadtree.quadtree(nodes, x$1, y$1).visitAfter(accumulate);
	      for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
	    }
	
	    function initialize() {
	      if (!nodes) return;
	      var i, n = nodes.length;
	      strengths = new Array(n);
	      for (i = 0; i < n; ++i) strengths[i] = +strength(nodes[i], i, nodes);
	    }
	
	    function accumulate(quad) {
	      var strength = 0, q, c, x, y, i;
	
	      // For internal nodes, accumulate forces from child quadrants.
	      if (quad.length) {
	        for (x = y = i = 0; i < 4; ++i) {
	          if ((q = quad[i]) && (c = q.value)) {
	            strength += c, x += c * q.x, y += c * q.y;
	          }
	        }
	        quad.x = x / strength;
	        quad.y = y / strength;
	      }
	
	      // For leaf nodes, accumulate forces from coincident quadrants.
	      else {
	        q = quad;
	        q.x = q.data.x;
	        q.y = q.data.y;
	        do strength += strengths[q.data.index];
	        while (q = q.next);
	      }
	
	      quad.value = strength;
	    }
	
	    function apply(quad, x1, _, x2) {
	      if (!quad.value) return true;
	
	      var x = quad.x - node.x,
	          y = quad.y - node.y,
	          w = x2 - x1,
	          l = x * x + y * y;
	
	      // Apply the Barnes-Hut approximation if possible.
	      // Limit forces for very close nodes; randomize direction if coincident.
	      if (w * w / theta2 < l) {
	        if (l < distanceMax2) {
	          if (x === 0) x = jiggle(), l += x * x;
	          if (y === 0) y = jiggle(), l += y * y;
	          if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	          node.vx += x * quad.value * alpha / l;
	          node.vy += y * quad.value * alpha / l;
	        }
	        return true;
	      }
	
	      // Otherwise, process points directly.
	      else if (quad.length || l >= distanceMax2) return;
	
	      // Limit forces for very close nodes; randomize direction if coincident.
	      if (quad.data !== node || quad.next) {
	        if (x === 0) x = jiggle(), l += x * x;
	        if (y === 0) y = jiggle(), l += y * y;
	        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	      }
	
	      do if (quad.data !== node) {
	        w = strengths[quad.data.index] * alpha / l;
	        node.vx += x * w;
	        node.vy += y * w;
	      } while (quad = quad.next);
	    }
	
	    force.initialize = function(_) {
	      nodes = _;
	      initialize();
	    };
	
	    force.strength = function(_) {
	      return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	    };
	
	    force.distanceMin = function(_) {
	      return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	    };
	
	    force.distanceMax = function(_) {
	      return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	    };
	
	    force.theta = function(_) {
	      return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	    };
	
	    return force;
	  }
	
	  function x$2(x) {
	    var strength = constant(0.1),
	        nodes,
	        strengths,
	        xz;
	
	    if (typeof x !== "function") x = constant(x == null ? 0 : +x);
	
	    function force(alpha) {
	      for (var i = 0, n = nodes.length, node; i < n; ++i) {
	        node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	      }
	    }
	
	    function initialize() {
	      if (!nodes) return;
	      var i, n = nodes.length;
	      strengths = new Array(n);
	      xz = new Array(n);
	      for (i = 0; i < n; ++i) {
	        strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	      }
	    }
	
	    force.initialize = function(_) {
	      nodes = _;
	      initialize();
	    };
	
	    force.strength = function(_) {
	      return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	    };
	
	    force.x = function(_) {
	      return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), initialize(), force) : x;
	    };
	
	    return force;
	  }
	
	  function y$2(y) {
	    var strength = constant(0.1),
	        nodes,
	        strengths,
	        yz;
	
	    if (typeof y !== "function") y = constant(y == null ? 0 : +y);
	
	    function force(alpha) {
	      for (var i = 0, n = nodes.length, node; i < n; ++i) {
	        node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	      }
	    }
	
	    function initialize() {
	      if (!nodes) return;
	      var i, n = nodes.length;
	      strengths = new Array(n);
	      yz = new Array(n);
	      for (i = 0; i < n; ++i) {
	        strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	      }
	    }
	
	    force.initialize = function(_) {
	      nodes = _;
	      initialize();
	    };
	
	    force.strength = function(_) {
	      return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
	    };
	
	    force.y = function(_) {
	      return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), initialize(), force) : y;
	    };
	
	    return force;
	  }
	
	  exports.forceCenter = center;
	  exports.forceCollide = collide;
	  exports.forceLink = link;
	  exports.forceManyBody = manyBody;
	  exports.forceSimulation = simulation;
	  exports.forceX = x$2;
	  exports.forceY = y$2;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-quadtree/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  function tree_add(d) {
	    var x = +this._x.call(null, d),
	        y = +this._y.call(null, d);
	    return add(this.cover(x, y), x, y, d);
	  }
	
	  function add(tree, x, y, d) {
	    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
	
	    var parent,
	        node = tree._root,
	        leaf = {data: d},
	        x0 = tree._x0,
	        y0 = tree._y0,
	        x1 = tree._x1,
	        y1 = tree._y1,
	        xm,
	        ym,
	        xp,
	        yp,
	        right,
	        bottom,
	        i,
	        j;
	
	    // If the tree is empty, initialize the root as a leaf.
	    if (!node) return tree._root = leaf, tree;
	
	    // Find the existing leaf for the new point, or add it.
	    while (node.length) {
	      if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	      if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	      if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	    }
	
	    // Is the new point is exactly coincident with the existing point?
	    xp = +tree._x.call(null, node.data);
	    yp = +tree._y.call(null, node.data);
	    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	
	    // Otherwise, split the leaf node until the old and new point are separated.
	    do {
	      parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	      if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	      if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
	    return parent[j] = node, parent[i] = leaf, tree;
	  }
	
	  function addAll(data) {
	    var d, i, n = data.length,
	        x,
	        y,
	        xz = new Array(n),
	        yz = new Array(n),
	        x0 = Infinity,
	        y0 = Infinity,
	        x1 = -Infinity,
	        y1 = -Infinity;
	
	    // Compute the points and their extent.
	    for (i = 0; i < n; ++i) {
	      if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
	      xz[i] = x;
	      yz[i] = y;
	      if (x < x0) x0 = x;
	      if (x > x1) x1 = x;
	      if (y < y0) y0 = y;
	      if (y > y1) y1 = y;
	    }
	
	    // If there were no (valid) points, inherit the existing extent.
	    if (x1 < x0) x0 = this._x0, x1 = this._x1;
	    if (y1 < y0) y0 = this._y0, y1 = this._y1;
	
	    // Expand the tree to cover the new points.
	    this.cover(x0, y0).cover(x1, y1);
	
	    // Add the new points.
	    for (i = 0; i < n; ++i) {
	      add(this, xz[i], yz[i], data[i]);
	    }
	
	    return this;
	  }
	
	  function tree_cover(x, y) {
	    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
	
	    var x0 = this._x0,
	        y0 = this._y0,
	        x1 = this._x1,
	        y1 = this._y1;
	
	    // If the quadtree has no extent, initialize them.
	    // Integer extent are necessary so that if we later double the extent,
	    // the existing quadrant boundaries don’t change due to floating point error!
	    if (isNaN(x0)) {
	      x1 = (x0 = Math.floor(x)) + 1;
	      y1 = (y0 = Math.floor(y)) + 1;
	    }
	
	    // Otherwise, double repeatedly to cover.
	    else if (x0 > x || x > x1 || y0 > y || y > y1) {
	      var z = x1 - x0,
	          node = this._root,
	          parent,
	          i;
	
	      switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
	        case 0: {
	          do parent = new Array(4), parent[i] = node, node = parent;
	          while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
	          break;
	        }
	        case 1: {
	          do parent = new Array(4), parent[i] = node, node = parent;
	          while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
	          break;
	        }
	        case 2: {
	          do parent = new Array(4), parent[i] = node, node = parent;
	          while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
	          break;
	        }
	        case 3: {
	          do parent = new Array(4), parent[i] = node, node = parent;
	          while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
	          break;
	        }
	      }
	
	      if (this._root && this._root.length) this._root = node;
	    }
	
	    // If the quadtree covers the point already, just return.
	    else return this;
	
	    this._x0 = x0;
	    this._y0 = y0;
	    this._x1 = x1;
	    this._y1 = y1;
	    return this;
	  }
	
	  function tree_data() {
	    var data = [];
	    this.visit(function(node) {
	      if (!node.length) do data.push(node.data); while (node = node.next)
	    });
	    return data;
	  }
	
	  function tree_extent(_) {
	    return arguments.length
	        ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
	        : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	  }
	
	  function Quad(node, x0, y0, x1, y1) {
	    this.node = node;
	    this.x0 = x0;
	    this.y0 = y0;
	    this.x1 = x1;
	    this.y1 = y1;
	  }
	
	  function tree_find(x, y, radius) {
	    var data,
	        x0 = this._x0,
	        y0 = this._y0,
	        x1,
	        y1,
	        x2,
	        y2,
	        x3 = this._x1,
	        y3 = this._y1,
	        quads = [],
	        node = this._root,
	        q,
	        i;
	
	    if (node) quads.push(new Quad(node, x0, y0, x3, y3));
	    if (radius == null) radius = Infinity;
	    else {
	      x0 = x - radius, y0 = y - radius;
	      x3 = x + radius, y3 = y + radius;
	      radius *= radius;
	    }
	
	    while (q = quads.pop()) {
	
	      // Stop searching if this quadrant can’t contain a closer node.
	      if (!(node = q.node)
	          || (x1 = q.x0) > x3
	          || (y1 = q.y0) > y3
	          || (x2 = q.x1) < x0
	          || (y2 = q.y1) < y0) continue;
	
	      // Bisect the current quadrant.
	      if (node.length) {
	        var xm = (x1 + x2) / 2,
	            ym = (y1 + y2) / 2;
	
	        quads.push(
	          new Quad(node[3], xm, ym, x2, y2),
	          new Quad(node[2], x1, ym, xm, y2),
	          new Quad(node[1], xm, y1, x2, ym),
	          new Quad(node[0], x1, y1, xm, ym)
	        );
	
	        // Visit the closest quadrant first.
	        if (i = (y >= ym) << 1 | (x >= xm)) {
	          q = quads[quads.length - 1];
	          quads[quads.length - 1] = quads[quads.length - 1 - i];
	          quads[quads.length - 1 - i] = q;
	        }
	      }
	
	      // Visit this point. (Visiting coincident points isn’t necessary!)
	      else {
	        var dx = x - +this._x.call(null, node.data),
	            dy = y - +this._y.call(null, node.data),
	            d2 = dx * dx + dy * dy;
	        if (d2 < radius) {
	          var d = Math.sqrt(radius = d2);
	          x0 = x - d, y0 = y - d;
	          x3 = x + d, y3 = y + d;
	          data = node.data;
	        }
	      }
	    }
	
	    return data;
	  }
	
	  function tree_remove(d) {
	    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
	
	    var parent,
	        node = this._root,
	        retainer,
	        previous,
	        next,
	        x0 = this._x0,
	        y0 = this._y0,
	        x1 = this._x1,
	        y1 = this._y1,
	        x,
	        y,
	        xm,
	        ym,
	        right,
	        bottom,
	        i,
	        j;
	
	    // If the tree is empty, initialize the root as a leaf.
	    if (!node) return this;
	
	    // Find the leaf node for the point.
	    // While descending, also retain the deepest parent with a non-removed sibling.
	    if (node.length) while (true) {
	      if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	      if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	      if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	      if (!node.length) break;
	      if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
	    }
	
	    // Find the point to remove.
	    while (node.data !== d) if (!(previous = node, node = node.next)) return this;
	    if (next = node.next) delete node.next;
	
	    // If there are multiple coincident points, remove just the point.
	    if (previous) return (next ? previous.next = next : delete previous.next), this;
	
	    // If this is the root point, remove it.
	    if (!parent) return this._root = next, this;
	
	    // Remove this leaf.
	    next ? parent[i] = next : delete parent[i];
	
	    // If the parent now contains exactly one leaf, collapse superfluous parents.
	    if ((node = parent[0] || parent[1] || parent[2] || parent[3])
	        && node === (parent[3] || parent[2] || parent[1] || parent[0])
	        && !node.length) {
	      if (retainer) retainer[j] = node;
	      else this._root = node;
	    }
	
	    return this;
	  }
	
	  function removeAll(data) {
	    for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
	    return this;
	  }
	
	  function tree_root() {
	    return this._root;
	  }
	
	  function tree_size() {
	    var size = 0;
	    this.visit(function(node) {
	      if (!node.length) do ++size; while (node = node.next)
	    });
	    return size;
	  }
	
	  function tree_visit(callback) {
	    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
	    if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
	    while (q = quads.pop()) {
	      if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	        if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	        if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	        if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	        if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	      }
	    }
	    return this;
	  }
	
	  function tree_visitAfter(callback) {
	    var quads = [], next = [], q;
	    if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
	    while (q = quads.pop()) {
	      var node = q.node;
	      if (node.length) {
	        var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	        if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	        if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	        if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	        if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	      }
	      next.push(q);
	    }
	    while (q = next.pop()) {
	      callback(q.node, q.x0, q.y0, q.x1, q.y1);
	    }
	    return this;
	  }
	
	  function defaultX(d) {
	    return d[0];
	  }
	
	  function tree_x(_) {
	    return arguments.length ? (this._x = _, this) : this._x;
	  }
	
	  function defaultY(d) {
	    return d[1];
	  }
	
	  function tree_y(_) {
	    return arguments.length ? (this._y = _, this) : this._y;
	  }
	
	  function quadtree(nodes, x, y) {
	    var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
	    return nodes == null ? tree : tree.addAll(nodes);
	  }
	
	  function Quadtree(x, y, x0, y0, x1, y1) {
	    this._x = x;
	    this._y = y;
	    this._x0 = x0;
	    this._y0 = y0;
	    this._x1 = x1;
	    this._y1 = y1;
	    this._root = undefined;
	  }
	
	  function leaf_copy(leaf) {
	    var copy = {data: leaf.data}, next = copy;
	    while (leaf = leaf.next) next = next.next = {data: leaf.data};
	    return copy;
	  }
	
	  var treeProto = quadtree.prototype = Quadtree.prototype;
	
	  treeProto.copy = function() {
	    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
	        node = this._root,
	        nodes,
	        child;
	
	    if (!node) return copy;
	
	    if (!node.length) return copy._root = leaf_copy(node), copy;
	
	    nodes = [{source: node, target: copy._root = new Array(4)}];
	    while (node = nodes.pop()) {
	      for (var i = 0; i < 4; ++i) {
	        if (child = node.source[i]) {
	          if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
	          else node.target[i] = leaf_copy(child);
	        }
	      }
	    }
	
	    return copy;
	  };
	
	  treeProto.add = tree_add;
	  treeProto.addAll = addAll;
	  treeProto.cover = tree_cover;
	  treeProto.data = tree_data;
	  treeProto.extent = tree_extent;
	  treeProto.find = tree_find;
	  treeProto.remove = tree_remove;
	  treeProto.removeAll = removeAll;
	  treeProto.root = tree_root;
	  treeProto.size = tree_size;
	  treeProto.visit = tree_visit;
	  treeProto.visitAfter = tree_visitAfter;
	  treeProto.x = tree_x;
	  treeProto.y = tree_y;
	
	  exports.quadtree = quadtree;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dispatch/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var noop = {value: function() {}};
	
	  function dispatch() {
	    for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	      if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	      _[t] = [];
	    }
	    return new Dispatch(_);
	  }
	
	  function Dispatch(_) {
	    this._ = _;
	  }
	
	  function parseTypenames(typenames, types) {
	    return typenames.trim().split(/^|\s+/).map(function(t) {
	      var name = "", i = t.indexOf(".");
	      if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	      if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	      return {type: t, name: name};
	    });
	  }
	
	  Dispatch.prototype = dispatch.prototype = {
	    constructor: Dispatch,
	    on: function(typename, callback) {
	      var _ = this._,
	          T = parseTypenames(typename + "", _),
	          t,
	          i = -1,
	          n = T.length;
	
	      // If no callback was specified, return the callback of the given type and name.
	      if (arguments.length < 2) {
	        while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	        return;
	      }
	
	      // If a type was specified, set the callback for the given type and name.
	      // Otherwise, if a null callback was specified, remove callbacks of the given name.
	      if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      while (++i < n) {
	        if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	        else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	      }
	
	      return this;
	    },
	    copy: function() {
	      var copy = {}, _ = this._;
	      for (var t in _) copy[t] = _[t].slice();
	      return new Dispatch(copy);
	    },
	    call: function(type, that) {
	      if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	      for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	    },
	    apply: function(type, that, args) {
	      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	      for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	    }
	  };
	
	  function get(type, name) {
	    for (var i = 0, n = type.length, c; i < n; ++i) {
	      if ((c = type[i]).name === name) {
	        return c.value;
	      }
	    }
	  }
	
	  function set(type, name, callback) {
	    for (var i = 0, n = type.length; i < n; ++i) {
	      if (type[i].name === name) {
	        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	        break;
	      }
	    }
	    if (callback != null) type.push({name: name, value: callback});
	    return type;
	  }
	
	  exports.dispatch = dispatch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var frame = 0;
	  var timeout = 0;
	  var interval = 0;
	  var pokeDelay = 1000;
	  var taskHead;
	  var taskTail;
	  var clockLast = 0;
	  var clockNow = 0;
	  var clockSkew = 0;
	  var clock = typeof performance === "object" && performance.now ? performance : Date;
	  var setFrame = typeof requestAnimationFrame === "function"
	          ? (clock === Date ? function(f) { requestAnimationFrame(function() { f(clock.now()); }); } : requestAnimationFrame)
	          : function(f) { setTimeout(f, 17); };
	  function now() {
	    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	  }
	
	  function clearNow() {
	    clockNow = 0;
	  }
	
	  function Timer() {
	    this._call =
	    this._time =
	    this._next = null;
	  }
	
	  Timer.prototype = timer.prototype = {
	    constructor: Timer,
	    restart: function(callback, delay, time) {
	      if (typeof callback !== "function") throw new TypeError("callback is not a function");
	      time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	      if (!this._next && taskTail !== this) {
	        if (taskTail) taskTail._next = this;
	        else taskHead = this;
	        taskTail = this;
	      }
	      this._call = callback;
	      this._time = time;
	      sleep();
	    },
	    stop: function() {
	      if (this._call) {
	        this._call = null;
	        this._time = Infinity;
	        sleep();
	      }
	    }
	  };
	
	  function timer(callback, delay, time) {
	    var t = new Timer;
	    t.restart(callback, delay, time);
	    return t;
	  }
	
	  function timerFlush() {
	    now(); // Get the current time, if not already set.
	    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	    var t = taskHead, e;
	    while (t) {
	      if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	      t = t._next;
	    }
	    --frame;
	  }
	
	  function wake(time) {
	    clockNow = (clockLast = time || clock.now()) + clockSkew;
	    frame = timeout = 0;
	    try {
	      timerFlush();
	    } finally {
	      frame = 0;
	      nap();
	      clockNow = 0;
	    }
	  }
	
	  function poke() {
	    var now = clock.now(), delay = now - clockLast;
	    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	  }
	
	  function nap() {
	    var t0, t1 = taskHead, t2, time = Infinity;
	    while (t1) {
	      if (t1._call) {
	        if (time > t1._time) time = t1._time;
	        t0 = t1, t1 = t1._next;
	      } else {
	        t2 = t1._next, t1._next = null;
	        t1 = t0 ? t0._next = t2 : taskHead = t2;
	      }
	    }
	    taskTail = t0;
	    sleep(time);
	  }
	
	  function sleep(time) {
	    if (frame) return; // Soonest alarm already set, or will be.
	    if (timeout) timeout = clearTimeout(timeout);
	    var delay = time - clockNow;
	    if (delay > 24) {
	      if (time < Infinity) timeout = setTimeout(wake, delay);
	      if (interval) interval = clearInterval(interval);
	    } else {
	      if (!interval) interval = setInterval(poke, pokeDelay);
	      frame = 1, setFrame(wake);
	    }
	  }
	
	  function timeout$1(callback, delay, time) {
	    var t = new Timer;
	    delay = delay == null ? 0 : +delay;
	    t.restart(function(elapsed) {
	      t.stop();
	      callback(elapsed + delay);
	    }, delay, time);
	    return t;
	  }
	
	  function interval$1(callback, delay, time) {
	    var t = new Timer, total = delay;
	    if (delay == null) return t.restart(callback, delay, time), t;
	    delay = +delay, time = time == null ? now() : +time;
	    t.restart(function tick(elapsed) {
	      elapsed += total;
	      t.restart(tick, total += delay, time);
	      callback(elapsed);
	    }, delay, time);
	    return t;
	  }
	
	  exports.now = now;
	  exports.timer = timer;
	  exports.timerFlush = timerFlush;
	  exports.timeout = timeout$1;
	  exports.interval = interval$1;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var xhtml = "http://www.w3.org/1999/xhtml";
	
	  var namespaces = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: xhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	
	  function namespace(name) {
	    var prefix = name += "", i = prefix.indexOf(":");
	    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	    return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	  }
	
	  function creatorInherit(name) {
	    return function() {
	      var document = this.ownerDocument,
	          uri = this.namespaceURI;
	      return uri === xhtml && document.documentElement.namespaceURI === xhtml
	          ? document.createElement(name)
	          : document.createElementNS(uri, name);
	    };
	  }
	
	  function creatorFixed(fullname) {
	    return function() {
	      return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	    };
	  }
	
	  function creator(name) {
	    var fullname = namespace(name);
	    return (fullname.local
	        ? creatorFixed
	        : creatorInherit)(fullname);
	  }
	
	  var nextId = 0;
	
	  function local() {
	    return new Local;
	  }
	
	  function Local() {
	    this._ = "@" + (++nextId).toString(36);
	  }
	
	  Local.prototype = local.prototype = {
	    constructor: Local,
	    get: function(node) {
	      var id = this._;
	      while (!(id in node)) if (!(node = node.parentNode)) return;
	      return node[id];
	    },
	    set: function(node, value) {
	      return node[this._] = value;
	    },
	    remove: function(node) {
	      return this._ in node && delete node[this._];
	    },
	    toString: function() {
	      return this._;
	    }
	  };
	
	  var matcher = function(selector) {
	    return function() {
	      return this.matches(selector);
	    };
	  };
	
	  if (typeof document !== "undefined") {
	    var element = document.documentElement;
	    if (!element.matches) {
	      var vendorMatches = element.webkitMatchesSelector
	          || element.msMatchesSelector
	          || element.mozMatchesSelector
	          || element.oMatchesSelector;
	      matcher = function(selector) {
	        return function() {
	          return vendorMatches.call(this, selector);
	        };
	      };
	    }
	  }
	
	  var matcher$1 = matcher;
	
	  var filterEvents = {};
	
	  exports.event = null;
	
	  if (typeof document !== "undefined") {
	    var element$1 = document.documentElement;
	    if (!("onmouseenter" in element$1)) {
	      filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	    }
	  }
	
	  function filterContextListener(listener, index, group) {
	    listener = contextListener(listener, index, group);
	    return function(event) {
	      var related = event.relatedTarget;
	      if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	        listener.call(this, event);
	      }
	    };
	  }
	
	  function contextListener(listener, index, group) {
	    return function(event1) {
	      var event0 = exports.event; // Events can be reentrant (e.g., focus).
	      exports.event = event1;
	      try {
	        listener.call(this, this.__data__, index, group);
	      } finally {
	        exports.event = event0;
	      }
	    };
	  }
	
	  function parseTypenames(typenames) {
	    return typenames.trim().split(/^|\s+/).map(function(t) {
	      var name = "", i = t.indexOf(".");
	      if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	      return {type: t, name: name};
	    });
	  }
	
	  function onRemove(typename) {
	    return function() {
	      var on = this.__on;
	      if (!on) return;
	      for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	        if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	          this.removeEventListener(o.type, o.listener, o.capture);
	        } else {
	          on[++i] = o;
	        }
	      }
	      if (++i) on.length = i;
	      else delete this.__on;
	    };
	  }
	
	  function onAdd(typename, value, capture) {
	    var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	    return function(d, i, group) {
	      var on = this.__on, o, listener = wrap(value, i, group);
	      if (on) for (var j = 0, m = on.length; j < m; ++j) {
	        if ((o = on[j]).type === typename.type && o.name === typename.name) {
	          this.removeEventListener(o.type, o.listener, o.capture);
	          this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	          o.value = value;
	          return;
	        }
	      }
	      this.addEventListener(typename.type, listener, capture);
	      o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	      if (!on) this.__on = [o];
	      else on.push(o);
	    };
	  }
	
	  function selection_on(typename, value, capture) {
	    var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	    if (arguments.length < 2) {
	      var on = this.node().__on;
	      if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	        for (i = 0, o = on[j]; i < n; ++i) {
	          if ((t = typenames[i]).type === o.type && t.name === o.name) {
	            return o.value;
	          }
	        }
	      }
	      return;
	    }
	
	    on = value ? onAdd : onRemove;
	    if (capture == null) capture = false;
	    for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	    return this;
	  }
	
	  function customEvent(event1, listener, that, args) {
	    var event0 = exports.event;
	    event1.sourceEvent = exports.event;
	    exports.event = event1;
	    try {
	      return listener.apply(that, args);
	    } finally {
	      exports.event = event0;
	    }
	  }
	
	  function sourceEvent() {
	    var current = exports.event, source;
	    while (source = current.sourceEvent) current = source;
	    return current;
	  }
	
	  function point(node, event) {
	    var svg = node.ownerSVGElement || node;
	
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      point.x = event.clientX, point.y = event.clientY;
	      point = point.matrixTransform(node.getScreenCTM().inverse());
	      return [point.x, point.y];
	    }
	
	    var rect = node.getBoundingClientRect();
	    return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	  }
	
	  function mouse(node) {
	    var event = sourceEvent();
	    if (event.changedTouches) event = event.changedTouches[0];
	    return point(node, event);
	  }
	
	  function none() {}
	
	  function selector(selector) {
	    return selector == null ? none : function() {
	      return this.querySelector(selector);
	    };
	  }
	
	  function selection_select(select) {
	    if (typeof select !== "function") select = selector(select);
	
	    for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	        if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          subgroup[i] = subnode;
	        }
	      }
	    }
	
	    return new Selection(subgroups, this._parents);
	  }
	
	  function empty() {
	    return [];
	  }
	
	  function selectorAll(selector) {
	    return selector == null ? empty : function() {
	      return this.querySelectorAll(selector);
	    };
	  }
	
	  function selection_selectAll(select) {
	    if (typeof select !== "function") select = selectorAll(select);
	
	    for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	        if (node = group[i]) {
	          subgroups.push(select.call(node, node.__data__, i, group));
	          parents.push(node);
	        }
	      }
	    }
	
	    return new Selection(subgroups, parents);
	  }
	
	  function selection_filter(match) {
	    if (typeof match !== "function") match = matcher$1(match);
	
	    for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	        if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	          subgroup.push(node);
	        }
	      }
	    }
	
	    return new Selection(subgroups, this._parents);
	  }
	
	  function sparse(update) {
	    return new Array(update.length);
	  }
	
	  function selection_enter() {
	    return new Selection(this._enter || this._groups.map(sparse), this._parents);
	  }
	
	  function EnterNode(parent, datum) {
	    this.ownerDocument = parent.ownerDocument;
	    this.namespaceURI = parent.namespaceURI;
	    this._next = null;
	    this._parent = parent;
	    this.__data__ = datum;
	  }
	
	  EnterNode.prototype = {
	    constructor: EnterNode,
	    appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	    insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	    querySelector: function(selector) { return this._parent.querySelector(selector); },
	    querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	  };
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	  function bindIndex(parent, group, enter, update, exit, data) {
	    var i = 0,
	        node,
	        groupLength = group.length,
	        dataLength = data.length;
	
	    // Put any non-null nodes that fit into update.
	    // Put any null nodes into enter.
	    // Put any remaining data into enter.
	    for (; i < dataLength; ++i) {
	      if (node = group[i]) {
	        node.__data__ = data[i];
	        update[i] = node;
	      } else {
	        enter[i] = new EnterNode(parent, data[i]);
	      }
	    }
	
	    // Put any non-null nodes that don’t fit into exit.
	    for (; i < groupLength; ++i) {
	      if (node = group[i]) {
	        exit[i] = node;
	      }
	    }
	  }
	
	  function bindKey(parent, group, enter, update, exit, data, key) {
	    var i,
	        node,
	        nodeByKeyValue = {},
	        groupLength = group.length,
	        dataLength = data.length,
	        keyValues = new Array(groupLength),
	        keyValue;
	
	    // Compute the key for each node.
	    // If multiple nodes have the same key, the duplicates are added to exit.
	    for (i = 0; i < groupLength; ++i) {
	      if (node = group[i]) {
	        keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	        if (keyValue in nodeByKeyValue) {
	          exit[i] = node;
	        } else {
	          nodeByKeyValue[keyValue] = node;
	        }
	      }
	    }
	
	    // Compute the key for each datum.
	    // If there a node associated with this key, join and add it to update.
	    // If there is not (or the key is a duplicate), add it to enter.
	    for (i = 0; i < dataLength; ++i) {
	      keyValue = keyPrefix + key.call(parent, data[i], i, data);
	      if (node = nodeByKeyValue[keyValue]) {
	        update[i] = node;
	        node.__data__ = data[i];
	        nodeByKeyValue[keyValue] = null;
	      } else {
	        enter[i] = new EnterNode(parent, data[i]);
	      }
	    }
	
	    // Add any remaining nodes that were not bound to data to exit.
	    for (i = 0; i < groupLength; ++i) {
	      if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	        exit[i] = node;
	      }
	    }
	  }
	
	  function selection_data(value, key) {
	    if (!value) {
	      data = new Array(this.size()), j = -1;
	      this.each(function(d) { data[++j] = d; });
	      return data;
	    }
	
	    var bind = key ? bindKey : bindIndex,
	        parents = this._parents,
	        groups = this._groups;
	
	    if (typeof value !== "function") value = constant(value);
	
	    for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	      var parent = parents[j],
	          group = groups[j],
	          groupLength = group.length,
	          data = value.call(parent, parent && parent.__data__, j, parents),
	          dataLength = data.length,
	          enterGroup = enter[j] = new Array(dataLength),
	          updateGroup = update[j] = new Array(dataLength),
	          exitGroup = exit[j] = new Array(groupLength);
	
	      bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	      // Now connect the enter nodes to their following update node, such that
	      // appendChild can insert the materialized enter node before this node,
	      // rather than at the end of the parent node.
	      for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	        if (previous = enterGroup[i0]) {
	          if (i0 >= i1) i1 = i0 + 1;
	          while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	          previous._next = next || null;
	        }
	      }
	    }
	
	    update = new Selection(update, parents);
	    update._enter = enter;
	    update._exit = exit;
	    return update;
	  }
	
	  function selection_exit() {
	    return new Selection(this._exit || this._groups.map(sparse), this._parents);
	  }
	
	  function selection_merge(selection) {
	
	    for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	      for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	        if (node = group0[i] || group1[i]) {
	          merge[i] = node;
	        }
	      }
	    }
	
	    for (; j < m0; ++j) {
	      merges[j] = groups0[j];
	    }
	
	    return new Selection(merges, this._parents);
	  }
	
	  function selection_order() {
	
	    for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	      for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	
	    return this;
	  }
	
	  function selection_sort(compare) {
	    if (!compare) compare = ascending;
	
	    function compareNode(a, b) {
	      return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	    }
	
	    for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	        if (node = group[i]) {
	          sortgroup[i] = node;
	        }
	      }
	      sortgroup.sort(compareNode);
	    }
	
	    return new Selection(sortgroups, this._parents).order();
	  }
	
	  function ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	
	  function selection_call() {
	    var callback = arguments[0];
	    arguments[0] = this;
	    callback.apply(null, arguments);
	    return this;
	  }
	
	  function selection_nodes() {
	    var nodes = new Array(this.size()), i = -1;
	    this.each(function() { nodes[++i] = this; });
	    return nodes;
	  }
	
	  function selection_node() {
	
	    for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	      for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	
	    return null;
	  }
	
	  function selection_size() {
	    var size = 0;
	    this.each(function() { ++size; });
	    return size;
	  }
	
	  function selection_empty() {
	    return !this.node();
	  }
	
	  function selection_each(callback) {
	
	    for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	        if (node = group[i]) callback.call(node, node.__data__, i, group);
	      }
	    }
	
	    return this;
	  }
	
	  function attrRemove(name) {
	    return function() {
	      this.removeAttribute(name);
	    };
	  }
	
	  function attrRemoveNS(fullname) {
	    return function() {
	      this.removeAttributeNS(fullname.space, fullname.local);
	    };
	  }
	
	  function attrConstant(name, value) {
	    return function() {
	      this.setAttribute(name, value);
	    };
	  }
	
	  function attrConstantNS(fullname, value) {
	    return function() {
	      this.setAttributeNS(fullname.space, fullname.local, value);
	    };
	  }
	
	  function attrFunction(name, value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) this.removeAttribute(name);
	      else this.setAttribute(name, v);
	    };
	  }
	
	  function attrFunctionNS(fullname, value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	      else this.setAttributeNS(fullname.space, fullname.local, v);
	    };
	  }
	
	  function selection_attr(name, value) {
	    var fullname = namespace(name);
	
	    if (arguments.length < 2) {
	      var node = this.node();
	      return fullname.local
	          ? node.getAttributeNS(fullname.space, fullname.local)
	          : node.getAttribute(fullname);
	    }
	
	    return this.each((value == null
	        ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	        ? (fullname.local ? attrFunctionNS : attrFunction)
	        : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	  }
	
	  function defaultView(node) {
	    return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	        || (node.document && node) // node is a Window
	        || node.defaultView; // node is a Document
	  }
	
	  function styleRemove(name) {
	    return function() {
	      this.style.removeProperty(name);
	    };
	  }
	
	  function styleConstant(name, value, priority) {
	    return function() {
	      this.style.setProperty(name, value, priority);
	    };
	  }
	
	  function styleFunction(name, value, priority) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) this.style.removeProperty(name);
	      else this.style.setProperty(name, v, priority);
	    };
	  }
	
	  function selection_style(name, value, priority) {
	    var node;
	    return arguments.length > 1
	        ? this.each((value == null
	              ? styleRemove : typeof value === "function"
	              ? styleFunction
	              : styleConstant)(name, value, priority == null ? "" : priority))
	        : defaultView(node = this.node())
	            .getComputedStyle(node, null)
	            .getPropertyValue(name);
	  }
	
	  function propertyRemove(name) {
	    return function() {
	      delete this[name];
	    };
	  }
	
	  function propertyConstant(name, value) {
	    return function() {
	      this[name] = value;
	    };
	  }
	
	  function propertyFunction(name, value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) delete this[name];
	      else this[name] = v;
	    };
	  }
	
	  function selection_property(name, value) {
	    return arguments.length > 1
	        ? this.each((value == null
	            ? propertyRemove : typeof value === "function"
	            ? propertyFunction
	            : propertyConstant)(name, value))
	        : this.node()[name];
	  }
	
	  function classArray(string) {
	    return string.trim().split(/^|\s+/);
	  }
	
	  function classList(node) {
	    return node.classList || new ClassList(node);
	  }
	
	  function ClassList(node) {
	    this._node = node;
	    this._names = classArray(node.getAttribute("class") || "");
	  }
	
	  ClassList.prototype = {
	    add: function(name) {
	      var i = this._names.indexOf(name);
	      if (i < 0) {
	        this._names.push(name);
	        this._node.setAttribute("class", this._names.join(" "));
	      }
	    },
	    remove: function(name) {
	      var i = this._names.indexOf(name);
	      if (i >= 0) {
	        this._names.splice(i, 1);
	        this._node.setAttribute("class", this._names.join(" "));
	      }
	    },
	    contains: function(name) {
	      return this._names.indexOf(name) >= 0;
	    }
	  };
	
	  function classedAdd(node, names) {
	    var list = classList(node), i = -1, n = names.length;
	    while (++i < n) list.add(names[i]);
	  }
	
	  function classedRemove(node, names) {
	    var list = classList(node), i = -1, n = names.length;
	    while (++i < n) list.remove(names[i]);
	  }
	
	  function classedTrue(names) {
	    return function() {
	      classedAdd(this, names);
	    };
	  }
	
	  function classedFalse(names) {
	    return function() {
	      classedRemove(this, names);
	    };
	  }
	
	  function classedFunction(names, value) {
	    return function() {
	      (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	    };
	  }
	
	  function selection_classed(name, value) {
	    var names = classArray(name + "");
	
	    if (arguments.length < 2) {
	      var list = classList(this.node()), i = -1, n = names.length;
	      while (++i < n) if (!list.contains(names[i])) return false;
	      return true;
	    }
	
	    return this.each((typeof value === "function"
	        ? classedFunction : value
	        ? classedTrue
	        : classedFalse)(names, value));
	  }
	
	  function textRemove() {
	    this.textContent = "";
	  }
	
	  function textConstant(value) {
	    return function() {
	      this.textContent = value;
	    };
	  }
	
	  function textFunction(value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    };
	  }
	
	  function selection_text(value) {
	    return arguments.length
	        ? this.each(value == null
	            ? textRemove : (typeof value === "function"
	            ? textFunction
	            : textConstant)(value))
	        : this.node().textContent;
	  }
	
	  function htmlRemove() {
	    this.innerHTML = "";
	  }
	
	  function htmlConstant(value) {
	    return function() {
	      this.innerHTML = value;
	    };
	  }
	
	  function htmlFunction(value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    };
	  }
	
	  function selection_html(value) {
	    return arguments.length
	        ? this.each(value == null
	            ? htmlRemove : (typeof value === "function"
	            ? htmlFunction
	            : htmlConstant)(value))
	        : this.node().innerHTML;
	  }
	
	  function raise() {
	    if (this.nextSibling) this.parentNode.appendChild(this);
	  }
	
	  function selection_raise() {
	    return this.each(raise);
	  }
	
	  function lower() {
	    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	  }
	
	  function selection_lower() {
	    return this.each(lower);
	  }
	
	  function selection_append(name) {
	    var create = typeof name === "function" ? name : creator(name);
	    return this.select(function() {
	      return this.appendChild(create.apply(this, arguments));
	    });
	  }
	
	  function constantNull() {
	    return null;
	  }
	
	  function selection_insert(name, before) {
	    var create = typeof name === "function" ? name : creator(name),
	        select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	    return this.select(function() {
	      return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	    });
	  }
	
	  function remove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	
	  function selection_remove() {
	    return this.each(remove);
	  }
	
	  function selection_datum(value) {
	    return arguments.length
	        ? this.property("__data__", value)
	        : this.node().__data__;
	  }
	
	  function dispatchEvent(node, type, params) {
	    var window = defaultView(node),
	        event = window.CustomEvent;
	
	    if (event) {
	      event = new event(type, params);
	    } else {
	      event = window.document.createEvent("Event");
	      if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	      else event.initEvent(type, false, false);
	    }
	
	    node.dispatchEvent(event);
	  }
	
	  function dispatchConstant(type, params) {
	    return function() {
	      return dispatchEvent(this, type, params);
	    };
	  }
	
	  function dispatchFunction(type, params) {
	    return function() {
	      return dispatchEvent(this, type, params.apply(this, arguments));
	    };
	  }
	
	  function selection_dispatch(type, params) {
	    return this.each((typeof params === "function"
	        ? dispatchFunction
	        : dispatchConstant)(type, params));
	  }
	
	  var root = [null];
	
	  function Selection(groups, parents) {
	    this._groups = groups;
	    this._parents = parents;
	  }
	
	  function selection() {
	    return new Selection([[document.documentElement]], root);
	  }
	
	  Selection.prototype = selection.prototype = {
	    constructor: Selection,
	    select: selection_select,
	    selectAll: selection_selectAll,
	    filter: selection_filter,
	    data: selection_data,
	    enter: selection_enter,
	    exit: selection_exit,
	    merge: selection_merge,
	    order: selection_order,
	    sort: selection_sort,
	    call: selection_call,
	    nodes: selection_nodes,
	    node: selection_node,
	    size: selection_size,
	    empty: selection_empty,
	    each: selection_each,
	    attr: selection_attr,
	    style: selection_style,
	    property: selection_property,
	    classed: selection_classed,
	    text: selection_text,
	    html: selection_html,
	    raise: selection_raise,
	    lower: selection_lower,
	    append: selection_append,
	    insert: selection_insert,
	    remove: selection_remove,
	    datum: selection_datum,
	    on: selection_on,
	    dispatch: selection_dispatch
	  };
	
	  function select(selector) {
	    return typeof selector === "string"
	        ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	        : new Selection([[selector]], root);
	  }
	
	  function selectAll(selector) {
	    return typeof selector === "string"
	        ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	        : new Selection([selector == null ? [] : selector], root);
	  }
	
	  function touch(node, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	    for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return point(node, touch);
	      }
	    }
	
	    return null;
	  }
	
	  function touches(node, touches) {
	    if (touches == null) touches = sourceEvent().touches;
	
	    for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	      points[i] = point(node, touches[i]);
	    }
	
	    return points;
	  }
	
	  exports.creator = creator;
	  exports.local = local;
	  exports.matcher = matcher$1;
	  exports.mouse = mouse;
	  exports.namespace = namespace;
	  exports.namespaces = namespaces;
	  exports.select = select;
	  exports.selectAll = selectAll;
	  exports.selection = selection;
	  exports.selector = selector;
	  exports.selectorAll = selectorAll;
	  exports.touch = touch;
	  exports.touches = touches;
	  exports.window = defaultView;
	  exports.customEvent = customEvent;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 218 */
/***/ function(module, exports) {

	"use strict";
	function getDischargeValue(waterLevel, dischargeModel) {
	    return dischargeModel.paramC *
	        Math.pow(waterLevel + dischargeModel.paramA, dischargeModel.paramB);
	}
	exports.getDischargeValue = getDischargeValue;
	function getDischargePoints(minWaterLevel, maxWaterLevel, dischargeModel, resolution) {
	    var range = maxWaterLevel - minWaterLevel;
	    var step = range / resolution;
	    var points = [];
	    for (var waterLevel = minWaterLevel; waterLevel < maxWaterLevel; waterLevel += step) {
	        points.push({
	            discharge: getDischargeValue(waterLevel, dischargeModel),
	            waterLevel: waterLevel
	        });
	    }
	    return points;
	}
	exports.getDischargePoints = getDischargePoints;


/***/ },
/* 219 */
/***/ function(module, exports) {

	"use strict";
	var DischargeCurveSettingsDialog = (function () {
	    function DischargeCurveSettingsDialog($mdDialog) {
	        var _this = this;
	        this.$mdDialog = $mdDialog;
	        this.apply = function () {
	            _this.$mdDialog.hide(_this.curveSettings);
	        };
	        this.cancel = function () {
	            _this.$mdDialog.cancel();
	        };
	    }
	    Object.defineProperty(DischargeCurveSettingsDialog.prototype, "manualViewport", {
	        get: function () {
	            return !this.curveSettings.fitViewportToData;
	        },
	        set: function (value) {
	            this.curveSettings.fitViewportToData = !value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DischargeCurveSettingsDialog.$inject = ['$mdDialog'];
	    return DischargeCurveSettingsDialog;
	}());
	exports.DischargeCurveSettingsDialog = DischargeCurveSettingsDialog;


/***/ },
/* 220 */
/***/ function(module, exports) {

	module.exports = "<md-dialog> <form name=settingsForm> <md-dialog-content> <div layout=column class=md-dialog-content> <h2 class=md-title>Discharge Chart Settings</h2> <md-checkbox ng-model=$ctrl.manualViewport>Adjust chart bounds </md-checkbox> <md-input-container> <label translate>MINIMUM_H_CM</label> <input type=number step=1 min=0 max={{$ctrl.curveSettings.maxWaterLevel}} required ng-model=$ctrl.curveSettings.minWaterLevel ng-disabled=$ctrl.curveSettings.fitViewportToData> </md-input-container> <md-input-container> <label translate>MAXIMUM_H_CM</label> <input type=number step=1 min={{$ctrl.curveSettings.minWaterLevel}} required ng-model=$ctrl.curveSettings.maxWaterLevel ng-disabled=$ctrl.curveSettings.fitViewportToData> </md-input-container> <md-input-container> <label translate>MINIMUM_Q_M3_S</label> <input type=number step=0.1 min=0 max={{$ctrl.curveSettings.maxDischarge}} ng-model=$ctrl.curveSettings.minDischarge required ng-disabled=$ctrl.curveSettings.fitViewportToData> </md-input-container> <md-input-container> <label translate>MAXIMUM_Q_M3_S</label> <input type=number step=0.1 min={{$ctrl.curveSettings.minDischarge}} ng-model=$ctrl.curveSettings.maxDischarge ng-disabled=$ctrl.curveSettings.fitViewportToData> </md-input-container> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply() ng-disabled=\"$ctrl.manualViewport && settingsForm.$invalid\"> <span translate>APPLY</span> </md-button> </md-dialog-actions> </form> </md-dialog>";

/***/ },
/* 221 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 222 */
/***/ function(module, exports) {

	module.exports = "<md-card class=\"discharge-curve card\"> <svg class=\"discharge-curve draw-area\" ng-attr-view_box=\"0 0 {{$ctrl.width}} {{$ctrl.height}}\" preserveAspectRatio=\"xMidYMid meet\"> <g ng-attr-transform=\"translate({{$ctrl.majorMargin}}, {{$ctrl.minorMargin}})\"> <defs> <clipPath class=drawing-area> <rect ng-attr-width={{$ctrl.innerWidth}} ng-attr-height={{$ctrl.innerHeight}}></rect> </clipPath> </defs> <g class=\"x axis\"></g> <g class=\"y axis\" ng-attr-transform=\"translate({{$ctrl.innerWidth}}, 0)\"></g> <g ng-repeat=\"dischargeCurve in $ctrl.dischargeCurves\" clip-path=url(.drawing-area)> <path class=curve ng-attr-d={{dischargeCurve.path}} ng-style=\"{stroke: dischargeCurve.strokeColor}\"></path> </g> <g class=nodes clip-path=url(.drawing-area)> <g class=node-group ng-class=\"{selected: dischargePoint.selected}\" ng-repeat=\"dischargePoint in $ctrl.dischargePoints\"> <circle ng-attr-cx={{dischargePoint.x}} ng-attr-cy={{dischargePoint.y}} r=5></circle> <text ng-if=$ctrl.dischargeLabels[$index].label ng-attr-transform=\"translate({{$ctrl.dischargeLabels[$index].x}}, {{$ctrl.dischargeLabels[$index].y}})\"> {{ $ctrl.dischargeLabels[$index].label }} </text> <line ng-attr-x1={{dischargePoint.x}} , ng-attr-x2={{$ctrl.dischargeLabels[$index].x}} , ng-attr-y1={{dischargePoint.y}} , ng-attr-y2={{$ctrl.dischargeLabels[$index].y}} ng-if=$ctrl.dischargeLabels[$index].label></line> </g> </g> </g> <text ng-attr-transform=\"translate({{$ctrl.innerWidth/2 + $ctrl.majorMargin}}, {{$ctrl.height - 10}})\" text-anchor=middle> Q (m^3/s) </text> <text ng-attr-transform=\"translate(20, {{$ctrl.innerHeight/2}}) rotate(270)\" text-anchor=middle> H (cm) </text> <rect class=mouse-capture ng-attr-width={{$ctrl.innerWidth}} ng-attr-height={{$ctrl.innerHeight}} ng-attr-transform=\"translate({{$ctrl.majorMargin}}, {{$ctrl.minorMargin}})\" ng-mousemove=$ctrl.onMousemove($event) ng-mouseout=$ctrl.onMouseout($event)></rect> </svg> <md-card-actions layout=row class=\"discharge-curve actions\"> <div layout=row layout-align=\"start center\" class=\"discharge-curve legend\"> <span class=md-body-1 translate>H_CM</span> <span class=md-body-2>{{ $ctrl.cursor.waterLevel | number:0 }}</span> <span class=md-body-1 translate>Q_M3_S</span> <span class=md-body-2>{{ $ctrl.cursor.discharge | number:2 }}</span> </div> <div flex></div> <md-button class=md-icon-button ng-click=$ctrl.showChartSettings($event)> <md-icon class=material-icons>settings</md-icon> </md-button> </md-card-actions> </md-card>";

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var table_controller_1 = __webpack_require__(224);
	var template = __webpack_require__(225);
	var bindings = {
	    minX: '<',
	    maxX: '<',
	    dischargeModel: '<'
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    bindings: bindings,
	    controller: table_controller_1.default,
	    template: template
	};


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utils_1 = __webpack_require__(218);
	var DischargeTableController = (function () {
	    function DischargeTableController($filter) {
	        this.dischargeNumberFormatter = $filter('hydroNumberFormatter');
	    }
	    Object.defineProperty(DischargeTableController.prototype, "digits", {
	        get: function () {
	            return DischargeTableController.DIGITS;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DischargeTableController.prototype.$onChanges = function (changes) {
	        var lowerX = Math.floor(this.minX / 10) * 10;
	        var upperX = Math.ceil(this.maxX / 10) * 10;
	        this.tableRows = [];
	        for (var x = lowerX; x < upperX; x += 10) {
	            var row = {
	                decade: x,
	                dischargeValues: []
	            };
	            this.tableRows.push(row);
	            for (var d = 0; d < 10; ++d) {
	                row.dischargeValues.push(this.dischargeNumberFormatter(utils_1.getDischargeValue(x + d, this.dischargeModel)));
	            }
	        }
	    };
	    DischargeTableController.$inject = ['$filter'];
	    DischargeTableController.DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
	    return DischargeTableController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DischargeTableController;


/***/ },
/* 225 */
/***/ function(module, exports) {

	module.exports = "<md-table-container class=hq-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column><span translate>H_CM</span></th> <th md-column ng-repeat=\"digit in $ctrl.digits\">{{ ::digit }}</th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"row in $ctrl.tableRows\"> <td md-cell>{{ ::row.decade }}</td> <td md-cell ng-repeat=\"value in row.dischargeValues track by $index\"> {{ ::value }} </td> </tr> </tbody> </table> </md-table-container>";

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var discharge_data_list_controller_1 = __webpack_require__(227);
	__webpack_require__(229);
	var template = __webpack_require__(230);
	var dischargeDataListComponent = {
	    bindings: {
	        measuredDischargeDataItems: '<',
	        onCreatedItemsChange: '&',
	        onSelectedItemsChange: '&'
	    },
	    controller: discharge_data_list_controller_1.default,
	    require: {
	        dischargeDataListCurveController: '^^?imomoDischargeDataListCurve'
	    },
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = dischargeDataListComponent;


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var addPairDialogTemplate = __webpack_require__(228);
	var DischargeDataListController = (function () {
	    function DischargeDataListController($mdDialog) {
	        var _this = this;
	        this.$mdDialog = $mdDialog;
	        this.onDischargeDataItemSelect = function (dischargeDataItem) {
	            if (_this.createdDischargeDataItems.contains(dischargeDataItem)) {
	                _this.selectedCreatedDischargeDataItems =
	                    _this.selectedCreatedDischargeDataItems.add(dischargeDataItem);
	            }
	            _this.notifySelectionChange();
	        };
	        this.onDischargeDataItemDeselect = function (dischargeDataItem) {
	            if (_this.selectedCreatedDischargeDataItems.contains(dischargeDataItem)) {
	                _this.selectedCreatedDischargeDataItems =
	                    _this.selectedCreatedDischargeDataItems.remove(dischargeDataItem);
	            }
	            _this.notifySelectionChange();
	        };
	        this.dischargeDataItems = [];
	        this.selectedDischargeDataItems = [];
	        this.createdDischargeDataItems = immutable_1.List();
	        this.selectedCreatedDischargeDataItems = immutable_1.Set();
	    }
	    DischargeDataListController.prototype.$onChanges = function () {
	        this.measuredDischargeDataItems =
	            this.measuredDischargeDataItems || immutable_1.List();
	        this.dischargeDataItems = this.measuredDischargeDataItems
	            .concat(this.createdDischargeDataItems)
	            .toArray();
	        if (this.dischargeDataListCurveController) {
	            this.dischargeDataListCurveController
	                .onDischargeDataItemsChange(immutable_1.List(this.dischargeDataItems));
	        }
	        this.selectedDischargeDataItems = [];
	        this.notifySelectionChange();
	    };
	    Object.defineProperty(DischargeDataListController.prototype, "canDelete", {
	        get: function () {
	            return this.selectedCreatedDischargeDataItems.size > 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DischargeDataListController.prototype.deleteCreatedDischargePairs = function () {
	        var _this = this;
	        var isNotDeleted = function (dischargeDataItem) {
	            return !_this.selectedCreatedDischargeDataItems.contains(dischargeDataItem);
	        };
	        this.selectedDischargeDataItems =
	            this.selectedDischargeDataItems.filter(isNotDeleted);
	        this.dischargeDataItems = this.dischargeDataItems
	            .filter(isNotDeleted);
	        this.createdDischargeDataItems = this.createdDischargeDataItems
	            .filter(isNotDeleted).toList();
	        this.selectedCreatedDischargeDataItems =
	            this.selectedCreatedDischargeDataItems.clear();
	        this.notifyCreationChange();
	        this.notifySelectionChange();
	    };
	    DischargeDataListController.prototype.showCreationDialog = function ($event) {
	        var _this = this;
	        this.$mdDialog.show({
	            controller: AddPairDialogController,
	            controllerAs: '$ctrl',
	            targetEvent: $event,
	            template: addPairDialogTemplate
	        }).then(function (pair) {
	            var newDischargeDataItem = {
	                waterLevel: pair.waterLevel,
	                discharge: pair.discharge
	            };
	            _this.createdDischargeDataItems =
	                _this.createdDischargeDataItems.unshift(newDischargeDataItem);
	            _this.dischargeDataItems.unshift(newDischargeDataItem);
	            _this.notifyCreationChange();
	        });
	    };
	    DischargeDataListController.prototype.notifySelectionChange = function () {
	        var selectedDischargeDataItemsList = immutable_1.List(this.selectedDischargeDataItems);
	        this.onSelectedItemsChange({
	            selectedDischargeDataItems: selectedDischargeDataItemsList
	        });
	        if (this.dischargeDataListCurveController) {
	            this.dischargeDataListCurveController
	                .onSelectedDischargeDataItemsChange(selectedDischargeDataItemsList);
	        }
	    };
	    DischargeDataListController.prototype.notifyCreationChange = function () {
	        this.onCreatedItemsChange({
	            createdDischargeDataItems: this.createdDischargeDataItems
	        });
	        if (this.dischargeDataListCurveController) {
	            this.dischargeDataListCurveController
	                .onDischargeDataItemsChange(immutable_1.List(this.dischargeDataItems));
	        }
	    };
	    DischargeDataListController.$inject = ['$mdDialog'];
	    return DischargeDataListController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DischargeDataListController;
	var AddPairDialogController = (function () {
	    function AddPairDialogController($mdDialog) {
	        this.$mdDialog = $mdDialog;
	    }
	    AddPairDialogController.prototype.submit = function () {
	        this.$mdDialog.hide({
	            waterLevel: this.waterLevel,
	            discharge: this.discharge
	        });
	    };
	    AddPairDialogController.prototype.dismiss = function () {
	        this.$mdDialog.cancel();
	    };
	    AddPairDialogController.$inject = ['$mdDialog'];
	    return AddPairDialogController;
	}());


/***/ },
/* 228 */
/***/ function(module, exports) {

	module.exports = "<md-dialog> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>ADD_DISCHARGE_DATA_POINT</h2> </div> </md-toolbar> <md-dialog-content> <form class=md-dialog-content layout=column name=dischargePairForm> <md-input-container> <label translate>H_CM</label> <input md-no-asterisk required type=number step=1 min=0 ng-model=$ctrl.waterLevel> </md-input-container> <md-input-container> <label translate>Q_M3_S</label> <input md-no-asterisk required type=number step=0.001 min=0 ng-model=$ctrl.discharge> </md-input-container> </form> </md-dialog-content> <md-dialog-actions layout=row layout-align=\"end stretch\"> <md-button ng-click=$ctrl.dismiss()> <span translate>CANCEL</span> </md-button> <md-button class=md-primary ng-disabled=dischargePairForm.$invalid ng-click=$ctrl.submit()> <span translate>ADD</span> </md-button> </md-dialog-actions> </md-dialog>";

/***/ },
/* 229 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 230 */
/***/ function(module, exports) {

	module.exports = "<md-card flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span translate>DISCHARGE_DATA</span> <span flex></span> <md-button class=\"md-icon-button md-warn\" ng-show=$ctrl.canDelete ng-click=$ctrl.deleteCreatedDischargePairs()> <md-icon>delete</md-icon> <md-tooltip md-direction=down> <span translate>DELETE_SELECTED_ARTIFICIAL_DATA</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=$ctrl.showCreationDialog($event)> <md-icon>add</md-icon> </md-button> </div> </md-toolbar> <md-table-container class=table-bottom-margin> <table md-table md-row-select multiple=true ng-model=$ctrl.selectedDischargeDataItems> <thead md-head> <tr md-row> <th md-column ng-if=$ctrl.measuredDischargeDataItems.size> <span translate>DATE</span> </th> <th md-column md-numeric> <span translate>WATER_LEVEL</span> </th> <th md-column md-numeric> <span translate>DISCHARGE</span> </th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select md-select=dischargeDataItem md-on-select=$ctrl.onDischargeDataItemSelect md-on-deselect=$ctrl.onDischargeDataItemDeselect ng-repeat=\"dischargeDataItem in $ctrl.dischargeDataItems\"> <td md-cell ng-if=$ctrl.measuredDischargeDataItems.size> <span ng-show=dischargeDataItem.date> {{ dischargeDataItem.date | momentFormatter:'date-time' }} </span> <span ng-hide=dischargeDataItem.date> -- </span> </td> <td md-cell> {{ dischargeDataItem.waterLevel | hydroNumberFormatter }} <span translate>CM</span> </td> <td md-cell> {{ dischargeDataItem.discharge | hydroNumberFormatter }} <span translate>M3_S</span> </td> </tr> </tbody> </table> </md-table-container> </md-card>";

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var model_list_controller_1 = __webpack_require__(232);
	__webpack_require__(235);
	var template = __webpack_require__(236);
	var modelListComponent = {
	    bindings: {
	        dischargeModelItems: '<',
	        disabledDelete: '<',
	        minWaterLevel: '<',
	        maxWaterLevel: '<',
	        onModelToggle: '&',
	        onModelDelete: '&'
	    },
	    controller: model_list_controller_1.default,
	    require: {
	        dischargeModeListCurveController: '^^?imomoDischargeModelListCurve'
	    },
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = modelListComponent;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var curve_hq_table_controller_1 = __webpack_require__(233);
	var hqTableTemplate = __webpack_require__(234);
	var DischargeModelListController = (function () {
	    function DischargeModelListController($mdDialog, $translate) {
	        var _this = this;
	        this.$mdDialog = $mdDialog;
	        this.disabledModelsVisible = true;
	        this.dischargeModelItemsView = [];
	        // The signature for confirm in typings doesn't recognize onComplete.
	        var customMdDialog = $mdDialog;
	        this.deleteConfirmDialog = customMdDialog.confirm({
	            onComplete: function afterShowAnimation() {
	                // Change the buttons so that the OK action has md-warn.
	                var $dialog = angular.element(document.querySelector('md-dialog'));
	                var $actionsSection = $dialog.find('md-dialog-actions');
	                var $cancelButton = $actionsSection.children()[0];
	                var $confirmButton = $actionsSection.children()[1];
	                angular.element($confirmButton)
	                    .addClass('md-warn').removeClass('md-primary');
	                angular.element($cancelButton).removeClass('md-primary');
	            }
	        });
	        $translate([
	            'DELETE_DISCHARGE_MODEL',
	            'DELETE_DISCHARGE_MODEL_EXTENDED',
	            'DELETE',
	            'CANCEL'
	        ]).then(function (translations) {
	            _this.deleteConfirmDialog
	                .title(translations['DELETE_DISCHARGE_MODEL'])
	                .textContent(translations['DELETE_DISCHARGE_MODEL_EXTENDED'])
	                .ok(translations['DELETE'])
	                .cancel(translations['CANCEL']);
	        });
	    }
	    DischargeModelListController.prototype.$onChanges = function () {
	        this.minWaterLevel = this.minWaterLevel || 0;
	        this.maxWaterLevel = this.maxWaterLevel || 100;
	        this.dischargeModelItems = this.dischargeModelItems
	            || immutable_1.List();
	        this.notifyCurveController();
	        this.buildDischargeModelItemsView();
	    };
	    DischargeModelListController.prototype.onDischargeModelItemToggle = function () {
	        this.onModelToggle({
	            dischargeModelItems: this.dischargeModelItems
	        });
	        this.notifyCurveController();
	        this.buildDischargeModelItemsView();
	    };
	    DischargeModelListController.prototype.onDisabledModelsVisibilityToggle = function () {
	        this.buildDischargeModelItemsView();
	    };
	    DischargeModelListController.prototype.showHQTable = function ($event, dischargeModelItem) {
	        this.$mdDialog.show({
	            targetEvent: $event,
	            controller: curve_hq_table_controller_1.StationCreatorHQTableController,
	            controllerAs: '$ctrl',
	            bindToController: true,
	            locals: {
	                dischargeModel: dischargeModelItem.dischargeModel,
	                minWaterLevel: this.minWaterLevel,
	                maxWaterLevel: this.maxWaterLevel
	            },
	            template: hqTableTemplate
	        });
	    };
	    ;
	    DischargeModelListController.prototype.deleteDischargeModel = function ($event, $index) {
	        var _this = this;
	        this.deleteConfirmDialog.targetEvent($event);
	        this.$mdDialog.show(this.deleteConfirmDialog)
	            .then(function () {
	            var dischargeModelItem = _this.dischargeModelItems.get($index);
	            _this.dischargeModelItems = _this.dischargeModelItems.remove($index);
	            _this.buildDischargeModelItemsView();
	            _this.onModelDelete({
	                dischargeModelItem: dischargeModelItem,
	                dischargeModelItems: _this.dischargeModelItems
	            });
	            _this.notifyCurveController();
	        });
	    };
	    DischargeModelListController.prototype.buildDischargeModelItemsView = function () {
	        var _this = this;
	        this.dischargeModelItemsView = this.dischargeModelItems.filter(function (dischargeModelItem) {
	            return _this.disabledModelsVisible ? true : dischargeModelItem.enabled;
	        })
	            .toArray();
	    };
	    DischargeModelListController.prototype.notifyCurveController = function () {
	        if (this.dischargeModeListCurveController) {
	            this.dischargeModeListCurveController
	                .onDischargeModelItemsChange(this.dischargeModelItems);
	        }
	    };
	    DischargeModelListController.$inject = ['$mdDialog', '$translate'];
	    return DischargeModelListController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DischargeModelListController;


/***/ },
/* 233 */
/***/ function(module, exports) {

	"use strict";
	var StationCreatorHQTableController = (function () {
	    function StationCreatorHQTableController($mdDialog) {
	        this.$mdDialog = $mdDialog;
	    }
	    StationCreatorHQTableController.prototype.cancelDialog = function () {
	        this.$mdDialog.cancel();
	    };
	    StationCreatorHQTableController.$inject = ['$mdDialog'];
	    return StationCreatorHQTableController;
	}());
	exports.StationCreatorHQTableController = StationCreatorHQTableController;


/***/ },
/* 234 */
/***/ function(module, exports) {

	module.exports = "<md-dialog class=hq-table-dialog> <md-toolbar> <div class=md-toolbar-tools> <h2 translate>MODEL_H_Q_TABLE</h2> <span flex></span> <md-button class=md-icon-button ng-click=$ctrl.cancelDialog()> <md-icon class=material-icons>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content> <imomo-discharge-table discharge-model=$ctrl.dischargeModel min-x=$ctrl.minWaterLevel max-x=$ctrl.maxWaterLevel> </imomo-discharge-table> </div> </md-dialog-content> </md-dialog>";

/***/ },
/* 235 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 236 */
/***/ function(module, exports) {

	module.exports = "<md-card layout-padding class=model-list-card flex> <section layout=row flex=none> <span class=md-title translate> DISCHARGE_MODELS </span> <span flex></span> <md-checkbox ng-model=$ctrl.disabledModelsVisible ng-change=$ctrl.onDisabledModelsVisibilityToggle()> <span translate>SHOW_HIDDEN_MODELS</span> </md-checkbox> </section> <md-content flex class=model-list-content> <md-list class=model-list> <md-list-item class=md-2-line ng-click=null ng-repeat=\"dischargeModelItem in $ctrl.dischargeModelItemsView\"> <div class=md-avatar ng-style=\"{background:\n                    dischargeModelItem.colors.backgroundColor}\"></div> <div class=md-list-item-text> <h3> {{ dischargeModelItem.dischargeModel.modelName }} </h3> <p ng-if=dischargeModelItem.dischargeModel.validFrom> {{ dischargeModelItem.dischargeModel.validFrom | unixTimestampFormatter | momentFormatter:'date' }} </p> <p ng-if=!dischargeModelItem.dischargeModel.validFrom>∞</p> </div> <md-button class=\"md-icon-button md-secondary md-warn\" ng-if=!$ctrl.disabledDelete> <md-icon class=material-icons ng-click=\"$ctrl.deleteDischargeModel($event, $index)\"> delete_forever </md-icon> </md-button> <md-button class=\"md-icon-button md-secondary\"> <md-icon class=material-icons ng-click=\"$ctrl.showHQTable($event, dischargeModelItem)\"> view_module </md-icon> </md-button> <md-switch class=md-secondary ng-change=$ctrl.onDischargeModelItemToggle() ng-model=dischargeModelItem.enabled></md-switch> </md-list-item> </md-list> </md-content> </md-card>";

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var iter_functions_1 = __webpack_require__(238);
	var DischargeCurveFittingService = (function () {
	    function DischargeCurveFittingService() {
	    }
	    DischargeCurveFittingService.prototype.fitCurveQuadraticMethod = function (dischargePoints) {
	        var fitSolution = DischargeCurveFittingService.leastSquaresFit(dischargePoints.map(function (dp) { return dp.waterLevel; }), dischargePoints.map(function (dp) { return Math.sqrt(dp.discharge); }));
	        return {
	            paramA: fitSolution.a / fitSolution.b,
	            paramB: 2,
	            paramC: Math.pow(fitSolution.b, 2),
	            paramDeltaLevel: 0
	        };
	    };
	    DischargeCurveFittingService.leastSquaresFit = function (xValues, yValues) {
	        var meanX = mean(xValues);
	        var meanY = mean(yValues);
	        var ssxx = xValues.reduce(function (v, u) { return v + Math.pow(u - meanX, 2); }, 0);
	        var ssyy = yValues.reduce(function (v, u) { return v + Math.pow(u - meanY, 2); }, 0);
	        var ssxy = iter_functions_1.zip(xValues, yValues).reduce(function (v, _a) {
	            var a = _a[0], b = _a[1];
	            return v + ((a - meanX) * (b - meanY));
	        }, 0);
	        return {
	            a: meanY - (ssxy * meanX / ssxx),
	            b: ssxy / ssxx,
	            r: Math.pow(ssxy, 2) / (ssxx * ssyy)
	        };
	    };
	    return DischargeCurveFittingService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DischargeCurveFittingService;
	function mean(values) {
	    return values.reduce(function (v, u) { return v + u; }, 0) / values.length;
	}


/***/ },
/* 238 */
/***/ function(module, exports) {

	"use strict";
	function zip(valuesA, valuesB) {
	    return valuesA.map(function (valueA, index) { return [valueA, valuesB[index]]; });
	}
	exports.zip = zip;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var dischargeDataListCurveFactory = function () {
	    return {
	        restrict: 'A',
	        controller: DischargeDataListCurveController
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = dischargeDataListCurveFactory;
	var DischargeDataListCurveController = (function () {
	    function DischargeDataListCurveController($filter) {
	        this.momentFormatter = $filter('momentFormatter');
	        this.dischargeDataItems = immutable_1.List();
	        this.selectedDischargeDataItems = immutable_1.Set();
	        this.dischargeChartPoints = immutable_1.List();
	    }
	    DischargeDataListCurveController.prototype.addDischargeCurveController = function (dischargeCurveController) {
	        this.dischargeCurveController = dischargeCurveController;
	    };
	    DischargeDataListCurveController.prototype.onDischargeDataItemsChange = function (dischargeDataItems) {
	        this.dischargeDataItems = dischargeDataItems;
	        this.buildChartDataList();
	    };
	    DischargeDataListCurveController.prototype.onSelectedDischargeDataItemsChange = function (selectedDischargeDataItems) {
	        this.selectedDischargeDataItems = immutable_1.Set(selectedDischargeDataItems);
	        this.buildChartDataList();
	    };
	    DischargeDataListCurveController.prototype.buildChartDataList = function () {
	        var _this = this;
	        this.dischargeChartPoints = this.dischargeDataItems
	            .map(function (dischargeDataItem) {
	            return {
	                discharge: dischargeDataItem.discharge,
	                waterLevel: dischargeDataItem.waterLevel,
	                label: _this.momentFormatter(dischargeDataItem.date, 'roman'),
	                selected: _this.selectedDischargeDataItems
	                    .contains(dischargeDataItem)
	            };
	        }).toList();
	        this.notifyChart();
	    };
	    DischargeDataListCurveController.prototype.notifyChart = function () {
	        if (this.dischargeCurveController) {
	            this.dischargeCurveController
	                .onDischargeChartPointsChange(this.dischargeChartPoints);
	        }
	    };
	    DischargeDataListCurveController.$inject = ['$filter'];
	    return DischargeDataListCurveController;
	}());


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var dischargeModelListCurveFactory = function () {
	    return {
	        restrict: 'A',
	        controller: DischargeModelListCurveController
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = dischargeModelListCurveFactory;
	var DischargeModelListCurveController = (function () {
	    function DischargeModelListCurveController() {
	        this.visibleDischargeModelItems = immutable_1.List();
	    }
	    DischargeModelListCurveController.prototype.addDischargeCurveController = function (dischargeCurveController) {
	        this.dischargeCurveController = dischargeCurveController;
	    };
	    DischargeModelListCurveController.prototype.onDischargeModelItemsChange = function (dischargeModelItems) {
	        this.visibleDischargeModelItems = dischargeModelItems
	            .filter(function (dischargeModelItem) { return dischargeModelItem.enabled; }).toList();
	        if (this.dischargeCurveController) {
	            this.dischargeCurveController
	                .onDischargeModelItemsChange(this.visibleDischargeModelItems);
	        }
	    };
	    return DischargeModelListCurveController;
	}());


/***/ },
/* 241 */
/***/ function(module, exports) {

	"use strict";
	var ModelCreatorService = (function () {
	    function ModelCreatorService(dischargeCurveFittingService) {
	        this.dischargeCurveFittingService = dischargeCurveFittingService;
	    }
	    ModelCreatorService.prototype.createModel = function (newModelOptions) {
	        var dischargeModelBase = {
	            id: -1,
	            modelName: newModelOptions.name,
	            validFrom: newModelOptions.date.clone().unix(),
	            paramA: 0,
	            paramB: 0,
	            paramC: 0,
	            paramDeltaLevel: 0
	        };
	        switch (newModelOptions.creationMode) {
	            case 'deltaH':
	                dischargeModelBase.paramA =
	                    newModelOptions.referenceModel.paramA + newModelOptions.deltaH;
	                dischargeModelBase.paramB = newModelOptions.referenceModel.paramB;
	                dischargeModelBase.paramC = newModelOptions.referenceModel.paramC;
	                dischargeModelBase.paramDeltaLevel =
	                    newModelOptions.referenceModel.paramDeltaLevel;
	                break;
	            case 'fitCurve':
	                var modelFit = this.dischargeCurveFittingService
	                    .fitCurveQuadraticMethod(newModelOptions.selectedDischargeDataItems.toArray());
	                dischargeModelBase.paramA = modelFit.paramA;
	                dischargeModelBase.paramB = modelFit.paramB;
	                dischargeModelBase.paramC = modelFit.paramC;
	                dischargeModelBase.paramDeltaLevel = modelFit.paramDeltaLevel;
	                break;
	        }
	        return dischargeModelBase;
	    };
	    ModelCreatorService.prototype.validateOptions = function (newModelOptions) {
	        switch (newModelOptions.creationMode) {
	            case 'deltaH':
	                return newModelOptions.name != null &&
	                    newModelOptions.deltaH != null &&
	                    newModelOptions.referenceModel != null;
	            case 'fitCurve':
	                return newModelOptions.selectedDischargeDataItems.size >= 2 &&
	                    newModelOptions.name != null;
	            default:
	                return false;
	        }
	    };
	    ModelCreatorService.$inject = ['dischargeCurveFittingService'];
	    return ModelCreatorService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ModelCreatorService;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var modelFormatterFactory = function ($filter) {
	    var momentFormatter = $filter('momentFormatter');
	    return function (dischargeModel) {
	        if (dischargeModel) {
	            if (dischargeModel.validFrom) {
	                return dischargeModel.modelName + " -\n    \t\t" + momentFormatter(moment.unix(dischargeModel.validFrom));
	            }
	            else {
	                return dischargeModel.modelName + " - \u221E";
	            }
	        }
	        return '';
	    };
	};
	modelFormatterFactory.$inject = ['$filter'];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = modelFormatterFactory;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var error_service_1 = __webpack_require__(244);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.error', [])
	    .service('imomoErrorService', error_service_1.default)
	    .name;


/***/ },
/* 244 */
/***/ function(module, exports) {

	"use strict";
	var ImomoErrorService = (function () {
	    function ImomoErrorService($mdDialog, $translate) {
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	    }
	    ImomoErrorService.prototype.showMissingStationErrorDialog = function (stationCode) {
	        var dialog = this.$mdDialog.alert()
	            .title(this.$translate.instant('NON_EXISTENT_STATION_CODE'))
	            .textContent(this.$translate.instant('NON_EXISTENT_STATION_CODE_EXTENDED', { stationCode: stationCode }))
	            .ok(this.$translate.instant('OK'));
	        return this.$mdDialog.show(dialog);
	    };
	    ImomoErrorService.prototype.showForbiddenStationErrorDialog = function (stationCode) {
	        var dialog = this.$mdDialog.alert()
	            .title(this.$translate.instant('FORBIDDEN_STATION_CODE'))
	            .textContent(this.$translate.instant('FORBIDDEN_STATION_CODE_EXTENDED', { stationCode: stationCode }))
	            .ok(this.$translate.instant('OK'));
	        return this.$mdDialog.show(dialog);
	    };
	    ImomoErrorService.prototype.showErrorDetailsDialog = function (errorMsg) {
	        var dialog = this.$mdDialog.alert()
	            .title(this.$translate.instant('ERROR'))
	            .textContent(errorMsg)
	            .ok(this.$translate.instant('OK'));
	        return this.$mdDialog.show(dialog);
	    };
	    ImomoErrorService.prototype.showGenericErrorDialog = function () {
	        var dialog = this.$mdDialog.alert()
	            .title(this.$translate.instant('UNEXPECTED_ERROR'))
	            .textContent(this.$translate.instant('UNEXPECTED_ERROR_EXTENDED'))
	            .ok(this.$translate.instant('TRY_AGAIN'));
	        return this.$mdDialog.show(dialog);
	    };
	    ImomoErrorService.$inject = ['$mdDialog', '$translate'];
	    return ImomoErrorService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ImomoErrorService;


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	var hydromet_component_1 = __webpack_require__(246);
	var home_component_1 = __webpack_require__(249);
	var organization_component_1 = __webpack_require__(252);
	var toolbar_component_1 = __webpack_require__(259);
	var sidenav_component_1 = __webpack_require__(264);
	var help_component_1 = __webpack_require__(267);
	var about_component_1 = __webpack_require__(270);
	var invitations_component_1 = __webpack_require__(273);
	var sidenav_service_1 = __webpack_require__(276);
	var organization_service_1 = __webpack_require__(277);
	var userManagement_component_1 = __webpack_require__(278);
	var userDetails_component_1 = __webpack_require__(282);
	var reset_password_component_1 = __webpack_require__(287);
	var timeseries_component_1 = __webpack_require__(290);
	var timeseries_new_component_1 = __webpack_require__(294);
	var seasonal_frequency_manager_component_1 = __webpack_require__(301);
	var access_component_1 = __webpack_require__(305);
	var cms_component_1 = __webpack_require__(308);
	var wizard_component_1 = __webpack_require__(314);
	var paginationControls_component_1 = __webpack_require__(318);
	var change_password_form_component_1 = __webpack_require__(322);
	var reporting_templates_component_1 = __webpack_require__(325);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.hydromet', [])
	    .component('hydromet', hydromet_component_1.hydrometComponent)
	    .component('hydrometHome', home_component_1.default)
	    .component('hydrometOrganization', organization_component_1.default)
	    .component('hydrometHelp', help_component_1.default)
	    .component('hydrometAbout', about_component_1.default)
	    .component('hydrometInvitations', invitations_component_1.default)
	    .component('userManagement', userManagement_component_1.default)
	    .component('userDetails', userDetails_component_1.default)
	    .component('hydrometToolbar', toolbar_component_1.default)
	    .component('hydrometSidenav', sidenav_component_1.default)
	    .component('resetPassword', reset_password_component_1.default)
	    .component('hydrometTimeseries', timeseries_component_1.default)
	    .component('hydrometTimeseriesNew', timeseries_new_component_1.default)
	    .component('seasonalFrequencyManager', seasonal_frequency_manager_component_1.default)
	    .component('access', access_component_1.default)
	    .component('cms', cms_component_1.default)
	    .component('wizard', wizard_component_1.default)
	    .component('paginationControls', paginationControls_component_1.default)
	    .component('changePasswordForm', change_password_form_component_1.default)
	    .component('reportingTemplates', reporting_templates_component_1.default)
	    .service('sidenavService', sidenav_service_1.SidenavService)
	    .service('organizationService', organization_service_1.default)
	    .config(hydromet_component_1.configStates)
	    .name;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(247);
	var template = __webpack_require__(248);
	exports.hydrometComponent = {
	    template: template
	};
	exports.configStates = function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('home', {
	        component: 'hydrometHome',
	        url: '/home'
	    });
	    $stateProvider.state('login', {
	        component: 'imomoLogin',
	        url: '/login'
	    });
	    $stateProvider.state('help', {
	        component: 'hydrometHelp',
	        url: '/help'
	    });
	    $stateProvider.state('about', {
	        component: 'hydrometAbout',
	        url: '/about'
	    });
	    $stateProvider.state('organization', {
	        component: 'hydrometOrganization',
	        url: '/organization/:id'
	    });
	    $stateProvider.state('user-management', {
	        component: 'userManagement',
	        url: '/users'
	    });
	    $stateProvider.state('user-details', {
	        component: 'userDetails',
	        url: '/users/:id'
	    });
	    $stateProvider.state('reset-password', {
	        component: 'resetPassword',
	        url: '/reset-password/'
	    });
	    $stateProvider.state('access', {
	        component: 'access',
	        url: '/access'
	    });
	    $stateProvider.state('invitations', {
	        component: 'hydrometInvitations',
	        url: '/invitations/'
	    });
	    $urlRouterProvider.when('/', '/home').otherwise('/home');
	};
	exports.configStates.$inject = ['$stateProvider', '$urlRouterProvider'];


/***/ },
/* 247 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 248 */
/***/ function(module, exports) {

	module.exports = "<hydromet-sidenav layout=row></hydromet-sidenav> <div layout=column flex> <hydromet-toolbar></hydromet-toolbar> <section class=hydromet-outlet flex ui-view> </section> </div>";

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var home_controller_1 = __webpack_require__(250);
	var template = __webpack_require__(251);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: home_controller_1.default,
	    template: template
	};


/***/ },
/* 250 */
/***/ function(module, exports) {

	"use strict";
	var HomeController = (function () {
	    function HomeController(loginService, userApi, $scope, $window) {
	        var _this = this;
	        this.loginService = loginService;
	        this.userApi = userApi;
	        this.$window = $window;
	        this.onLoginStateChange(loginService.isLoggedIn());
	        var deregisterLoginStateListener = loginService
	            .onLoginStateChange(function (loggedIn) { return _this.onLoginStateChange(loggedIn); });
	        $scope.$on('$destroy', function () {
	            deregisterLoginStateListener();
	        });
	    }
	    HomeController.prototype.logOut = function () {
	        this.loginService.logOutUser();
	        this.$window.localStorage.removeItem('currentOrgId');
	    };
	    HomeController.prototype.onLoginStateChange = function (loggedIn) {
	        var _this = this;
	        this.loggedIn = loggedIn;
	        if (this.loggedIn) {
	            this.currentUser = null;
	            this.userApi.getCurrentUser().then(function (user) { return _this.currentUser = user; });
	        }
	    };
	    HomeController.$inject = ['loginService', 'userApi', '$scope', '$window'];
	    return HomeController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = HomeController;


/***/ },
/* 251 */
/***/ function(module, exports) {

	module.exports = "<section layout=row flex class=home-container> <imomo-login-card class=flex-width flex ng-hide=$ctrl.loggedIn layout=row layout-align=\"center stretch\"></imomo-login-card> <md-card flex layout-padding ng-show=$ctrl.loggedIn> <h3 class=md-title> <span translate>WELCOME_BACK</span> <span class=md-subhead>{{ $ctrl.currentUser.fullName }}</span> </h3> <a translate>CLOUD_AUTOMATED_WORKSTATION_OF_THE_OPERATIONAL_HYDROLOGIST</a> <md-list> <md-list-item translate>1_PROCESSING_OF_KH_15_TELEGRAMS_WITH_DAILY_HYDROLOGICAL_DATA</md-list-item> <md-list-item translate>2_CREATION_AND_MODIFICATION_OF_OPERATIONAL_DISCHARGE_RATION_CURVES</md-list-item> <md-list-item translate>3_CALCULATION_OF_CURRENT_AND_DAILY_AVERAGE_HYDROLOGICAL_VALUES</md-list-item> <md-list-item translate>4_RELEASE_OF_THE_DAILY_HYDROLOGICAL_BULLETIN</md-list-item> <md-list-item translate>5_HYDROLOGICAL_FORECASTING</md-list-item> </md-list> <p flex></p> <md-button class=\"md-raised md-warn\" ng-click=$ctrl.logOut()> <span translate>LOG_OUT</span> </md-button> </md-card> <imomo-news layout=row flex></imomo-news> </section>";

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var organization_controller_1 = __webpack_require__(253);
	__webpack_require__(257);
	var template = __webpack_require__(258);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: organization_controller_1.default,
	    bindings: {
	        id: '<',
	        isEditable: '<',
	        isInsideOrgSetupWizard: '<',
	        organizationForm: '=',
	        organizationData: '=',
	        forecastTypes: '=',
	        seasonalForecastTypes: '='
	    },
	    template: template
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(254);
	var IOrganizationEvents;
	(function (IOrganizationEvents) {
	    IOrganizationEvents.ORGANIZATION_CHANGE = 'imomo-organization-change';
	})(IOrganizationEvents = exports.IOrganizationEvents || (exports.IOrganizationEvents = {}));
	var OrganizationController = (function () {
	    function OrganizationController(organizationApi, $window, $filter, userApi, $stateParams, $state, $mdDialog, organizationService, $rootScope, $q, imomoErrorService, $scope, stationApi, $translate) {
	        var _this = this;
	        this.organizationApi = organizationApi;
	        this.$window = $window;
	        this.$filter = $filter;
	        this.userApi = userApi;
	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.$mdDialog = $mdDialog;
	        this.organizationService = organizationService;
	        this.$rootScope = $rootScope;
	        this.$q = $q;
	        this.imomoErrorService = imomoErrorService;
	        this.$scope = $scope;
	        this.stationApi = stationApi;
	        this.$translate = $translate;
	        this.isSaving = false;
	        this.isDeleting = false;
	        this.isLoading = true;
	        this.isNew = false;
	        this.isEditable = false;
	        var currentTime = new Date();
	        var currentOrgId = parseInt(this.$window.localStorage.getItem('currentOrgId'), 10);
	        this.forecastTypes = {
	            fiveDay: {
	                name: "5-day",
	                sourceId: currentOrgId,
	                frequency: "pentadal",
	                issueDateOffset: undefined
	            },
	            decadal: {
	                name: "Decadal",
	                sourceId: currentOrgId,
	                frequency: "decade",
	                issueDateOffset: undefined
	            },
	            monthly: {
	                name: "Monthly",
	                sourceId: currentOrgId,
	                frequency: "monthly",
	                issueDateOffset: undefined
	            }
	        };
	        this.yearTypes = ["hydro_year", "calendar_year"];
	        this.seasonalForecastTypes = [];
	        if (this.$stateParams.id !== 'new') {
	            this.fetchOrganization(this.$stateParams.id || this.id.toString());
	        }
	        else {
	            this.isNew = true;
	            this.isEditable = true;
	            this.isLoading = false;
	        }
	        if (typeof this.isEditable === 'undefined') {
	            this.isEditable = false;
	        }
	        userApi.getUserList()
	            .then(function (data) {
	            data.forEach(function (user) {
	                delete user.sourceId;
	                delete user.registeredOn;
	            });
	            _this.users = data;
	        });
	        userApi.getCurrentUser()
	            .then(function (data) {
	            _this.currentUser = data;
	        });
	        organizationApi.getOrganizations()
	            .then(function (organizations) {
	            _this.organizations = organizations;
	        });
	        if (this.isInsideOrgSetupWizard) {
	            this.isEditable = true;
	        }
	        this.filter = $filter('filter');
	        this.timezones = moment.tz.names();
	    }
	    OrganizationController.prototype.getMatchedTimezones = function (searchText) {
	        var _this = this;
	        return this.filter(this.timezones, searchText).filter(function (timezone) {
	            return _this.timezones.indexOf(timezone) != -1;
	        });
	    };
	    OrganizationController.prototype.fetchOrganization = function (id) {
	        var _this = this;
	        this.organizationApi.getOrganization(parseInt(id, 10))
	            .then(function (data) {
	            _this.organizationData = data;
	            _this.$window.localStorage.setItem('currentOrgId', id);
	            _this.$rootScope.$broadcast(IOrganizationEvents.ORGANIZATION_CHANGE);
	            _this.organizationApi.getForecastTypes(parseInt(id, 10))
	                .then(function (forecastTypes) {
	                forecastTypes.forEach(function (forecastType) {
	                    switch (forecastType.frequency) {
	                        case 'pentadal':
	                            _this.forecastTypes.fiveDay = forecastType;
	                            break;
	                        case 'decade':
	                            _this.forecastTypes.decadal = forecastType;
	                            break;
	                        case 'monthly':
	                            _this.forecastTypes.monthly = forecastType;
	                            break;
	                        case 'seasonal':
	                            // console.log(1, forecastType.issueDate,new Date(forecastType.issueDate))
	                            // forecastType.issueDate = new Date(forecastType.issueDate);
	                            // forecastType.targetPeriodStart = new Date(forecastType.targetPeriodStart);
	                            // forecastType.targetPeriodEnd = new Date(forecastType.targetPeriodEnd);
	                            _this.seasonalForecastTypes.push(forecastType);
	                            break;
	                        default:
	                            break;
	                    }
	                });
	            });
	            _this.isLoading = false;
	        }, function (errorData) {
	            _this.isLoading = false;
	        });
	    };
	    OrganizationController.prototype.onOrganizationChange = function (newOrganizationId) {
	        this.$window.localStorage.setItem('currentOrgId', newOrganizationId);
	        this.$rootScope.$broadcast(IOrganizationEvents.ORGANIZATION_CHANGE);
	        this.$state.go('organization', { id: newOrganizationId });
	    };
	    OrganizationController.prototype.onCancelClick = function ($event) {
	        this.isEditable = false;
	        if (this.isNew) {
	            this.$state.go('organization', { id: Number.parseInt(this.$window.localStorage.getItem('currentOrgId')) });
	        }
	    };
	    OrganizationController.prototype.onSaveClick = function ($event) {
	        var self = this;
	        self.isEditable = false;
	        self.isSaving = true;
	        self.organizationApi.saveOrganization(this.organizationData)
	            .then(function (data) {
	            self.isSaving = false;
	            self.$window.localStorage.setItem('currentOrgId', data.id + '');
	            self.$state.go('organization', { id: data.id });
	            self.$rootScope.$broadcast(IOrganizationEvents.ORGANIZATION_CHANGE);
	            self.submitForecastTypes();
	            self.$window.localStorage.setItem('orgTimezone', self.organizationData.timezone);
	        }, function (errorData) {
	            self.isSaving = false;
	            self.$mdDialog.show(self.$mdDialog.alert()
	                .clickOutsideToClose(true)
	                .title(this.$translate.instant('SAVE_FAILED'))
	                .textContent(errorData.data.details)
	                .ok('OK')
	                .targetEvent($event));
	        });
	    };
	    OrganizationController.prototype.submitForecastTypes = function () {
	        var _this = this;
	        var forecastTypes = [];
	        var forecastTypePromises = [];
	        var currentOrgId = Number.parseInt(this.$window.localStorage.getItem('currentOrgId'));
	        if (typeof this.forecastTypes.fiveDay.issueDateOffset !== 'undefined') {
	            forecastTypes.push(this.forecastTypes.fiveDay);
	        }
	        if (typeof this.forecastTypes.decadal.issueDateOffset !== 'undefined') {
	            forecastTypes.push(this.forecastTypes.decadal);
	        }
	        if (typeof this.forecastTypes.monthly.issueDateOffset !== 'undefined') {
	            forecastTypes.push(this.forecastTypes.monthly);
	        }
	        forecastTypes.concat(this.seasonalForecastTypes)
	            .forEach(function (forecastType) {
	            if (!forecastType.id) {
	                forecastTypePromises
	                    .push(_this.organizationApi.createForecastType(currentOrgId, forecastType));
	            }
	            else {
	                forecastTypePromises
	                    .push(_this.organizationApi.updateForecastType(currentOrgId, forecastType));
	            }
	        });
	        this.$q.all(forecastTypePromises)
	            .then(function () { })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	        });
	    };
	    OrganizationController.prototype.goToCurrentOrg = function () {
	        var _this = this;
	        this.organizationService.getCurrentOrgId()
	            .then(function (id) {
	            _this.$state.go('organization', { id: id });
	        });
	    };
	    OrganizationController.prototype.onBackClick = function ($event) {
	        this.goToCurrentOrg();
	    };
	    OrganizationController.prototype.onDeleteClick = function ($event) {
	        var self = this;
	        var confirm = this.$mdDialog.confirm()
	            .title(this.$translate.instant('DELETE_ORGANIZATION'))
	            .textContent(this.$translate.instant('DELETE_CONFIRMATION', { item: self.organizationData.organization }))
	            .targetEvent($event)
	            .ok(this.$translate.instant('DELETE'))
	            .cancel(this.$translate.instant('CANCEL'));
	        this.$mdDialog.show(confirm).then(function () {
	            self.isDeleting = true;
	            self.organizationApi.deleteOrganization(parseInt(self.$stateParams.id))
	                .then(function (data) {
	                self.isDeleting = false;
	                self.$window.localStorage.removeItem('currentOrgId');
	                self.goToCurrentOrg();
	                self.$rootScope.$broadcast(IOrganizationEvents.ORGANIZATION_CHANGE);
	            }, function (errorData) {
	                self.isDeleting = false;
	            });
	        });
	    };
	    OrganizationController.prototype.onSeasonalFrequencyChange = function (seasonalFrequencies) {
	        this.seasonalForecastTypes = seasonalFrequencies;
	    };
	    OrganizationController.$inject = ['organizationApi', '$window', '$filter', 'userApi', '$stateParams',
	        '$state', '$mdDialog', 'organizationService', '$rootScope', '$q', 'imomoErrorService', '$scope', 'stationApi', '$translate'];
	    return OrganizationController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OrganizationController;


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(255);
	moment.tz.load(__webpack_require__(256));


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.29
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(45)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(45)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.29",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Country object
		************************************/
	
		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
	
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function getCountryNames () {
			return Object.keys(countries);
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) return;
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}
	
		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}
	
		function zonesForCountry(country, with_offset) {
			country = getCountry(country);
	
			if (!country) return null;
	
			var zones = country.zones.sort();
	
			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}
	
			return zones;
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 256 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2019c",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
			"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
			"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
			"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
			"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
			"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
			"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
			"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5",
			"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
			"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
			"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
			"Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|-02|20|0||30",
			"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"EST|EST|50|0||",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Etc/GMT-0|GMT|0|0||",
			"Etc/GMT-1|+01|-10|0||",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Etc/GMT-11|+11|-b0|0||",
			"Pacific/Tarawa|+12|-c0|0||29e3",
			"Etc/GMT-13|+13|-d0|0||",
			"Etc/GMT-14|+14|-e0|0||",
			"Etc/GMT-2|+02|-20|0||",
			"Etc/GMT-3|+03|-30|0||",
			"Etc/GMT-4|+04|-40|0||",
			"Etc/GMT-5|+05|-50|0||",
			"Etc/GMT-6|+06|-60|0||",
			"Indian/Christmas|+07|-70|0||21e2",
			"Etc/GMT-8|+08|-80|0||",
			"Pacific/Palau|+09|-90|0||21e3",
			"Etc/GMT+1|-01|10|0||",
			"Etc/GMT+10|-10|a0|0||",
			"Etc/GMT+11|-11|b0|0||",
			"Etc/GMT+12|-12|c0|0||",
			"Etc/GMT+3|-03|30|0||",
			"Etc/GMT+4|-04|40|0||",
			"Etc/GMT+5|-05|50|0||",
			"Etc/GMT+6|-06|60|0||",
			"Etc/GMT+7|-07|70|0||",
			"Etc/GMT+8|-08|80|0||",
			"Etc/GMT+9|-09|90|0||",
			"Etc/UTC|UTC|0|0||",
			"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0||",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Cocos|+0630|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"MST|MST|70|0||",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1",
			"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
			"Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4",
			"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
			"Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
			"Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
			"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
			"Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
			"Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3",
			"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Atlantic/South_Georgia|Etc/GMT+2",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT-0|Etc/GMT",
			"Etc/GMT-0|Etc/GMT+0",
			"Etc/GMT-0|Etc/GMT0",
			"Etc/GMT-0|Etc/Greenwich",
			"Etc/GMT-0|GMT",
			"Etc/GMT-0|GMT+0",
			"Etc/GMT-0|GMT-0",
			"Etc/GMT-0|GMT0",
			"Etc/GMT-0|Greenwich",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Christmas|Etc/GMT-7",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Chuuk|Pacific/Truk",
			"Pacific/Chuuk|Pacific/Yap",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Palau|Etc/GMT-9",
			"Pacific/Pohnpei|Pacific/Ponape",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Tarawa|Etc/GMT-12",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		],
		"countries": [
			"AD|Europe/Andorra",
			"AE|Asia/Dubai",
			"AF|Asia/Kabul",
			"AG|America/Port_of_Spain America/Antigua",
			"AI|America/Port_of_Spain America/Anguilla",
			"AL|Europe/Tirane",
			"AM|Asia/Yerevan",
			"AO|Africa/Lagos Africa/Luanda",
			"AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo",
			"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
			"AS|Pacific/Pago_Pago",
			"AT|Europe/Vienna",
			"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
			"AW|America/Curacao America/Aruba",
			"AX|Europe/Helsinki Europe/Mariehamn",
			"AZ|Asia/Baku",
			"BA|Europe/Belgrade Europe/Sarajevo",
			"BB|America/Barbados",
			"BD|Asia/Dhaka",
			"BE|Europe/Brussels",
			"BF|Africa/Abidjan Africa/Ouagadougou",
			"BG|Europe/Sofia",
			"BH|Asia/Qatar Asia/Bahrain",
			"BI|Africa/Maputo Africa/Bujumbura",
			"BJ|Africa/Lagos Africa/Porto-Novo",
			"BL|America/Port_of_Spain America/St_Barthelemy",
			"BM|Atlantic/Bermuda",
			"BN|Asia/Brunei",
			"BO|America/La_Paz",
			"BQ|America/Curacao America/Kralendijk",
			"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
			"BS|America/Nassau",
			"BT|Asia/Thimphu",
			"BW|Africa/Maputo Africa/Gaborone",
			"BY|Europe/Minsk",
			"BZ|America/Belize",
			"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson",
			"CC|Indian/Cocos",
			"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
			"CF|Africa/Lagos Africa/Bangui",
			"CG|Africa/Lagos Africa/Brazzaville",
			"CH|Europe/Zurich",
			"CI|Africa/Abidjan",
			"CK|Pacific/Rarotonga",
			"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
			"CM|Africa/Lagos Africa/Douala",
			"CN|Asia/Shanghai Asia/Urumqi",
			"CO|America/Bogota",
			"CR|America/Costa_Rica",
			"CU|America/Havana",
			"CV|Atlantic/Cape_Verde",
			"CW|America/Curacao",
			"CX|Indian/Christmas",
			"CY|Asia/Nicosia Asia/Famagusta",
			"CZ|Europe/Prague",
			"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
			"DJ|Africa/Nairobi Africa/Djibouti",
			"DK|Europe/Copenhagen",
			"DM|America/Port_of_Spain America/Dominica",
			"DO|America/Santo_Domingo",
			"DZ|Africa/Algiers",
			"EC|America/Guayaquil Pacific/Galapagos",
			"EE|Europe/Tallinn",
			"EG|Africa/Cairo",
			"EH|Africa/El_Aaiun",
			"ER|Africa/Nairobi Africa/Asmara",
			"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
			"ET|Africa/Nairobi Africa/Addis_Ababa",
			"FI|Europe/Helsinki",
			"FJ|Pacific/Fiji",
			"FK|Atlantic/Stanley",
			"FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae",
			"FO|Atlantic/Faroe",
			"FR|Europe/Paris",
			"GA|Africa/Lagos Africa/Libreville",
			"GB|Europe/London",
			"GD|America/Port_of_Spain America/Grenada",
			"GE|Asia/Tbilisi",
			"GF|America/Cayenne",
			"GG|Europe/London Europe/Guernsey",
			"GH|Africa/Accra",
			"GI|Europe/Gibraltar",
			"GL|America/Godthab America/Danmarkshavn America/Scoresbysund America/Thule",
			"GM|Africa/Abidjan Africa/Banjul",
			"GN|Africa/Abidjan Africa/Conakry",
			"GP|America/Port_of_Spain America/Guadeloupe",
			"GQ|Africa/Lagos Africa/Malabo",
			"GR|Europe/Athens",
			"GS|Atlantic/South_Georgia",
			"GT|America/Guatemala",
			"GU|Pacific/Guam",
			"GW|Africa/Bissau",
			"GY|America/Guyana",
			"HK|Asia/Hong_Kong",
			"HN|America/Tegucigalpa",
			"HR|Europe/Belgrade Europe/Zagreb",
			"HT|America/Port-au-Prince",
			"HU|Europe/Budapest",
			"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
			"IE|Europe/Dublin",
			"IL|Asia/Jerusalem",
			"IM|Europe/London Europe/Isle_of_Man",
			"IN|Asia/Kolkata",
			"IO|Indian/Chagos",
			"IQ|Asia/Baghdad",
			"IR|Asia/Tehran",
			"IS|Atlantic/Reykjavik",
			"IT|Europe/Rome",
			"JE|Europe/London Europe/Jersey",
			"JM|America/Jamaica",
			"JO|Asia/Amman",
			"JP|Asia/Tokyo",
			"KE|Africa/Nairobi",
			"KG|Asia/Bishkek",
			"KH|Asia/Bangkok Asia/Phnom_Penh",
			"KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati",
			"KM|Africa/Nairobi Indian/Comoro",
			"KN|America/Port_of_Spain America/St_Kitts",
			"KP|Asia/Pyongyang",
			"KR|Asia/Seoul",
			"KW|Asia/Riyadh Asia/Kuwait",
			"KY|America/Panama America/Cayman",
			"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
			"LA|Asia/Bangkok Asia/Vientiane",
			"LB|Asia/Beirut",
			"LC|America/Port_of_Spain America/St_Lucia",
			"LI|Europe/Zurich Europe/Vaduz",
			"LK|Asia/Colombo",
			"LR|Africa/Monrovia",
			"LS|Africa/Johannesburg Africa/Maseru",
			"LT|Europe/Vilnius",
			"LU|Europe/Luxembourg",
			"LV|Europe/Riga",
			"LY|Africa/Tripoli",
			"MA|Africa/Casablanca",
			"MC|Europe/Monaco",
			"MD|Europe/Chisinau",
			"ME|Europe/Belgrade Europe/Podgorica",
			"MF|America/Port_of_Spain America/Marigot",
			"MG|Africa/Nairobi Indian/Antananarivo",
			"MH|Pacific/Majuro Pacific/Kwajalein",
			"MK|Europe/Belgrade Europe/Skopje",
			"ML|Africa/Abidjan Africa/Bamako",
			"MM|Asia/Yangon",
			"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
			"MO|Asia/Macau",
			"MP|Pacific/Guam Pacific/Saipan",
			"MQ|America/Martinique",
			"MR|Africa/Abidjan Africa/Nouakchott",
			"MS|America/Port_of_Spain America/Montserrat",
			"MT|Europe/Malta",
			"MU|Indian/Mauritius",
			"MV|Indian/Maldives",
			"MW|Africa/Maputo Africa/Blantyre",
			"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas",
			"MY|Asia/Kuala_Lumpur Asia/Kuching",
			"MZ|Africa/Maputo",
			"NA|Africa/Windhoek",
			"NC|Pacific/Noumea",
			"NE|Africa/Lagos Africa/Niamey",
			"NF|Pacific/Norfolk",
			"NG|Africa/Lagos",
			"NI|America/Managua",
			"NL|Europe/Amsterdam",
			"NO|Europe/Oslo",
			"NP|Asia/Kathmandu",
			"NR|Pacific/Nauru",
			"NU|Pacific/Niue",
			"NZ|Pacific/Auckland Pacific/Chatham",
			"OM|Asia/Dubai Asia/Muscat",
			"PA|America/Panama",
			"PE|America/Lima",
			"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
			"PG|Pacific/Port_Moresby Pacific/Bougainville",
			"PH|Asia/Manila",
			"PK|Asia/Karachi",
			"PL|Europe/Warsaw",
			"PM|America/Miquelon",
			"PN|Pacific/Pitcairn",
			"PR|America/Puerto_Rico",
			"PS|Asia/Gaza Asia/Hebron",
			"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
			"PW|Pacific/Palau",
			"PY|America/Asuncion",
			"QA|Asia/Qatar",
			"RE|Indian/Reunion",
			"RO|Europe/Bucharest",
			"RS|Europe/Belgrade",
			"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
			"RW|Africa/Maputo Africa/Kigali",
			"SA|Asia/Riyadh",
			"SB|Pacific/Guadalcanal",
			"SC|Indian/Mahe",
			"SD|Africa/Khartoum",
			"SE|Europe/Stockholm",
			"SG|Asia/Singapore",
			"SH|Africa/Abidjan Atlantic/St_Helena",
			"SI|Europe/Belgrade Europe/Ljubljana",
			"SJ|Europe/Oslo Arctic/Longyearbyen",
			"SK|Europe/Prague Europe/Bratislava",
			"SL|Africa/Abidjan Africa/Freetown",
			"SM|Europe/Rome Europe/San_Marino",
			"SN|Africa/Abidjan Africa/Dakar",
			"SO|Africa/Nairobi Africa/Mogadishu",
			"SR|America/Paramaribo",
			"SS|Africa/Juba",
			"ST|Africa/Sao_Tome",
			"SV|America/El_Salvador",
			"SX|America/Curacao America/Lower_Princes",
			"SY|Asia/Damascus",
			"SZ|Africa/Johannesburg Africa/Mbabane",
			"TC|America/Grand_Turk",
			"TD|Africa/Ndjamena",
			"TF|Indian/Reunion Indian/Kerguelen",
			"TG|Africa/Abidjan Africa/Lome",
			"TH|Asia/Bangkok",
			"TJ|Asia/Dushanbe",
			"TK|Pacific/Fakaofo",
			"TL|Asia/Dili",
			"TM|Asia/Ashgabat",
			"TN|Africa/Tunis",
			"TO|Pacific/Tongatapu",
			"TR|Europe/Istanbul",
			"TT|America/Port_of_Spain",
			"TV|Pacific/Funafuti",
			"TW|Asia/Taipei",
			"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
			"UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
			"UG|Africa/Nairobi Africa/Kampala",
			"UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway",
			"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
			"UY|America/Montevideo",
			"UZ|Asia/Samarkand Asia/Tashkent",
			"VA|Europe/Rome Europe/Vatican",
			"VC|America/Port_of_Spain America/St_Vincent",
			"VE|America/Caracas",
			"VG|America/Port_of_Spain America/Tortola",
			"VI|America/Port_of_Spain America/St_Thomas",
			"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
			"VU|Pacific/Efate",
			"WF|Pacific/Wallis",
			"WS|Pacific/Apia",
			"YE|Asia/Riyadh Asia/Aden",
			"YT|Africa/Nairobi Indian/Mayotte",
			"ZA|Africa/Johannesburg",
			"ZM|Africa/Maputo Africa/Lusaka",
			"ZW|Africa/Maputo Africa/Harare"
		]
	};

/***/ },
/* 257 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports = "<md-toolbar user-permissions=\"['super_admin']\" class=\"md-table-toolbar md-default\" ng-if=\"!$ctrl.isNew && !$ctrl.isInsideOrgSetupWizard\"> <div class=md-toolbar-tools> <span flex></span> <md-button user-permissions=\"['super_admin']\" class=md-icon-button ui-sref=\"organization({id: 'new'})\"> <md-icon>group_add</md-icon> <md-tooltip md-direction=down> <span translate>ADD_ORGANIZATION</span> </md-tooltip> </md-button> </div> </md-toolbar> <section user-permissions=\"['super_admin']\" layout=row layout-align=\"center top\" ng-if=\"!$ctrl.isNew && !$ctrl.isInsideOrgSetupWizard\"> <md-card layout-padding class=centered-card style=width:300px> <md-input-container> <label translate>ORGANIZATION</label> <md-select name=organization ng-disabled=$ctrl.isEditable ng-model=$ctrl.organizationData.id ng-change=$ctrl.onOrganizationChange($ctrl.organizationData.id)> <md-option ng-repeat=\"organization in $ctrl.organizations\" value=\"{{ organization.id }}\"> {{ organization.organization }} </md-option> </md-select> </md-input-container> </md-card> </section> <section layout=row layout-fill layout-align=\"center top\"> <md-card class=centered-card style=\"width:900px;min-height:calc(100vh - 300px)\"> <div layout=row layout-align=\"space-between center\" layout-padding ng-if=!$ctrl.isInsideOrgSetupWizard> <h3 translate>ORGANIZATION</h3> <md-button class=md-icon-button ng-click=\"$ctrl.isEditable = true;\" ng-show=!$ctrl.isEditable user-permissions=\"['admin', 'super_admin']\"> <md-icon>edit</md-icon> <md-tooltip md-direction=down> <span translate>EDIT_ORGANIZATION</span> </md-tooltip> </md-button> </div> <md-tabs flex md-border-bottom md-selected=$ctrl.currentStepIndex class=full-height-tabs> <md-tab> <md-tabl-label translate> INFO </md-tabl-label> <md-tab-body class=fill-tab> <md-progress-linear md-mode=indeterminate ng-disabled=!$ctrl.isLoading> </md-progress-linear> <form name=$ctrl.organizationForm layout=column> <div layout=row layout-padding> <md-input-container flex=50> <label translate>NAME</label> <input ng-disabled=!$ctrl.isEditable name=name required ng-model=$ctrl.organizationData.organization ng-maxlength=100> <div ng-messages=organizationForm.name.$error ng-show=organizationForm.name.$touched> <div ng-message=required translate> REQUIRED </div> <div ng-message=maxlength translate> MAX_LENGTH_ERROR </div> </div> </md-input-container> <md-input-container flex=50> <label translate>COUNTRY</label> <input ng-disabled=!$ctrl.isEditable type=text name=country required ng-model=$ctrl.organizationData.country> <div ng-messages=organizationForm.country.$error ng-show=organizationForm.country.$touched> <div ng-message=required translate> REQUIRED </div> </div> </md-input-container> </div> <div layout=row layout-padding> <md-input-container flex=50> <label translate>CITY</label> <input ng-disabled=!$ctrl.isEditable type=text name=city required ng-model=$ctrl.organizationData.city> <div ng-messages=organizationForm.city.$error ng-show=organizationForm.city.$touched> <div ng-message=required translate> REQUIRED </div> </div> </md-input-container> <md-input-container flex=50> <label translate>ADDRESS</label> <input ng-disabled=!$ctrl.isEditable type=text name=address required ng-model=$ctrl.organizationData.address> <div ng-messages=organizationForm.address.$error ng-show=organizationForm.address.$touched> <div ng-message=required translate> REQUIRED </div> </div> </md-input-container> </div> <div layout=row layout-padding> <md-input-container flex=50> <label translate>ZIP_CODE</label> <input ng-disabled=!$ctrl.isEditable type=text required name=zipCode ng-model=$ctrl.organizationData.zipCode> <div ng-messages=organizationForm.zipCode.$error ng-show=organizationForm.zipCode.$touched> <div ng-message=required translate> REQUIRED </div> </div> </md-input-container> <div flex=50> <md-autocomplete ng-disabled=!$ctrl.isEditable md-no-cache=true md-search-text=$ctrl.timezoneSearchText md-items=\"timezone in $ctrl.getMatchedTimezones($ctrl.timezoneSearchText)\" md-selected-item=$ctrl.organizationData.timezone md-selected-item-change=$ctrl.onTimezoneSelected(timezone) md-item-text=timezone md-min-length=0 placeholder=\"{{'TIMEZONE' | translate}}\"> <md-item-template> <strong md-highlight-text=$ctrl.timezoneSearchText md-highlight-flags=^i style=white-space:nowrap>{{ timezone }}</strong> </md-item-template> <md-not-found> <span translate>NO_MATCH</span> </md-not-found> </md-autocomplete> <sub translate>TIMEZONE_NOTE</sub> </div> </div> <div layout=row layout-padding> <md-input-container flex=50> <label translate>LANGUAGE</label> <md-select ng-model=$ctrl.organizationData.language ng-disabled=!$ctrl.isEditable> <md-option ng-value=\"'en'\"><span translate>ENGLISH</span></md-option> <md-option ng-value=\"'ru'\"><span translate>RUSSIAN</span></md-option> </md-select> <sub translate>LANGUAGE_NOTE</sub> </md-input-container> <md-input-container flex=50> <label translate>YEAR_TYPE</label> <md-select name=year_type ng-disabled=!$ctrl.isEditable ng-model=$ctrl.organizationData.yearType> <md-option translate ng-repeat=\"yearType in $ctrl.yearTypes\" value=\"{{ yearType }}\"> {{ yearType.toUpperCase() }} </md-option> </md-select> </md-input-container> </div> <div layout=row layout-padding> <div flex=50> <h5 ng-if=\"!$ctrl.isNew && !$ctrl.isInsideOrgSetupWizard\" translate>ADMINISTRATORS</h5> <md-list ng-if=!$ctrl.isInsideOrgSetupWizard> <md-list-item ng-repeat=\"admin in $ctrl.organizationData.admins\" ui-sref=\"user-details({id: admin.id})\">{{ admin.fullName }}</md-list-item> <md-list-item ng-if=\"!$ctrl.organizationData.admins.length && !$ctrl.isNew\"> <span translate>NO_ADMINS</span> </md-list-item> </md-list> </div> </div> </form> </md-tab-body> </md-tab> <md-tab> <md-tabl-label translate> FORECAST_ISSUE_DATES </md-tabl-label> <md-tab-body class=fill-tab> <div layout-padding> <div layout=row layout-align=\"start center\" ng-if=\"!$ctrl.isInsideOrgSetupWizard && !$ctrl.isNew\"> <span><md-icon>error</md-icon></span><sup translate>FORECAST_TYPE_CHANGE_WARNING</sup> </div> <md-divider ng-if=\"!$ctrl.isInsideOrgSetupWizard && !$ctrl.isNew\"></md-divider> <div layout=row> <md-input-container layout-padding flex=33> <label translate>5_DAY</label> <md-select ng-model=$ctrl.forecastTypes.fiveDay.issueDateOffset ng-disabled=!$ctrl.isEditable> <md-option ng-repeat=\"n in [] | numberRangeFormatter: -5:5\" ng-value=n>{{n}}</md-option> </md-select> </md-input-container> <md-input-container layout-padding flex=33> <label translate>DECADAL</label> <md-select ng-model=$ctrl.forecastTypes.decadal.issueDateOffset ng-disabled=!$ctrl.isEditable> <md-option ng-repeat=\"n in [] | numberRangeFormatter: -5:10\" ng-value=n>{{n}}</md-option> </md-select> </md-input-container> <md-input-container layout-padding flex=33 ng-if=!$ctrl.isMonthlyPeriodRelative> <label translate>MONTHLY</label> <md-select ng-model=$ctrl.forecastTypes.monthly.issueDateOffset ng-disabled=!$ctrl.isEditable> <md-option ng-repeat=\"n in [] | numberRangeFormatter: -5:28\" ng-value=n>{{n}}</md-option> </md-select> </md-input-container> </div> <seasonal-frequency-manager flex forecast-types=$ctrl.seasonalForecastTypes on-seasonal-frequency-change=$ctrl.onSeasonalFrequencyChange(seasonalFrequencies) is-disabled=!$ctrl.isEditable is-inside-org-setup-wizard=$ctrl.isInsideOrgSetupWizard> </seasonal-frequency-manager> </div> </md-tab-body> </md-tab> <md-tab ng-if=\"($ctrl.currentUser.role === 'admin' || $ctrl.currentUser.role === 'super_admin') && !$ctrl.isNew\"> <md-tab-label> <span translate>REPORTING_TEMPLATES</span> </md-tab-label> <md-tab-body> <reporting-templates></reporting-templates> </md-tab-body> </md-tab> </md-tabs> <section layout=row layout-align=\"start center\" flex=none ng-if=\"$ctrl.isEditable && !$ctrl.isInsideOrgSetupWizard\"> <md-button class=\"md-raised md-accent\" ng-if=!$ctrl.isNew ng-disabled=\"$ctrl.isDeleting || $ctrl.isSaving || $ctrl.isLoading\" ng-click=$ctrl.onDeleteClick($event)> <span translate ng-hide=$ctrl.isDeleting>DELETE</span> <div ng-show=$ctrl.isDeleting layout=row layout-align=\"center center\"> <md-progress-circular md-mode=indeterminate style=margin-right:10px md-diameter=15> </md-progress-circular> <span translate>DELETING</span> </div> </md-button> <div flex></div> <md-button class=md-raised ng-click=$ctrl.onCancelClick($event) ng-disabled=\"$ctrl.isDeleting || $ctrl.isSaving || $ctrl.isLoading\"> <span translate>CANCEL</span> </md-button> <md-button class=\"md-raised md-primary\" ng-click=$ctrl.onSaveClick($event) ng-disabled=\"organizationForm.$invalid || $ctrl.isDeleting || $ctrl.isSaving || $ctrl.isLoading\"> <span translate ng-hide=$ctrl.isSaving>SAVE</span> <div ng-show=$ctrl.isSaving layout=row layout-align=\"center center\"> <md-progress-circular md-mode=indeterminate style=margin-right:10px md-diameter=15> </md-progress-circular> <span translate>SAVING</span> </div> </md-button> </section> </md-card> </section>";

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var toolbar_controller_1 = __webpack_require__(260);
	__webpack_require__(261);
	var template = __webpack_require__(262);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: toolbar_controller_1.default,
	    template: template
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var organization_controller_1 = __webpack_require__(253);
	var login_service_1 = __webpack_require__(194);
	var ToolbarController = (function () {
	    function ToolbarController($state, sidenavService, $translate, organizationApi, organizationService, $rootScope, $location, userApi) {
	        var _this = this;
	        this.$state = $state;
	        this.sidenavService = sidenavService;
	        this.$translate = $translate;
	        this.organizationApi = organizationApi;
	        this.organizationService = organizationService;
	        this.$rootScope = $rootScope;
	        this.$location = $location;
	        this.userApi = userApi;
	        if (this.$location.path() !== '/reset-password/') {
	            this.setCurrentUserName();
	            this.setCurrentOrganizationName();
	        }
	        this.$rootScope.$on(organization_controller_1.IOrganizationEvents.ORGANIZATION_CHANGE, function () {
	            _this.setCurrentOrganizationName();
	        });
	        this.$rootScope.$on(login_service_1.ILoginService.LOGOUT_EVENT_NAME, function () {
	            _this.organization = null;
	            _this.currentUser = null;
	        });
	        this.$rootScope.$on(login_service_1.ILoginService.LOGIN_EVENT_NAME, function () {
	            _this.setCurrentUserName();
	            _this.setCurrentOrganizationName();
	        });
	    }
	    Object.defineProperty(ToolbarController.prototype, "currentOrg", {
	        get: function () {
	            return this.organization;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ToolbarController.prototype, "currentLanguage", {
	        get: function () {
	            return ToolbarController.LANGUAGE_NAMES[this.$translate.use()];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ToolbarController.prototype.goToCurrentOrgPage = function () {
	        var _this = this;
	        this.organizationService.getCurrentOrgId()
	            .then(function (id) {
	            _this.$state.go("organization", { id: id });
	        });
	    };
	    ToolbarController.prototype.setCurrentOrganizationName = function () {
	        var _this = this;
	        this.organizationService.getCurrentOrgId()
	            .then(function (id) {
	            _this.organizationApi.getOrganization(id)
	                .then(function (data) {
	                _this.organization = data.organization;
	            });
	        });
	    };
	    ;
	    ToolbarController.prototype.setCurrentUserName = function () {
	        var _this = this;
	        this.userApi.getCurrentUser()
	            .then(function (data) {
	            _this.currentUser = data;
	        });
	    };
	    ToolbarController.prototype.toggleLeftSidenav = function () {
	        this.sidenavService.toggleLeftSidenav();
	    };
	    ToolbarController.prototype.selectLanguage = function (languageKey) {
	        this.$translate.use(languageKey);
	    };
	    ToolbarController.$inject = ['$state', 'sidenavService', '$translate', 'organizationApi', 'organizationService', '$rootScope', '$location', 'userApi'];
	    ToolbarController.LANGUAGE_NAMES = {
	        'en': 'English',
	        'ru': 'Русский'
	    };
	    return ToolbarController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ToolbarController;


/***/ },
/* 261 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<md-toolbar class=md-hue-2> <div class=md-toolbar-tools> <img src=" + __webpack_require__(263) + " ng-click=$ctrl.toggleLeftSidenav($event) /> <md-button class=md-icon-button ng-click=$ctrl.toggleLeftSidenav($event)> <md-icon md-font-set=material-icons>menu</md-icon> </md-button> <span flex></span> <md-button layout=row ng-click=$ctrl.goToCurrentOrgPage() ng-if=$ctrl.organization> <md-icon class=material-icons>domain</md-icon>&nbsp;&nbsp;<span style=text-transform:capitalize;font-size:14px>{{ $ctrl.organization }}</span> </md-button> <md-button ui-sref=\"user-details({id: 'me'})\" layout=row title=\"{{ $ctrl.currentUser.role }}\" ng-if=$ctrl.currentUser> <md-icon class=material-icons>person</md-icon>&nbsp;&nbsp;<span style=text-transform:capitalize>{{ $ctrl.currentUser.username }}</span> </md-button> <md-menu class=language-menu> <md-button class=md-icon-button ng-click=$mdOpenMenu($event)> <md-icon class=material-icons>language</md-icon> </md-button> <md-menu-content> <md-menu-item> <md-button ng-click=\"$ctrl.selectLanguage('en')\"> English </md-button> </md-menu-item> <md-menu-item> <md-button ng-click=\"$ctrl.selectLanguage('ru')\"> Русский </md-button> </md-menu-item> </md-menu-content> </md-menu> <span class=md-body-2> {{ $ctrl.currentLanguage }} </span> </div> </md-toolbar>";

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/b39e620f00a4c182f4b48caf76d0e23f.svg";

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var sidenav_controller_1 = __webpack_require__(265);
	var template = __webpack_require__(266);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: sidenav_controller_1.default,
	    template: template
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var login_service_1 = __webpack_require__(194);
	var SidenavController = (function () {
	    function SidenavController($state, sidenavService, loginService, userApi, $window, organizationService, $rootScope) {
	        var _this = this;
	        this.$state = $state;
	        this.sidenavService = sidenavService;
	        this.loginService = loginService;
	        this.userApi = userApi;
	        this.$window = $window;
	        this.organizationService = organizationService;
	        this.$rootScope = $rootScope;
	        this.showUserManagement = false;
	        loginService.onLoginStateChange(function (loggedIn) {
	            _this.onLoginStateChange(loggedIn);
	        });
	        this.loggedIn = loginService.isLoggedIn();
	    }
	    SidenavController.prototype.logOut = function () {
	        var _this = this;
	        this.$rootScope.$broadcast(login_service_1.ILoginService.LOGOUT_EVENT_NAME);
	        this.loginService.logOutUser().then(function () {
	            _this.$state.go('home');
	        });
	        this.sidenavService.toggleLeftSidenav();
	        this.$window.localStorage.removeItem('currentOrgId');
	    };
	    SidenavController.prototype.navigateTo = function (state) {
	        var _this = this;
	        if (state === 'organization') {
	            this.organizationService.getCurrentOrgId()
	                .then(function (id) {
	                _this.$state.go(state, { id: id });
	            });
	        }
	        else if (state === 'account') {
	            this.$state.go('user-details', { id: 'me' });
	        }
	        else {
	            this.$state.go(state);
	        }
	        this.sidenavService.toggleLeftSidenav();
	    };
	    SidenavController.prototype.onLoginStateChange = function (loggedIn) {
	        this.loggedIn = loggedIn;
	    };
	    SidenavController.$inject = ['$state', 'sidenavService', 'loginService', 'userApi', '$window', 'organizationService', '$rootScope'];
	    return SidenavController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = SidenavController;


/***/ },
/* 266 */
/***/ function(module, exports) {

	module.exports = "<md-sidenav class=md-sidenav-left md-component-id=left md-whiteframe=4> <md-toolbar class=md-hue-2> <h1 class=md-toolbar-tools translate>MENU</h1> </md-toolbar> <md-content> <md-list> <md-list-item ng-click=\"$ctrl.navigateTo('home')\"> <md-icon class=material-icons>home</md-icon> <p translate>HOME</p> </md-list-item> <md-list-item ng-hide=$ctrl.loggedIn ng-click=\"$ctrl.navigateTo('login')\"> <md-icon class=material-icons>exit_to_app</md-icon> <p translate>LOG_IN</p> </md-list-item> <md-list-item ng-show=$ctrl.loggedIn ng-click=\"$ctrl.navigateTo('account')\"> <md-icon class=material-icons>account_box</md-icon> <p translate>ACCOUNT</p> </md-list-item> <md-list-item ng-show=$ctrl.loggedIn ng-click=\"$ctrl.navigateTo('organization')\"> <md-icon class=material-icons>domain</md-icon> <p translate>ORGANIZATION</p> </md-list-item> <md-list-item ng-show=$ctrl.loggedIn ng-click=\"$ctrl.navigateTo('user-management')\"> <md-icon class=material-icons>people</md-icon> <p translate>USERS</p> </md-list-item> <md-list-item user-permissions=\"['super_admin']\" ng-if=$ctrl.loggedIn ng-click=\"$ctrl.navigateTo('access')\"> <md-icon class=material-icons>playlist_add_check</md-icon> <p translate>ACCESS</p> </md-list-item> <md-list-item ng-show=$ctrl.loggedIn ng-click=$ctrl.logOut()> <md-icon class=material-icons>power_settings_new</md-icon> <p translate>LOG_OUT</p> </md-list-item> <md-divider></md-divider> <md-subheader class=md-no-sticky> <div layout=row> <span flex translate>TOOLS</span> <md-icon class=material-icons> <span ng-hide=$ctrl.loggedIn>lock</span> <span ng-show=$ctrl.loggedIn>lock_open</span> </md-icon> </div> </md-subheader> <md-list-item ng-click=\"$ctrl.navigateTo('station.manager')\" ng-disabled=!$ctrl.loggedIn> <md-icon class=material-icons>place</md-icon> <p translate>DISCHARGE_STATIONS</p> </md-list-item> <md-list-item ng-click=\"$ctrl.navigateTo('meteostation.manager')\" ng-disabled=!$ctrl.loggedIn> <md-icon class=material-icons>wb_cloudy</md-icon> <p translate>METEOSTATIONS</p> </md-list-item> <md-list-item ng-disabled=!$ctrl.loggedIn ng-click=\"$ctrl.navigateTo('operational.options')\"> <md-icon class=material-icons>poll</md-icon> <p translate>OPERATIONAL_HYDROLOGY</p> </md-list-item> <md-list-item ng-disabled=!$ctrl.loggedIn ng-click=\"$ctrl.navigateTo('forecast.options')\"> <md-icon class=material-icons>timeline</md-icon> <p translate>DISCHARGE_FORECASTING</p> </md-list-item> </md-list> <md-divider></md-divider> <md-list-item ng-click=\"$ctrl.navigateTo('help')\"> <md-icon class=material-icons>help</md-icon> <p translate>HELP</p> </md-list-item> <md-list-item href=\"mailto:siegfried@hydrosolutions.ch,andrey.yakovlev65@gmail.com?subject=iMoMo Hydromet Feedback\"> <md-icon class=material-icons>feedback</md-icon> <p translate>FEEDBACK</p> </md-list-item> <md-list-item ng-click=\"$ctrl.navigateTo('about')\"> <md-icon class=material-icons>info</md-icon> <p translate>ABOUT_US</p> </md-list-item> </md-content> </md-sidenav>";

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var help_controller_1 = __webpack_require__(268);
	var template = __webpack_require__(269);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: help_controller_1.default,
	    template: template
	};


/***/ },
/* 268 */
/***/ function(module, exports) {

	"use strict";
	var HelpController = (function () {
	    function HelpController(contactEmailApi, $mdDialog, $state, $timeout, $translate) {
	        var _this = this;
	        this.contactEmailApi = contactEmailApi;
	        this.$mdDialog = $mdDialog;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.$translate = $translate;
	        this.sending = false;
	        this.sendEmail = function () {
	            var self = _this;
	            self.sending = true;
	            _this.contactEmailApi.sendContactEmail(_this.contactForm)
	                .then(function () {
	                self.sending = false;
	                self.$mdDialog
	                    .show(self.$mdDialog.alert()
	                    .title(self.$translate.instant('THANK_YOU'))
	                    .textContent(self.$translate.instant('WE_WILL_CONTACT_YOU_ASAP'))
	                    .ok('OK'))
	                    .then(function () {
	                    self.$state.go('home');
	                });
	            }, function () {
	                self.sending = false;
	                self.$mdDialog
	                    .show(self.$mdDialog.alert()
	                    .title(self.$translate.instant('WE_ARE_SORRY'))
	                    .textContent(self.$translate.instant('HELP_MESSAGE_ERROR'))
	                    .ok('OK'));
	            });
	        };
	    }
	    HelpController.$inject = ['contactEmailApi', '$mdDialog', '$state', '$timeout', '$translate'];
	    return HelpController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = HelpController;


/***/ },
/* 269 */
/***/ function(module, exports) {

	module.exports = "<section layout=row layout-fill layout-align=\"center top\"> <md-card layout=column layout-padding class=centered-card> <h3 translate>CONTACT_US_FOR_HELP</h3> <cms content-name=\"'help'\"></cms> <form layout=column name=contactForm> <div layout=column style=width:400px> <md-input-container> <label translate>YOUR_NAME</label> <input type=text required name=name md-maxlength=50 ng-model=$ctrl.contactForm.name> </md-input-container> <md-input-container> <label translate>YOUR_EMAIL</label> <input type=email required name=email md-maxlength=50 ng-model=$ctrl.contactForm.email> </md-input-container> </div> <md-input-container> <label translate>MESSAGE</label> <textarea md-maxlength=1000 rows=1 required name=message ng-model=$ctrl.contactForm.content>\n        </textarea> </md-input-container> <div layout=row layout-align=\"end center\"> <md-button class=\"md-primary md-raised\" ng-click=$ctrl.sendEmail() ng-disabled=\"contactForm.$invalid || $ctrl.sending\"> <a ng-if=!$ctrl.sending translate>SEND</a> <div ng-if=$ctrl.sending layout=row layout-align=\"center center\"> <md-progress-circular md-mode=indeterminate style=margin-right:10px md-diameter=15> </md-progress-circular> <span translate>SENDING</span> </div> </md-button> </div> </form> </md-card> </section>";

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var about_controller_1 = __webpack_require__(271);
	var template = __webpack_require__(272);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: about_controller_1.default,
	    template: template
	};


/***/ },
/* 271 */
/***/ function(module, exports) {

	"use strict";
	var AboutController = (function () {
	    function AboutController($scope) {
	    }
	    AboutController.$inject = ['$scope'];
	    return AboutController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = AboutController;


/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = "<section layout=row layout-fill layout-align=\"center top\"> <md-card layout-padding class=centered-card> <h3 translate>ABOUT_US</h3> <cms content-name=\"'about'\"></cms> </md-card> </section>";

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var invitations_controller_1 = __webpack_require__(274);
	var template = __webpack_require__(275);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: invitations_controller_1.default,
	    template: template
	};


/***/ },
/* 274 */
/***/ function(module, exports) {

	"use strict";
	var IncitationsController = (function () {
	    function IncitationsController(userApi, $location, $state, imomoErrorService) {
	        var _this = this;
	        this.userApi = userApi;
	        this.$location = $location;
	        this.$state = $state;
	        this.imomoErrorService = imomoErrorService;
	        this.invitedUserData = {
	            username: null,
	            fullName: null
	        };
	        if (this.$location.search().invitation_uuid) {
	            this.userApi.getInvitationDetails(this.$location.search().invitation_uuid)
	                .then(function (invitationData) {
	                _this.invitationData = invitationData;
	                _this.invitedUserData.fullName = _this.invitationData.fullName;
	            })
	                .catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(error.data.details)
	                    .then(function () {
	                    _this.$state.go('home');
	                });
	            });
	        }
	    }
	    IncitationsController.prototype.onRegisterClick = function () {
	        var _this = this;
	        this.userApi.createUserFromInvitation(this.invitedUserData, this.$location.search().invitation_uuid)
	            .then(function () {
	            _this.$state.go('home');
	        })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	        });
	    };
	    IncitationsController.$inject = ['userApi', '$location', '$state', 'imomoErrorService'];
	    return IncitationsController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = IncitationsController;


/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = "<section layout=row layout-fill layout-align=\"center top\"> <md-card layout-padding class=centered-card style=width:400px> <md-progress-linear md-mode=indeterminate ng-disabled=!$ctrl.isLoading> </md-progress-linear> <form name=userForm layout=column> <md-input-container> <label translate>USERNAME</label> <input name=username required ng-model=$ctrl.invitedUserData.username ng-maxlength=24 minlength=6> <div ng-messages=userForm.username.$error md-auto-hide=false ng-show=userForm.username.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> <div ng-message=maxlength translate> THE_VALUE_IS_TOO_LONG </div> <div ng-message=minlength translate> THE_VALUE_IS_TOO_SHORT </div> </div> </md-input-container> <md-input-container> <label translate>NAME</label> <input name=fullName required ng-model=$ctrl.invitedUserData.fullName ng-maxlength=100> <div ng-messages=userForm.fullName.$error ng-show=userForm.fullName.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> <div ng-message=maxlength translate> THE_VALUE_IS_TOO_LONG </div> </div> </md-input-container> <md-input-container> <label translate>PASSWORD</label> <input name=password type=password ng-model=$ctrl.invitedUserData.password1 required> </md-input-container> <md-input-container> <label translate>REPEAT_PASSWORD</label> <input name=repeatPassword type=password ng-model=$ctrl.invitedUserData.password2 required> </md-input-container> <md-input-container> <label translate>PHONE</label> <input name=phone type=text ng-model=$ctrl.invitedUserData.phone> </md-input-container> <section layout=row layout-align=\"end center\" flex=none> <md-button class=\"md-raised md-primary\" ng-click=$ctrl.onRegisterClick($event) ng-disabled=\"userForm.$invalid || $ctrl.isLoading\"> <span translate ng-hide=$ctrl.isSaving>REGISTER</span> <div ng-show=$ctrl.isSaving layout=row layout-align=\"center center\"> <md-progress-circular md-mode=indeterminate style=margin-right:10px md-diameter=15> </md-progress-circular> <span translate>SAVING</span> </div> </md-button> </section> </form> </md-card> </section>";

/***/ },
/* 276 */
/***/ function(module, exports) {

	"use strict";
	var SidenavService = (function () {
	    function SidenavService($mdSidenav) {
	        var _this = this;
	        this.$mdSidenav = $mdSidenav;
	        this.toggleLeftSidenav = function () {
	            _this.$mdSidenav('left').toggle();
	        };
	    }
	    SidenavService.$inject = ['$mdSidenav'];
	    return SidenavService;
	}());
	exports.SidenavService = SidenavService;


/***/ },
/* 277 */
/***/ function(module, exports) {

	"use strict";
	var OrganizationService = (function () {
	    function OrganizationService($window, userApi, $q) {
	        this.$window = $window;
	        this.userApi = userApi;
	        this.$q = $q;
	    }
	    OrganizationService.prototype.getCurrentOrgId = function () {
	        var _this = this;
	        var deferred = this.$q.defer();
	        var currentOrgId = this.$window.localStorage
	            .getItem('currentOrgId');
	        if (currentOrgId) {
	            deferred.resolve(parseInt(currentOrgId, 10));
	        }
	        else {
	            this.userApi.getCurrentUser()
	                .then(function (data) {
	                deferred.resolve(parseInt(data.sourceId, 10));
	                _this.$window.localStorage.setItem('currentOrgId', data.sourceId);
	            }, function (errorData) {
	                deferred.reject();
	            });
	        }
	        return deferred.promise;
	    };
	    OrganizationService.$inject = ['$window', 'userApi', '$q'];
	    return OrganizationService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OrganizationService;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var userManagement_controller_1 = __webpack_require__(279);
	__webpack_require__(280);
	var template = __webpack_require__(281);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: userManagement_controller_1.default,
	    template: template
	};


/***/ },
/* 279 */
/***/ function(module, exports) {

	"use strict";
	var UserManagementController = (function () {
	    function UserManagementController(userApi) {
	        this.userApi = userApi;
	        this.selectedUsers = [];
	        var self = this;
	        self.userListPromise = userApi.getUserList()
	            .then(function (data) {
	            self.userList = data;
	        });
	    }
	    UserManagementController.$inject = ['userApi', '$state'];
	    return UserManagementController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = UserManagementController;


/***/ },
/* 280 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 281 */
/***/ function(module, exports) {

	module.exports = "<section layout=row layout-fill> <md-card flex layout-padding> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span ng-hide=$ctrl.isUserSelected translate>USERS</span> <span flex></span> <md-button user-permissions=\"['admin', 'super_admin']\" class=md-icon-button ui-sref=\"user-details({id: 'new'})\"> <md-icon>person_add</md-icon> <md-tooltip md-direction=down> <span translate>ADD_USER</span> </md-tooltip> </md-button> </div> </md-toolbar> <md-table-container flex> <table md-table md-progress=$ctrl.userListPromise md-row-select ng-model=$ctrl.selectedUsers> <thead md-head> <tr md-row> <th md-column><span translate>NAME</span></th> <th md-column><span translate>USERNAME</span></th> <th md-column><span translate>EMAIL</span></th> </tr> </thead> <tbody md-body> <tr md-row ui-sref=\"user-details({id: user.id})\" class=user-item ng-repeat=\"user in $ctrl.userList | orderBy:'fullName'\"> <td md-cell>{{ user.fullName }}</td> <td md-cell>{{ user.username }}</td> <td md-cell>{{ user.email }}</td> </tr> </tbody> </table> </md-table-container> </md-card> </section>";

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var userDetails_controller_1 = __webpack_require__(283);
	var template = __webpack_require__(286);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: userDetails_controller_1.default,
	    bindings: {
	        id: '<',
	        isEditable: '<',
	        userForm: '=',
	        userData: '=',
	        isInsideOrgSetupWizard: '<'
	    },
	    template: template
	};


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var change_password_dialog_controller_1 = __webpack_require__(284);
	var changePasswordDialogTemplate = __webpack_require__(285);
	var UserDetailsController = (function () {
	    function UserDetailsController(userApi, $stateParams, $state, organizationApi, $mdDialog, $scope, $timeout, $translate) {
	        var _this = this;
	        this.userApi = userApi;
	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.organizationApi = organizationApi;
	        this.$mdDialog = $mdDialog;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.$translate = $translate;
	        this.isNew = false;
	        this.isSaving = false;
	        this.isDeleting = false;
	        this.isLoading = true;
	        this.isCurrentUserSuperAdmin = false;
	        this.roles = ['super_admin', 'admin', 'user'];
	        var self = this;
	        self.userData = {
	            email: null,
	            fullName: null,
	            id: undefined,
	            sourceId: null,
	            username: null,
	            role: 'user',
	            registeredOn: null,
	            phone: null
	        };
	        if (typeof this.isEditable === 'undefined') {
	            this.isEditable = false;
	        }
	        if (self.$stateParams.id === 'new') {
	            self.isNew = true;
	            self.isEditable = true;
	        }
	        else if (self.$stateParams.id === 'me' || this.id === 'me') {
	            userApi.getCurrentUser()
	                .then(function (data) {
	                delete data.registeredOn;
	                self.storedUserData = angular.copy(data);
	                self.userData = data;
	                self.isLoading = false;
	            }, function (errorData) {
	                if (!self.isInsideOrgSetupWizard) {
	                    self.$mdDialog.show(self.$mdDialog.alert()
	                        .clickOutsideToClose(true)
	                        .title(self.$translate.instant('FAILED_TO_LOAD_USER'))
	                        .textContent(errorData.data.details)
	                        .ok('OK'));
	                }
	            });
	        }
	        else {
	            var userId = typeof self.$stateParams.id !== 'undefined' ? parseInt(self.$stateParams.id, 10) : this.id;
	            userApi.getUser(userId)
	                .then(function (data) {
	                delete data.registeredOn;
	                self.storedUserData = angular.copy(data);
	                self.userData = data;
	                self.isLoading = false;
	            }, function (errorData) {
	                self.$mdDialog.show(self.$mdDialog.alert()
	                    .clickOutsideToClose(true)
	                    .title(this.$translate.instant('FAILED_TO_LOAD_USER'))
	                    .textContent(errorData.data.details)
	                    .ok('OK'));
	            });
	        }
	        userApi.getCurrentUser()
	            .then(function (data) {
	            if (data.role === 'super_admin') {
	                _this.isCurrentUserSuperAdmin = true;
	                self.organizationsPromise = organizationApi.getOrganizations()
	                    .then(function (organizations) {
	                    if (self.userForm['organization']) {
	                        self.userForm['organization'].$setDirty();
	                    }
	                    self.organizations = organizations;
	                    self.userData.sourceId = data.sourceId;
	                    self.isLoading = false;
	                }, function (errorData) {
	                    if (!self.isInsideOrgSetupWizard) {
	                        self.$mdDialog.show(self.$mdDialog.alert()
	                            .clickOutsideToClose(true)
	                            .title(self.$translate.instant('FAILED_TO_LOAD_ORGANIZATIONS'))
	                            .textContent(errorData.data.details)
	                            .ok('OK'));
	                    }
	                });
	            }
	            else {
	                self.userData.sourceId = data.sourceId;
	            }
	            self.isLoading = false;
	        });
	    }
	    UserDetailsController.prototype.onChangePasswordClick = function ($event) {
	        var _this = this;
	        this.$mdDialog.show({
	            targetEvent: $event,
	            template: changePasswordDialogTemplate,
	            controller: change_password_dialog_controller_1.ChangePasswordDialog,
	            bindToController: true,
	            controllerAs: '$ctrl'
	        }).then(function (userData) {
	            _this.userApi.changePassword(userData)
	                .then(function () { }, function (errorData) {
	                _this.$mdDialog.show(_this.$mdDialog.alert()
	                    .clickOutsideToClose(true)
	                    .title('')
	                    .textContent(errorData.data.details)
	                    .ok('OK'));
	            });
	        });
	    };
	    UserDetailsController.prototype.onSaveClick = function ($event) {
	        var self = this;
	        delete self.userData.registeredOn;
	        self.isSaving = true;
	        self.userApi.saveUser(self.userData)
	            .then(function (data) {
	            self.isSaving = false;
	            self.isEditable = false;
	            if (self.$stateParams.id === 'new') {
	                self.$state.go('user-details', { id: data.id });
	            }
	        }, function (errorData) {
	            self.isSaving = false;
	            self.$mdDialog.show(self.$mdDialog.alert()
	                .clickOutsideToClose(true)
	                .title(self.$translate.instant('FAILED_TO_LOAD_ORGANIZATIONS'))
	                .textContent(errorData.data.details)
	                .ok('OK')
	                .targetEvent($event));
	        });
	    };
	    UserDetailsController.prototype.onBackClick = function ($event) {
	        this.$state.go('user-management');
	    };
	    UserDetailsController.prototype.onCancelClick = function ($event) {
	        if (this.isNew) {
	            this.$state.go('user-management');
	        }
	        else {
	            this.isEditable = false;
	            this.userData = angular.copy(this.storedUserData);
	        }
	    };
	    UserDetailsController.prototype.onDeleteClick = function ($event) {
	        var self = this;
	        var confirm = this.$mdDialog.confirm()
	            .title(this.$translate.instant('DELETE_USER'))
	            .textContent(this.$translate.instant('DELETE_CONFIRMATION', { item: self.userData.fullName }))
	            .targetEvent($event)
	            .ok(this.$translate.instant('DELETE'))
	            .cancel(this.$translate.instant('CANCEL'));
	        this.$mdDialog.show(confirm).then(function () {
	            self.isDeleting = true;
	            self.userApi.deleteUser(parseInt(self.$stateParams.id))
	                .then(function (data) {
	                self.isDeleting = true;
	                self.$state.go('user-management');
	            }, function (errorData) {
	                self.isDeleting = true;
	            });
	        });
	    };
	    UserDetailsController.prototype.onSelectOpen = function () {
	        return this.organizationsPromise;
	    };
	    UserDetailsController.$inject = ['userApi', '$stateParams', '$state', 'organizationApi', '$mdDialog', '$scope',
	        '$timeout', '$translate'];
	    return UserDetailsController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = UserDetailsController;


/***/ },
/* 284 */
/***/ function(module, exports) {

	"use strict";
	var ChangePasswordDialog = (function () {
	    function ChangePasswordDialog($mdDialog) {
	        var _this = this;
	        this.$mdDialog = $mdDialog;
	        this.apply = function () {
	            _this.$mdDialog.hide(_this.changePasswordData);
	        };
	        this.cancel = function () {
	            _this.$mdDialog.cancel();
	        };
	    }
	    ChangePasswordDialog.$inject = ['$mdDialog'];
	    return ChangePasswordDialog;
	}());
	exports.ChangePasswordDialog = ChangePasswordDialog;


/***/ },
/* 285 */
/***/ function(module, exports) {

	module.exports = "<md-dialog style=width:400px> <md-dialog-content> <change-password-form on-change=\"\" change-password-data=$ctrl.changePasswordData change-password-form=$ctrl.changePasswordForm></change-password-form> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply()> <span translate>CHANGE_PASSWORD</span> </md-button> </md-dialog-actions> </md-dialog>";

/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports = "<section layout=row layout-fill layout-align=\"center top\"> <md-card layout-padding class=centered-card style=width:400px> <md-progress-linear md-mode=indeterminate ng-disabled=!$ctrl.isLoading> </md-progress-linear> <div layout=row layout-align=\"space-between top\" ng-if=!$ctrl.isInsideOrgSetupWizard> <md-button class=md-icon-button ng-click=$ctrl.onBackClick($event)> <md-icon>chevron_left</md-icon> <md-tooltip md-direction=down> <span translate>BACK</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=\"$ctrl.isEditable = true;\" ng-if=\"!$ctrl.isNew && !$ctrl.isEditable\" user-permissions=\"['admin','super_admin', 'current_user']\"> <md-icon>edit</md-icon> <md-tooltip md-direction=down> <span translate>EDIT_USER</span> </md-tooltip> </md-button> </div> <form name=$ctrl.userForm layout=column> <md-input-container> <label translate>USERNAME</label> <input name=username required ng-model=$ctrl.userData.username ng-maxlength=24 ng-minlength=6 ng-disabled=\"!$ctrl.isEditable && !$ctrl.isNew\"> <div ng-messages=$ctrl.userForm.username.$error md-auto-hide=false ng-show=$ctrl.userForm.username.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> <div ng-message=maxlength translate> THE_VALUE_IS_TOO_LONG </div> <div ng-message=minlength translate> THE_VALUE_IS_TOO_SHORT </div> </div> </md-input-container> <md-input-container> <label translate>NAME</label> <input name=fullName required ng-model=$ctrl.userData.fullName ng-maxlength=100 ng-disabled=\"!$ctrl.isEditable && !$ctrl.isNew\"> <div ng-messages=$ctrl.userForm.fullName.$error ng-show=$ctrl.userForm.fullName.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> <div ng-message=maxlength translate> THE_VALUE_IS_TOO_LONG </div> </div> </md-input-container> <md-input-container> <label translate>EMAIL</label> <input name=email type=email required ng-model=$ctrl.userData.email ng-maxlength=100 ng-disabled=\"!$ctrl.isEditable && !$ctrl.isNew\"> <div ng-messages=$ctrl.userForm.email.$error md-auto-hide=false ng-show=$ctrl.userForm.email.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> <div ng-message=maxlength translate> THE_VALUE_IS_TOO_LONG </div> </div> </md-input-container> <md-input-container> <label translate>PHONE</label> <input ng-disabled=!$ctrl.isEditable name=phone type=text ng-model=$ctrl.userData.phone ng-disabled=\"!$ctrl.isEditable && !$ctrl.isNew\"> </md-input-container> <md-input-container ng-if=!$ctrl.isInsideOrgSetupWizard> <label translate>ROLE</label> <md-select name=role ng-model=$ctrl.userData.role md-on-open=$ctrl.onSelectOpen() ng-disabled=\"!$ctrl.isEditable && !$ctrl.isNew\"> <md-option ng-repeat=\"role in $ctrl.roles\" value=\"{{ role }}\" ng-if=\"!(role === 'super_admin' && !$ctrl.isCurrentUserSuperAdmin)\"> {{ role }} </md-option> </md-select> </md-input-container> <md-input-container user-permissions=\"['super_admin']\" ng-if=!$ctrl.isInsideOrgSetupWizard> <label translate>ORGANIZATION</label> <md-select name=organization ng-required=$ctrl.isCurrentUserSuperAdmin ng-model=$ctrl.userData.sourceId md-on-open=$ctrl.onSelectOpen() ng-disabled=\"!$ctrl.isEditable && !$ctrl.isNew\"> <md-option ng-repeat=\"organization in $ctrl.organizations\" ng-value=\"{{ organization.id }}\"> {{ organization.organization }} </md-option> </md-select> <div ng-messages=$ctrl.userForm.organization.$error md-auto-hide=false ng-show=$ctrl.userForm.organization.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> </div> </md-input-container> <md-button class=md-raised ng-if=\"!$ctrl.isNew && !$ctrl.isInsideOrgSetupWizard\" ng-disabled=!$ctrl.isEditable ng-click=$ctrl.onChangePasswordClick($event)> <span translate>CHANGE_PASSWORD</span> </md-button> <section layout=row layout-align=\"start center\" flex=none ng-if=\"$ctrl.isEditable && !$ctrl.isInsideOrgSetupWizard\"> <md-button class=\"md-raised md-accent\" ng-if=!$ctrl.isNew ng-disabled=\"$ctrl.isDeleting || $ctrl.isSaving || $ctrl.isLoading\" ng-click=$ctrl.onDeleteClick($event)> <span translate ng-hide=$ctrl.isDeleting>DELETE</span> <div ng-show=$ctrl.isDeleting layout=row layout-align=\"center center\"> <md-progress-circular md-mode=indeterminate style=margin-right:10px md-diameter=15> </md-progress-circular> <span translate>DELETING</span> </div> </md-button> <div flex></div> <md-button class=md-raised ng-click=$ctrl.onCancelClick($event) ng-disabled=\"$ctrl.isDeleting || $ctrl.isSaving || $ctrl.isLoading\"> <span translate>CANCEL</span> </md-button> <md-button class=\"md-raised md-primary\" ng-click=$ctrl.onSaveClick($event) ng-disabled=\"$ctrl.userForm.$invalid || $ctrl.isDeleting || $ctrl.isSaving || $ctrl.isLoading\"> <span translate ng-hide=$ctrl.isSaving>SAVE</span> <div ng-show=$ctrl.isSaving layout=row layout-align=\"center center\"> <md-progress-circular md-mode=indeterminate style=margin-right:10px md-diameter=15> </md-progress-circular> <span translate>SAVING</span> </div> </md-button> </section> </form> </md-card> </section>";

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var reset_password_controller_1 = __webpack_require__(288);
	var template = __webpack_require__(289);
	exports.resetPasswordComponent = {
	    controller: reset_password_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = exports.resetPasswordComponent;


/***/ },
/* 288 */
/***/ function(module, exports) {

	"use strict";
	var ResetPasswordController = (function () {
	    function ResetPasswordController(userApi, $state, $location, $mdDialog) {
	        this.userApi = userApi;
	        this.$state = $state;
	        this.$location = $location;
	        this.$mdDialog = $mdDialog;
	    }
	    ResetPasswordController.prototype.onResetPasswordClick = function ($event) {
	        var _this = this;
	        this.resetPasswordData.token = this.$location.search().token;
	        this.userApi.resetPassword(this.resetPasswordData)
	            .then(function () {
	            _this.$state.go('home');
	        }, function (errorData) {
	            _this.$mdDialog.show(_this.$mdDialog.alert()
	                .clickOutsideToClose(true)
	                .title('')
	                .textContent(errorData.data.details)
	                .ok('OK'));
	        });
	    };
	    ResetPasswordController.$inject = ['userApi', '$state', '$location', '$mdDialog'];
	    return ResetPasswordController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ResetPasswordController;


/***/ },
/* 289 */
/***/ function(module, exports) {

	module.exports = "<section layout=row layout-fill layout-align=\"center top\"> <md-card layout-padding class=centered-card style=width:400px> <md-toolbar class=\"md-table-toolbar md-default\"> <span translate>RESET_PASSWORD</span> </md-toolbar> <form name=resetPasswordForm> <md-input-container> <label translate>NEW_PASSWORD</label> <input type=password required name=newPassword ng-model=$ctrl.resetPasswordData.newPassword1 minlength=6 maxlength=72> <div ng-messages=resetPasswordForm.newPassword.$error ng-show=resetPasswordForm.newPassword.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> <div ng-message=maxlength translate> THE_VALUE_IS_TOO_LONG </div> <div ng-message=minlength translate> THE_VALUE_IS_TOO_SHORT </div> </div> </md-input-container> <md-input-container> <label translate>REPEAT_NEW_PASSWORD</label> <input type=password required name=repeatNewPassword ng-model=$ctrl.resetPasswordData.newPassword2 minlength=6 maxlength=72> <div ng-messages=resetPasswordForm.repeatNewPassword.$error ng-show=resetPasswordForm.repeatNewPassword.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> <div ng-message=maxlength translate> THE_VALUE_IS_TOO_LONG </div> <div ng-message=minlength translate> THE_VALUE_IS_TOO_SHORT </div> </div> </md-input-container> <div layout=row ng-if=\"$ctrl.resetPasswordData.newPassword1 !== $ctrl.resetPasswordData.newPassword2\"> <md-icon class=md-warn>info_outline</md-icon><p flex>&nbsp;<span translate>PASSWORDS_NOT_MATCHING</span></p> </div> <section layout=row layout-align=\"end center\" flex=none> <span flex></span> <md-button class=\"md-raised md-primary\" ng-click=$ctrl.onResetPasswordClick($event) ng-disabled=resetPasswordForm.$invalid> <span translate ng-hide=$ctrl.isReseting>RESET</span> <div ng-show=$ctrl.isReseting layout=row layout-align=\"center center\"> <md-progress-circular md-mode=indeterminate style=margin-right:10px md-diameter=15> </md-progress-circular> <span translate>RESETING</span> </div> </md-button> </section> </form> </md-card> </section>";

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var timeseries_controller_1 = __webpack_require__(291);
	__webpack_require__(292);
	var template = __webpack_require__(293);
	var timeseriesComponent = {
	    bindings: {
	        timeseries: '<',
	        hydrodataType: '<'
	    },
	    controller: timeseries_controller_1.TimeseriesController,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = timeseriesComponent;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var d3_axis_1 = __webpack_require__(202);
	var d3_scale_1 = __webpack_require__(203);
	var d3_selection_1 = __webpack_require__(217);
	var moment = __webpack_require__(45);
	var d3_shape_1 = __webpack_require__(211);
	var TimeseriesController = (function () {
	    function TimeseriesController($element, chartColorService) {
	        this.$element = $element;
	        this.chartColorService = chartColorService;
	        this.curves = [];
	        this.legendEntries = [];
	        this.drawn = false;
	        var firstDayInHydroyear = moment()
	            .year(TimeseriesController.CURRENT_HYDROYEAR - 1)
	            .month(9) // October
	            .startOf('month');
	        var lastDayInHydroyear = moment()
	            .year(TimeseriesController.CURRENT_HYDROYEAR)
	            .month(8) // September
	            .endOf('month');
	        this.timeScale = d3_scale_1.scaleTime()
	            .domain([
	            firstDayInHydroyear.toDate(),
	            lastDayInHydroyear.toDate()
	        ])
	            .range([0, this.innerWidth]);
	    }
	    Object.defineProperty(TimeseriesController.prototype, "width", {
	        /**
	         * Default width of the SVG, in pixels.
	         */
	        get: function () {
	            return 960;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeseriesController.prototype, "height", {
	        /**
	         * Default height of the SVG, in pixels.
	         */
	        get: function () {
	            return 540;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeseriesController.prototype, "minorMargin", {
	        /**
	         * Minor margin used in the top and right parts of the graph.
	         */
	        get: function () {
	            return 20;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeseriesController.prototype, "majorMargin", {
	        /**
	         * Major margin used in the left and bottom parts of the graph.
	         */
	        get: function () {
	            return 60;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeseriesController.prototype, "innerWidth", {
	        /**
	         * Calculated width of the inner drawing area.
	         */
	        get: function () {
	            return this.width - this.minorMargin - this.majorMargin;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeseriesController.prototype, "innerHeight", {
	        /**
	         * Calculated height of the inner drawing area.
	         */
	        get: function () {
	            return this.height - this.minorMargin - this.majorMargin;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeseriesController.prototype, "legendWidth", {
	        /**
	         * Legend width.
	         */
	        get: function () {
	            return 150;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeseriesController.prototype, "legendHeight", {
	        /**
	         * Calculated legend height.
	         */
	        get: function () {
	            return this.legendEntries.length * 20 + 2;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimeseriesController.prototype, "legendRadius", {
	        /**
	         * Legend rounded corner radius.
	         */
	        get: function () {
	            return 2;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TimeseriesController.prototype.$postLink = function () {
	        this.draw();
	        this.drawn = true;
	    };
	    TimeseriesController.prototype.$onChanges = function () {
	        this.timeseries = this.timeseries || [];
	        if (this.drawn) {
	            this.update();
	        }
	    };
	    TimeseriesController.prototype.draw = function () {
	        var element = d3_selection_1.select(this.$element[0]);
	        var axisElement = element.select('.x.axis');
	        var xAxis = d3_axis_1.axisBottom(this.timeScale)
	            .ticks(12)
	            .tickSizeInner(-this.innerHeight)
	            .tickSizeOuter(0)
	            .tickFormat(function (date) { return moment(date).format('MMM'); });
	        axisElement.call(xAxis);
	    };
	    TimeseriesController.prototype.update = function () {
	        var _this = this;
	        var element = d3_selection_1.select(this.$element[0]);
	        var axisElement = element.select('.y.axis');
	        var yScale = d3_scale_1.scaleLinear()
	            .domain([this.hydrodataType === 'temperature' ? this.determineMinTemperature() : 0, this.determineMaxDischarge()])
	            .range([this.innerHeight, 0]);
	        var yAxis = d3_axis_1.axisLeft(yScale)
	            .tickSizeOuter(0)
	            .tickSizeInner(-this.innerWidth)
	            .ticks(10);
	        axisElement.call(yAxis);
	        var lineGenerator = d3_shape_1.line()
	            .x(function (datum) {
	            return _this.timeScale(_this.normalizeDate(datum.date));
	        })
	            .y(function (datum) { return yScale(datum.hydrodata); })
	            .curve(d3_shape_1.curveLinear);
	        this.curves = this.timeseries.map(function (timeseries, index) {
	            return {
	                path: lineGenerator(timeseries.data),
	                strokeColor: _this.chartColorService.getColors(index).backgroundColor
	            };
	        });
	        this.legendEntries = this.curves.map(function (curve, index) {
	            return {
	                label: _this.timeseries[index].label,
	                color: curve.strokeColor
	            };
	        });
	    };
	    TimeseriesController.prototype.normalizeDate = function (date) {
	        date = date.clone();
	        if (date.month() < 9) {
	            date.year(TimeseriesController.CURRENT_HYDROYEAR);
	        }
	        else {
	            date.year(TimeseriesController.CURRENT_HYDROYEAR - 1);
	        }
	        return date.toDate();
	    };
	    TimeseriesController.prototype.determineMaxDischarge = function () {
	        var margin = 5;
	        var max = Math.max.apply(Math, this.timeseries.map(function (timeseries) {
	            return Math.max.apply(Math, timeseries.data.map(function (datum) { return datum.hydrodata; }));
	        }));
	        return max + margin;
	    };
	    TimeseriesController.prototype.determineMinTemperature = function () {
	        var margin = 5;
	        var min = Math.min.apply(Math, this.timeseries.map(function (timeseries) {
	            return Math.min.apply(Math, timeseries.data.map(function (datum) { return datum.hydrodata; }));
	        }));
	        return min - margin;
	    };
	    TimeseriesController.$inject = ['$element', 'chartColorService'];
	    /**
	     * The hydrological year starts in October.
	     */
	    TimeseriesController.CURRENT_HYDROYEAR = moment().month() >= 9 ? moment().year() + 1 : moment().year();
	    return TimeseriesController;
	}());
	exports.TimeseriesController = TimeseriesController;


/***/ },
/* 292 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 293 */
/***/ function(module, exports) {

	module.exports = "<svg ng-attr-view_box=\"0 0 {{$ctrl.width}} {{$ctrl.height}}\" class=timeseries-draw-area preserveAspectRatio=\"xMidYMid meet\"> <g ng-attr-transform=\"translate({{$ctrl.majorMargin}}, {{$ctrl.minorMargin}})\"> <defs> <clipPath class=drawing-area> <rect ng-attr-width={{$ctrl.innerWidth}} ng-attr-height={{$ctrl.innerHeight}}></rect> </clipPath> </defs> <g class=\"x axis timeseries-axis\" ng-attr-transform=\"translate(0, {{$ctrl.innerHeight}})\"> </g> <g class=\"y axis timeseries-axis\"> </g> <text class=timeseries-axis-label ng-if=\"$ctrl.hydrodataType === 'discharge'\" ng-attr-transform=\"translate({{-$ctrl.majorMargin / 2}}, {{$ctrl.innerHeight / 2}})rotate(270)\"> {{ 'Q_M3_S' | translate }} </text> <text class=timeseries-axis-label ng-if=\"$ctrl.hydrodataType === 'precipitation'\" ng-attr-transform=\"translate({{-$ctrl.majorMargin / 2}}, {{$ctrl.innerHeight / 2}})rotate(270)\"> {{ 'MM_DAY' | translate }} </text> <text class=timeseries-axis-label ng-if=\"$ctrl.hydrodataType === 'temperature'\" ng-attr-transform=\"translate({{-$ctrl.majorMargin / 2}}, {{$ctrl.innerHeight / 2}})rotate(270)\"> °C </text> <g clip-path=url(.drawing-area)> <path ng-repeat=\"curve in $ctrl.curves\" ng-attr-d={{curve.path}} fill=none ng-attr-stroke={{curve.strokeColor}} stroke-width=2></path> </g> <g ng-attr-transform=\"translate({{$ctrl.innerWidth - $ctrl.legendWidth}})\" class=timeseries-legend> <rect ng-attr-width={{$ctrl.legendWidth}} ng-attr-height={{$ctrl.legendHeight}} ng-attr-rx={{$ctrl.legendRadius}} ng-attr-ry={{$ctrl.legendRadius}}> </rect> <g ng-repeat=\"entry in $ctrl.legendEntries\"> <rect x=8 width=8 ng-attr-y=\"{{$index * 20 + 6}}\" height=8 ng-attr-fill={{entry.color}} stroke=none></rect> <text x=24 dy=.35em ng-attr-y=\"{{$index * 20 + 10}}\"> {{ entry.label }} </text> <line x1=0 x2=100 y1=10 y2=10 stroke=none></line> </g> </g> </g> </svg>";

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var timeseries_new_controller_1 = __webpack_require__(295);
	__webpack_require__(299);
	var template = __webpack_require__(300);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: timeseries_new_controller_1.default,
	    bindings: {
	        timeseries: '<',
	        hydrodataType: '<'
	    },
	    template: template
	};


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var HC_more = __webpack_require__(296);
	var Highcharts = __webpack_require__(32);
	HC_more(Highcharts);
	var exporting = __webpack_require__(297);
	exporting(Highcharts);
	var noDataToDisplay = __webpack_require__(298);
	noDataToDisplay(Highcharts);
	var TimeseriesNewController = (function () {
	    function TimeseriesNewController($translate, organizationApi, $window) {
	        var _this = this;
	        this.$translate = $translate;
	        this.organizationApi = organizationApi;
	        this.$window = $window;
	        this.chartOptions = {};
	        this.organizationApi
	            .getOrganization(Number.parseInt(this.$window.localStorage.getItem('currentOrgId')))
	            .then(function (org) {
	            _this.yearType = org.yearType;
	            if (org.yearType === "hydro_year") {
	                _this.CURRENT_HYDROYEAR =
	                    moment().month() >= 9 ? moment().year() + 1 : moment().year();
	            }
	            else if (org.yearType === "calendar_year") {
	                _this.CURRENT_HYDROYEAR = moment().year();
	            }
	        });
	        switch (this.hydrodataType) {
	            case 'discharge':
	                this.yAxisLabel = this.$translate.instant('Q_M3_S');
	                break;
	            case 'precipitation':
	                this.yAxisLabel = this.$translate.instant('MM_DAY');
	                break;
	            case 'temperature':
	                this.yAxisLabel = '°C';
	                break;
	            case 'snowData':
	                this.yAxisLabel = this.$translate.instant('MEAN_CATCHMENT_NDSI') + ' [%]';
	                break;
	            default:
	                break;
	        }
	    }
	    TimeseriesNewController.prototype.$onChanges = function (changes) {
	        this.timeseries = this.timeseries || [];
	        this.prepareChartOptions();
	    };
	    TimeseriesNewController.prototype.normalizeDate = function (date) {
	        date = date.clone();
	        if (this.yearType === "hydro_year") {
	            if (date.month() < 9) {
	                date.year(this.CURRENT_HYDROYEAR);
	            }
	            else {
	                date.year(this.CURRENT_HYDROYEAR - 1);
	            }
	        }
	        else {
	            date.year(this.CURRENT_HYDROYEAR);
	        }
	        return date.toDate();
	    };
	    TimeseriesNewController.prototype.formatTimeseries = function () {
	        var _this = this;
	        return this.timeseries.map(function (series, index) {
	            var color;
	            if (series.highlighted) {
	                color = '#000';
	            }
	            if (series.current) {
	                color = '#C40000';
	            }
	            if (series.id === "SD") {
	                return {
	                    name: series.label,
	                    data: _.sortBy(series.data.map(function (datum) {
	                        return {
	                            x: _this.normalizeDate(datum.date),
	                            low: datum.hydrodata[1],
	                            high: datum.hydrodata[0],
	                            name: moment(datum.date).format('MMMM DD, YYYY')
	                        };
	                    }), 'x'),
	                    lineWidth: 0,
	                    color: "#aaa",
	                    type: "arearange",
	                    zIndex: index,
	                    fillOpacity: 0.2,
	                    marker: {
	                        enabled: false
	                    },
	                };
	            }
	            else {
	                return {
	                    name: series.label,
	                    data: _.sortBy(series.data.map(function (datum) {
	                        return {
	                            x: _this.normalizeDate(datum.date),
	                            y: datum.hydrodata,
	                            name: moment(datum.date).format('MMMM DD, YYYY')
	                        };
	                    }), 'x'),
	                    visible: index > (_this.timeseries.length - 5),
	                    lineWidth: series.highlighted ? 2 : 1,
	                    color: color,
	                    type: "line",
	                    zIndex: index
	                };
	            }
	        }).reverse();
	    };
	    TimeseriesNewController.prototype.prepareChartOptions = function () {
	        this.chartOptions = {
	            credits: {
	                enabled: false
	            },
	            legend: {
	                enabled: true,
	                layout: 'vertical',
	                align: 'right',
	                verticalAlign: 'top',
	                itemMarginTop: 10
	            },
	            title: {
	                text: ''
	            },
	            exporting: {
	                buttons: {
	                    contextButton: {
	                        x: -145,
	                        y: -5
	                    }
	                },
	                sourceWidth: 1000
	            },
	            chart: {
	                height: 500
	            },
	            options: {
	                chart: {
	                    type: 'StockChart'
	                },
	                navigator: {
	                    enabled: true
	                }
	            },
	            tooltip: {
	                valueDecimals: 2,
	                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name} - ' + (this.hydrodataType === 'snowData' ? this.$translate.instant('MEAN_CATCHMENT_NDSI') : this.hydrodataType) + ': <b>{point.y}</b><br/>'
	            },
	            xAxis: {
	                tickWidth: 1,
	                tickLength: 20,
	                title: {
	                    text: this.$translate.instant('MONTH')
	                },
	                labels: {
	                    formatter: function () {
	                        console.log(this);
	                        return moment(this.value).add(2, "days").format('MMM');
	                    }
	                },
	                tickPositioner: function () {
	                    var positions = [], tick = Math.floor(this.dataMin), increment = Math.ceil((this.dataMax - this.dataMin) / 12);
	                    if (this.dataMax !== null && this.dataMin !== null) {
	                        for (tick; tick - increment <= this.dataMax; tick += increment) {
	                            positions.push(tick);
	                        }
	                    }
	                    return positions;
	                }
	            },
	            yAxis: {
	                title: {
	                    text: this.yAxisLabel,
	                    useHTML: true
	                }
	            },
	            useHighStocks: true,
	            series: this.formatTimeseries(),
	            plotOptions: {
	                series: {
	                    turboThreshold: 10000,
	                    states: {
	                        hover: {
	                            lineWidth: 2
	                        }
	                    }
	                }
	            }
	        };
	        //Discharge [m3/s]
	    };
	    TimeseriesNewController.$inject = ['$translate', 'organizationApi', '$window'];
	    return TimeseriesNewController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = TimeseriesNewController;


/***/ },
/* 296 */
/***/ function(module, exports) {

	/*
	 Highcharts JS v6.0.4 (2017-12-15)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(x){"object"===typeof module&&module.exports?module.exports=x:x(Highcharts)})(function(x){(function(a){var t=a.deg2rad,v=a.isNumber,w=a.pick,n=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,e=this.chart,k=2*(a.slicedOffset||0),b=e.plotWidth-2*k,e=e.plotHeight-2*k,c=a.center,c=[w(c[0],"50%"),w(c[1],"50%"),a.size||"100%",a.innerSize||0],l=Math.min(b,e),g,d;for(g=0;4>g;++g)d=c[g],a=2>g||2===g&&/%$/.test(d),c[g]=n(d,[b,e,l,c[2]][g])+(a?k:0);c[3]>c[2]&&(c[3]=c[2]);
	return c},getStartAndEndRadians:function(a,e){a=v(a)?a:0;e=v(e)&&e>a&&360>e-a?e:a+360;return{start:t*(a+-90),end:t*(e+-90)}}}})(x);(function(a){function t(a,b){this.init(a,b)}var v=a.CenteredSeriesMixin,w=a.each,n=a.extend,m=a.merge,e=a.splat;n(t.prototype,{coll:"pane",init:function(a,b){this.chart=b;this.background=[];b.pane.push(this);this.setOptions(a)},setOptions:function(a){this.options=m(this.defaultOptions,this.chart.angular?{background:{}}:void 0,a)},render:function(){var a=this.options,b=
	this.options.background,c=this.chart.renderer;this.group||(this.group=c.g("pane-group").attr({zIndex:a.zIndex||0}).add());this.updateCenter();if(b)for(b=e(b),a=Math.max(b.length,this.background.length||0),c=0;c<a;c++)b[c]&&this.axis?this.renderBackground(m(this.defaultBackgroundOptions,b[c]),c):this.background[c]&&(this.background[c]=this.background[c].destroy(),this.background.splice(c,1))},renderBackground:function(a,b){var c="animate";this.background[b]||(this.background[b]=this.chart.renderer.path().add(this.group),
	c="attr");this.background[b][c]({d:this.axis.getPlotBandPath(a.from,a.to,a)}).attr({fill:a.backgroundColor,stroke:a.borderColor,"stroke-width":a.borderWidth,"class":"highcharts-pane "+(a.className||"")})},defaultOptions:{center:["50%","50%"],size:"85%",startAngle:0},defaultBackgroundOptions:{shape:"circle",borderWidth:1,borderColor:"#cccccc",backgroundColor:{linearGradient:{x1:0,y1:0,x2:0,y2:1},stops:[[0,"#ffffff"],[1,"#e6e6e6"]]},from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:"105%"},
	updateCenter:function(a){this.center=(a||this.axis||{}).center=v.getCenter.call(this)},update:function(a,b){m(!0,this.options,a);this.setOptions(this.options);this.render();w(this.chart.axes,function(c){c.pane===this&&(c.pane=null,c.update({},b))},this)}});a.Pane=t})(x);(function(a){var t=a.each,v=a.extend,w=a.map,n=a.merge,m=a.noop,e=a.pick,k=a.pInt,b=a.wrap,c,l,g=a.Axis.prototype;a=a.Tick.prototype;c={getOffset:m,redraw:function(){this.isDirty=!1},render:function(){this.isDirty=!1},setScale:m,setCategories:m,
	setTitle:m};l={defaultRadialGaugeOptions:{labels:{align:"center",x:0,y:null},minorGridLineWidth:0,minorTickInterval:"auto",minorTickLength:10,minorTickPosition:"inside",minorTickWidth:1,tickLength:10,tickPosition:"inside",tickWidth:2,title:{rotation:0},zIndex:2},defaultRadialXOptions:{gridLineWidth:1,labels:{align:null,distance:15,x:0,y:null,style:{textOverflow:"none"}},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},defaultRadialYOptions:{gridLineInterpolation:"circle",labels:{align:"right",
	x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}},setOptions:function(b){b=this.options=n(this.defaultOptions,this.defaultRadialOptions,b);b.plotBands||(b.plotBands=[])},getOffset:function(){g.getOffset.call(this);this.chart.axisOffset[this.side]=0},getLinePath:function(b,c){b=this.center;var d=this.chart,f=e(c,b[2]/2-this.offset);this.isCircular||void 0!==c?(c=this.chart.renderer.symbols.arc(this.left+b[0],this.top+b[1],f,f,{start:this.startAngleRad,end:this.endAngleRad,open:!0,innerR:0}),
	c.xBounds=[this.left+b[0]],c.yBounds=[this.top+b[1]-f]):(c=this.postTranslate(this.angleRad,f),c=["M",b[0]+d.plotLeft,b[1]+d.plotTop,"L",c.x,c.y]);return c},setAxisTranslation:function(){g.setAxisTranslation.call(this);this.center&&(this.transA=this.isCircular?(this.endAngleRad-this.startAngleRad)/(this.max-this.min||1):this.center[2]/2/(this.max-this.min||1),this.minPixelPadding=this.isXAxis?this.transA*this.minPointOffset:0)},beforeSetTickPositions:function(){if(this.autoConnect=this.isCircular&&
	void 0===e(this.userMax,this.options.max)&&this.endAngleRad-this.startAngleRad===2*Math.PI)this.max+=this.categories&&1||this.pointRange||this.closestPointRange||0},setAxisSize:function(){g.setAxisSize.call(this);this.isRadial&&(this.pane.updateCenter(this),this.isCircular&&(this.sector=this.endAngleRad-this.startAngleRad),this.len=this.width=this.height=this.center[2]*e(this.sector,1)/2)},getPosition:function(b,c){return this.postTranslate(this.isCircular?this.translate(b):this.angleRad,e(this.isCircular?
	c:this.translate(b),this.center[2]/2)-this.offset)},postTranslate:function(b,c){var d=this.chart,f=this.center;b=this.startAngleRad+b;return{x:d.plotLeft+f[0]+Math.cos(b)*c,y:d.plotTop+f[1]+Math.sin(b)*c}},getPlotBandPath:function(b,c,a){var d=this.center,f=this.startAngleRad,l=d[2]/2,h=[e(a.outerRadius,"100%"),a.innerRadius,e(a.thickness,10)],g=Math.min(this.offset,0),u=/%$/,m,n=this.isCircular;"polygon"===this.options.gridLineInterpolation?d=this.getPlotLinePath(b).concat(this.getPlotLinePath(c,
	!0)):(b=Math.max(b,this.min),c=Math.min(c,this.max),n||(h[0]=this.translate(b),h[1]=this.translate(c)),h=w(h,function(b){u.test(b)&&(b=k(b,10)*l/100);return b}),"circle"!==a.shape&&n?(b=f+this.translate(b),c=f+this.translate(c)):(b=-Math.PI/2,c=1.5*Math.PI,m=!0),h[0]-=g,h[2]-=g,d=this.chart.renderer.symbols.arc(this.left+d[0],this.top+d[1],h[0],h[0],{start:Math.min(b,c),end:Math.max(b,c),innerR:e(h[1],h[0]-h[2]),open:m}));return d},getPlotLinePath:function(b,c){var d=this,f=d.center,a=d.chart,l=d.getPosition(b),
	g,e,u;d.isCircular?u=["M",f[0]+a.plotLeft,f[1]+a.plotTop,"L",l.x,l.y]:"circle"===d.options.gridLineInterpolation?(b=d.translate(b))&&(u=d.getLinePath(0,b)):(t(a.xAxis,function(b){b.pane===d.pane&&(g=b)}),u=[],b=d.translate(b),f=g.tickPositions,g.autoConnect&&(f=f.concat([f[0]])),c&&(f=[].concat(f).reverse()),t(f,function(c,d){e=g.getPosition(c,b);u.push(d?"L":"M",e.x,e.y)}));return u},getTitlePosition:function(){var b=this.center,c=this.chart,a=this.options.title;return{x:c.plotLeft+b[0]+(a.x||0),
	y:c.plotTop+b[1]-{high:.5,middle:.25,low:0}[a.align]*b[2]+(a.y||0)}}};b(g,"init",function(b,f,a){var d=f.angular,h=f.polar,g=a.isX,y=d&&g,m,u=f.options,k=a.pane||0,t=this.pane=f.pane&&f.pane[k],k=t&&t.options;if(d){if(v(this,y?c:l),m=!g)this.defaultRadialOptions=this.defaultRadialGaugeOptions}else h&&(v(this,l),this.defaultRadialOptions=(m=g)?this.defaultRadialXOptions:n(this.defaultYAxisOptions,this.defaultRadialYOptions));d||h?(this.isRadial=!0,f.inverted=!1,u.chart.zoomType=null):this.isRadial=
	!1;t&&m&&(t.axis=this);b.call(this,f,a);!y&&t&&(d||h)&&(b=this.options,this.angleRad=(b.angle||0)*Math.PI/180,this.startAngleRad=(k.startAngle-90)*Math.PI/180,this.endAngleRad=(e(k.endAngle,k.startAngle+360)-90)*Math.PI/180,this.offset=b.offset||0,this.isCircular=m)});b(g,"autoLabelAlign",function(b){if(!this.isRadial)return b.apply(this,[].slice.call(arguments,1))});b(a,"getPosition",function(b,c,a,l,g){var d=this.axis;return d.getPosition?d.getPosition(a):b.call(this,c,a,l,g)});b(a,"getLabelPosition",
	function(b,c,a,l,g,r,y,m,u){var d=this.axis,f=r.y,h=20,p=r.align,q=(d.translate(this.pos)+d.startAngleRad+Math.PI/2)/Math.PI*180%360;d.isRadial?(b=d.getPosition(this.pos,d.center[2]/2+e(r.distance,-25)),"auto"===r.rotation?l.attr({rotation:q}):null===f&&(f=d.chart.renderer.fontMetrics(l.styles.fontSize).b-l.getBBox().height/2),null===p&&(d.isCircular?(this.label.getBBox().width>d.len*d.tickInterval/(d.max-d.min)&&(h=0),p=q>h&&q<180-h?"left":q>180+h&&q<360-h?"right":"center"):p="center",l.attr({align:p})),
	b.x+=r.x,b.y+=f):b=b.call(this,c,a,l,g,r,y,m,u);return b});b(a,"getMarkPath",function(b,c,a,l,g,r,e){var d=this.axis;d.isRadial?(b=d.getPosition(this.pos,d.center[2]/2+l),c=["M",c,a,"L",b.x,b.y]):c=b.call(this,c,a,l,g,r,e);return c})})(x);(function(a){var t=a.each,v=a.pick,w=a.defined,n=a.seriesType,m=a.seriesTypes,e=a.Series.prototype,k=a.Point.prototype;n("arearange","area",{lineWidth:1,threshold:null,tooltip:{pointFormat:'\x3cspan style\x3d"color:{series.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},
	trackByArea:!0,dataLabels:{align:null,verticalAlign:null,xLow:0,xHigh:0,yLow:0,yHigh:0}},{pointArrayMap:["low","high"],dataLabelCollections:["dataLabel","dataLabelUpper"],toYData:function(b){return[b.low,b.high]},pointValKey:"low",deferTranslatePolar:!0,highToXY:function(b){var c=this.chart,a=this.xAxis.postTranslate(b.rectPlotX,this.yAxis.len-b.plotHigh);b.plotHighX=a.x-c.plotLeft;b.plotHigh=a.y-c.plotTop;b.plotLowX=b.plotX},translate:function(){var b=this,c=b.yAxis,a=!!b.modifyValue;m.area.prototype.translate.apply(b);
	t(b.points,function(l){var d=l.low,f=l.high,h=l.plotY;null===f||null===d?(l.isNull=!0,l.plotY=null):(l.plotLow=h,l.plotHigh=c.translate(a?b.modifyValue(f,l):f,0,1,0,1),a&&(l.yBottom=l.plotHigh))});this.chart.polar&&t(this.points,function(c){b.highToXY(c);c.tooltipPos=[(c.plotHighX+c.plotLowX)/2,(c.plotHigh+c.plotLow)/2]})},getGraphPath:function(b){var c=[],a=[],g,d=m.area.prototype.getGraphPath,f,h,q;q=this.options;var p=this.chart.polar&&!1!==q.connectEnds,r=q.connectNulls,e=q.step;b=b||this.points;
	for(g=b.length;g--;)f=b[g],f.isNull||p||r||b[g+1]&&!b[g+1].isNull||a.push({plotX:f.plotX,plotY:f.plotY,doCurve:!1}),h={polarPlotY:f.polarPlotY,rectPlotX:f.rectPlotX,yBottom:f.yBottom,plotX:v(f.plotHighX,f.plotX),plotY:f.plotHigh,isNull:f.isNull},a.push(h),c.push(h),f.isNull||p||r||b[g-1]&&!b[g-1].isNull||a.push({plotX:f.plotX,plotY:f.plotY,doCurve:!1});b=d.call(this,b);e&&(!0===e&&(e="left"),q.step={left:"right",center:"center",right:"left"}[e]);c=d.call(this,c);a=d.call(this,a);q.step=e;q=[].concat(b,
	c);this.chart.polar||"M"!==a[0]||(a[0]="L");this.graphPath=q;this.areaPath=b.concat(a);q.isArea=!0;q.xMap=b.xMap;this.areaPath.xMap=b.xMap;return q},drawDataLabels:function(){var b=this.data,c=b.length,a,g=[],d=this.options.dataLabels,f=d.align,h=d.verticalAlign,q=d.inside,p,r,y=this.chart.inverted;if(d.enabled||this._hasPointLabels){for(a=c;a--;)if(p=b[a])r=q?p.plotHigh<p.plotLow:p.plotHigh>p.plotLow,p.y=p.high,p._plotY=p.plotY,p.plotY=p.plotHigh,g[a]=p.dataLabel,p.dataLabel=p.dataLabelUpper,p.below=
	r,y?f||(d.align=r?"right":"left"):h||(d.verticalAlign=r?"top":"bottom"),d.x=d.xHigh,d.y=d.yHigh;e.drawDataLabels&&e.drawDataLabels.apply(this,arguments);for(a=c;a--;)if(p=b[a])r=q?p.plotHigh<p.plotLow:p.plotHigh>p.plotLow,p.dataLabelUpper=p.dataLabel,p.dataLabel=g[a],p.y=p.low,p.plotY=p._plotY,p.below=!r,y?f||(d.align=r?"left":"right"):h||(d.verticalAlign=r?"bottom":"top"),d.x=d.xLow,d.y=d.yLow;e.drawDataLabels&&e.drawDataLabels.apply(this,arguments)}d.align=f;d.verticalAlign=h},alignDataLabel:function(){m.column.prototype.alignDataLabel.apply(this,
	arguments)},drawPoints:function(){var b=this.points.length,c,a;e.drawPoints.apply(this,arguments);for(a=0;a<b;)c=this.points[a],c.lowerGraphic=c.graphic,c.graphic=c.upperGraphic,c._plotY=c.plotY,c._plotX=c.plotX,c.plotY=c.plotHigh,w(c.plotHighX)&&(c.plotX=c.plotHighX),a++;e.drawPoints.apply(this,arguments);for(a=0;a<b;)c=this.points[a],c.upperGraphic=c.graphic,c.graphic=c.lowerGraphic,c.plotY=c._plotY,c.plotX=c._plotX,a++},setStackedPoints:a.noop},{setState:function(){var b=this.state,c=this.series,
	a=c.chart.polar;w(this.plotHigh)||(this.plotHigh=c.yAxis.toPixels(this.high,!0));w(this.plotLow)||(this.plotLow=this.plotY=c.yAxis.toPixels(this.low,!0));k.setState.apply(this,arguments);this.graphic=this.upperGraphic;this.plotY=this.plotHigh;a&&(this.plotX=this.plotHighX);this.state=b;c.stateMarkerGraphic&&(c.lowerStateMarkerGraphic=c.stateMarkerGraphic,c.stateMarkerGraphic=c.upperStateMarkerGraphic);k.setState.apply(this,arguments);this.plotY=this.plotLow;this.graphic=this.lowerGraphic;a&&(this.plotX=
	this.plotLowX);c.stateMarkerGraphic&&(c.upperStateMarkerGraphic=c.stateMarkerGraphic,c.stateMarkerGraphic=c.lowerStateMarkerGraphic,c.lowerStateMarkerGraphic=void 0)},haloPath:function(){var b=this.series.chart.polar,c;this.plotY=this.plotLow;b&&(this.plotX=this.plotLowX);c=k.haloPath.apply(this,arguments);this.plotY=this.plotHigh;b&&(this.plotX=this.plotHighX);return c=c.concat(k.haloPath.apply(this,arguments))},destroy:function(){this.upperGraphic&&(this.upperGraphic=this.upperGraphic.destroy());
	return k.destroy.apply(this,arguments)}})})(x);(function(a){var t=a.seriesType;t("areasplinerange","arearange",null,{getPointSpline:a.seriesTypes.spline.prototype.getPointSpline})})(x);(function(a){var t=a.defaultPlotOptions,v=a.each,w=a.merge,n=a.noop,m=a.pick,e=a.seriesType,k=a.seriesTypes.column.prototype;e("columnrange","arearange",w(t.column,t.arearange,{pointRange:null,marker:null,states:{hover:{halo:!1}}}),{translate:function(){var b=this,c=b.yAxis,a=b.xAxis,g=a.startAngleRad,d,f=b.chart,h=
	b.xAxis.isRadial,q=Math.max(f.chartWidth,f.chartHeight)+999,p;k.translate.apply(b);v(b.points,function(l){var r=l.shapeArgs,e=b.options.minPointLength,u,k;l.plotHigh=p=Math.min(Math.max(-q,c.translate(l.high,0,1,0,1)),q);l.plotLow=Math.min(Math.max(-q,l.plotY),q);k=p;u=m(l.rectPlotY,l.plotY)-p;Math.abs(u)<e?(e-=u,u+=e,k-=e/2):0>u&&(u*=-1,k-=u);h?(d=l.barX+g,l.shapeType="path",l.shapeArgs={d:b.polarArc(k+u,k,d,d+l.pointWidth)}):(r.height=u,r.y=k,l.tooltipPos=f.inverted?[c.len+c.pos-f.plotLeft-k-u/
	2,a.len+a.pos-f.plotTop-r.x-r.width/2,u]:[a.left-f.plotLeft+r.x+r.width/2,c.pos-f.plotTop+k+u/2,u])})},directTouch:!0,trackerGroups:["group","dataLabelsGroup"],drawGraph:n,getSymbol:n,crispCol:k.crispCol,drawPoints:k.drawPoints,drawTracker:k.drawTracker,getColumnMetrics:k.getColumnMetrics,pointAttribs:k.pointAttribs,animate:function(){return k.animate.apply(this,arguments)},polarArc:function(){return k.polarArc.apply(this,arguments)},translate3dPoints:function(){return k.translate3dPoints.apply(this,
	arguments)},translate3dShapes:function(){return k.translate3dShapes.apply(this,arguments)}},{setState:k.pointClass.prototype.setState})})(x);(function(a){var t=a.each,v=a.isNumber,w=a.merge,n=a.pick,m=a.pInt,e=a.Series,k=a.seriesType,b=a.TrackerMixin;k("gauge","line",{dataLabels:{enabled:!0,defer:!1,y:15,borderRadius:3,crop:!1,verticalAlign:"top",zIndex:2,borderWidth:1,borderColor:"#cccccc"},dial:{},pivot:{},tooltip:{headerFormat:""},showInLegend:!1},{angular:!0,directTouch:!0,drawGraph:a.noop,fixedBox:!0,
	forceDL:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],translate:function(){var b=this.yAxis,a=this.options,g=b.center;this.generatePoints();t(this.points,function(c){var d=w(a.dial,c.dial),l=m(n(d.radius,80))*g[2]/200,q=m(n(d.baseLength,70))*l/100,p=m(n(d.rearLength,10))*l/100,r=d.baseWidth||3,e=d.topWidth||1,k=a.overshoot,u=b.startAngleRad+b.translate(c.y,null,null,null,!0);v(k)?(k=k/180*Math.PI,u=Math.max(b.startAngleRad-k,Math.min(b.endAngleRad+k,u))):!1===a.wrap&&(u=Math.max(b.startAngleRad,
	Math.min(b.endAngleRad,u)));u=180*u/Math.PI;c.shapeType="path";c.shapeArgs={d:d.path||["M",-p,-r/2,"L",q,-r/2,l,-e/2,l,e/2,q,r/2,-p,r/2,"z"],translateX:g[0],translateY:g[1],rotation:u};c.plotX=g[0];c.plotY=g[1]})},drawPoints:function(){var b=this,a=b.yAxis.center,g=b.pivot,d=b.options,f=d.pivot,h=b.chart.renderer;t(b.points,function(c){var a=c.graphic,f=c.shapeArgs,l=f.d,g=w(d.dial,c.dial);a?(a.animate(f),f.d=l):(c.graphic=h[c.shapeType](f).attr({rotation:f.rotation,zIndex:1}).addClass("highcharts-dial").add(b.group),
	c.graphic.attr({stroke:g.borderColor||"none","stroke-width":g.borderWidth||0,fill:g.backgroundColor||"#000000"}))});g?g.animate({translateX:a[0],translateY:a[1]}):(b.pivot=h.circle(0,0,n(f.radius,5)).attr({zIndex:2}).addClass("highcharts-pivot").translate(a[0],a[1]).add(b.group),b.pivot.attr({"stroke-width":f.borderWidth||0,stroke:f.borderColor||"#cccccc",fill:f.backgroundColor||"#000000"}))},animate:function(b){var c=this;b||(t(c.points,function(b){var a=b.graphic;a&&(a.attr({rotation:180*c.yAxis.startAngleRad/
	Math.PI}),a.animate({rotation:b.shapeArgs.rotation},c.options.animation))}),c.animate=null)},render:function(){this.group=this.plotGroup("group","series",this.visible?"visible":"hidden",this.options.zIndex,this.chart.seriesGroup);e.prototype.render.call(this);this.group.clip(this.chart.clipRect)},setData:function(b,a){e.prototype.setData.call(this,b,!1);this.processData();this.generatePoints();n(a,!0)&&this.chart.redraw()},drawTracker:b&&b.drawTrackerPoint},{setState:function(b){this.state=b}})})(x);
	(function(a){var t=a.each,v=a.noop,w=a.pick,n=a.seriesType,m=a.seriesTypes;n("boxplot","column",{threshold:null,tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cb\x3e {series.name}\x3c/b\x3e\x3cbr/\x3eMaximum: {point.high}\x3cbr/\x3eUpper quartile: {point.q3}\x3cbr/\x3eMedian: {point.median}\x3cbr/\x3eLower quartile: {point.q1}\x3cbr/\x3eMinimum: {point.low}\x3cbr/\x3e'},whiskerLength:"50%",fillColor:"#ffffff",lineWidth:1,medianWidth:2,states:{hover:{brightness:-.3}},
	whiskerWidth:2},{pointArrayMap:["low","q1","median","q3","high"],toYData:function(a){return[a.low,a.q1,a.median,a.q3,a.high]},pointValKey:"high",pointAttribs:function(a){var e=this.options,b=a&&a.color||this.color;return{fill:a.fillColor||e.fillColor||b,stroke:e.lineColor||b,"stroke-width":e.lineWidth||0}},drawDataLabels:v,translate:function(){var a=this.yAxis,k=this.pointArrayMap;m.column.prototype.translate.apply(this);t(this.points,function(b){t(k,function(c){null!==b[c]&&(b[c+"Plot"]=a.translate(b[c],
	0,1,0,1))})})},drawPoints:function(){var a=this,k=a.options,b=a.chart.renderer,c,l,g,d,f,h,q=0,p,r,m,n,u=!1!==a.doQuartiles,v,A=a.options.whiskerLength;t(a.points,function(e){var y=e.graphic,t=y?"animate":"attr",J=e.shapeArgs,x={},C={},H={},I=e.color||a.color;void 0!==e.plotY&&(p=J.width,r=Math.floor(J.x),m=r+p,n=Math.round(p/2),c=Math.floor(u?e.q1Plot:e.lowPlot),l=Math.floor(u?e.q3Plot:e.lowPlot),g=Math.floor(e.highPlot),d=Math.floor(e.lowPlot),y||(e.graphic=y=b.g("point").add(a.group),e.stem=b.path().addClass("highcharts-boxplot-stem").add(y),
	A&&(e.whiskers=b.path().addClass("highcharts-boxplot-whisker").add(y)),u&&(e.box=b.path(void 0).addClass("highcharts-boxplot-box").add(y)),e.medianShape=b.path(void 0).addClass("highcharts-boxplot-median").add(y)),x.stroke=e.stemColor||k.stemColor||I,x["stroke-width"]=w(e.stemWidth,k.stemWidth,k.lineWidth),x.dashstyle=e.stemDashStyle||k.stemDashStyle,e.stem.attr(x),A&&(C.stroke=e.whiskerColor||k.whiskerColor||I,C["stroke-width"]=w(e.whiskerWidth,k.whiskerWidth,k.lineWidth),e.whiskers.attr(C)),u&&
	(y=a.pointAttribs(e),e.box.attr(y)),H.stroke=e.medianColor||k.medianColor||I,H["stroke-width"]=w(e.medianWidth,k.medianWidth,k.lineWidth),e.medianShape.attr(H),h=e.stem.strokeWidth()%2/2,q=r+n+h,e.stem[t]({d:["M",q,l,"L",q,g,"M",q,c,"L",q,d]}),u&&(h=e.box.strokeWidth()%2/2,c=Math.floor(c)+h,l=Math.floor(l)+h,r+=h,m+=h,e.box[t]({d:["M",r,l,"L",r,c,"L",m,c,"L",m,l,"L",r,l,"z"]})),A&&(h=e.whiskers.strokeWidth()%2/2,g+=h,d+=h,v=/%$/.test(A)?n*parseFloat(A)/100:A/2,e.whiskers[t]({d:["M",q-v,g,"L",q+v,
	g,"M",q-v,d,"L",q+v,d]})),f=Math.round(e.medianPlot),h=e.medianShape.strokeWidth()%2/2,f+=h,e.medianShape[t]({d:["M",r,f,"L",m,f]}))})},setStackedPoints:v})})(x);(function(a){var t=a.each,v=a.noop,w=a.seriesType,n=a.seriesTypes;w("errorbar","boxplot",{color:"#000000",grouping:!1,linkedTo:":previous",tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},whiskerWidth:null},{type:"errorbar",
	pointArrayMap:["low","high"],toYData:function(a){return[a.low,a.high]},pointValKey:"high",doQuartiles:!1,drawDataLabels:n.arearange?function(){var a=this.pointValKey;n.arearange.prototype.drawDataLabels.call(this);t(this.data,function(e){e.y=e[a]})}:v,getColumnMetrics:function(){return this.linkedParent&&this.linkedParent.columnMetrics||n.column.prototype.getColumnMetrics.call(this)}})})(x);(function(a){var t=a.correctFloat,v=a.isNumber,w=a.pick,n=a.Point,m=a.Series,e=a.seriesType,k=a.seriesTypes;
	e("waterfall","column",{dataLabels:{inside:!0},lineWidth:1,lineColor:"#333333",dashStyle:"dot",borderColor:"#333333",states:{hover:{lineWidthPlus:0}}},{pointValKey:"y",translate:function(){var b=this.options,c=this.yAxis,a,g,d,f,h,e,p,r,m,n,u=w(b.minPointLength,5),v=u/2,x=b.threshold,D=b.stacking,z;k.column.prototype.translate.apply(this);r=m=x;g=this.points;a=0;for(b=g.length;a<b;a++)d=g[a],p=this.processedYData[a],f=d.shapeArgs,h=D&&c.stacks[(this.negStacks&&p<x?"-":"")+this.stackKey],z=this.getStackIndicator(z,
	d.x,this.index),n=h?h[d.x].points[z.key]:[0,p],d.isSum?d.y=t(p):d.isIntermediateSum&&(d.y=t(p-m)),e=Math.max(r,r+d.y)+n[0],f.y=c.translate(e,0,1,0,1),d.isSum?(f.y=c.translate(n[1],0,1,0,1),f.height=Math.min(c.translate(n[0],0,1,0,1),c.len)-f.y):d.isIntermediateSum?(f.y=c.translate(n[1],0,1,0,1),f.height=Math.min(c.translate(m,0,1,0,1),c.len)-f.y,m=n[1]):(f.height=0<p?c.translate(r,0,1,0,1)-f.y:c.translate(r,0,1,0,1)-c.translate(r-p,0,1,0,1),r+=h&&h[d.x]?h[d.x].total:p),0>f.height&&(f.y+=f.height,
	f.height*=-1),d.plotY=f.y=Math.round(f.y)-this.borderWidth%2/2,f.height=Math.max(Math.round(f.height),.001),d.yBottom=f.y+f.height,f.height<=u&&!d.isNull?(f.height=u,f.y-=v,d.plotY=f.y,d.minPointLengthOffset=0>d.y?-v:v):d.minPointLengthOffset=0,f=d.plotY+(d.negative?f.height:0),this.chart.inverted?d.tooltipPos[0]=c.len-f:d.tooltipPos[1]=f},processData:function(b){var c=this.yData,a=this.options.data,e,d=c.length,f,h,q,p,r,k;h=f=q=p=this.options.threshold||0;for(k=0;k<d;k++)r=c[k],e=a&&a[k]?a[k]:{},
	"sum"===r||e.isSum?c[k]=t(h):"intermediateSum"===r||e.isIntermediateSum?c[k]=t(f):(h+=r,f+=r),q=Math.min(h,q),p=Math.max(h,p);m.prototype.processData.call(this,b);this.options.stacking||(this.dataMin=q,this.dataMax=p)},toYData:function(b){return b.isSum?0===b.x?null:"sum":b.isIntermediateSum?0===b.x?null:"intermediateSum":b.y},pointAttribs:function(b,a){var c=this.options.upColor;c&&!b.options.color&&(b.color=0<b.y?c:null);b=k.column.prototype.pointAttribs.call(this,b,a);delete b.dashstyle;return b},
	getGraphPath:function(){return["M",0,0]},getCrispPath:function(){var b=this.data,a=b.length,e=this.graph.strokeWidth()+this.borderWidth,e=Math.round(e)%2/2,g=this.yAxis.reversed,d=[],f,h,q;for(q=1;q<a;q++){h=b[q].shapeArgs;f=b[q-1].shapeArgs;h=["M",f.x+f.width,f.y+b[q-1].minPointLengthOffset+e,"L",h.x,f.y+b[q-1].minPointLengthOffset+e];if(0>b[q-1].y&&!g||0<b[q-1].y&&g)h[2]+=f.height,h[5]+=f.height;d=d.concat(h)}return d},drawGraph:function(){m.prototype.drawGraph.call(this);this.graph.attr({d:this.getCrispPath()})},
	setStackedPoints:function(){var b=this.options,a,e;m.prototype.setStackedPoints.apply(this,arguments);a=this.stackedYData?this.stackedYData.length:0;for(e=1;e<a;e++)b.data[e].isSum||b.data[e].isIntermediateSum||(this.stackedYData[e]+=this.stackedYData[e-1])},getExtremes:function(){if(this.options.stacking)return m.prototype.getExtremes.apply(this,arguments)}},{getClassName:function(){var b=n.prototype.getClassName.call(this);this.isSum?b+=" highcharts-sum":this.isIntermediateSum&&(b+=" highcharts-intermediate-sum");
	return b},isValid:function(){return v(this.y,!0)||this.isSum||this.isIntermediateSum}})})(x);(function(a){var t=a.Series,v=a.seriesType,w=a.seriesTypes;v("polygon","scatter",{marker:{enabled:!1,states:{hover:{enabled:!1}}},stickyTracking:!1,tooltip:{followPointer:!0,pointFormat:""},trackByArea:!0},{type:"polygon",getGraphPath:function(){for(var a=t.prototype.getGraphPath.call(this),m=a.length+1;m--;)(m===a.length||"M"===a[m])&&0<m&&a.splice(m,0,"z");return this.areaPath=a},drawGraph:function(){this.options.fillColor=
	this.color;w.area.prototype.drawGraph.call(this)},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawTracker:t.prototype.drawTracker,setStackedPoints:a.noop})})(x);(function(a){var t=a.arrayMax,v=a.arrayMin,w=a.Axis,n=a.color,m=a.each,e=a.isNumber,k=a.noop,b=a.pick,c=a.pInt,l=a.Point,g=a.Series,d=a.seriesType,f=a.seriesTypes;d("bubble","scatter",{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:"middle"},marker:{lineColor:null,lineWidth:1,radius:null,states:{hover:{radiusPlus:0}},
	symbol:"circle"},minSize:8,maxSize:"20%",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},turboThreshold:0,zThreshold:0,zoneAxis:"z"},{pointArrayMap:["y","z"],parallelArrays:["x","y","z"],trackerGroups:["group","dataLabelsGroup"],specialGroup:"group",bubblePadding:!0,zoneAxis:"z",directTouch:!0,pointAttribs:function(a,c){var d=b(this.options.marker.fillOpacity,.5);a=g.prototype.pointAttribs.call(this,a,c);1!==d&&(a.fill=n(a.fill).setOpacity(d).get("rgba"));
	return a},getRadii:function(b,a,c,d){var f,e,h,g=this.zData,l=[],p=this.options,r="width"!==p.sizeBy,q=p.zThreshold,k=a-b;e=0;for(f=g.length;e<f;e++)h=g[e],p.sizeByAbsoluteValue&&null!==h&&(h=Math.abs(h-q),a=Math.max(a-q,Math.abs(b-q)),b=0),null===h?h=null:h<b?h=c/2-1:(h=0<k?(h-b)/k:.5,r&&0<=h&&(h=Math.sqrt(h)),h=Math.ceil(c+h*(d-c))/2),l.push(h);this.radii=l},animate:function(b){var a=this.options.animation;b||(m(this.points,function(b){var c=b.graphic,d;c&&c.width&&(d={x:c.x,y:c.y,width:c.width,
	height:c.height},c.attr({x:b.plotX,y:b.plotY,width:1,height:1}),c.animate(d,a))}),this.animate=null)},translate:function(){var b,c=this.data,d,g,l=this.radii;f.scatter.prototype.translate.call(this);for(b=c.length;b--;)d=c[b],g=l?l[b]:0,e(g)&&g>=this.minPxSize/2?(d.marker=a.extend(d.marker,{radius:g,width:2*g,height:2*g}),d.dlBox={x:d.plotX-g,y:d.plotY-g,width:2*g,height:2*g}):d.shapeArgs=d.plotY=d.dlBox=void 0},alignDataLabel:f.column.prototype.alignDataLabel,buildKDTree:k,applyZones:k},{haloPath:function(b){return l.prototype.haloPath.call(this,
	0===b?0:(this.marker?this.marker.radius||0:0)+b)},ttBelow:!1});w.prototype.beforePadding=function(){var a=this,d=this.len,f=this.chart,g=0,l=d,k=this.isXAxis,n=k?"xData":"yData",w=this.min,x={},D=Math.min(f.plotWidth,f.plotHeight),z=Number.MAX_VALUE,E=-Number.MAX_VALUE,F=this.max-w,B=d/F,G=[];m(this.series,function(d){var e=d.options;!d.bubblePadding||!d.visible&&f.options.chart.ignoreHiddenSeries||(a.allowZoomOutside=!0,G.push(d),k&&(m(["minSize","maxSize"],function(b){var a=e[b],d=/%$/.test(a),
	a=c(a);x[b]=d?D*a/100:a}),d.minPxSize=x.minSize,d.maxPxSize=Math.max(x.maxSize,x.minSize),d=d.zData,d.length&&(z=b(e.zMin,Math.min(z,Math.max(v(d),!1===e.displayNegative?e.zThreshold:-Number.MAX_VALUE))),E=b(e.zMax,Math.max(E,t(d))))))});m(G,function(b){var c=b[n],d=c.length,f;k&&b.getRadii(z,E,b.minPxSize,b.maxPxSize);if(0<F)for(;d--;)e(c[d])&&a.dataMin<=c[d]&&c[d]<=a.dataMax&&(f=b.radii[d],g=Math.min((c[d]-w)*B-f,g),l=Math.max((c[d]-w)*B+f,l))});G.length&&0<F&&!this.isLog&&(l-=d,B*=(d+g-l)/d,m([["min",
	"userMin",g],["max","userMax",l]],function(c){void 0===b(a.options[c[0]],a[c[1]])&&(a[c[0]]+=c[2]/B)}))}})(x);(function(a){function t(b,a){var c=this.chart,e=this.options.animation,d=this.group,f=this.markerGroup,h=this.xAxis.center,k=c.plotLeft,p=c.plotTop;c.polar?c.renderer.isSVG&&(!0===e&&(e={}),a?(b={translateX:h[0]+k,translateY:h[1]+p,scaleX:.001,scaleY:.001},d.attr(b),f&&f.attr(b)):(b={translateX:k,translateY:p,scaleX:1,scaleY:1},d.animate(b,e),f&&f.animate(b,e),this.animate=null)):b.call(this,
	a)}var v=a.each,w=a.pick,n=a.seriesTypes,m=a.wrap,e=a.Series.prototype,k=a.Pointer.prototype;e.searchPointByAngle=function(b){var a=this.chart,e=this.xAxis.pane.center;return this.searchKDTree({clientX:180+-180/Math.PI*Math.atan2(b.chartX-e[0]-a.plotLeft,b.chartY-e[1]-a.plotTop)})};e.getConnectors=function(b,a,e,g){var c,f,h,l,k,m,n,t;f=g?1:0;c=0<=a&&a<=b.length-1?a:0>a?b.length-1+a:0;a=0>c-1?b.length-(1+f):c-1;f=c+1>b.length-1?f:c+1;h=b[a];f=b[f];l=h.plotX;h=h.plotY;k=f.plotX;m=f.plotY;f=b[c].plotX;
	c=b[c].plotY;l=(1.5*f+l)/2.5;h=(1.5*c+h)/2.5;k=(1.5*f+k)/2.5;n=(1.5*c+m)/2.5;m=Math.sqrt(Math.pow(l-f,2)+Math.pow(h-c,2));t=Math.sqrt(Math.pow(k-f,2)+Math.pow(n-c,2));l=Math.atan2(h-c,l-f);n=Math.PI/2+(l+Math.atan2(n-c,k-f))/2;Math.abs(l-n)>Math.PI/2&&(n-=Math.PI);l=f+Math.cos(n)*m;h=c+Math.sin(n)*m;k=f+Math.cos(Math.PI+n)*t;n=c+Math.sin(Math.PI+n)*t;f={rightContX:k,rightContY:n,leftContX:l,leftContY:h,plotX:f,plotY:c};e&&(f.prevPointCont=this.getConnectors(b,a,!1,g));return f};m(e,"buildKDTree",
	function(b){this.chart.polar&&(this.kdByAngle?this.searchPoint=this.searchPointByAngle:this.options.findNearestPointBy="xy");b.apply(this)});e.toXY=function(b){var a,e=this.chart,g=b.plotX;a=b.plotY;b.rectPlotX=g;b.rectPlotY=a;a=this.xAxis.postTranslate(b.plotX,this.yAxis.len-a);b.plotX=b.polarPlotX=a.x-e.plotLeft;b.plotY=b.polarPlotY=a.y-e.plotTop;this.kdByAngle?(e=(g/Math.PI*180+this.xAxis.pane.options.startAngle)%360,0>e&&(e+=360),b.clientX=e):b.clientX=b.plotX};n.spline&&(m(n.spline.prototype,
	"getPointSpline",function(b,a,e,g){this.chart.polar?g?(b=this.getConnectors(a,g,!0,this.connectEnds),b=["C",b.prevPointCont.rightContX,b.prevPointCont.rightContY,b.leftContX,b.leftContY,b.plotX,b.plotY]):b=["M",e.plotX,e.plotY]:b=b.call(this,a,e,g);return b}),n.areasplinerange&&(n.areasplinerange.prototype.getPointSpline=n.spline.prototype.getPointSpline));m(e,"translate",function(b){var a=this.chart;b.call(this);if(a.polar&&(this.kdByAngle=a.tooltip&&a.tooltip.shared,!this.preventPostTranslate))for(b=
	this.points,a=b.length;a--;)this.toXY(b[a])});m(e,"getGraphPath",function(b,a){var c=this,e,d,f;if(this.chart.polar){a=a||this.points;for(e=0;e<a.length;e++)if(!a[e].isNull){d=e;break}!1!==this.options.connectEnds&&void 0!==d&&(this.connectEnds=!0,a.splice(a.length,0,a[d]),f=!0);v(a,function(b){void 0===b.polarPlotY&&c.toXY(b)})}e=b.apply(this,[].slice.call(arguments,1));f&&a.pop();return e});m(e,"animate",t);n.column&&(n=n.column.prototype,n.polarArc=function(b,a,e,g){var c=this.xAxis.center,f=this.yAxis.len;
	return this.chart.renderer.symbols.arc(c[0],c[1],f-a,null,{start:e,end:g,innerR:f-w(b,f)})},m(n,"animate",t),m(n,"translate",function(b){var a=this.xAxis,e=a.startAngleRad,g,d,f;this.preventPostTranslate=!0;b.call(this);if(a.isRadial)for(g=this.points,f=g.length;f--;)d=g[f],b=d.barX+e,d.shapeType="path",d.shapeArgs={d:this.polarArc(d.yBottom,d.plotY,b,b+d.pointWidth)},this.toXY(d),d.tooltipPos=[d.plotX,d.plotY],d.ttBelow=d.plotY>a.center[1]}),m(n,"alignDataLabel",function(a,c,l,g,d,f){this.chart.polar?
	(a=c.rectPlotX/Math.PI*180,null===g.align&&(g.align=20<a&&160>a?"left":200<a&&340>a?"right":"center"),null===g.verticalAlign&&(g.verticalAlign=45>a||315<a?"bottom":135<a&&225>a?"top":"middle"),e.alignDataLabel.call(this,c,l,g,d,f)):a.call(this,c,l,g,d,f)}));m(k,"getCoordinates",function(a,c){var b=this.chart,e={xAxis:[],yAxis:[]};b.polar?v(b.axes,function(a){var d=a.isXAxis,g=a.center,k=c.chartX-g[0]-b.plotLeft,g=c.chartY-g[1]-b.plotTop;e[d?"xAxis":"yAxis"].push({axis:a,value:a.translate(d?Math.PI-
	Math.atan2(k,g):Math.sqrt(Math.pow(k,2)+Math.pow(g,2)),!0)})}):e=a.call(this,c);return e});m(a.Chart.prototype,"getAxes",function(b){this.pane||(this.pane=[]);v(a.splat(this.options.pane),function(b){new a.Pane(b,this)},this);b.call(this)});m(a.Chart.prototype,"drawChartBox",function(a){a.call(this);v(this.pane,function(a){a.render()})});m(a.Chart.prototype,"get",function(b,c){return a.find(this.pane,function(a){return a.options.id===c})||b.call(this,c)})})(x)});


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Highcharts JS v7.2.2 (2020-08-24)
	
	 Exporting module
	
	 (c) 2010-2019 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(f){"object"===typeof module&&module.exports?(f["default"]=f,module.exports=f): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32)], __WEBPACK_AMD_DEFINE_RESULT__ = function(k){f(k);f.Highcharts=k;return f}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):f("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(f){function k(g,e,f,H){g.hasOwnProperty(e)||(g[e]=H.apply(null,f))}f=f?f._modules:{};k(f,"modules/full-screen.src.js",[f["parts/Globals.js"]],function(g){(g.FullScreen=function(e){this.init(e.parentNode)}).prototype=
	{init:function(e){var g;e.requestFullscreen?g=e.requestFullscreen():e.mozRequestFullScreen?g=e.mozRequestFullScreen():e.webkitRequestFullscreen?g=e.webkitRequestFullscreen():e.msRequestFullscreen&&(g=e.msRequestFullscreen());if(g)g["catch"](function(){alert("Full screen is not supported inside a frame")})}}});k(f,"mixins/navigation.js",[],function(){return{initUpdate:function(g){g.navigation||(g.navigation={updates:[],update:function(g,f){this.updates.forEach(function(e){e.update.call(e.context,g,
	f)})}})},addUpdate:function(g,e){e.navigation||this.initUpdate(e);e.navigation.updates.push({update:g,context:e})}}});k(f,"modules/exporting.src.js",[f["parts/Globals.js"],f["parts/Utilities.js"],f["mixins/navigation.js"]],function(g,e,f){var k=e.discardElement,t=e.extend,I=e.isObject,C=e.objectEach,r=e.pick;e=g.defaultOptions;var w=g.doc,A=g.Chart,x=g.addEvent,J=g.removeEvent,B=g.fireEvent,v=g.createElement,n=g.css,p=g.merge,K=g.isTouchDevice,y=g.win,F=y.navigator.userAgent,D=g.SVGRenderer,G=g.Renderer.prototype.symbols,
	L=/Edge\/|Trident\/|MSIE /.test(F),M=/firefox/i.test(F);t(e.lang,{viewFullscreen:"View in full screen",printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});e.navigation||(e.navigation={});p(!0,e.navigation,{buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}});
	p(!0,e.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",color:"#333333",background:"none",fontSize:K?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{padding:5}}});e.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",
	menuClassName:"highcharts-contextmenu",symbol:"menu",titleKey:"contextButtonTitle",menuItems:"viewFullscreen printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")}},menuItemDefinitions:{viewFullscreen:{textKey:"viewFullscreen",onclick:function(){this.fullscreen=new g.FullScreen(this.container)}},printChart:{textKey:"printChart",onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",
	onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",onclick:function(){this.exportChart({type:"image/svg+xml"})}}}};g.post=function(a,b,c){var d=v("form",p({method:"post",action:a,enctype:"multipart/form-data"},c),{display:"none"},w.body);C(b,function(b,a){v("input",{type:"hidden",name:a,value:b},null,d)});d.submit();k(d)};t(A.prototype,{sanitizeSVG:function(a,
	b){var c=a.indexOf("</svg>")+6,d=a.substr(c);a=a.substr(0,c);b&&b.exporting&&b.exporting.allowHTML&&d&&(d='<foreignObject x="0" y="0" width="'+b.chart.width+'" height="'+b.chart.height+'"><body xmlns="http://www.w3.org/1999/xhtml">'+d+"</body></foreignObject>",a=a.replace("</svg>",d+"</svg>"));a=a.replace(/zIndex="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(.*?)("|&quot;);?\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,
	'<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+:)href=/g," xlink:href=").replace(/\n/," ").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g,"\u00a0").replace(/&shy;/g,"\u00ad");this.ieSanitizeSVG&&(a=this.ieSanitizeSVG(a));return a},getChartHTML:function(){this.styledMode&&this.inlineStyles();return this.container.innerHTML},getSVG:function(a){var b,c=p(this.options,a);c.plotOptions=p(this.userOptions.plotOptions,
	a&&a.plotOptions);c.time=p(this.userOptions.time,a&&a.time);var d=v("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},w.body);var e=this.renderTo.style.width;var q=this.renderTo.style.height;e=c.exporting.sourceWidth||c.chart.width||/px$/.test(e)&&parseInt(e,10)||(c.isGantt?800:600);q=c.exporting.sourceHeight||c.chart.height||/px$/.test(q)&&parseInt(q,10)||400;t(c.chart,{animation:!1,renderTo:d,forExport:!0,renderer:"SVGRenderer",width:e,height:q});
	c.exporting.enabled=!1;delete c.data;c.series=[];this.series.forEach(function(a){b=p(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});b.isInternal||c.series.push(b)});this.axes.forEach(function(a){a.userOptions.internalKey||(a.userOptions.internalKey=g.uniqueKey())});var f=new g.Chart(c,this.callback);a&&["xAxis","yAxis","series"].forEach(function(b){var d={};a[b]&&(d[b]=a[b],f.update(d))});this.axes.forEach(function(b){var a=g.find(f.axes,function(a){return a.options.internalKey===
	b.userOptions.internalKey}),d=b.getExtremes(),c=d.userMin;d=d.userMax;a&&(void 0!==c&&c!==a.min||void 0!==d&&d!==a.max)&&a.setExtremes(c,d,!0,!1)});e=f.getChartHTML();B(this,"getSVG",{chartCopy:f});e=this.sanitizeSVG(e,c);c=null;f.destroy();k(d);return e},getSVGForExport:function(a,b){var c=this.options.exporting;return this.getSVG(p({chart:{borderRadius:0}},c.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||c.sourceWidth,sourceHeight:a&&a.sourceHeight||c.sourceHeight}}))},getFilename:function(){var a=
	this.userOptions.title&&this.userOptions.title.text,b=this.options.exporting.filename;if(b)return b;"string"===typeof a&&(b=a.toLowerCase().replace(/<\/?[^>]+(>|$)/g,"").replace(/[\s_]+/g,"-").replace(/[^a-z0-9\-]/g,"").replace(/^[\-]+/g,"").replace(/[\-]+/g,"-").substr(0,24).replace(/[\-]+$/g,""));if(!b||5>b.length)b="chart";return b},exportChart:function(a,b){b=this.getSVGForExport(a,b);a=p(this.options.exporting,a);g.post(a.url,{filename:a.filename||this.getFilename(),type:a.type,width:a.width||
	0,scale:a.scale,svg:b},a.formAttributes)},print:function(){function a(a){(b.fixedDiv?[b.fixedDiv,b.scrollingContainer]:[b.container]).forEach(function(b){a.appendChild(b)})}var b=this,c=[],d=w.body,e=d.childNodes,g=b.options.exporting.printMaxWidth,f;if(!b.isPrinting){b.isPrinting=!0;b.pointer.reset(null,0);B(b,"beforePrint");if(f=g&&b.chartWidth>g){var h=[b.options.chart.width,void 0,!1];b.setSize(g,void 0,!1)}[].forEach.call(e,function(a,b){1===a.nodeType&&(c[b]=a.style.display,a.style.display=
	"none")});a(d);setTimeout(function(){y.focus();y.print();setTimeout(function(){a(b.renderTo);[].forEach.call(e,function(a,b){1===a.nodeType&&(a.style.display=c[b]||"")});b.isPrinting=!1;f&&b.setSize.apply(b,h);B(b,"afterPrint")},1E3)},1)}},contextMenu:function(a,b,c,d,e,f,E){var h=this,q=h.options.navigation,p=h.chartWidth,z=h.chartHeight,m="cache-"+a,l=h[m],u=Math.max(e,f);if(!l){h.exportContextMenu=h[m]=l=v("div",{className:a},{position:"absolute",zIndex:1E3,padding:u+"px",pointerEvents:"auto"},
	h.fixedDiv||h.container);var k=v("div",{className:"highcharts-menu"},null,l);h.styledMode||n(k,t({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},q.menuStyle));l.hideMenu=function(){n(l,{display:"none"});E&&E.setState(0);h.openMenu=!1;n(h.renderTo,{overflow:"hidden"});g.clearTimeout(l.hideTimer);B(h,"exportMenuHidden")};h.exportEvents.push(x(l,"mouseleave",function(){l.hideTimer=y.setTimeout(l.hideMenu,500)}),x(l,"mouseenter",function(){g.clearTimeout(l.hideTimer)}),
	x(w,"mouseup",function(b){h.pointer.inClass(b.target,a)||l.hideMenu()}),x(l,"click",function(){h.openMenu&&l.hideMenu()}));b.forEach(function(a){"string"===typeof a&&(a=h.options.exporting.menuItemDefinitions[a]);if(I(a,!0)){if(a.separator)var b=v("hr",null,null,k);else b=v("div",{className:"highcharts-menu-item",onclick:function(b){b&&b.stopPropagation();l.hideMenu();a.onclick&&a.onclick.apply(h,arguments)},innerHTML:a.text||h.options.lang[a.textKey]},null,k),h.styledMode||(b.onmouseover=function(){n(this,
	q.menuItemHoverStyle)},b.onmouseout=function(){n(this,q.menuItemStyle)},n(b,t({cursor:"pointer"},q.menuItemStyle)));h.exportDivElements.push(b)}});h.exportDivElements.push(k,l);h.exportMenuWidth=l.offsetWidth;h.exportMenuHeight=l.offsetHeight}b={display:"block"};c+h.exportMenuWidth>p?b.right=p-c-e-u+"px":b.left=c-u+"px";d+f+h.exportMenuHeight>z&&"top"!==E.alignOptions.verticalAlign?b.bottom=z-d-u+"px":b.top=d+f-u+"px";n(l,b);n(h.renderTo,{overflow:""});h.openMenu=!0;B(h,"exportMenuShown")},addButton:function(a){var b=
	this,c=b.renderer,d=p(b.options.navigation.buttonOptions,a),e=d.onclick,g=d.menuItems,f=d.symbolSize||12;b.btnCount||(b.btnCount=0);b.exportDivElements||(b.exportDivElements=[],b.exportSVGElements=[]);if(!1!==d.enabled){var h=d.theme,k=h.states,n=k&&k.hover;k=k&&k.select;var z;b.styledMode||(h.fill=r(h.fill,"#ffffff"),h.stroke=r(h.stroke,"none"));delete h.states;e?z=function(a){a&&a.stopPropagation();e.call(b,a)}:g&&(z=function(a){a&&a.stopPropagation();b.contextMenu(m.menuClassName,g,m.translateX,
	m.translateY,m.width,m.height,m);m.setState(2)});d.text&&d.symbol?h.paddingLeft=r(h.paddingLeft,25):d.text||t(h,{width:d.width,height:d.height,padding:0});b.styledMode||(h["stroke-linecap"]="round",h.fill=r(h.fill,"#ffffff"),h.stroke=r(h.stroke,"none"));var m=c.button(d.text,0,0,z,h,n,k).addClass(a.className).attr({title:r(b.options.lang[d._titleKey||d.titleKey],"")});m.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;if(d.symbol){var l=c.symbol(d.symbol,d.symbolX-f/2,d.symbolY-f/2,
	f,f,{width:f,height:f}).addClass("highcharts-button-symbol").attr({zIndex:1}).add(m);b.styledMode||l.attr({stroke:d.symbolStroke,fill:d.symbolFill,"stroke-width":d.symbolStrokeWidth||1})}m.add(b.exportingGroup).align(t(d,{width:m.width,x:r(d.x,b.buttonOffset)}),!0,"spacingBox");b.buttonOffset+=(m.width+d.buttonSpacing)*("right"===d.align?-1:1);b.exportSVGElements.push(m,l)}},destroyExport:function(a){var b=a?a.target:this;a=b.exportSVGElements;var c=b.exportDivElements,d=b.exportEvents,e;a&&(a.forEach(function(a,
	d){a&&(a.onclick=a.ontouchstart=null,e="cache-"+a.menuClassName,b[e]&&delete b[e],b.exportSVGElements[d]=a.destroy())}),a.length=0);b.exportingGroup&&(b.exportingGroup.destroy(),delete b.exportingGroup);c&&(c.forEach(function(a,d){g.clearTimeout(a.hideTimer);J(a,"mouseleave");b.exportDivElements[d]=a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=null;k(a)}),c.length=0);d&&(d.forEach(function(a){a()}),d.length=0)}});D.prototype.inlineToAttributes="fill stroke strokeLinecap strokeLinejoin strokeWidth textAnchor x y".split(" ");
	D.prototype.inlineBlacklist=[/-/,/^(clipPath|cssText|d|height|width)$/,/^font$/,/[lL]ogical(Width|Height)$/,/perspective/,/TapHighlightColor/,/^transition/,/^length$/];D.prototype.unstyledElements=["clipPath","defs","desc"];A.prototype.inlineStyles=function(){function a(a){return a.replace(/([A-Z])/g,function(a,b){return"-"+b.toLowerCase()})}function b(c){function m(b,f){u=n=!1;if(g){for(q=g.length;q--&&!n;)n=g[q].test(f);u=!n}"transform"===f&&"none"===b&&(u=!0);for(q=e.length;q--&&!u;)u=e[q].test(f)||
	"function"===typeof b;u||x[f]===b&&"svg"!==c.nodeName||h[c.nodeName][f]===b||(-1!==d.indexOf(f)?c.setAttribute(a(f),b):l+=a(f)+":"+b+";")}var l="",u,n,q;if(1===c.nodeType&&-1===f.indexOf(c.nodeName)){var t=y.getComputedStyle(c,null);var x="svg"===c.nodeName?{}:y.getComputedStyle(c.parentNode,null);if(!h[c.nodeName]){k=r.getElementsByTagName("svg")[0];var v=r.createElementNS(c.namespaceURI,c.nodeName);k.appendChild(v);h[c.nodeName]=p(y.getComputedStyle(v,null));"text"===c.nodeName&&delete h.text.fill;
	k.removeChild(v)}if(M||L)for(var w in t)m(t[w],w);else C(t,m);l&&(t=c.getAttribute("style"),c.setAttribute("style",(t?t+";":"")+l));"svg"===c.nodeName&&c.setAttribute("stroke-width","1px");"text"!==c.nodeName&&[].forEach.call(c.children||c.childNodes,b)}}var c=this.renderer,d=c.inlineToAttributes,e=c.inlineBlacklist,g=c.inlineWhitelist,f=c.unstyledElements,h={},k;c=w.createElement("iframe");n(c,{width:"1px",height:"1px",visibility:"hidden"});w.body.appendChild(c);var r=c.contentWindow.document;r.open();
	r.write('<svg xmlns="http://www.w3.org/2000/svg"></svg>');r.close();b(this.container.querySelector("svg"));k.parentNode.removeChild(k)};G.menu=function(a,b,c,d){return["M",a,b+2.5,"L",a+c,b+2.5,"M",a,b+d/2+.5,"L",a+c,b+d/2+.5,"M",a,b+d-1.5,"L",a+c,b+d-1.5]};G.menuball=function(a,b,c,d){a=[];d=d/3-2;return a=a.concat(this.circle(c-d,b,d,d),this.circle(c-d,b+d+4,d,d),this.circle(c-d,b+2*(d+4),d,d))};A.prototype.renderExporting=function(){var a=this,b=a.options.exporting,c=b.buttons,d=a.isDirtyExporting||
	!a.exportSVGElements;a.buttonOffset=0;a.isDirtyExporting&&a.destroyExport();d&&!1!==b.enabled&&(a.exportEvents=[],a.exportingGroup=a.exportingGroup||a.renderer.g("exporting-group").attr({zIndex:3}).add(),C(c,function(b){a.addButton(b)}),a.isDirtyExporting=!1);x(a,"destroy",a.destroyExport)};x(A,"init",function(){var a=this;a.exporting={update:function(b,c){a.isDirtyExporting=!0;p(!0,a.options.exporting,b);r(c,!0)&&a.redraw()}};f.addUpdate(function(b,c){a.isDirtyExporting=!0;p(!0,a.options.navigation,
	b);r(c,!0)&&a.redraw()},a)});A.prototype.callbacks.push(function(a){a.renderExporting();x(a,"redraw",a.renderExporting)})});k(f,"masters/modules/exporting.src.js",[],function(){})});
	//# sourceMappingURL=exporting.js.map

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Highcharts JS v7.2.2 (2020-08-24)
	
	 Plugin for displaying a message when there is no data visible in chart.
	
	 (c) 2010-2019 Highsoft AS
	 Author: Oystein Moseng
	
	 License: www.highcharts.com/license
	*/
	(function(a){"object"===typeof module&&module.exports?(a["default"]=a,module.exports=a): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32)], __WEBPACK_AMD_DEFINE_RESULT__ = function(c){a(c);a.Highcharts=c;return a}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):a("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(a){function c(a,d,c,e){a.hasOwnProperty(d)||(a[d]=e.apply(null,c))}a=a?a._modules:{};c(a,"modules/no-data-to-display.src.js",[a["parts/Globals.js"],a["parts/Utilities.js"]],function(a,d){var c=d.extend;d=a.Chart.prototype;
	var e=a.getOptions();c(e.lang,{noData:"No data to display"});e.noData={position:{x:0,y:0,align:"center",verticalAlign:"middle"},style:{fontWeight:"bold",fontSize:"12px",color:"#666666"}};d.showNoData=function(a){var b=this.options;a=a||b&&b.lang.noData;b=b&&b.noData;!this.noDataLabel&&this.renderer&&(this.noDataLabel=this.renderer.label(a,0,0,null,null,null,b.useHTML,null,"no-data"),this.styledMode||this.noDataLabel.attr(b.attr).css(b.style),this.noDataLabel.add(),this.noDataLabel.align(c(this.noDataLabel.getBBox(),
	b.position),!1,"plotBox"))};d.hideNoData=function(){this.noDataLabel&&(this.noDataLabel=this.noDataLabel.destroy())};d.hasData=function(){for(var a=this.series||[],b=a.length;b--;)if(a[b].hasData()&&!a[b].options.isInternal)return!0;return this.loadingShown};a.addEvent(a.Chart,"render",function(){this.hasData()?this.hideNoData():this.showNoData()})});c(a,"masters/modules/no-data-to-display.src.js",[],function(){})});
	//# sourceMappingURL=no-data-to-display.js.map

/***/ },
/* 299 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 300 */
/***/ function(module, exports) {

	module.exports = "<highchart id=chart1 config=$ctrl.chartOptions></highchart>";

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var seasonal_frequency_manager_controller_1 = __webpack_require__(302);
	__webpack_require__(303);
	var template = __webpack_require__(304);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    bindings: {
	        forecastTypes: '=',
	        onSeasonalFrequencyChange: '&',
	        isDisabled: '<',
	        isInsideOrgSetupWizard: '<'
	    },
	    controller: seasonal_frequency_manager_controller_1.default,
	    template: template
	};


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var SeasonalFrequencyManagerController = (function () {
	    function SeasonalFrequencyManagerController(organizationApi, $mdDialog, $translate, $window) {
	        this.organizationApi = organizationApi;
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.$window = $window;
	        this.forecastTypes = [];
	        this.seasonalFrequencySettings = {
	            issueDate: new Date,
	            targetPeriodStart: new Date,
	            targetPeriodEnd: new Date,
	            name: '',
	            frequency: 'seasonal'
	        };
	        this.isSettingsEditorVisible = false;
	        this.isEditMode = false;
	        this.isInsideOrgSetupWizard = true;
	        if (typeof this.isDisabled === 'undefined') {
	            this.isDisabled = false;
	        }
	    }
	    SeasonalFrequencyManagerController.prototype.onAddFrequency = function ($event) {
	        this.isSettingsEditorVisible = true;
	    };
	    SeasonalFrequencyManagerController.prototype.onSaveClick = function () {
	        if (this.isEditMode) {
	            this.forecastTypes[this.editableFrequencyIndex] = this.seasonalFrequencySettings;
	        }
	        else {
	            this.forecastTypes.push(this.seasonalFrequencySettings);
	        }
	        this.notifyChange();
	        this.resetFrequencySettings();
	        this.isSettingsEditorVisible = false;
	        this.isEditMode = false;
	    };
	    SeasonalFrequencyManagerController.prototype.onCancelClick = function () {
	        this.resetFrequencySettings();
	        this.isSettingsEditorVisible = false;
	        this.isEditMode = false;
	    };
	    SeasonalFrequencyManagerController.prototype.onEditFrequency = function ($event, frequency, index) {
	        this.seasonalFrequencySettings = angular.copy(frequency);
	        this.isSettingsEditorVisible = true;
	        this.isEditMode = true;
	        this.editableFrequencyIndex = index;
	        this.seasonalFrequencySettings.issueDate = new Date(moment(this.seasonalFrequencySettings.issueDate).format());
	        this.seasonalFrequencySettings.targetPeriodStart = new Date(moment(this.seasonalFrequencySettings.targetPeriodStart).format());
	        this.seasonalFrequencySettings.targetPeriodEnd = new Date(moment(this.seasonalFrequencySettings.targetPeriodEnd).format());
	    };
	    SeasonalFrequencyManagerController.prototype.resetFrequencySettings = function () {
	        this.seasonalFrequencySettings = {
	            issueDate: new Date,
	            targetPeriodStart: new Date,
	            targetPeriodEnd: new Date,
	            name: '',
	            frequency: 'seasonal'
	        };
	    };
	    SeasonalFrequencyManagerController.prototype.onDeleteFrequency = function ($event, index) {
	        var _this = this;
	        var self = this;
	        var currentOrgId = parseInt(this.$window.localStorage.getItem('currentOrgId'), 10);
	        if (this.isInsideOrgSetupWizard) {
	            this.forecastTypes.splice(index, 1);
	        }
	        else {
	            var confirm_1 = this.$mdDialog.confirm()
	                .title('')
	                .textContent(this.$translate.instant('DELETE_CONFIRMATION', { item: self.forecastTypes[index].name }))
	                .targetEvent($event)
	                .ok(this.$translate.instant('DELETE'))
	                .cancel(this.$translate.instant('CANCEL'));
	            this.$mdDialog.show(confirm_1).then(function () {
	                if (self.forecastTypes[index].id) {
	                    _this.organizationApi.deleteForecastType(currentOrgId, self.forecastTypes[index])
	                        .then(function () {
	                        _this.forecastTypes.splice(index, 1);
	                    });
	                }
	                else {
	                    _this.forecastTypes.splice(index, 1);
	                }
	            });
	        }
	    };
	    SeasonalFrequencyManagerController.prototype.notifyChange = function () {
	        this.onSeasonalFrequencyChange({ seasonalFrequencies: this.forecastTypes });
	    };
	    SeasonalFrequencyManagerController.$inject = ['organizationApi', '$mdDialog', '$translate', '$window'];
	    return SeasonalFrequencyManagerController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = SeasonalFrequencyManagerController;


/***/ },
/* 303 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 304 */
/***/ function(module, exports) {

	module.exports = "<div layout=row> <div flex=40 layout-padding> <div layout=row layout-align=\"space-between center\"> <label translate>SEASONAL</label> <md-button class=\"md-primary md-raised\" ng-click=$ctrl.onAddFrequency($event); ng-disabled=\"$ctrl.forecastTypes.length > 4 || $ctrl.isDisabled\"> <span translate>ADD</span> </md-button> </div> <md-content flex class=md-whiteframe-2dp layout=column layout-padding> <md-list flex> <md-list-item ng-repeat=\"type in $ctrl.forecastTypes\"> {{ type.name }} <span flex></span> <md-button class=md-icon-button ng-disabled=$ctrl.isDisabled ng-click=\"$ctrl.onEditFrequency($event, type, $index)\"> <md-icon>edit</md-icon> </md-button> <md-button class=md-icon-button ng-disabled=$ctrl.isDisabled ng-click=\"$ctrl.onDeleteFrequency($event, $index)\"> <md-icon>cancel</md-icon> </md-button> </md-list-item> </md-list> </md-content> </div> <md-content ng-if=\"!$ctrl.isDisabled && $ctrl.isSettingsEditorVisible\" flex class=md-whiteframe-2dp layout=column layout-padding> <form name=settingsForm> <div> <div layout=column class=md-dialog-content> <h2 class=md-title translate>SEASONAL_FREQUENCY_SETTINGS</h2> <md-input-container> <label translate>NAME</label> <input type=text name=name ng-model=$ctrl.seasonalFrequencySettings.name required> </md-input-container> <md-input-container> <label translate>ISSUE_DATE</label> <md-datepicker name=issueDate ng-model=$ctrl.seasonalFrequencySettings.issueDate required></md-datepicker> </md-input-container> <div layout=row> <md-input-container> <label translate>START_DATE</label> <md-datepicker name=targetPeriodStart ng-model=$ctrl.seasonalFrequencySettings.targetPeriodStart required></md-datepicker> </md-input-container> <md-input-container> <label translate>END_DATE</label> <md-datepicker name=targetPeriodEnd ng-model=$ctrl.seasonalFrequencySettings.targetPeriodEnd required></md-datepicker> </md-input-container> </div> </div> </div> <div layout=row layout-align=\"start center\"> <span><md-icon>error</md-icon></span><sup translate>YEAR_WILL_BE_IGNORED</sup> </div> <div layout=row layout-align=\"end center\"> <md-button ng-click=$ctrl.onCancelClick();> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.onSaveClick(); class=md-raised ng-disabled=settingsForm.$invalid> <span translate>ADD</span> </md-button> </div> </form> </md-content> </div>";

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var access_controller_1 = __webpack_require__(306);
	var template = __webpack_require__(307);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: access_controller_1.default,
	    template: template
	};


/***/ },
/* 306 */
/***/ function(module, exports) {

	"use strict";
	var UserManagementController = (function () {
	    function UserManagementController(organizationApi, $mdDialog, $translate, $scope) {
	        this.organizationApi = organizationApi;
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.$scope = $scope;
	        var self = this;
	        self.organizationListPromise = organizationApi.getOrganizations()
	            .then(function (data) {
	            self.organizationList = data;
	        });
	    }
	    UserManagementController.prototype.onVerifyClick = function (organization) {
	        var _this = this;
	        var confirm = this.$mdDialog.confirm()
	            .title('')
	            .textContent(this.$translate.instant('PAYMENT_VERIFICATION_CONFIRMATION', { organization: organization.organization }))
	            .ok(this.$translate.instant('VERIFY_PAYMENT'))
	            .cancel(this.$translate.instant('CANCEL'));
	        this.$mdDialog.show(confirm).then(function () {
	            _this.organizationApi.renewPayment(organization.id)
	                .then(function (organization) {
	                _this.organizationList.forEach(function (orgItem, index) {
	                    if (orgItem.id === organization.id) {
	                        _this.organizationList[index] = organization;
	                    }
	                });
	            });
	        });
	    };
	    UserManagementController.$inject = ['organizationApi', '$mdDialog', '$translate', '$scope'];
	    return UserManagementController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = UserManagementController;


/***/ },
/* 307 */
/***/ function(module, exports) {

	module.exports = "<section layout=row layout-fill> <md-card flex layout-padding> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span ng-hide=$ctrl.isUserSelected translate>ACCESS</span> </div> </md-toolbar> <md-table-container flex> <table md-table md-progress=$ctrl.organizationListPromise> <thead md-head> <tr md-row> <th md-column><span translate>ORGANIZATION</span></th> <th md-column><span translate>STATUS</span></th> <th md-column><span translate>ACTIVATE_OR_RENEW_SUBSCRIPTIONS</span></th> </tr> </thead> <tbody md-body> <tr md-row ui-sref=\"organization-details({id: organization.id})\" class=organization-item ng-repeat=\"organization in $ctrl.organizationList | orderBy:'organization'\"> <td md-cell>{{ organization.organization }}</td> <td md-cell> <span ng-if=organization.active><md-icon>check</md-icon> {{'ENABLED_UNTIL_DATE' | translate: {date: (organization.expiresAt | momentFormatter:'date')} }}</span> <span ng-if=\"!organization.active && organization.expiresAt\"><md-icon>close</md-icon><span translate>DISABLED</span></span> <span ng-if=\"!organization.active && organization.expiresAt === null\"><md-icon>hourglass_empty</md-icon><span translate>ACCESS_REQUESTED</span></span> </td> <td md-cell> <md-button class=\"md-primary md-raised\" ng-click=$ctrl.onVerifyClick(organization)> <span translate>VERIFY_PAYMENT</span> </md-button> </td> </tr> </tbody> </table> </md-table-container> </md-card> </section>";

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var cms_controller_1 = __webpack_require__(309);
	__webpack_require__(312);
	var template = __webpack_require__(313);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: cms_controller_1.default,
	    bindings: {
	        contentName: '<'
	    },
	    template: template
	};


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var cms_editor_dialog_controller_1 = __webpack_require__(310);
	var cmsEditorDialogTemplate = __webpack_require__(311);
	var CmsController = (function () {
	    function CmsController(cmsApi, $translate, $mdDialog, $rootScope, loginService) {
	        var _this = this;
	        this.cmsApi = cmsApi;
	        this.$translate = $translate;
	        this.$mdDialog = $mdDialog;
	        this.$rootScope = $rootScope;
	        this.loginService = loginService;
	        this.languageId = this.$translate.proposedLanguage();
	        this.loggedIn = loginService.isLoggedIn();
	        this.fetchContent();
	        this.$rootScope.$on('$translateChangeStart', function ($event, args) {
	            _this.cmsContentText = _this.getCmsContent(args.language);
	        });
	        loginService.onLoginStateChange(function (loggedIn) {
	            _this.loggedIn = loginService.isLoggedIn();
	            if (_this.loggedIn) {
	                _this.fetchContent();
	            }
	        });
	    }
	    CmsController.prototype.fetchContent = function () {
	        var _this = this;
	        this.cmsApi.getCmsContent(this.contentName)
	            .then(function (content) {
	            if (content && content.length) {
	                _this.cmsContent = content;
	            }
	            else {
	                _this.cmsContent = [
	                    {
	                        text: '',
	                        type: _this.contentName,
	                        language: 'en'
	                    },
	                    {
	                        text: '',
	                        type: _this.contentName,
	                        language: 'ru'
	                    }
	                ];
	            }
	            _this.cmsContentText = _this.getCmsContent(_this.languageId);
	        });
	    };
	    CmsController.prototype.getCmsContent = function (language) {
	        var cmsContent;
	        _.forEach(this.cmsContent, function (content) {
	            if (content.language == language) {
	                cmsContent = content;
	            }
	            ;
	        });
	        return cmsContent.text;
	    };
	    CmsController.prototype.onEditClick = function ($event) {
	        var _this = this;
	        this.$mdDialog.show({
	            targetEvent: $event,
	            template: cmsEditorDialogTemplate,
	            controller: cms_editor_dialog_controller_1.CmsEditorDialog,
	            bindToController: true,
	            controllerAs: '$ctrl',
	            locals: {
	                cmsContent: this.cmsContent
	            }
	        })
	            .then(function (cmsContent) {
	            _this.cmsApi.saveCmsContent(_this.contentName, cmsContent)
	                .then(function () {
	                _this.cmsContent = cmsContent;
	                _this.cmsContentText = _this.getCmsContent(_this.languageId);
	            });
	        });
	    };
	    CmsController.$inject = ['cmsApi', '$translate', '$mdDialog', '$rootScope', 'loginService'];
	    return CmsController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = CmsController;


/***/ },
/* 310 */
/***/ function(module, exports) {

	"use strict";
	var CmsEditorDialog = (function () {
	    function CmsEditorDialog($mdDialog) {
	        var _this = this;
	        this.$mdDialog = $mdDialog;
	        this.apply = function () {
	            _this.$mdDialog.hide(_this.cmsContent);
	        };
	        this.cancel = function () {
	            _this.$mdDialog.cancel();
	        };
	    }
	    CmsEditorDialog.$inject = ['$mdDialog'];
	    return CmsEditorDialog;
	}());
	exports.CmsEditorDialog = CmsEditorDialog;


/***/ },
/* 311 */
/***/ function(module, exports) {

	module.exports = "<md-dialog> <div layout-padding> <md-input-container ng-repeat=\"content in $ctrl.cmsContent\"> <label ng-if=\"content.language === 'en'\" translate>ENGLISH</label> <label ng-if=\"content.language === 'ru'\" translate>RUSSIAN</label> <textarea ng-model=content.text md-no-autogrow rows=7 style=width:500px></textarea> </md-input-container> </div> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply()> <span translate>SAVE</span> </md-button> </md-dialog-actions> </md-dialog>";

/***/ },
/* 312 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 313 */
/***/ function(module, exports) {

	module.exports = "<div class=cms-container layout=row layout-align=\"space-between top\"> <pre class=cms-formatted-text ng-if=$ctrl.cmsContentText>{{ $ctrl.cmsContentText }}</pre> <div ng-if=\"!$ctrl.cmsContentText && $ctrl.loggedIn\" user-permissions=\"['super_admin']\"><span translate>NO_CONTENT</span></div> <md-button class=\"md-icon-button cms-edit-button\" ng-click=$ctrl.onEditClick() user-permissions=\"['super_admin']\" ng-if=$ctrl.loggedIn> <md-icon>edit</md-icon> </md-button> </div>";

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var wizard_controller_1 = __webpack_require__(315);
	__webpack_require__(316);
	var template = __webpack_require__(317);
	var wizardComponent = {
	    bindings: {
	        title: "<",
	        currentStepIndex: '=',
	        stepsCount: '<',
	        nextButtonName: '<',
	        isNextPrevented: '<',
	        onNext: '&',
	        stepValidation: '&',
	        onFinish: '&',
	        onCancel: '&' // callback function executed on click on Cancel button
	    },
	    transclude: true,
	    controller: wizard_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = wizardComponent;


/***/ },
/* 315 */
/***/ function(module, exports) {

	"use strict";
	var WizardController = (function () {
	    function WizardController() {
	        this.onBackClick = function ($event, currentStepIndex) {
	            if (this.currentStepIndex > 0) {
	                this.currentStepIndex = this.currentStepIndex - 1;
	            }
	        };
	        this.onNextClick = function ($event, currentStepIndex) {
	            this.onNext();
	            if (!this.isNextPrevented) {
	                this.currentStepIndex = this.currentStepIndex + 1;
	            }
	        };
	        this.onFinishClick = function ($event) {
	            this.onFinish();
	        };
	        this.onCancelClick = function ($event) {
	            this.onCancel();
	        };
	    }
	    return WizardController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = WizardController;


/***/ },
/* 316 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 317 */
/***/ function(module, exports) {

	module.exports = "<div layout=column layout-fill> <md-toolbar ng-if=$ctrl.title> <div class=md-toolbar-tools> <h3> <span>{{$ctrl.title}}</span> </h3> </div> </md-toolbar> <md-content flex ng-transclude layout=column></md-content> <div layout=row class=wizard-actions-bar> <md-button ng-if=\"$ctrl.currentStepIndex != 0\" ng-click=\"$ctrl.onBackClick($event, $ctrl.currentStepIndex)\"> {{::'BACK' | translate}} </md-button> <div flex></div> <md-button ng-click=$ctrl.onCancelClick($event) ng-if=$ctrl.onCancel> {{::'CANCEL' | translate}} </md-button> <md-button ng-click=\"$ctrl.onNextClick($event, $ctrl.currentStepIndex)\" ng-if=\"$ctrl.currentStepIndex != $ctrl.stepsCount-1\" ng-disabled=\"!$ctrl.stepValidation({stepIndex: $ctrl.currentStepIndex})\" class=md-primary> <span ng-if=$ctrl.nextButtonName>{{ $ctrl.nextButtonName }}</span> <span ng-if=!$ctrl.nextButtonName>{{::'NEXT' | translate}}</span> </md-button> <md-button ng-click=\"$ctrl.onFinishClick($event, $ctrl.currentStepIndex)\" ng-if=\"$ctrl.currentStepIndex == $ctrl.stepsCount-1\" ng-disabled=\"!$ctrl.stepValidation({stepIndex: $ctrl.currentStepIndex})\" class=md-primary> {{::'FINISH' | translate}} </md-button> </div> </div>";

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var paginationControls_controller_1 = __webpack_require__(319);
	__webpack_require__(320);
	var template = __webpack_require__(321);
	var paginationControlsComponent = {
	    bindings: {
	        onPageChange: '&',
	        currentPage: '=',
	        count: '<',
	        pageSize: '<'
	    },
	    transclude: true,
	    controller: paginationControls_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = paginationControlsComponent;


/***/ },
/* 319 */
/***/ function(module, exports) {

	"use strict";
	var PaginationControlsController = (function () {
	    function PaginationControlsController($timeout) {
	        this.$timeout = $timeout;
	        this.setPageCount();
	    }
	    PaginationControlsController.prototype.$onChanges = function (changesObject) {
	        if (changesObject['count'] || changesObject['pageSize']) {
	            this.setPageCount();
	        }
	    };
	    ;
	    PaginationControlsController.prototype.onNextPageClick = function () {
	        this.currentPage++;
	        this.triggerOnChangeEvent();
	    };
	    ;
	    PaginationControlsController.prototype.onPrevPageClick = function () {
	        this.currentPage--;
	        this.triggerOnChangeEvent();
	    };
	    PaginationControlsController.prototype.onFirstPageClick = function () {
	        this.currentPage = 1;
	        this.triggerOnChangeEvent();
	    };
	    ;
	    PaginationControlsController.prototype.onLastPageClick = function () {
	        this.currentPage = this.pageCount;
	        this.triggerOnChangeEvent();
	    };
	    ;
	    PaginationControlsController.prototype.setPageCount = function () {
	        this.pageCount = Math.ceil(this.count / this.pageSize);
	    };
	    PaginationControlsController.prototype.triggerOnChangeEvent = function () {
	        var _this = this;
	        // triggered inside $timeout to put it in next digest cycle
	        // if triggered in the same digest cycle the parent component's two-way bind variables will not be updated in time
	        this.$timeout(function () {
	            _this.onPageChange({ page: _this.currentPage });
	        });
	    };
	    PaginationControlsController.$inject = ['$timeout'];
	    return PaginationControlsController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = PaginationControlsController;


/***/ },
/* 320 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 321 */
/***/ function(module, exports) {

	module.exports = "<div class=pagination-controls> <md-button ng-click=$ctrl.onFirstPageClick($event) ng-disabled=\"$ctrl.currentPage == 1\" class=\"md-primary md-raised md-icon-button\"> <md-icon>first_page</md-icon> <md-tooltip md-direction=top>{{::'FIRST_PAGE' | translate}}</md-tooltip> </md-button> <md-button ng-click=$ctrl.onPrevPageClick($event) ng-disabled=\"$ctrl.currentPage == 1\" class=\"md-primary md-raised md-icon-button\"> <md-icon>navigate_before</md-icon> <md-tooltip md-direction=top>{{::'PREVIOUS_PAGE' | translate}}</md-tooltip> </md-button> <span class=page-count>{{ $ctrl.currentPage }} / {{ $ctrl.pageCount }}</span> <md-button ng-click=$ctrl.onNextPageClick($event) ng-disabled=\"$ctrl.currentPage >= $ctrl.pageCount\" class=\"md-primary md-raised md-icon-button\"> <md-icon>navigate_next</md-icon> <md-tooltip md-direction=top>{{::'NEXT_PAGE' | translate}}</md-tooltip> </md-button> <md-button ng-click=$ctrl.onLastPageClick($event) ng-disabled=\"$ctrl.currentPage >= $ctrl.pageCount\" class=\"md-primary md-raised md-icon-button\"> <md-icon>last_page</md-icon> <md-tooltip md-direction=top>{{::'LAST_PAGE' | translate}}</md-tooltip> </md-button> </div>";

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var change_password_form_controller_1 = __webpack_require__(323);
	var template = __webpack_require__(324);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: change_password_form_controller_1.default,
	    bindings: {
	        changePasswordForm: '=',
	        changePasswordData: '='
	    },
	    template: template
	};


/***/ },
/* 323 */
/***/ function(module, exports) {

	"use strict";
	var ChangePasswordFormController = (function () {
	    function ChangePasswordFormController() {
	    }
	    return ChangePasswordFormController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ChangePasswordFormController;


/***/ },
/* 324 */
/***/ function(module, exports) {

	module.exports = "<form name=$ctrl.changePasswordForm> <div layout=column class=md-dialog-content> <md-input-container> <label translate>OLD_PASSWORD</label> <input type=password required name=oldPassword ng-model=$ctrl.changePasswordData.oldPassword> <div ng-messages=$ctrl.changePasswordForm.oldPassword.$error ng-show=$ctrl.changePasswordForm.oldPassword.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> </div> </md-input-container> <md-input-container> <label translate>NEW_PASSWORD</label> <input type=password required name=newPassword ng-model=$ctrl.changePasswordData.newPassword1 minlength=6 maxlength=72> <div ng-messages=$ctrl.changePasswordForm.newPassword.$error ng-show=$ctrl.changePasswordForm.newPassword.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> <div ng-message=maxlength translate> THE_VALUE_IS_TOO_LONG </div> <div ng-message=minlength translate> THE_VALUE_IS_TOO_SHORT </div> </div> </md-input-container> <md-input-container> <label translate>REPEAT_NEW_PASSWORD</label> <input type=password required name=repeatNewPassword ng-model=$ctrl.changePasswordData.newPassword2 minlength=6 maxlength=72> <div ng-messages=$ctrl.changePasswordForm.repeatNewPassword.$error ng-show=$ctrl.changePasswordForm.repeatNewPassword.$touched> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> <div ng-message=maxlength translate> THE_VALUE_IS_TOO_LONG </div> <div ng-message=minlength translate> THE_VALUE_IS_TOO_SHORT </div> </div> </md-input-container> <div layout=row ng-if=\"$ctrl.changePasswordData.newPassword1 !== $ctrl.changePasswordData.newPassword2\"> <md-icon class=md-warn>info_outline</md-icon><p flex>&nbsp;<span translate>PASSWORDS_NOT_MATCHING</span></p> </div> </div> </form>";

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var reporting_templates_controller_1 = __webpack_require__(326);
	// import './reporting-templates.css';
	var template = __webpack_require__(328);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: reporting_templates_controller_1.default,
	    template: template
	};


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var extensions_1 = __webpack_require__(327);
	var IDataFileState;
	(function (IDataFileState) {
	    IDataFileState[IDataFileState["Unselected"] = 0] = "Unselected";
	    IDataFileState[IDataFileState["Selected"] = 1] = "Selected";
	    IDataFileState[IDataFileState["Validating"] = 2] = "Validating";
	    IDataFileState[IDataFileState["Invalid"] = 3] = "Invalid";
	    IDataFileState[IDataFileState["Valid"] = 4] = "Valid";
	})(IDataFileState || (IDataFileState = {}));
	var ReportingTemplatesController = (function () {
	    function ReportingTemplatesController(organizationApi, Upload, $translate, imomoErrorService, $stateParams) {
	        var _this = this;
	        this.organizationApi = organizationApi;
	        this.Upload = Upload;
	        this.$translate = $translate;
	        this.imomoErrorService = imomoErrorService;
	        this.$stateParams = $stateParams;
	        this.decadalBulletinDataFileState = IDataFileState.Unselected;
	        this.dailyBulletinDataFileState = IDataFileState.Unselected;
	        this.showDailyTags = false;
	        this.showDecadalTags = false;
	        this.isLoading = false;
	        this.onDecadalTemplateDataFileChange = function (files) {
	            if (files && files[0]) {
	                _this.decadalBulletinDataFile = files[0];
	                _this.decadalBulletinDataFileState = IDataFileState.Selected;
	            }
	            else {
	                _this.decadalBulletinDataFileState = IDataFileState.Unselected;
	                _this.decadalBulletinDataFile = null;
	            }
	        };
	        this.onDailyTemplateDataFileChange = function (files) {
	            if (files && files[0]) {
	                _this.dailyBulletinDataFile = files[0];
	                _this.dailyBulletinDataFileState = IDataFileState.Selected;
	            }
	            else {
	                _this.dailyBulletinDataFileState = IDataFileState.Unselected;
	                _this.dailyBulletinDataFile = null;
	            }
	        };
	        this.organizationApi.getReportingTemplateTags('daily_bulletin')
	            .then(function (tags) {
	            _this.dailyBulletintemplateTags = tags;
	        });
	        this.organizationApi.getReportingTemplateTags('decadal_bulletin')
	            .then(function (tags) {
	            _this.decadalBulletintemplateTags = tags;
	        });
	        this.organizationApi.getReportingTemplateDefault('daily_bulletin')
	            .then(function (url) {
	            _this.dailyBulletinTemplateUrl = url;
	        });
	        this.organizationApi.getReportingTemplateDefault('decadal_bulletin')
	            .then(function (url) {
	            _this.decadalBulletinTemplateUrl = url;
	        });
	        if (this.$stateParams.id !== 'new') {
	            this.fetchCurrentDailyTemplate();
	            this.fetchCurrentDecadalTemplate();
	        }
	    }
	    Object.defineProperty(ReportingTemplatesController.prototype, "excelMimeTypes", {
	        get: function () {
	            return extensions_1.EXCEL_MIME_TYPES;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ReportingTemplatesController.prototype, "isDecadalBulletinDataFileUnselected", {
	        get: function () {
	            return this.decadalBulletinDataFileState == IDataFileState.Unselected;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ReportingTemplatesController.prototype, "isDailyBulletinDataFileUnselected", {
	        get: function () {
	            return this.dailyBulletinDataFileState == IDataFileState.Unselected;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ReportingTemplatesController.prototype.fetchCurrentDailyTemplate = function () {
	        var _this = this;
	        this.organizationApi.getReportingTemplate('daily_bulletin')
	            .then(function (data) {
	            _this.dailyBulletinTemplateUrlCurrent = data.templateUrl;
	        });
	    };
	    ReportingTemplatesController.prototype.fetchCurrentDecadalTemplate = function () {
	        var _this = this;
	        this.organizationApi.getReportingTemplate('decadal_bulletin')
	            .then(function (data) {
	            _this.decadalBulletinTemplateUrlCurrent = data.templateUrl;
	        });
	    };
	    ReportingTemplatesController.prototype.onUploadTemplate = function (reportType) {
	        var _this = this;
	        var language = this.$translate.proposedLanguage();
	        this.isLoading = true;
	        if (reportType === 'daily_bulletin') {
	            this.Upload.base64DataUrl(this.dailyBulletinDataFile)
	                .then(function (base64String) {
	                _this.organizationApi.saveReportingTemplate('daily_bulletin', {
	                    language: language,
	                    templateFileBase64: base64String
	                }).then(function () {
	                    _this.dailyBulletinDataFileState = IDataFileState.Unselected;
	                    _this.dailyBulletinDataFile = null;
	                    _this.dailyBulletinTemplateError = null;
	                    _this.isLoading = false;
	                    _this.fetchCurrentDailyTemplate();
	                }).catch(function (error) {
	                    //this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                    _this.dailyBulletinTemplateError = error.data.details;
	                    _this.isLoading = false;
	                });
	            });
	        }
	        else if (reportType === 'decadal_bulletin') {
	            this.Upload.base64DataUrl(this.decadalBulletinDataFile)
	                .then(function (base64String) {
	                _this.organizationApi.saveReportingTemplate('decadal_bulletin', {
	                    language: language,
	                    templateFileBase64: base64String
	                }).then(function () {
	                    _this.decadalBulletinDataFileState = IDataFileState.Unselected;
	                    _this.decadalBulletinDataFile = null;
	                    _this.decadalBulletinTemplateError = null;
	                    _this.isLoading = false;
	                    _this.fetchCurrentDecadalTemplate();
	                }).catch(function (error) {
	                    //this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                    _this.decadalBulletinTemplateError = error.data.details;
	                    _this.isLoading = false;
	                });
	            });
	        }
	    };
	    ReportingTemplatesController.prototype.onDeleteTemplate = function (reportType) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationApi.deleteReportingTemplate(reportType)
	            .then(function () {
	            if (reportType === 'daily_bulletin') {
	                _this.dailyBulletinTemplateUrlCurrent = null;
	            }
	            if (reportType === 'decadal_bulletin') {
	                _this.decadalBulletinTemplateUrlCurrent = null;
	            }
	            _this.isLoading = false;
	        })
	            .finally(function () {
	            _this.isLoading = false;
	        });
	    };
	    ReportingTemplatesController.$inject = ['organizationApi', 'Upload', '$translate', 'imomoErrorService', '$stateParams'];
	    return ReportingTemplatesController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ReportingTemplatesController;


/***/ },
/* 327 */
/***/ function(module, exports) {

	"use strict";
	exports.EXCEL_MIME_TYPES = [
	    'application/vnd.ms-excel',
	    'application/msexcel',
	    'application/x-msexcel',
	    'application/x-ms-excel',
	    'application/x-excel',
	    'application/x-dos_ms_excel',
	    'application/xls',
	    'application/x-xls',
	    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
	].join(',');
	exports.JSON_MIME_TYPE = ['application/json', 'application/geo+json'].join(',');


/***/ },
/* 328 */
/***/ function(module, exports) {

	module.exports = "<md-progress-linear md-mode=indeterminate ng-disabled=!$ctrl.isLoading> </md-progress-linear> <section layout-padding> <div layout=row flex> <span translate class=md-title>DAILY_BULLETIN</span> <span flex></span> <md-button class=\"md-raised md-warn\" ng-click=\"$ctrl.onDeleteTemplate('daily_bulletin')\" ng-disabled=!$ctrl.dailyBulletinTemplateUrlCurrent> <span translate>DELETE</span> </md-button> <form name=dailyTemplateDataFileForm layout=row layout-align=\"start center\"> <md-button ngf-select ngf-multiple=false class=md-raised ng-model=$ctrl.dailyBulletinDataFile ngf-change=$ctrl.onDailyTemplateDataFileChange($files) ngf-pattern=$ctrl.excelMimeTypes ngf-accept=$ctrl.excelMimeTypes required ng-class=\"{'md-accent': $ctrl.isDailyBulletinDataFileUnselected}\"> <span ng-show=$ctrl.isDailyBulletinDataFileUnselected translate> SELECT_FILE </span> <span ng-hide=$ctrl.isDailyBulletinDataFileUnselected translate> CHANGE </span> </md-button> </form> <md-button ng-if=$ctrl.dailyBulletinDataFile class=\"md-raised md-primary\" ng-click=\"$ctrl.onUploadTemplate('daily_bulletin')\"> <span translate>UPLOAD</span> </md-button> </div> <md-content> <div layout=row layout-align=\"space-between center\"> <span class=md-title translate>TEMPLATE_TAGS</span> <md-button class=md-icon-button ng-if=!$ctrl.showDailyTags ng-click=\"$ctrl.showDailyTags = true\"> <md-icon>expand_more</md-icon> </md-button> <md-button class=md-icon-button ng-if=$ctrl.showDailyTags ng-click=\"$ctrl.showDailyTags = false\"> <md-icon>expand_less</md-icon> </md-button> </div> <div ng-if=$ctrl.showDailyTags ng-repeat=\"(key, tags) in $ctrl.dailyBulletintemplateTags\" layout-padding> <h3>{{key}}</h3> <div ng-repeat=\"tag in tags\" layout-padding> <div><strong>{{ tag.tag }}</strong></div> <div> {{ tag.description }} </div> </div> </div> </md-content> <div layout=row> <span flex></span> <md-button class=md-raised ng-href={{$ctrl.dailyBulletinTemplateUrl}} download=daily-bulletin-default-template.xlsx ng-disabled=!$ctrl.dailyBulletinTemplateUrl> <span translate>DEFAULT_TEMPLATE</span> </md-button> <md-button class=\"md-raised md-primary\" ng-href={{$ctrl.dailyBulletinTemplateUrlCurrent}} download=daily-bulletin-current-template.xlsx ng-disabled=!$ctrl.dailyBulletinTemplateUrlCurrent> <span translate>CURRENT_TEMPLATE</span> </md-button> </div> <sub style=color:red>{{ $ctrl.dailyBulletinTemplateError}}</sub> <br> <md-divider></md-divider> <br> <div layout=row flex> <span translate class=md-title>DECADAL_BULLETIN</span> <span flex></span> <md-button class=\"md-raised md-warn\" ng-click=\"$ctrl.onDeleteTemplate('decadal_bulletin')\" ng-disabled=!$ctrl.decadalBulletinTemplateUrlCurrent> <span translate>DELETE</span> </md-button> <form name=decadalTemplateDataFileForm layout=row layout-align=\"start center\"> <md-button ngf-select ngf-multiple=false class=md-raised ng-model=$ctrl.decadalBulletinDataFile ngf-change=$ctrl.onDecadalTemplateDataFileChange($files) ngf-pattern=$ctrl.excelMimeTypes ngf-accept=$ctrl.excelMimeTypes required ng-class=\"{'md-accent': $ctrl.isDecadalBulletinDataFileUnselected}\"> <span ng-show=$ctrl.isDecadalBulletinDataFileUnselected translate> SELECT_FILE </span> <span ng-hide=$ctrl.isDecadalBulletinDataFileUnselected translate> CHANGE </span> </md-button> </form> <md-button ng-if=$ctrl.decadalBulletinDataFile class=\"md-raised md-primary\" ng-click=\"$ctrl.onUploadTemplate('decadal_bulletin')\"> <span translate>UPLOAD</span> </md-button> </div> <md-content> <div layout=row layout-align=\"space-between center\"> <span class=md-title translate>TEMPLATE_TAGS</span> <md-button class=md-icon-button ng-if=!$ctrl.showDecadalTags ng-click=\"$ctrl.showDecadalTags = true\"> <md-icon>expand_more</md-icon> </md-button> <md-button class=md-icon-button ng-if=$ctrl.showDecadalTags ng-click=\"$ctrl.showDecadalTags = false\"> <md-icon>expand_less</md-icon> </md-button> </div> <div ng-if=$ctrl.showDecadalTags ng-repeat=\"(key, tags) in $ctrl.decadalBulletintemplateTags\" layout-padding> <h3>{{key}}</h3> <div ng-repeat=\"tag in tags\" layout-padding> <div><strong>{{ tag.tag }}</strong></div> <div> {{ tag.description }} </div> </div> </div> </md-content> <div layout=row> <span flex></span> <md-button class=md-raised ng-href={{$ctrl.decadalBulletinTemplateUrl}} download=decadal-bulletin-default-template.xlsx ng-disabled=!$ctrl.decadalBulletinTemplateUrl> <span translate>DEFAULT_TEMPLATE</span> </md-button> <md-button class=\"md-raised md-primary\" ng-href={{$ctrl.decadalBulletinTemplateUrlCurrent}} download=decadal-bulletin-current-template.xlsx ng-disabled=!$ctrl.decadalBulletinTemplateUrlCurrent> <span translate>CURRENT_TEMPLATE</span> </md-button> </div> <sub style=color:red>{{ $ctrl.decadalBulletinTemplateError}}</sub> <br> <md-divider></md-divider> <br> <div layout=row layout-align=\"start center\"> <span><md-icon>error</md-icon></span><sup translate>MIN_TEMPLATE_TAG_NOTE</sup> </div> </section>";

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var login_component_1 = __webpack_require__(330);
	var login_card_component_1 = __webpack_require__(333);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.login', [])
	    .component('imomoLogin', login_component_1.default)
	    .component('imomoLoginCard', login_card_component_1.default)
	    .name;


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(331);
	var template = __webpack_require__(332);
	exports.loginComponent = {
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = exports.loginComponent;


/***/ },
/* 331 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 332 */
/***/ function(module, exports) {

	module.exports = "<div class=login-container layout=column layout-align=\"center center\"> <imomo-login-card></imomo-login-card> </div>";

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var login_card_controller_1 = __webpack_require__(334);
	var template = __webpack_require__(341);
	exports.loginCardComponent = {
	    controller: login_card_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = exports.loginCardComponent;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var login_service_1 = __webpack_require__(194);
	var request_access_dialog_controller_1 = __webpack_require__(335);
	var request_reset_password_dialog_controller_1 = __webpack_require__(336);
	var app_setup_dialog_controller_1 = __webpack_require__(337);
	var organization_controller_1 = __webpack_require__(253);
	var requestResetPasswordDialogTemplate = __webpack_require__(339);
	var requestAccessDialogTemplate = __webpack_require__(340);
	var appSetupDialogTemplate = __webpack_require__(338);
	var LoginCardController = (function () {
	    function LoginCardController(loginService, $state, $log, $translate, $window, $mdDialog, userApi, requestAccessApi, $rootScope, organizationApi, imomoErrorService) {
	        this.loginService = loginService;
	        this.$state = $state;
	        this.$log = $log;
	        this.$translate = $translate;
	        this.$window = $window;
	        this.$mdDialog = $mdDialog;
	        this.userApi = userApi;
	        this.requestAccessApi = requestAccessApi;
	        this.$rootScope = $rootScope;
	        this.organizationApi = organizationApi;
	        this.imomoErrorService = imomoErrorService;
	        this.loginDetails = {
	            username: null,
	            password: null
	        };
	        this.logInInProgress = false;
	    }
	    LoginCardController.prototype.logIn = function () {
	        var _this = this;
	        this.logInInProgress = true;
	        this.loginErrorMessage = null;
	        this.loginService.logInUser(this.loginDetails.username, this.loginDetails.password).then(function () {
	            _this.$rootScope.$broadcast(login_service_1.ILoginService.LOGIN_EVENT_NAME);
	            _this.userApi.getCurrentUser()
	                .then(function (data) {
	                _this.$window.localStorage.setItem('currentOrgId', data.sourceId);
	                _this.$rootScope.$broadcast(organization_controller_1.IOrganizationEvents.ORGANIZATION_CHANGE);
	                _this.organizationApi.getOrganization(data.sourceId)
	                    .then(function (data) {
	                    if (data.setupFinished) {
	                        _this.$state.go('home');
	                    }
	                    else {
	                        _this.$mdDialog.show({
	                            template: appSetupDialogTemplate,
	                            controller: app_setup_dialog_controller_1.AppSetupDialog,
	                            bindToController: true,
	                            controllerAs: '$ctrl'
	                        }).then(function () {
	                        });
	                    }
	                });
	            });
	        }).catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(_this.$translate.instant('USERNAME_OR_PASSWORD_WRONG'));
	            if (error.data) {
	                _this.onLoginError(error.data);
	            }
	        }).finally(function () {
	            _this.logInInProgress = false;
	        });
	    };
	    ;
	    LoginCardController.prototype.requestAccess = function ($event) {
	        var _this = this;
	        var self = this;
	        this.$mdDialog.show({
	            targetEvent: $event,
	            template: requestAccessDialogTemplate,
	            controller: request_access_dialog_controller_1.RequestAccessDialog,
	            bindToController: true,
	            controllerAs: '$ctrl'
	        }).then(function (userData) {
	            _this.requestAccessApi.sendAccessData(userData).then(function () { }, function (errorData) {
	                self.$mdDialog.show(self.$mdDialog.alert()
	                    .clickOutsideToClose(true)
	                    .title('Save failed')
	                    .textContent(errorData.data.details)
	                    .ok('OK')
	                    .targetEvent($event));
	            });
	        });
	    };
	    LoginCardController.prototype.requestResetPassword = function ($event) {
	        var _this = this;
	        this.$mdDialog.show({
	            targetEvent: $event,
	            template: requestResetPasswordDialogTemplate,
	            controller: request_reset_password_dialog_controller_1.RequestResetPasswordDialog,
	            bindToController: true,
	            controllerAs: '$ctrl'
	        }).then(function (data) {
	            _this.userApi.requestResetPassword(data);
	        });
	    };
	    LoginCardController.prototype.onLoginError = function (error) {
	        var _this = this;
	        this.$translate("API.ERRORS." + error.errorType + "_" + error.errorCode)
	            .then(function (translatedMessage) {
	            _this.loginErrorMessage = translatedMessage;
	            _this.loginDetails.password = '';
	            _this.$log.error(_this.loginErrorMessage);
	        });
	    };
	    ;
	    LoginCardController.$inject = ['loginService', '$state', '$log',
	        '$translate', '$window', '$mdDialog', 'userApi', 'requestAccessApi', '$rootScope', 'organizationApi', 'imomoErrorService'];
	    return LoginCardController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = LoginCardController;


/***/ },
/* 335 */
/***/ function(module, exports) {

	"use strict";
	var RequestAccessDialog = (function () {
	    function RequestAccessDialog($mdDialog) {
	        var _this = this;
	        this.$mdDialog = $mdDialog;
	        this.apply = function () {
	            _this.$mdDialog.hide(_this.newUserData);
	        };
	        this.cancel = function () {
	            _this.$mdDialog.cancel();
	        };
	    }
	    RequestAccessDialog.$inject = ['$mdDialog'];
	    return RequestAccessDialog;
	}());
	exports.RequestAccessDialog = RequestAccessDialog;


/***/ },
/* 336 */
/***/ function(module, exports) {

	"use strict";
	var RequestResetPasswordDialog = (function () {
	    function RequestResetPasswordDialog($mdDialog) {
	        var _this = this;
	        this.$mdDialog = $mdDialog;
	        this.apply = function () {
	            _this.$mdDialog.hide(_this.requestResetPasswordData);
	        };
	        this.cancel = function () {
	            _this.$mdDialog.cancel();
	        };
	    }
	    RequestResetPasswordDialog.$inject = ['$mdDialog'];
	    return RequestResetPasswordDialog;
	}());
	exports.RequestResetPasswordDialog = RequestResetPasswordDialog;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var appSetupDialogTemplate = __webpack_require__(338);
	var AppSetupDialog = (function () {
	    function AppSetupDialog($mdDialog, organizationService, $q, userApi, organizationApi, imomoErrorService) {
	        var _this = this;
	        this.$mdDialog = $mdDialog;
	        this.organizationService = organizationService;
	        this.$q = $q;
	        this.userApi = userApi;
	        this.organizationApi = organizationApi;
	        this.imomoErrorService = imomoErrorService;
	        this.currentStepIndex = 0;
	        this.stepsCount = 3;
	        this.invitationList = [];
	        this.organizationService.getCurrentOrgId()
	            .then(function (id) { return _this.currentOrgId = id; });
	        if (this.DialogParams && this.DialogParams.wizardStep) {
	            this.currentStepIndex = this.DialogParams.wizardStep;
	        }
	    }
	    AppSetupDialog.prototype.wizardStepValidation = function (stepIndex) {
	        if (stepIndex == 0 && this.userForm && this.changePasswordForm) {
	            return this.userForm.$valid && this.changePasswordForm.$valid ||
	                this.userForm.$valid &&
	                    (!this.changePasswordForm.oldPassword.$modelValue &&
	                        !this.changePasswordForm.newPassword.$modelValue &&
	                        !this.changePasswordForm.repeatNewPassword.$modelValue);
	        }
	        else if (stepIndex === 1 && this.organizationForm) {
	            return this.organizationForm.$valid;
	        }
	        else if (stepIndex === 2) {
	            return true;
	        }
	        else if (stepIndex === 3) {
	            return true;
	        }
	        return false;
	    };
	    AppSetupDialog.prototype.onWizardFinish = function () {
	        var _this = this;
	        var promises = [];
	        var forecastTypes = [];
	        var userPromise = this.userApi.saveUser(this.userData);
	        promises.push(userPromise);
	        if (this.changePasswordData &&
	            this.changePasswordData.oldPassword &&
	            this.changePasswordData.newPassword1 &&
	            this.changePasswordData.newPassword2) {
	            var changePasswordPromise = this.userApi.changePassword(this.changePasswordData);
	            promises.push(changePasswordPromise);
	        }
	        this.organizationData.setupFinished = true;
	        var organizationPromise = this.organizationApi.saveOrganization(this.organizationData);
	        promises.push(organizationPromise);
	        if (typeof this.forecastTypes.fiveDay.issueDateOffset !== 'undefined') {
	            forecastTypes.push(this.forecastTypes.fiveDay);
	        }
	        if (typeof this.forecastTypes.decadal.issueDateOffset !== 'undefined') {
	            forecastTypes.push(this.forecastTypes.decadal);
	        }
	        if (typeof this.forecastTypes.monthly.issueDateOffset !== 'undefined') {
	            forecastTypes.push(this.forecastTypes.monthly);
	        }
	        forecastTypes.concat(this.seasonalForecastTypes)
	            .forEach(function (forecastType) {
	            if (!forecastType.id) {
	                promises
	                    .push(_this.organizationApi.createForecastType(_this.currentOrgId, forecastType));
	            }
	            else {
	                promises
	                    .push(_this.organizationApi.updateForecastType(_this.currentOrgId, forecastType));
	            }
	        });
	        this.invitationList.forEach(function (invitation) {
	            promises.push(_this.userApi.sendInvitation(invitation));
	        });
	        this.$q.all(promises)
	            .then(function () {
	            _this.$mdDialog.hide();
	        }).catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details)
	                .then(function () {
	                _this.$mdDialog.show({
	                    template: appSetupDialogTemplate,
	                    controller: AppSetupDialog,
	                    bindToController: true,
	                    controllerAs: '$ctrl'
	                }).then(function () {
	                });
	            });
	        });
	    };
	    AppSetupDialog.prototype.addToInvitationList = function (invitation) {
	        this.invitationList.push(invitation);
	        this.invitation = null;
	    };
	    AppSetupDialog.prototype.removeInvitation = function ($index) {
	        this.invitationList.splice($index, 1);
	    };
	    AppSetupDialog.prototype.onCancelClick = function () {
	        this.$mdDialog.cancel();
	    };
	    AppSetupDialog.$inject = ['$mdDialog', 'organizationService', '$q', 'userApi', 'organizationApi', 'imomoErrorService'];
	    return AppSetupDialog;
	}());
	exports.AppSetupDialog = AppSetupDialog;


/***/ },
/* 338 */
/***/ function(module, exports) {

	module.exports = "<md-dialog flex style=\"height:calc(100vh - 20px)\"> <md-toolbar> <div class=md-toolbar-tools> <h2>{{::'SETUP' | translate}}</h2> </div> </md-toolbar> <md-dialog-content class=create-organization-content layout=row flex> <wizard current-step-index=$ctrl.currentStepIndex flex steps-count=$ctrl.stepsCount step-validation=$ctrl.wizardStepValidation($ctrl.currentStepIndex) on-finish=$ctrl.onWizardFinish() on-cancel=$ctrl.onCancelClick()> <md-tabs flex md-border-bottom md-selected=$ctrl.currentStepIndex class=full-height-tabs> <md-tab ng-disabled=true> <md-tab-label translate>ACCOUNT</md-tab-label> <md-tab-body> <div layout=row layout-align=\"center top\"> <user-details id=\"'me'\" is-inside-org-setup-wizard=true is-editable=true user-data=$ctrl.userData user-form=$ctrl.userForm> </user-details> <md-card style=width:300px> <change-password-form change-password-data=$ctrl.changePasswordData change-password-form=$ctrl.changePasswordForm></change-password-form> <md-card> </md-card></md-card></div> </md-tab-body> </md-tab> <md-tab ng-disabled=true> <md-tab-label translate>ORGANIZATION</md-tab-label> <md-tab-body> <hydromet-organization id=$ctrl.currentOrgId is-inside-org-setup-wizard=true is-editable=true organization-data=$ctrl.organizationData organization-form=$ctrl.organizationForm forecast-types=$ctrl.forecastTypes seasonal-forecast-types=$ctrl.seasonalForecastTypes> </hydromet-organization> </md-tab-body> </md-tab> <md-tab ng-disabled=true> <md-tab-label translate>INVITATIONS</md-tab-label> <md-tab-body> <div layout=row layout-align=\"center top\"> <md-card layout-padding style=width:500px> <form name=invitationForm layout=row flex> <md-input-container flex> <input flex type=text ng-model=$ctrl.invitation.fullName placeholder=\"{{ 'NAME' | translate}}\"> </md-input-container> <md-input-container flex> <input flex type=email ng-model=$ctrl.invitation.email placeholder=\"{{ 'EMAIL' | translate}}\"> </md-input-container> <div> <md-button type=submit class=\"md-primary md-raised\" ng-disabled=invitationForm.$invalid ng-click=$ctrl.addToInvitationList($ctrl.invitation)> <span translate>ADD</span> </md-button> </div> </form> <md-content class=md-whiteframe-2dp layout=column> <md-list> <md-list-item ng-repeat=\"invitation in $ctrl.invitationList\" layout-padding> <div> <div> <strong>{{invitation.fullName}}</strong> </div> <div>{{invitation.email}}</div> </div> <md-icon class=\"material-icons md-secondary md-warn\" ng-click=$ctrl.removeInvitation($index)> cancel </md-icon> </md-list-item> </md-list> </md-content> </md-card> </div> </md-tab-body> </md-tab> </md-tabs> </wizard> </md-dialog-content> </md-dialog>";

/***/ },
/* 339 */
/***/ function(module, exports) {

	module.exports = "<md-dialog style=width:400px> <form name=settingsForm> <md-dialog-content> <div layout=column class=md-dialog-content> <md-input-container> <label translate>EMAIL</label> <input type=text required ng-model=$ctrl.requestResetPasswordData.email> </md-input-container> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply()> <span translate>SEND</span> </md-button> </md-dialog-actions> </form> </md-dialog>";

/***/ },
/* 340 */
/***/ function(module, exports) {

	module.exports = "<md-dialog style=width:400px> <form name=settingsForm> <md-dialog-content> <div layout=column class=md-dialog-content> <md-input-container> <label translate>ORGANIZATION_NAME</label> <input type=text required ng-model=$ctrl.newUserData.organization> </md-input-container> <md-input-container> <label translate>COUNTRY</label> <input type=text required ng-model=$ctrl.newUserData.country> </md-input-container> <md-input-container> <label translate>CITY</label> <input type=text required ng-model=$ctrl.newUserData.city> </md-input-container> <md-input-container> <label translate>ADDRESS</label> <input type=text required ng-model=$ctrl.newUserData.address> </md-input-container> <md-input-container> <label translate>ZIP_CODE</label> <input type=text required ng-model=$ctrl.newUserData.zipCode> </md-input-container> <md-input-container> <label translate>USERNAME</label> <input type=text required ng-model=$ctrl.newUserData.username> </md-input-container> <md-input-container> <label translate>EMAIL</label> <input type=text required ng-model=$ctrl.newUserData.email> </md-input-container> <md-input-container> <label translate>PHONE</label> <input type=text required ng-model=$ctrl.newUserData.phone> </md-input-container> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply()> <span translate>APPLY</span> </md-button> </md-dialog-actions> </form> </md-dialog>";

/***/ },
/* 341 */
/***/ function(module, exports) {

	module.exports = "<md-card layout=column layout-padding class=login-card> <div> <md-progress-linear md-mode=indeterminate ng-disabled=!$ctrl.logInInProgress> </md-progress-linear> </div> <h2 class=md-title translate>LOGIN</h2> <span class=\"login-error md-subhead\" md-colors=\"::{color: 'warn'}\" ng-class=\"{visible: $ctrl.loginErrorMessage}\"> {{ $ctrl.loginErrorMessage }} </span> <form name=loginForm layout=column> <md-input-container> <label translate>USERNAME</label> <input required name=username ng-model=$ctrl.loginDetails.username> </md-input-container> <md-input-container> <label translate>PASSWORD</label> <input required type=password ng-model=$ctrl.loginDetails.password> </md-input-container> <md-button type=submit class=\"md-primary md-raised\" ng-click=$ctrl.logIn() ng-disabled=\"loginForm.$invalid || $ctrl.logInInProgress\"> <span translate>LOG_IN</span> </md-button> <md-button ng-disabled=$ctrl.logInInProgress ng-click=$ctrl.requestResetPassword()> <span translate>FORGOT_YOUR_PASSWORD</span> </md-button> <md-button class=\"md-raised md-accent\" ng-disabled=$ctrl.logInInProgress ng-click=$ctrl.requestAccess()> <span translate>REQUEST_ACCESS</span> </md-button> </form> </md-card>";

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var news_list_component_1 = __webpack_require__(343);
	var news_service_1 = __webpack_require__(346);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.news', [])
	    .component('imomoNews', news_list_component_1.default)
	    .service('newsService', news_service_1.default)
	    .name;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var news_controller_1 = __webpack_require__(344);
	var template = __webpack_require__(345);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: news_controller_1.default,
	    template: template
	};


/***/ },
/* 344 */
/***/ function(module, exports) {

	"use strict";
	var NewsListController = (function () {
	    function NewsListController(newsService) {
	        this.newsService = newsService;
	        this.loadNews();
	    }
	    NewsListController.prototype.loadNews = function () {
	        var _this = this;
	        this.newsService.getLatestNews().then(function (latestNews) {
	            _this.latestNews = latestNews;
	        });
	    };
	    NewsListController.$inject = ['newsService', 'cmsApi', '$translate'];
	    return NewsListController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = NewsListController;


/***/ },
/* 345 */
/***/ function(module, exports) {

	module.exports = "<md-card layout=column flex layout-padding> <h3 class=md-title translate>ANNOUNCEMENTS</h3> <md-content> <md-list> <md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"newsItem in $ctrl.latestNews\"> <div class=md-list-item-text> <h4 class=md-subhead>{{ newsItem.title }}</h4> <p>{{ newsItem.date | momentFormatter }}</p> <p>{{ newsItem.content }}</p> </div> </md-list-item> <md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"newsItem in $ctrl.latestNews\"> <div class=md-list-item-text> <cms content-name=\"'announcements'\"></cms> </div> </md-list-item> </md-list> </md-content> </md-card>";

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var NewsService = (function () {
	    function NewsService($q) {
	        this.$q = $q;
	    }
	    NewsService.prototype.getLatestNews = function () {
	        return this.$q.when([{
	                title: 'Hydromet 2.1.1 released',
	                date: moment({ y: 2021, M: 9, d: 1 }),
	                content: ''
	            }]);
	    };
	    NewsService.$inject = ['$q'];
	    return NewsService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = NewsService;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var input_module_1 = __webpack_require__(348);
	var journal_module_1 = __webpack_require__(395);
	var operational_component_1 = __webpack_require__(416);
	var options_component_1 = __webpack_require__(418);
	var bulletin_component_1 = __webpack_require__(424);
	var bulk_data_download_component_1 = __webpack_require__(427);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.operational', [input_module_1.default, journal_module_1.default])
	    .config(operational_component_1.configStates)
	    .component('imomoOperational', operational_component_1.default)
	    .component('imomoOperationalOptions', options_component_1.default)
	    .component('imomoOperationalBulletin', bulletin_component_1.default)
	    .component('imomoOperationalBulkDataDownload', bulk_data_download_component_1.default)
	    .name;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var kn15_parse_service_1 = __webpack_require__(349);
	var input_service_1 = __webpack_require__(351);
	var daily_data_service_1 = __webpack_require__(352);
	var telegram_data_comparison_service_1 = __webpack_require__(353);
	var curve_component_1 = __webpack_require__(354);
	var input_component_1 = __webpack_require__(359);
	var save_component_1 = __webpack_require__(362);
	var telegram_component_1 = __webpack_require__(366);
	var data_overview_component_1 = __webpack_require__(369);
	var data_processing_component_1 = __webpack_require__(373);
	var water_level_card_component_1 = __webpack_require__(377);
	var discharge_card_component_1 = __webpack_require__(380);
	var ice_phenomena_card_component_1 = __webpack_require__(383);
	var temperature_card_component_1 = __webpack_require__(385);
	var meteo_card_component_1 = __webpack_require__(388);
	var ice_phenomena_1 = __webpack_require__(350);
	var curve_creator_component_1 = __webpack_require__(391);
	var kn15_parse_validator_directive_1 = __webpack_require__(394);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.operational.input', [])
	    .component('imomoOperationalInput', input_component_1.default)
	    .component('imomoOperationalInputTelegram', telegram_component_1.default)
	    .component('imomoOperationalInputDataOverview', data_overview_component_1.default)
	    .component('imomoOperationalInputDataProcessing', data_processing_component_1.default)
	    .component('imomoOperationalInputCurve', curve_component_1.default)
	    .component('imomoOperationalInputSave', save_component_1.default)
	    .component('imomoOperationalInputWaterLevelCard', water_level_card_component_1.default)
	    .component('imomoOperationalInputDischargeCard', discharge_card_component_1.default)
	    .component('imomoOperationalInputIcePhenomenaCard', ice_phenomena_card_component_1.default)
	    .component('imomoOperationalInputTemperatureCard', temperature_card_component_1.default)
	    .component('imomoOperationalInputMeteoCard', meteo_card_component_1.default)
	    .component('imomoOperationalInputCurveCreator', curve_creator_component_1.default)
	    .service('kn15ParseService', kn15_parse_service_1.KN15ParseService)
	    .service('operationalInputService', input_service_1.OperationalInputService)
	    .service('dailyDataService', daily_data_service_1.DailyDataService)
	    .service('telegramDataComparisonService', telegram_data_comparison_service_1.TelegramDataComparisonService)
	    .filter('icePhenomenaCodeFormatter', ice_phenomena_1.icePhenomenaCodeFormatterFactory)
	    .filter('icePhenomenaIntensityFormatter', ice_phenomena_1.icePhenomenaIntensityFormatterFactory)
	    .directive('kn15ParseValidator', kn15_parse_validator_directive_1.default)
	    .name;


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var immutable_1 = __webpack_require__(195);
	var ice_phenomena_1 = __webpack_require__(350);
	var KN15ParseError = (function () {
	    function KN15ParseError(messageId, badToken, tokens) {
	        this.messageId = messageId;
	        this.badToken = badToken;
	        this.tokens = tokens;
	    }
	    return KN15ParseError;
	}());
	exports.KN15ParseError = KN15ParseError;
	var KN15ParseService = (function () {
	    function KN15ParseService() {
	    }
	    KN15ParseService.prototype.parse = function (telegram) {
	        var parsedTelegram = {
	            telegramText: telegram,
	            sectionZero: null,
	            sectionOne: null,
	        };
	        KN15ParseService.isMeteoStationDataOnly = false;
	        if (telegram.endsWith('=')) {
	            telegram = telegram.slice(0, -1);
	        }
	        if (telegram.indexOf('//') != -1) {
	            telegram = telegram.replace('//', '');
	        }
	        var tokens = immutable_1.Stack(telegram.trim().split(/\s+/));
	        if (tokens.get(1) && tokens.get(1).indexOf('988') != -1) {
	            KN15ParseService.isMeteoStationDataOnly = true;
	        }
	        var badToken = tokens.find(function (token) { return token.length != 5 && token.length != 3; });
	        if (badToken) {
	            throw new KN15ParseError('TOO_SHORT_TOKEN', badToken, tokens);
	        }
	        var parsedSectionZero;
	        (_a = KN15ParseService.parseSectionZero(tokens), tokens = _a.tokens, parsedSectionZero = _a.parsedSectionZero, _a);
	        parsedTelegram.sectionZero = parsedSectionZero;
	        if (parsedSectionZero.sectionCode != 1 &&
	            parsedSectionZero.sectionCode != 2 &&
	            parsedSectionZero.sectionCode != null) {
	            // TODO: Support more codes.
	            throw new KN15ParseError('UNSUPPORTED_SECTION_CODE', '', tokens);
	        }
	        if (!KN15ParseService.isMeteoStationDataOnly) {
	            var parsedSectionOne = void 0;
	            (_b = KN15ParseService.parseSectionOne(tokens), tokens = _b.tokens, parsedSectionOne = _b.parsedSectionOne, _b);
	            parsedTelegram.sectionOne = parsedSectionOne;
	        }
	        if (parsedSectionZero && parsedSectionZero.sectionCode == 2) {
	            while (tokens.size) {
	                var token = tokens.peek();
	                switch (token.slice(0, 3)) {
	                    case '933':
	                        var parsedSectionThree = void 0;
	                        (_c = KN15ParseService.parseSectionThree(tokens), tokens = _c.tokens, parsedSectionThree = _c.parsedSectionThree, _c);
	                        parsedTelegram.sectionThree = parsedSectionThree;
	                        break;
	                    case '966':
	                        var parsedSectionSix = void 0;
	                        (_d = KN15ParseService.parseSectionSix(tokens), tokens = _d.tokens, parsedSectionSix = _d.parsedSectionSix, _d);
	                        parsedTelegram.sectionSix = parsedSectionSix;
	                        break;
	                    case '988':
	                        var parsedSectionEight = void 0;
	                        (_e = KN15ParseService.parseSectionEight(tokens), tokens = _e.tokens, parsedSectionEight = _e.parsedSectionEight, _e);
	                        parsedTelegram.sectionEight = parsedSectionEight;
	                        break;
	                    default:
	                        // TODO: Support more codes.
	                        throw new KN15ParseError('UNSUPPORTED_SECTION', token, tokens);
	                }
	            }
	        }
	        else if (parsedSectionZero && parsedSectionZero.sectionCode != 2 || KN15ParseService.isMeteoStationDataOnly) {
	            while (tokens.size) {
	                var token = tokens.peek();
	                switch (token.slice(0, 3)) {
	                    case '988':
	                        var parsedSectionEight = void 0;
	                        (_f = KN15ParseService.parseSectionEight(tokens), tokens = _f.tokens, parsedSectionEight = _f.parsedSectionEight, _f);
	                        parsedTelegram.sectionEight = parsedSectionEight;
	                        break;
	                    default:
	                        // TODO: Support more codes.
	                        throw new KN15ParseError('UNSUPPORTED_SECTION', token, tokens);
	                }
	            }
	        }
	        return parsedTelegram;
	        var _a, _b, _c, _d, _e, _f;
	    };
	    KN15ParseService.parseSectionZero = function (tokens) {
	        // Groups MMMM and BBiii
	        var maxStationCodeTries = 2;
	        var parsedStationCode;
	        var token;
	        while (maxStationCodeTries > 0 && !parsedStationCode) {
	            token = tokens.peek();
	            if (KN15ParseService.STATION_CODE_REGEXP.test(token)) {
	                parsedStationCode = token;
	            }
	            tokens = tokens.pop();
	            maxStationCodeTries--;
	        }
	        if (!parsedStationCode) {
	            throw new KN15ParseError('NO_STATION_CODE', token, tokens);
	        }
	        if (KN15ParseService.isMeteoStationDataOnly) {
	            return {
	                tokens: tokens,
	                parsedSectionZero: {
	                    stationCode: parsedStationCode,
	                    date: null,
	                    sectionCode: null
	                }
	            };
	        }
	        // Group YYGGn
	        var dateToken = tokens.peek();
	        tokens = tokens.pop();
	        var yyPart = dateToken.slice(0, 2);
	        var ggPart = dateToken.slice(2, 4);
	        var nPart = dateToken.slice(4);
	        var dayInMonth = Number.parseInt(yyPart);
	        if (Number.isNaN(dayInMonth)) {
	            throw new KN15ParseError('INVALID_DAY_IN_MONTH', dateToken, tokens);
	        }
	        if (ggPart != '08') {
	            // TODO: Support more codes.
	            throw new KN15ParseError('UNSUPPORTED_HOUR_CODE', dateToken, tokens);
	        }
	        var parsedDate = moment().date(dayInMonth);
	        if (parsedDate.isAfter(moment().endOf('month'))) {
	            // Carried over.
	            parsedDate = moment().subtract(1, 'month').endOf('month');
	        }
	        if (parsedDate.isAfter(moment())) {
	            parsedDate.subtract(1, 'month');
	        }
	        parsedDate.hour(8).minute(0).second(0).millisecond(0);
	        if (!parsedDate.isValid()) {
	            throw new KN15ParseError('OUT_OF_RANGE_DAY_IN_MONTH', dateToken, tokens);
	        }
	        var parsedSectionCode = Number.parseInt(nPart);
	        if (Number.isNaN(parsedSectionCode)) {
	            throw new KN15ParseError('INVALID_SECTION_CODE', dateToken, tokens);
	        }
	        return {
	            tokens: tokens,
	            parsedSectionZero: {
	                stationCode: parsedStationCode,
	                date: parsedDate,
	                sectionCode: parsedSectionCode
	            }
	        };
	    };
	    KN15ParseService.parseSectionOne = function (tokens) {
	        // Group 1HHHH
	        var token = tokens.peek();
	        if (!(token && token.startsWith('1'))) {
	            throw new KN15ParseError('INVALID_GROUP_ONE', token, tokens);
	        }
	        var waterLevelAtEight = Number.parseInt(token.slice(1));
	        if (Number.isNaN(waterLevelAtEight)) {
	            throw new KN15ParseError('INVALID_WATER_LEVEL', token, tokens);
	        }
	        waterLevelAtEight = waterLevelAtEight > 5000
	            ? 5000 - waterLevelAtEight
	            : waterLevelAtEight;
	        tokens = tokens.pop();
	        // Group 2HHHK
	        token = tokens.peek();
	        if (!(token && token.startsWith('2'))) {
	            throw new KN15ParseError('INVALID_GROUP_TWO', token, tokens);
	        }
	        var waterLevelTrend = Number.parseInt(token.slice(1, 4));
	        var waterLevelTrendSign = Number.parseInt(token.slice(4));
	        if (Number.isNaN(waterLevelTrend) ||
	            [0, 1, 2].indexOf(waterLevelTrendSign) == -1) {
	            throw new KN15ParseError('INVALID_TREND', token, tokens);
	        }
	        waterLevelTrend = waterLevelTrendSign == 2
	            ? -waterLevelTrend
	            : waterLevelTrend;
	        tokens = tokens.pop();
	        // Group 3HHHH
	        token = tokens.peek();
	        if (!(token && token.startsWith('3'))) {
	            throw new KN15ParseError('INVALID_GROUP_THREE', token, tokens);
	        }
	        var waterLevelAtTwenty = Number.parseInt(token.slice(1));
	        if (Number.isNaN(waterLevelAtTwenty)) {
	            throw new KN15ParseError('INVALID_WATER_LEVEL', token, tokens);
	        }
	        waterLevelAtTwenty = waterLevelAtTwenty > 5000
	            ? 5000 - waterLevelAtTwenty
	            : waterLevelAtTwenty;
	        tokens = tokens.pop();
	        var temperatures = null;
	        var icePhenomenae = [];
	        token = tokens.peek();
	        while (tokens.size && !token.startsWith('9')) {
	            // Group 4ttTT
	            if (token.startsWith('4')) {
	                var waterTemperature = Number.parseInt(token.slice(1, 3));
	                var airTemperature = Number.parseInt(token.slice(3));
	                if (Number.isNaN(waterTemperature)) {
	                    throw new KN15ParseError('INVALID_TEMPERATURE', token, tokens);
	                }
	                waterTemperature /= 10;
	                if (!Number.isNaN(airTemperature) && airTemperature > 50) {
	                    airTemperature -= 50;
	                    airTemperature = -airTemperature;
	                }
	                if (Number.isNaN(airTemperature)) {
	                    temperatures = {
	                        waterTemperature: waterTemperature
	                    };
	                }
	                else {
	                    temperatures = {
	                        waterTemperature: waterTemperature,
	                        airTemperature: airTemperature
	                    };
	                }
	            }
	            // Group 5EEii or 5EEEE
	            if (token.startsWith('5')) {
	                var icePhenomena = null;
	                var icePhenomenaCode = Number.parseInt(token.slice(1, 3));
	                var intensity = Number.parseInt(token.slice(3));
	                if (Number.isNaN(icePhenomenaCode) || Number.isNaN(intensity)) {
	                    throw new KN15ParseError('INVALID_ICE_PHENOMENA', token, tokens);
	                }
	                if (!ice_phenomena_1.IcePhenomena.verifyIcePhenomena(icePhenomenaCode, intensity)) {
	                    throw new KN15ParseError('INVALID_ICE_PHENOMENA', token, tokens);
	                }
	                if (icePhenomenaCode == intensity) {
	                    icePhenomena = {
	                        code: icePhenomenaCode
	                    };
	                }
	                else {
	                    icePhenomena = {
	                        code: icePhenomenaCode,
	                        intensity: intensity
	                    };
	                }
	                icePhenomenae.push(icePhenomena);
	            }
	            tokens = tokens.pop();
	            token = tokens.peek();
	        }
	        return {
	            tokens: tokens,
	            parsedSectionOne: {
	                waterLevelAtEight: waterLevelAtEight,
	                waterLevelAtTwenty: waterLevelAtTwenty,
	                waterLevelTrend: waterLevelTrend,
	                icePhenomenae: icePhenomenae,
	                temperatures: temperatures
	            }
	        };
	    };
	    KN15ParseService.parseSectionThree = function (tokens) {
	        tokens = tokens.pop();
	        // TODO: Do something with the first token.
	        // Group 1HHHH
	        var token = tokens.peek();
	        if (!(token && token.startsWith('1'))) {
	            throw new KN15ParseError('INVALID_GROUP_ONE', token, tokens);
	        }
	        var waterLevelAverage = Number.parseInt(token.slice(1));
	        waterLevelAverage = waterLevelAverage > 5000
	            ? 5000 - waterLevelAverage
	            : waterLevelAverage;
	        tokens = tokens.pop();
	        token = tokens.peek();
	        while (tokens.size && !token.startsWith('9')) {
	            tokens = tokens.pop();
	            token = tokens.peek();
	        }
	        return {
	            tokens: tokens,
	            parsedSectionThree: {
	                waterLevelAverage: waterLevelAverage
	            }
	        };
	    };
	    KN15ParseService.parseSectionSix = function (tokens) {
	        var parsedSectionSix = {
	            waterLevel: null,
	            discharge: null,
	            date: null
	        };
	        // Group 966MM
	        var token = tokens.peek();
	        var monthString = token.slice(3);
	        // Javascript months are zero-indexed.
	        var month = Number.parseInt(monthString) - 1;
	        if (Number.isNaN(month) || month > 11 || month < 0) {
	            throw new KN15ParseError('INVALID_MONTH', token, tokens);
	        }
	        tokens = tokens.pop();
	        // Group 1HHHH
	        token = tokens.peek();
	        if (!(token && token.startsWith('1'))) {
	            throw new KN15ParseError('INVALID_GROUP_ONE', token, tokens);
	        }
	        var waterLevel = Number.parseInt(token.slice(1));
	        parsedSectionSix.waterLevel = waterLevel > 5000
	            ? 5000 - waterLevel
	            : waterLevel;
	        tokens = tokens.pop();
	        // Group 2kQQQ
	        token = tokens.peek();
	        if (!(token && token.startsWith('2'))) {
	            throw new KN15ParseError('INVALID_GROUP_TWO_DISCHARGE', token, tokens);
	        }
	        var dischargeSignficand = Number.parseInt(token.slice(2));
	        var dischargeExponent = Number.parseInt(token.charAt(1));
	        if (Number.isNaN(dischargeSignficand) || Number.isNaN(dischargeExponent)) {
	            throw new KN15ParseError('INVALID_DISCHARGE_VALUE', token, tokens);
	        }
	        tokens = tokens.pop();
	        parsedSectionSix.discharge = dischargeSignficand *
	            Math.pow(10, dischargeExponent - 3);
	        // Group 3kFFF
	        token = tokens.peek();
	        if (token && token.startsWith('3')) {
	            var areaSignificand = Number.parseInt(token.slice(2));
	            var areaExponent = Number.parseInt(token.charAt(1));
	            if (Number.isNaN(dischargeSignficand) || Number.isNaN(dischargeExponent)) {
	                throw new KN15ParseError('INVALID_FREE_RIVER_AREA_VALUE', token, tokens);
	            }
	            tokens = tokens.pop();
	            parsedSectionSix.freeRiverArea = areaSignificand *
	                Math.pow(10, areaExponent - 3);
	        }
	        // Group 4hhhh
	        token = tokens.peek();
	        if (token && token.startsWith('4')) {
	            var maximumDepth = Number.parseInt(token.slice(1));
	            if (Number.isNaN(maximumDepth)) {
	                throw new KN15ParseError('INVALID_MAXIMUM_DEPTH_VALUE', token, tokens);
	            }
	            tokens = tokens.pop();
	            parsedSectionSix.maximumDepth = maximumDepth;
	        }
	        // Group 5YYGG
	        token = tokens.peek();
	        if (!(token && token.startsWith('5'))) {
	            throw new KN15ParseError('INVALID_GROUP_FIVE', token, tokens);
	        }
	        var yyPart = token.slice(1, 3);
	        var dayInMonth = Number.parseInt(yyPart);
	        var date = moment().month(month).date(dayInMonth);
	        if (!date.isValid()) {
	            throw new KN15ParseError('OUT_OF_RANGE_DAY_IN_MONTH', token, tokens);
	        }
	        var ggPart = token.slice(3);
	        var hour = Number.parseInt(ggPart);
	        date.hour(hour).minute(0).second(0).millisecond(0);
	        if (!date.isValid()) {
	            throw new KN15ParseError('OUT_OF_RANGE_HOUR', token, tokens);
	        }
	        if (date.isAfter(moment())) {
	            date = date.subtract(1, 'year');
	        }
	        tokens = tokens.pop();
	        parsedSectionSix.date = date;
	        token = tokens.peek();
	        while (tokens.size && !token.startsWith('9')) {
	            tokens = tokens.pop();
	            token = tokens.peek();
	        }
	        return {
	            tokens: tokens,
	            parsedSectionSix: parsedSectionSix
	        };
	    };
	    KN15ParseService.parseSectionEight = function (tokens) {
	        var parsedSectionEight = {
	            month: null,
	            decade: null,
	            year: Number.parseInt(moment().format('YYYY')),
	            currentDate: moment(),
	            precipitation: null,
	            precipitationChecksum: null,
	            airTemp: null
	        };
	        // Group 988MM
	        var token = tokens.peek();
	        var monthString = token.slice(3);
	        // Javascript months are zero-indexed.
	        var month = Number.parseInt(monthString) - 1;
	        if (Number.isNaN(month) || month > 11 || month < 0) {
	            throw new KN15ParseError('INVALID_MONTH', token, tokens);
	        }
	        tokens = tokens.pop();
	        // Group 1
	        token = tokens.peek();
	        if (!(token && token.startsWith('1'))) {
	            throw new KN15ParseError('INVALID_GROUP_ONE', token, tokens);
	        }
	        var decade = Number.parseInt(token.slice(1));
	        var formattedDecade;
	        switch (decade) {
	            case 11:
	                formattedDecade = 1;
	                break;
	            case 22:
	                formattedDecade = 2;
	                break;
	            case 33:
	                formattedDecade = 3;
	                break;
	            case 30:
	                formattedDecade = 4;
	                break;
	            default:
	                // TODO: Support more codes.
	                throw new KN15ParseError('UNSUPPORTED_SECTION', token, tokens);
	        }
	        parsedSectionEight.month = Number.parseInt(moment().month(month).format('M'));
	        parsedSectionEight.decade = formattedDecade;
	        parsedSectionEight.year = Number.parseInt(moment().format('Y'));
	        tokens = tokens.pop();
	        // Group 2
	        token = tokens.peek();
	        if (token && token.startsWith('2')) {
	            parsedSectionEight.precipitation = Number.parseInt(token.slice(1, -1));
	            parsedSectionEight.precipitationChecksum = Number.parseInt(token.slice(4));
	            tokens = tokens.pop();
	        }
	        // Group 3
	        token = tokens.peek();
	        if (token && token.startsWith('3')) {
	            var airTempSign = Number.parseInt(token.slice(1, -3)) === 1 ? -1 : 1;
	            var airTemp = Number.parseInt(token.slice(2)) * 0.1;
	            parsedSectionEight.airTemp = airTemp * airTempSign;
	            tokens = tokens.pop();
	        }
	        return {
	            tokens: tokens,
	            parsedSectionEight: parsedSectionEight
	        };
	    };
	    KN15ParseService.STATION_CODE_REGEXP = /^[0-9]{5}$/;
	    return KN15ParseService;
	}());
	exports.KN15ParseService = KN15ParseService;


/***/ },
/* 350 */
/***/ function(module, exports) {

	"use strict";
	exports.icePhenomenaCodeFormatterFactory = function ($translate) {
	    return function (icePhenomenaCode) {
	        return $translate.instant("ICE_PHENOMENA_" + icePhenomenaCode);
	    };
	};
	exports.icePhenomenaCodeFormatterFactory.$inject = ['$translate'];
	exports.icePhenomenaIntensityFormatterFactory = function () {
	    return function (icePhenomenaIntensity) {
	        if (icePhenomenaIntensity && typeof icePhenomenaIntensity === 'number') {
	            return icePhenomenaIntensity * 10 + "%";
	        }
	        return '---';
	    };
	};
	var IcePhenomena;
	(function (IcePhenomena) {
	    var VALID_CODE_RANGES = [[11, 26], [30, 54], [63, 77]];
	    var CODES_WITH_INTENSITY = [12, 13, 14, 16, 19, 39, 48, 49, 50, 64];
	    function verifyIcePhenomena(code, intensity) {
	        var filteredRange = VALID_CODE_RANGES.filter(function (_a) {
	            var rangeStart = _a[0], rangeEnd = _a[1];
	            return rangeStart <= code && code <= rangeEnd;
	        });
	        if (filteredRange.length == 0) {
	            return false;
	        }
	        if (CODES_WITH_INTENSITY.indexOf(code) != -1) {
	            if (intensity < 1 || intensity > 10) {
	                return false;
	            }
	        }
	        else if (code != intensity) {
	            return false;
	        }
	        return true;
	    }
	    IcePhenomena.verifyIcePhenomena = verifyIcePhenomena;
	})(IcePhenomena = exports.IcePhenomena || (exports.IcePhenomena = {}));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var utils_1 = __webpack_require__(218);
	var OperationalInputService = (function () {
	    function OperationalInputService($http, backendUrl, stationApi) {
	        this.$http = $http;
	        this.stationApi = stationApi;
	        this.dataValuesEndpoint = backendUrl + "/data_values";
	        this.dischargeModelsEndpoint = backendUrl + "/discharge_models";
	    }
	    OperationalInputService.prototype.verifyWaterTrend = function (date, stationCode, waterLevelAtEight, waterLevelTrend) {
	        var previousDate = moment(date).subtract(1, 'day');
	        return this.$http({
	            url: this.dataValuesEndpoint + "/water_level",
	            method: 'GET',
	            params: {
	                localDateTime: previousDate.unix(),
	                utcOffset: previousDate.utcOffset() * 60,
	                siteCode: stationCode
	            }
	        }).then(function (httpData) {
	            var dataValues = httpData.data.resources;
	            if (dataValues && dataValues.length) {
	                var waterLevelDataValue = dataValues[0];
	                var measuredTrend = waterLevelAtEight - waterLevelDataValue.dataValue;
	                var isValidTrend = measuredTrend == waterLevelTrend;
	                return {
	                    previousWaterLevelAtEight: waterLevelDataValue.dataValue,
	                    valid: isValidTrend
	                };
	            }
	            return null;
	        });
	    };
	    OperationalInputService.prototype.calculateAverageWaterLevel = function (waterLevelAtTwenty, waterLevelAtEight) {
	        // if no water level at eight, do not calculate average
	        if (waterLevelAtEight != null) {
	            return Math.round((waterLevelAtTwenty +
	                waterLevelAtEight) / 2);
	        }
	        else {
	            return null;
	        }
	    };
	    OperationalInputService.prototype.calculateDailyDischarge = function (waterLevelData, dischargeModel, previousDischargeModel) {
	        var dischargeModelDate = dischargeModel.validFrom ? moment.unix(dischargeModel.validFrom) : null;
	        return waterLevelData.map(function (waterLevelDatum) {
	            var currentDate = waterLevelDatum.date;
	            var morningCell = null;
	            var eveningCell = null;
	            var averageCell = null;
	            if (!dischargeModelDate || currentDate.isAfter(dischargeModelDate, 'day')) {
	                if (waterLevelDatum.morningWaterLevel != null) {
	                    morningCell = {
	                        waterLevel: waterLevelDatum.morningWaterLevel,
	                        discharge: utils_1.getDischargeValue(waterLevelDatum.morningWaterLevel, dischargeModel),
	                        highlighted: true
	                    };
	                }
	                if (waterLevelDatum.eveningWaterLevel != null) {
	                    eveningCell = {
	                        waterLevel: waterLevelDatum.eveningWaterLevel,
	                        discharge: utils_1.getDischargeValue(waterLevelDatum.eveningWaterLevel, dischargeModel),
	                        highlighted: true
	                    };
	                }
	                if (waterLevelDatum.averageWaterLevel != null) {
	                    averageCell = {
	                        waterLevel: waterLevelDatum.averageWaterLevel,
	                        discharge: utils_1.getDischargeValue(waterLevelDatum.averageWaterLevel, dischargeModel),
	                        highlighted: true
	                    };
	                }
	            }
	            else if (currentDate.isSame(dischargeModelDate, 'day')) {
	                var dischargeSum = 0;
	                var dischargeCount = 0;
	                if (waterLevelDatum.morningDischarge != null &&
	                    waterLevelDatum.morningWaterLevel != null) {
	                    dischargeSum += waterLevelDatum.morningDischarge;
	                    dischargeCount++;
	                    morningCell = {
	                        waterLevel: waterLevelDatum.morningWaterLevel,
	                        discharge: waterLevelDatum.morningDischarge,
	                        highlighted: false
	                    };
	                }
	                if (waterLevelDatum.morningDischarge == null &&
	                    waterLevelDatum.morningWaterLevel != null) {
	                    morningCell = {
	                        waterLevel: waterLevelDatum.morningWaterLevel,
	                        discharge: utils_1.getDischargeValue(waterLevelDatum.morningWaterLevel, dischargeModel),
	                        highlighted: false
	                    };
	                }
	                if (waterLevelDatum.eveningWaterLevel != null) {
	                    var discharge = utils_1.getDischargeValue(waterLevelDatum.eveningWaterLevel, dischargeModel);
	                    dischargeSum += discharge;
	                    dischargeCount++;
	                    eveningCell = {
	                        waterLevel: waterLevelDatum.eveningWaterLevel,
	                        discharge: discharge,
	                        highlighted: true
	                    };
	                }
	                averageCell = {
	                    waterLevel: null,
	                    discharge: dischargeCount ? dischargeSum / dischargeCount : null,
	                    highlighted: true
	                };
	            }
	            else {
	                if (waterLevelDatum.morningWaterLevel != null) {
	                    morningCell = {
	                        waterLevel: waterLevelDatum.morningWaterLevel,
	                        discharge: utils_1.getDischargeValue(waterLevelDatum.morningWaterLevel, previousDischargeModel),
	                        highlighted: true
	                    };
	                }
	                if (waterLevelDatum.eveningWaterLevel != null) {
	                    eveningCell = {
	                        waterLevel: waterLevelDatum.eveningWaterLevel,
	                        discharge: utils_1.getDischargeValue(waterLevelDatum.eveningWaterLevel, previousDischargeModel),
	                        highlighted: true
	                    };
	                }
	                if (waterLevelDatum.averageWaterLevel != null) {
	                    averageCell = {
	                        waterLevel: waterLevelDatum.averageWaterLevel,
	                        discharge: utils_1.getDischargeValue(waterLevelDatum.averageWaterLevel, previousDischargeModel),
	                        highlighted: true
	                    };
	                }
	            }
	            return {
	                date: currentDate,
	                morningCell: morningCell,
	                eveningCell: eveningCell,
	                averageCell: averageCell
	            };
	        });
	    };
	    OperationalInputService.$inject = ['$http', 'backendUrl', 'stationApi'];
	    return OperationalInputService;
	}());
	exports.OperationalInputService = OperationalInputService;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var _ = __webpack_require__(29);
	var DailyDataService = (function () {
	    function DailyDataService(dataValueApi, operationalInputService, $q, $log) {
	        this.dataValueApi = dataValueApi;
	        this.operationalInputService = operationalInputService;
	        this.$q = $q;
	        this.$log = $log;
	    }
	    DailyDataService.prototype.calculateAvg = function (dataRow) {
	        var discharges = [];
	        if (dataRow.morningCell && dataRow.morningCell.discharge && !isNaN(dataRow.morningCell.discharge)) {
	            discharges.push(dataRow.morningCell.discharge);
	        }
	        if (dataRow.eveningCell && dataRow.eveningCell.discharge && !isNaN(dataRow.eveningCell.discharge)) {
	            discharges.push(dataRow.eveningCell.discharge);
	        }
	        var sum = 0;
	        _.forEach(discharges, function (discharge) {
	            sum += discharge;
	        });
	        return sum / discharges.length;
	    };
	    DailyDataService.prototype.getPreviousDailyData = function (parsedTelegram, dischargeModel, createdDischargeModel) {
	        if (createdDischargeModel) {
	            this.startDate = moment.unix(dischargeModel.validFrom)
	                .startOf('day');
	        }
	        else {
	            this.startDate = moment(parsedTelegram.overriddenDate)
	                .clone().subtract({ day: 1 }).startOf('day');
	        }
	        this.endDate = moment(parsedTelegram.overriddenDate)
	            .clone().subtract({ day: 1 }).endOf('day');
	        var deferred = this.$q.defer();
	        var stationId = parsedTelegram.station.id;
	        var startDate = this.startDate;
	        var endDate = this.endDate;
	        this.dataValueApi.getDailyData(stationId, startDate, endDate)
	            .then(function (dailyData) {
	            deferred.resolve(dailyData);
	        })
	            .catch(function (error) {
	            deferred.reject(error);
	        });
	        return deferred.promise;
	    };
	    DailyDataService.prototype.getDataRows = function (dailyData, parsedTelegram, dischargeModel, previousDischargeModel) {
	        var partialDailyData = dailyData
	            .map(function (dailyTriplet) {
	            var partialDatum = {
	                date: extractDate(dailyTriplet)
	            };
	            if (dailyTriplet.eightData != null) {
	                partialDatum.morningWaterLevel = dailyTriplet.eightData
	                    .waterLevel.dataValue;
	                partialDatum.morningDischarge = dailyTriplet.eightData
	                    .discharge.dataValue;
	            }
	            if (dailyTriplet.twentyData != null) {
	                partialDatum.eveningWaterLevel = dailyTriplet.twentyData
	                    .waterLevel.dataValue;
	            }
	            if (dailyTriplet.averageData != null) {
	                partialDatum.averageWaterLevel = dailyTriplet.averageData
	                    .waterLevel.dataValue;
	            }
	            return partialDatum;
	        });
	        var previousTelegramDay = moment(parsedTelegram.overriddenDate)
	            .clone().subtract({ day: 1 });
	        var previousDayDatum = null;
	        if (partialDailyData && partialDailyData.length &&
	            partialDailyData.slice(-1)[0].date.isSame(previousTelegramDay, 'day')) {
	            previousDayDatum = partialDailyData.slice(-1)[0];
	        }
	        else {
	            previousDayDatum = {
	                date: previousTelegramDay
	            };
	            partialDailyData.push(previousDayDatum);
	        }
	        previousDayDatum.eveningWaterLevel = parsedTelegram
	            .waterLevelData.previousWaterLevelAtTwenty;
	        previousDayDatum.averageWaterLevel = this.operationalInputService
	            .calculateAverageWaterLevel(previousDayDatum.eveningWaterLevel, previousDayDatum.morningWaterLevel);
	        var currentDayDatum = {
	            date: moment(parsedTelegram.overriddenDate),
	            morningWaterLevel: parsedTelegram.waterLevelData.waterLevelAtEight
	        };
	        partialDailyData.push(currentDayDatum);
	        return this.operationalInputService
	            .calculateDailyDischarge(partialDailyData, dischargeModel, previousDischargeModel);
	    };
	    DailyDataService.prototype.getProcessedData = function (dataRows) {
	        var processedData = dataRows
	            .map(function (dataRow) {
	            var dailyDataRequest = {
	                date: dataRow.date.clone(),
	                morningData: null,
	                eveningData: null,
	                averageData: null
	            };
	            if (dataRow.morningCell) {
	                dailyDataRequest.morningData = {
	                    waterLevel: dataRow.morningCell.waterLevel,
	                    discharge: dataRow.morningCell.discharge
	                };
	            }
	            if (dataRow.eveningCell) {
	                dailyDataRequest.eveningData = {
	                    waterLevel: dataRow.eveningCell.waterLevel,
	                    discharge: dataRow.eveningCell.discharge
	                };
	            }
	            if (dataRow.averageCell) {
	                dailyDataRequest.averageData = {
	                    waterLevel: dataRow.averageCell.waterLevel,
	                    discharge: dataRow.averageCell.discharge
	                };
	            }
	            return dailyDataRequest;
	        });
	        return processedData;
	    };
	    DailyDataService.prototype.getDailyDataAtOnce = function (parsedTelegram, dischargeModel, createdDischargeModel, previousDischargeModel) {
	        var _this = this;
	        var deferred = this.$q.defer();
	        this.getPreviousDailyData(parsedTelegram, dischargeModel, createdDischargeModel)
	            .then(function (dailyData) {
	            deferred.resolve(_this.getProcessedData(_this.getDataRows(dailyData, parsedTelegram, dischargeModel, previousDischargeModel)));
	        })
	            .catch(function (error) {
	            deferred.reject(error);
	        });
	        return deferred.promise;
	    };
	    DailyDataService.prototype.formatDailyDataRequest = function (dailyData) {
	        var formattedDailyData = [];
	        dailyData.forEach(function (dailyDataItem) {
	            var formattedDailyDataItem = {
	                date: dailyDataItem.date,
	                morningData: {
	                    waterLevel: null,
	                    discharge: null
	                },
	                eveningData: {
	                    waterLevel: null,
	                    discharge: null
	                },
	                averageData: {
	                    waterLevel: null,
	                    discharge: null
	                }
	            };
	            // morning
	            formattedDailyDataItem.morningData.waterLevel =
	                dailyDataItem.morningCell.overrideWaterLevelData ?
	                    dailyDataItem.morningCell.newWaterLevel || null :
	                    dailyDataItem.morningCell.oldWaterLevel || null;
	            formattedDailyDataItem.morningData.discharge =
	                dailyDataItem.morningCell.overrideDischargeData ?
	                    dailyDataItem.morningCell.newDischarge || null :
	                    dailyDataItem.morningCell.oldDischarge || null;
	            // evening
	            formattedDailyDataItem.eveningData.waterLevel =
	                dailyDataItem.eveningCell.overrideWaterLevelData ?
	                    dailyDataItem.eveningCell.newWaterLevel || null :
	                    dailyDataItem.eveningCell.oldWaterLevel || null;
	            formattedDailyDataItem.eveningData.discharge =
	                dailyDataItem.eveningCell.overrideDischargeData ?
	                    dailyDataItem.eveningCell.newDischarge || null :
	                    dailyDataItem.eveningCell.oldDischarge || null;
	            // average
	            formattedDailyDataItem.averageData.waterLevel =
	                dailyDataItem.averageCell.overrideWaterLevelData ?
	                    dailyDataItem.averageCell.newWaterLevel || null :
	                    dailyDataItem.averageCell.oldWaterLevel || null;
	            formattedDailyDataItem.averageData.discharge =
	                dailyDataItem.averageCell.overrideDischargeData ?
	                    dailyDataItem.averageCell.newDischarge || null :
	                    dailyDataItem.averageCell.oldDischarge || null;
	            formattedDailyData.push(formattedDailyDataItem);
	        });
	        return formattedDailyData;
	    };
	    DailyDataService.$inject = ['dataValueApi', 'operationalInputService', '$q', '$log', 'dischargeModelApi'];
	    return DailyDataService;
	}());
	exports.DailyDataService = DailyDataService;
	function extractDate(dailyTriplet) {
	    if (dailyTriplet.eightData) {
	        return moment.unix(dailyTriplet.eightData.waterLevel.dateTimeUtc);
	    }
	    else if (dailyTriplet.twentyData) {
	        return moment.unix(dailyTriplet.twentyData.waterLevel.dateTimeUtc);
	    }
	    return null;
	}


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var TelegramDataComparisonService = (function () {
	    function TelegramDataComparisonService() {
	    }
	    // receives data from telegram and data from database
	    // and formats it for comparison
	    TelegramDataComparisonService.prototype.formatDataForTelegramProcessing = function (newEntry, oldEntry) {
	        var formattedDischargeDataForTelegramProcessing = [];
	        var formattedMeteoDataForTelegramProcessing = [];
	        var formattedIceDataForTelegramProcessing = [];
	        var formattedDailyDataForTelegramProcessing = [];
	        if (newEntry.dischargeData && oldEntry.dischargeData) {
	            // daily data
	            if (newEntry.dischargeData.dailyData && oldEntry.dischargeData.dailyData) {
	                newEntry.dischargeData.dailyData.forEach(function (newEntryDailyDataRow, index) {
	                    var dailyDataRow = {
	                        date: null,
	                        morningCell: {
	                            newWaterLevel: null,
	                            newDischarge: null,
	                            oldWaterLevel: null,
	                            oldDischarge: null,
	                            overrideWaterLevelData: true,
	                            overrideDischargeData: true
	                        },
	                        eveningCell: {
	                            newWaterLevel: null,
	                            newDischarge: null,
	                            oldWaterLevel: null,
	                            oldDischarge: null,
	                            overrideWaterLevelData: true,
	                            overrideDischargeData: true
	                        },
	                        averageCell: {
	                            newWaterLevel: null,
	                            newDischarge: null,
	                            oldWaterLevel: null,
	                            oldDischarge: null,
	                            overrideWaterLevelData: true,
	                            overrideDischargeData: true
	                        }
	                    };
	                    var oldDailyData = oldEntry.dischargeData.dailyData;
	                    if (oldDailyData[index]) {
	                        var addDailyDataRow = false;
	                        dailyDataRow.date = newEntryDailyDataRow.date;
	                        // evening
	                        if (newEntryDailyDataRow.eveningData) {
	                            //new
	                            dailyDataRow.eveningCell.newWaterLevel = newEntryDailyDataRow.eveningData.waterLevel;
	                            dailyDataRow.eveningCell.newDischarge = newEntryDailyDataRow.eveningData.discharge;
	                            //old
	                            dailyDataRow.eveningCell.oldWaterLevel =
	                                oldDailyData[index].eveningData && oldDailyData[index].eveningData.waterLevel;
	                            dailyDataRow.eveningCell.oldDischarge =
	                                oldDailyData[index].eveningData && oldDailyData[index].eveningData.discharge;
	                            if (newEntry.dischargeData &&
	                                newEntry.dischargeData.icePhenomenae && newEntry.dischargeData.icePhenomenae.length) {
	                                addDailyDataRow = true;
	                            }
	                            else {
	                                if (
	                                // 
	                                dailyDataRow.eveningCell.newWaterLevel != null && dailyDataRow.eveningCell.oldWaterLevel != null ||
	                                    dailyDataRow.eveningCell.newDischarge != null && dailyDataRow.eveningCell.oldDischarge != null) {
	                                    addDailyDataRow = true;
	                                }
	                            }
	                        }
	                        // morning
	                        if (newEntryDailyDataRow.morningData) {
	                            //new
	                            dailyDataRow.morningCell.newWaterLevel = newEntryDailyDataRow.morningData.waterLevel;
	                            dailyDataRow.morningCell.newDischarge = newEntryDailyDataRow.morningData.discharge;
	                            //old
	                            dailyDataRow.morningCell.oldWaterLevel =
	                                oldDailyData[index].morningData && oldDailyData[index].morningData.waterLevel;
	                            dailyDataRow.morningCell.oldDischarge =
	                                oldDailyData[index].morningData && oldDailyData[index].morningData.discharge;
	                            if (newEntry.dischargeData &&
	                                newEntry.dischargeData.icePhenomenae && newEntry.dischargeData.icePhenomenae.length) {
	                                addDailyDataRow = true;
	                            }
	                            else {
	                                if (dailyDataRow.morningCell.newWaterLevel != null && dailyDataRow.morningCell.oldWaterLevel != null ||
	                                    dailyDataRow.morningCell.newDischarge != null && dailyDataRow.morningCell.oldDischarge != null) {
	                                    addDailyDataRow = true;
	                                }
	                            }
	                        }
	                        // average
	                        if (newEntryDailyDataRow.averageData) {
	                            //new
	                            dailyDataRow.averageCell.newWaterLevel = newEntryDailyDataRow.averageData.waterLevel;
	                            dailyDataRow.averageCell.newDischarge = newEntryDailyDataRow.averageData.discharge;
	                            //old
	                            dailyDataRow.averageCell.oldWaterLevel =
	                                oldDailyData[index].averageData && oldDailyData[index].averageData.waterLevel;
	                            dailyDataRow.averageCell.oldDischarge =
	                                oldDailyData[index].averageData && oldDailyData[index].averageData.discharge;
	                            if (newEntry.dischargeData &&
	                                newEntry.dischargeData.icePhenomenae && newEntry.dischargeData.icePhenomenae.length) {
	                                addDailyDataRow = true;
	                            }
	                            else {
	                                if (dailyDataRow.averageCell.newWaterLevel != null && dailyDataRow.averageCell.oldWaterLevel != null ||
	                                    dailyDataRow.averageCell.newDischarge != null && dailyDataRow.averageCell.oldDischarge != null) {
	                                    addDailyDataRow = true;
	                                }
	                            }
	                        }
	                        if (addDailyDataRow) {
	                            formattedDailyDataForTelegramProcessing.push(dailyDataRow);
	                        }
	                    }
	                });
	            }
	            // discharge data
	            if (newEntry.dischargeData &&
	                newEntry.dischargeData.dischargeMeasurementData
	                &&
	                    oldEntry.dischargeData &&
	                oldEntry.dischargeData.dischargeMeasurementData) {
	                // discharge
	                if (newEntry.dischargeData.dischargeMeasurementData.discharge &&
	                    oldEntry.dischargeData.dischargeMeasurementData.discharge) {
	                    formattedDischargeDataForTelegramProcessing.push({
	                        fieldName: 'discharge',
	                        label: 'discharge',
	                        newValue: newEntry.dischargeData.dischargeMeasurementData.discharge,
	                        oldValue: oldEntry.dischargeData.dischargeMeasurementData.discharge,
	                        overrideData: true,
	                        manualInputValue: null
	                    });
	                }
	                // waterlevel
	                if (newEntry.dischargeData.dischargeMeasurementData.waterLevel &&
	                    oldEntry.dischargeData.dischargeMeasurementData.waterLevel) {
	                    formattedDischargeDataForTelegramProcessing.push({
	                        fieldName: 'waterLevel',
	                        label: 'waterLevel',
	                        newValue: newEntry.dischargeData.dischargeMeasurementData.waterLevel,
	                        oldValue: oldEntry.dischargeData.dischargeMeasurementData.waterLevel,
	                        overrideData: true,
	                        manualInputValue: null
	                    });
	                }
	                // free river area
	                if (newEntry.dischargeData.dischargeMeasurementData.freeRiverArea &&
	                    oldEntry.dischargeData.dischargeMeasurementData.freeRiverArea) {
	                    formattedDischargeDataForTelegramProcessing.push({
	                        fieldName: 'freeRiverArea',
	                        label: 'freeRiverArea',
	                        newValue: newEntry.dischargeData.dischargeMeasurementData.freeRiverArea,
	                        oldValue: oldEntry.dischargeData.dischargeMeasurementData.freeRiverArea,
	                        overrideData: true,
	                        manualInputValue: null
	                    });
	                }
	                // maximum depth
	                if (newEntry.dischargeData.dischargeMeasurementData.maximumDepth &&
	                    oldEntry.dischargeData.dischargeMeasurementData.maximumDepth) {
	                    formattedDischargeDataForTelegramProcessing.push({
	                        fieldName: 'maximumDepth',
	                        label: 'maximumDepth',
	                        newValue: newEntry.dischargeData.dischargeMeasurementData.maximumDepth,
	                        oldValue: oldEntry.dischargeData.dischargeMeasurementData.maximumDepth,
	                        overrideData: true,
	                        manualInputValue: null
	                    });
	                }
	                // date
	                if (newEntry.dischargeData.dischargeMeasurementData.date &&
	                    oldEntry.dischargeData.dischargeMeasurementData.date) {
	                    formattedDischargeDataForTelegramProcessing.push({
	                        fieldName: 'date',
	                        label: 'date',
	                        newValue: newEntry.dischargeData.dischargeMeasurementData.date,
	                        oldValue: moment.unix(oldEntry.dischargeData.dischargeMeasurementData.date),
	                        overrideData: true,
	                        manualInputValue: null
	                    });
	                }
	            }
	            // temperatures
	            if (newEntry.dischargeData &&
	                newEntry.dischargeData.temperatures
	                &&
	                    oldEntry.dischargeData &&
	                oldEntry.dischargeData.temperatures) {
	                if (newEntry.dischargeData.temperatures.waterTemperature &&
	                    oldEntry.dischargeData.temperatures.waterTemperature) {
	                    formattedDischargeDataForTelegramProcessing.push({
	                        fieldName: 'waterTemperature',
	                        label: 'waterTemperature',
	                        newValue: newEntry.dischargeData.temperatures.waterTemperature,
	                        oldValue: oldEntry.dischargeData.temperatures.waterTemperature,
	                        overrideData: true,
	                        manualInputValue: null
	                    });
	                }
	                if (newEntry.dischargeData.temperatures.airTemperature &&
	                    oldEntry.dischargeData.temperatures.airTemperature) {
	                    formattedDischargeDataForTelegramProcessing.push({
	                        fieldName: 'airTemperature',
	                        label: 'airTemperature',
	                        newValue: newEntry.dischargeData.temperatures.airTemperature,
	                        oldValue: oldEntry.dischargeData.temperatures.airTemperature,
	                        overrideData: true,
	                        manualInputValue: null
	                    });
	                }
	            }
	            // ice phenomena
	            if (newEntry.dischargeData &&
	                newEntry.dischargeData.icePhenomenae
	                &&
	                    oldEntry.dischargeData &&
	                oldEntry.dischargeData.icePhenomenae) {
	                newEntry.dischargeData.icePhenomenae.forEach(function (iceDataItem, index) {
	                    var icePhenomenaeDataRows = [];
	                    icePhenomenaeDataRows.push({
	                        fieldName: 'code',
	                        label: 'Code',
	                        newValue: iceDataItem.code,
	                        oldValue: oldEntry.dischargeData.icePhenomenae[index] && oldEntry.dischargeData.icePhenomenae[index].code,
	                        overrideData: true,
	                        manualInputValue: null
	                    });
	                    icePhenomenaeDataRows.push({
	                        fieldName: 'intensity',
	                        label: 'Intensity',
	                        newValue: iceDataItem.intensity,
	                        oldValue: oldEntry.dischargeData.icePhenomenae[index] && oldEntry.dischargeData.icePhenomenae[index].intensity,
	                        overrideData: true,
	                        manualInputValue: null
	                    });
	                    formattedIceDataForTelegramProcessing.push(icePhenomenaeDataRows);
	                });
	            }
	        }
	        // meteo data
	        if (newEntry.meteoData && oldEntry.meteoData) {
	            if (newEntry.meteoData.airTemp && oldEntry.meteoData.airTemp) {
	                formattedMeteoDataForTelegramProcessing.push({
	                    fieldName: 'airTemperature',
	                    label: 'airTemperature',
	                    newValue: newEntry.meteoData.airTemp,
	                    oldValue: oldEntry.meteoData.airTemp,
	                    overrideData: true,
	                    manualInputValue: null
	                });
	            }
	            if (newEntry.meteoData.precipitation && oldEntry.meteoData.precipitation) {
	                formattedMeteoDataForTelegramProcessing.push({
	                    fieldName: 'precipitation',
	                    label: 'precipitation',
	                    newValue: newEntry.meteoData.precipitation,
	                    oldValue: oldEntry.meteoData.precipitation,
	                    overrideData: true,
	                    manualInputValue: null
	                });
	            }
	        }
	        return {
	            dailyData: formattedDailyDataForTelegramProcessing,
	            dischargeDataRows: formattedDischargeDataForTelegramProcessing,
	            meteoDataRows: formattedMeteoDataForTelegramProcessing,
	            icePhenomenaeDataRowsList: formattedIceDataForTelegramProcessing
	        };
	    };
	    return TelegramDataComparisonService;
	}());
	exports.TelegramDataComparisonService = TelegramDataComparisonService;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var curve_controller_1 = __webpack_require__(355);
	__webpack_require__(357);
	var template = __webpack_require__(358);
	var curveComponent = {
	    bindings: {
	        stationId: '<',
	        parsedTelegram: '<',
	        parsedTelegramDate: '<',
	        onModelChange: '&'
	    },
	    controller: curve_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = curveComponent;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var chart_color_service_1 = __webpack_require__(356);
	var immutable_1 = __webpack_require__(195);
	var OperationalInputCurveController = (function () {
	    function OperationalInputCurveController(dischargeModelApi, chartColorService, dataValueApi, curveSettingsApi, modelCreatorService, $scope, $q, $rootScope, imomoErrorService) {
	        var _this = this;
	        this.dischargeModelApi = dischargeModelApi;
	        this.chartColorService = chartColorService;
	        this.dataValueApi = dataValueApi;
	        this.curveSettingsApi = curveSettingsApi;
	        this.modelCreatorService = modelCreatorService;
	        this.$scope = $scope;
	        this.$q = $q;
	        this.$rootScope = $rootScope;
	        this.imomoErrorService = imomoErrorService;
	        this.currentHydrologicalYear = moment(this.parsedTelegramDate).year(); //hydrologicalYear(this.parsedTelegramDate);
	        this.measuredDischargeDataItems = immutable_1.List();
	        this.loadingInProgress = false;
	        this.$rootScope.$on('ALL_MODELS_UPDATED', function () {
	            _this.$onChanges();
	            _this.$rootScope.$broadcast('MODEL_CHANGE');
	        });
	    }
	    OperationalInputCurveController.prototype.$onChanges = function () {
	        var _this = this;
	        this.resetView();
	        this.parsedStationId = Number.parseInt(this.stationId);
	        if (!Number.isNaN(this.parsedStationId)) {
	            this.loadingInProgress = true;
	            this.currentHydrologicalYear = moment(this.parsedTelegramDate).year(); //hydrologicalYear(this.parsedTelegramDate);
	            var dischargeModelPromise = this.loadDischargeModels();
	            var dischargeDataPromise = this.loadDischargeData();
	            this.$q.all([dischargeModelPromise, dischargeDataPromise])
	                .finally(function () {
	                _this.loadingInProgress = false;
	            });
	            this.curveSettingsApi.getCurveSettings(this.parsedStationId)
	                .then(function (curveSettings) {
	                if (curveSettings) {
	                    _this.dischargeCurveSettings = curveSettings[0];
	                }
	            });
	        }
	        this.visibleCurveCreator =
	            this.parsedTelegram && this.parsedTelegram.dischargeData != null ||
	                this.selectedDischargeDataItems && this.selectedDischargeDataItems.size > 1;
	    };
	    Object.defineProperty(OperationalInputCurveController.prototype, "newModelDate", {
	        get: function () {
	            return this.parsedTelegram && this.parsedTelegram.dischargeData &&
	                this.parsedTelegram.dischargeData.date;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OperationalInputCurveController.prototype.addCurveCreatorController = function (curveCreatorController) {
	        this.curveCreatorController = curveCreatorController;
	    };
	    OperationalInputCurveController.prototype.onChartBoundsChange = function (curveSettings, userChange) {
	        this.minWaterLevel = curveSettings.minWaterLevel;
	        this.maxWaterLevel = curveSettings.maxWaterLevel;
	        if (userChange && this.parsedStationId) {
	            this.curveSettingsApi.createCurveSettings(curveSettings, this.parsedStationId);
	        }
	    };
	    OperationalInputCurveController.prototype.onSelectedDischargeDataItemsChange = function (selectedDischargeDataItems) {
	        this.selectedDischargeDataItems = selectedDischargeDataItems;
	    };
	    OperationalInputCurveController.prototype.onNewModelChange = function (newModel, created) {
	        var _this = this;
	        if (created) {
	            if (this.newModel) {
	                this.dischargeModelItems = this.dischargeModelItems.shift();
	            }
	            this.dischargeModelItems = this.dischargeModelItems.unshift({
	                dischargeModel: newModel,
	                enabled: true,
	                colors: chart_color_service_1.IChartColorService.BLACK_COLORS
	            });
	            this.enabledModel.enabled = false;
	            this.onModelChange({
	                dischargeModel: newModel,
	                created: true
	            });
	            this.dischargeModelApi.createDischargeModel({
	                modelName: newModel.modelName,
	                paramA: newModel.paramA,
	                paramB: newModel.paramB,
	                paramC: newModel.paramC,
	                paramDeltaLevel: newModel.paramDeltaLevel,
	                validFrom: newModel.validFrom ? moment.unix(newModel.validFrom) : null,
	                siteId: Number.parseInt(this.stationId)
	            })
	                .then(function (dischargeModel) {
	                _this.newModel.id = dischargeModel.id;
	                _this.$rootScope.$broadcast('MODEL_CHANGE');
	            })
	                .catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	            });
	        }
	        else {
	            this.dischargeModelItems = this.dischargeModelItems.shift();
	            this.enabledModel.enabled = true;
	            this.onModelChange({
	                dischargeModel: this.enabledModel.dischargeModel,
	                created: false
	            });
	            this.dischargeModelApi.deleteDischargeModel(this.newModel.id).then(function () {
	                _this.$rootScope.$broadcast('MODEL_CHANGE');
	            });
	        }
	        this.newModel = newModel;
	        this.$rootScope.$broadcast('NEW_MODEL_UPDATED');
	    };
	    OperationalInputCurveController.prototype.loadDischargeModels = function () {
	        var _this = this;
	        var deferred = this.$q.defer();
	        // add last model from the previous year to the list of models in the current year
	        this.dischargeModelApi
	            .getDischargeModels(this.parsedStationId, (this.currentHydrologicalYear - 1))
	            .then(function (dischargeModelsFromPreviousYear) {
	            var lastDischargeModelFromPreviousYear = dischargeModelsFromPreviousYear.slice(-1);
	            _this.dischargeModelApi
	                .getDischargeModels(_this.parsedStationId, _this.currentHydrologicalYear)
	                .then(function (dischargeModels) {
	                var isModelValidInCurrantAndPrevYear = false;
	                dischargeModels.forEach(function (model) {
	                    if (model.id === lastDischargeModelFromPreviousYear[0].id) {
	                        isModelValidInCurrantAndPrevYear = true;
	                    }
	                });
	                _this.dischargeModels = isModelValidInCurrantAndPrevYear ? dischargeModels : lastDischargeModelFromPreviousYear.concat(dischargeModels);
	                _this.dischargeModelItems = immutable_1.List(dischargeModels.map(function (model, index) {
	                    return {
	                        dischargeModel: model,
	                        enabled: false,
	                        colors: _this.chartColorService.getColors(index)
	                    };
	                }));
	                if (_this.dischargeModelItems.size) {
	                    var isModelEnabled_1 = false;
	                    _this.dischargeModelItems.forEach(function (dischargeModel) {
	                        if (dischargeModel.dischargeModel.validFrom <= moment(_this.parsedTelegramDate).unix() && !isModelEnabled_1) {
	                            dischargeModel.enabled = true;
	                            _this.enabledModel = dischargeModel;
	                            isModelEnabled_1 = true;
	                        }
	                    });
	                    // this.dischargeModelItems.first().enabled = true;
	                    //this.dischargeModelItems = List([this.enabledModel])
	                    _this.onModelChange({
	                        dischargeModel: _this.enabledModel.dischargeModel,
	                        created: false
	                    });
	                }
	                deferred.resolve();
	            });
	        });
	        return deferred.promise;
	    };
	    OperationalInputCurveController.prototype.loadDischargeData = function () {
	        var _this = this;
	        var deferred = this.$q.defer();
	        // "We want you to save the last 3 points in the Discharge data when switching to the hydrological year
	        //     so that we ourselves can form a curve for the new hydrological year at these three points"
	        this.dataValueApi.getDischargePairs(this.parsedStationId, (this.currentHydrologicalYear - 1))
	            .then(function (dischargePairsFromPrevHydroyear) {
	            var lastThreeDischargePairsFromPrevHydroyear = dischargePairsFromPrevHydroyear.slice(0, 3);
	            _this.dataValueApi.getDischargePairs(_this.parsedStationId, _this.currentHydrologicalYear)
	                .then(function (dischargePairs) {
	                dischargePairs = dischargePairs.concat(lastThreeDischargePairsFromPrevHydroyear);
	                _this.loadedDischargeDataItems = immutable_1.List(dischargePairs
	                    .map(function (dischargeMeasurementPair) {
	                    return {
	                        date: moment
	                            .unix(dischargeMeasurementPair.waterLevel.localDateTime).utc(),
	                        waterLevel: dischargeMeasurementPair.waterLevel.dataValue,
	                        discharge: dischargeMeasurementPair.discharge.dataValue
	                    };
	                }));
	                _this.updateDischargeDataItems();
	                deferred.resolve();
	            });
	        });
	        return deferred.promise;
	    };
	    OperationalInputCurveController.prototype.updateDischargeDataItems = function () {
	        this.measuredDischargeDataItems = immutable_1.List(this.loadedDischargeDataItems);
	        if (this.parsedTelegram && this.parsedTelegram.dischargeData) {
	            var dischargeDataItem = {
	                date: moment(this.parsedTelegram.dischargeData.date),
	                waterLevel: this.parsedTelegram.dischargeData.waterLevel,
	                discharge: this.parsedTelegram.dischargeData.discharge
	            };
	            this.measuredDischargeDataItems =
	                this.measuredDischargeDataItems.unshift(dischargeDataItem);
	        }
	    };
	    OperationalInputCurveController.prototype.resetView = function () {
	        this.onModelChange({ dischargeModel: null, created: false });
	        this.loadedDischargeDataItems = immutable_1.List();
	        this.measuredDischargeDataItems = immutable_1.List();
	        this.dischargeModels = [];
	        this.dischargeModelItems = immutable_1.List();
	        this.newModel = null;
	        if (this.curveCreatorController) {
	            this.curveCreatorController.resetCreatorForm();
	        }
	    };
	    OperationalInputCurveController.$inject = ['dischargeModelApi', 'chartColorService', 'dataValueApi', 'curveSettingsApi',
	        'modelCreatorService', '$scope', '$q', '$rootScope', 'imomoErrorService'];
	    return OperationalInputCurveController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalInputCurveController;


/***/ },
/* 356 */
/***/ function(module, exports) {

	"use strict";
	var IChartColorService;
	(function (IChartColorService) {
	    IChartColorService.BLACK_COLORS = {
	        backgroundColor: 'rgba(0, 0, 0, 1)',
	        foregroundColor: 'rgba(255, 255, 255, 1)',
	        iconColor: 'rgba(255, 255, 255, 1)'
	    };
	})(IChartColorService = exports.IChartColorService || (exports.IChartColorService = {}));
	var ChartColorService = (function () {
	    function ChartColorService($mdColors) {
	        this.$mdColors = $mdColors;
	    }
	    ChartColorService.prototype.getColors = function (index) {
	        return {
	            backgroundColor: this.getColor(index),
	            foregroundColor: ChartColorService.getForegroundColor(index),
	            iconColor: ChartColorService.getIconColor(index)
	        };
	    };
	    ChartColorService.prototype.getColor = function (index) {
	        return this.$mdColors.getThemeColor(ChartColorService.
	            COLORS[index % ChartColorService.COLORS.length] + "-500-1");
	    };
	    ChartColorService.getForegroundColor = function (index) {
	        if (ChartColorService.DARK_BACKGROUNDS[index]) {
	            return 'rgba(255, 255, 255, 1)';
	        }
	        else {
	            return 'rgba(0, 0, 0, 1)';
	        }
	    };
	    ChartColorService.getIconColor = function (index) {
	        if (ChartColorService.DARK_BACKGROUNDS[index]) {
	            return 'rgba(255, 255, 255, 1)';
	        }
	        else {
	            return 'rgba(0, 0, 0, .54)';
	        }
	    };
	    ChartColorService.$inject = ['$mdColors'];
	    ChartColorService.COLORS = [
	        'deep-purple', 'light-blue', 'green', 'yellow',
	        'blue-grey', 'indigo', 'cyan', 'light-green', 'amber',
	        'brown', 'purple', 'blue', 'teal', 'lime', 'grey'
	    ];
	    ChartColorService.DARK_BACKGROUNDS = [
	        true, true, false, false, false, true, true, true, true, false, false,
	        false, true, true, true, true, false, false, false
	    ];
	    return ChartColorService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ChartColorService;


/***/ },
/* 357 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 358 */
/***/ function(module, exports) {

	module.exports = "<md-progress-linear ng-disabled=!$ctrl.loadingInProgress md-mode=indeterminate></md-progress-linear> <section layout=row flex imomo-discharge-data-list-curve imomo-discharge-model-list-curve class=operational-curve-container ng-class=\"{'long': $ctrl.visibleCurveCreator}\"> <section class=\"operational-curve left-column\" layout=column> <imomo-discharge-curve class=operational-curve curve-settings=$ctrl.dischargeCurveSettings on-bounds-change=\"$ctrl.onChartBoundsChange(curveSettings, userChange)\"> </imomo-discharge-curve> <imomo-operational-input-curve-creator ng-if=$ctrl.visibleCurveCreator discharge-models=$ctrl.dischargeModels selected-discharge-data-items=$ctrl.selectedDischargeDataItems new-model=$ctrl.newModel starting-date=$ctrl.newModelDate on-new-model-change=\"$ctrl.onNewModelChange(newModel, created)\"> </imomo-operational-input-curve-creator> </section> <section layout=column class=\"operational-curve right-column\"> <imomo-discharge-model-list layout=row discharge-model-items=$ctrl.dischargeModelItems disabled-delete=true min-water-level=$ctrl.minWaterLevel max-water-level=$ctrl.maxWaterLevel> </imomo-discharge-model-list> <imomo-discharge-data-list layout=row class=data-list-card measured-discharge-data-items=$ctrl.measuredDischargeDataItems on-selected-items-change=$ctrl.onSelectedDischargeDataItemsChange(selectedDischargeDataItems)> </imomo-discharge-data-list> </section> </section>";

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var input_controller_1 = __webpack_require__(360);
	var template = __webpack_require__(361);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: input_controller_1.default,
	    template: template
	};


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	/**
	 * Steps required for submitting operational data.
	 */
	var OperationalInputSteps;
	(function (OperationalInputSteps) {
	    OperationalInputSteps[OperationalInputSteps["Telegram"] = 0] = "Telegram";
	    OperationalInputSteps[OperationalInputSteps["DataOverview"] = 1] = "DataOverview";
	    OperationalInputSteps[OperationalInputSteps["DataProcessing"] = 2] = "DataProcessing";
	    OperationalInputSteps[OperationalInputSteps["Save"] = 3] = "Save";
	})(OperationalInputSteps || (OperationalInputSteps = {}));
	var IInputEvents;
	(function (IInputEvents) {
	    IInputEvents.INPUT_SUBMITTED = 'imomo-input-submitted';
	})(IInputEvents = exports.IInputEvents || (exports.IInputEvents = {}));
	/**
	 * Controller for the operational input tool.
	 */
	var OperationalInputController = (function () {
	    function OperationalInputController($stateParams, $state, dataValueApi, imomoErrorService, $q, dailyDataService, dischargeModelApi, telegramDataComparisonService, $rootScope, $translate) {
	        var _this = this;
	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.dataValueApi = dataValueApi;
	        this.imomoErrorService = imomoErrorService;
	        this.$q = $q;
	        this.dailyDataService = dailyDataService;
	        this.dischargeModelApi = dischargeModelApi;
	        this.telegramDataComparisonService = telegramDataComparisonService;
	        this.$rootScope = $rootScope;
	        this.$translate = $translate;
	        this.automaticallyProcessedTelegramDailyDataParamsCollection = [];
	        /**
	         * Whether the discharge model was created in this session.
	         */
	        this.createdDischargeModel = false;
	        this.telegrams = $stateParams.telegrams || [];
	        this.$rootScope.$on('MODEL_CHANGE', function () {
	            _this.onTelegramProcessed(_this.parsedTelegramDataCollection, _this.unprocessedTelegrams);
	        });
	    }
	    /**
	     * Hook to process changes to the telegram parameter.
	     */
	    OperationalInputController.prototype.uiOnParamsChanged = function (newParams) {
	        this.telegrams = newParams.telegrams || [];
	        this.selectedTabIndex = 0;
	    };
	    Object.defineProperty(OperationalInputController.prototype, "nextButtonDisabled", {
	        /**
	         * Whether the button for the next step can be clicked.
	         */
	        get: function () {
	            switch (this.selectedTabIndex) {
	                case OperationalInputSteps.Telegram:
	                    return !this.telegramStepValid;
	                case OperationalInputSteps.DataOverview:
	                    return false;
	                case OperationalInputSteps.DataProcessing:
	                    return false;
	                default:
	                    return true;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OperationalInputController.prototype, "previousButtonDisabled", {
	        /**
	         * Whether the button for previous button can be clicked.
	         */
	        get: function () {
	            return this.selectedTabIndex == OperationalInputSteps.Telegram;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OperationalInputController.prototype, "submitButtonShown", {
	        /**
	         * Whether the button for submitting the data can be shown.
	         */
	        get: function () {
	            return this.selectedTabIndex == OperationalInputSteps.Save;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OperationalInputController.prototype, "submitButtonDisabled", {
	        /**
	         * Whether the button for submitting data can be clicked.
	         */
	        get: function () {
	            return this.processedData && !this.processedData.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Advances one step/tab.
	     */
	    OperationalInputController.prototype.goToNextStep = function () {
	        this.selectedTabIndex++;
	    };
	    /**
	     * Goes back one step/tab.
	     */
	    OperationalInputController.prototype.goToPreviousStep = function () {
	        this.selectedTabIndex--;
	    };
	    /**
	     * Stores the processed telegram and loaded station data.
	     */
	    OperationalInputController.prototype.onTelegramProcessed = function (parsedTelegramDataCollection, unprocessedTelegrams) {
	        var _this = this;
	        this.parsedTelegramDataCollection = parsedTelegramDataCollection;
	        this.unprocessedTelegrams = unprocessedTelegrams;
	        this.splitTelegramData(parsedTelegramDataCollection)
	            .then(function (splittedTelegramData) {
	            _this.completedTelegrams = splittedTelegramData.completedTelegrams;
	            _this.telegramsRequiringAction = splittedTelegramData.telegramsRequiringAction;
	            _this.telegramDataForProcessing = splittedTelegramData.telegramDataForProcessing;
	            _this.telegramStepValid =
	                _this.completedTelegrams && _this.completedTelegrams.length != 0 ||
	                    _this.telegramsRequiringAction && _this.telegramsRequiringAction.length != 0;
	            _this.dischargeModelStepValid = _this.telegramStepValid
	                && _this.dischargeModelStepValid;
	            if (unprocessedTelegrams && unprocessedTelegrams.length) {
	                _this.$state.go('.', { telegrams: unprocessedTelegrams });
	            }
	        });
	    };
	    OperationalInputController.prototype.splitTelegramData = function (parsedTelegramDataCollection) {
	        var _this = this;
	        // this function has to calculate the data that would be submitted to the daily_data_new endpoint
	        var deferred = this.$q.defer();
	        var telegramDataPromises = [];
	        var dischargeModelAndParsedTelegramPromises = [];
	        var dailyDataAndDischargeModelAndParsedTelegramPromises = [];
	        var telegramsRequiringAction = [];
	        var telegramDataForProcessing = [];
	        var parsedTelegramDataCollectionCached = angular.copy(parsedTelegramDataCollection);
	        var automaticallyProcessedTelegrams = parsedTelegramDataCollectionCached;
	        this.automaticallyProcessedTelegramDailyDataParamsCollection = [];
	        // get discharge models for telegram data
	        angular.forEach(parsedTelegramDataCollection, function (parsedTelegramData) {
	            if (parsedTelegramData.waterLevelData || parsedTelegramData.dischargeData) {
	                var dischargeModelPromise = _this.dischargeModelApi
	                    .getDischargeModels(parsedTelegramData.station.id, moment(parsedTelegramData.overriddenDate).year()); // hydrologicalYear(parsedTelegramData.overriddenDate)
	                // parsedTelegramData is passed down through the promises for the convenience sake                                          
	                var dischargeModelAndParsedTelegramPromise = _this.$q.all([dischargeModelPromise, parsedTelegramData]);
	                dischargeModelAndParsedTelegramPromises.push(dischargeModelAndParsedTelegramPromise);
	            }
	            else {
	                var dischargeModelAndParsedTelegramPromise = _this.$q.all([null, parsedTelegramData]);
	                dischargeModelAndParsedTelegramPromises.push(dischargeModelAndParsedTelegramPromise);
	            }
	        });
	        if (dischargeModelAndParsedTelegramPromises && dischargeModelAndParsedTelegramPromises.length) {
	            // get daily data using discharge models
	            this.$q.all(dischargeModelAndParsedTelegramPromises)
	                .then(function (dischargeModelsAndParsedTelegrams) {
	                var dataCheckPromises = [];
	                var chronologicalDischargeModel;
	                var previousDischargeModel;
	                dischargeModelsAndParsedTelegrams.forEach(function (_a) {
	                    var dischargeModels = _a[0], parsedTelegramData = _a[1];
	                    if (dischargeModels && dischargeModels.length) {
	                        dischargeModels.forEach(function (dischargeModel, i) {
	                            if (!chronologicalDischargeModel &&
	                                (!dischargeModel.validFrom ||
	                                    moment.unix(dischargeModel.validFrom) <= moment.unix(parsedTelegramData.overriddenDate))) {
	                                chronologicalDischargeModel = dischargeModel;
	                                if (dischargeModels.length > 1) {
	                                    previousDischargeModel = dischargeModels[i + 1];
	                                }
	                            }
	                        });
	                        var deferred_1 = _this.$q.defer();
	                        // check daily data 
	                        _this.dailyDataService.getDailyDataAtOnce(parsedTelegramData, chronologicalDischargeModel, _this.createdDischargeModel, previousDischargeModel)
	                            .then(function (dailyData) {
	                            var calculatedTelegramData = {
	                                dischargeData: {
	                                    date: parsedTelegramData.overriddenDate,
	                                    siteId: parsedTelegramData.station.id,
	                                    dailyData: dailyData,
	                                    dischargeModelParams: {
	                                        dischargeModel: chronologicalDischargeModel,
	                                        createdDischargeModel: _this.createdDischargeModel
	                                    },
	                                    dischargeMeasurementData: parsedTelegramData.dischargeData,
	                                    temperatures: parsedTelegramData.temperatureData,
	                                    icePhenomenae: parsedTelegramData.icePhenomenaCardData.icePhenomenae
	                                }
	                            };
	                            if (parsedTelegramData.meteoData && parsedTelegramData.meteoData.siteId) {
	                                calculatedTelegramData.meteoData = parsedTelegramData.meteoData;
	                            }
	                            _this.dataValueApi.checkDailyData(calculatedTelegramData)
	                                .then(function (checkedData) {
	                                deferred_1.resolve([checkedData, calculatedTelegramData, parsedTelegramData]);
	                            })
	                                .catch(function (error) {
	                                _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                            });
	                        });
	                        dataCheckPromises.push(deferred_1.promise);
	                    }
	                    else {
	                        if (parsedTelegramData.waterLevelData || parsedTelegramData.dischargeData) {
	                            _this.$translate.instant('NO_DISCHARGE_CURVE_FOR_SITE_WITH_CODE', { siteCode: parsedTelegramData.station.siteCode });
	                        }
	                        else if (parsedTelegramData.meteoData && parsedTelegramData.meteoData.siteId) {
	                            var deferred_2 = _this.$q.defer();
	                            var calculatedTelegramData_1 = {
	                                meteoData: parsedTelegramData.meteoData
	                            };
	                            _this.dataValueApi.checkDailyData(calculatedTelegramData_1).then(function (checkedData) {
	                                deferred_2.resolve([checkedData, calculatedTelegramData_1, parsedTelegramData]);
	                            });
	                            dataCheckPromises.push(deferred_2.promise);
	                        }
	                    }
	                });
	                _this.$q.all(dataCheckPromises)
	                    .then(function (values) {
	                    values.forEach(function (_a) {
	                        var checkedData = _a[0], calculatedTelegramData = _a[1], parsedTelegramData = _a[2];
	                        var comparisonData = _this.telegramDataComparisonService.formatDataForTelegramProcessing(calculatedTelegramData, checkedData);
	                        var isHqAdjustmentEnabled = parsedTelegramData.isHqAdjustmentEnabled;
	                        var isEntryInDatabase = comparisonData.dailyData.length ||
	                            comparisonData.dischargeDataRows.length ||
	                            comparisonData.meteoDataRows.length
	                            ?
	                                true : false;
	                        var isWaterLevelTrendDifferent;
	                        var isIcePhenomenaIncluded;
	                        if (checkedData.dischargeData) {
	                            isWaterLevelTrendDifferent = _this.checkWaterLevelTrend(parsedTelegramData, checkedData.dischargeData.dailyData);
	                            console.log('isWaterLevelTrendDifferent', isWaterLevelTrendDifferent);
	                            isIcePhenomenaIncluded =
	                                calculatedTelegramData.dischargeData.icePhenomenae && calculatedTelegramData.dischargeData.icePhenomenae.length ? true : false;
	                        }
	                        // Telegrams requiring action
	                        if (isHqAdjustmentEnabled ||
	                            isEntryInDatabase ||
	                            isWaterLevelTrendDifferent ||
	                            isIcePhenomenaIncluded) {
	                            telegramsRequiringAction.push(parsedTelegramData);
	                            telegramDataForProcessing.push({
	                                comparisonData: _this.telegramDataComparisonService.formatDataForTelegramProcessing(calculatedTelegramData, checkedData),
	                                actions: {
	                                    hqAdjustment: isHqAdjustmentEnabled,
	                                    entryCorrection: isEntryInDatabase,
	                                    waterLevelTrend: isWaterLevelTrendDifferent,
	                                    icePhenomena: isIcePhenomenaIncluded
	                                },
	                                calculatedTelegramData: calculatedTelegramData,
	                                parsedTelegramData: parsedTelegramData
	                            });
	                            automaticallyProcessedTelegrams.splice(_.findLastIndex(automaticallyProcessedTelegrams, {
	                                telegramText: parsedTelegramData.telegramText
	                            }), 1);
	                        }
	                        else {
	                            _this.automaticallyProcessedTelegramDailyDataParamsCollection.push({
	                                dailyDataParams: calculatedTelegramData,
	                                parsedTelegramData: parsedTelegramData
	                            });
	                        }
	                    });
	                    deferred.resolve({
	                        completedTelegrams: automaticallyProcessedTelegrams,
	                        telegramsRequiringAction: telegramsRequiringAction,
	                        telegramDataForProcessing: telegramDataForProcessing
	                    });
	                })
	                    .catch(function (error) {
	                    _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                });
	            })
	                .catch(function (error) {
	                deferred.reject(error);
	            });
	        }
	        return deferred.promise;
	    };
	    /**
	     * Stores the processed daily data.
	     */
	    OperationalInputController.prototype.onDataProcessed = function (telegramsRequiringActionFinalData, createdDischargeModel) {
	        this.processedData =
	            telegramsRequiringActionFinalData
	                .concat(this.automaticallyProcessedTelegramDailyDataParamsCollection);
	        this.createdDischargeModel = createdDischargeModel;
	    };
	    OperationalInputController.prototype.checkWaterLevelTrend = function (parsedTelegramData, oldEntryDailyData) {
	        var waterLevelTrendInDatabase;
	        angular.forEach(oldEntryDailyData, function (dailyTriplet, index) {
	            if (dailyTriplet.morningData && dailyTriplet.morningData.waterLevel && oldEntryDailyData[index - 1] &&
	                oldEntryDailyData[index - 1].morningData) {
	                waterLevelTrendInDatabase = dailyTriplet.morningData.waterLevel -
	                    oldEntryDailyData[index - 1].morningData.waterLevel;
	            }
	        });
	        return typeof waterLevelTrendInDatabase === 'undefined' ?
	            false : parsedTelegramData.waterLevelData.waterLevelTrend !== waterLevelTrendInDatabase;
	    };
	    /**
	     * Submits the processed data and created discharge model to the backend.
	     */
	    OperationalInputController.prototype.submitData = function () {
	        var _this = this;
	        this.submitInProgress = true;
	        var dailyDataPromises = [];
	        this.processedData.forEach(function (telegramDailyDataParams) {
	            _this.dataValueApi.storeDailyData(telegramDailyDataParams.dailyDataParams)
	                .catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(telegramDailyDataParams.parsedTelegramData.station.siteCode + ': ' + error.data.details);
	            });
	        });
	        this.$q.all(dailyDataPromises)
	            .then(function () {
	            _this.$state.go('.', { telegrams: '' });
	        }).catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	        }).finally(function () {
	            _this.submitInProgress = false;
	            _this.resetView();
	            _this.$rootScope.$broadcast(IInputEvents.INPUT_SUBMITTED);
	        });
	    };
	    OperationalInputController.prototype.resetView = function () {
	        this.telegramStepValid = false;
	        this.$stateParams.telegrams = null;
	        this.telegrams = [];
	        this.processedData = [];
	        this.completedTelegrams = [];
	        this.telegramsRequiringAction = [];
	        this.telegramDataForProcessing = [];
	        this.automaticallyProcessedTelegramDailyDataParamsCollection = [];
	    };
	    OperationalInputController.$inject = ['$stateParams', '$state', 'dataValueApi', 'imomoErrorService', '$q',
	        'dailyDataService', 'dischargeModelApi', 'telegramDataComparisonService', '$rootScope', '$translate'];
	    return OperationalInputController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalInputController;


/***/ },
/* 361 */
/***/ function(module, exports) {

	module.exports = "<div layout=column flex class=operational-input-container> <md-progress-linear ng-disabled=!$ctrl.submitInProgress></md-progress-linear> <md-tabs md-selected=$ctrl.selectedTabIndex class=full-height-tabs md-border-bottom flex> <md-tab> <md-tab-label> <span class=step-label>1</span> <span translate>TELEGRAM</span> </md-tab-label> <md-tab-body> <imomo-operational-input-telegram class=fill-tab layout=column params-telegrams=$ctrl.telegrams on-processed=\"$ctrl.onTelegramProcessed(parsedTelegramDataCollection, unprocessedTelegrams)\"> </imomo-operational-input-telegram> </md-tab-body> </md-tab> <md-tab ng-disabled=!$ctrl.telegramStepValid> <md-tab-label> <span class=step-label>2</span> <span translate>DATA_OVERVIEW</span> </md-tab-label> <md-tab-body> <imomo-operational-input-data-overview class=fill-tab layout=column completed-telegrams=$ctrl.completedTelegrams telegrams-requiring-action=$ctrl.telegramsRequiringAction on-processed=\"$ctrl.onTelegramProcessed(parsedTelegramDataCollection, unprocessedTelegrams)\">> </imomo-operational-input-data-overview> </md-tab-body> </md-tab> <md-tab ng-disabled=!$ctrl.telegramStepValid> <md-tab-label> <span class=step-label>3</span> <span translate>DATA_PROCESSING</span> </md-tab-label> <md-tab-body> <imomo-operational-input-data-processing class=fill-tab layout=column completed-telegrams=$ctrl.completedTelegrams telegram-data-for-processing=$ctrl.telegramDataForProcessing on-processed=\"$ctrl.onDataProcessed(telegramsRequiringActionFinalData, createdDischargeModel)\"> </imomo-operational-input-data-processing> </md-tab-body> </md-tab> <md-tab ng-disabled=!$ctrl.processedData.length> <md-tab-label> <span class=step-label>3</span> <span translate>SAVE_DATA</span> </md-tab-label> <md-tab-body> <imomo-operational-input-save class=fill-tab layout=column processed-data=$ctrl.processedData> </imomo-operational-input-save> </md-tab-body> </md-tab> </md-tabs> <md-divider></md-divider> <section layout=row> <md-button class=md-primary ng-disabled=$ctrl.previousButtonDisabled ng-click=$ctrl.goToPreviousStep()> <span translate>PREVIOUS</span> </md-button> <div flex></div> <md-button class=md-primary ng-disabled=$ctrl.nextButtonDisabled ng-click=$ctrl.goToNextStep() ng-hide=$ctrl.submitButtonShown> <span translate>NEXT</span> </md-button> <md-button class=md-accent ng-show=$ctrl.submitButtonShown ng-disabled=$ctrl.submitButtonDisabled ng-click=$ctrl.submitData()> <span translate>SUBMIT_DATA</span> </md-button> </section> </div>";

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var save_controller_1 = __webpack_require__(363);
	var template = __webpack_require__(364);
	__webpack_require__(365);
	var saveComponent = {
	    bindings: {
	        processedData: '<'
	    },
	    controller: save_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = saveComponent;


/***/ },
/* 363 */
/***/ function(module, exports) {

	"use strict";
	var OperationalInputSaveController = (function () {
	    function OperationalInputSaveController() {
	    }
	    OperationalInputSaveController.prototype.$onChanges = function (changes) {
	        if (changes.hasOwnProperty('processedData') && changes['processedData'].currentValue) {
	            this.processedData = changes['processedData'].currentValue;
	        }
	        // this.resetView();
	        // this.notifyProcessedData();
	        // if (this.station && this.parsedTelegram && this.dischargeModel) {
	        //   this.loadPreviousDailyData();
	        //   this.buildIcePhenomenaCard();
	        //   this.buildDischargeCard();
	        //   this.buildMeteoCard();
	        // }
	    };
	    OperationalInputSaveController.prototype.buildDischargeCard = function (telegramData) {
	        return telegramData.dailyDataParams.dischargeData && telegramData.dailyDataParams.dischargeData.dischargeMeasurementData;
	    };
	    OperationalInputSaveController.prototype.buildMeteoCard = function (telegramData) {
	        return telegramData.dailyDataParams.meteoData;
	    };
	    return OperationalInputSaveController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalInputSaveController;


/***/ },
/* 364 */
/***/ function(module, exports) {

	module.exports = "<md-card ng-if=$ctrl.processedData.length id=telegram-save> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>COMPLETED_TELEGRAMS</span> </md-toolbar> <md-table-container> <table md-table flex> <thead md-head> <tr md-row flex> <th md-column> <span translate>CODE</span> </th> <th md-column> <span translate>NAME</span> </th> <th md-column> <span translate>TYPE</span> </th> <th md-column> <span translate>DATE</span> </th> <th md-column> <span translate>EXPAND</span> </th> </tr> </thead> <tbody md-body ng-repeat=\"telegramData in $ctrl.processedData track by $index\"> <tr md-row ng-click=\"$ctrl['completedTelegramDataExpanded' + $index] = !$ctrl['completedTelegramDataExpanded' + $index];\"> <td md-cell> {{ telegramData.parsedTelegramData.station.siteCode }} </td> <td md-cell> {{ telegramData.parsedTelegramData.station.siteName }} </td> <td md-cell> <span ng-if=\"telegramData.parsedTelegramData.meteoData && \n                (telegramData.parsedTelegramData.waterLevelData || telegramData.parsedTelegramData.dischargeData)\"> discharge / meteo </span> <span ng-if=\"!telegramData.parsedTelegramData.meteoData && \n                (telegramData.parsedTelegramData.waterLevelData || telegramData.parsedTelegramData.dischargeData)\"> discharge </span> <span ng-if=\"telegramData.parsedTelegramData.meteoData && \n                !(telegramData.parsedTelegramData.waterLevelData || telegramData.parsedTelegramData.dischargeData)\"> meteo </span> </td> <td md-cell> {{ telegramData.parsedTelegramData.overriddenDate | momentFormatter:'overriddenDate-time' }} <span ng-if=\"telegramData.parsedTelegramData.meteoData && \n                !(telegramData.parsedTelegramData.waterLevelData || telegramData.parsedTelegramData.dischargeData)\">---</span> </td> <td md-cell> <md-button class=md-icon-button ng-if=\"!$ctrl['completedTelegramDataExpanded' + $index]\"> <md-icon>expand_more</md-icon> </md-button> <md-button class=md-icon-button ng-if=\"$ctrl['completedTelegramDataExpanded' + $index]\"> <md-icon>expand_less</md-icon> </md-button> </td> </tr> <tr md-row ng-if=\"$ctrl['completedTelegramDataExpanded' + $index]\"> <td md-cell colspan=5 class=telegram-data-content-cell> <h3 class=md-headline ng-if=\"telegramData.dailyDataParams.dischargeData && \n                  telegramData.dailyDataParams.dischargeData.dischargeModelParams &&\n                  telegramData.dailyDataParams.dischargeData.dischargeModelParams.dischargeModel\"> <span translate>DISCHARGE_MODEL</span>: <span class=md-title> {{ telegramData.dailyDataParams.dischargeData.dischargeModelParams.dischargeModel | dischargeModelFormatter }} </span> </h3> <md-card ng-if=telegramData.dailyDataParams.dischargeData.dailyData.length> <md-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column colspan=2> <span translate>DATE</span> </th> <th md-column colspan=2> <span translate>8_AM</span> </th> <th md-column colspan=2> <span translate>8_PM</span> </th> <th md-column colspan=2> <span translate>AVERAGE</span> </th> </tr> <tr md-row> <th md-column></th> <th md-column md-numeric> <span translate>H_CM</span> </th> <th md-column md-numeric> <span translate>Q_M3_S</span> </th> <th md-column md-numeric> <span translate>H_CM</span> </th> <th md-column md-numeric> <span translate>Q_M3_S</span> </th> <th md-column md-numeric> <span translate>H_CM</span> </th> <th md-column md-numeric> <span translate>Q_M3_S</span> </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"dataRow in telegramData.dailyDataParams.dischargeData.dailyData track by $index\"> <td md-cell>{{ dataRow.date | momentFormatter }}</td> <td md-cell ng-class=\"{'md-body-2': dataRow.morningData.highlighted}\"> {{ dataRow.morningData.waterLevel | hydroNumberFormatter }} </td> <td md-cell ng-class=\"{'md-body-2': dataRow.morningData.highlighted}\"> {{ dataRow.morningData.discharge | hydroNumberFormatter }} </td> <td md-cell ng-class=\"{'md-body-2': dataRow.eveningData.highlighted}\"> {{ dataRow.eveningData.waterLevel | hydroNumberFormatter }} </td> <td md-cell ng-class=\"{'md-body-2': dataRow.eveningData.highlighted}\"> {{ dataRow.eveningData.discharge | hydroNumberFormatter }} </td> <td md-cell ng-class=\"{'md-body-2': dataRow.averageData.highlighted}\"> {{ dataRow.averageData.waterLevel | hydroNumberFormatter }} </td> <td md-cell ng-class=\"{'md-body-2': dataRow.averageData.highlighted}\"> {{ dataRow.averageData.discharge | hydroNumberFormatter}} </td> </tr> </tbody> </table> </md-table-container> </md-card> <md-content layout=row layout-align=\"start start\" layout-wrap> <imomo-operational-input-discharge-card ng-show=$ctrl.buildDischargeCard(telegramData) discharge-data=$ctrl.buildDischargeCard(telegramData)> </imomo-operational-input-discharge-card> <imomo-operational-input-ice-phenomena-card ng-repeat=\"icePhenomena in telegramData.dailyDataParams.dischargeData.icePhenomenae\" ng-show=telegramData.dailyDataParams.dischargeData.icePhenomenae discharge-option-enabled=false index=$index card-data=\"{\n                      date: telegramData.parsedTelegramData.overriddenDate,\n                      icePhenomenae: icePhenomena,\n                      disabledDischarge: false\n                    }\"> </imomo-operational-input-ice-phenomena-card> <imomo-operational-input-temperature-card temperature-data=telegramData.dailyDataParams.dischargeData.temperatures ng-if=telegramData.dailyDataParams.dischargeData.temperatures> </imomo-operational-input-temperature-card> <imomo-operational-input-meteo-card meteo-data=telegramData.dailyDataParams.meteoData ng-show=telegramData.dailyDataParams.meteoData> </imomo-operational-input-meteo-card> </md-content> </td> </tr> </tbody> </table> </md-table-container> </md-card>";

/***/ },
/* 365 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var telegram_controller_1 = __webpack_require__(367);
	var template = __webpack_require__(368);
	var telegramComponent = {
	    bindings: {
	        paramsTelegrams: '<',
	        onProcessed: '&'
	    },
	    controller: telegram_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = telegramComponent;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var immutable_1 = __webpack_require__(195);
	var input_controller_1 = __webpack_require__(360);
	var OperationalInputTelegramController = (function () {
	    function OperationalInputTelegramController(kn15ParseService, operationalInputService, stationApi, $q, $log, imomoErrorService, $mdDialog, $translate, $state, $timeout, $rootScope) {
	        var _this = this;
	        this.kn15ParseService = kn15ParseService;
	        this.operationalInputService = operationalInputService;
	        this.stationApi = stationApi;
	        this.$q = $q;
	        this.$log = $log;
	        this.imomoErrorService = imomoErrorService;
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.$rootScope = $rootScope;
	        this.unprocessedTelegrams = [];
	        this.parsedTelegramDataCollection = [];
	        this.stationAndTrendDataPromises = [];
	        this.telegramsBackendErrorMessages = [];
	        this.telegramsMeteoWarningMessages = [];
	        this.loadSitesWithoutTelegramForToday();
	        this.$rootScope.$on(input_controller_1.IInputEvents.INPUT_SUBMITTED, function () {
	            _this.loadSitesWithoutTelegramForToday();
	        });
	        if (this.paramsTelegrams) {
	            this.unprocessedTelegrams = this.paramsTelegrams;
	            this.processTelegrams();
	        }
	        $timeout(function () {
	            var initialTelegramInput = document.getElementById('bulk-telegram-input');
	            initialTelegramInput.focus();
	            //enable only the paste event
	            initialTelegramInput.addEventListener('keypress', function (evt) {
	                var theEvent = evt;
	                var regex = /[]|\./;
	                var key = theEvent.keyCode || theEvent.which;
	                key = String.fromCharCode(key);
	                if (!regex.test(key)) {
	                    theEvent.returnValue = false;
	                    if (theEvent.preventDefault)
	                        theEvent.preventDefault();
	                }
	            });
	        });
	    }
	    /**
	     * Hook that processes changes in the one-directional bindings.
	     */
	    OperationalInputTelegramController.prototype.$onChanges = function (changes) {
	        // this.resetView();
	        if (changes.hasOwnProperty('paramsTelegrams')) {
	            this.unprocessedTelegrams = changes['paramsTelegrams'].currentValue;
	        }
	        this.onChanges();
	    };
	    OperationalInputTelegramController.prototype.$postLink = function () {
	        var _this = this;
	        this.$log.debug('Post link called.');
	        angular.forEach(this.unprocessedTelegrams, function (telegramText, index) {
	            _this.displayError(index);
	        });
	    };
	    OperationalInputTelegramController.prototype.loadSitesWithoutTelegramForToday = function () {
	        var _this = this;
	        var currentDate = moment();
	        this.$q.all([
	            this.stationApi.getDischargeStationsWithTelegramByDate(currentDate, false),
	            this.stationApi.getMeteoStationsWithTelegramByDate(currentDate, false)
	        ])
	            .then(function (_a) {
	            var dischargeStations = _a[0], meteoStations = _a[1];
	            _this.dischargeStationsWithMissingDataForToday = dischargeStations[0].sites;
	            _this.meteoStationsWithMissingDataForToday = meteoStations[0].sites;
	        });
	    };
	    OperationalInputTelegramController.prototype.resetView = function () {
	        this.parsedTelegramDataCollection = [];
	        this.stationAndTrendDataPromises = [];
	        this.telegramsBackendErrorMessages = [];
	        this.telegramsMeteoWarningMessages = [];
	    };
	    OperationalInputTelegramController.prototype.onChanges = function () {
	        //this.notifyChanges();
	        if (this.telegrams) {
	            this.processTelegrams();
	        }
	        else {
	            if (this.telegramForm) {
	                this.telegramForm.$setUntouched();
	                this.telegramForm.$setPristine();
	            }
	        }
	    };
	    OperationalInputTelegramController.prototype.onProcessButtonClick = function () {
	        this.parsedTelegramDataCollection = [];
	        //this.notifyChanges();
	        this.processTelegrams();
	    };
	    OperationalInputTelegramController.prototype.processTelegrams = function () {
	        var _this = this;
	        this.stationAndTrendDataPromises = [];
	        this.parsedTelegramDataCollection = [];
	        this.telegramsBackendErrorMessages = [];
	        angular.forEach(this.unprocessedTelegrams, function (telegramText, index) {
	            _this.processTelegram(telegramText, index);
	        });
	    };
	    /**
	     * Processes the telegram text input and builds the parsed data views.
	     */
	    OperationalInputTelegramController.prototype.processTelegram = function (telegramText, index) {
	        var _this = this;
	        var self = this;
	        self.processingInProgress = true;
	        var parsedTelegram = null;
	        var overrideDate = null;
	        var isMeteoStationDataOnly;
	        try {
	            parsedTelegram = self.kn15ParseService.parse(telegramText);
	        }
	        catch (error) {
	            self.displayError(index);
	            self.processingInProgress = false;
	            return;
	        }
	        var dischargeStationPromise = isMeteostationDataOnly(parsedTelegram) ? null :
	            this.stationApi.getDischargeStation({
	                stationCode: parsedTelegram.sectionZero.stationCode
	            });
	        if (parsedTelegram.sectionZero) {
	            this.telegramsBackendErrorMessages.push('');
	            var trendDataPromise = parsedTelegram.sectionOne ? self.operationalInputService.verifyWaterTrend(parsedTelegram.sectionZero.date, parsedTelegram.sectionZero.stationCode, parsedTelegram.sectionOne.waterLevelAtEight, parsedTelegram.sectionOne.waterLevelTrend) : null;
	            this.stationAndTrendDataPromises.push(self.$q.all([dischargeStationPromise, trendDataPromise, parsedTelegram, overrideDate])
	                .catch(function (error) {
	                errorHandling(error);
	                self.processingInProgress = false;
	            }));
	            // last iteration
	            if ((index || index === 0) &&
	                index === (this.unprocessedTelegrams.length - 1)) {
	                self.$q.all(this.stationAndTrendDataPromises)
	                    .then(function (values) {
	                    // value of failed promise is 'undefined' and we want to continue the process only if 
	                    // there is a station for every telegram's station code
	                    if (values.indexOf(undefined) === -1) {
	                        var promises_1 = [];
	                        values.forEach(function (_a, promiseIndex) {
	                            var dischargeStation = _a[0], trendResponse = _a[1], parsedTelegram = _a[2], overrideDate = _a[3];
	                            var deferred = self.$q.defer();
	                            if (parsedTelegram.sectionEight) {
	                                var meteostationPromise = _this.stationApi.getMeteoStation({
	                                    stationCode: parsedTelegram.sectionZero.stationCode
	                                })
	                                    .then(function (meteoStation) {
	                                    parsedTelegram.sectionEight.siteId = meteoStation.id;
	                                    self.telegramsMeteoWarningMessages[promiseIndex] = '';
	                                    var station = isMeteostationDataOnly(parsedTelegram) ? meteoStation : dischargeStation;
	                                    deferred.resolve([parsedTelegram, station, trendResponse, overrideDate, promiseIndex]);
	                                })
	                                    .catch(function (errorData) {
	                                    var stationCode = parsedTelegram.sectionZero.stationCode;
	                                    self.telegramsMeteoWarningMessages[promiseIndex] =
	                                        self.$translate.instant('NO_METEOSTATION_FOR_CODE_EXTENDED', { stationCode: stationCode });
	                                    if (isMeteostationDataOnly(parsedTelegram)) {
	                                        deferred.resolve();
	                                        _this.processingInProgress = false;
	                                    }
	                                    else {
	                                        deferred.resolve([parsedTelegram, dischargeStation, trendResponse, overrideDate, promiseIndex]);
	                                    }
	                                });
	                            }
	                            else {
	                                deferred.resolve([parsedTelegram, dischargeStation, trendResponse, overrideDate, promiseIndex]);
	                            }
	                            promises_1.push(deferred.promise);
	                        });
	                        self.$q.all(promises_1)
	                            .then(function (values) {
	                            values.forEach(function (_a) {
	                                var parsedTelegram = _a[0], station = _a[1], trendResponse = _a[2], overrideDate = _a[3], promiseIndex = _a[4];
	                                self.onStationTrendDataLoaded(parsedTelegram, station, trendResponse, overrideDate, promiseIndex);
	                                self.processingInProgress = false;
	                            });
	                        });
	                    }
	                }).catch(function (error) {
	                    errorHandling(error);
	                    self.processingInProgress = false;
	                });
	            }
	        }
	        else {
	            dischargeStationPromise.then(function (station) {
	                self.notifyChanges();
	                self.processingInProgress = false;
	            }).catch(function (error) {
	                errorHandling(error);
	                self.processingInProgress = false;
	            });
	        }
	        function errorHandling(error) {
	            var stationCode = parsedTelegram.sectionZero.stationCode;
	            if (error.status == 400 || error.status == 404) {
	                // self.imomoErrorService.showMissingStationErrorDialog(
	                //     parsedTelegram.sectionZero.stationCode);
	                self.telegramForm['telegram' + index].$setValidity('backendError', false);
	                self.telegramsBackendErrorMessages[index] = self.$translate.instant('NON_EXISTENT_STATION_CODE_EXTENDED', { stationCode: stationCode });
	                self.telegramForm['telegram' + index].$setDirty();
	                self.telegramForm['telegram' + index].$setTouched();
	            }
	            else if (error.status == 403) {
	                self.imomoErrorService.showForbiddenStationErrorDialog(stationCode);
	            }
	            else {
	                self.imomoErrorService.showGenericErrorDialog();
	            }
	        }
	        function isMeteostationDataOnly(parsedTelegram) {
	            return parsedTelegram &&
	                immutable_1.Stack(parsedTelegram.telegramText.trim().split(/\s+/)).get(1).indexOf('988') != -1;
	        }
	    };
	    // backend error message is displayed only after process button is pressed
	    // so if there is a missing station error and user enters new code
	    // message will still be present
	    // this removes old message to prevent confusion
	    OperationalInputTelegramController.prototype.onIndividualTelegramInputChange = function ($index) {
	        this.telegramsBackendErrorMessages[$index] = '';
	        this.telegramForm['telegram' + $index].$setValidity('backendError', true);
	    };
	    OperationalInputTelegramController.prototype.onStationTrendDataLoaded = function (parsedTelegram, station, trendResponse, overrideDate, promiseIndex) {
	        var parsedTelegramData = {
	            telegramText: parsedTelegram.telegramText,
	            station: null,
	            overriddenDate: null,
	            overrideDate: overrideDate,
	            waterLevelData: null,
	            dischargeData: null,
	            icePhenomenaCardData: null,
	            temperatureData: null,
	            meteoData: null,
	            isHqAdjustmentEnabled: parsedTelegram.sectionOne && parsedTelegram.sectionSix ? true : false
	        };
	        parsedTelegramData.station = station;
	        parsedTelegramData.overriddenDate = parsedTelegram.sectionZero.date && parsedTelegram.sectionZero.date.toDate();
	        var averageWaterLevel = this.operationalInputService
	            .calculateAverageWaterLevel(parsedTelegram.sectionOne && parsedTelegram.sectionOne.waterLevelAtTwenty, trendResponse && trendResponse.previousWaterLevelAtEight);
	        var previousDate = moment(parsedTelegram.sectionZero.date)
	            .subtract(1, 'day');
	        if (parsedTelegram.sectionOne && parsedTelegram.sectionOne.temperatures) {
	            parsedTelegramData.temperatureData = {
	                airTemperature: parsedTelegram.sectionOne.temperatures.airTemperature,
	                waterTemperature: parsedTelegram.sectionOne.temperatures.waterTemperature,
	                telegramDay: parsedTelegram.sectionZero.date
	            };
	        }
	        else {
	            parsedTelegramData.temperatureData = undefined;
	        }
	        if (parsedTelegram.sectionOne) {
	            parsedTelegramData.waterLevelData = {
	                averageWaterLevel: parsedTelegram.sectionThree ?
	                    parsedTelegram.sectionThree.waterLevelAverage : averageWaterLevel,
	                telegramDate: parsedTelegram.sectionZero.date,
	                previousDate: previousDate,
	                waterLevelAtEight: parsedTelegram.sectionOne.waterLevelAtEight,
	                waterLevelAtTwenty: parsedTelegram.sectionOne.waterLevelAtTwenty,
	                previousWaterLevelAtEight: trendResponse &&
	                    trendResponse.previousWaterLevelAtEight,
	                previousWaterLevelAtTwenty: parsedTelegram.
	                    sectionOne.waterLevelAtTwenty,
	                validWaterTrend: trendResponse && trendResponse.valid,
	                waterLevelTrend: parsedTelegram.sectionOne.waterLevelTrend
	            };
	        }
	        if (parsedTelegram.sectionOne && parsedTelegram.sectionOne.icePhenomenae) {
	            parsedTelegramData.icePhenomenaCardData = {
	                date: parsedTelegram.sectionZero.date,
	                icePhenomenae: parsedTelegram.sectionOne.icePhenomenae,
	                disabledDischarge: false
	            };
	        }
	        parsedTelegramData.dischargeData = parsedTelegram.sectionSix;
	        parsedTelegramData.meteoData = parsedTelegram.sectionEight;
	        var telegramCollectionIndex = this.getTelegramCollectionIndex(parsedTelegramData);
	        if (typeof telegramCollectionIndex !== 'undefined') {
	            this.parsedTelegramDataCollection[telegramCollectionIndex] = parsedTelegramData;
	        }
	        else {
	            this.parsedTelegramDataCollection.push(parsedTelegramData);
	        }
	        //last iteration 
	        if ((promiseIndex || promiseIndex === 0) && promiseIndex === (this.stationAndTrendDataPromises.length - 1)) {
	            this.notifyChanges();
	        }
	    };
	    OperationalInputTelegramController.prototype.getTelegramCollectionIndex = function (parsedTelegram) {
	        var telegramIndex;
	        angular.forEach(this.parsedTelegramDataCollection, function (telegramData, index) {
	            if (telegramData.telegramText === parsedTelegram.telegramText) {
	                telegramIndex = index;
	            }
	        });
	        return telegramIndex;
	    };
	    OperationalInputTelegramController.prototype.onInitialTelegramInputChange = function () {
	        var _this = this;
	        if (this.telegrams) {
	            this.unprocessedTelegrams =
	                this.telegrams
	                    .split(/(?:\s\s+|\t)|[\n\r]/g);
	        }
	        else {
	            this.unprocessedTelegrams = [];
	        }
	        this.telegrams = '';
	        this.$timeout(function () {
	            angular.forEach(_this.telegramForm.$error.kn15Parser, function (field) {
	                field.$setTouched();
	            });
	        });
	    };
	    OperationalInputTelegramController.prototype.onAddSingleTelegram = function () {
	        this.unprocessedTelegrams.push('');
	    };
	    OperationalInputTelegramController.prototype.onDeleteTelegramClick = function (telegramText, $index) {
	        this.unprocessedTelegrams.splice(this.unprocessedTelegrams.indexOf(telegramText), 1);
	        this.telegramsBackendErrorMessages.splice($index, 1);
	        this.telegramsMeteoWarningMessages.splice($index, 1);
	        if (this.unprocessedTelegrams.length === 0 || !this.telegramForm.$valid) {
	            this.processTelegrams();
	        }
	    };
	    /**
	     * Force the parse error to be displayed if the URL changed.
	     */
	    OperationalInputTelegramController.prototype.displayError = function (index) {
	        if (this.telegrams && this.telegramForm) {
	            this.telegramForm['telegram' + index].$setDirty();
	            this.telegramForm['telegram' + index].$setTouched();
	        }
	    };
	    /**
	     * Notifies the parent component with the current processed data.
	     */
	    OperationalInputTelegramController.prototype.notifyChanges = function () {
	        if (this.onProcessed) {
	            this.onProcessed({
	                parsedTelegramDataCollection: this.parsedTelegramDataCollection,
	                unprocessedTelegrams: this.unprocessedTelegrams
	            });
	        }
	    };
	    OperationalInputTelegramController.$inject = ['kn15ParseService', 'operationalInputService', 'stationApi', '$q', '$log',
	        'imomoErrorService', '$mdDialog', '$translate', '$state', '$timeout', '$rootScope'];
	    return OperationalInputTelegramController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalInputTelegramController;


/***/ },
/* 368 */
/***/ function(module, exports) {

	module.exports = "<section> <section class=\"md-whiteframe-z2 telegram-input-container\"> <md-progress-linear ng-disabled=!$ctrl.processingInProgress md-mode=indeterminate></md-progress-linear> <form name=$ctrl.telegramForm class=md-padding> <section layout=column> <div layout=row layout-align=\"end center\"> <md-input-container flex> <textarea id=bulk-telegram-input placeholder=\"{{'PASTE_MULTIPLE_KN_15_TELEGRAMS' | translate}}\" ng-model=$ctrl.telegrams ng-change=$ctrl.onInitialTelegramInputChange()></textarea> </md-input-container> <md-button ng-click=$ctrl.onAddSingleTelegram($event) class=\"md-primary md-raised\"> <md-icon>add</md-icon> <span translate>ADD_SINGLE_TELEGRAM</span> </md-button> </div> <md-input-container flex layout=row ng-repeat=\"telegram in $ctrl.unprocessedTelegrams track by $index\"> <div flex> <label translate> KN15_TELEGRAM </label> <input name=\"{{'telegram' + $index}}\" required ng-model=$ctrl.unprocessedTelegrams[$index] kn15-parse-validator error-message=\"$ctrl['parsingErrorMessage'+$index]\" ng-change=$ctrl.onIndividualTelegramInputChange($index)> <div ng-messages=\"$ctrl.telegramForm['telegram' + $index].$error\" md-auto-hide=true> <div ng-message=kn15Parser> {{ $ctrl['parsingErrorMessage'+$index] }} </div> <div ng-message=backendError> {{ $ctrl.telegramsBackendErrorMessages[$index] }} </div> <div ng-message=required translate> TELEGRAM_IS_REQUIRED </div> </div> <p ng-if=$ctrl.telegramsMeteoWarningMessages[$index]> <md-icon class=md-warn>warning</md-icon> <sub>{{ $ctrl.telegramsMeteoWarningMessages[$index] }}</sub> </p> </div> <md-button class=md-icon-button ng-click=\"$ctrl.onDeleteTelegramClick(telegram, $index)\"> <md-icon>close</md-icon> </md-button> </md-input-container> <div layout=row layout-align=\"end center\"> <md-button class=\"md-primary md-raised\" type=submit ng-click=$ctrl.onProcessButtonClick() ng-disabled=\"$ctrl.telegramForm.$invalid || \n                      $ctrl.processingInProgress || \n                      !$ctrl.unprocessedTelegrams.length\"> <span translate> PROCESS_TELEGRAM </span> </md-button> </div> </section> </form> </section> <div class=station-manager-container layout=row ng-if=\"$ctrl.dischargeStationsWithMissingDataForToday && $ctrl.dischargeStationsWithMissingDataForToday.length\"> <md-card flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span translate>DISCHARGE_STATIONS_WITH_MISSING_TELEGRAMS</span> </div> </md-toolbar> <md-table-container flex> <table md-table md-progress=$ctrl.stationsPromise ng-model=$ctrl.selectedStations> <thead md-head> <tr md-row> <th md-column><span translate>STATION_CODE</span></th> <th md-column><span translate>STATION_NAME</span></th> <th md-column><span translate>REGION</span> </th> <th md-column><span translate>RIVER_BASIN</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"station in $ctrl.dischargeStationsWithMissingDataForToday\"> <td md-cell> {{ station.siteCode }} <md-icon ng-if=station.isVirtual> call_merge <md-tooltip> <span translate>VIRTUAL_STATION</span> </md-tooltip> </md-icon> </td> <td md-cell>{{ station.siteName }}</td> <td md-cell>{{ station.region }}</td> <td md-cell>{{ station.basin }}</td> </tr> </tbody> </table> </md-table-container> </md-card> </div> <div class=station-manager-container layout=row ng-if=\"$ctrl.meteoStationsWithMissingDataForToday && $ctrl.meteoStationsWithMissingDataForToday.length\"> <md-card flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span translate>METEO_STATIONS_WITH_MISSING_TELEGRAMS</span> </div> </md-toolbar> <md-table-container flex> <table md-table md-progress=$ctrl.stationsPromise ng-model=$ctrl.selectedStations> <thead md-head> <tr md-row> <th md-column><span translate>STATION_CODE</span></th> <th md-column><span translate>STATION_NAME</span></th> <th md-column><span translate>REGION</span> </th> <th md-column><span translate>RIVER_BASIN</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"station in $ctrl.meteoStationsWithMissingDataForToday\"> <td md-cell> {{ station.siteCode }} <md-icon ng-if=station.isVirtual> call_merge <md-tooltip> <span translate>VIRTUAL_STATION</span> </md-tooltip> </md-icon> </td> <td md-cell>{{ station.siteName }}</td> <td md-cell>{{ station.region }}</td> <td md-cell>{{ station.basin }}</td> </tr> </tbody> </table> </md-table-container> </md-card> </div> </section>";

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var data_overview_controller_1 = __webpack_require__(370);
	__webpack_require__(371);
	var template = __webpack_require__(372);
	var dataOverviewComponent = {
	    bindings: {
	        completedTelegrams: '<',
	        telegramsRequiringAction: '<',
	        onProcessed: '&'
	    },
	    controller: data_overview_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = dataOverviewComponent;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var OperationalInputDataOverviewController = (function () {
	    function OperationalInputDataOverviewController($timeout, operationalInputService) {
	        this.$timeout = $timeout;
	        this.operationalInputService = operationalInputService;
	        this.isTelegramCachingCompleted = false;
	        this.currentDate = new Date;
	    }
	    // date changed
	    OperationalInputDataOverviewController.prototype.onDateChanged = function ($event, telegramData) {
	        telegramData.overriddenDate = new Date(moment(telegramData.overriddenDate).hour(8).minute(0).second(0).millisecond(0).format());
	        this.handleTrendDataPromise(telegramData);
	    };
	    // checkbox changed
	    OperationalInputDataOverviewController.prototype.onOverrideDateChanged = function ($event, telegramData) {
	        if (!telegramData.overrideDate) {
	            telegramData.overriddenDate = _.filter(this.cachedTelegrams, function (cachedTelegram) {
	                return cachedTelegram.telegramText === telegramData.telegramText;
	            })[0].overriddenDate;
	        }
	        this.handleTrendDataPromise(telegramData);
	    };
	    OperationalInputDataOverviewController.prototype.$onChanges = function () {
	        if (!this.isTelegramCachingCompleted &&
	            ((this.completedTelegrams && this.completedTelegrams.length) ||
	                (this.telegramsRequiringAction && this.telegramsRequiringAction.length))) {
	            this.cachedTelegrams = angular.copy(this.completedTelegrams).concat(angular.copy(this.telegramsRequiringAction));
	            this.isTelegramCachingCompleted = true;
	        }
	    };
	    /**
	     * Notifies the parent component with the current processed data.
	     */
	    OperationalInputDataOverviewController.prototype.notifyChanges = function () {
	        if (this.onProcessed) {
	            this.onProcessed({
	                parsedTelegramDataCollection: this.completedTelegrams.concat(this.telegramsRequiringAction),
	                unprocessedTelegrams: null
	            });
	        }
	    };
	    OperationalInputDataOverviewController.prototype.handleTrendDataPromise = function (telegramData) {
	        var _this = this;
	        var trendDataPromise = this.operationalInputService.verifyWaterTrend(moment(telegramData.overriddenDate).hour(8).minute(0).second(0).millisecond(0), telegramData.station.siteCode, telegramData.waterLevelData.waterLevelAtEight, telegramData.waterLevelData.waterLevelTrend);
	        trendDataPromise
	            .then(function (trendResponse) {
	            var averageWaterLevel = _this.operationalInputService
	                .calculateAverageWaterLevel(telegramData.waterLevelData && telegramData.waterLevelData.waterLevelAtTwenty, trendResponse && trendResponse.previousWaterLevelAtEight);
	            telegramData.waterLevelData.averageWaterLevel = averageWaterLevel;
	            telegramData.waterLevelData.previousWaterLevelAtEight = trendResponse && trendResponse.previousWaterLevelAtEight;
	            telegramData.waterLevelData.validWaterTrend = trendResponse && trendResponse.valid;
	            telegramData.waterLevelData.telegramDate = moment(telegramData.overriddenDate);
	            telegramData.waterLevelData.previousDate = moment(telegramData.overriddenDate).subtract(1, 'day');
	        })
	            .finally(function () {
	            _this.notifyChanges();
	        });
	    };
	    OperationalInputDataOverviewController.$inject = ['$timeout', 'operationalInputService'];
	    return OperationalInputDataOverviewController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalInputDataOverviewController;


/***/ },
/* 371 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 372 */
/***/ function(module, exports) {

	module.exports = "<md-content id=telegram-data-overview> <md-card ng-if=$ctrl.completedTelegrams.length> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>COMPLETED_TELEGRAMS</span> </md-toolbar> <md-table-container> <table md-table flex> <thead md-head> <tr md-row flex> <th md-column> <span translate>CODE</span> </th> <th md-column> <span translate>NAME</span> </th> <th md-column> <span translate>TYPE</span> </th> <th md-column> <span translate>DATE</span> </th> <th md-column> <span translate>EXPAND</span> </th> </tr> </thead> <tbody md-body ng-repeat=\"telegramData in $ctrl.completedTelegrams track by $index\"> <tr md-row ng-click=\"$ctrl['completedTelegramDataExpanded' + $index] = !$ctrl['completedTelegramDataExpanded' + $index];\"> <td md-cell> {{ telegramData.station.siteCode }} </td> <td md-cell> {{ telegramData.station.siteName }} </td> <td md-cell> <span ng-if=\"telegramData.meteoData && (telegramData.waterLevelData || telegramData.dischargeData)\">discharge / meteo</span> <span ng-if=\"!telegramData.meteoData && (telegramData.waterLevelData || telegramData.dischargeData)\">discharge</span> <span ng-if=\"telegramData.meteoData && !(telegramData.waterLevelData || telegramData.dischargeData)\">meteo</span> </td> <td md-cell> {{ telegramData.overriddenDate | momentFormatter:'overriddenDate-time' }} <span ng-if=\"telegramData.meteoData && !(telegramData.waterLevelData || telegramData.dischargeData)\">---</span> </td> <td md-cell> <md-button class=md-icon-button ng-if=\"!$ctrl['completedTelegramDataExpanded' + $index]\"> <md-icon>expand_more</md-icon> </md-button> <md-button class=md-icon-button ng-if=\"$ctrl['completedTelegramDataExpanded' + $index]\"> <md-icon>expand_less</md-icon> </md-button> </td> </tr> <tr md-row ng-if=\"$ctrl['completedTelegramDataExpanded' + $index]\"> <td md-cell colspan=5 class=telegram-data-content-cell> <md-content layout=row class=md-padding layout-align=\"space-between center\" ng-if=\"!(telegramData.meteoData && !(telegramData.waterLevelData || telegramData.dischargeData))\"> <md-content ng-if=telegramData.station style=overflow:visible> <span>Telegram day:</span> <md-datepicker style=margin-right:0 md-open-on-focus ng-model=telegramData.overriddenDate md-max-date=$ctrl.currentDate ng-disabled=\"telegramData.overrideDate != true\" ng-change=\"$ctrl.onDateChanged($event, telegramData, $index, true)\"></md-datepicker> <md-checkbox ng-model=telegramData.overrideDate ng-change=\"$ctrl.onOverrideDateChanged($event, telegramData, $index, true)\">Override</md-checkbox> </md-content> </md-content> <md-content layout=row layout-align=\"start start\" layout-wrap> <imomo-operational-input-water-level-card ng-show=telegramData.waterLevelData water-level-data=telegramData.waterLevelData> </imomo-operational-input-water-level-card> <imomo-operational-input-discharge-card ng-show=telegramData.dischargeData discharge-data=telegramData.dischargeData> </imomo-operational-input-discharge-card> <imomo-operational-input-ice-phenomena-card ng-repeat=\"icePhenomena in telegramData.icePhenomenaCardData.icePhenomenae\" ng-show=icePhenomena discharge-option-enabled=false index=$index card-data=\"{\n\t\t\t                      date: telegramData.overriddenDate,\n\t\t\t                      icePhenomenae: icePhenomena,\n\t\t\t                      disabledDischarge: false\n\t\t\t                    }\"> </imomo-operational-input-ice-phenomena-card> <imomo-operational-input-temperature-card temperature-data=telegramData.temperatureData ng-if=telegramData.temperatureData> </imomo-operational-input-temperature-card> <imomo-operational-input-meteo-card meteo-data=telegramData.meteoData ng-if=telegramData.meteoData> </imomo-operational-input-meteo-card> </md-content> </td> </tr> </tbody> </table> </md-table-container> </md-card> <md-card ng-if=$ctrl.telegramsRequiringAction.length> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>TELEGRAMS_REQUIRING_ACTION</span> </md-toolbar> <md-table-container> <table md-table flex> <thead md-head> <tr md-row flex> <th md-column> <span translate>CODE</span> </th> <th md-column> <span translate>NAME</span> </th> <th md-column> <span translate>TYPE</span> </th> <th md-column> <span translate>DATE</span> </th> <th md-column> <span translate>EXPAND</span> </th> </tr> </thead> <tbody md-body ng-repeat=\"telegramData in $ctrl.telegramsRequiringAction track by $index\"> <tr md-row ng-click=\"$ctrl['actionTelegramDataExpanded' + $index] = !$ctrl['actionTelegramDataExpanded' + $index];\"> <td md-cell> {{ telegramData.station.siteCode }} </td> <td md-cell> {{ telegramData.station.siteName }} </td> <td md-cell> <span ng-if=\"telegramData.meteoData && (telegramData.waterLevelData || telegramData.dischargeData)\">discharge / meteo</span> <span ng-if=\"!telegramData.meteoData && (telegramData.waterLevelData || telegramData.dischargeData)\">discharge</span> <span ng-if=\"telegramData.meteoData && !(telegramData.waterLevelData || telegramData.dischargeData)\">meteo</span> </td> <td md-cell> {{ telegramData.overriddenDate | momentFormatter:'overriddenDate-time' }} <span ng-if=\"telegramData.meteoData && !(telegramData.waterLevelData || telegramData.dischargeData)\">---</span> </td> <td md-cell> <md-button class=md-icon-button ng-if=\"!$ctrl['actionTelegramDataExpanded' + $index]\"> <md-icon>expand_more</md-icon> </md-button> <md-button class=md-icon-button ng-if=\"$ctrl['actionTelegramDataExpanded' + $index]\"> <md-icon>expand_less</md-icon> </md-button> </td> </tr> <tr md-row ng-if=\"$ctrl['actionTelegramDataExpanded' + $index]\"> <td md-cell colspan=5 class=telegram-data-content-cell> <md-content layout=row class=md-padding layout-align=\"space-between center\" ng-if=telegramData.overriddenDate> <md-content ng-if=telegramData.station style=overflow:visible> <span>Telegram day:</span> <md-datepicker style=margin-right:0 md-open-on-focus ng-model=telegramData.overriddenDate md-max-date=$ctrl.currentDate ng-disabled=\"telegramData.overrideDate != true\" ng-change=\"$ctrl.onDateChanged($event, telegramData, $index, false)\"></md-datepicker> <md-checkbox ng-model=telegramData.overrideDate ng-change=\"$ctrl.onOverrideDateChanged($event, telegramData, $index, false)\">Override</md-checkbox> </md-content> </md-content> <md-content layout=row layout-align=\"start start\" layout-wrap> <imomo-operational-input-water-level-card ng-show=telegramData.waterLevelData water-level-data=telegramData.waterLevelData> </imomo-operational-input-water-level-card> <imomo-operational-input-discharge-card ng-show=telegramData.dischargeData discharge-data=telegramData.dischargeData> </imomo-operational-input-discharge-card> <imomo-operational-input-ice-phenomena-card ng-repeat=\"icePhenomena in telegramData.icePhenomenaCardData.icePhenomenae\" ng-show=icePhenomena discharge-option-enabled=false index=$index card-data=\"{\n\t\t\t                      date: telegramData.overriddenDate,\n\t\t\t                      icePhenomenae: icePhenomena,\n\t\t\t                      disabledDischarge: false\n\t\t\t                    }\"> </imomo-operational-input-ice-phenomena-card> <imomo-operational-input-temperature-card temperature-data=telegramData.temperatureData ng-if=telegramData.temperatureData> </imomo-operational-input-temperature-card> <imomo-operational-input-meteo-card meteo-data=telegramData.meteoData ng-show=telegramData.meteoData> </imomo-operational-input-meteo-card> </md-content> </td> </tr> </tbody> </table> </md-table-container> </md-card> </md-content>";

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var data_processing_controller_1 = __webpack_require__(374);
	__webpack_require__(375);
	var template = __webpack_require__(376);
	var dataProcessingComponent = {
	    bindings: {
	        completedTelegrams: '<',
	        telegramDataForProcessing: '<',
	        onProcessed: '&'
	    },
	    controller: data_processing_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = dataProcessingComponent;


/***/ },
/* 374 */
/***/ function(module, exports) {

	"use strict";
	var OperationalInputDataProcessingController = (function () {
	    function OperationalInputDataProcessingController(dailyDataService, operationalInputService, dischargeModelApi, $rootScope) {
	        this.dailyDataService = dailyDataService;
	        this.operationalInputService = operationalInputService;
	        this.dischargeModelApi = dischargeModelApi;
	        this.$rootScope = $rootScope;
	        // collection of discharge models of all sites
	        this.dischargeModels = [];
	        this.isDischargeInputManual = false;
	        this.isWaterLevelInputManual = false;
	        this.currentDate = new Date;
	    }
	    OperationalInputDataProcessingController.prototype.$onChanges = function (changes) {
	        if (changes.hasOwnProperty('telegramDataForProcessing') && changes['telegramDataForProcessing'].currentValue) {
	            this.telegramDataForProcessing = changes['telegramDataForProcessing'].currentValue;
	            this.notifyChanges();
	        }
	    };
	    /**
	     * Serves to update averages.
	     */
	    OperationalInputDataProcessingController.prototype.onDailyDataWaterLevelChange = function (dataRow) {
	        dataRow.averageCell.newWaterLevel = this.calculateAvgWaterLevel(dataRow);
	        this.onDataChange();
	    };
	    OperationalInputDataProcessingController.prototype.onDailyDataDischargeChange = function (dataRow) {
	        dataRow.averageCell.newDischarge = this.calculateAvgDischarge(dataRow);
	        this.onDataChange();
	    };
	    OperationalInputDataProcessingController.prototype.calculateAvgWaterLevel = function (dataRow) {
	        var waterLevels = [];
	        if (dataRow.morningCell && dataRow.morningCell.newWaterLevel && !isNaN(dataRow.morningCell.newWaterLevel)) {
	            waterLevels.push(dataRow.morningCell.newWaterLevel);
	        }
	        if (dataRow.eveningCell && dataRow.eveningCell.newWaterLevel && !isNaN(dataRow.eveningCell.newWaterLevel)) {
	            waterLevels.push(dataRow.eveningCell.newWaterLevel);
	        }
	        if (waterLevels.length === 2) {
	            var sum_1 = 0;
	            _.forEach(waterLevels, function (discharge) {
	                sum_1 += discharge;
	            });
	            return sum_1 / waterLevels.length;
	        }
	        else {
	            return null;
	        }
	    };
	    OperationalInputDataProcessingController.prototype.calculateAvgDischarge = function (dataRow) {
	        var discharges = [];
	        if (dataRow.morningCell && dataRow.morningCell.newDischarge && !isNaN(dataRow.morningCell.newDischarge)) {
	            discharges.push(dataRow.morningCell.newDischarge);
	        }
	        if (dataRow.eveningCell && dataRow.eveningCell.newDischarge && !isNaN(dataRow.eveningCell.newDischarge)) {
	            discharges.push(dataRow.eveningCell.newDischarge);
	        }
	        if (discharges.length === 2) {
	            var sum_2 = 0;
	            _.forEach(discharges, function (discharge) {
	                sum_2 += discharge;
	            });
	            return sum_2 / discharges.length;
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Stores the selected or created discharge model.
	     */
	    OperationalInputDataProcessingController.prototype.onDischargeModelChange = function (dischargeModel, created, stationId, $index) {
	        var _this = this;
	        // this.dischargeModel = dischargeModel;
	        this.createdDischargeModel = created;
	        // this.dischargeModelStepValid = dischargeModel != null;
	        if (dischargeModel != null) {
	            var dischargeModelData_1 = {
	                dischargeModel: dischargeModel,
	                createdDischargeModel: created,
	                stationId: stationId
	            };
	            var isDischargeModelDataInDischargeModelsList_1 = false;
	            if (this.dischargeModels && this.dischargeModels.length) {
	                this.dischargeModels.forEach(function (model, index) {
	                    if (model.stationId === stationId) {
	                        _this.dischargeModels[index] = dischargeModelData_1;
	                        isDischargeModelDataInDischargeModelsList_1 = true;
	                    }
	                });
	            }
	            if (!isDischargeModelDataInDischargeModelsList_1) {
	                this.dischargeModels.push(dischargeModelData_1);
	            }
	            if (this.telegramDataForProcessing && this.telegramDataForProcessing.length) {
	                this.notifyChanges();
	            }
	        }
	    };
	    OperationalInputDataProcessingController.prototype.onDataChange = function () {
	        this.notifyChanges();
	    };
	    /**
	     * Notifies the parent component with the current processed data.
	     */
	    OperationalInputDataProcessingController.prototype.notifyChanges = function () {
	        if (this.onProcessed) {
	            var dailyDataParams = this.generateDailyDataParams();
	            this.onProcessed({
	                telegramsRequiringActionFinalData: dailyDataParams,
	                createdDischargeModel: this.createdDischargeModel
	            });
	        }
	    };
	    OperationalInputDataProcessingController.prototype.generateDailyDataParams = function () {
	        var _this = this;
	        var processedTelegramData = [];
	        this.telegramDataForProcessing.forEach(function (telegramData) {
	            var telegramDischargeModel = _.filter(_this.dischargeModels, function (dischargeModel) {
	                return dischargeModel.stationId === telegramData.parsedTelegramData.station.id;
	            })[0];
	            var telegramDischargeData = telegramData.calculatedTelegramData.dischargeData;
	            var telegramMeteoData = telegramData.calculatedTelegramData.meteoData;
	            var formattedDailyData = _this.dailyDataService.formatDailyDataRequest(telegramData.comparisonData.dailyData);
	            // if telegram requiring actions didn't need daily data correction, set daily data to default
	            var dailyData = formattedDailyData.length ?
	                formattedDailyData :
	                (telegramData.calculatedTelegramData.dischargeData &&
	                    telegramData.calculatedTelegramData.dischargeData.dailyData);
	            // set telegrams daily data to inititaly calculated values
	            // if some values had to be processed they will be added in the switch statement below
	            var telegramDailyDataParams = {
	                dischargeData: {
	                    date: telegramDischargeData &&
	                        telegramDischargeData.date,
	                    siteId: telegramData.parsedTelegramData.station.id,
	                    dailyData: dailyData,
	                    temperatures: {
	                        waterTemperature: telegramDischargeData &&
	                            telegramDischargeData.temperatures &&
	                            telegramDischargeData.temperatures.waterTemperature ||
	                            telegramDischargeData &&
	                                telegramDischargeData.temperatures &&
	                                (telegramDischargeData.temperatures.waterTemperature === 0 ?
	                                    telegramDischargeData.temperatures.waterTemperature : null),
	                        airTemperature: telegramDischargeData &&
	                            telegramDischargeData.temperatures &&
	                            telegramDischargeData.temperatures.airTemperature ||
	                            telegramDischargeData &&
	                                telegramDischargeData.temperatures &&
	                                (telegramDischargeData.temperatures.airTemperature === 0 ?
	                                    telegramDischargeData.temperatures.airTemperature : null),
	                    },
	                    icePhenomenae: telegramDischargeData &&
	                        telegramDischargeData.icePhenomenae,
	                    dischargeModelParams: {
	                        dischargeModel: (telegramDischargeModel && telegramDischargeModel.dischargeModel),
	                        createdDischargeModel: telegramDischargeModel ?
	                            telegramDischargeModel.createdDischargeModel : null
	                    },
	                    dischargeMeasurementData: {
	                        waterLevel: telegramDischargeData &&
	                            telegramDischargeData.dischargeMeasurementData &&
	                            telegramDischargeData.dischargeMeasurementData.waterLevel ||
	                            telegramDischargeData &&
	                                telegramDischargeData.dischargeMeasurementData &&
	                                (telegramDischargeData.dischargeMeasurementData.waterLevel === 0 ?
	                                    telegramDischargeData.dischargeMeasurementData.waterLevel : null),
	                        discharge: telegramDischargeData &&
	                            telegramDischargeData.dischargeMeasurementData &&
	                            telegramDischargeData.dischargeMeasurementData.discharge ||
	                            telegramDischargeData &&
	                                telegramDischargeData.dischargeMeasurementData &&
	                                (telegramDischargeData.dischargeMeasurementData.discharge === 0 ?
	                                    telegramDischargeData.dischargeMeasurementData.discharge : null),
	                        freeRiverArea: telegramDischargeData &&
	                            telegramDischargeData.dischargeMeasurementData &&
	                            telegramDischargeData.dischargeMeasurementData.freeRiverArea ||
	                            telegramDischargeData &&
	                                telegramDischargeData.dischargeMeasurementData &&
	                                (telegramDischargeData.dischargeMeasurementData.freeRiverArea === 0 ?
	                                    telegramDischargeData.dischargeMeasurementData.freeRiverArea : null),
	                        maximumDepth: telegramDischargeData &&
	                            telegramDischargeData.dischargeMeasurementData &&
	                            telegramDischargeData.dischargeMeasurementData.maximumDepth ||
	                            telegramDischargeData &&
	                                telegramDischargeData.dischargeMeasurementData &&
	                                (telegramDischargeData.dischargeMeasurementData.maximumDepth === 0 ?
	                                    telegramDischargeData.dischargeMeasurementData.maximumDepth : null),
	                        date: telegramDischargeData &&
	                            telegramDischargeData.dischargeMeasurementData &&
	                            telegramDischargeData.dischargeMeasurementData.date ?
	                            telegramDischargeData.dischargeMeasurementData.date : null
	                    }
	                },
	                meteoData: {
	                    siteId: telegramMeteoData &&
	                        telegramMeteoData.siteId,
	                    month: telegramMeteoData &&
	                        telegramMeteoData.month,
	                    decade: telegramMeteoData &&
	                        telegramMeteoData.decade,
	                    precipitation: telegramMeteoData &&
	                        telegramMeteoData.precipitation ||
	                        telegramMeteoData &&
	                            (telegramMeteoData.precipitation === 0 ?
	                                telegramMeteoData.precipitation : null),
	                    precipitationChecksum: telegramMeteoData &&
	                        telegramMeteoData.precipitationChecksum ||
	                        telegramMeteoData &&
	                            (telegramMeteoData.precipitationChecksum === 0 ?
	                                telegramMeteoData.precipitationChecksum : null),
	                    airTemp: telegramMeteoData &&
	                        telegramMeteoData.airTemp ||
	                        telegramMeteoData &&
	                            (telegramMeteoData.airTemp === 0 ?
	                                telegramMeteoData.airTemp : null),
	                    year: telegramMeteoData &&
	                        telegramMeteoData.year,
	                    currentDate: telegramMeteoData &&
	                        telegramMeteoData.currentDate
	                }
	            };
	            // overwrite default telegram's daily data values with processed values
	            telegramData.comparisonData.dischargeDataRows.forEach(function (dischargeDataRow) {
	                switch (dischargeDataRow.fieldName) {
	                    case 'discharge':
	                        telegramDailyDataParams.dischargeData.dischargeMeasurementData.discharge =
	                            dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;
	                        if (dischargeDataRow.manualInputValue) {
	                            telegramDailyDataParams.dischargeData.dischargeMeasurementData.discharge =
	                                dischargeDataRow.manualInputValue;
	                        }
	                        break;
	                    case 'waterLevel':
	                        telegramDailyDataParams.dischargeData.dischargeMeasurementData.waterLevel =
	                            dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;
	                        if (dischargeDataRow.manualInputValue) {
	                            telegramDailyDataParams.dischargeData.dischargeMeasurementData.waterLevel =
	                                dischargeDataRow.manualInputValue;
	                        }
	                        break;
	                    case 'freeRiverArea':
	                        telegramDailyDataParams.dischargeData.dischargeMeasurementData.freeRiverArea =
	                            dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;
	                        if (dischargeDataRow.manualInputValue) {
	                            telegramDailyDataParams.dischargeData.dischargeMeasurementData.freeRiverArea =
	                                dischargeDataRow.manualInputValue;
	                        }
	                        break;
	                    case 'maximumDepth':
	                        telegramDailyDataParams.dischargeData.dischargeMeasurementData.maximumDepth =
	                            dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;
	                        if (dischargeDataRow.manualInputValue) {
	                            telegramDailyDataParams.dischargeData.dischargeMeasurementData.maximumDepth =
	                                dischargeDataRow.manualInputValue;
	                        }
	                        break;
	                    case 'date':
	                        telegramDailyDataParams.dischargeData.dischargeMeasurementData.date =
	                            dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;
	                        if (dischargeDataRow.manualInputValue) {
	                            telegramDailyDataParams.dischargeData.dischargeMeasurementData.date =
	                                dischargeDataRow.manualInputValue;
	                        }
	                        break;
	                    case 'waterTemperature':
	                        telegramDailyDataParams.dischargeData.temperatures.waterTemperature =
	                            dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;
	                        if (dischargeDataRow.manualInputValue) {
	                            telegramDailyDataParams.dischargeData.temperatures.waterTemperature =
	                                dischargeDataRow.manualInputValue;
	                        }
	                        break;
	                    case 'airTemperature':
	                        telegramDailyDataParams.dischargeData.temperatures.airTemperature =
	                            dischargeDataRow.overrideData ? dischargeDataRow.newValue : dischargeDataRow.oldValue;
	                        if (dischargeDataRow.manualInputValue) {
	                            telegramDailyDataParams.dischargeData.temperatures.airTemperature =
	                                dischargeDataRow.manualInputValue;
	                        }
	                        break;
	                }
	            });
	            if (!telegramData.calculatedTelegramData.meteoData ||
	                (telegramData.calculatedTelegramData.meteoData && !telegramData.calculatedTelegramData.meteoData.siteId)) {
	                delete telegramDailyDataParams.meteoData;
	            }
	            else {
	                telegramData.comparisonData.meteoDataRows.forEach(function (meteoDataRow) {
	                    switch (meteoDataRow.fieldName) {
	                        case 'airTemperature':
	                            telegramDailyDataParams.meteoData.airTemp =
	                                meteoDataRow.overrideData ? meteoDataRow.newValue : meteoDataRow.oldValue;
	                            if (meteoDataRow.manualInputValue) {
	                                telegramDailyDataParams.meteoData.airTemp =
	                                    meteoDataRow.manualInputValue;
	                            }
	                            break;
	                        case 'precipitation':
	                            telegramDailyDataParams.meteoData.precipitation =
	                                meteoDataRow.overrideData ? meteoDataRow.newValue : meteoDataRow.oldValue;
	                            if (meteoDataRow.manualInputValue) {
	                                telegramDailyDataParams.meteoData.precipitation =
	                                    meteoDataRow.manualInputValue;
	                            }
	                            break;
	                    }
	                });
	            }
	            if (!telegramDailyDataParams.dischargeData.dischargeMeasurementData.waterLevel &&
	                !telegramDailyDataParams.dischargeData.dischargeMeasurementData.discharge &&
	                !telegramDailyDataParams.dischargeData.dischargeMeasurementData.freeRiverArea &&
	                !telegramDailyDataParams.dischargeData.dischargeMeasurementData.maximumDepth) {
	                delete telegramDailyDataParams.dischargeData.dischargeMeasurementData;
	            }
	            if (!telegramData.calculatedTelegramData.dischargeData) {
	                delete telegramDailyDataParams.dischargeData;
	            }
	            telegramData.comparisonData.icePhenomenaeDataRowsList.forEach(function (icePhenomenaeDataRow, index) {
	                icePhenomenaeDataRow.forEach(function (icePhenomenaeItem) {
	                    switch (icePhenomenaeItem.fieldName) {
	                        case 'code':
	                            telegramDailyDataParams.dischargeData.icePhenomenae[index].code =
	                                icePhenomenaeItem.overrideData ? icePhenomenaeItem.newValue : icePhenomenaeItem.oldValue;
	                            if (icePhenomenaeItem.manualInputValue) {
	                                telegramDailyDataParams.dischargeData.icePhenomenae[index].code =
	                                    icePhenomenaeItem.manualInputValue;
	                            }
	                            break;
	                        case 'intensity':
	                            telegramDailyDataParams.dischargeData.icePhenomenae[index].intensity =
	                                icePhenomenaeItem.overrideData ? icePhenomenaeItem.newValue : icePhenomenaeItem.oldValue;
	                            if (icePhenomenaeItem.manualInputValue) {
	                                telegramDailyDataParams.dischargeData.icePhenomenae[index].intensity =
	                                    icePhenomenaeItem.manualInputValue;
	                            }
	                            break;
	                    }
	                });
	            });
	            processedTelegramData.push({
	                dailyDataParams: telegramDailyDataParams,
	                parsedTelegramData: telegramData.parsedTelegramData
	            });
	        });
	        return processedTelegramData;
	    };
	    OperationalInputDataProcessingController.prototype.isDataRowOverrideDisabled = function (dataRow) {
	        return dataRow.oldValue === null || typeof dataRow.oldValue === 'undefined';
	    };
	    OperationalInputDataProcessingController.$inject = ['dailyDataService', 'operationalInputService', 'dischargeModelApi', '$rootScope'];
	    return OperationalInputDataProcessingController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalInputDataProcessingController;


/***/ },
/* 375 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 376 */
/***/ function(module, exports) {

	module.exports = "<md-content id=telegram-data-overview> <md-card ng-if=$ctrl.telegramDataForProcessing.length style=\"min-height:calc(100vh - 200px)\"> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>TELEGRAMS_REQUIRING_ACTION</span> </md-toolbar> <md-tabs class=full-height-tabs md-border-bottom flex> <md-tab ng-repeat=\"telegramData in $ctrl.telegramDataForProcessing track by $index\"> <md-tab-label> <span>{{ telegramData.parsedTelegramData.station.siteCode }} - {{ telegramData.parsedTelegramData.station.siteName }}</span> </md-tab-label> <md-tab-body> <div> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>CURVE_MANAGEMENT</span> </md-toolbar> <div> <md-tabs class=full-height-tabs md-border-bottom flex style=min-height:1000px> <md-tab ng-if=telegramData.actions.hqAdjustment> <md-tab-label> <span translate>CURRENT_CURVE_ADJUSTMENT</span> </md-tab-label> <md-tab-body> <imomo-operational-input-curve class=fill-tab layout=column station-id=telegramData.parsedTelegramData.station.id parsed-telegram=telegramData.parsedTelegramData parsed-telegram-date=telegramData.parsedTelegramData.overriddenDate on-model-change=\"$ctrl.onDischargeModelChange(dischargeModel, created, telegramData.parsedTelegramData.station.id, $index)\"> </imomo-operational-input-curve> </md-tab-body> </md-tab> <md-tab> <md-tab-label> <span translate>ALL_CURVES</span> </md-tab-label> <md-tab-body> <imomo-station-curve station-id=telegramData.parsedTelegramData.station.id></imomo-station-curve> </md-tab-body> </md-tab> </md-tabs> </div> </div> <md-divider></md-divider> <div ng-if=telegramData.comparisonData> <div ng-if=telegramData.comparisonData.dailyData.length> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>DAILY_DATA</span> <span ng-if=telegramData.actions.icePhenomena> <md-checkbox ng-model=$ctrl.isDischargeInputManual><span translate>MANUAL_DISCHARGE_INPUT</span></md-checkbox> </span> <span ng-if=telegramData.actions.waterLevelTrend> <md-checkbox ng-model=$ctrl.isWaterLevelInputManual><span translate>MANUAL_WATER_LEVEL_INPUT</span></md-checkbox> </span> </md-toolbar> <md-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column colspan=4> <span translate>DATE</span> </th> <th md-column colspan=6> <span translate>8_AM</span> </th> <th md-column colspan=6> <span translate>8_PM</span> </th> <th md-column colspan=6> <span translate>AVERAGE</span> </th> </tr> <tr md-row> <th md-column></th> <th md-column md-numeric> <span translate>H_CM</span> </th> <th md-column md-numeric> <span class=old-value-header translate>H_CM_OLD</span> </th> <th md-column> <span translate>OVERRIDE</span> </th> <th md-column md-numeric> <span translate>Q_M3_S</span> </th> <th md-column md-numeric> <span class=old-value-header translate>Q_M3_S_OLD</span> </th> <th md-column> <span translate>OVERRIDE</span> </th> <th md-column md-numeric> <span translate>H_CM</span> </th> <th md-column md-numeric> <span class=old-value-header translate>H_CM_OLD</span> </th> <th md-column> <span translate>OVERRIDE</span> </th> <th md-column md-numeric> <span translate>Q_M3_S</span> </th> <th md-column md-numeric> <span class=old-value-header translate>Q_M3_S_OLD</span> </th> <th md-column> <span translate>OVERRIDE</span> </th> <th md-column md-numeric> <span translate>H_CM</span> </th> <th md-column md-numeric> <span class=old-value-header translate>H_CM_OLD</span> </th> <th md-column> <span translate>OVERRIDE</span> </th> <th md-column md-numeric> <span translate>Q_M3_S</span> </th> <th md-column md-numeric> <span class=old-value-header translate>Q_M3_S_OLD</span> </th> <th md-column> <span translate>OVERRIDE</span> </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"dataRow in telegramData.comparisonData.dailyData track by $index\"> <td md-cell>{{ dataRow.date | momentFormatter }}</td> <td md-cell ng-class=\"{'md-body-2': dataRow.morningCell.highlighted}\"> <p ng-if=!$ctrl.isWaterLevelInputManual> <strong>{{ dataRow.morningCell.newWaterLevel | hydroNumberFormatter }}</strong> </p> <p ng-if=$ctrl.isWaterLevelInputManual> <input style=width:40px type=number min=0 ng-model=dataRow.morningCell.newWaterLevel ng-change=\"$ctrl.onDataChange(); $ctrl.onDailyDataWaterLevelChange(dataRow)\"/> </p> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.morningCell.highlighted}\"> {{ dataRow.morningCell.oldWaterLevel | hydroNumberFormatter }} </td> <td md-cell class=override-column> <md-checkbox ng-model=dataRow.morningCell.overrideWaterLevelData ng-disabled=$ctrl.isWaterLevelInputManual ng-if=dataRow.morningCell.newWaterLevel ng-change=$ctrl.onDataChange() aria-label=\"override old data\"></md-checkbox> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.morningCell.highlighted}\"> <p ng-if=!$ctrl.isDischargeInputManual> <strong>{{ dataRow.morningCell.newDischarge | hydroNumberFormatter }}</strong> </p> <p ng-if=$ctrl.isDischargeInputManual> <input style=width:40px type=number min=0 ng-model=dataRow.morningCell.newDischarge ng-change=\"$ctrl.onDataChange(); $ctrl.onDailyDataDischargeChange(dataRow)\"/> </p> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.morningCell.highlighted}\"> {{ dataRow.morningCell.oldDischarge | hydroNumberFormatter }} </td> <td md-cell class=override-column> <md-checkbox ng-model=dataRow.morningCell.overrideDischargeData ng-disabled=telegramData.actions.icePhenomena ng-if=dataRow.morningCell.newDischarge ng-change=$ctrl.onDataChange() aria-label=\"override old data\"></md-checkbox> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.eveningCell.highlighted}\"> <p ng-if=!$ctrl.isWaterLevelInputManual> <strong>{{ dataRow.eveningCell.newWaterLevel | hydroNumberFormatter }}</strong> </p> <p ng-if=$ctrl.isWaterLevelInputManual> <input style=width:40px type=number min=0 ng-model=dataRow.eveningCell.newWaterLevel ng-change=\"$ctrl.onDataChange(); $ctrl.onDailyDataWaterLevelChange(dataRow)\"/> </p> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.eveningCell.highlighted}\"> {{ dataRow.eveningCell.oldWaterLevel | hydroNumberFormatter }} </td> <td md-cell class=override-column> <md-checkbox ng-model=dataRow.eveningCell.overrideWaterLevelData ng-disabled=$ctrl.isWaterLevelInputManual ng-if=dataRow.eveningCell.newWaterLevel ng-change=$ctrl.onDataChange() aria-label=\"override old data\"></md-checkbox> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.eveningCell.highlighted}\"> <p ng-if=!$ctrl.isDischargeInputManual> <strong>{{ dataRow.eveningCell.newDischarge | hydroNumberFormatter }}</strong> </p> <p ng-if=$ctrl.isDischargeInputManual> <input style=width:40px type=number min=0 ng-model=dataRow.eveningCell.newDischarge ng-change=\"$ctrl.onDataChange(); $ctrl.onDailyDataDischargeChange(dataRow)\"/> </p> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.eveningCell.highlighted}\"> {{ dataRow.eveningCell.oldDischarge | hydroNumberFormatter }} </td> <td md-cell class=override-column> <md-checkbox ng-model=dataRow.eveningCell.overrideDischargeData ng-disabled=telegramData.actions.icePhenomena ng-if=dataRow.eveningCell.newDischarge ng-change=$ctrl.onDataChange() aria-label=\"override old data\"></md-checkbox> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.averageCell.highlighted}\"> <strong>{{ dataRow.averageCell.newWaterLevel | hydroNumberFormatter }}</strong> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.averageCell.highlighted}\"> {{ dataRow.averageCell.oldWaterLevel | hydroNumberFormatter }} </td> <td md-cell class=override-column> <md-checkbox ng-model=dataRow.averageCell.overrideWaterLevelData ng-if=dataRow.averageCell.newWaterLevel ng-change=$ctrl.onDataChange() aria-label=\"override old data\"></md-checkbox> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.averageCell.highlighted}\"> <strong>{{ dataRow.averageCell.newDischarge | hydroNumberFormatter}}</strong> </td> <td md-cell ng-class=\"{'md-body-2': dataRow.averageCell.highlighted}\"> {{ dataRow.averageCell.oldDischarge | hydroNumberFormatter}} </td> <td md-cell class=override-column> <md-checkbox ng-model=dataRow.averageCell.overrideDischargeData ng-if=dataRow.averageCell.newDischarge ng-change=$ctrl.onDataChange() aria-label=\"override old data\"></md-checkbox> </td> </tr> </tbody> </table> </md-table-container> </div> <div ng-if=telegramData.comparisonData.dischargeDataRows.length> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>DISCHARGE_DATA</span> </md-toolbar> <md-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column></th> <th md-column md-numeric> <span translate>NEW_TELEGRAM_DATA_ENTRY</span> </th> <th md-column md-numeric> <span translate>OLD_TELEGRAM_DATA_ENTRY</span> </th> <th md-column md-numeric> <span translate>OVERRIDE_OLD_ENTRY</span> </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"dataRow in telegramData.comparisonData.dischargeDataRows\"> <td md-cell> {{ dataRow.label}} </td> <td md-cell ng-if=\"dataRow.fieldName != 'date'\"> {{ dataRow.newValue | hydroNumberFormatter}} </td> <td md-cell ng-if=\"dataRow.fieldName != 'date'\"> {{ dataRow.oldValue | hydroNumberFormatter}} </td> <td md-cell ng-if=\"dataRow.fieldName == 'date'\"> {{ dataRow.newValue | momentFormatter:'date-time'}} </td> <td md-cell ng-if=\"dataRow.fieldName == 'date'\"> {{ dataRow.oldValue | momentFormatter:'date-time'}} </td> <td md-cell> <md-checkbox ng-disabled=$ctrl.isDataRowOverrideDisabled(dataRow) ng-model=dataRow.overrideData ng-change=$ctrl.onDataChange() aria-label=\"override old data\"></md-checkbox> </td> </tr> </tbody> </table> </md-table-container> </div> <div ng-if=telegramData.comparisonData.meteoDataRows.length> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>METEO_DATA</span> </md-toolbar> <md-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column></th> <th md-column md-numeric> <span translate>NEW_TELEGRAM_DATA_ENTRY</span> </th> <th md-column md-numeric> <span translate>OLD_TELEGRAM_DATA_ENTRY</span> </th> <th md-column md-numeric> <span translate>OVERRIDE_OLD_ENTRY</span> </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"dataRow in telegramData.comparisonData.meteoDataRows\"> <td md-cell> {{ dataRow.label}} </td> <td md-cell> {{ dataRow.newValue | hydroNumberFormatter}} </td> <td md-cell> {{ dataRow.oldValue | hydroNumberFormatter}} </td> <td md-cell> <md-checkbox ng-disabled=$ctrl.isDataRowOverrideDisabled(dataRow) ng-model=dataRow.overrideData ng-change=$ctrl.onDataChange() aria-label=\"override old data\"></md-checkbox> </td> </tr> </tbody> </table> </md-table-container> </div> </div> <div ng-if=telegramData.comparisonData.icePhenomenaeDataRowsList.length ng-repeat=\"icePhenomenaeDataRows in telegramData.comparisonData.icePhenomenaeDataRowsList track by $index\"> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>ICE_PHENOMENA</span> <span>#{{ $index +1 }}</span> </md-toolbar> <md-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column></th> <th md-column md-numeric> <span translate>NEW_TELEGRAM_DATA_ENTRY</span> </th> <th md-column md-numeric> <span translate>OLD_TELEGRAM_DATA_ENTRY</span> </th> <th md-column md-numeric> <span translate>OVERRIDE_OLD_ENTRY</span> </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"dataRow in icePhenomenaeDataRows\"> <td md-cell> {{ dataRow.label}} </td> <td md-cell> <span ng-if=\"dataRow.fieldName === 'intensity'\">{{ dataRow.newValue | icePhenomenaIntensityFormatter }}</span> <span ng-if=\"dataRow.fieldName !== 'intensity'\">{{ dataRow.newValue | hydroNumberFormatter}}</span> </td> <td md-cell> <span ng-if=\"dataRow.fieldName === 'intensity'\">{{ dataRow.oldValue | icePhenomenaIntensityFormatter }}</span> <span ng-if=\"dataRow.fieldName !== 'intensity'\">{{ dataRow.oldValue | hydroNumberFormatter}}</span> </td> <td md-cell> <md-checkbox ng-disabled=$ctrl.isDataRowOverrideDisabled(dataRow) ng-model=dataRow.overrideData ng-change=$ctrl.onDataChange() aria-label=\"override old data\"></md-checkbox> </td> </tr> </tbody> </table> </md-table-container> </div>  </md-tab-body> </md-tab> </md-tabs> </md-card> <md-card ng-if=$ctrl.completedTelegrams.length style=\"min-height:calc(100vh - 200px)\"> <md-toolbar layout-padding class=\"md-table-toolbar md-default\"> <span translate>AUTOMATICALLY_PROCESSED_TELEGRAMS</span> </md-toolbar> <md-tabs class=full-height-tabs md-border-bottom flex style=min-height:1000px> <md-tab ng-repeat=\"telegramData in $ctrl.completedTelegrams track by $index\"> <md-tab-label> <span>{{ telegramData.station.siteCode }} - {{ telegramData.station.siteName }}</span> </md-tab-label> <md-tab-body> <imomo-station-curve class=fill-tab layout=column station-id=telegramData.station.id></imomo-station-curve> <p layout-padding ng-if=\"!(telegramData.waterLevelData || telegramData.dischargeData)\" translate>NO_CURVE_FOR_METEO</p> </md-tab-body> </md-tab> </md-tabs> </md-card> </md-content>";

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var water_level_card_controller_1 = __webpack_require__(378);
	var template = __webpack_require__(379);
	var waterLevelCardComponent = {
	    bindings: {
	        waterLevelData: '<'
	    },
	    controller: water_level_card_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = waterLevelCardComponent;


/***/ },
/* 378 */
/***/ function(module, exports) {

	"use strict";
	var OperationalInputWaterLevelCardController = (function () {
	    function OperationalInputWaterLevelCardController() {
	    }
	    return OperationalInputWaterLevelCardController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalInputWaterLevelCardController;


/***/ },
/* 379 */
/***/ function(module, exports) {

	module.exports = "<md-card class=parsed-water-level-card> <md-card-title> <md-card-title-text> <span class=md-title translate> REPORTED_WATER_LEVEL </span> </md-card-title-text> </md-card-title> <md-card-content> <md-list> <md-list-item class=md-2-line> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> PREVIOUS_DAY </h3> <p> {{ $ctrl.waterLevelData.previousDate | momentFormatter }} </p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> 8_AM </h3> <p> {{ $ctrl.waterLevelData.previousWaterLevelAtEight | hydroNumberFormatter }} <span translate>CM</span> </p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> 8_PM </h3> <p> {{ $ctrl.waterLevelData.previousWaterLevelAtTwenty | hydroNumberFormatter }} <span translate>CM</span> </p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> DAILY_AVERAGE </h3> <p> {{ $ctrl.waterLevelData.averageWaterLevel | hydroNumberFormatter }} <span translate>CM</span> </p> </div> </md-list-item> <md-divider></md-divider> <md-list-item class=md-2-line layout-wrap> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> TELEGRAM_DAY </h3> <p>{{ $ctrl.waterLevelData.telegramDate | momentFormatter }}</p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> 8_AM </h3> <p> {{ $ctrl.waterLevelData.waterLevelAtEight | hydroNumberFormatter }} <span translate>CM</span> </p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> DAILY_CHANGE </h3> <p> {{ $ctrl.waterLevelData.waterLevelTrend | hydroNumberFormatter}} <span translate>CM</span> </p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <md-icon ng-show=$ctrl.waterLevelData.validWaterTrend class=tooltip-icon> <md-tooltip md-direction=top> <span translate> WATER_LEVEL_TREND_IS_CORRECT </span> </md-tooltip> check </md-icon> <md-icon ng-hide=$ctrl.waterLevelData.validWaterTrend class=\"md-warn tooltip-icon\"> <md-tooltip md-direction=top> <span translate> WATER_LEVEL_TREND_WRONG </span> </md-tooltip> warning </md-icon> </div> </md-list-item> </md-list> </md-card-content> </md-card>";

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var discharge_card_controller_1 = __webpack_require__(381);
	var template = __webpack_require__(382);
	var dischargeCardComponent = {
	    bindings: {
	        dischargeData: '<',
	        icePhenomenaDisabledDischarge: '<'
	    },
	    controller: discharge_card_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = dischargeCardComponent;


/***/ },
/* 381 */
/***/ function(module, exports) {

	"use strict";
	var DischargeCardController = (function () {
	    function DischargeCardController() {
	    }
	    return DischargeCardController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DischargeCardController;


/***/ },
/* 382 */
/***/ function(module, exports) {

	module.exports = "<md-card> <md-card-title> <md-card-title-text> <span class=md-title translate> REPORTED_DISCHARGE </span> </md-card-title-text> </md-card-title> <md-card-content> <md-list> <md-list-item class=md-2-line> <div class=\"md-list-item-text discharge-card-row-item\"> <h3 translate>DATE</h3> <p>{{ $ctrl.dischargeData.date | momentFormatter:'date-time' }}</p> </div> <div class=\"md-list-item-text discharge-card-row-item\"> <h3 translate> WATER_LEVEL </h3> <p> {{ $ctrl.dischargeData.waterLevel | hydroNumberFormatter }} <span translate>CM</span> </p> </div> <div class=\"md-list-item-text discharge-card-row-item\"> <h3 translate> CROSS_SECTION_AREA</h3> <p> {{ $ctrl.dischargeData.freeRiverArea | hydroNumberFormatter }} <span translate>M2</span> </p> </div> </md-list-item> <md-divider></md-divider> <md-list-item class=md-2-line> <div class=\"md-list-item-text discharge-card-row-item\"> </div> <div class=\"md-list-item-text discharge-card-row-item\"> <h3 translate> DISCHARGE </h3> <p> {{ $ctrl.dischargeData.discharge | hydroNumberFormatter }} <span translate>M3_S</span> </p> </div> <div class=\"md-list-item-text discharge-card-row-item\"> <h3 translate> MAXIMUM_DEPTH </h3> <p> {{ $ctrl.dischargeData.maximumDepth | hydroNumberFormatter }} <span translate>CM</span> </p> </div> </md-list-item> </md-list> </md-card-content> </md-card>";

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var template = __webpack_require__(384);
	var icePhenomenaCardComponent = {
	    bindings: {
	        cardData: '<',
	        dischargeOptionEnabled: '<',
	        onDischargeDisabled: '&',
	        index: '<'
	    },
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = icePhenomenaCardComponent;


/***/ },
/* 384 */
/***/ function(module, exports) {

	module.exports = "<md-card class=parsed-water-level-card> <md-card-title> <md-card-title-text layout=row> <span class=md-title translate> ICE_PHENOMENA </span> <span class=md-title style=padding-left:7px ng-show=\"$ctrl.index > 0\">#{{$ctrl.index + 1}}</span> </md-card-title-text> <form name=$ctrl.dischargeForm ng-if=$ctrl.dischargeOptionEnabled> <md-checkbox name=disabledDischarge ng-model=$ctrl.cardData.disabledDischarge ng-change=\"$ctrl.onDischargeDisabled({\n                     disabled: $ctrl.cardData.disabledDischarge\n                   })\"> <label translate> DISCHARGE_CALCULATION_DISABLED </label> </md-checkbox> </form> </md-card-title> <md-card-content> <md-list> <md-list-item class=md-2-line> <div class=\"md-list-item-text ice-phenomena-row-item\"> <h3 translate> DATE </h3> <p> {{ $ctrl.cardData.date | momentFormatter:'date' }} </p> </div> <div class=\"md-list-item-text ice-phenomena-row-item\"> <h3 translate> CODE </h3> <p> {{ $ctrl.cardData.icePhenomenae.code }} </p> </div> </md-list-item> <md-divider></md-divider> <md-list-item class=md-2-line> <div class=\"md-list-item-text ice-phenomena-row-item\"> <h3 translate> DESCRIPTION </h3> <p> {{ $ctrl.cardData.icePhenomenae.code | icePhenomenaCodeFormatter }} </p> </div> <div class=\"md-list-item-text ice-phenomena-row-item\"> <h3 translate> INTENSITY </h3> <p> {{ $ctrl.cardData.icePhenomenae.intensity | icePhenomenaIntensityFormatter }} </p> </div> </md-list-item> </md-list> </md-card-content> </md-card>";

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var temperature_card_controller_1 = __webpack_require__(386);
	var template = __webpack_require__(387);
	var temperatureCardComponent = {
	    bindings: {
	        temperatureData: '<'
	    },
	    controller: temperature_card_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = temperatureCardComponent;


/***/ },
/* 386 */
/***/ function(module, exports) {

	"use strict";
	var OperationalInputTemperatureCardController = (function () {
	    function OperationalInputTemperatureCardController() {
	    }
	    return OperationalInputTemperatureCardController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalInputTemperatureCardController;


/***/ },
/* 387 */
/***/ function(module, exports) {

	module.exports = "<md-card class=parsed-water-level-card> <md-card-title> <md-card-title-text> <span class=md-title> Temperature </span> </md-card-title-text> </md-card-title> <md-card-content> <md-list> <md-list-item class=md-2-line> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> Telegram day </h3> <p> {{ $ctrl.temperatureData.telegramDay | momentFormatter}} </p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> Air </h3> <p> {{ $ctrl.temperatureData.airTemperature | hydroNumberFormatter }}&deg;C </p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <h3> Water </h3> <p> {{ $ctrl.temperatureData.waterTemperature | hydroNumberFormatter }}&deg;C </p> </div> </md-list-item> </md-list> </md-card-content> </md-card>";

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var meteo_card_controller_1 = __webpack_require__(389);
	var template = __webpack_require__(390);
	var meteoCardComponent = {
	    bindings: {
	        meteoData: '='
	    },
	    controller: meteo_card_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = meteoCardComponent;


/***/ },
/* 389 */
/***/ function(module, exports) {

	"use strict";
	var OperationalInputMeteoCardController = (function () {
	    function OperationalInputMeteoCardController() {
	    }
	    return OperationalInputMeteoCardController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalInputMeteoCardController;


/***/ },
/* 390 */
/***/ function(module, exports) {

	module.exports = "<md-card class=parsed-water-level-card> <md-card-title> <md-card-title-text> <span class=md-title> Meteodata </span> </md-card-title-text> </md-card-title> <md-card-content> <md-list> <md-list-item class=md-2-line> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> Period </h3> <p> {{ 'MONTH' | translate}}: {{ $ctrl.meteoData.month }}, {{ 'DECADE' | translate}}: {{ $ctrl.meteoData.decade }} </p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <h3 translate> Precipitation </h3> <p> {{ $ctrl.meteoData.precipitation | hydroNumberFormatter }} mm </p> </div> <div class=\"md-list-item-text water-level-card-row-item\"> <h3> Air temperature </h3> <p> {{ $ctrl.meteoData.airTemp | hydroNumberFormatter }}&deg;C </p> </div> </md-list-item> </md-list> </md-card-content> </md-card>";

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var curve_creator_controller_1 = __webpack_require__(392);
	var template = __webpack_require__(393);
	var curveCreatorComponent = {
	    bindings: {
	        selectedDischargeDataItems: '<',
	        dischargeModels: '<',
	        newModel: '<',
	        startingDate: '<',
	        onNewModelChange: '&'
	    },
	    controller: curve_creator_controller_1.default,
	    require: {
	        parent: '^?imomoOperationalInputCurve'
	    },
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = curveCreatorComponent;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var moment = __webpack_require__(45);
	var CurveCreatorController = (function () {
	    function CurveCreatorController(modelCreatorService) {
	        this.modelCreatorService = modelCreatorService;
	        this.newModelOptions = {
	            creationMode: 'deltaH',
	            name: null,
	            selectedDischargeDataItems: immutable_1.List(),
	            date: moment()
	        };
	    }
	    Object.defineProperty(CurveCreatorController.prototype, "disabledNewModelButton", {
	        get: function () {
	            return !this.modelCreatorService.validateOptions(this.newModelOptions);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CurveCreatorController.prototype.$onInit = function () {
	        if (this.parent) {
	            this.parent.addCurveCreatorController(this);
	        }
	    };
	    CurveCreatorController.prototype.$onChanges = function () {
	        this.newModelOptions.date = this.startingDate;
	        this.newModelOptions.selectedDischargeDataItems =
	            this.selectedDischargeDataItems || immutable_1.List();
	    };
	    CurveCreatorController.prototype.resetCreatorForm = function () {
	        this.selectedModelId = null;
	        this.newModelOptions = {
	            date: this.startingDate || moment(),
	            name: null,
	            deltaH: null,
	            creationMode: 'deltaH',
	            referenceModel: null,
	            selectedDischargeDataItems: this.newModelOptions
	                .selectedDischargeDataItems
	        };
	        if (this.newModelForm) {
	            this.newModelForm.$setPristine();
	            this.newModelForm.$setUntouched();
	        }
	    };
	    CurveCreatorController.prototype.onModelSelect = function () {
	        var _this = this;
	        this.newModelOptions.referenceModel = this.dischargeModels
	            .find(function (dischargeModel) { return dischargeModel.id == _this.selectedModelId; });
	    };
	    CurveCreatorController.prototype.createNewModel = function () {
	        this.newModel = this.modelCreatorService.createModel(this.newModelOptions);
	        this.notifyNewModelChange(true);
	        this.resetCreatorForm();
	    };
	    CurveCreatorController.prototype.deleteNewModel = function () {
	        this.newModel = null;
	        this.notifyNewModelChange(false);
	    };
	    CurveCreatorController.prototype.notifyNewModelChange = function (created) {
	        if (this.onNewModelChange) {
	            this.onNewModelChange({
	                newModel: this.newModel,
	                created: created
	            });
	        }
	    };
	    CurveCreatorController.$inject = ['modelCreatorService'];
	    return CurveCreatorController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = CurveCreatorController;


/***/ },
/* 393 */
/***/ function(module, exports) {

	module.exports = "<md-card> <md-card-header> <md-card-header-text> <span class=md-title translate> ADJUST_DISCHARGE_MODEL </span> </md-card-header-text> </md-card-header> <md-card-content> <form name=$ctrl.newModelForm layout=row> <div layout=column flex> <md-input-container> <label translate> IDENTIFIER </label> <input required ng-model=$ctrl.newModelOptions.name> </md-input-container> <md-radio-group ng-model=$ctrl.newModelOptions.creationMode> <md-radio-button value=deltaH> <span translate>ADD_DELTA_H</span> </md-radio-button> <md-radio-button value=fitCurve> <span translate>FIT_TO_SELECTED_DATA</span> </md-radio-button> </md-radio-group> </div> <section ng-switch=$ctrl.newModelOptions.creationMode class=new-model-options> <div ng-switch-when=deltaH> <md-input-container class=md-block> <label translate> REFERENCE_MODEL </label> <md-select ng-model=$ctrl.selectedModelId md-on-close=$ctrl.onModelSelect() required> <md-option ng-repeat=\"dischargeModel in $ctrl.dischargeModels\" value={{dischargeModel.id}}> {{ dischargeModel.modelName }} - {{ dischargeModel.validFrom | unixTimestampFormatter | momentFormatter:'date' }} </md-option> </md-select> </md-input-container> <md-input-container class=md-block> <label translate>DELTA_H</label> <input type=number step=1 required ng-model=$ctrl.newModelOptions.deltaH> </md-input-container> </div> <div ng-switch-when=fitCurve> <md-input-container class=md-block> <span translate=DATA_SELECTED translate-values=\"{count: $ctrl.newModelOptions.selectedDischargeDataItems.size}\"> </span> </md-input-container> </div> </section> </form> <section layout=row class=\"md-whiteframe-z2 md-padding\" layout-align=\"start center\"> <span flex class=md-body-2 ng-show=$ctrl.newModel> {{ $ctrl.newModel.modelName }} </span> <span flex ng-hide=$ctrl.newModel translate class=md-body-1> NO_NEW_MODEL </span> <div imomo-visible=$ctrl.newModel> <span translate class=md-body-1> VALID_FROM </span> <span class=md-body-2> {{ $ctrl.newModelOptions.date | momentFormatter:'date' }} </span> </div> </section> </md-card-content> <md-card-actions layout=row layout-align=\"end center\"> <md-button class=\"md-warn md-raised\" ng-click=$ctrl.deleteNewModel() ng-show=$ctrl.newModel> <span translate>DELETE_MODEL</span> </md-button> <md-button class=\"md-accent md-raised\" ng-click=$ctrl.createNewModel() ng-disabled=$ctrl.disabledNewModelButton ng-hide=$ctrl.newModel> <span translate>CREATE_MODEL</span> </md-button> </md-card-actions> </md-card>";

/***/ },
/* 394 */
/***/ function(module, exports) {

	"use strict";
	exports.kn15ParseValidatorFactory = function (kn15ParseService, $translate, $parse) {
	    function formatKN15Error(error) {
	        var translation = $translate.instant("KN15_ERRORS_" + error.messageId);
	        if (error.badToken) {
	            return translation + " Bad token: " + error.badToken + ".";
	        }
	        else {
	            return translation;
	        }
	    }
	    return {
	        require: 'ngModel',
	        link: function (scope, element, attr, ngModel) {
	            var errorMessage = $parse(attr['errorMessage']);
	            ngModel.$validators['kn15Parser'] = function (modelValue, viewValue) {
	                var value = modelValue || viewValue;
	                if (!value) {
	                    return true;
	                }
	                try {
	                    kn15ParseService.parse(value);
	                    return true;
	                }
	                catch (error) {
	                    errorMessage.assign(scope, formatKN15Error(error));
	                    return false;
	                }
	            };
	        }
	    };
	};
	exports.kn15ParseValidatorFactory.$inject = ['kn15ParseService', '$translate',
	    '$parse'];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = exports.kn15ParseValidatorFactory;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var journal_component_1 = __webpack_require__(396);
	var discharge_table_component_1 = __webpack_require__(400);
	var daily_data_table_component_1 = __webpack_require__(405);
	var decadal_discharge_table_component_1 = __webpack_require__(409);
	var decadal_meteo_table_component_1 = __webpack_require__(412);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.operational.journal', [])
	    .component('imomoOperationalJournal', journal_component_1.default)
	    .component('imomoOperationalJournalDailyDataTable', daily_data_table_component_1.default)
	    .component('imomoOperationalJournalDischargeTable', discharge_table_component_1.default)
	    .component('imomoOperationalJournalDecadalDischargeTable', decadal_discharge_table_component_1.default)
	    .component('imomoOperationalJournalDecadalMeteoTable', decadal_meteo_table_component_1.default)
	    .name;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var journal_controller_1 = __webpack_require__(397);
	__webpack_require__(398);
	var template = __webpack_require__(399);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: journal_controller_1.default,
	    template: template
	};


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var _ = __webpack_require__(29);
	var immutable_1 = __webpack_require__(195);
	var OperationalJournalController = (function () {
	    function OperationalJournalController($scope, dataValueApi, $rootScope) {
	        var _this = this;
	        this.$scope = $scope;
	        this.dataValueApi = dataValueApi;
	        this.$rootScope = $rootScope;
	        this.selectedStations = immutable_1.Set();
	        this.selectedDate = moment().startOf('month');
	        this.selectedMonth = this.selectedDate.month();
	        this.selectedYear = this.selectedDate.year();
	        this.loadingInProgress = false;
	        this.months = moment.months();
	        this.years = OperationalJournalController.JOURNAL_YEARS;
	        this.journalViewData = [];
	        this.deregisterTranslateListener = this.$rootScope
	            .$on('$translateChangeSuccess', function () {
	            _this.months = moment.months();
	            _this.selectedDate = moment()
	                .month(_this.selectedDate.month())
	                .year(_this.selectedDate.year());
	        });
	    }
	    // ===========================================================================
	    // Lifecycle hooks
	    // ===========================================================================
	    OperationalJournalController.prototype.$postLink = function () {
	        var _this = this;
	        // Needed because of md-select not registering a default value and
	        // triggering the validation.
	        this.selectedMonth = this.selectedDate.month();
	        this.selectedYear = this.selectedDate.year();
	        this.$scope.$applyAsync(function () {
	            _this.dateForm.month.$validate();
	            _this.dateForm.year.$validate();
	        });
	    };
	    OperationalJournalController.prototype.$onDestroy = function () {
	        this.deregisterTranslateListener();
	    };
	    Object.defineProperty(OperationalJournalController.prototype, "disabledLoadButton", {
	        get: function () {
	            return !this.dateForm || this.dateForm.$invalid
	                || this.selectedStations.isEmpty();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OperationalJournalController.prototype.onSelectedStationsChange = function (selectedStations) {
	        this.selectedStations = selectedStations;
	    };
	    OperationalJournalController.prototype.onHighlightedStationChange = function (station) {
	        this.determineTabIndex(station);
	    };
	    OperationalJournalController.prototype.onTabSelect = function (journalViewDatum) {
	        if (this.loadingInProgress) {
	            // Ignore selection.
	            return;
	        }
	        this.highlightedStation = journalViewDatum.station;
	    };
	    OperationalJournalController.prototype.loadJournal = function () {
	        var _this = this;
	        this.selectedDate = moment()
	            .month(this.selectedMonth)
	            .year(this.selectedYear);
	        this.loadingInProgress = true;
	        this.journalViewData = [];
	        this.dataValueApi.getJournalData(this.selectedMonth, this.selectedYear, this.selectedStations.map(function (station) { return station.id; }).toArray())
	            .then(function (journalData) {
	            _this.loadedJournalData = journalData;
	            _this.journalViewData = [];
	            for (var siteId in _this.loadedJournalData.siteData) {
	                var siteDatum = _this.loadedJournalData.siteData[siteId];
	                _this.journalViewData.push({
	                    station: siteDatum.site,
	                    dailyData: siteDatum.dailyData ? siteDatum.dailyData.map(_this.toJournalDailyDataRow) : null,
	                    dischargeData: siteDatum.dischargeData ? siteDatum.dischargeData.map(_this.toJournalDischargeDataRow) : null,
	                    decadalData: siteDatum.decadalData.map(_this.toJournalDecadalDataRow)
	                });
	                // removing the first item since it has date from previous month,
	                // this item is used to calculate the waterlevel trend for the first day of a month
	                _this.journalViewData.forEach(function (journalViewDatum) {
	                    if (journalViewDatum && journalViewDatum.dailyData && journalViewDatum.dailyData.length) {
	                        if (journalViewDatum.dailyData[0].date.month() !== _this.selectedDate.month()) {
	                            journalViewDatum.dailyData.splice(0, 1);
	                        }
	                    }
	                });
	            }
	            _this.journalViewData = _this.journalViewData.sort(function (a, b) {
	                return a.station.siteCode.localeCompare(b.station.siteCode);
	            });
	            _this.determineTabIndex(_this.highlightedStation);
	        })
	            .finally(function () {
	            _this.loadingInProgress = false;
	        });
	    };
	    OperationalJournalController.prototype.determineTabIndex = function (station) {
	        if (!station) {
	            return;
	        }
	        var foundIndex = this.journalViewData.findIndex(function (journalViewDatum) { return journalViewDatum.station.id == station.id; });
	        if (foundIndex > -1) {
	            this.selectedTabIndex = foundIndex;
	        }
	        else {
	            this.selectedTabIndex = 0;
	            if (this.journalViewData.length) {
	                this.highlightedStation = this.journalViewData[0].station;
	            }
	            else {
	                this.highlightedStation = null;
	            }
	        }
	    };
	    OperationalJournalController.prototype.toJournalDailyDataRow = function (dailyTriplet, index, dailyData) {
	        var date;
	        if (dailyTriplet.eightData && dailyTriplet.eightData.waterLevel) {
	            date = moment.unix(dailyTriplet.eightData.waterLevel.localDateTime).utc();
	        }
	        else if (dailyTriplet.twentyData && dailyTriplet.twentyData.waterLevel) {
	            date = moment.unix(dailyTriplet.twentyData.waterLevel.localDateTime).utc();
	        }
	        else if (dailyTriplet.eightData && dailyTriplet.eightData.discharge) {
	            date = moment.unix(dailyTriplet.eightData.discharge.localDateTime).utc();
	        }
	        else if (dailyTriplet.twentyData && dailyTriplet.twentyData.discharge) {
	            date = moment.unix(dailyTriplet.twentyData.discharge.localDateTime).utc();
	        }
	        else if (dailyTriplet.averageData && dailyTriplet.averageData.discharge) {
	            date = moment.unix(dailyTriplet.averageData.discharge.localDateTime).utc();
	        }
	        var waterLevelMorning = dailyTriplet.eightData &&
	            dailyTriplet.eightData.waterLevel &&
	            dailyTriplet.eightData.waterLevel.dataValue;
	        var dischargeMorning = dailyTriplet.eightData &&
	            dailyTriplet.eightData.discharge &&
	            dailyTriplet.eightData.discharge.dataValue;
	        var waterLevelTrend;
	        if (dailyTriplet.eightData && dailyTriplet.eightData.waterLevel && dailyData[index - 1] &&
	            dailyData[index - 1].eightData) {
	            waterLevelTrend = dailyTriplet.eightData.waterLevel.dataValue -
	                dailyData[index - 1].eightData.waterLevel.dataValue;
	        }
	        var waterLevelEvening = dailyTriplet.twentyData &&
	            dailyTriplet.twentyData.waterLevel &&
	            dailyTriplet.twentyData.waterLevel.dataValue;
	        var dischargeEvening = dailyTriplet.twentyData &&
	            dailyTriplet.twentyData.discharge &&
	            dailyTriplet.twentyData.discharge.dataValue;
	        // set averages only if both morning and evening values are present
	        var waterLevelAverage = dailyTriplet.averageData && waterLevelMorning && waterLevelEvening &&
	            dailyTriplet.averageData.waterLevel.dataValue;
	        var dischargeAverage = dailyTriplet.averageData && dischargeMorning && dischargeEvening &&
	            dailyTriplet.averageData.discharge.dataValue;
	        if (!dailyTriplet.eightData && !dailyTriplet.twentyData) {
	            dischargeAverage = dailyTriplet.averageData.discharge.dataValue;
	        }
	        var waterTemperature = dailyTriplet.additionalData &&
	            dailyTriplet.additionalData.waterTemperature &&
	            dailyTriplet.additionalData.waterTemperature.dataValue;
	        var airTemperature = dailyTriplet.additionalData &&
	            dailyTriplet.additionalData.airTemperature &&
	            dailyTriplet.additionalData.airTemperature.dataValue;
	        var icePhenomenae = dailyTriplet.additionalData &&
	            dailyTriplet.additionalData.icePhenomenae;
	        return {
	            date: date,
	            waterLevelMorning: waterLevelMorning,
	            waterLevelTrend: waterLevelTrend,
	            dischargeMorning: dischargeMorning,
	            waterLevelEvening: waterLevelEvening,
	            dischargeEvening: dischargeEvening,
	            waterLevelAverage: waterLevelAverage,
	            dischargeAverage: dischargeAverage,
	            waterTemperature: waterTemperature,
	            airTemperature: airTemperature,
	            icePhenomenae: icePhenomenae
	        };
	    };
	    OperationalJournalController.prototype.toJournalDischargeDataRow = function (dischargeTuple) {
	        return {
	            date: moment.unix(dischargeTuple.waterLevel.localDateTime).utc(),
	            waterLevel: dischargeTuple.waterLevel,
	            discharge: dischargeTuple.discharge,
	            freeRiverArea: dischargeTuple.freeRiverArea
	        };
	    };
	    OperationalJournalController.prototype.toJournalDecadalDataRow = function (decadalJournalDatum) {
	        if (typeof decadalJournalDatum.averageData.precipitation !== 'undefined' ||
	            typeof decadalJournalDatum.averageData.temperature !== 'undefined') {
	            return {
	                decadeInMonth: decadalJournalDatum.decadeInMonth,
	                precipitation: decadalJournalDatum.averageData.precipitation && decadalJournalDatum.averageData.precipitation.dataValue,
	                temperature: decadalJournalDatum.averageData.temperature && decadalJournalDatum.averageData.temperature.dataValue
	            };
	        }
	        else {
	            return {
	                decadeInMonth: decadalJournalDatum.decadeInMonth,
	                waterLevel: decadalJournalDatum.averageData.waterLevel,
	                discharge: decadalJournalDatum.averageData.discharge
	            };
	        }
	    };
	    OperationalJournalController.$inject = ['$scope', 'dataValueApi', '$rootScope'];
	    OperationalJournalController.YEAR_RANGE_SIZE = 10;
	    OperationalJournalController.JOURNAL_YEARS = _.range(moment().year() - OperationalJournalController.YEAR_RANGE_SIZE, moment().year() + OperationalJournalController.YEAR_RANGE_SIZE);
	    return OperationalJournalController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = OperationalJournalController;


/***/ },
/* 398 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 399 */
/***/ function(module, exports) {

	module.exports = "<div class=operational-journal-container layout=row> <imomo-station-selector highlighted-station-id=$ctrl.highlightedStation.id on-station-highlight-change=$ctrl.onHighlightedStationChange(station) on-select-change=$ctrl.onSelectedStationsChange(selectedStations) is-with-meteostations=true> </imomo-station-selector> <md-card flex> <md-toolbar class=imomo-medium-tall> <div class=md-toolbar-tools> <div flex layout=column> <span class=md-title translate> OPERATIONAL_JOURNAL </span> <span class=md-subhead> {{ $ctrl.selectedDate | momentFormatter:'month-long' }} </span> </div> <form name=$ctrl.dateForm> <md-input-container> <label translate>MONTH</label> <md-select required ng-model=$ctrl.selectedMonth md-no-asterisk name=month> <md-option ng-repeat=\"month in $ctrl.months\" ng-value=$index> {{ month }} </md-option> </md-select> </md-input-container> <md-input-container> <label translate>YEAR</label> <md-select required ng-model=$ctrl.selectedYear md-no-asterisk name=year> <md-option ng-repeat=\"year in $ctrl.years\" ng-value=year> {{ year }} </md-option> </md-select> </md-input-container> </form> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.loadJournal() ng-disabled=$ctrl.disabledLoadButton> <span translate> LOAD_JOURNAL </span> </md-button> </div> </md-toolbar> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress></md-progress-linear> <md-tabs flex class=full-height-tabs md-selected=$ctrl.selectedTabIndex> <md-tab ng-repeat=\"journalViewDatum in $ctrl.journalViewData\" md-on-select=$ctrl.onTabSelect(journalViewDatum)> <md-tab-label> {{ journalViewDatum.station | stationFormatter }} </md-tab-label> <md-tab-body class=fill-tab> <div class=journal-site-container> <imomo-operational-journal-daily-data-table ng-if=\"journalViewDatum.dailyData && journalViewDatum.dailyData.length\" daily-data=journalViewDatum.dailyData station-id=journalViewDatum.station.id load-journal=$ctrl.loadJournal() is-virtual-station=journalViewDatum.station.isVirtual> </imomo-operational-journal-daily-data-table> <md-divider class=bottom-divider ng-if=\"journalViewDatum.dailyData && journalViewDatum.dailyData.length\"></md-divider> <p layout-padding ng-if=\"journalViewDatum.dischargeData && !(journalViewDatum.dailyData && journalViewDatum.dailyData.length)\" translate>NO_DAILY_DATA</p> <imomo-operational-journal-discharge-table ng-if=\"journalViewDatum.dischargeData && journalViewDatum.dischargeData.length\" discharge-data=journalViewDatum.dischargeData> </imomo-operational-journal-discharge-table> <md-divider class=bottom-divider ng-if=\"journalViewDatum.dischargeData && journalViewDatum.dischargeData.length\"></md-divider> <p layout-padding ng-if=\"journalViewDatum.dischargeData && !(journalViewDatum.dischargeData && journalViewDatum.dischargeData.length)\" translate>NO_DISCHARGE_DATA</p> <imomo-operational-journal-decadal-discharge-table ng-if=\"journalViewDatum.dischargeData && journalViewDatum.decadalData && journalViewDatum.decadalData.length\" decadal-data=journalViewDatum.decadalData> </imomo-operational-journal-decadal-discharge-table> <p layout-padding ng-if=\"journalViewDatum.dischargeData && !(journalViewDatum.decadalData && journalViewDatum.decadalData.length)\" translate>NO_DECADAL_DATA</p> <imomo-operational-journal-decadal-meteo-table ng-if=\"!journalViewDatum.dischargeData && journalViewDatum.decadalData && journalViewDatum.decadalData.length\" decadal-data=journalViewDatum.decadalData selected-year=$ctrl.selectedYear selected-month=$ctrl.selectedMonth station-id=journalViewDatum.station.id load-journal=$ctrl.loadJournal()> </imomo-operational-journal-decadal-meteo-table> <p layout-padding ng-if=\"!journalViewDatum.dischargeData && !(journalViewDatum.decadalData && journalViewDatum.decadalData.length)\" translate>NO_DECADAL_DATA</p> </div> </md-tab-body> </md-tab> </md-tabs> </md-card> </div>";

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var discharge_table_controller_1 = __webpack_require__(401);
	var template = __webpack_require__(404);
	var dischargeTableComponent = {
	    bindings: {
	        dischargeData: '<'
	    },
	    controller: discharge_table_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = dischargeTableComponent;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var editDialogTemplate = __webpack_require__(402);
	var deleteDialogTemplate = __webpack_require__(403);
	var DischargeTableController = (function () {
	    function DischargeTableController($mdDialog, snackbarService, $translate) {
	        this.$mdDialog = $mdDialog;
	        this.snackbarService = snackbarService;
	        this.$translate = $translate;
	        this.selectedDischargeRows = [];
	    }
	    DischargeTableController.prototype.$onChanges = function () {
	        this.selectedDischargeRows = [];
	    };
	    Object.defineProperty(DischargeTableController.prototype, "selectedDischargeRow", {
	        /**
	         * Whether there is a selected discharge row.
	         */
	        get: function () {
	            return this.selectedDischargeRows.length > 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Prompt a dialog to edit the selected discharge data row.
	     */
	    DischargeTableController.prototype.editRow = function ($event) {
	        var _this = this;
	        var selectedDischargeRow = this.selectedDischargeRows[0];
	        var dialogOptions = {
	            locals: {
	                dischargeDataRow: selectedDischargeRow
	            },
	            controller: DischargeTableEditDialogController,
	            controllerAs: '$ctrl',
	            escapeToClose: false,
	            targetEvent: $event,
	            template: editDialogTemplate
	        };
	        this.$mdDialog.show(dialogOptions)
	            .then(function (response) {
	            response.dischargeDataRow.waterLevel.dataValue = response.waterLevel;
	            response.dischargeDataRow.discharge.dataValue = response.discharge;
	            if (response.dischargeDataRow.freeRiverArea) {
	                response.dischargeDataRow.freeRiverArea.dataValue =
	                    response.freeRiverArea;
	            }
	            _this.snackbarService.show({
	                content: _this.$translate.instant('DISCHARGE_DATA_WAS_EDITED')
	            });
	        })
	            .catch(function (error) {
	            if (error) {
	                _this.snackbarService.show({
	                    content: _this.$translate.instant('ERROR_UPDATING_DISCHARGE_DATA')
	                });
	            }
	        });
	    };
	    /**
	     * Delete the selected discharge data row from the backend.
	     */
	    DischargeTableController.prototype.deleteRow = function ($event) {
	        var _this = this;
	        var dischargeDataRow = this.selectedDischargeRows[0];
	        var dialogOptions = {
	            controller: DischargeTableDeleteDialogController,
	            controllerAs: '$ctrl',
	            escapeToClose: false,
	            locals: {
	                dischargeDataRow: dischargeDataRow
	            },
	            targetEvent: $event,
	            template: deleteDialogTemplate
	        };
	        this.$mdDialog.show(dialogOptions)
	            .then(function () {
	            _this.selectedDischargeRows = [];
	            var rowIndex = _this.dischargeData.indexOf(dischargeDataRow);
	            _this.dischargeData.splice(rowIndex, 1);
	            _this.snackbarService.show({
	                content: _this.$translate.instant('DISCHARGE_DATA_WAS_DELETED')
	            });
	        })
	            .catch(function (error) {
	            if (error) {
	                _this.snackbarService.show({
	                    content: _this.$translate.instant('ERROR_DELETING_DISCHARGE_DATA')
	                });
	            }
	        });
	    };
	    DischargeTableController.$inject = ['$mdDialog', 'snackbarService', '$translate'];
	    return DischargeTableController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DischargeTableController;
	var DischargeTableEditDialogController = (function () {
	    function DischargeTableEditDialogController(dischargeDataRow, dataValueApi, $mdDialog) {
	        this.dischargeDataRow = dischargeDataRow;
	        this.dataValueApi = dataValueApi;
	        this.$mdDialog = $mdDialog;
	        this.waterLevel = dischargeDataRow.waterLevel.dataValue;
	        this.discharge = dischargeDataRow.discharge.dataValue;
	        this.disabledFreeRiverAreaInput = dischargeDataRow.freeRiverArea == null;
	        if (dischargeDataRow.freeRiverArea) {
	            this.freeRiverArea = dischargeDataRow.freeRiverArea.dataValue;
	        }
	        this.loadingInProgress = false;
	    }
	    Object.defineProperty(DischargeTableEditDialogController.prototype, "disabledApplyButton", {
	        /**
	         * Whether the apply button is disabled.
	         */
	        get: function () {
	            if (this.editForm) {
	                var unchangedWaterLevel = this.waterLevel == this.dischargeDataRow.waterLevel.dataValue;
	                var unchangedDischarge = this.discharge == this.dischargeDataRow.discharge.dataValue;
	                var unchangedFreeRiverArea = this.dischargeDataRow.freeRiverArea != null
	                    ? this.freeRiverArea == this.dischargeDataRow.freeRiverArea.dataValue
	                    : true;
	                return this.editForm.$invalid || this.loadingInProgress ||
	                    (unchangedWaterLevel && unchangedDischarge && unchangedFreeRiverArea);
	            }
	            else {
	                return true;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Apply the changes in the backend.
	     */
	    DischargeTableEditDialogController.prototype.applyChanges = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        var waterLevelRequest = {
	            dataValue: this.waterLevel,
	            id: this.dischargeDataRow.waterLevel.id
	        };
	        var dischargeRequest = {
	            dataValue: this.discharge,
	            id: this.dischargeDataRow.discharge.id
	        };
	        var freeRiverAreaRequest = null;
	        if (this.dischargeDataRow.freeRiverArea) {
	            freeRiverAreaRequest = {
	                dataValue: this.freeRiverArea,
	                id: this.dischargeDataRow.freeRiverArea.id
	            };
	        }
	        this.dataValueApi.editDischargeData(this.dischargeDataRow.waterLevel.siteId, waterLevelRequest, dischargeRequest, freeRiverAreaRequest)
	            .then(function () {
	            _this.$mdDialog.hide({
	                dischargeDataRow: _this.dischargeDataRow,
	                waterLevel: _this.waterLevel,
	                discharge: _this.discharge,
	                freeRiverArea: _this.freeRiverArea
	            });
	        })
	            .catch(function (error) {
	            _this.$mdDialog.cancel(error);
	        })
	            .finally(function () {
	            _this.loadingInProgress = false;
	        });
	    };
	    /**
	     * Cancel the dialog without making changes.
	     */
	    DischargeTableEditDialogController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    DischargeTableEditDialogController.$inject = ['dischargeDataRow', 'dataValueApi', '$mdDialog'];
	    return DischargeTableEditDialogController;
	}());
	var DischargeTableDeleteDialogController = (function () {
	    function DischargeTableDeleteDialogController(dischargeDataRow, dataValueApi, $mdDialog) {
	        this.dischargeDataRow = dischargeDataRow;
	        this.dataValueApi = dataValueApi;
	        this.$mdDialog = $mdDialog;
	        this.loadingInProgress = false;
	    }
	    /**
	     * Delete the discharge data from the database.
	     */
	    DischargeTableDeleteDialogController.prototype.confirmDelete = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.dataValueApi.deleteDischargeData(this.dischargeDataRow.waterLevel.siteId, this.dischargeDataRow.waterLevel.id, this.dischargeDataRow.discharge.id).then(function () {
	            _this.$mdDialog.hide();
	        }).catch(function (error) {
	            _this.$mdDialog.cancel(error);
	        }).finally(function () {
	            _this.loadingInProgress = false;
	        });
	    };
	    /**
	     * Cancel the dialog without making changes.
	     */
	    DischargeTableDeleteDialogController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    DischargeTableDeleteDialogController.$inject = ['dischargeDataRow', 'dataValueApi', '$mdDialog'];
	    return DischargeTableDeleteDialogController;
	}());


/***/ },
/* 402 */
/***/ function(module, exports) {

	module.exports = "<md-dialog> <md-toolbar> <div class=md-toolbar-tools> <span class=md-title translate> EDIT_DISCHARGE_ROW </span> </div> </md-toolbar> <md-dialog-content> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress> </md-progress-linear> <form name=$ctrl.editForm class=md-dialog-content layout=column> <md-input-container> <label translate> H_CM </label> <input type=number name=waterLevel step=1 ng-model=$ctrl.waterLevel required> </md-input-container> <md-input-container> <label translate> Q_M3_S </label> <input type=number name=discharge step=0.001 ng-model=$ctrl.discharge required> </md-input-container> <md-input-container> <label translate> F_M2 </label> <input type=number name=freeRiverArea step=1 ng-required=!$ctrl.disabledFreeRiverAreaInput ng-model=$ctrl.freeRiverArea ng-disabled=$ctrl.disabledFreeRiverAreaInput> </md-input-container> </form> </md-dialog-content> <md-dialog-actions> <md-button ng-click=$ctrl.cancel() ng-disabled=$ctrl.loadingInProgress> <span translate> CANCEL </span> </md-button> <md-button class=md-primary ng-click=$ctrl.applyChanges() ng-disabled=$ctrl.disabledApplyButton> <span translate> APPLY_CHANGES </span> </md-button> </md-dialog-actions> </md-dialog>";

/***/ },
/* 403 */
/***/ function(module, exports) {

	module.exports = "<md-dialog> <md-toolbar> <div class=md-toolbar-tools> <span class=md-title translate> DELETE_DISCHARGE_DATA </span> </div> </md-toolbar> <md-dialog-content> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress> </md-progress-linear> <div class=md-dialog-content> <p translate> DELETE_DATA_WARNING </p> </div> </md-dialog-content> <md-dialog-actions> <md-button ng-click=$ctrl.cancel() ng-disabled=$ctrl.loadingInProgress> <span translate> CANCEL </span> </md-button> <md-button ng-click=$ctrl.confirmDelete() class=md-warn ng-disabled=$ctrl.loadingInProgress> <span translate> DELETE </span> </md-button> </md-dialog-actions> </md-dialog>";

/***/ },
/* 404 */
/***/ function(module, exports) {

	module.exports = "<md-toolbar class=md-table-toolbar ng-class=\"{'md-accent': $ctrl.selectedDischargeRow,\n                       'md-default': !$ctrl.selectedDischargeRow}\"> <div class=md-toolbar-tools> <span flex translate>H_Q_TABLE</span> <div> <md-button class=\"md-icon-button md-primary\" ng-click=$ctrl.editRow($event) ng-class=\"{'md-raised': $ctrl.selectedDischargeRow}\" ng-disabled=!$ctrl.selectedDischargeRow> <md-icon class=material-icons> edit </md-icon> <md-tooltip md-direction=top> <span translate> EDIT_SELECTED_ROW </span> </md-tooltip> </md-button> <md-button class=\"md-icon-button md-warn\" ng-click=$ctrl.deleteRow() ng-class=\"{'md-raised': $ctrl.selectedDischargeRow}\" ng-disabled=!$ctrl.selectedDischargeRow> <md-icon class=material-icons> delete_forever </md-icon> <md-tooltip md-direction=top> <span translate> DELETE_SELECTED_ROW_FROM_DATABASE </span> </md-tooltip> </md-button> </div> </div> </md-toolbar> <md-table-container> <table md-table md-row-select ng-model=$ctrl.selectedDischargeRows> <thead md-head> <tr md-row> <th md-column> <span translate> DATE </span> </th> <th md-column> <span translate> H_CM </span> </th> <th md-column> <span translate> Q_M3_S </span> </th> <th md-column> <span translate> F_M2 </span> </th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select md-select=dischargeDataRow ng-repeat=\"dischargeDataRow in $ctrl.dischargeData\"> <td md-cell> {{ dischargeDataRow.date | momentFormatter:'day'}} </td> <td md-cell> {{ dischargeDataRow.waterLevel.dataValue | hydroNumberFormatter }} </td> <td md-cell> {{ dischargeDataRow.discharge.dataValue | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ dischargeDataRow.freeRiverArea.dataValue | hydroNumberFormatter }} </td> </tr> </tbody> </table> </md-table-container>";

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var daily_data_table_controller_1 = __webpack_require__(406);
	var template = __webpack_require__(408);
	var dailyDataTableComponent = {
	    bindings: {
	        'dailyData': '<',
	        'stationId': '<',
	        'isVirtualStation': '<',
	        'loadJournal': '&'
	    },
	    controller: daily_data_table_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = dailyDataTableComponent;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var editDialogTemplate = __webpack_require__(407);
	var DailyDataTableController = (function () {
	    function DailyDataTableController($mdDialog, $translate, $log, snackbarService) {
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.$log = $log;
	        this.snackbarService = snackbarService;
	        this.selectedRows = [];
	    }
	    Object.defineProperty(DailyDataTableController.prototype, "selectedRow", {
	        /**
	         * Selected row, if any.
	         */
	        get: function () {
	            return this.selectedRows.length > 0 ? this.selectedRows[0] : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DailyDataTableController.prototype.$onChanges = function () {
	        this.dailyData = this.dailyData || [];
	        if (this.dailyData.length == 0) {
	            this.minimumData = null;
	            this.maximumData = null;
	        }
	        this.calculateMinimumMaximumValues();
	    };
	    DailyDataTableController.prototype.editRow = function ($event) {
	        var _this = this;
	        var dialogOptions = {
	            controller: EditDailyDataRowDialogController,
	            controllerAs: '$ctrl',
	            escapeToClose: false,
	            locals: {
	                dataRow: this.selectedRow,
	                stationId: this.stationId
	            },
	            targetEvent: $event,
	            template: editDialogTemplate
	        };
	        this.$mdDialog.show(dialogOptions)
	            .then(function (dailyTriplet) {
	            if (dailyTriplet.eightData) {
	                _this.selectedRow.waterLevelMorning = dailyTriplet.eightData
	                    .waterLevel.dataValue;
	                _this.selectedRow.dischargeMorning = dailyTriplet.eightData
	                    .discharge.dataValue;
	            }
	            if (dailyTriplet.twentyData) {
	                _this.selectedRow.waterLevelEvening = dailyTriplet.twentyData
	                    .waterLevel.dataValue;
	                _this.selectedRow.dischargeEvening = dailyTriplet.twentyData
	                    .discharge.dataValue;
	            }
	            if (dailyTriplet.averageData) {
	                _this.selectedRow.waterLevelAverage = dailyTriplet.averageData
	                    .waterLevel.dataValue;
	                _this.selectedRow.dischargeAverage = dailyTriplet.averageData
	                    .discharge.dataValue;
	            }
	            _this.calculateMinimumMaximumValues();
	            _this.snackbarService.show({
	                content: _this.$translate.instant('DAILY_DATA_WAS_EDITED')
	            });
	            _this.loadJournal();
	        })
	            .catch(function (error) {
	            if (error) {
	                _this.snackbarService.show({
	                    content: _this.$translate.instant('ERROR_UPDATING_DATA')
	                });
	                _this.$log.error(error);
	            }
	        });
	    };
	    DailyDataTableController.prototype.calculateMinimumMaximumValues = function () {
	        var _this = this;
	        this.minimumData = {
	            waterLevelMorning: Number.MAX_VALUE,
	            dischargeMorning: Number.MAX_VALUE,
	            waterLevelEvening: Number.MAX_VALUE,
	            dischargeEvening: Number.MAX_VALUE,
	            waterLevelAverage: Number.MAX_VALUE,
	            dischargeAverage: Number.MAX_VALUE,
	            waterTemperature: Number.MAX_VALUE,
	            airTemperature: Number.MAX_VALUE,
	            icePhenomena: Number.MAX_VALUE,
	        };
	        this.maximumData = {
	            waterLevelMorning: Number.MIN_VALUE,
	            dischargeMorning: Number.MIN_VALUE,
	            waterLevelEvening: Number.MIN_VALUE,
	            dischargeEvening: Number.MIN_VALUE,
	            waterLevelAverage: Number.MIN_VALUE,
	            dischargeAverage: Number.MIN_VALUE,
	            waterTemperature: Number.NEGATIVE_INFINITY,
	            airTemperature: Number.NEGATIVE_INFINITY,
	            icePhenomena: Number.MIN_VALUE,
	        };
	        this.dailyData.forEach(function (dailyDatum) {
	            if (dailyDatum.waterLevelMorning != null) {
	                _this.minimumData.waterLevelMorning = Math.min(dailyDatum.waterLevelMorning, _this.minimumData.waterLevelMorning);
	                _this.maximumData.waterLevelMorning = Math.max(dailyDatum.waterLevelMorning, _this.maximumData.waterLevelMorning);
	            }
	            if (dailyDatum.dischargeMorning != null) {
	                _this.minimumData.dischargeMorning = Math.min(dailyDatum.dischargeMorning, _this.minimumData.dischargeMorning);
	                _this.maximumData.dischargeMorning = Math.max(dailyDatum.dischargeMorning, _this.maximumData.dischargeMorning);
	            }
	            if (dailyDatum.waterLevelEvening != null) {
	                _this.minimumData.waterLevelEvening = Math.min(dailyDatum.waterLevelEvening, _this.minimumData.waterLevelEvening);
	                _this.maximumData.waterLevelEvening = Math.max(dailyDatum.waterLevelEvening, _this.maximumData.waterLevelEvening);
	            }
	            if (dailyDatum.dischargeEvening != null) {
	                _this.minimumData.dischargeEvening = Math.min(dailyDatum.dischargeEvening, _this.minimumData.dischargeEvening);
	                _this.maximumData.dischargeEvening = Math.max(dailyDatum.dischargeEvening, _this.maximumData.dischargeEvening);
	            }
	            if (dailyDatum.waterLevelAverage != null) {
	                _this.minimumData.waterLevelAverage = Math.min(dailyDatum.waterLevelAverage, _this.minimumData.waterLevelAverage);
	                _this.maximumData.waterLevelAverage = Math.max(dailyDatum.waterLevelAverage, _this.maximumData.waterLevelAverage);
	            }
	            if (dailyDatum.dischargeAverage != null) {
	                _this.minimumData.dischargeAverage = Math.min(dailyDatum.dischargeAverage, _this.minimumData.dischargeAverage);
	                _this.maximumData.dischargeAverage = Math.max(dailyDatum.dischargeAverage, _this.maximumData.dischargeAverage);
	            }
	            if (dailyDatum.waterTemperature != null) {
	                _this.minimumData.waterTemperature = Math.min(dailyDatum.waterTemperature, _this.minimumData.waterTemperature);
	                _this.maximumData.waterTemperature = Math.max(dailyDatum.waterTemperature, _this.maximumData.waterTemperature);
	            }
	            if (dailyDatum.airTemperature != null) {
	                _this.minimumData.airTemperature = Math.min(dailyDatum.airTemperature, _this.minimumData.airTemperature);
	                _this.maximumData.airTemperature = Math.max(dailyDatum.airTemperature, _this.maximumData.airTemperature);
	            }
	            // if (dailyDatum.icePhenomena != null) {
	            //     this.minimumData.icePhenomena = Math.min(
	            //         dailyDatum.icePhenomena, this.minimumData.icePhenomena);
	            //     this.maximumData.icePhenomena = Math.max(
	            //         dailyDatum.icePhenomena, this.maximumData.icePhenomena);
	            // }
	        });
	        this.minimumData = {
	            waterLevelMorning: this.minimumData.waterLevelMorning == Number.MAX_VALUE
	                ? Number.NaN : this.minimumData.waterLevelMorning,
	            dischargeMorning: this.minimumData.dischargeMorning == Number.MAX_VALUE
	                ? Number.NaN : this.minimumData.dischargeMorning,
	            waterLevelEvening: this.minimumData.waterLevelEvening == Number.MAX_VALUE
	                ? Number.NaN : this.minimumData.waterLevelEvening,
	            dischargeEvening: this.minimumData.dischargeEvening == Number.MAX_VALUE
	                ? Number.NaN : this.minimumData.dischargeEvening,
	            waterLevelAverage: this.minimumData.waterLevelAverage == Number.MAX_VALUE
	                ? Number.NaN : this.minimumData.waterLevelAverage,
	            dischargeAverage: this.minimumData.dischargeAverage == Number.MAX_VALUE
	                ? Number.NaN : this.minimumData.dischargeAverage,
	            waterTemperature: this.minimumData.waterTemperature == Number.MAX_VALUE
	                ? Number.NaN : this.minimumData.waterTemperature,
	            airTemperature: this.minimumData.airTemperature == Number.MAX_VALUE
	                ? Number.NaN : this.minimumData.airTemperature,
	            icePhenomena: this.minimumData.icePhenomena == Number.MAX_VALUE
	                ? Number.NaN : this.minimumData.icePhenomena
	        };
	        this.maximumData = {
	            waterLevelMorning: this.maximumData.waterLevelMorning == Number.MIN_VALUE
	                ? Number.NaN : this.maximumData.waterLevelMorning,
	            dischargeMorning: this.maximumData.dischargeMorning == Number.MIN_VALUE
	                ? Number.NaN : this.maximumData.dischargeMorning,
	            waterLevelEvening: this.maximumData.waterLevelEvening == Number.MIN_VALUE
	                ? Number.NaN : this.maximumData.waterLevelEvening,
	            dischargeEvening: this.maximumData.dischargeEvening == Number.MIN_VALUE
	                ? Number.NaN : this.maximumData.dischargeEvening,
	            waterLevelAverage: this.maximumData.waterLevelAverage == Number.MIN_VALUE
	                ? Number.NaN : this.maximumData.waterLevelAverage,
	            dischargeAverage: this.maximumData.dischargeAverage == Number.MIN_VALUE
	                ? Number.NaN : this.maximumData.dischargeAverage,
	            waterTemperature: this.maximumData.waterTemperature == Number.NEGATIVE_INFINITY
	                ? Number.NaN : this.maximumData.waterTemperature,
	            airTemperature: this.maximumData.airTemperature == Number.NEGATIVE_INFINITY
	                ? Number.NaN : this.maximumData.airTemperature,
	            icePhenomena: this.maximumData.icePhenomena == Number.MIN_VALUE
	                ? Number.NaN : this.maximumData.icePhenomena
	        };
	    };
	    DailyDataTableController.$inject = ['$mdDialog', '$translate',
	        '$log', 'snackbarService'];
	    return DailyDataTableController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DailyDataTableController;
	var EditDailyDataRowDialogController = (function () {
	    function EditDailyDataRowDialogController(dataRow, stationId, $mdDialog, dataValueApi) {
	        this.dataRow = dataRow;
	        this.stationId = stationId;
	        this.$mdDialog = $mdDialog;
	        this.dataValueApi = dataValueApi;
	        this.date = dataRow.date;
	        this.waterLevelMorning = dataRow.waterLevelMorning;
	        this.waterLevelEvening = dataRow.waterLevelEvening;
	        this.loadingInProgress = false;
	    }
	    Object.defineProperty(EditDailyDataRowDialogController.prototype, "disabledApplyButton", {
	        /**
	         * Whether the apply changes button is disabled.
	         */
	        get: function () {
	            return !this.editForm || this.editForm.$invalid || this.loadingInProgress;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(EditDailyDataRowDialogController.prototype, "waterLevelAverage", {
	        /**
	         * Calculated water level average.
	         */
	        get: function () {
	            if (this.dataRow.waterLevelAverage == null) {
	                return null;
	            }
	            var waterLevelSum = 0;
	            var waterLevelCount = 0;
	            if (this.waterLevelMorning != null) {
	                waterLevelSum += this.waterLevelMorning;
	                waterLevelCount++;
	            }
	            if (this.waterLevelEvening != null) {
	                waterLevelSum += this.waterLevelEvening;
	                waterLevelCount++;
	            }
	            return waterLevelCount > 1
	                ? Math.round(waterLevelSum / waterLevelCount)
	                : Number.NaN;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Apply the changes to the daily water level.
	     */
	    EditDailyDataRowDialogController.prototype.applyChanges = function () {
	        var _this = this;
	        this.dataValueApi.editDailyData(this.stationId, this.date, this.waterLevelMorning, this.waterLevelEvening, this.waterLevelAverage)
	            .then(function (dailyTriplet) {
	            _this.$mdDialog.hide(dailyTriplet);
	        })
	            .catch(function (error) {
	            _this.$mdDialog.cancel(error);
	        });
	    };
	    /**
	     * Cancel the dialog without any changes.
	     */
	    EditDailyDataRowDialogController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    EditDailyDataRowDialogController.$inject = ['dataRow', 'stationId',
	        '$mdDialog', 'dataValueApi'];
	    return EditDailyDataRowDialogController;
	}());


/***/ },
/* 407 */
/***/ function(module, exports) {

	module.exports = "<md-dialog> <md-toolbar> <div class=md-toolbar-tools> <span class=md-title translate> EDIT_DAILY_DATA_ROW </span> </div> </md-toolbar> <md-dialog-content> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress> </md-progress-linear> <form name=$ctrl.editForm class=md-dialog-content layout=column> <md-input-container> <span translate> DATE </span> <span class=md-body-2> {{ $ctrl.date | momentFormatter:'date'}} </span> </md-input-container> <md-input-container> <label translate> H_8_AM </label> <input type=number name=waterLevelMorning step=1 ng-model=$ctrl.waterLevelMorning required ng-disabled=$ctrl.loadingInProgress> </md-input-container> <md-input-container> <label translate> H_8_PM </label> <input type=number name=waterLevelEvening step=1 ng-model=$ctrl.waterLevelEvening required ng-disabled=$ctrl.loadingInProgress> </md-input-container> <md-input-container ng-if=\"$ctrl.dataRow.waterLevelAverage != null\"> <label translate> H_AVERAGE </label> <input type=number name=waterLevelAverage disabled=disabled ng-value=\"$ctrl.waterLevelAverage | hydroNumberFormatter\">  </md-input-container> </form> </md-dialog-content> <md-dialog-actions> <md-button ng-click=$ctrl.cancel() ng-disabled=$ctrl.loadingInProgress> <span translate> CANCEL </span> </md-button> <md-button class=md-primary ng-click=$ctrl.applyChanges() ng-disabled=$ctrl.disabledApplyButton> <span translate> APPLY_CHANGES </span> </md-button> </md-dialog-actions> </md-dialog>";

/***/ },
/* 408 */
/***/ function(module, exports) {

	module.exports = "<md-toolbar class=md-table-toolbar ng-class=\"{'md-accent': $ctrl.selectedRow,\n                       'md-default': !$ctrl.selectedRow}\"> <div class=md-toolbar-tools> <span flex translate>DAILY_DATA</span> <div> <md-button class=\"md-icon-button md-primary\" ng-click=$ctrl.editRow($event) ng-class=\"{'md-raised': $ctrl.selectedRow}\" ng-disabled=!$ctrl.selectedRow> <md-icon class=material-icons> edit </md-icon> <md-tooltip md-direction=bottom> <span translate> EDIT_SELECTED_ROW </span> </md-tooltip> </md-button> </div> </div> </md-toolbar> <md-table-container class=daily-data-table> <table md-table md-row-select ng-model=$ctrl.selectedRows> <thead md-head> <tr md-row> <th md-column colspan=2> <span translate> DATE </span> </th> <th md-column colspan=3> <span translate> 8_AM </span> </th> <th md-column colspan=2> <span translate> 8_PM </span> </th> <th md-column colspan=2> <span translate> AVERAGE </span> </th> </tr> <tr md-row> <th md-column></th> <th md-column md-numeric> <span translate> H_CM </span> </th> <th md-column md-numeric> <span translate> TREND </span> </th> <th md-column md-numeric> <span translate> Q_M3_S </span> </th> <th md-column md-numeric> <span translate> H_CM </span> </th> <th md-column md-numeric> <span translate> Q_M3_S </span> </th> <th md-column md-numeric> <span translate> H_CM </span> </th> <th md-column md-numeric> <span translate> Q_M3_S </span> </th> <th md-column md-numeric> <span translate> WATER_CELSIUS </span> </th> <th md-column md-numeric> <span translate> AIR_CELSIUS </span> </th> <th md-column md-numeric> <span translate> ICE </span> </th> </tr> </thead> <tbody md-body> <tr ng-if=$ctrl.isVirtualStation md-row ng-repeat=\"dailyDataRow in $ctrl.dailyData\"> <td md-cell> {{ dailyDataRow.date | momentFormatter:'day'}} </td> <td md-cell> {{ dailyDataRow.waterLevelMorning | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.waterLevelTrend | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.dischargeMorning | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.waterLevelEvening | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.dischargeEvening | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.waterLevelAverage | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.dischargeAverage | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.waterTemperature | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.airTemperature | hydroNumberFormatter }} </td> <td md-cell> <span> {{ dailyDataRow.icePhenomenae | icePhenomenaFormatter}} </span> </td> </tr> <tr ng-if=!$ctrl.isVirtualStation md-row md-auto-select md-select=dailyDataRow ng-repeat=\"dailyDataRow in $ctrl.dailyData\"> <td md-cell> {{ dailyDataRow.date | momentFormatter:'day'}} </td> <td md-cell> {{ dailyDataRow.waterLevelMorning | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.waterLevelTrend | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.dischargeMorning | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.waterLevelEvening | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.dischargeEvening | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.waterLevelAverage | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.dischargeAverage | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.waterTemperature | hydroNumberFormatter }} </td> <td md-cell> {{ dailyDataRow.airTemperature | hydroNumberFormatter }} </td> <td md-cell> <span> {{ dailyDataRow.icePhenomenae | icePhenomenaFormatter}} </span> </td> </tr> <tr md-row style=color:rgba(0,0,0,.54);font-size:12px;font-weight:700;text-align:right;white-space:nowrap> <th md-cell></th> <th md-cell md-numeric> <span translate> H_CM </span> </th> <th md-cell md-numeric> <span translate> TREND </span> </th> <th md-cell md-numeric> <span translate> Q_M3_S </span> </th> <th md-cell md-numeric> <span translate> H_CM </span> </th> <th md-cell md-numeric> <span translate> Q_M3_S </span> </th> <th md-cell md-numeric> <span translate> H_CM </span> </th> <th md-cell md-numeric> <span translate> Q_M3_S </span> </th> <th md-cell md-numeric> <span translate> WATER_CELSIUS </span> </th> <th md-cell md-numeric> <span translate> AIR_CELSIUS </span> </th> <th md-cell md-numeric> <span translate> ICE </span> </th> </tr> <tr md-row ng-if=$ctrl.minimumData class=bold> <td md-cell> <span translate> MINIMUM </span> </td> <td md-cell> {{ $ctrl.minimumData.waterLevelMorning | hydroNumberFormatter }} </td> <td md-cell></td> <td md-cell> {{ $ctrl.minimumData.dischargeMorning | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ $ctrl.minimumData.waterLevelEvening | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.minimumData.dischargeEvening | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ $ctrl.minimumData.waterLevelAverage | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.minimumData.dischargeAverage | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ $ctrl.minimumData.waterTemperature | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.minimumData.airTemperature | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.minimumData.icePhenomena | hydroNumberFormatter }} </td> </tr> <tr md-row ng-if=$ctrl.maximumData class=bold> <td md-cell> <span translate> MAXIMUM </span> </td> <td md-cell> {{ $ctrl.maximumData.waterLevelMorning | hydroNumberFormatter }} </td> <td md-cell></td> <td md-cell> {{ $ctrl.maximumData.dischargeMorning | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ $ctrl.maximumData.waterLevelEvening | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.maximumData.dischargeEvening | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ $ctrl.maximumData.waterLevelAverage | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.maximumData.dischargeAverage | hydroDischargeNumberFormatter }} </td> <td md-cell> {{ $ctrl.maximumData.waterTemperature | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.maximumData.airTemperature | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.maximumData.icePhenomena | hydroNumberFormatter }} </td> </tr> </tbody> </table> </md-table-container>";

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var decadal_discharge_table_controller_1 = __webpack_require__(410);
	var template = __webpack_require__(411);
	var decadalTableComponent = {
	    bindings: {
	        decadalData: '<'
	    },
	    controller: decadal_discharge_table_controller_1.DecadalTableController,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = decadalTableComponent;


/***/ },
/* 410 */
/***/ function(module, exports) {

	"use strict";
	var DecadalTableController = (function () {
	    function DecadalTableController() {
	    }
	    DecadalTableController.prototype.$onChanges = function () {
	        this.decadalData = this.decadalData || [];
	        if (this.decadalData.length == 0) {
	            this.monthlyAverage = null;
	            return;
	        }
	        var accumulatedData = this.decadalData
	            .reduce(function (previousValue, currentValue) {
	            return {
	                waterLevel: previousValue.waterLevel + currentValue.waterLevel,
	                discharge: previousValue.discharge + currentValue.discharge
	            };
	        }, {
	            waterLevel: 0,
	            discharge: 0
	        });
	        this.monthlyAverage = {
	            waterLevel: Math.round(accumulatedData.waterLevel / this.decadalData.length),
	            discharge: accumulatedData.discharge / this.decadalData.length
	        };
	    };
	    return DecadalTableController;
	}());
	exports.DecadalTableController = DecadalTableController;


/***/ },
/* 411 */
/***/ function(module, exports) {

	module.exports = "<md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span translate>DECADAL_DATA</span> </div> </md-toolbar> <md-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column> <span translate> DECADE </span> </th> <th md-column md-numeric> <span translate> H_CM </span> </th> <th md-column md-numeric> <span translate> Q_M3_S </span> </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"decadalDataRow in $ctrl.decadalData\"> <td md-cell> {{ decadalDataRow.decadeInMonth }} </td> <td md-cell> {{ decadalDataRow.waterLevel | hydroNumberFormatter }} </td> <td md-cell> {{ decadalDataRow.discharge | hydroDischargeNumberFormatter }} </td> </tr> <tr md-row ng-if=$ctrl.monthlyAverage class=bold> <td md-cell> <span translate> MONTHLY_AVERAGE </span> </td> <td md-cell> {{ $ctrl.monthlyAverage.waterLevel | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.monthlyAverage.discharge | hydroDischargeNumberFormatter }} </td> </tr> </tbody> </table> </md-table-container>";

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var decadal_meteo_table_controller_1 = __webpack_require__(413);
	var template = __webpack_require__(415);
	var decadalMeteoTableComponent = {
	    bindings: {
	        decadalData: '<',
	        selectedYear: '<',
	        selectedMonth: '<',
	        stationId: '<',
	        'loadJournal': '&'
	    },
	    controller: decadal_meteo_table_controller_1.DecadalMeteoTableController,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = decadalMeteoTableComponent;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var editDialogTemplate = __webpack_require__(414);
	var DecadalMeteoTableController = (function () {
	    function DecadalMeteoTableController($mdDialog, $translate, $log, snackbarService, dataValueApi) {
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.$log = $log;
	        this.snackbarService = snackbarService;
	        this.dataValueApi = dataValueApi;
	        this.selectedRows = [];
	    }
	    DecadalMeteoTableController.prototype.$onChanges = function () {
	        this.decadalData = this.decadalData || [];
	        if (this.decadalData.length == 0) {
	            this.monthlyValues = null;
	            return;
	        }
	        var accumulatedData = this.decadalData
	            .reduce(function (previousValue, currentValue) {
	            return {
	                precipitation: previousValue.precipitation + currentValue.precipitation,
	                temperature: previousValue.temperature + currentValue.temperature
	            };
	        }, {
	            precipitation: 0,
	            temperature: 0
	        });
	        this.monthlyValues = {
	            precipitation: accumulatedData.precipitation,
	            temperature: accumulatedData.temperature / this.decadalData.length
	        };
	    };
	    Object.defineProperty(DecadalMeteoTableController.prototype, "selectedRow", {
	        get: function () {
	            return this.selectedRows.length > 0 ? this.selectedRows[0] : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DecadalMeteoTableController.prototype.editRow = function ($event) {
	        var _this = this;
	        var dialogOptions = {
	            controller: EditDecadalMeteoDataRowDialogController,
	            controllerAs: '$ctrl',
	            escapeToClose: false,
	            locals: {
	                dataRow: this.selectedRow,
	                stationId: this.stationId,
	                year: this.selectedYear,
	                month: this.selectedMonth + 1
	            },
	            targetEvent: $event,
	            template: editDialogTemplate
	        };
	        this.$mdDialog.show(dialogOptions)
	            .then(function (decadalData) {
	            if (decadalData && decadalData.temperature) {
	                _this.selectedRow.temperature = decadalData.temperature;
	            }
	            if (decadalData && decadalData.precipitation) {
	                _this.selectedRow.precipitation = decadalData.precipitation;
	            }
	            _this.snackbarService.show({
	                content: _this.$translate.instant('METEO_DATA_WAS_EDITED')
	            });
	            _this.loadJournal();
	        })
	            .catch(function (error) {
	            if (error) {
	                _this.snackbarService.show({
	                    content: _this.$translate.instant('ERROR_UPDATING_DATA')
	                });
	                _this.$log.error(error);
	            }
	        });
	    };
	    DecadalMeteoTableController.$inject = ['$mdDialog', '$translate', '$log', 'snackbarService', 'dataValueApi'];
	    return DecadalMeteoTableController;
	}());
	exports.DecadalMeteoTableController = DecadalMeteoTableController;
	var EditDecadalMeteoDataRowDialogController = (function () {
	    function EditDecadalMeteoDataRowDialogController(dataRow, stationId, month, year, $mdDialog, dataValueApi) {
	        this.dataRow = dataRow;
	        this.stationId = stationId;
	        this.month = month;
	        this.year = year;
	        this.$mdDialog = $mdDialog;
	        this.dataValueApi = dataValueApi;
	        this.decade = dataRow.decadeInMonth;
	        this.temperature = dataRow.temperature;
	        this.precipitation = dataRow.precipitation;
	        this.loadingInProgress = false;
	    }
	    /**
	     * Apply the changes to the daily water level.
	     */
	    EditDecadalMeteoDataRowDialogController.prototype.applyChanges = function () {
	        var _this = this;
	        this.dataValueApi.editMeteoDecadalData(this.stationId, this.year, this.month, this.decade, this.temperature, this.precipitation)
	            .then(function (decadalData) {
	            _this.$mdDialog.hide({
	                decadeInMonth: _this.decade,
	                temperature: _this.temperature,
	                precipitation: _this.precipitation
	            });
	        })
	            .catch(function (error) {
	            _this.$mdDialog.cancel(error);
	        });
	    };
	    /**
	     * Cancel the dialog without any changes.
	     */
	    EditDecadalMeteoDataRowDialogController.prototype.cancel = function () {
	        this.$mdDialog.cancel();
	    };
	    EditDecadalMeteoDataRowDialogController.$inject = ['dataRow', 'stationId', 'month', 'year',
	        '$mdDialog', 'dataValueApi'];
	    return EditDecadalMeteoDataRowDialogController;
	}());


/***/ },
/* 414 */
/***/ function(module, exports) {

	module.exports = "<md-dialog> <md-toolbar> <div class=md-toolbar-tools> <span class=md-title translate> EDIT_METEO_ROW </span> </div> </md-toolbar> <md-dialog-content> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress> </md-progress-linear> <form name=$ctrl.editForm class=md-dialog-content layout=column> <md-input-container> <label translate> TEMPERATURE </label> <input type=number name=temperature step=1 ng-model=$ctrl.temperature required> </md-input-container> <md-input-container> <label translate> PRECIPITATION </label> <input type=number name=precipitation step=1 ng-model=$ctrl.precipitation required> </md-input-container> </form> </md-dialog-content> <md-dialog-actions> <md-button ng-click=$ctrl.cancel() ng-disabled=$ctrl.loadingInProgress> <span translate> CANCEL </span> </md-button> <md-button class=md-primary ng-click=$ctrl.applyChanges()> <span translate> APPLY_CHANGES </span> </md-button> </md-dialog-actions> </md-dialog>";

/***/ },
/* 415 */
/***/ function(module, exports) {

	module.exports = "<md-toolbar class=md-table-toolbar ng-class=\"{'md-accent': $ctrl.selectedRow,\n                       'md-default': !$ctrl.selectedRow}\"> <div class=md-toolbar-tools> <span flex translate>DECADAL_DATA</span> <div> <md-button class=\"md-icon-button md-primary\" ng-click=$ctrl.editRow($event) ng-class=\"{'md-raised': $ctrl.selectedRow}\" ng-disabled=!$ctrl.selectedRow> <md-icon class=material-icons> edit </md-icon> <md-tooltip md-direction=bottom> <span translate> EDIT_SELECTED_ROW </span> </md-tooltip> </md-button> </div> </div> </md-toolbar> <md-table-container> <table md-table md-row-select ng-model=$ctrl.selectedRows> <thead md-head> <tr md-row> <th md-column> <span translate> DECADE </span> </th> <th md-column md-numeric> <span translate> PRECIPITATION </span> </th> <th md-column md-numeric> <span translate> TEMPERATURE </span> </th> </tr> </thead> <tbody md-body> <tr md-row md-row md-auto-select md-select=decadalDataRow ng-repeat=\"decadalDataRow in $ctrl.decadalData\"> <td md-cell> {{ decadalDataRow.decadeInMonth }} </td> <td md-cell> {{ decadalDataRow.precipitation | hydroNumberFormatter }} </td> <td md-cell> {{ decadalDataRow.temperature | hydroNumberFormatter }} </td> </tr> <tr md-row ng-if=$ctrl.monthlyValues class=bold> <td md-cell> <span translate> MONTHLY_VALUES </span> </td> <td md-cell> {{ $ctrl.monthlyValues.precipitation | hydroNumberFormatter }} </td> <td md-cell> {{ $ctrl.monthlyValues.temperature | hydroNumberFormatter }} </td> </tr> </tbody> </table> </md-table-container>";

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var auth_guard_1 = __webpack_require__(198);
	__webpack_require__(417);
	exports.configStates = function ($stateProvider) {
	    var stateData = {};
	    stateData[auth_guard_1.AuthGuard.REQUIRES_AUTH_KEY] = true;
	    $stateProvider.state('operational', {
	        url: '/operational',
	        abstract: true,
	        component: 'imomoOperational',
	        data: stateData
	    });
	    $stateProvider.state('operational.options', {
	        parent: 'operational',
	        url: '',
	        component: 'imomoOperationalOptions'
	    });
	    $stateProvider.state('operational.input', {
	        parent: 'operational',
	        url: '/input?telegrams',
	        component: 'imomoOperationalInput',
	        params: {
	            telegrams: {
	                dynamic: true,
	                array: true
	            }
	        }
	    });
	    $stateProvider.state('operational.journal', {
	        parent: 'operational',
	        url: '/journal',
	        component: 'imomoOperationalJournal'
	    });
	    $stateProvider.state('operational.bulletin', {
	        parent: 'operational',
	        url: '/bulletin/:type',
	        component: 'imomoOperationalBulletin'
	    });
	    $stateProvider.state('operational.bulk-data', {
	        parent: 'operational',
	        url: '/bulk-data',
	        component: 'imomoOperationalBulkDataDownload'
	    });
	};
	exports.configStates.$inject = ['$stateProvider'];
	var operationalComponent = {
	    template: '<ui-view class="inner-outlet"></ui-view>'
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = operationalComponent;


/***/ },
/* 417 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var template = __webpack_require__(419);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    template: template
	};


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=operational-options-container layout=row layout-align=\"start start\" layout-wrap> <md-card class=operational-options-card> <md-card-title> <md-card-title-text> <span class=md-headline translate> OPERATIONAL_DATA_INPUT </span> </md-card-title-text> <md-card-title-media> <div class=md-media-lg> <img class=options-image src=" + __webpack_require__(420) + "> </div> </md-card-title-media> </md-card-title> <md-card-actions layout=row layout-align=\"end stretch\"> <md-button ui-sref=operational.input> <span translate>ENTER_TELEGRAM</span> </md-button> </md-card-actions> </md-card> <md-card class=operational-options-card> <md-card-title> <md-card-title-text> <span class=md-headline translate> OPERATIONAL_JOURNAL </span> </md-card-title-text> <md-card-title-media> <div class=md-media-lg> <img class=options-image src=" + __webpack_require__(421) + "> </div> </md-card-title-media> </md-card-title> <md-card-actions layout=row layout-align=\"end stretch\"> <md-button ui-sref=operational.journal> <span translate>VIEW_JOURNAL</span> </md-button> </md-card-actions> </md-card> <md-card class=operational-options-card> <md-card-title> <md-card-title-text> <span class=md-headline translate> DAILY_OPERATIONAL_BULLETIN </span> </md-card-title-text> <md-card-title-media> <div class=md-media-lg> <img class=options-image src=" + __webpack_require__(422) + "> </div> </md-card-title-media> </md-card-title> <md-card-actions layout=row layout-align=\"end stretch\"> <md-button ui-sref=\"operational.bulletin({type: 'daily'})\"> <span translate>GENERATE_BULLETIN</span> </md-button> </md-card-actions> </md-card> <md-card class=operational-options-card> <md-card-title> <md-card-title-text> <span class=md-headline translate> DECADAL_OPERATIONAL_BULLETIN </span> </md-card-title-text> <md-card-title-media> <div class=md-media-lg> <img class=options-image src=" + __webpack_require__(422) + "> </div> </md-card-title-media> </md-card-title> <md-card-actions layout=row layout-align=\"end stretch\"> <md-button ui-sref=\"operational.bulletin({type: 'decadal'})\"> <span translate>GENERATE_BULLETIN</span> </md-button> </md-card-actions> </md-card> <md-card class=operational-options-card> <md-card-title> <md-card-title-text> <span class=md-headline translate> BULK_DATA_DOWNLOAD </span> </md-card-title-text> <md-card-title-media> <div class=md-media-lg> <img class=options-image src=" + __webpack_require__(423) + "> </div> </md-card-title-media> </md-card-title> <md-card-actions layout=row layout-align=\"end stretch\"> <md-button ui-sref=operational.bulk-data> <span translate>GENERATE_BULK_DATA</span> </md-button> </md-card-actions> </md-card> </section>";

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/8f35b27ab69db875ad01133bb6ffdcd3.jpg";

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/64be33f89cd1b00382deea2a73b44722.jpg";

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/76f22051ebf9eaa9333cd7a20bd9c285.jpg";

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/27c9388a9fa699b678bd080bd8fa63ef.jpg";

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var bulettin_controller_1 = __webpack_require__(425);
	var template = __webpack_require__(426);
	var bulletinComponent = {
	    controller: bulettin_controller_1.BulletinController,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = bulletinComponent;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var moment = __webpack_require__(45);
	var BulletinController = (function () {
	    function BulletinController(organizationApi, $log, $stateParams, $timeout) {
	        var _this = this;
	        this.organizationApi = organizationApi;
	        this.$log = $log;
	        this.$stateParams = $stateParams;
	        this.$timeout = $timeout;
	        this.subscriberList = [];
	        this.decadalPeriod = _.range(1, 10);
	        this.preselectedStations = [];
	        this.date = new Date();
	        this.selectedStations = immutable_1.Set();
	        this.loadingInProgress = false;
	        this.maxDate = new Date();
	        this.readyToDownload = false;
	        this.bulletinType = this.$stateParams.type;
	        if (this.bulletinType === "decadal") {
	            this.organizationApi.getDecadalBulletinSettings()
	                .then(function (data) {
	                _this.decadalBulletinIssueDate = data.dayOfDecade;
	                _this.subscriberList = data.subscriptions;
	                _this.preselectedStations = data.sites;
	            });
	        }
	    }
	    BulletinController.prototype.onSelectedStationsChange = function (selectedStations) {
	        this.selectedStations = selectedStations;
	        if (selectedStations) {
	            this.preselectedStations = selectedStations.toArray();
	        }
	    };
	    BulletinController.prototype.prepareBulletin = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.$timeout(function () {
	            _this.readyToDownload = true;
	        }, 1000).finally(function () {
	            _this.loadingInProgress = false;
	        });
	    };
	    BulletinController.prototype.downloadBulletin = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.organizationApi.generateBulletin(this.$stateParams.type === 'daily' ? 'daily_bulletin' : 'decadal_bulletin', this.selectedStations.map(function (station) { return station.id; }).toArray(), moment(this.date))
	            .then(function (data) {
	            var byteArray = new Uint8Array(data.filecontent);
	            var filename = data.filename;
	            var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
	            // Create a link element and click it to trigger the download
	            var downloadLink = document.createElement('a');
	            downloadLink.href = window.URL.createObjectURL(blob);
	            downloadLink.download = filename;
	            downloadLink.click();
	        })
	            .catch(function (error) {
	            _this.$log.error('Error retrieving bulletin.', error);
	        })
	            .finally(function () {
	            _this.loadingInProgress = false;
	        });
	    };
	    BulletinController.prototype.addToSubscriberList = function (subscriber) {
	        this.subscriberList.push(subscriber);
	    };
	    BulletinController.prototype.removeSubscriber = function ($index) {
	        this.subscriberList.splice($index, 1);
	    };
	    BulletinController.prototype.onDecadalBulletinScheduleSettingsSave = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.organizationApi.saveDecadalBulletinSettings({
	            dayOfDecade: this.decadalBulletinIssueDate,
	            subscriptions: this.subscriberList,
	            siteIds: this.selectedStations.map(function (station) { return station.id; }).toArray()
	        })
	            .finally(function () {
	            _this.loadingInProgress = false;
	        });
	    };
	    BulletinController.prototype.onDecadalBulletinScheduleSettingsDelete = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.organizationApi.deleteDecadalBulletinSettings()
	            .then(function () {
	            _this.decadalBulletinIssueDate = null;
	            _this.subscriberList = [];
	        })
	            .finally(function () {
	            _this.loadingInProgress = false;
	        });
	    };
	    BulletinController.prototype.isDecadalBulletinScheduleSettingsSaveDisabled = function () {
	        return typeof this.decadalBulletinIssueDate === 'undefined' ||
	            !(this.subscriberList && this.subscriberList.length) ||
	            !(this.selectedStations && this.selectedStations.toArray().length);
	    };
	    BulletinController.$inject = ['organizationApi', '$log', '$stateParams', '$timeout'];
	    return BulletinController;
	}());
	exports.BulletinController = BulletinController;


/***/ },
/* 426 */
/***/ function(module, exports) {

	module.exports = "<div class=operational-bulletin-container layout=row ng-if=\"$ctrl.bulletinType !== 'decadal'\"> <imomo-station-selector on-select-change=$ctrl.onSelectedStationsChange(selectedStations)> </imomo-station-selector> <md-card> <md-card-header> <md-card-header-text> <span class=md-title translate> OPERATIONAL_BULLETIN </span> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress></md-progress-linear> </md-card-header-text> </md-card-header> <md-card-content flex layout=column> <form name=$ctrl.bulletinForm flex layout=column> <div layout=row layout-align=\"start center\"> <label translate> BULLETIN_DATE </label> <md-datepicker ng-model=$ctrl.date required ng-disabled=$ctrl.loadingInProgress md-max-date=$ctrl.maxDate></md-datepicker> </div> <div flex></div> <md-button class=\"md-raised md-primary\" type=submit ng-click=$ctrl.prepareBulletin() ng-disabled=\"$ctrl.bulletinForm.$invalid || $ctrl.loadingInProgress || !$ctrl.selectedStations.toArray().length\"> <span translate> PREPARE_BULLETIN </span> </md-button> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.downloadBulletin() ng-disabled=\"!$ctrl.readyToDownload || $ctrl.loadingInProgress\"> <span translate> DOWNLOAD_BULLETIN </span> </md-button> </form> </md-card-content> </md-card> </div> <div class=operational-bulletin-container ng-if=\"$ctrl.bulletinType === 'decadal'\"> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress></md-progress-linear> <div layout=row> <imomo-station-selector stations=$ctrl.preselectedStations is-list-cached=false on-select-change=$ctrl.onSelectedStationsChange(selectedStations)> </imomo-station-selector> <div layout=row layout-align=\"center top\"> <md-card layout-padding style=width:500px> <md-input-container> <label translate>ISSUE_DATE</label> <md-select ng-model=$ctrl.decadalBulletinIssueDate> <md-option ng-repeat=\"number in $ctrl.decadalPeriod\" ng-value=number>{{ number }}</md-option> </md-select> </md-input-container> <form name=invitationForm layout=row flex> <md-input-container flex> <input flex type=email ng-model=$ctrl.subscriber placeholder=\"{{ 'EMAIL' | translate}}\"> </md-input-container> <div> <md-button type=submit class=\"md-primary md-raised\" ng-disabled=invitationForm.$invalid ng-click=$ctrl.addToSubscriberList($ctrl.subscriber)> <span translate>ADD</span> </md-button> </div> </form> <md-content class=md-whiteframe-2dp layout=column> <md-list> <md-list-item ng-repeat=\"subscriber in $ctrl.subscriberList track by $index\" layout-padding> <div>{{ subscriber }}</div> <md-icon class=\"material-icons md-secondary md-warn\" ng-click=$ctrl.removeSubscriber($index)> cancel </md-icon> </md-list-item> </md-list> </md-content> <div layout=row> <span flex></span> <md-button ng-click=$ctrl.onDecadalBulletinScheduleSettingsDelete() class=\"md-raised md-warn\" ng-disabled=$ctrl.isDecadalBulletinScheduleSettingsSaveDisabled()> <span translate>DELETE</span> </md-button> <md-button ng-click=$ctrl.onDecadalBulletinScheduleSettingsSave() class=\"md-raised md-primary\" ng-disabled=$ctrl.isDecadalBulletinScheduleSettingsSaveDisabled()> <span translate>SAVE</span> </md-button> </div> </md-card> </div> </div> </div>";

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var bulk_data_download_controller_1 = __webpack_require__(428);
	var template = __webpack_require__(429);
	var bulkDataDownloadComponent = {
	    controller: bulk_data_download_controller_1.BulkDataDownloadController,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = bulkDataDownloadComponent;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var BulkDataDownloadController = (function () {
	    function BulkDataDownloadController(dataValueApi, $log, $timeout) {
	        this.dataValueApi = dataValueApi;
	        this.$log = $log;
	        this.$timeout = $timeout;
	        this.selectedStations = immutable_1.Set();
	        this.loadingInProgress = false;
	        this.readyToDownload = false;
	    }
	    BulkDataDownloadController.prototype.onSelectedStationsChange = function (selectedStations) {
	        this.selectedStations = selectedStations;
	    };
	    BulkDataDownloadController.prototype.downloadBulkData = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.dataValueApi.getBulkData(this.selectedStations.map(function (station) { return station.id; }).toArray())
	            .then(function (data) {
	            var byteArray = new Uint8Array(data.filecontent);
	            var filename = data.filename;
	            var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
	            // Create a link element and click it to trigger the download
	            var downloadLink = document.createElement('a');
	            downloadLink.href = window.URL.createObjectURL(blob);
	            downloadLink.download = filename;
	            downloadLink.click();
	        })
	            .catch(function (error) {
	            _this.$log.error('Error retrieving bulk data.', error);
	        })
	            .finally(function () {
	            _this.loadingInProgress = false;
	        });
	    };
	    BulkDataDownloadController.prototype.prepareBulkData = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.$timeout(function () {
	            _this.readyToDownload = true;
	        }, 1000).finally(function () {
	            _this.loadingInProgress = false;
	        });
	    };
	    BulkDataDownloadController.$inject = ['dataValueApi', '$log', '$timeout'];
	    return BulkDataDownloadController;
	}());
	exports.BulkDataDownloadController = BulkDataDownloadController;


/***/ },
/* 429 */
/***/ function(module, exports) {

	module.exports = "<div class=operational-bulkData-container layout=row layout-align=\"center top\"> <imomo-station-selector on-select-change=$ctrl.onSelectedStationsChange(selectedStations) is-with-meteostations=true> </imomo-station-selector> <md-card> <md-card-header> <md-card-header-text> <span class=md-title translate> BULK_DATA </span> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress></md-progress-linear> </md-card-header-text> </md-card-header> <md-card-content flex layout=column> <form name=$ctrl.bulkDataForm flex layout=column> <md-button class=\"md-raised md-primary\" type=submit ng-click=$ctrl.prepareBulkData() ng-disabled=\"$ctrl.bulkDataForm.$invalid || $ctrl.loadingInProgress\"> <span translate> PREPARE_BULK_DATA </span> </md-button> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.downloadBulkData() ng-disabled=\"!$ctrl.readyToDownload || $ctrl.loadingInProgress\"> <span translate> BULK_DATA_DOWNLOAD </span> </md-button> </form> </md-card-content> </md-card> </div>";

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forecast_options_component_1 = __webpack_require__(431);
	var forecast_bulletin_component_1 = __webpack_require__(435);
	var forecasting_process_component_1 = __webpack_require__(438);
	var forecasting_component_1 = __webpack_require__(442);
	var forecasting_table_component_1 = __webpack_require__(443);
	var forecasting_sites_component_1 = __webpack_require__(447);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.forecast', [])
	    .config(forecasting_component_1.configStates)
	    .component('imomoForecast', forecasting_component_1.default)
	    .component('imomoForecastProcess', forecasting_process_component_1.default)
	    .component('imomoForecastOptions', forecast_options_component_1.default)
	    .component('imomoForecastBulletin', forecast_bulletin_component_1.default)
	    .component('forecastingTable', forecasting_table_component_1.default)
	    .component('forecastingSites', forecasting_sites_component_1.default)
	    .name;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var template = __webpack_require__(432);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    template: template
	};


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=operational-options-container layout=row layout-align=\"start start\" layout-wrap> <md-card class=operational-options-card> <md-card-title> <md-card-title-text> <span class=md-headline translate> PROCESS </span> </md-card-title-text> <md-card-title-media> <div class=md-media-lg> <img class=options-image src=" + __webpack_require__(433) + "> </div> </md-card-title-media> </md-card-title> <md-card-actions layout=row layout-align=\"end stretch\"> <md-button ui-sref=forecast.process> <span translate>PROCESS</span> </md-button> </md-card-actions> </md-card> <md-card class=operational-options-card> <md-card-title> <md-card-title-text> <span class=md-headline translate> FORECAST_BULLETIN </span> </md-card-title-text> <md-card-title-media> <div class=md-media-lg> <img class=options-image src=" + __webpack_require__(434) + "> </div> </md-card-title-media> </md-card-title> <md-card-actions layout=row layout-align=\"end stretch\"> <md-button ui-sref=forecast.bulletin> <span translate>GENERATE_BULLETIN</span> </md-button> </md-card-actions> </md-card> </section>";

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/78483d1eef3ab81f65357b92246f5196.png";

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/10a98d16f7d319f5b96c6879b0f71ac6.png";

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forecast_bulletin_controller_1 = __webpack_require__(436);
	var template = __webpack_require__(437);
	var forecastBulletinComponent = {
	    controller: forecast_bulletin_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = forecastBulletinComponent;


/***/ },
/* 436 */
/***/ function(module, exports) {

	"use strict";
	var ForecastBulletinController = (function () {
	    function ForecastBulletinController(organizationApi, imomoErrorService, stationApi, $window) {
	        this.organizationApi = organizationApi;
	        this.imomoErrorService = imomoErrorService;
	        this.stationApi = stationApi;
	        this.$window = $window;
	        this.bulletinLoadingInProgress = false;
	        this.forecastBulletinSiteList = [];
	    }
	    ForecastBulletinController.prototype.onPrepareForecastBulletin = function () {
	        var _this = this;
	        this.bulletinLoadingInProgress = true;
	        var siteIdList = _.map(this.forecastBulletinSiteList, function (site) {
	            return site.id;
	        });
	        this.organizationApi
	            .generateForecastBulletin(Number.parseInt(this.$window.localStorage.getItem('currentOrgId')), siteIdList)
	            .then(function (data) {
	            _this.bulletinUrl = data;
	            _this.bulletinLoadingInProgress = false;
	        })
	            .catch(function (error) {
	            _this.bulletinLoadingInProgress = false;
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	        });
	    };
	    ForecastBulletinController.prototype.queryStations = function () {
	        var _this = this;
	        return this.stationApi.getDischargeStationsWithAcceptedForecast()
	            .then(function (data) {
	            return _this.filterStationsByText(_this.filterStationsBySelected(data));
	        });
	    };
	    ForecastBulletinController.prototype.onStationSelected = function (station) {
	        if (station) {
	            this.forecastBulletinSiteList.push(station);
	        }
	        this.forecastBulletinSiteListSearchText = null;
	    };
	    ForecastBulletinController.prototype.unselectStation = function (station) {
	        this.forecastBulletinSiteList.splice(this.forecastBulletinSiteList.indexOf(station), 1);
	    };
	    ForecastBulletinController.prototype.filterStationsBySelected = function (fetchedStations) {
	        var _this = this;
	        return _.filter(fetchedStations, function (station) {
	            var isItemSelected;
	            if (_this.forecastBulletinSiteList) {
	                _this.forecastBulletinSiteList.forEach(function (selectedStation) {
	                    if (!isItemSelected) {
	                        isItemSelected = station.id === selectedStation.id;
	                    }
	                });
	            }
	            return !isItemSelected;
	        });
	    };
	    ForecastBulletinController.prototype.filterStationsByText = function (stations) {
	        var _this = this;
	        if (this.forecastBulletinSiteListSearchText) {
	            return _.filter(stations, function (station) {
	                return station.siteName.toLowerCase().indexOf(_this.forecastBulletinSiteListSearchText.toLowerCase()) !== -1 ||
	                    station.siteCode.indexOf(_this.forecastBulletinSiteListSearchText) !== -1;
	            });
	        }
	        else {
	            return stations;
	        }
	    };
	    ForecastBulletinController.$inject = ['organizationApi', 'imomoErrorService', 'stationApi', '$window'];
	    return ForecastBulletinController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ForecastBulletinController;


/***/ },
/* 437 */
/***/ function(module, exports) {

	module.exports = "<div layout=row layout-align=\"center center\"> <md-card style=width:530px> <div layout-padding> <md-progress-linear ng-disabled=!$ctrl.bulletinLoadingInProgress> </md-progress-linear> <h2 translate>FORECAST_BULLETIN</h2> <h3 class=md-title translate>STATION_LIST</h3> <md-autocomplete id=stationSearch md-no-cache=true md-search-text=$ctrl.searchText md-items=\"station in $ctrl.queryStations($ctrl.searchText)\" md-selected-item-change=$ctrl.onStationSelected(station) md-selected-item=selectedStation md-item-text=station.siteName md-min-length=0 placeholder=\"{{'SEARCH_STATIONS_PLACEHOLDER' | translate}}\"> <md-item-template> <strong md-highlight-text=$ctrl.searchText md-highlight-flags=^i style=white-space:nowrap>{{station.siteCode}} - </strong> <span md-highlight-text=$ctrl.searchText md-highlight-flags=^i> {{station.siteName}}</span> </md-item-template> <md-not-found> <span translate>NO_STATIONS</span> </md-not-found> </md-autocomplete> <br> <div layout-padding> <md-content flex class=md-whiteframe-2dp layout=column layout-padding> <md-list> <md-list-item ng-repeat=\"station in $ctrl.forecastBulletinSiteList | orderBy: 'siteName'\"> <strong style=white-space:nowrap>{{station.siteCode}} - </strong><span> {{station.siteName}}</span> <span flex></span> <md-button class=md-icon-button ng-click=$ctrl.unselectStation(station)> <md-icon>clear</md-icon> </md-button> </md-list-item> </md-list> </md-content> </div> <div layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-primary\" type=submit ng-click=$ctrl.onPrepareForecastBulletin() ng-disabled=\"!$ctrl.forecastBulletinSiteList.length || $ctrl.bulletinLoadingInProgress\"> <span translate> PREPARE_BULLETIN </span> </md-button> <md-button class=\"md-raised md-accent\" ng-href={{$ctrl.bulletinUrl}} download=forecast-bulletin.xlsx ng-disabled=\"!$ctrl.bulletinUrl || $ctrl.bulletinLoadingInProgress\"> <span translate> DOWNLOAD_BULLETIN </span> </md-button> </div> </div> </md-card> </div>";

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forecasting_process_controller_1 = __webpack_require__(439);
	__webpack_require__(440);
	var template = __webpack_require__(441);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: forecasting_process_controller_1.default,
	    template: template
	};


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var ForecatingProcessController = (function () {
	    function ForecatingProcessController(stationApi, $q) {
	        this.stationApi = stationApi;
	        this.$q = $q;
	        this.loadingInProgress = false;
	        this.maxDate = new Date();
	        this.showPeriodOptions = false;
	    }
	    ForecatingProcessController.prototype.onSelectedStationChange = function (selectedStation) {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.selectedStation = selectedStation;
	        if (this.selectedStation) {
	            var forecastPromises = [
	                this.stationApi.getForecasts(this.selectedStation.id, 'pentadal'),
	                this.stationApi.getForecasts(this.selectedStation.id, 'decade'),
	                this.stationApi.getForecasts(this.selectedStation.id, 'monthly'),
	                this.stationApi.getForecasts(this.selectedStation.id, 'seasonal')
	            ];
	            this.$q.all(forecastPromises)
	                .then(function (_a) {
	                var pentadalForecasts = _a[0], decadalForecasts = _a[1], monthlyForecast = _a[2], seasonalForecast = _a[3];
	                var forecastsFormattedByFrequency = {
	                    pentadal: {
	                        label: "5-day",
	                        forecastData: pentadalForecasts,
	                        initialForecastData: angular.copy(pentadalForecasts),
	                        customPeriodDate: new Date()
	                    },
	                    decade: {
	                        label: "Decadal",
	                        forecastData: decadalForecasts,
	                        initialForecastData: angular.copy(decadalForecasts),
	                        customPeriodDate: new Date()
	                    },
	                    monthly: {
	                        label: "Monthly",
	                        forecastData: monthlyForecast,
	                        initialForecastData: angular.copy(monthlyForecast),
	                        customPeriodDate: new Date()
	                    },
	                    seasonal: {
	                        label: "Seasonal",
	                        forecastData: seasonalForecast,
	                        initialForecastData: angular.copy(seasonalForecast),
	                        customPeriodDate: new Date()
	                    },
	                };
	                _this.selectedStationForecasts = forecastsFormattedByFrequency;
	                _this.loadingInProgress = false;
	            });
	        }
	        else {
	            this.loadingInProgress = false;
	        }
	    };
	    ForecatingProcessController.prototype.onPreviousPeriodClick = function (frequency) {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.stationApi.getForecasts(this.selectedStation.id, frequency, this.selectedStationForecasts[frequency].forecastData[0].forecastingPeriodStart, true)
	            .then(function (prevForecastData) {
	            _this.selectedStationForecasts[frequency].forecastData = prevForecastData;
	            _this.loadingInProgress = false;
	        });
	    };
	    ForecatingProcessController.prototype.onChosenPeriodDateClick = function (frequency) {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.stationApi.getForecasts(this.selectedStation.id, frequency, new Date(moment(this.selectedStationForecasts[frequency].customPeriodDate).format("YYYY-MM-DD")), false)
	            .then(function (forecastData) {
	            _this.selectedStationForecasts[frequency].forecastData = forecastData;
	            _this.loadingInProgress = false;
	        });
	    };
	    ForecatingProcessController.prototype.onCurrentPeriodClick = function (frequency) {
	        this.selectedStationForecasts[frequency].forecastData =
	            angular.copy(this.selectedStationForecasts[frequency].initialForecastData);
	    };
	    ForecatingProcessController.prototype.isForecastDataPresent = function (forecastData) {
	        var hasForecastData = false;
	        if (forecastData && forecastData.length) {
	            forecastData.forEach(function (forecastDataItem) {
	                if (forecastDataItem.forecasts.length) {
	                    forecastDataItem.forecasts.forEach(function (forecast) {
	                        if (forecast.forecastResults.length) {
	                            hasForecastData = true;
	                        }
	                    });
	                }
	            });
	        }
	        return hasForecastData;
	    };
	    ForecatingProcessController.$inject = ['stationApi', '$q'];
	    return ForecatingProcessController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ForecatingProcessController;


/***/ },
/* 440 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 441 */
/***/ function(module, exports) {

	module.exports = "<div class=forecasting-container layout=row flex> <forecasting-sites on-selected-station-change=$ctrl.onSelectedStationChange(selectedStation)> </forecasting-sites> <md-card flex> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress></md-progress-linear> <md-tabs flex class=full-height-tabs md-selected=$ctrl.selectedTabIndex ng-show=\"$ctrl.selectedStation && \n             $ctrl.selectedStationForecasts\"> <md-tab ng-repeat=\"(key, forecastItem) in $ctrl.selectedStationForecasts\" md-on-select=$ctrl.onTabSelect()> <md-tab-label> {{ forecastItem.label }} </md-tab-label> <md-tab-body class=fill-tab> <md-content> <div layout=row layout-align=\"space-between center\"> <span layout-padding translate>SELECT_FORECASTING_PERIOD</span> <md-button class=md-icon-button ng-if=!$ctrl.showPeriodOptions ng-click=\"$ctrl.showPeriodOptions = true\"> <md-icon>expand_more</md-icon> </md-button> <md-button class=md-icon-button ng-if=$ctrl.showPeriodOptions ng-click=\"$ctrl.showPeriodOptions = false\"> <md-icon>expand_less</md-icon> </md-button> </div> <div ng-if=$ctrl.showPeriodOptions layout-padding> <div layout=row layout-align=\"space-between center\"> <md-button translate ng-click=$ctrl.onPreviousPeriodClick(key) class=\"md-primary md-raised\">PREVIOUS</md-button> <div> <md-datepicker ng-model=forecastItem.customPeriodDate md-max-date=$ctrl.maxDate></md-datepicker> <md-button translate ng-click=$ctrl.onChosenPeriodDateClick(key) class=\"md-primary md-raised\">APPLY</md-button> </div> <md-button ng-disabled=\"forecastItem.initialForecastData[0].forecastingPeriodStart === forecastItem.forecastData[0].forecastingPeriodStart\" translate ng-click=$ctrl.onCurrentPeriodClick(key) class=\"md-primary md-raised\">CURRENT</md-button> </div> </div> </md-content> <div ng-repeat=\"forecast in forecastItem.forecastData\"> <div layout-padding> <h4 translate>{{ forecast.forecastType.name }}</h4> <h5 translate>CURRENT_FORECASTING_PERIOD</h5> <span>{{forecast.forecastingPeriodStart}}</span> - <span>{{forecast.forecastingPeriodEnd}}</span> </div> <forecasting-table ng-if=\"\n                forecast.forecasts && \n                forecast.forecasts.length &&\n                forecast.forecasts[0] &&\n                forecast.forecasts[0].forecastResults && \n                forecast.forecasts[0].forecastResults.length\" forecasts=forecast.forecasts forecast-type=forecast.forecastType station=$ctrl.selectedStation> </forecasting-table> <div layout-padding layout-align=\"center center\" layout=row ng-if=\"!(\n                forecast.forecasts && \n                forecast.forecasts.length &&\n                forecast.forecasts[0] &&\n                forecast.forecasts[0].forecastResults && \n                forecast.forecasts[0].forecastResults.length\n                )\"> <span translate>NO_DATA</span> </div> </div> </md-tab-body> </md-tab> </md-tabs> </md-card> </div>";

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var auth_guard_1 = __webpack_require__(198);
	//import './forecasting.css';
	exports.configStates = function ($stateProvider) {
	    var stateData = {};
	    stateData[auth_guard_1.AuthGuard.REQUIRES_AUTH_KEY] = true;
	    $stateProvider.state('forecast', {
	        url: '/forecast',
	        abstract: true,
	        component: 'imomoForecast',
	        data: stateData
	    });
	    $stateProvider.state('forecast.options', {
	        parent: 'forecast',
	        url: '',
	        component: 'imomoForecastOptions'
	    });
	    $stateProvider.state('forecast.process', {
	        parent: 'forecast',
	        url: '/process',
	        component: 'imomoForecastProcess'
	    });
	    $stateProvider.state('forecast.bulletin', {
	        parent: 'forecast',
	        url: '/bulletin',
	        component: 'imomoForecastBulletin'
	    });
	};
	exports.configStates.$inject = ['$stateProvider'];
	var forecastComponent = {
	    template: '<ui-view class="inner-outlet"></ui-view>'
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = forecastComponent;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forecasting_table_controller_1 = __webpack_require__(444);
	__webpack_require__(445);
	var template = __webpack_require__(446);
	var frequencyTableComponent = {
	    bindings: {
	        'station': '<',
	        'forecasts': '<',
	        'forecastType': '<'
	    },
	    controller: forecasting_table_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = frequencyTableComponent;


/***/ },
/* 444 */
/***/ function(module, exports) {

	"use strict";
	var ForecastingTableController = (function () {
	    function ForecastingTableController(stationApi, organizationApi, $window, imomoErrorService, $mdDialog, $translate) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.organizationApi = organizationApi;
	        this.$window = $window;
	        this.imomoErrorService = imomoErrorService;
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.manualForecastValues = {
	            forecastTypeId: null,
	            forecastedValue: null,
	            previousValue: null,
	            trainingDataCount: null,
	            percentage: null,
	            relativeError: null,
	            standardDeviation: null,
	            maximum: null,
	            norm: null,
	            minimum: null
	        };
	        this.modelInvariantFields = ['previousValue', 'standardDeviation', 'maximum', 'norm', 'minimum'];
	        this.isWithAccepted = false;
	        this.isManualAccepted = false;
	        var currentOrgId = Number.parseInt(this.$window.localStorage.getItem('currentOrgId'));
	        this.manualForecastValues.forecastTypeId = this.forecastType.id;
	        // if (this.forecastType.frequency !== 'seasonal') {
	        this.forecasts.forEach(function (forecast) {
	            if (forecast.forecastResults && forecast.forecastResults[0] && forecast.forecastResults[0].accepted) {
	                _this.isWithAccepted = true;
	            }
	            var forecastResult = forecast.forecastResults[0];
	            if (forecastResult) {
	                _this.modelInvariantFields.forEach(function (field) {
	                    if (forecastResult[field] || forecastResult[field] === 0) {
	                        _this.manualForecastValues[field] = forecastResult[field];
	                    }
	                });
	            }
	        });
	        // } else {
	        //     this.forecasts.forEach((forecast) => {
	        //         if (forecast.forecastResults && forecast.forecastResults.length) {
	        //             forecast.forecastResults.forEach((forecastResult) => {
	        //                 if (forecastResult.accepted) {
	        //                     this.isWithAccepted = true;
	        //                 }
	        //             });
	        //         }
	        //     });
	        // }
	    }
	    ForecastingTableController.prototype.onAcceptClick = function (forecastResult) {
	        var _this = this;
	        var confirm = this.$mdDialog.confirm()
	            .title('')
	            .textContent(this.$translate.instant('NON_REVERTIBLE_ACTION'))
	            .ok(this.$translate.instant('OK'))
	            .cancel(this.$translate.instant('CANCEL'));
	        this.$mdDialog.show(confirm).then(function () {
	            _this.stationApi.acceptForecast(_this.station.id, forecastResult.id)
	                .then(function () {
	                forecastResult.accepted = true;
	                _this.isWithAccepted = true;
	            })
	                .catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	            });
	        });
	    };
	    ForecastingTableController.prototype.onManualAcceptClick = function () {
	        var _this = this;
	        this.stationApi.createManualForecast(this.station.id, this.manualForecastValues)
	            .then(function () {
	            _this.isWithAccepted = true;
	            _this.isManualAccepted = true;
	        })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	        });
	    };
	    ForecastingTableController.prototype.onTryRerunClick = function (stationId, forecast) {
	    };
	    ForecastingTableController.$inject = ['stationApi', 'organizationApi', '$window', 'imomoErrorService', '$mdDialog', '$translate'];
	    return ForecastingTableController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ForecastingTableController;


/***/ },
/* 445 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 446 */
/***/ function(module, exports) {

	module.exports = "<md-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column colspan=1> <span translate>FORECAST_NAME</span> </th> <th md-column colspan=2 class=forecast-first-level-th> <span translate>VALUES</span> </th> <th md-column colspan=3 class=forecast-first-level-th> <span translate>EVALUATION_STATISTICS</span> </th> <th md-column colspan=4 class=forecast-first-level-th> <span translate>DISCHARGE_CHARACTERISTICS</span> </th> <th></th> </tr> <tr md-row> <th md-column></th> <th md-column md-numeric> <span translate>FORECAST_VALUE</span> <md-tooltip md-direction=top><span translate>FORECAST_VALUE</span></md-tooltip> </th> <th md-column md-numeric> <span translate>PREVIOUS_VALUE</span> <md-tooltip md-direction=top><span translate>PREVIOUS_VALUE</span></md-tooltip> </th> <th md-column md-numeric> <span translate>NUMBER_OF_TRAINING_DATA</span> <md-tooltip md-direction=top><span translate>NUMBER_OF_TRAINING_DATA</span></md-tooltip> </th> <th md-column md-numeric> <span translate>PERCENTAGE</span> <md-tooltip md-direction=top><span translate>PERCENTAGE</span></md-tooltip> </th> <th md-column md-numeric> <span translate>RELATIVE_ERROR</span> <md-tooltip md-direction=top><span translate>RELATIVE_ERROR</span></md-tooltip> </th> <th md-column md-numeric> <span translate>STANDARD_DEVIATION</span> <md-tooltip md-direction=top><span translate>STANDARD_DEVIATION</span></md-tooltip> </th> <th md-column md-numeric> <span translate>MAXIMUM</span> <md-tooltip md-direction=top><span translate>MAXIMUM</span></md-tooltip> </th> <th md-column md-numeric> <span translate>NORM</span> <md-tooltip md-direction=top><span translate>NORM</span></md-tooltip> </th> <th md-column md-numeric> <span translate>MINIMUM</span> <md-tooltip md-direction=top><span translate>MINIMUM</span></md-tooltip> </th> <th md-column md-numeric></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"forecast in $ctrl.forecasts\" ng-class=\"{\n          'highlighted-row': forecast.forecastResults[0].accepted,\n          'row-value-best': (forecast.forecastResults[0].standardDeviation / forecast.forecastResults[0].relativeError) <= 0.6,\n          'row-value-good': (forecast.forecastResults[0].standardDeviation / forecast.forecastResults[0].relativeError) <= 0.8,\n          'row-value-bad': (forecast.forecastResults[0].standardDeviation / forecast.forecastResults[0].relativeError) > 0.8\n        }\" ng-hide=\"(forecast.forecastModel == null && !$ctrl.isWithAccepted) || (forecast.forecastModel == null && $ctrl.isManualAccepted)\"> <td md-cell> <strong ng-hide=\"forecast.forecastModel != null\" translate>MANUAL_INPUT</strong> <span ng-if=\"forecast.forecastModel != null\"> <span ng-if=forecast.forecastResults[0].errorMessage> <md-icon>error</md-icon> <md-tooltip md-direction=top>{{forecast.forecastResults[0].errorMessage}}</md-tooltip> </span> <span>{{ forecast.forecastModel.name }}<span> </span> </span></span></td> <td md-cell>{{ forecast.forecastResults[0].forecastedValue | hydroDischargeNumberFormatter}}</td> <td md-cell>{{ forecast.forecastResults[0].previousValue | hydroDischargeNumberFormatter}}</td> <td md-cell>{{ forecast.forecastResults[0].trainingDataCount | hydroNumberFormatter}}</td> <td md-cell>{{ forecast.forecastResults[0].percentage | hydroNumberFormatter}}</td> <td md-cell>{{ forecast.forecastResults[0].relativeError | hydroNumberFormatter}}</td> <td md-cell>{{ forecast.forecastResults[0].standardDeviation | hydroNumberFormatter}}</td> <td md-cell>{{ forecast.forecastResults[0].maximum | hydroNumberFormatter}}</td> <td md-cell>{{ forecast.forecastResults[0].norm | hydroNumberFormatter}}</td> <td md-cell>{{ forecast.forecastResults[0].minimum | hydroNumberFormatter}}</td> <td md-cell> <md-button ng-if=!$ctrl.isWithAccepted class=\"md-primary md-raised\" ng-click=$ctrl.onAcceptClick(forecast.forecastResults[0]) ng-disabled=forecast.forecastResults[0].errorMessage> <span translate>ACCEPT</span> </md-button> </td> </tr> <tr md-row class=forecast-manual-row ng-if=\"!$ctrl.isWithAccepted || $ctrl.isManualAccepted\" ng-class=\"{'highlighted-row': $ctrl.isManualAccepted}\"> <td md-cell><span translate>MANUAL_INPUT</span></td> <td md-cell> <md-input-container md-no-float> <input placeholder=--- ng-model=$ctrl.manualForecastValues.forecastedValue ng-disabled=$ctrl.isManualAccepted type=number> </md-input-container> </td> <td md-cell> {{ ($ctrl.manualForecastValues.previousValue | hydroDischargeNumberFormatter) || '---' }} </td> <td md-cell> <md-input-container md-no-float> <input placeholder=--- ng-model=$ctrl.manualForecastValues.trainingDataCount ng-disabled=$ctrl.isManualAccepted type=number> </md-input-container> </td> <td md-cell> <md-input-container md-no-float> <input placeholder=--- ng-model=$ctrl.manualForecastValues.percentage ng-disabled=$ctrl.isManualAccepted type=number> </md-input-container> </td> <td md-cell> <md-input-container md-no-float> <input placeholder=--- ng-model=$ctrl.manualForecastValues.relativeError ng-disabled=$ctrl.isManualAccepted type=number> </md-input-container> </td> <td md-cell> {{ ($ctrl.manualForecastValues.standardDeviation | hydroNumberFormatter) || '---' }} </td> <td md-cell> {{ ($ctrl.manualForecastValues.maximum | hydroNumberFormatter) || '---' }} </td> <td md-cell> {{ ($ctrl.manualForecastValues.norm | hydroNumberFormatter) || '---' }} </td> <td md-cell> {{ ($ctrl.manualForecastValues.minimum | hydroNumberFormatter) || '---' }} </td> <td md-cell> <md-button class=\"md-primary md-raised\" ng-click=$ctrl.onManualAcceptClick(forecast) ng-if=!$ctrl.isWithAccepted> <span translate>ACCEPT</span> </md-button> </td> </tr> </tbody> </table> </md-table-container>";

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forecasting_sites_controller_1 = __webpack_require__(448);
	var template = __webpack_require__(449);
	var forecastingSitesComponent = {
	    bindings: {
	        onSelectedStationChange: '&',
	    },
	    controller: forecasting_sites_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = forecastingSitesComponent;


/***/ },
/* 448 */
/***/ function(module, exports) {

	"use strict";
	var ForecastingTableController = (function () {
	    function ForecastingTableController(stationApi, $scope) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.$scope = $scope;
	        this.isOpen = false;
	        this.onStationsReady = function (stations) {
	            _this.stations = stations;
	            _this.selectedStation = _this.stations[0];
	            _this.notifyChanges(_this.selectedStation);
	        };
	        this.selectedStation;
	        this.stations = [];
	        this.stationsPromise = this.stationApi.getDischargeStationsWithForecast()
	            .then(this.onStationsReady);
	    }
	    ForecastingTableController.prototype.notifyChanges = function (station) {
	        if (this.onSelectedStationChange) {
	            this.onSelectedStationChange({
	                selectedStation: station
	            });
	        }
	    };
	    ForecastingTableController.prototype.onStationSelected = function (station) {
	        this.notifyChanges(this.selectedStation);
	    };
	    ForecastingTableController.$inject = ['stationApi', '$scope'];
	    return ForecastingTableController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ForecastingTableController;


/***/ },
/* 449 */
/***/ function(module, exports) {

	module.exports = "<md-content class=station-manager-container layout=row> <md-card flex> <md-toolbar class=md-table-toolbar ng-class=\"{'md-default': !$ctrl.isStationSelected, 'md-accent': $ctrl.isStationSelected}\"> <div class=md-toolbar-tools> <span ng-hide=$ctrl.isStationSelected translate>HYDROLOGICAL_STATIONS_WITH_FORECASTING</span> <span ng-show=$ctrl.isStationSelected> {{ $ctrl.selectedStation | stationFormatter }} </span> </div> </md-toolbar> <md-radio-group ng-model=$ctrl.selectedStation ng-if=$ctrl.stations.length ng-change=$ctrl.onStationSelected()> <md-list flex class=station-selector-list> <md-list-item ng-repeat=\"station in $ctrl.stations\" class=md-1-line> <md-radio-button ng-value=station aria-label=\"{{ station | stationFormatter }}\"> <div class=md-list-item-text> <h3>{{ station | stationFormatter }}</h3> <h4>{{ station.basin }}</h4> </div> </md-radio-button> </md-list-item> </md-list> </md-radio-group> <div ng-if=!$ctrl.stations.length layout-padding layout=column layout-align=\"center center\" flex> <span translate>NO_STATIONS_WITH_FORECAST</span> </div> </md-card> </md-content>";

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var snackbar_component_1 = __webpack_require__(451);
	var snackbar_service_1 = __webpack_require__(455);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.snackbar', [])
	    .component('imomoSnackbar', snackbar_component_1.default)
	    .service('snackbarService', snackbar_service_1.default)
	    .name;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var snackbar_controller_1 = __webpack_require__(452);
	__webpack_require__(453);
	var template = __webpack_require__(454);
	var snackbarComponent = {
	    controller: snackbar_controller_1.default,
	    template: template,
	    transclude: {
	        action: '?snackbarActionText',
	        content: '?snackbarContent',
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = snackbarComponent;


/***/ },
/* 452 */
/***/ function(module, exports) {

	"use strict";
	var SnackbarController = (function () {
	    function SnackbarController($transclude) {
	        this.enabledAction = $transclude.isSlotFilled('action');
	    }
	    SnackbarController.$inject = ['$transclude'];
	    return SnackbarController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = SnackbarController;


/***/ },
/* 453 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 454 */
/***/ function(module, exports) {

	module.exports = "<div class=\"snackbar-text md-body-1\" ng-transclude=content> </div> <div class=snackbar-action ng-if=$ctrl.enabledAction> <md-button class=md-accent> <span ng-transclude=action></span> </md-button> </div>";

/***/ },
/* 455 */
/***/ function(module, exports) {

	"use strict";
	var SnackbarService = (function () {
	    function SnackbarService($document, $compile, $timeout, $rootScope, $q, $log) {
	        this.$document = $document;
	        this.$compile = $compile;
	        this.$timeout = $timeout;
	        this.$rootScope = $rootScope;
	        this.$q = $q;
	        this.$log = $log;
	    }
	    SnackbarService.prototype.show = function (options) {
	        var _this = this;
	        if (this.snackbar) {
	            return this.hide().then(function () {
	                return _this.show(options);
	            });
	        }
	        else {
	            var deferred_1 = this.$q.defer();
	            var document_1 = this.$document[0];
	            this.snackbar = this.buildSnackbar(options);
	            this.snackbar.classList.add('enter', 'animation-start');
	            this.snackbar.addEventListener('transitionend', function () {
	                _this.$log.debug('Snackbar is visible.');
	                deferred_1.resolve();
	            });
	            document_1.body.appendChild(this.snackbar);
	            this.$timeout(function () {
	                _this.snackbar.classList.remove('animation-start');
	                _this.snackbar.classList.add('animation-end');
	            }, 0);
	            this.$timeout(function () {
	                _this.hide();
	            }, options.delay || 2000);
	            return deferred_1.promise;
	        }
	    };
	    SnackbarService.prototype.hide = function () {
	        var _this = this;
	        var deferred = this.$q.defer();
	        if (this.snackbar) {
	            this.snackbar.classList.remove('enter', 'animation-end');
	            this.snackbar.classList.add('animation-start', 'exit');
	            this.$timeout(function () {
	                _this.snackbar.classList.remove('animation-start');
	                _this.snackbar.classList.add('animation-end');
	            }, 0);
	            this.snackbar.addEventListener('transitionend', function () {
	                _this.$log.debug('Snackbar is hidden.');
	                deferred.resolve();
	                _this.snackbar = null;
	            });
	        }
	        else {
	            deferred.resolve();
	        }
	        return deferred.promise;
	    };
	    SnackbarService.prototype.buildSnackbar = function (options) {
	        var document = this.$document[0];
	        var snackbar = document.createElement('imomo-snackbar');
	        var snackbarContent = document.createElement('snackbar-content');
	        snackbarContent.textContent = options.content;
	        snackbar.appendChild(snackbarContent);
	        if (options.actionText) {
	            var snackbarActionText = document.createElement('snackbar-action-text');
	            snackbarActionText.textContent = options.actionText;
	            snackbar.appendChild(snackbarActionText);
	        }
	        var scope = this.$rootScope.$new(true);
	        var compiledSnackbar = this.$compile(snackbar)(scope);
	        document.body.appendChild(compiledSnackbar[0]);
	        return compiledSnackbar[0];
	    };
	    SnackbarService.$inject = ['$document', '$compile', '$timeout', '$rootScope', '$q',
	        '$log'];
	    return SnackbarService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = SnackbarService;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var creator_module_1 = __webpack_require__(457);
	var manager_component_1 = __webpack_require__(470);
	var station_component_1 = __webpack_require__(473);
	var selector_component_1 = __webpack_require__(477);
	var historic_norm_component_1 = __webpack_require__(481);
	var curve_component_1 = __webpack_require__(484);
	var details_component_1 = __webpack_require__(487);
	var edit_component_1 = __webpack_require__(490);
	var station_formatter_1 = __webpack_require__(494);
	var unique_station_code_directive_1 = __webpack_require__(495);
	var station_component_2 = __webpack_require__(473);
	var selector_service_1 = __webpack_require__(496);
	var timeseries_component_1 = __webpack_require__(497);
	var timeseries_service_1 = __webpack_require__(500);
	var aggregationEdit_component_1 = __webpack_require__(501);
	var forecast_model_component_1 = __webpack_require__(504);
	var forecast_model_service_1 = __webpack_require__(510);
	var snow_data_component_1 = __webpack_require__(511);
	var station_map_service_1 = __webpack_require__(492);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.station', [creator_module_1.default.name])
	    .component('imomoStation', station_component_1.default)
	    .component('imomoStationManager', manager_component_1.default)
	    .component('imomoStationSelector', selector_component_1.default)
	    .component('imomoStationHistoricNorm', historic_norm_component_1.default)
	    .component('imomoStationCurve', curve_component_1.default)
	    .component('imomoStationDetails', details_component_1.default)
	    .component('imomoStationDetailsEdit', edit_component_1.default)
	    .component('imomoStationAggregationsEdit', aggregationEdit_component_1.default)
	    .component('imomoStationSnowData', snow_data_component_1.default)
	    .component('imomoStationTimeseries', timeseries_component_1.default)
	    .component('imomoStationForecastModel', forecast_model_component_1.default)
	    .config(station_component_2.configStates)
	    .filter('stationFormatter', station_formatter_1.default)
	    .directive('uniqueDischargeStationCode', unique_station_code_directive_1.uniqueStationCodeFactory)
	    .service('stationSelectorService', selector_service_1.default)
	    .service('forecastingService', forecast_model_service_1.default)
	    .service('stationMapService', station_map_service_1.default)
	    .service('timeseriesService', timeseries_service_1.default)
	    .name;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var creator_component_1 = __webpack_require__(458);
	var curve_component_1 = __webpack_require__(461);
	var data_component_1 = __webpack_require__(464);
	var snow_data_component_1 = __webpack_require__(467);
	var imomoStationCreatorModule = angular.module('imomo.station.creator', [])
	    .component('imomoStationCreator', creator_component_1.default)
	    .component('imomoStationCreatorCurve', curve_component_1.default)
	    .component('imomoStationCreatorData', data_component_1.default)
	    .component('imomoStationCreatorSnowData', snow_data_component_1.default);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = imomoStationCreatorModule;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var creator_controller_1 = __webpack_require__(459);
	var template = __webpack_require__(460);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: creator_controller_1.default,
	    template: template
	};


/***/ },
/* 459 */
/***/ function(module, exports) {

	"use strict";
	var StationCreatorController = (function () {
	    function StationCreatorController($state, stationApi, imomoErrorService, Upload, $mdDialog, $translate) {
	        this.$state = $state;
	        this.stationApi = stationApi;
	        this.imomoErrorService = imomoErrorService;
	        this.Upload = Upload;
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	    }
	    StationCreatorController.prototype.$onInit = function () {
	        this.isStepOneValid = false;
	        this.isStepTwoValid = false;
	        this.isStepThreeValid = false;
	        this.isStepFourValid = false;
	        this.isVirtual = this.$state.current.name === 'station.creatorVirtual';
	    };
	    Object.defineProperty(StationCreatorController.prototype, "isStepTwoDisabled", {
	        get: function () {
	            return !this.isStepOneValid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isStepThreeDisabled", {
	        get: function () {
	            return !this.isStepOneValid || !this.isStepTwoValid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isStepFourDisabled", {
	        get: function () {
	            return !this.isStepOneValid || !this.isStepTwoValid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isStepFiveDisabled", {
	        get: function () {
	            return !this.isStepOneValid || !this.isStepTwoValid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isNextButtonDisabled", {
	        get: function () {
	            switch (this.selectedTabIndex) {
	                case 0:
	                    return this.isStepTwoDisabled;
	                case 1:
	                    return this.isStepThreeDisabled;
	                case 2:
	                    return this.isStepFourDisabled;
	                case 3:
	                    return this.isStepFiveDisabled;
	                default:
	                    return true;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isPrevButtonDisabled", {
	        get: function () {
	            switch (this.selectedTabIndex) {
	                case 0:
	                    return true;
	                default:
	                    return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isSubmitButtonDisabled", {
	        get: function () {
	            if (this.isVirtual) {
	                return !this.isStepOneValid
	                    || !this.isStepTwoValid
	                    || this.isLoading;
	            }
	            else {
	                return !this.isStepOneValid
	                    || !this.isStepTwoValid
	                    || this.isLoading;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isLastStep", {
	        get: function () {
	            if (this.isVirtual) {
	                return this.selectedTabIndex == 1;
	            }
	            else {
	                return this.selectedTabIndex == 3;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationCreatorController.prototype.onDischargeModelChange = function (dischargeModel, isValid) {
	        this.dischargeModel = dischargeModel;
	        this.isStepTwoValid = isValid;
	    };
	    StationCreatorController.prototype.onStationDetailsChange = function (station, isValid) {
	        this.isStepOneValid = isValid;
	        this.stationDetails = station;
	    };
	    StationCreatorController.prototype.onHistoricalDataChange = function (dataFile, isValid) {
	        this.isStepThreeValid = isValid;
	        this.historicalDataFile = dataFile;
	    };
	    StationCreatorController.prototype.onSnowDataChange = function (dataFile, isValid) {
	        this.isStepFourValid = isValid;
	        this.snowDataFile = dataFile;
	    };
	    StationCreatorController.prototype.onStationAggregationsChange = function (selectedStations, isValid) {
	        this.isStepTwoValid = isValid;
	        this.stationDetails.aggregations = selectedStations;
	    };
	    StationCreatorController.prototype.nextStep = function () {
	        this.selectedTabIndex += 1;
	    };
	    StationCreatorController.prototype.prevStep = function () {
	        this.selectedTabIndex -= 1;
	    };
	    StationCreatorController.prototype.createStation = function () {
	        var _this = this;
	        this.isLoading = true;
	        var stationRequest = {
	            siteName: this.stationDetails.name,
	            siteCode: this.stationDetails.code,
	            country: this.stationDetails.country,
	            basin: this.stationDetails.basin,
	            region: this.stationDetails.region,
	            latitude: this.stationDetails.location.latitude,
	            longitude: this.stationDetails.location.longitude,
	            aggregations: this.stationDetails.aggregations,
	            isVirtual: this.isVirtual
	        };
	        this.stationApi.createDischargeStation(stationRequest, this.dischargeModel, this.historicalDataFile, this.stationDetails.maxDischarge)
	            .then(function (station) {
	            var confirm = _this.$mdDialog.confirm()
	                .title(_this.$translate.instant('FORECAST_MODEL_SETUP'))
	                .textContent(_this.$translate.instant('FORECAST_MODEL_SETUP_EXTENDED'))
	                .ok(_this.$translate.instant('OK'))
	                .cancel(_this.$translate.instant('CANCEL'));
	            if (!station.isVirtual && _this.snowDataFile) {
	                _this.Upload.base64DataUrl(_this.snowDataFile)
	                    .then(function (jsonstring) {
	                    _this.stationApi.uploadSnowData(station.id, jsonstring)
	                        .then(function () {
	                        _this.$mdDialog.show(confirm).then(function () {
	                            _this.$state.go('station.forecastModels', { stationId: station.id });
	                        }, function () {
	                            _this.$state.go('station.manager');
	                        });
	                    })
	                        .catch(function (error) {
	                        _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                    })
	                        .finally(function () {
	                        _this.isLoading = false;
	                    });
	                });
	            }
	            else {
	                _this.$mdDialog.show(confirm).then(function () {
	                    _this.$state.go('station.forecastModels', { stationId: station.id });
	                }, function () {
	                    _this.$state.go('station.manager');
	                });
	            }
	        })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	        })
	            .finally(function () {
	            _this.isLoading = false;
	        });
	    };
	    StationCreatorController.$inject = ['$state', 'stationApi', 'imomoErrorService', 'Upload', '$mdDialog', '$translate'];
	    return StationCreatorController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationCreatorController;


/***/ },
/* 460 */
/***/ function(module, exports) {

	module.exports = "<div class=station-creator-container layout=column> <md-progress-linear md-mode=indeterminate ng-show=$ctrl.isLoading> </md-progress-linear> <md-tabs class=full-height-tabs md-selected=$ctrl.selectedTabIndex md-border-bottom flex> <md-tab md-on-select=$ctrl.onTabSelect()> <md-tab-label> <span translate>STEP_1_DETAILS</span> </md-tab-label> <md-tab-body> <imomo-station-details-edit class=fill-tab layout=row on-change=\"$ctrl.onStationDetailsChange(station, isValid)\" station-details=$ctrl.stationDetails> </imomo-station-details-edit> </md-tab-body> </md-tab> <md-tab md-on-select=$ctrl.onTabSelect() ng-disabled=$ctrl.isStepTwoDisabled ng-if=!$ctrl.isVirtual> <md-tab-label> <span translate>STEP_2_DISCHARGE_CURVE</span> </md-tab-label> <md-tab-body> <imomo-station-creator-curve class=fill-tab layout=row on-change=\"$ctrl.onDischargeModelChange(dischargeModel, isValid)\"> </imomo-station-creator-curve> </md-tab-body> </md-tab> <md-tab md-on-select=$ctrl.onTabSelect() ng-disabled=$ctrl.isStepThreeDisabled ng-if=!$ctrl.isVirtual> <md-tab-label> <span translate>STEP_3_HISTORICAL_DISCHARGE_DATA</span> </md-tab-label> <md-tab-body> <imomo-station-creator-data class=fill-tab layout=row on-change=\"$ctrl.onHistoricalDataChange(dataFile, isValid)\"> </imomo-station-creator-data> </md-tab-body> </md-tab> <md-tab ng-if=!$ctrl.isVirtual md-on-select=$ctrl.onTabSelect() ng-disabled=\"$ctrl.isStepFourDisabled || false\"> <md-tab-label> <span translate>STEP_4_SNOW_DATA</span> </md-tab-label> <md-tab-body> <imomo-station-creator-snow-data class=fill-tab layout=row is-new-site=true on-change=\"$ctrl.onSnowDataChange(dataFile, isValid)\"> </imomo-station-creator-snow-data> </md-tab-body> </md-tab> <md-tab md-on-select=$ctrl.onTabSelect() ng-disabled=$ctrl.isStepTwoDisabled ng-if=$ctrl.isVirtual> <md-tab-label> <span translate>STEP_2_AGGREGATIONS</span> </md-tab-label> <md-tab-body> <imomo-station-aggregations-edit class=fill-tab layout=row on-change=\"$ctrl.onStationAggregationsChange(selectedStations, isValid)\"> </imomo-station-aggregations-edit> </md-tab-body> </md-tab> </md-tabs> <section layout=row flex=none> <md-button ng-disabled=$ctrl.isPrevButtonDisabled ng-click=$ctrl.prevStep()> <span translate>PREVIOUS</span> </md-button> <span flex></span> <md-button ng-disabled=$ctrl.isNextButtonDisabled ng-click=$ctrl.nextStep() ng-hide=$ctrl.isLastStep> <span translate>NEXT</span> </md-button> <md-button class=md-primary ng-show=$ctrl.isLastStep ng-disabled=$ctrl.isSubmitButtonDisabled ng-click=$ctrl.createStation()> <span translate>CREATE</span> </md-button> </section> </div>";

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var curve_controller_1 = __webpack_require__(462);
	var template = __webpack_require__(463);
	var bindings = {
	    onChange: '&'
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    bindings: bindings,
	    controller: curve_controller_1.default,
	    template: template
	};


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var curve_hq_table_controller_1 = __webpack_require__(233);
	var chart_color_service_1 = __webpack_require__(356);
	var hqTableTemplate = __webpack_require__(234);
	var StationCreatorCurveController = (function () {
	    function StationCreatorCurveController($scope, $mdDialog, dischargeCurveFittingService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$mdDialog = $mdDialog;
	        this.dischargeCurveFittingService = dischargeCurveFittingService;
	        this.showHQTable = function ($event) {
	            _this.$mdDialog.show({
	                targetEvent: $event,
	                controller: curve_hq_table_controller_1.StationCreatorHQTableController,
	                controllerAs: '$ctrl',
	                bindToController: true,
	                locals: {
	                    dischargeModel: _this.mutableDischargeModel,
	                    minWaterLevel: _this.minWaterLevel,
	                    maxWaterLevel: _this.maxWaterLevel
	                },
	                template: hqTableTemplate
	            });
	        };
	        this.dischargeData = immutable_1.List();
	        this.newDischargePoint = {
	            discharge: null,
	            waterLevel: null
	        };
	        this.dischargeModelItems = immutable_1.List();
	    }
	    Object.defineProperty(StationCreatorCurveController.prototype, "mutableDischargeModel", {
	        get: function () {
	            return this.dischargeModelItems.size > 0
	                ? this.dischargeModelItems.first().dischargeModel
	                : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationCreatorCurveController.prototype.addDischargePoint = function () {
	        this.dischargeData = this.dischargeData.push(this.newDischargePoint);
	        this.dischargeDataArray = this.dischargeData.toArray();
	        this.newDischargePoint = {
	            discharge: null,
	            waterLevel: null
	        };
	        this.$scope.waterLevelForm.$setPristine();
	        this.$scope.dischargeForm.$setPristine();
	        this.$scope.waterLevelForm.$setUntouched();
	        this.$scope.dischargeForm.$setUntouched();
	        if (this.dischargeData.size > 1) {
	            this.fitNewModel();
	        }
	        this.notifyChange();
	    };
	    StationCreatorCurveController.prototype.deleteDischargePoint = function (index) {
	        this.dischargeData = this.dischargeData.remove(index);
	        this.dischargeDataArray = this.dischargeData.toArray();
	        this.dischargeModelItems = this.dischargeModelItems.clear();
	        if (this.dischargeData.size > 1) {
	            this.fitNewModel();
	        }
	        this.notifyChange();
	    };
	    StationCreatorCurveController.prototype.onChartBoundsChanged = function (curveSettings, userChange) {
	        this.minWaterLevel = curveSettings.minWaterLevel;
	        this.maxWaterLevel = curveSettings.maxWaterLevel;
	    };
	    ;
	    StationCreatorCurveController.prototype.onModelNameChange = function () {
	        if (this.mutableDischargeModel) {
	            this.mutableDischargeModel.modelName = this.modelName;
	            this.notifyChange();
	        }
	    };
	    StationCreatorCurveController.prototype.fitNewModel = function () {
	        this.dischargeModelItems = immutable_1.List.of({
	            dischargeModel: StationCreatorCurveController.toDischargeModel(this.dischargeCurveFittingService
	                .fitCurveQuadraticMethod(this.dischargeDataArray)),
	            colors: chart_color_service_1.IChartColorService.BLACK_COLORS,
	            enabled: true
	        });
	        this.mutableDischargeModel.modelName = this.modelName;
	    };
	    StationCreatorCurveController.prototype.notifyChange = function () {
	        var isValidModel = this.mutableDischargeModel &&
	            this.mutableDischargeModel.modelName != null;
	        this.onChange({
	            dischargeModel: this.mutableDischargeModel,
	            isValid: isValidModel
	        });
	    };
	    StationCreatorCurveController.toDischargeModel = function (fitModel) {
	        return {
	            id: 0,
	            modelName: '',
	            paramA: fitModel.paramA,
	            paramB: fitModel.paramB,
	            paramC: fitModel.paramC,
	            paramDeltaLevel: fitModel.paramDeltaLevel,
	            validFrom: null
	        };
	    };
	    StationCreatorCurveController.$inject = ['$scope', '$mdDialog', 'dischargeCurveFittingService'];
	    return StationCreatorCurveController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationCreatorCurveController;


/***/ },
/* 463 */
/***/ function(module, exports) {

	module.exports = "<div flex layout=row> <imomo-discharge-curve layout=row flex discharge-models=$ctrl.dischargeModelItems discharge-data=$ctrl.dischargeData on-bounds-change=\"$ctrl.onChartBoundsChanged(curveSettings, userChange)\"> </imomo-discharge-curve> <section layout=column flex> <md-card flex layout=column> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span translate>DISCHARGE_POINTS</span> </div> </md-toolbar> <md-table-container flex> <table md-table> <thead md-head> <tr md-row> <th md-column> <span translate>WATER_LEVEL_CM</span> </th> <th md-column> <span translate>DISCHARGE_M3_S</span> </th> <th md-column></th> </tr> </thead> <tbody md-body> <tr md-row> <td md-cell> <form name=waterLevelForm> <md-input-container md-no-float> <input type=number step=1 placeholder=100 required ng-model=$ctrl.newDischargePoint.waterLevel> </md-input-container> </form> </td> <td md-cell> <form name=dischargeForm> <md-input-container md-no-float> <input type=number min=0 step=0.1 placeholder=50 required ng-model=$ctrl.newDischargePoint.discharge> </md-input-container> </form> </td> <td md-cell> <md-button class=\"md-raised md-primary md-icon-button\" ng-click=$ctrl.addDischargePoint() ng-disabled=\"waterLevelForm.$invalid || dischargeForm.$invalid\"> <md-icon class=material-icons>add</md-icon> </md-button> </td> </tr><tr md-row ng-repeat=\"dischargePoint in $ctrl.dischargeDataArray\"> <td md-cell> {{ dischargePoint.waterLevel | number}} </td> <td md-cell> {{ dischargePoint.discharge | number }} </td> <td md-cell> <md-button class=\"md-warn md-icon-button\" ng-click=$ctrl.deleteDischargePoint($index)> <md-icon class=material-icons>delete</md-icon> </md-button> </td> </tr>  </tbody> </table> </md-table-container> </md-card> <md-card layout-padding> <form name=modelForm> <h4 class=md-title translate>DISCHARGE_MODEL</h4> <section layout=row> <md-input-container> <label translate>IDENTIFIER</label> <input required ng-model=$ctrl.modelName name=modelName ng-change=$ctrl.onModelNameChange() ng-maxlength=255> <div class=hint translate ng-hide=\"modelForm.modelName.$touched && modelForm.modelName.$invalid\"> EG_INITIAL_STATION_MODEL </div> <div ng-messages=modelForm.modelName.$error md-auto-hide=false ng-show=modelForm.modelName.$touched> <div ng-message=required translate> AN_IDENTIFIER_IS_REQUIRED </div> <div ng-message=maxlength translate> IDENTIFIER_IS_TOO_LONG </div> </div> </md-input-container> <span flex></span> <md-button ng-disabled=!$ctrl.mutableDischargeModel ng-click=$ctrl.showHQTable($event)> <span translate>SHOW_H_Q_TABLE</span> </md-button> </section> </form> </md-card> </section> </div>";

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var data_controller_1 = __webpack_require__(465);
	var template = __webpack_require__(466);
	var bindings = {
	    onChange: '&'
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    bindings: bindings,
	    controller: data_controller_1.default,
	    template: template
	};


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var extensions_1 = __webpack_require__(327);
	var IDataFileState;
	(function (IDataFileState) {
	    IDataFileState[IDataFileState["Unselected"] = 0] = "Unselected";
	    IDataFileState[IDataFileState["Selected"] = 1] = "Selected";
	    IDataFileState[IDataFileState["Validating"] = 2] = "Validating";
	    IDataFileState[IDataFileState["Invalid"] = 3] = "Invalid";
	    IDataFileState[IDataFileState["Valid"] = 4] = "Valid";
	})(IDataFileState || (IDataFileState = {}));
	var StationCreatorDataController = (function () {
	    function StationCreatorDataController(s3UploadService, stationApi, imomoErrorService) {
	        var _this = this;
	        this.s3UploadService = s3UploadService;
	        this.stationApi = stationApi;
	        this.imomoErrorService = imomoErrorService;
	        this.onDataFileChange = function (files) {
	            if (files && files[0]) {
	                _this.dataFile = files[0];
	                _this.dataFileState = IDataFileState.Selected;
	            }
	            else {
	                _this.dataFileState = IDataFileState.Unselected;
	                _this.dataFile = null;
	            }
	            _this.notifyChange(false);
	        };
	        this.dataFileState = IDataFileState.Unselected;
	    }
	    Object.defineProperty(StationCreatorDataController.prototype, "isUnselected", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Unselected;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "isValidating", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Validating;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "isInvalid", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Invalid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "isValidated", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Valid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "excelMimeTypes", {
	        get: function () {
	            return extensions_1.EXCEL_MIME_TYPES;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "dataFileStateIcon", {
	        get: function () {
	            switch (this.dataFileState) {
	                case IDataFileState.Selected:
	                    return {
	                        name: 'indeterminate_check_box',
	                        cssClass: ''
	                    };
	                case IDataFileState.Validating:
	                    return {
	                        name: 'cached',
	                        cssClass: ''
	                    };
	                case IDataFileState.Valid:
	                    return {
	                        name: 'check_circle',
	                        cssClass: 'md-accent'
	                    };
	                case IDataFileState.Invalid:
	                    return {
	                        name: 'error_outline',
	                        cssClass: 'md-warn'
	                    };
	                default:
	                    return {
	                        name: '',
	                        cssClass: ''
	                    };
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationCreatorDataController.prototype.validate = function () {
	        var _this = this;
	        this.dataFileState = IDataFileState.Validating;
	        return this.stationApi.validateDischargeData(this.dataFile)
	            .then(function () {
	            _this.dataFileState = IDataFileState.Valid;
	            _this.notifyChange(true);
	        })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	            _this.dataFileState = IDataFileState.Invalid;
	            _this.notifyChange(false);
	        });
	    };
	    ;
	    StationCreatorDataController.prototype.notifyChange = function (valid) {
	        if (this.onChange) {
	            this.onChange({
	                dataFile: this.dataFile,
	                isValid: valid
	            });
	        }
	    };
	    StationCreatorDataController.$inject = ['s3UploadService', 'stationApi', 'imomoErrorService'];
	    return StationCreatorDataController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationCreatorDataController;


/***/ },
/* 466 */
/***/ function(module, exports) {

	module.exports = "<md-card layout=column layout-padding flex> <h2 class=md-headline translate>HISTORICAL_DISCHARGE_DATA_UPLOAD</h2> <p class=md-subhead> <span translate>PLEASE_UPLOAD_HISTORICAL</span><br> <span translate>DATA_AVAILABLE_FOR_DOWNLOAD</span><br/> <span translate>DATA_MUST_BE_EXCEL</span> </p> <section> <h3 ng-show=$ctrl.isUnselected translate> NO_FILE_SELECTED</h3> <h3 ng-hide=$ctrl.isUnselected> {{ $ctrl.dataFile.name }} <md-icon ng-show=$ctrl.isSelected ng-class=$ctrl.dataFileStateIcon.cssClass class=material-icons>{{ $ctrl.dataFileStateIcon.name }} </md-icon> </h3> </section> <form name=fileForm layout=row layout-align=\"start center\" ng-hide=$ctrl.isValidating> <md-button href=https://s3.eu-central-1.amazonaws.com/imomo-uploads/discharge_template.xlsx download=dischargetemplate.xlsx> <span translate>DOWNLOAD_EXAMPLE_FILE</span> </md-button> <md-button ngf-select ngf-multiple=false class=md-raised ng-model=$ctrl.dataFile ngf-change=$ctrl.onDataFileChange($files) ngf-pattern=$ctrl.excelMimeTypes ngf-accept=$ctrl.excelMimeTypes required ng-class=\"{'md-accent': $ctrl.isUnselected, 'md-warn': !$ctrl.isUnselected}\"> <span ng-show=$ctrl.isUnselected translate> SELECT_FILE </span> <span ng-hide=$ctrl.isUnselected translate> CHANGE </span> </md-button> <md-button class=\"md-raised md-primary self-align-end\" ng-disabled=\"fileForm.$invalid || $ctrl.isInvalid || $ctrl.isValidated\" ng-click=$ctrl.validate()> <span ng-hide=$ctrl.isValidated translate> VALIDATE </span> <span ng-show=$ctrl.isValidated translate> VALIDATED </span> </md-button> </form> <div> <md-progress-linear ng-show=$ctrl.isValidating></md-progress-linear> </div> </md-card>";

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var snow_data_controller_1 = __webpack_require__(468);
	var template = __webpack_require__(469);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: snow_data_controller_1.default,
	    bindings: {
	        onChange: '&'
	    },
	    template: template
	};


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var extensions_1 = __webpack_require__(327);
	var IDataFileState;
	(function (IDataFileState) {
	    IDataFileState[IDataFileState["Unselected"] = 0] = "Unselected";
	    IDataFileState[IDataFileState["Selected"] = 1] = "Selected";
	    IDataFileState[IDataFileState["Validating"] = 2] = "Validating";
	    IDataFileState[IDataFileState["Invalid"] = 3] = "Invalid";
	    IDataFileState[IDataFileState["Valid"] = 4] = "Valid";
	})(IDataFileState || (IDataFileState = {}));
	var SnowDataController = (function () {
	    function SnowDataController(s3UploadService, stationApi, imomoErrorService) {
	        var _this = this;
	        this.s3UploadService = s3UploadService;
	        this.stationApi = stationApi;
	        this.imomoErrorService = imomoErrorService;
	        this.onDataFileChange = function (files) {
	            if (files && files[0]) {
	                _this.dataFile = files[0];
	                _this.dataFileState = IDataFileState.Selected;
	            }
	            else {
	                _this.dataFileState = IDataFileState.Unselected;
	                _this.dataFile = null;
	            }
	            _this.notifyChange(true);
	        };
	        this.dataFileState = IDataFileState.Unselected;
	    }
	    Object.defineProperty(SnowDataController.prototype, "isUnselected", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Unselected;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "isValidating", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Validating;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "isInvalid", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Invalid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "isValidated", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Valid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "jsonMimeTypes", {
	        get: function () {
	            return extensions_1.JSON_MIME_TYPE;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "dataFileStateIcon", {
	        get: function () {
	            switch (this.dataFileState) {
	                case IDataFileState.Selected:
	                    return {
	                        name: 'indeterminate_check_box',
	                        cssClass: ''
	                    };
	                case IDataFileState.Validating:
	                    return {
	                        name: 'cached',
	                        cssClass: ''
	                    };
	                case IDataFileState.Valid:
	                    return {
	                        name: 'check_circle',
	                        cssClass: 'md-accent'
	                    };
	                case IDataFileState.Invalid:
	                    return {
	                        name: 'error_outline',
	                        cssClass: 'md-warn'
	                    };
	                default:
	                    return {
	                        name: '',
	                        cssClass: ''
	                    };
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SnowDataController.prototype.notifyChange = function (valid) {
	        if (this.onChange) {
	            this.onChange({
	                dataFile: this.dataFile,
	                isValid: valid
	            });
	        }
	    };
	    SnowDataController.$inject = ['s3UploadService', 'stationApi', 'imomoErrorService'];
	    return SnowDataController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = SnowDataController;


/***/ },
/* 469 */
/***/ function(module, exports) {

	module.exports = "<md-card layout=column layout-padding flex> <h2 class=md-headline translate>CATCHMENT_AREA_FILE_UPLOAD</h2> <section> <h3 ng-show=$ctrl.isUnselected translate> NO_FILE_SELECTED</h3> <h3 ng-hide=$ctrl.isUnselected> {{ $ctrl.dataFile.name }} <md-icon ng-show=$ctrl.isSelected ng-class=$ctrl.dataFileStateIcon.cssClass class=material-icons>{{ $ctrl.dataFileStateIcon.name }} </md-icon> </h3> </section> <form name=fileForm layout=row layout-align=\"start center\"> <md-button ngf-select ngf-multiple=false class=md-raised ng-model=$ctrl.dataFile ngf-change=$ctrl.onDataFileChange($files) ngf-pattern=$ctrl.jsonMimeTypes ngf-accept=$ctrl.jsonMimeTypes required ng-class=\"{'md-accent': $ctrl.isUnselected, 'md-warn': !$ctrl.isUnselected}\"> <span ng-show=$ctrl.isUnselected translate> SELECT_FILE </span> <span ng-hide=$ctrl.isUnselected translate> CHANGE </span> </md-button> </form> <sub translate>SNOW_DATA_FILE_NOTE</sub> </md-card>";

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var manager_controller_1 = __webpack_require__(471);
	var template = __webpack_require__(472);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: manager_controller_1.default,
	    template: template
	};


/***/ },
/* 471 */
/***/ function(module, exports) {

	"use strict";
	var StationManagerController = (function () {
	    function StationManagerController($state, stationApi, $mdDialog, $translate, $location) {
	        var _this = this;
	        this.$state = $state;
	        this.stationApi = stationApi;
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.$location = $location;
	        this.isOpen = false;
	        this.newStation = function () {
	            _this.$state.go('station.creator');
	        };
	        this.newVirtualStation = function () {
	            _this.$state.go('station.creatorVirtual');
	        };
	        this.onStationsReady = function (stationsPaginated) {
	            _this.stations = stationsPaginated.resources;
	            _this.paginationSettings.count = stationsPaginated.count;
	        };
	        this.selectedStations = [];
	        this.stations = [];
	        this.paginationSettings = {
	            offset: this.$location.search().offset || 0,
	            pageSize: 10,
	            currentPage: this.$location.search().offset ? parseInt(this.$location.search().offset) + 1 : 1
	        };
	        this.order = this.$location.search().order;
	        this.onOrderChange = this.onOrderChange.bind(this);
	        this.getStations();
	    }
	    Object.defineProperty(StationManagerController.prototype, "isStationSelected", {
	        get: function () {
	            return this.selectedStations.length > 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationManagerController.prototype, "isSelectedStationVirtual", {
	        get: function () {
	            return this.selectedStation.isVirtual;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationManagerController.prototype, "selectedStation", {
	        get: function () {
	            return this.selectedStations[0];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationManagerController.prototype.showForecastModels = function () {
	        this.$state.go('station.forecastModels', { stationId: this.selectedStation.id });
	    };
	    ;
	    StationManagerController.prototype.showSnowData = function () {
	        this.$state.go('station.snowData', { stationId: this.selectedStation.id });
	    };
	    StationManagerController.prototype.showHistoricData = function () {
	        this.$state.go('station.historicNorm', { stationId: this.selectedStation.id });
	    };
	    StationManagerController.prototype.showStationCurve = function () {
	        this.$state.go('station.curve', { stationId: this.selectedStation.id });
	    };
	    StationManagerController.prototype.showStationTimeseries = function () {
	        this.$state.go('station.timeseries', { stationId: this.selectedStation.id });
	    };
	    StationManagerController.prototype.editStation = function () {
	        this.$state.go('station.details', { stationId: this.selectedStation.id });
	    };
	    StationManagerController.prototype.deleteStation = function (id) {
	        var _this = this;
	        var confirm = this.$mdDialog.confirm()
	            .textContent(this.$translate.instant('DELETE_CONFIRMATION', { item: this.selectedStation.siteName }))
	            .ok(this.$translate.instant('DELETE'))
	            .cancel(this.$translate.instant('CANCEL'));
	        this.$mdDialog.show(confirm).then(function () {
	            _this.stationApi.deleteDischargeStation(id)
	                .then(function () {
	                _this.getStations();
	                _this.selectedStations = [];
	            });
	        });
	    };
	    StationManagerController.prototype.getStations = function () {
	        this.stationsPromise = this.stationApi.getPaginatedDischargeStations(this.paginationSettings.pageSize, this.paginationSettings.offset, this.order)
	            .then(this.onStationsReady);
	    };
	    StationManagerController.prototype.onOrderChange = function (order) {
	        this.getStations();
	        this.$location.search({
	            offset: this.paginationSettings.offset,
	            order: this.order
	        });
	    };
	    StationManagerController.prototype.onPageChange = function (page) {
	        this.paginationSettings.offset = page - 1;
	        this.getStations();
	        this.$location.search({
	            offset: this.paginationSettings.offset,
	            order: this.order
	        });
	    };
	    StationManagerController.prototype.onSiteSearchTextChange = function () {
	        var _this = this;
	        this.stationApi.searchDischargeStations(this.siteSearchText)
	            .then(function (stations) {
	            _this.stations = stations;
	        });
	    };
	    StationManagerController.$inject = ['$state', 'stationApi', '$mdDialog', '$translate', '$location'];
	    return StationManagerController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationManagerController;


/***/ },
/* 472 */
/***/ function(module, exports) {

	module.exports = "<div class=station-manager-container layout=row> <md-card flex> <md-toolbar class=md-table-toolbar ng-class=\"{'md-default': !$ctrl.isStationSelected, 'md-accent': $ctrl.isStationSelected}\"> <div class=md-toolbar-tools> <span ng-hide=$ctrl.isStationSelected translate>HYDROLOGICAL_DISCHARGE_STATIONS</span> <span ng-show=$ctrl.isStationSelected> {{ $ctrl.selectedStation | stationFormatter }} </span> <span flex></span> <md-button class=md-icon-button ng-disabled=!$ctrl.isStationSelected ng-click=$ctrl.editStation()> <md-icon>edit</md-icon> <md-tooltip md-direction=down> <span translate>EDIT_STATION</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=!$ctrl.isStationSelected ng-click=$ctrl.showStationCurve() ng-if=!$ctrl.selectedStation.isVirtual> <md-icon>show_chart</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_DISCHARGE_CURVES</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=!$ctrl.isStationSelected ng-click=$ctrl.showStationTimeseries()> <md-icon>timeline</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_DISCHARGE_TIME_SERIES</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=!$ctrl.isStationSelected ng-click=$ctrl.showHistoricData()> <md-icon>history</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_HISTORIC_DATA</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=!$ctrl.isStationSelected ng-click=$ctrl.showForecastModels()> <md-icon>equalizer</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_FORECAST_MODELS</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=!$ctrl.isStationSelected ng-click=$ctrl.showSnowData() ng-if=!$ctrl.selectedStations[0].isVirtual> <md-icon>ac_unit</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_SNOW_DATA</span> </md-tooltip> </md-button> <md-fab-speed-dial class=\"md-hover-full md-scale\" md-direction=down style=top:40px md-open=openAddDialAlt ng-mouseenter=\"openAddDialAlt = true\" ng-mouseleave=\"openAddDialAlt = false\"> <md-fab-trigger> <md-button class=\"md-icon-button md-raised\"> <md-icon class=material-icons>add</md-icon> </md-button> </md-fab-trigger> <md-fab-actions> <md-button class=\"md-fab md-mini md-raised\" ng-click=$ctrl.newStation()> <md-icon class=material-icons>location_on</md-icon> <md-tooltip md-direction=left> <span translate>ADD_STATION</span> </md-tooltip> </md-button> <md-button class=\"md-fab md-mini md-raised\" ng-click=$ctrl.newVirtualStation()> <md-icon class=material-icons>call_merge</md-icon> <md-tooltip md-direction=left> <span translate>ADD_VIRTUAL_STATION</span> </md-tooltip> </md-button> </md-fab-actions> </md-fab-speed-dial> </div> </md-toolbar> <form name=searchForm layout=row class=site-search> <md-input-container> <label translate>SEARCH_STATION_CODE</label> <input type=text pattern=[0-9]* name=siteSearchText maxlength=5 ng-model=$ctrl.siteSearchText ng-change=$ctrl.onSiteSearchTextChange()> <div ng-messages=searchForm.siteSearchText.$error md-auto-hide=false ng-show=searchForm.siteSearchText.$dirty> <div ng-message=max translate> INVALID_VALUE </div> </div> </md-input-container> </form> <md-table-container flex ng-if=$ctrl.stations.length> <table md-table md-progress=$ctrl.stationsPromise md-row-select ng-model=$ctrl.selectedStations> <thead md-head md-order=$ctrl.order md-on-reorder=$ctrl.onOrderChange> <tr md-row> <th md-column md-order-by=siteCode><span translate>STATION_CODE</span></th> <th md-column md-order-by=siteName><span translate>STATION_NAME</span></th> <th md-column md-order-by=region><span translate>REGION</span> </th> <th md-column md-order-by=basin><span translate>RIVER_BASIN</span></th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select md-select=station md-select-id=id ng-repeat=\"station in $ctrl.stations\"> <td md-cell> {{ station.siteCode }} <md-icon ng-if=station.isVirtual> call_merge <md-tooltip> <span translate>VIRTUAL_STATION</span> </md-tooltip> </md-icon> </td> <td md-cell>{{ station.siteName }}</td> <td md-cell>{{ station.region }}</td> <td md-cell>{{ station.basin }}</td> </tr> </tbody> </table> </md-table-container> <div flex ng-if=!$ctrl.stations.length layout=column layout-align=\"center center\"> <span translate>NO_STATIONS</span> </div> <div layout=row layout-padding layout-align=\"end center\"> <pagination-controls ng-if=\"!$ctrl.siteSearchText && $ctrl.paginationSettings.count > $ctrl.paginationSettings.pageSize\" on-page-change=$ctrl.onPageChange(page) current-page=$ctrl.paginationSettings.currentPage count=$ctrl.paginationSettings.count page-size=$ctrl.paginationSettings.pageSize></pagination-controls> </div> </md-card> </div>";

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(474);
	var auth_guard_1 = __webpack_require__(198);
	var station_controller_1 = __webpack_require__(475);
	var template = __webpack_require__(476);
	exports.configStates = function ($stateProvider) {
	    var stateData = {};
	    stateData[auth_guard_1.AuthGuard.REQUIRES_AUTH_KEY] = true;
	    $stateProvider.state('station', {
	        url: '/station?offset&order',
	        component: 'imomoStation',
	        abstract: true,
	        data: stateData,
	        params: {
	            offset: { dynamic: true },
	            order: { dynamic: true }
	        }
	    });
	    $stateProvider.state('station.manager', {
	        name: 'station.manager',
	        parent: 'station',
	        url: '',
	        component: 'imomoStationManager'
	    });
	    $stateProvider.state('station.creator', {
	        parent: 'station',
	        url: '/new',
	        component: 'imomoStationCreator'
	    });
	    $stateProvider.state('station.creatorVirtual', {
	        parent: 'station',
	        url: '/virtual/new',
	        component: 'imomoStationCreator'
	    });
	    $stateProvider.state('station.forecastModels', {
	        parent: 'station',
	        url: '/:stationId/forecast-models/',
	        component: 'imomoStationForecastModel'
	    });
	    $stateProvider.state('station.snowData', {
	        parent: 'station',
	        url: '/snow-data/:stationId',
	        component: 'imomoStationSnowData'
	    });
	    $stateProvider.state('station.historicNorm', {
	        parent: 'station',
	        url: '/norm/:stationId',
	        component: 'imomoStationHistoricNorm'
	    });
	    $stateProvider.state('station.curve', {
	        parent: 'station',
	        url: '/curve/:stationId?year',
	        component: 'imomoStationCurve',
	        params: {
	            year: { dynamic: true }
	        }
	    });
	    $stateProvider.state('station.details', {
	        parent: 'station',
	        url: '/edit/:stationId',
	        component: 'imomoStationDetails'
	    });
	    $stateProvider.state('station.timeseries', {
	        parent: 'station',
	        url: '/timeseries/:stationId',
	        component: 'imomoStationTimeseries'
	    });
	};
	exports.configStates.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: station_controller_1.default,
	    template: template
	};


/***/ },
/* 474 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 475 */
/***/ function(module, exports) {

	"use strict";
	var StationManagerController = (function () {
	    function StationManagerController($state, $rootScope, $transitions) {
	        var _this = this;
	        this.$state = $state;
	        this.$rootScope = $rootScope;
	        this.$transitions = $transitions;
	        this.$rootScope.$on('STATION_LOADED', function (event, station) {
	            _this.station = station;
	        });
	        this.stateName = this.$state.current.name;
	        this.$transitions.onSuccess({}, function () {
	            _this.stateName = _this.$state.current.name;
	        });
	    }
	    StationManagerController.$inject = ['$state', '$rootScope', '$transitions'];
	    return StationManagerController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationManagerController;


/***/ },
/* 476 */
/***/ function(module, exports) {

	module.exports = "<md-toolbar class=md-table-toolbar ng-if=\"$ctrl.stateName !== 'station.manager' && $ctrl.stateName !== 'station.creator' && $ctrl.stateName !== 'station.creatorVirtual'\"> <div class=md-toolbar-tools> <span> {{ $ctrl.station | stationFormatter }} </span> <span flex></span> <md-button ui-sref=station.manager><md-icon>keyboard_arrow_left</md-icon><span translate>BACK_TO_STATION_LIST</span></md-button> <span flex></span> <md-button class=md-icon-button ng-disabled=\"$ctrl.stateName === 'station.details'\" ui-sref=\"station.details({stationId: $ctrl.station.id})\" ng-click=$ctrl.editStation()> <md-icon>edit</md-icon> <md-tooltip md-direction=down> <span translate>EDIT_STATION</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=\"$ctrl.stateName === 'station.curve'\" ui-sref=\"station.curve({stationId: $ctrl.station.id})\" ng-click=$ctrl.showStationCurve() ng-if=!$ctrl.station.isVirtual> <md-icon>show_chart</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_DISCHARGE_CURVES</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=\"$ctrl.stateName === 'station.timeseries'\" ui-sref=\"station.timeseries({stationId: $ctrl.station.id})\" ng-click=$ctrl.showStationTimeseries()> <md-icon>timeline</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_DISCHARGE_TIME_SERIES</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=\"$ctrl.stateName === 'station.historicNorm'\" ui-sref=\"station.historicNorm({stationId: $ctrl.station.id})\" ng-click=$ctrl.showHistoricData()> <md-icon>history</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_HISTORIC_DATA</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=\"$ctrl.stateName === 'station.forecastModels'\" ui-sref=\"station.forecastModels({stationId: $ctrl.station.id})\" ng-click=$ctrl.showForecastModels() ng-if=!$ctrl.station.isVirtual> <md-icon>equalizer</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_FORECAST_MODELS</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=\"$ctrl.stateName === 'station.snowData'\" ui-sref=\"station.snowData({stationId: $ctrl.station.id})\" ng-click=$ctrl.showSnowData() ng-if=!$ctrl.station.isVirtual> <md-icon>ac_unit</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_SNOW_DATA</span> </md-tooltip> </md-button> </div> </md-toolbar> <ui-view class=\"inner-outlet station-inner-outlet\" ng-class=\"{'station-manager-inner-outlet': $ctrl.stateName === 'station.manager' || $ctrl.stateName === 'station.creator' || $ctrl.stateName === 'station.creatorVirtual'}\"></ui-view>";

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var selector_controller_1 = __webpack_require__(478);
	__webpack_require__(479);
	var template = __webpack_require__(480);
	var selectorComponent = {
	    bindings: {
	        highlightedStationId: '<',
	        onSelectChange: '&',
	        onStationHighlightChange: '&',
	        isWithMeteostations: '<',
	        isDisabled: '=',
	        isSelectable: '<',
	        isElevated: '<',
	        stations: '<',
	        isDataTypeSelectingEnabled: '<',
	        isStationForecastActive: '<',
	        isListCached: '<',
	        forecastModelFrequency: '='
	    },
	    controller: selector_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = selectorComponent;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var StationSelectorController = (function () {
	    function StationSelectorController(stationApi, $filter, $element, stationSelectorService, $q, $translate) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.$element = $element;
	        this.stationSelectorService = stationSelectorService;
	        this.$q = $q;
	        this.$translate = $translate;
	        this.dischargeDataTypes = [{
	                label: this.$translate.instant('DISCHARGE'),
	                value: 'discharge'
	            }, {
	                label: this.$translate.instant('SNOW_DATA'),
	                value: 'snow_data'
	            }];
	        this.meteoDataTypes = [{
	                label: this.$translate.instant('AIR_CELSIUS'),
	                value: 'temperature'
	            }, {
	                label: this.$translate.instant('PRECIPITATION'),
	                value: 'precipitation'
	            }];
	        this.filter = $filter('filter');
	        var stationPromises = [];
	        var dischargeStationsPromise = stationApi.getDischargeStations();
	        var meteoStationsPromise = stationApi.getMeteoStations();
	        var stationsWithForecastResultPromise;
	        if (this.isStationForecastActive) {
	            stationsWithForecastResultPromise = stationApi.getDischargeStationsWithForecast();
	            stationPromises.push(stationsWithForecastResultPromise);
	        }
	        else {
	            stationPromises.push(dischargeStationsPromise);
	        }
	        if (typeof this.isSelectable === 'undefined') {
	            this.isSelectable = true;
	        }
	        if (typeof this.isElevated === 'undefined') {
	            this.isElevated = true;
	        }
	        if (typeof this.isListCached === 'undefined') {
	            this.isListCached = true;
	        }
	        if (this.isWithMeteostations) {
	            stationPromises.push(meteoStationsPromise);
	        }
	        this.stationsPromise = this.$q.all(stationPromises).then(function (_a) {
	            var dischargeStations = _a[0], meteoStations = _a[1];
	            var stations = dischargeStations;
	            stations.forEach(function (station, index) {
	                if (_this.stations && _this.stations.length) {
	                    _this.stations.forEach(function (stationFromInput) {
	                        if (station.id === stationFromInput.siteId || stationFromInput.id === station.id) {
	                            stations.splice(index, 1);
	                        }
	                    });
	                }
	            });
	            if (meteoStations && meteoStations.length) {
	                angular.forEach(meteoStations, function (meteoStation) {
	                    stations.push(meteoStation);
	                });
	            }
	            if (_this.isListCached) {
	                _this.selectedStations = _this.stationSelectorService.getStoredStations(StationSelectorController.STORAGE_KEY, immutable_1.List(stations));
	            }
	            _this.selectedStationsArray = _this.selectedStations
	                .toArray().sort(compareStations);
	            if (!_this.selectedStations.isEmpty()) {
	                _this.highlightedStationId = _this.selectedStationsArray[0].id;
	            }
	            _this.notifyChanges();
	            return stations;
	        });
	    }
	    StationSelectorController.prototype.$doCheck = function () {
	        if (typeof this.stations !== 'undefined') {
	            this.selectedStations = this.stations ? immutable_1.Set(this.stations) : immutable_1.Set([]);
	            this.selectedStationsArray = this.selectedStations.toArray();
	        }
	    };
	    StationSelectorController.prototype.$onChanges = function () {
	        var _this = this;
	        if (this.selectedStations && !this.selectedStations.find(function (station) { return station.id == _this.highlightedStationId; })) {
	            this.highlightedStationId = null;
	        }
	        if (this.stations && this.stations.length && this.isDataTypeSelectingEnabled) {
	            this.stations.forEach(function (stationFromInput) {
	                if (!stationFromInput.dataValueTypesSelectorHelper) {
	                    stationFromInput.dataValueTypesSelectorHelper = {
	                        discharge: null,
	                        snow_data: null,
	                        temperature: null,
	                        precipitation: null
	                    };
	                    stationFromInput.dataValueTypes.forEach(function (dataValueType) {
	                        switch (dataValueType.type) {
	                            case 'discharge':
	                                stationFromInput.dataValueTypesSelectorHelper.discharge = {
	                                    checked: true,
	                                    laglength: dataValueType.laglength
	                                };
	                                break;
	                            case 'snow_data':
	                                stationFromInput.dataValueTypesSelectorHelper.snow_data = {
	                                    checked: true,
	                                    laglength: dataValueType.laglength
	                                };
	                                break;
	                            case 'temperature':
	                                stationFromInput.dataValueTypesSelectorHelper.temperature = {
	                                    checked: true,
	                                    laglength: dataValueType.laglength
	                                };
	                                break;
	                            case 'precipitation':
	                                stationFromInput.dataValueTypesSelectorHelper.precipitation = {
	                                    checked: true,
	                                    laglength: dataValueType.laglength
	                                };
	                                break;
	                            default:
	                                break;
	                        }
	                    });
	                }
	            });
	        }
	    };
	    Object.defineProperty(StationSelectorController.prototype, "inputElement", {
	        /**
	         * Input element in the md-autocomplete component.
	         */
	        get: function () {
	            return this.$element[0].querySelector('#station-input');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the stations matching a search text.
	     */
	    StationSelectorController.prototype.getMatchedStations = function (searchText) {
	        var _this = this;
	        return this.stationsPromise.then(function (stations) {
	            return _this.filter(stations, searchText).filter(function (station) {
	                return !_this.selectedStations.contains(station);
	            });
	        });
	    };
	    /**
	     * Add the selected station to the set.
	     */
	    StationSelectorController.prototype.addToSelectedStations = function (station) {
	        if (this.highlightedStationId == null) {
	            this.highlightedStationId = station.id;
	        }
	        if (station.siteType === 'discharge' && this.isDataTypeSelectingEnabled) {
	            station.dataValueTypesSelectorHelper = {
	                discharge: {
	                    checked: true,
	                    laglength: this.forecastModelFrequency === 'seasonal' ? null : 1
	                },
	                snow_data: {
	                    checked: true,
	                    laglength: this.forecastModelFrequency === 'seasonal' ? null : 1
	                }
	            };
	        }
	        if (station.siteType === 'virtual-discharge' && this.isDataTypeSelectingEnabled) {
	            station.dataValueTypesSelectorHelper = {
	                discharge: {
	                    checked: true,
	                    laglength: this.forecastModelFrequency === 'seasonal' ? null : 1
	                }
	            };
	        }
	        if (station.siteType === 'meteo' && this.isDataTypeSelectingEnabled) {
	            station.dataValueTypesSelectorHelper = {
	                temperature: {
	                    checked: true,
	                    laglength: this.forecastModelFrequency === 'seasonal' ? null : 1
	                },
	                precipitation: {
	                    checked: true,
	                    laglength: this.forecastModelFrequency === 'seasonal' ? null : 1
	                }
	            };
	        }
	        this.setDataValueTypes(station);
	        this.selectedStations = this.selectedStations.add(station);
	        this.selectedStationsArray = this.selectedStations
	            .toArray().sort(compareStations);
	        this.searchText = '';
	        this.inputElement && this.inputElement.blur();
	        this.notifyChanges();
	    };
	    /**
	     * Remove a selected station from the set.
	     */
	    StationSelectorController.prototype.removeFromSelectedStations = function (station) {
	        this.selectedStations = this.selectedStations.remove(station);
	        this.selectedStationsArray = this.selectedStations
	            .toArray().sort(compareStations);
	        if (station.id == this.highlightedStationId) {
	            this.highlightedStationId = this.selectedStations.isEmpty()
	                ? null
	                : this.selectedStationsArray[0].id;
	        }
	        this.notifyChanges();
	    };
	    /**
	     * Highlight a station in the list.
	     */
	    StationSelectorController.prototype.highlightStation = function (station) {
	        this.highlightedStationId = station.id;
	        this.notifyChanges();
	    };
	    StationSelectorController.prototype.onDataTypeToggle = function (station) {
	        this.setDataValueTypes(station);
	    };
	    StationSelectorController.prototype.setDataValueTypes = function (station) {
	        station.dataValueTypes = [];
	        angular.forEach(station.dataValueTypesSelectorHelper, function (value, key) {
	            switch (key) {
	                case ('discharge'):
	                    if (value && value.checked) {
	                        station.dataValueTypes.push({ type: 'discharge', laglength: value.laglength });
	                    }
	                    break;
	                case ('snow_data'):
	                    if (value && value.checked) {
	                        station.dataValueTypes.push({ type: 'snow_data', laglength: value.laglength });
	                    }
	                    break;
	                case ('temperature'):
	                    if (value && value.checked) {
	                        station.dataValueTypes.push({ type: 'temperature', laglength: value.laglength });
	                    }
	                    break;
	                case ('precipitation'):
	                    if (value && value.checked) {
	                        station.dataValueTypes.push({ type: 'precipitation', laglength: value.laglength });
	                    }
	                    break;
	                default:
	                    break;
	            }
	        });
	    };
	    StationSelectorController.prototype.isDataValueTypeInStationDataInputs = function (station, value) {
	        var isPresent = false;
	        station.dataValueTypes.forEach(function (dataValueType) {
	            if (dataValueType.type = value) {
	                isPresent = true;
	                return;
	            }
	        });
	        return isPresent;
	    };
	    /**
	     * Notify the callback about changes in the set of selected stations and
	     * store it locally.
	     */
	    StationSelectorController.prototype.notifyChanges = function () {
	        var _this = this;
	        if (this.isListCached) {
	            this.stationSelectorService.storeStations(StationSelectorController.STORAGE_KEY, this.selectedStations);
	        }
	        if (this.onSelectChange) {
	            this.onSelectChange({
	                selectedStations: this.selectedStations
	            });
	        }
	        if (this.onStationHighlightChange) {
	            this.onStationHighlightChange({
	                station: this.selectedStations.find(function (station) { return station.id == _this.highlightedStationId; })
	            });
	        }
	    };
	    StationSelectorController.$inject = [
	        'stationApi',
	        '$filter',
	        '$element',
	        'stationSelectorService',
	        '$q',
	        '$translate'
	    ];
	    StationSelectorController.STORAGE_KEY = 'selector';
	    return StationSelectorController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationSelectorController;
	function compareStations(a, b) {
	    return a.siteCode.localeCompare(b.siteCode);
	}


/***/ },
/* 479 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 480 */
/***/ function(module, exports) {

	module.exports = "<md-card flex class=station-selector-card ng-class=\"{'not-elevated': !$ctrl.isElevated}\"> <md-card-title class=station-selector-title> <md-card-title-text> <span class=md-title translate> STATION_LIST </span> </md-card-title-text> </md-card-title> <md-card-content class=station-selector-content> <form name=stationForm layout=row class=station-selector-form> <md-autocomplete required flex ng-disabled=$ctrl.isDisabled md-items=\"station in $ctrl.getMatchedStations($ctrl.searchText)\" md-search-text=$ctrl.searchText md-min-length=0 md-item-text=\"station | stationFormatter\" md-selected-item=selectedStation md-no-cache=true md-input-id=station-input placeholder=\"{{'SELECT_A_STATION' | translate}}\"> <md-item-template> <md-icon ng-if=\"station.siteType === 'discharge'\" class=material-icons>place</md-icon> <md-icon ng-if=\"station.siteType === 'virtual-discharge'\" class=material-icons>call_merge</md-icon> <md-icon ng-if=\"station.siteType === 'meteo'\" class=material-icons>wb_cloudy</md-icon> <span md-highlight-text=$ctrl.searchText> {{ station | stationFormatter }} </span> </md-item-template> </md-autocomplete> <md-button type=submit class=\"md-icon-button md-primary md-raised\" ng-disabled=\"stationForm.$invalid || !selectedStation\" ng-click=$ctrl.addToSelectedStations(selectedStation)> <md-icon class=material-icons>add</md-icon> </md-button> </form> <md-content flex class=md-whiteframe-2dp layout=column> <md-radio-group ng-if=$ctrl.isSelectable ng-model=$ctrl.highlightedStationId ng-change=$ctrl.onStationRadioChange()> <md-list flex class=station-selector-list> <md-list-item ng-repeat=\"station in $ctrl.selectedStationsArray\" class=md-2-line ng-click=$ctrl.highlightStation(station)> <md-radio-button ng-value=station.id aria-label=\"{{ station | stationFormatter }}\"> </md-radio-button> <div class=md-list-item-text> <h3>{{ station | stationFormatter }}</h3> <h4>{{ station.basin }}</h4> </div> <md-icon class=\"material-icons md-secondary md-warn\" ng-click=$ctrl.removeFromSelectedStations(station)> cancel </md-icon> </md-list-item> </md-list> </md-radio-group> <md-list ng-if=!$ctrl.isSelectable flex class=station-selector-list> <md-list-item ng-repeat=\"station in $ctrl.selectedStationsArray\"> <div class=\"md-2-line md-list-item\"> <div class=md-list-item-text> <h3>{{ station | stationFormatter }}</h3> </div> <md-icon class=\"material-icons md-secondary md-warn\" ng-click=$ctrl.removeFromSelectedStations(station) ng-disabled=$ctrl.isDisabled> cancel </md-icon> <form name=\"{{ 'formStation' + (station.id || station.siteId) + 'DischargeDataValues' }}\"> <div layout=row ng-if=\"station.siteType === 'discharge' || station.siteType === 'virtual-discharge'\"> <div layout=column layout-padding ng-repeat=\"dataType in $ctrl.dischargeDataTypes track by $index\"> <md-checkbox name=\"{{ dataType.value }}\" ng-checked=station.dataValueTypesSelectorHelper[dataType.value].checked ng-click=\"station.dataValueTypesSelectorHelper[dataType.value].checked = !station.dataValueTypesSelectorHelper[dataType.value].checked; $ctrl.onDataTypeToggle(station)\" ng-hide=\"station.siteType === 'virtual-discharge' && dataType.value === 'snow_data'\" ng-disabled=\"station.siteType === 'virtual-discharge' || $ctrl.isDisabled\"> {{ dataType.label }} </md-checkbox> <md-input-container ng-hide=\"$ctrl.forecastModelFrequency === 'seasonal' || station.siteType === 'virtual-discharge' && dataType.value === 'snow_data'\"> <label> <span translate>FEATURE_TIMELAG</span> </label> <input name=\"{{ dataType.value + 'Laglength' }}\" required ng-model=station.dataValueTypesSelectorHelper[dataType.value].laglength ng-change=$ctrl.setDataValueTypes(station) ng-disabled=!station.dataValueTypesSelectorHelper[dataType.value].checked type=number min=1 max=10> </md-input-container> </div> </div> </form> <form name=\"$ctrl['formStation' + (station.id || station.siteId) + 'MeteoDataValues']\"> <div layout=row ng-if=\"station.siteType === 'meteo'\"> <div layout=column layout-padding ng-repeat=\"dataType in $ctrl.meteoDataTypes track by $index\"> <md-checkbox name=\"{{ dataType.value }}\" ng-checked=station.dataValueTypesSelectorHelper[dataType.value].checked ng-click=\"station.dataValueTypesSelectorHelper[dataType.value].checked = !station.dataValueTypesSelectorHelper[dataType.value].checked; $ctrl.onDataTypeToggle(station)\" ng-disabled=$ctrl.isDisabled> {{ dataType.label }} </md-checkbox> <md-input-container ng-hide=\"$ctrl.forecastModelFrequency === 'seasonal'\"> <label> <span translate>FEATURE_TIMELAG</span> </label> <input name=\"{{ dataType.value + 'Laglength' }}\" required ng-model=station.dataValueTypesSelectorHelper[dataType.value].laglength ng-change=$ctrl.setDataValueTypes(station) ng-disabled=!station.dataValueTypesSelectorHelper[dataType.value].checked type=number min=1 max=10> </md-input-container> </div> </div> </form> </div> <md-divider></md-divider> </md-list-item> </md-list> </md-content> </md-card-content> </md-card>";

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var historic_norm_controller_1 = __webpack_require__(482);
	var template = __webpack_require__(483);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: historic_norm_controller_1.default,
	    template: template
	};


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var StationHistoricNormController = (function () {
	    function StationHistoricNormController(stationApi, dataValueApi, s3UploadService, $q, $stateParams, $rootScope) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.dataValueApi = dataValueApi;
	        this.s3UploadService = s3UploadService;
	        this.$q = $q;
	        this.$rootScope = $rootScope;
	        this.isLoading = true;
	        this.normRows = [];
	        var months = moment.months();
	        for (var i = 0; i < 12; ++i) {
	            this.normRows.push({
	                month: months[i],
	                data: [undefined, undefined, undefined]
	            });
	        }
	        var stationId = Number.parseInt($stateParams.stationId);
	        this.stationId = stationId;
	        this.stationApi.getDischargeStation({ stationId: stationId }).then(function (station) {
	            _this.station = station;
	            _this.$rootScope.$broadcast('STATION_LOADED', station);
	        }).finally(function () {
	            _this.isLoading = false;
	        });
	        this.loadNorm(stationId);
	        // this.loadHistoricDischargeData(stationId);
	    }
	    StationHistoricNormController.prototype.uploadNewData = function ($file) {
	        var _this = this;
	        if ($file) {
	            this.isHistoricalDataLoading = true;
	            this.stationApi.uploadHistoricDischargeData(this.station.id, $file).then(function () {
	                _this.loadNorm(_this.station.id);
	                _this.isHistoricalDataLoading = false;
	            });
	        }
	    };
	    StationHistoricNormController.prototype.downloadHistoricDischargeData = function () {
	        var _this = this;
	        this.isHistoricalDataLoading = true;
	        return this.stationApi.getStationHistoricDischargeDataXLSX(this.stationId)
	            .finally(function () {
	            _this.isHistoricalDataLoading = false;
	        });
	    };
	    StationHistoricNormController.prototype.loadNorm = function (stationId) {
	        var _this = this;
	        this.clearNormRows();
	        this.normPromise = this.dataValueApi.getStationNorm(stationId, 'discharge')
	            .then(function (stationNorm) {
	            _this.normStartYear = stationNorm.startYear;
	            _this.normEndYear = stationNorm.endYear;
	            _this.processNorm(stationNorm);
	        });
	    };
	    StationHistoricNormController.prototype.clearNormRows = function () {
	        this.normRows.forEach(function (row) {
	            row.data = [undefined, undefined, undefined];
	        });
	    };
	    StationHistoricNormController.prototype.processNorm = function (stationNorm) {
	        var currentRow;
	        for (var i = 0; i < stationNorm.normData.length; ++i) {
	            if (i % 3 == 0) {
	                currentRow = this.normRows[Math.floor(i / 3)];
	            }
	            currentRow.data[i % 3] = stationNorm.normData[i];
	        }
	    };
	    StationHistoricNormController.$inject = ['stationApi', 'dataValueApi', 's3UploadService', '$q', '$stateParams', '$rootScope'];
	    return StationHistoricNormController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationHistoricNormController;


/***/ },
/* 483 */
/***/ function(module, exports) {

	module.exports = "<section layout=column class=historic-norm-container ng-hide=$ctrl.isLoading layout-padding> <md-card flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-title> <span translate>DISCHARGE_NORM</span> <span class=md-subhead> {{$ctrl.normStartYear}} - {{$ctrl.normEndYear}} </span> </span> </div> </md-toolbar> <md-table-container> <table md-table md-progress=$ctrl.normPromise> <thead md-head> <tr md-row> <th md-column></th> <th md-column colspan=3> <span translate>DECADE</span> </th> </tr> <tr md-row> <th md-column> <span translate>MONTH</span> </th> <th md-column md-numeric> <span translate>I</span> </th> <th md-column md-numeric> <span translate>II</span> </th> <th md-column md-numeric> <span translate>III</span> </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"normRow in $ctrl.normRows\"> <td md-cell>{{ normRow.month }}</td> <td md-cell ng-repeat=\"datum in normRow.data track by $index\"> {{ datum | hydroDischargeNumberFormatter }} </td> </tr> </tbody> </table> </md-table-container> </md-card> <md-card flex=none class=historic-upload-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-title translate> HISTORICAL_DISCHARGE_DATA </span> </div> </md-toolbar> <p translate> NEW_DATA_MUST_BE_EXCEL </p> <section layout=row layout-align=\"end center\" ng-hide=$ctrl.isHistoricalDataLoading> <md-button ng-href=https://s3.eu-central-1.amazonaws.com/imomo-uploads/discharge_template.xlsx download=discharge-template.xlsx> <span translate>DOWNLOAD_EXAMPLE_FILE</span> </md-button> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.downloadHistoricDischargeData()> <span translate>DOWNLOAD_DATA</span> </md-button> <md-button class=\"md-raised md-primary\" ng-if=!$ctrl.station.isVirtual ngf-select=$ctrl.uploadNewData($file)> <span translate>UPLOAD_NEW_DATA</span> </md-button> </section> <section ng-show=$ctrl.isHistoricalDataLoading class=progress-bar> <md-progress-linear></md-progress-linear> </section> </md-card> </section> <section layout=column class=historic-norm-container ng-show=$ctrl.isLoading layout=row layout-align=\"center center\"> <md-progress-circular></md-progress-circular> </section>";

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var curve_controller_1 = __webpack_require__(485);
	var template = __webpack_require__(486);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: curve_controller_1.default,
	    bindings: {
	        stationId: '<'
	    },
	    template: template
	};


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var chart_color_service_1 = __webpack_require__(356);
	var immutable_1 = __webpack_require__(195);
	var StationCurveController = (function () {
	    function StationCurveController(dischargeModelApi, dataValueApi, stationApi, curveSettingsApi, $q, modelCreatorService, $state, chartColorService, $scope, $stateParams, imomoErrorService, $rootScope) {
	        var _this = this;
	        this.dischargeModelApi = dischargeModelApi;
	        this.dataValueApi = dataValueApi;
	        this.stationApi = stationApi;
	        this.curveSettingsApi = curveSettingsApi;
	        this.$q = $q;
	        this.modelCreatorService = modelCreatorService;
	        this.$state = $state;
	        this.chartColorService = chartColorService;
	        this.$scope = $scope;
	        this.$stateParams = $stateParams;
	        this.imomoErrorService = imomoErrorService;
	        this.$rootScope = $rootScope;
	        this.newModelOption = 'deltaH';
	        this.selectedDischargeDataItems = immutable_1.Set();
	        this.parseYearFromParams(this.$stateParams);
	        var stationId = Number.parseInt(this.$stateParams.stationId) || this.stationId;
	        this.loadStationData(stationId);
	        this.curveSettingsApi.getCurveSettings(stationId)
	            .then(function (curveSettings) {
	            if (curveSettings) {
	                _this.dischargeCurveSettings = curveSettings[0];
	            }
	        });
	        this.$rootScope.$on('NEW_MODEL_UPDATED', function () {
	            _this.loadStationData(stationId);
	        });
	    }
	    StationCurveController.prototype.uiOnParamsChanged = function (newParams) {
	        this.parseYearFromParams(newParams);
	        this.loadStationData(this.station.id);
	    };
	    StationCurveController.prototype.changeYear = function () {
	        this.loadDischargeModels();
	    };
	    StationCurveController.prototype.onSelectedItemsChange = function (selectedDischargeDataItems) {
	        this.selectedDischargeDataItems = immutable_1.Set(selectedDischargeDataItems);
	    };
	    StationCurveController.prototype.onDischargeModelItemDelete = function (dischargeModelItem, dischargeModelItems) {
	        var _this = this;
	        var cachedDischargeModelItems = angular.copy(this.dischargeModelItems);
	        var stationId = Number.parseInt(this.$stateParams.stationId) || this.stationId;
	        if (dischargeModelItem.dischargeModel == this.newModel) {
	            this.newModel = null;
	        }
	        else {
	            this.isLoading = true;
	            this.dischargeModelApi.deleteDischargeModel(dischargeModelItem.dischargeModel.id)
	                .then(function () {
	                _this.dischargeModelItems = dischargeModelItems;
	                var indexToDelete = _this.dischargeModels
	                    .indexOf(dischargeModelItem.dischargeModel);
	                _this.dischargeModels.splice(indexToDelete, 1);
	                if (_this.selectedDischargeModelId == dischargeModelItem.dischargeModel.id) {
	                    _this.selectedDischargeModelId = null;
	                }
	            })
	                .catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                _this.dischargeModelItems = cachedDischargeModelItems;
	            })
	                .finally(function () {
	                _this.isLoading = false;
	                _this.loadStationData(stationId);
	                _this.$rootScope.$broadcast('ALL_MODELS_UPDATED');
	            });
	        }
	    };
	    StationCurveController.prototype.onChartBoundsChange = function (curveSettings, userChange) {
	        this.minWaterLevel = curveSettings.minWaterLevel;
	        this.maxWaterLevel = curveSettings.maxWaterLevel;
	        if (userChange) {
	            this.curveSettingsApi.createCurveSettings(curveSettings, this.station.id);
	        }
	    };
	    StationCurveController.prototype.isNewModelPossible = function () {
	        if (this.newModelOption == 'deltaH') {
	            return this.newModelName != null &&
	                this.deltaH != null &&
	                this.selectedDischargeModelId != null;
	        }
	        else {
	            return this.selectedDischargeDataItems.size >= 2 &&
	                this.newModelName != null;
	        }
	    };
	    StationCurveController.prototype.createNewModel = function () {
	        var _this = this;
	        if (this.newModel) {
	            this.dischargeModelItems = this.dischargeModelItems.shift();
	        }
	        this.newModelDate = new Date();
	        var selectedDischargeModel = this.dischargeModels.find(function (dischargeModel) { return dischargeModel.id == _this.selectedDischargeModelId; });
	        this.newModel = this.modelCreatorService.createModel({
	            name: this.newModelName,
	            date: moment(this.newModelDate),
	            creationMode: this.newModelOption,
	            referenceModel: selectedDischargeModel,
	            deltaH: this.deltaH,
	            selectedDischargeDataItems: this.selectedDischargeDataItems.toList()
	        });
	        this.dischargeModelItems = this.dischargeModelItems.unshift({
	            dischargeModel: this.newModel,
	            enabled: true,
	            colors: chart_color_service_1.IChartColorService.BLACK_COLORS
	        });
	        this.clearNewModelForm();
	    };
	    StationCurveController.prototype.saveNewModel = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.dischargeModelApi.createDischargeModel({
	            modelName: this.newModel.modelName,
	            paramA: this.newModel.paramA,
	            paramB: this.newModel.paramB,
	            paramC: this.newModel.paramC,
	            paramDeltaLevel: this.newModel.paramDeltaLevel,
	            validFrom: moment(this.newModelDate),
	            siteId: this.station.id
	        }).then(function () {
	            _this.newModel = null;
	            _this.clearNewModelForm();
	            _this.$rootScope.$broadcast('ALL_MODELS_UPDATED');
	            return _this.loadDischargeModels();
	        }).finally(function () {
	            _this.isLoading = false;
	        });
	    };
	    StationCurveController.prototype.clearNewModelForm = function () {
	        this.newModelName = null;
	        this.deltaH = null;
	        this.selectedDischargeModelId = null;
	        if (this.$scope['newModelForm']) {
	            this.$scope['newModelForm'].$setPristine();
	            this.$scope['newModelForm'].$setUntouched();
	        }
	    };
	    StationCurveController.prototype.parseYearFromParams = function (params) {
	        var parsedYear = Number.parseInt(params.year);
	        this.year = Number.isNaN(parsedYear)
	            ? this.year || moment().year() //hydrologicalYear(moment())
	            : parsedYear;
	    };
	    StationCurveController.prototype.loadStationData = function (stationId) {
	        var _this = this;
	        this.isLoading = true;
	        this.resetView();
	        this.stationApi.getDischargeStation({ stationId: stationId }).then(function (station) {
	            _this.station = station;
	            _this.$rootScope.$broadcast('STATION_LOADED', station);
	            var dischargePromise = _this.loadDischargeModels();
	            var dataPromise = _this.loadDischargeData();
	            return _this.$q.all([dischargePromise, dataPromise]);
	        }).finally(function () {
	            _this.isLoading = false;
	        });
	    };
	    StationCurveController.prototype.loadDischargeModels = function () {
	        var _this = this;
	        return this.dischargeModelApi
	            .getDischargeModels(this.station.id, this.year)
	            .then(function (dischargeModels) {
	            _this.dischargeModels = dischargeModels;
	            _this.dischargeModelItems = immutable_1.List(dischargeModels.map(function (model, index) {
	                return {
	                    dischargeModel: model,
	                    enabled: false,
	                    colors: _this.chartColorService.getColors(index)
	                };
	            }));
	            if (_this.dischargeModelItems.size) {
	                _this.dischargeModelItems.first().enabled = true;
	            }
	        });
	    };
	    StationCurveController.prototype.loadDischargeData = function () {
	        var _this = this;
	        return this.dataValueApi.getDischargePairs(this.station.id, this.year)
	            .then(function (dischargePairs) {
	            _this.measuredDischargeDataItems = immutable_1.List(dischargePairs
	                .map(function (dischargeMeasurementPair) {
	                return {
	                    date: moment
	                        .unix(dischargeMeasurementPair.waterLevel.localDateTime).utc(),
	                    waterLevel: dischargeMeasurementPair.waterLevel.dataValue,
	                    discharge: dischargeMeasurementPair.discharge.dataValue
	                };
	            }));
	        });
	    };
	    StationCurveController.prototype.resetView = function () {
	        this.dischargeModelItems = immutable_1.List();
	        this.measuredDischargeDataItems = immutable_1.List();
	        this.dischargeModels = [];
	        this.clearNewModelForm();
	        this.newModel = null;
	    };
	    StationCurveController.$inject = ['dischargeModelApi', 'dataValueApi', 'stationApi', 'curveSettingsApi',
	        '$q', 'modelCreatorService', '$state',
	        'chartColorService', '$scope', '$stateParams', 'imomoErrorService', '$rootScope'];
	    return StationCurveController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationCurveController;


/***/ },
/* 486 */
/***/ function(module, exports) {

	module.exports = "<md-progress-linear md-mode=indeterminate class=top-progress-bar ng-show=$ctrl.isLoading> </md-progress-linear> <div class=station-curve-container layout=row imomo-discharge-data-list-curve> <section layout=column flex imomo-discharge-model-list-curve> <imomo-discharge-curve class=flex-60-no-shrink layout=column curve-settings=$ctrl.dischargeCurveSettings on-bounds-change=\"$ctrl.onChartBoundsChange(curveSettings, userChange)\"> </imomo-discharge-curve> <imomo-discharge-model-list flex layout=row discharge-model-items=$ctrl.dischargeModelItems min-water-level=$ctrl.minWaterLevel max-water-level=$ctrl.maxWaterLevel on-model-delete=\"$ctrl.onDischargeModelItemDelete(dischargeModelItem, dischargeModelItems)\"> </imomo-discharge-model-list> </section> <section flex layout=column> <md-card flex=none layout-padding> <span ng-hide=$ctrl.station>-</span> <span ng-show=$ctrl.station> {{ $ctrl.station | stationFormatter }} </span> <form name=hydroYearForm layout=row flex layout-align=\"start center\"> <md-input-container> <label translate>HYDROLOGICAL_YEAR</label> <input ng-model=$ctrl.year type=number min=1900 step=1> </md-input-container> <span flex></span> <md-button class=\"md-primary md-raised\" ng-disabled=hydroYearForm.$invalid ng-click=$ctrl.changeYear()> <span translate>CHANGE_YEAR</span> </md-button> </form> </md-card> <md-card layout-padding flex=none> <span class=md-title translate> NEW_DISCHARGE_MODEL </span> <form name=newModelForm layout=row> <div layout=column> <md-input-container> <label translate>MODEL_IDENTIFIER</label> <input required ng-model=$ctrl.newModelName> </md-input-container> <md-radio-group ng-model=$ctrl.newModelOption> <md-radio-button value=deltaH> <span translate>ADD_DELTA_H</span> </md-radio-button> <md-radio-button value=fitCurve> <span translate>FIT_TO_SELECTED_DATA</span> </md-radio-button> </md-radio-group> </div> <section ng-switch=$ctrl.newModelOption> <div ng-switch-when=deltaH> <md-input-container class=md-block> <label translate>REFERENCE_MODEL</label> <md-select ng-model=$ctrl.selectedDischargeModelId required> <md-option ng-repeat=\"dischargeModel in $ctrl.dischargeModels\" value={{dischargeModel.id}}> {{ dischargeModel.modelName }} - {{ dischargeModel.validFrom | unixTimestampFormatter | momentFormatter:'date' }} </md-option> </md-select> </md-input-container> <md-input-container class=md-block> <label translate>DELTA_H</label> <input type=number step=1 required ng-model=$ctrl.deltaH> </md-input-container> </div> <div ng-switch-when=fitCurve> <md-input-container class=md-block> <span translate=DATA_SELECTED translate-values=\"{count: $ctrl.selectedDischargeDataItems.size}\"> </span> </md-input-container> </div> </section> </form> <section layout=column layout-padding> <span class=md-title translate>NEW_MODEL</span> <div layout=row layout-align=\"start center\" ng-show=$ctrl.newModel ng-style=\"{background: $ctrl.newModel.color}\"> <div flex class=md-body-2> {{ $ctrl.newModel.modelName }} </div> <label translate>VALID_FROM</label> <md-datepicker ng-model=$ctrl.newModelDate></md-datepicker> </div> </section> <section layout=row layout-align=\"end stretch\"> <md-button class=md-accent ng-click=$ctrl.createNewModel() ng-disabled=!$ctrl.isNewModelPossible()> <span translate>CREATE_MODEL</span> </md-button> <md-button class=md-primary ng-disabled=!$ctrl.newModel ng-click=$ctrl.saveNewModel()> <span translate>SAVE_NEW_MODEL</span> </md-button> </section> </md-card> <imomo-discharge-data-list flex layout=row measured-discharge-data-items=$ctrl.measuredDischargeDataItems on-selected-items-change=$ctrl.onSelectedItemsChange(selectedDischargeDataItems)> </imomo-discharge-data-list> </section> </div>";

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var details_controller_1 = __webpack_require__(488);
	var template = __webpack_require__(489);
	var stationDetailsComponent = {
	    controller: details_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = stationDetailsComponent;


/***/ },
/* 488 */
/***/ function(module, exports) {

	"use strict";
	var StationDetailsController = (function () {
	    function StationDetailsController(stationApi, dataValueApi, $q, $stateParams, $state, $rootScope, $mdDialog, $translate) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.dataValueApi = dataValueApi;
	        this.$q = $q;
	        this.$state = $state;
	        this.$rootScope = $rootScope;
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.resetDisabled = true;
	        this.saveDisabled = true;
	        var stationId = Number.parseInt($stateParams.stationId);
	        this.loadInProgress = true;
	        var stationPromise = this.stationApi.getDischargeStation({ stationId: stationId });
	        var maximumDischargePromise = this.dataValueApi
	            .getMaximumDischarge(stationId);
	        this.$q.all([stationPromise, maximumDischargePromise])
	            .then(function (_a) {
	            var station = _a[0], maximumDischarge = _a[1];
	            _this.station = station;
	            _this.$rootScope.$broadcast('STATION_LOADED', station);
	            _this.maximumDischarge = maximumDischarge;
	            _this.storedStationDetails = {
	                id: _this.station.id,
	                basin: _this.station.basin,
	                code: _this.station.siteCode,
	                country: _this.station.country,
	                location: {
	                    latitude: _this.station.latitude,
	                    longitude: _this.station.longitude
	                },
	                name: _this.station.siteName,
	                region: _this.station.region,
	                maxDischarge: _this.maximumDischarge ? _this.maximumDischarge.dataValue : null,
	                aggregations: _this.station.aggregations,
	                isVirtual: _this.station.isVirtual
	            };
	            _this.resetDetails();
	        }).finally(function () {
	            _this.loadInProgress = false;
	        });
	    }
	    StationDetailsController.prototype.resetDetails = function () {
	        this.stationDetails = angular.copy(this.storedStationDetails);
	        this.resetDisabled = true;
	        this.saveDisabled = true;
	    };
	    StationDetailsController.prototype.onDetailsChange = function (station, isValid) {
	        this.stationDetails = station;
	        this.resetDisabled = angular
	            .equals(this.storedStationDetails, this.stationDetails);
	        this.saveDisabled = this.resetDisabled || !isValid;
	    };
	    StationDetailsController.prototype.onStationAggregationsChange = function (selectedStations, isValid) {
	        this.stationDetails.aggregations = selectedStations || [];
	        this.resetDisabled = angular
	            .equals(this.storedStationDetails, this.stationDetails);
	        this.saveDisabled = this.resetDisabled || !isValid;
	    };
	    StationDetailsController.prototype.saveChanges = function () {
	        var _this = this;
	        this.loadInProgress = true;
	        this.saveDisabled = true;
	        this.resetDisabled = true;
	        this.stationApi.updateDischargeStation(this.station.id, {
	            id: this.station.id,
	            basin: this.stationDetails.basin,
	            country: this.stationDetails.country,
	            latitude: this.stationDetails.location.latitude,
	            longitude: this.stationDetails.location.longitude,
	            region: this.stationDetails.region,
	            siteCode: this.stationDetails.code,
	            siteName: this.stationDetails.name,
	            aggregations: this.stationDetails.aggregations,
	            isVirtual: this.stationDetails.isVirtual
	        }, this.stationDetails.maxDischarge).then(function () {
	            _this.storedStationDetails = angular.copy(_this.stationDetails);
	        }).finally(function () {
	            _this.loadInProgress = false;
	            _this.$state.go('station.manager');
	        });
	    };
	    StationDetailsController.prototype.delete = function () {
	        var _this = this;
	        var confirm = this.$mdDialog.confirm()
	            .textContent(this.$translate.instant('DELETE_CONFIRMATION', { item: this.station.siteName }))
	            .ok(this.$translate.instant('DELETE'))
	            .cancel(this.$translate.instant('CANCEL'));
	        this.$mdDialog.show(confirm).then(function () {
	            _this.stationApi.deleteDischargeStation(_this.station.id)
	                .then(function () {
	                _this.$state.go('meteostation.manager');
	            });
	        });
	    };
	    StationDetailsController.$inject = ['stationApi', 'dataValueApi', '$q', '$stateParams', '$state', '$rootScope', '$mdDialog', '$translate'];
	    return StationDetailsController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationDetailsController;


/***/ },
/* 489 */
/***/ function(module, exports) {

	module.exports = "<div class=station-details-container layout=column ng-if=!$ctrl.loadInProgress> <md-progress-linear md-mode=indeterminate ng-disabled=!$ctrl.loadInProgress> </md-progress-linear> <md-tabs class=full-height-tabs md-border-bottom flex> <md-tab> <md-tab-label> <span translate>STEP_1_DETAILS</span> </md-tab-label> <md-tab-body> <imomo-station-details-edit flex layout=row class=fill-tab station-details=$ctrl.stationDetails on-change=\"$ctrl.onDetailsChange(station, isValid)\"> </imomo-station-details-edit> </md-tab-body> </md-tab> <md-tab ng-if=$ctrl.station.isVirtual> <md-tab-label> <span translate>STEP_2_AGGREGATIONS</span> </md-tab-label> <md-tab-body> <imomo-station-aggregations-edit flex class=fill-tab layout=row station-details=$ctrl.stationDetails on-change=\"$ctrl.onStationAggregationsChange(selectedStations, isValid)\"> </imomo-station-aggregations-edit> </md-tab-body> </md-tab> </md-tabs> <section layout=row layout-align=\"end center\" flex=none> <md-button class=\"md-raised md-warn\" ng-click=$ctrl.delete()> <span translate>DELETE</span> </md-button> <span flex></span> <md-button class=md-raised ng-click=$ctrl.resetDetails() ng-disabled=$ctrl.resetDisabled> <span translate>RESET</span> </md-button> <md-button class=\"md-raised md-primary\" ng-click=$ctrl.saveChanges() ng-disabled=$ctrl.saveDisabled> <span translate>SAVE_CHANGES</span> </md-button> </section> </div>";

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var edit_controller_1 = __webpack_require__(491);
	var template = __webpack_require__(493);
	var detailsEditComponent = {
	    bindings: {
	        stationDetails: '<',
	        onChange: '&'
	    },
	    controller: edit_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = detailsEditComponent;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var station_map_service_1 = __webpack_require__(492);
	var StationDetailsEditController = (function () {
	    function StationDetailsEditController($scope, $state, uiGmapGoogleMapApi, stationApi, stationMapService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
	        this.stationApi = stationApi;
	        this.stationMapService = stationMapService;
	        this.preventMapRefresh = false;
	        this.map = this.stationMapService.getMapOptions();
	        this.map.events = {
	            click: function (map, eventName, _a) {
	                var mouseEvent = _a[0];
	                _this.onMapClick(mouseEvent);
	            }
	        };
	        this.marker = {
	            id: 'followMarker',
	            coords: this.map.center
	        };
	        StationDetailsEditController.DEFAULT_DETAILS.isVirtual =
	            this.$state.$current.name === 'station.creatorVirtual';
	        this.uiGmapGoogleMapApi.then(function (maps) {
	            _this.map.options.mapTypeId = maps.MapTypeId.TERRAIN;
	        });
	    }
	    StationDetailsEditController.prototype.$onChanges = function () {
	        var _this = this;
	        this.mutableStation = this.stationDetails
	            ? angular.copy(this.stationDetails)
	            : angular.copy(StationDetailsEditController.DEFAULT_DETAILS);
	        this.marker.coords = this.mutableStation.location;
	        if (this.map.control.refresh && !this.preventMapRefresh) {
	            this.map.control.refresh(this.mutableStation.location);
	        }
	        this.preventMapRefresh = false;
	        if (this.form) {
	            this.form.$setPristine();
	            this.form.$setUntouched();
	        }
	        if (this.stationDetails) {
	            this.stationApi.getCatchmentAreaGeojson(this.stationDetails.id, false)
	                .then(function (geojson) {
	                _this.uiGmapGoogleMapApi.then(function (maps) {
	                    _this.stationMapService.loadGeoJson(geojson.url, _this.map, maps, 0.5);
	                });
	            }, function () {
	                _this.map.center = _this.marker.coords;
	            });
	        }
	    };
	    StationDetailsEditController.prototype.onLocationInputFieldChange = function () {
	        this.notifyChange();
	        if (this.map.control.refresh) {
	            this.map.control.refresh(this.mutableStation.location);
	        }
	    };
	    StationDetailsEditController.prototype.getMessages = function (formValue) {
	        var errorsCopy = angular.copy(formValue.$error);
	        errorsCopy.$pending = formValue.$pending;
	        return errorsCopy;
	    };
	    Object.defineProperty(StationDetailsEditController.prototype, "form", {
	        get: function () {
	            return this.$scope['stationForm'] || null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationDetailsEditController.prototype.onMapClick = function (mouseEvent) {
	        var loc = mouseEvent.latLng;
	        this.marker.coords = {
	            latitude: loc.lat(),
	            longitude: loc.lng()
	        };
	        this.mutableStation.location = this.marker.coords;
	        this.preventMapRefresh = true;
	        this.$scope.$applyAsync();
	        this.notifyChange();
	    };
	    ;
	    StationDetailsEditController.prototype.notifyChange = function () {
	        if (this.onChange) {
	            this.onChange({ station: this.mutableStation, isValid: this.form.$valid });
	        }
	    };
	    StationDetailsEditController.$inject = ['$scope', '$state', 'uiGmapGoogleMapApi', 'stationApi', 'stationMapService'];
	    StationDetailsEditController.DEFAULT_DETAILS = {
	        code: '',
	        basin: '',
	        region: '',
	        name: '',
	        country: '',
	        location: station_map_service_1.default.DEFAULT_CENTER,
	        maxDischarge: null,
	        aggregations: null,
	        isVirtual: false
	    };
	    return StationDetailsEditController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationDetailsEditController;


/***/ },
/* 492 */
/***/ function(module, exports) {

	"use strict";
	var StationMapService = (function () {
	    function StationMapService(uiGmapGoogleMapApi, $timeout) {
	        this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
	        this.$timeout = $timeout;
	        this.map = {
	            center: StationMapService.DEFAULT_CENTER,
	            zoom: StationMapService.DEFAULT_ZOOM,
	            control: {},
	            options: {}
	        };
	    }
	    StationMapService.prototype.getMapOptions = function () {
	        return this.map;
	    };
	    StationMapService.prototype.loadGeoJson = function (geojsonUrl, mapInstance, googleMaps, fillOpacity) {
	        var _this = this;
	        var bounds = new googleMaps.LatLngBounds();
	        var map = mapInstance.control.getGMap();
	        map.data.addListener('addfeature', function (e) {
	            _this.processMapPolygonPoints(e.feature.getGeometry(), bounds.extend, bounds, googleMaps);
	            map.fitBounds(bounds);
	        });
	        map.data.loadGeoJson(geojsonUrl);
	        map.data.setStyle({
	            fillColor: '#3f51b5',
	            fillOpacity: fillOpacity,
	            strokeColor: '#283593',
	            strokeWeight: 3
	        });
	        return {
	            getCatchmentBounds: function () {
	                return bounds;
	            }
	        };
	    };
	    StationMapService.prototype.processMapPolygonPoints = function (geometry, callback, thisArg, map) {
	        var _this = this;
	        if (geometry instanceof map.LatLng) {
	            callback.call(thisArg, geometry);
	        }
	        else if (geometry instanceof map.Data.Point) {
	            callback.call(thisArg, geometry.get());
	        }
	        else {
	            geometry.getArray().forEach(function (g) {
	                _this.processMapPolygonPoints(g, callback, thisArg, map);
	            });
	        }
	    };
	    StationMapService.prototype.setOverlay = function (bounds, srcImage, map) {
	        this.uiGmapGoogleMapApi
	            .then(function (maps) {
	            // This example creates a custom overlay called USGSOverlay, containing
	            // a U.S. Geological Survey (USGS) image of the relevant area on the map.
	            // Set the custom overlay object's prototype to a new instance
	            // of OverlayView. In effect, this will subclass the overlay class therefore
	            // it's simpler to load the API synchronously, using
	            // google.maps.event.addDomListener().
	            // Note that we set the prototype to an instance, rather than the
	            // parent class itself, because we do not wish to modify the parent class.
	            USGSOverlay.prototype = new maps.OverlayView();
	            /** @constructor */
	            function USGSOverlay(bounds, image, map) {
	                // Initialize all properties.
	                this.bounds_ = bounds;
	                this.image_ = image;
	                this.map_ = map;
	                // Define a property to hold the image's div. We'll
	                // actually create this div upon receipt of the onAdd()
	                // method so we'll leave it null for now.
	                this.div_ = null;
	                // Explicitly call setMap on this overlay.
	                this.setMap(map);
	            }
	            /**
	             * onAdd is called when the map's panes are ready and the overlay has been
	             * added to the map.
	             */
	            USGSOverlay.prototype.onAdd = function () {
	                var div = document.createElement('div');
	                div.style.borderStyle = 'none';
	                div.style.borderWidth = '0px';
	                div.style.position = 'absolute';
	                // Create the img element and attach it to the div.
	                var img = document.createElement('img');
	                img.src = this.image_;
	                img.style.width = '100%';
	                img.style.height = '100%';
	                img.style.position = 'absolute';
	                div.appendChild(img);
	                this.div_ = div;
	                // Add the element to the "overlayLayer" pane.
	                var panes = this.getPanes();
	                panes.overlayLayer.appendChild(div);
	            };
	            USGSOverlay.prototype.draw = function () {
	                // We use the south-west and north-east
	                // coordinates of the overlay to peg it to the correct position and size.
	                // To do this, we need to retrieve the projection from the overlay.
	                var overlayProjection = this.getProjection();
	                // Retrieve the south-west and north-east coordinates of this overlay
	                // in LatLngs and convert them to pixel coordinates.
	                // We'll use these coordinates to resize the div.
	                var sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest());
	                var ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast());
	                // Resize the image's div to fit the indicated dimensions.
	                var div = this.div_;
	                div.style.left = sw.x + 'px';
	                div.style.top = ne.y + 'px';
	                div.style.width = (ne.x - sw.x) + 'px';
	                div.style.height = (sw.y - ne.y) + 'px';
	            };
	            // The onRemove() method will be called automatically from the API if
	            // we ever set the overlay's map property to 'null'.
	            USGSOverlay.prototype.onRemove = function () {
	                this.div_.parentNode.removeChild(this.div_);
	                this.div_ = null;
	            };
	            new USGSOverlay(bounds, srcImage, map.control.getGMap());
	        });
	    };
	    StationMapService.$inject = ['uiGmapGoogleMapApi', '$timeout'];
	    StationMapService.DEFAULT_CENTER = { latitude: 42.8746, longitude: 74.5698 };
	    StationMapService.DEFAULT_ZOOM = 10;
	    return StationMapService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationMapService;


/***/ },
/* 493 */
/***/ function(module, exports) {

	module.exports = "<div flex layout=row layout-padding> <md-card> <form name=stationForm layout=column> <section layout=row> <md-input-container flex> <label translate>LOCAL_CODE</label> <input name=stationCode unique-discharge-station-code initial-station-code={{::$ctrl.stationDetails.code}} is-virtual={{::$ctrl.stationDetails.isVirtual}} required ng-model=$ctrl.mutableStation.code ng-pattern=\"'[0-9]{5}'\" ng-change=$ctrl.notifyChange()> <div ng-messages=$ctrl.getMessages(stationForm.stationCode) md-auto-hide=false ng-show=stationForm.stationCode.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=pattern translate> INVALID_VALUE </div> <div ng-message=$pending class=pending-form-input translate> VERIFYING </div> <div ng-message=unique translate> CODE_IS_ALREADY_USED </div> </div> </md-input-container> <md-input-container> <label translate>NAME</label> <input name=stationName required ng-model=$ctrl.mutableStation.name ng-change=$ctrl.notifyChange() ng-maxlength=255> <div ng-messages=$ctrl.getMessages(stationForm.stationName) md-auto-hide=false ng-show=stationForm.stationName.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=maxlength translate> VALUE_IS_TOO_LONG </div> <div ng-message=$pending class=pending-form-input translate> VERIFYING </div> </div> </md-input-container> </section> <section layout=row> <md-input-container> <label translate>BASIN</label> <input name=basin required ng-model=$ctrl.mutableStation.basin ng-change=$ctrl.notifyChange() ng-maxlength=255> <div ng-messages=stationForm.basin.$error md-auto-hide=false ng-show=stationForm.basin.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=maxlength translate> VALUE_IS_TOO_LONG </div> </div> </md-input-container> <md-input-container> <label translate>REGION</label> <input name=region ng-model=$ctrl.mutableStation.region required ng-change=$ctrl.notifyChange() ng-maxlength=255> <div ng-messages=stationForm.region.$error md-auto-hide=false ng-show=stationForm.region.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=maxlength translate> VALUE_IS_TOO_LONG </div> </div> </md-input-container> </section> <md-input-container> <label translate>COUNTRY</label> <input name=country required ng-model=$ctrl.mutableStation.country ng-change=$ctrl.notifyChange() ng-maxlength=255> <div ng-messages=stationForm.country.$error md-auto-hide=false ng-show=stationForm.country.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=maxlength translate> VALUE_IS_TOO_LONG </div> </div> </md-input-container> <md-input-container> <label translate>MAXIMUM_DISCHARGE_LEVEL_M3_S</label> <input required type=number name=maxDischarge ng-model=$ctrl.mutableStation.maxDischarge step=0.01 ng-change=$ctrl.notifyChange() min=0> <div ng-messages=stationForm.maxDischarge.$error md-auto-hide=false ng-show=stationForm.maxDischarge.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=maxlength translate> VALUE_IS_TOO_LONG </div> </div> </md-input-container> <div layout=column> <label translate>LOCATION</label> <div layout=row> <md-input-container> <input class=md-input required type=number min=-85 max=85 placeholder=Latitude ng-change=$ctrl.onLocationInputFieldChange() ng-model=$ctrl.mutableStation.location.latitude> </md-input-container> <md-input-container> <input class=md-input required type=number min=-180 max=180 placeholder=Longitude ng-change=$ctrl.onLocationInputFieldChange() ng-model=$ctrl.mutableStation.location.longitude> </md-input-container> </div> </div> </form> </md-card> <div layout=column flex> <ui-gmap-google-map flex center=$ctrl.map.center zoom=$ctrl.map.zoom options=$ctrl.map.options events=$ctrl.map.events control=$ctrl.map.control class=edit-details-map layout=column> <ui-gmap-marker idkey=$ctrl.marker.id coords=$ctrl.marker.coords></ui-gmap-marker> </ui-gmap-google-map> </div> </div>";

/***/ },
/* 494 */
/***/ function(module, exports) {

	"use strict";
	var stationFormatterFactory = function () {
	    return function (station) { return station &&
	        station.siteCode + " - " + station.siteName; };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = stationFormatterFactory;


/***/ },
/* 495 */
/***/ function(module, exports) {

	"use strict";
	function uniqueStationCodeFactory(stationApi, $q, $mdDialog, $translate, imomoErrorService) {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function (scope, el, attrs, ngModel) {
	            ngModel.$asyncValidators.unique = function (stationCode) {
	                var initialCode = attrs['initialStationCode'];
	                var isVirtual = attrs['isVirtual'] === 'true';
	                var deferred = $q.defer();
	                if (stationCode == initialCode) {
	                    deferred.resolve();
	                }
	                else {
	                    stationApi.isDischargeStationCodeUnique(stationCode, isVirtual)
	                        .then(function (httpData) {
	                        if (httpData.available) {
	                            stationApi.isMeteoStationCodeUnique(stationCode)
	                                .then(function (httpData) {
	                                if (!httpData.available) {
	                                    var dialog = $mdDialog.alert()
	                                        .title($translate.instant('STATION_PAIR_NOTIFICATION', { stationCode: stationCode, stationType: 'Meteo' }))
	                                        .textContent($translate.instant('STATION_PAIR_NOTIFICATION_EXTENDED', { stationCode: stationCode, stationType: 'Meteo' }))
	                                        .ok($translate.instant('OK'));
	                                    $mdDialog.show(dialog);
	                                }
	                                deferred.resolve();
	                            });
	                            deferred.resolve();
	                        }
	                        else {
	                            imomoErrorService.showErrorDetailsDialog(httpData.message);
	                            deferred.reject();
	                        }
	                    }).catch(function (errData) {
	                        deferred.reject();
	                    });
	                }
	                return deferred.promise;
	            };
	        }
	    };
	}
	exports.uniqueStationCodeFactory = uniqueStationCodeFactory;
	uniqueStationCodeFactory.$inject = ['stationApi', '$q', '$mdDialog', '$translate', 'imomoErrorService'];


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var StationSelectorService = (function () {
	    function StationSelectorService($window, $log) {
	        this.$window = $window;
	        this.$log = $log;
	    }
	    StationSelectorService.prototype.getStoredStations = function (key, availableStations) {
	        var storedObject;
	        try {
	            storedObject = this.$window.localStorage
	                .getItem(StationSelectorService.STORAGE_KEY_PREFIX + "." + key);
	        }
	        catch (error) {
	            this.$log.error('Local storage is not available.', error);
	        }
	        if (!storedObject) {
	            return immutable_1.Set();
	        }
	        try {
	            var parsedObject = JSON.parse(storedObject);
	            if (parsedObject instanceof Array) {
	                var stationIds_1 = immutable_1.Set(parsedObject);
	                return availableStations.filter(function (station) {
	                    return stationIds_1.contains(station.id);
	                }).toSet();
	            }
	            else {
	                this.clearStoredList(key);
	                return immutable_1.Set();
	            }
	        }
	        catch (error) {
	            this.$log.error("Stored object in key " + key + " is not valid.", error);
	            this.clearStoredList(key);
	            return immutable_1.Set();
	        }
	    };
	    StationSelectorService.prototype.storeStations = function (key, stationList) {
	        try {
	            this.$window.localStorage
	                .setItem(StationSelectorService.STORAGE_KEY_PREFIX + "." + key, JSON.stringify(stationList.map(function (station) { return station.id; }).toArray()));
	        }
	        catch (error) {
	            this.$log.error('Could not store station list.');
	        }
	    };
	    StationSelectorService.prototype.clearStoredList = function (key) {
	        try {
	            this.$window.localStorage
	                .removeItem(StationSelectorService.STORAGE_KEY_PREFIX + "." + key);
	        }
	        catch (error) {
	            this.$log.error('Could not clear stored object.', error);
	        }
	    };
	    StationSelectorService.$inject = ['$window', '$log'];
	    StationSelectorService.STORAGE_KEY_PREFIX = 'imomo.stationStorage';
	    return StationSelectorService;
	}());
	exports.StationSelectorService = StationSelectorService;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationSelectorService;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var timeseries_controller_1 = __webpack_require__(498);
	var template = __webpack_require__(499);
	var timeseriesComponent = {
	    controller: timeseries_controller_1.TimeseriesController,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = timeseriesComponent;


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var _ = __webpack_require__(29);
	var TimeseriesController = (function () {
	    function TimeseriesController(dataValueApi, $stateParams, stationApi, $q, $log, $rootScope, timeseriesService) {
	        var _this = this;
	        this.dataValueApi = dataValueApi;
	        this.stationApi = stationApi;
	        this.$q = $q;
	        this.$log = $log;
	        this.$rootScope = $rootScope;
	        this.timeseriesService = timeseriesService;
	        this.stationId = Number.parseInt($stateParams.stationId);
	        this.startYear = moment().year();
	        this.endYear = moment().year();
	        this.loadingInProgress = true;
	        this.stationApi.getDischargeStation({ stationId: this.stationId })
	            .then(function (station) {
	            _this.station = station;
	            _this.$rootScope.$broadcast('STATION_LOADED', station);
	            return _this.loadTimeseries();
	        });
	    }
	    TimeseriesController.prototype.loadTimeseries = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.dischargeTimeseries = [];
	        var dischargePairPromises = _.range(this.startYear, this.endYear + 1)
	            .map(function (year) { return _this.dataValueApi.getYearDailyAverageData(_this.stationId, year, 'discharge'); });
	        this.$q.all(dischargePairPromises)
	            .then(function (dischargeSeries) {
	            _this.dischargeSeries = dischargeSeries;
	            var dischargeTimeseries = _this.dischargeSeries
	                .map(function (dischargeSeries, index) {
	                if (dischargeSeries.length == 0) {
	                    return null;
	                }
	                return averageDischargeToDischargeTimeseries(dischargeSeries, _this.startYear + index);
	            })
	                .filter(function (timeseries) { return timeseries; });
	            return _this.dataValueApi.getStationNorm(_this.stationId, 'discharge')
	                .then(function (dischargeNorm) {
	                dischargeTimeseries[dischargeTimeseries.length - 1].current = true;
	                dischargeTimeseries[dischargeTimeseries.length - 1].highlighted = true;
	                dischargeTimeseries.push(_this.timeseriesService.dischargeNormToDischargeTimeseries(dischargeNorm));
	                _this.dischargeTimeseries = dischargeTimeseries;
	                _this.loadingInProgress = false;
	            });
	        })
	            .catch(function (error) {
	            _this.$log.error('Error loading discharge data.', error);
	            _this.loadingInProgress = false;
	        });
	    };
	    TimeseriesController.$inject = ['dataValueApi', '$stateParams',
	        'stationApi', '$q', '$log', '$rootScope', 'timeseriesService'];
	    return TimeseriesController;
	}());
	exports.TimeseriesController = TimeseriesController;
	function averageDischargeToDischargeTimeseries(dischargeSeries, year) {
	    return {
	        data: dischargeSeries.map(function (avarageDischargeData) {
	            return {
	                hydrodata: avarageDischargeData.dataValue,
	                date: moment.unix(avarageDischargeData.localDateTime)
	            };
	        }),
	        label: "" + year
	    };
	}


/***/ },
/* 499 */
/***/ function(module, exports) {

	module.exports = "<div class=station-timeseries-container layout=column> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress> </md-progress-linear> <div layout=row class=station-timeseries-header-bar> <div layout=column> <span class=md-title translate> MEASURED_DISCHARGE_TIME_SERIES </span> <span class=md-subhead> {{ $ctrl.station | stationFormatter }} </span> </div> <div flex></div> <form name=$ctrl.yearForm layout=row> <md-input-container> <label translate> INITIAL_YEAR </label> <input name=startYear required max={{$ctrl.endYear}} ng-disabled=$ctrl.loadingInProgress type=number step=1 ng-model=$ctrl.startYear> </md-input-container> <md-input-container> <label translate> FINAL_YEAR </label> <input name=endYear required min={{$ctrl.startYear}} ng-disabled=$ctrl.loadingInProgress type=number step=1 ng-model=$ctrl.endYear> </md-input-container> <div> <md-button class=\"md-raised md-primary\" type=submit ng-disabled=\"$ctrl.yearForm.$invalid || $ctrl.loadingInProgress\" ng-click=$ctrl.loadTimeseries()> <span translate> LOAD_GRAPH </span> </md-button> </div> </form> </div> <md-divider></md-divider> <md-card layout=column flex> <hydromet-timeseries-new timeseries=$ctrl.dischargeTimeseries hydrodata-type=\"'discharge'\"></hydromet-timeseries-new> </md-card> </div>";

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var TimeseriesService = (function () {
	    function TimeseriesService($translate) {
	        this.$translate = $translate;
	    }
	    TimeseriesService.prototype.dischargeNormToDischargeTimeseries = function (dischargeNorm) {
	        return {
	            data: dischargeNorm.normData.map(function (datum, index) {
	                var month = Math.floor(index / 3);
	                var year = month >= 9 ? moment().year() - 1 : moment().year();
	                return {
	                    hydrodata: datum,
	                    date: moment()
	                        .year(year)
	                        .month(month)
	                        .date((index % 3) * 10 + 5)
	                        .startOf('day')
	                };
	            }).sort(function (datumA, datumB) {
	                if (datumA.date.isBefore(datumB.date)) {
	                    return -1;
	                }
	                else if (datumA.date.isAfter(datumB.date)) {
	                    return 1;
	                }
	                return 0;
	            }),
	            label: this.$translate.instant('HISTORICAL_NORM'),
	            highlighted: true
	        };
	    };
	    TimeseriesService.$inject = ['$translate'];
	    return TimeseriesService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = TimeseriesService;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var aggregationEdit_controller_1 = __webpack_require__(502);
	var template = __webpack_require__(503);
	var aggregationsEditComponent = {
	    bindings: {
	        stationDetails: '<',
	        onChange: '&'
	    },
	    controller: aggregationEdit_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = aggregationsEditComponent;


/***/ },
/* 502 */
/***/ function(module, exports) {

	"use strict";
	var StationCreatorAggregationsEditController = (function () {
	    function StationCreatorAggregationsEditController(stationApi, $scope) {
	        this.stationApi = stationApi;
	        this.$scope = $scope;
	        this.selectedStations = [];
	    }
	    StationCreatorAggregationsEditController.prototype.$onChanges = function () {
	        if (this.stationDetails &&
	            this.stationDetails.aggregations &&
	            this.stationDetails.aggregations.length) {
	            this.selectedStations = angular.copy(this.stationDetails.aggregations);
	        }
	    };
	    StationCreatorAggregationsEditController.prototype.queryStations = function () {
	        var _this = this;
	        return this.stationApi.getDischargeStations()
	            .then(function (stations) {
	            if (stations && stations.length) {
	                stations = _.filter(stations, function (station) {
	                    return !station.isVirtual;
	                });
	            }
	            return _this.filterStationsByText(_this.filterStationsBySelected(stations));
	        });
	    };
	    StationCreatorAggregationsEditController.prototype.onStationSelected = function (station) {
	        var _this = this;
	        if (station) {
	            this.selectedStations.push({
	                id: station.id,
	                siteName: station.siteName,
	                siteCode: station.siteCode,
	                weighting: 100
	            });
	            this.form.$setSubmitted();
	            this.$scope.$applyAsync(function () {
	                _this.notifyChange();
	            });
	        }
	        this.searchText = null;
	    };
	    StationCreatorAggregationsEditController.prototype.onWeightingFieldChange = function ($event) {
	        this.notifyChange();
	    };
	    StationCreatorAggregationsEditController.prototype.unselectStation = function (station) {
	        this.selectedStations.splice(this.selectedStations.indexOf(station), 1);
	        this.notifyChange();
	    };
	    StationCreatorAggregationsEditController.prototype.filterStationsBySelected = function (fetchedStations) {
	        var _this = this;
	        return _.filter(fetchedStations, function (station) {
	            var isItemSelected;
	            _this.selectedStations.forEach(function (selectedStation) {
	                if (!isItemSelected) {
	                    isItemSelected = station.id === selectedStation.id;
	                }
	            });
	            return !isItemSelected;
	        });
	    };
	    StationCreatorAggregationsEditController.prototype.filterStationsByText = function (stations) {
	        var _this = this;
	        if (this.searchText) {
	            return _.filter(stations, function (station) {
	                return station.siteName.toLowerCase().indexOf(_this.searchText.toLowerCase()) !== -1 ||
	                    station.siteCode.indexOf(_this.searchText) !== -1;
	            });
	        }
	        else {
	            return stations;
	        }
	    };
	    Object.defineProperty(StationCreatorAggregationsEditController.prototype, "form", {
	        get: function () {
	            return this.$scope['aggregationsForm'] || null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationCreatorAggregationsEditController.prototype.notifyChange = function () {
	        if (this.onChange) {
	            var isValid = this.form.$valid && Boolean(this.selectedStations.length);
	            this.onChange({ selectedStations: this.selectedStations, isValid: isValid });
	        }
	    };
	    StationCreatorAggregationsEditController.$inject = ['stationApi', '$scope'];
	    return StationCreatorAggregationsEditController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationCreatorAggregationsEditController;


/***/ },
/* 503 */
/***/ function(module, exports) {

	module.exports = "<div flex layout=row layout-padding> <md-card style=width:400px> <h3 translate>STATION_LIST</h3> <md-autocomplete id=stationSearch md-no-cache=true md-search-text=$ctrl.searchText md-items=\"station in $ctrl.queryStations($ctrl.searchText)\" md-selected-item-change=$ctrl.onStationSelected(station) md-item-text=station.siteName md-min-length=0 placeholder=\"{{'SEARCH_STATIONS_PLACEHOLDER' | translate}}\" md-autofocus=true> <md-item-template> <strong md-highlight-text=$ctrl.searchText md-highlight-flags=^i style=white-space:nowrap>{{station.siteCode}} - </strong> <span md-highlight-text=$ctrl.searchText md-highlight-flags=^i> {{station.siteName}}</span> </md-item-template> <md-not-found> <span translate>NO_STATIONS</span> </md-not-found> </md-autocomplete> <br> <md-content flex class=md-whiteframe-2dp layout=column layout-padding> <md-list> <md-list-item ng-repeat=\"station in $ctrl.selectedStations | orderBy: 'siteName'\"> <strong style=white-space:nowrap>{{station.siteCode}} - </strong><span> {{station.siteName}}</span> <span flex></span> <md-button class=md-icon-button ng-click=$ctrl.unselectStation(station)> <md-icon>clear</md-icon> </md-button> </md-list-item> </md-list> </md-content> </md-card> <md-card flex layout-padding style=overflow:auto> <h3 translate>Aggregations</h3> <form name=aggregationsForm> <md-list> <md-list-item ng-repeat=\"station in $ctrl.selectedStations | orderBy: 'siteName'\" flex layout-align=\"space-between center\" style=\"padding-top:20px;border-bottom:1px solid #ddd\"> <div style=\"padding:0 0 20px\"> <md-icon>location_on</md-icon><strong>{{station.siteCode}} - </strong><span>{{station.siteName}}</span> </div> <span flex></span> <md-input-container> <label><span translate>WEIGHTING</span> (%)</label> <input name=\"{{'station' + station.id}}\" required ng-model=station.weighting type=number min=0 ng-change=$ctrl.onWeightingFieldChange($event)> <div ng-messages=\"aggregationsForm['station' + station.id].$error\" ng-show=\"aggregationsForm['station' + station.id].$touched\"> <div ng-message=required translate> THIS_FIELD_IS_REQUIRED </div> </div> </md-input-container> </md-list-item> </md-list> </form> </md-card> </div>";

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var forecast_model_controller_1 = __webpack_require__(505);
	__webpack_require__(508);
	var template = __webpack_require__(509);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: forecast_model_controller_1.default,
	    template: template
	};


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var prediction_date_dialog_controller_1 = __webpack_require__(506);
	var predictionDateDialogTemplate = __webpack_require__(507);
	var StationForecastingController = (function () {
	    // private featureDataQmSearchText: string;
	    // private featureDataPmSearchText: string;
	    // private featureDataTmSearchText: string;
	    // private featureDataSmSearchText: string;
	    function StationForecastingController(stationApi, stationSelectorService, forecastingService, $filter, $stateParams, organizationApi, $window, imomoErrorService, $mdDialog, $translate, $q, $state, $timeout, $rootScope) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.stationSelectorService = stationSelectorService;
	        this.forecastingService = forecastingService;
	        this.$stateParams = $stateParams;
	        this.organizationApi = organizationApi;
	        this.$window = $window;
	        this.imomoErrorService = imomoErrorService;
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.$q = $q;
	        this.$state = $state;
	        this.$timeout = $timeout;
	        this.$rootScope = $rootScope;
	        this.forecastModels = [];
	        this.isForecastTypeDataExpanded = false;
	        this.filter = $filter('filter');
	        this.forecastMethodParams = null;
	        this.stationId = Number.parseInt($stateParams.stationId);
	        var currentOrgId = Number.parseInt(this.$window.localStorage.getItem('currentOrgId'));
	        this.isLoading = true;
	        this.$q.all([
	            this.organizationApi.getForecastTypes(currentOrgId),
	            this.stationApi.getForecastModels(this.stationId),
	            this.stationApi.getDischargeStation({ stationId: this.stationId })
	        ]).then(function (_a) {
	            var forecastTypes = _a[0], forecastModels = _a[1], station = _a[2];
	            _this.forecastTypes = forecastTypes;
	            _this.forecastModels = forecastModels;
	            _this.station = station;
	            _this.forecastMethods = _this.forecastingService.getForecastModelMethods();
	            _this.forecastModelParams = _this.forecastingService.getForecastModelParameters();
	            _this.$rootScope.$broadcast('STATION_LOADED', station);
	            if (_this.forecastModels && _this.forecastModels.length) {
	                _this.selectedForecastModel = _this.forecastModels[0];
	                _this.onMethodChange();
	                _this.onForecastTypeChange();
	            }
	        })
	            .finally(function () {
	            _this.isLoading = false;
	        });
	    }
	    StationForecastingController.prototype.addToForecastModelList = function () {
	        var _this = this;
	        var isNameDuplicate;
	        var defaultDataInput = {
	            siteId: this.station.id,
	            siteName: this.station.siteName,
	            siteType: this.station.siteType,
	            siteCode: this.station.siteCode,
	            dataValueTypes: [
	                {
	                    type: 'discharge',
	                    laglength: 1
	                }]
	        };
	        var defaultForecastModel = {
	            name: this.newForecastModelName,
	            forecastTypeId: undefined,
	            method: undefined,
	            dataInputs: [defaultDataInput],
	            methodParameters: {
	                fit_intercept: undefined,
	                alpha: undefined,
	                n_estimators: undefined,
	                random_state: undefined
	            },
	            modelParameters: {
	                multimodel: undefined,
	                earliestMonth: undefined,
	                nModel: undefined,
	                maxFeatures: undefined
	            }
	        };
	        this.forecastModels.forEach(function (model) {
	            if (model.name === _this.newForecastModelName) {
	                isNameDuplicate = true;
	            }
	        });
	        if (!isNameDuplicate) {
	            this.forecastModels.push(defaultForecastModel);
	            this.selectedForecastModel = this.forecastModels[this.forecastModels.length - 1];
	            this.newForecastModelName = null;
	            this.isNew = true;
	        }
	        this.selectedForecastType = null;
	    };
	    StationForecastingController.prototype.removeForecastModel = function (forecastModelIndex) {
	        var _this = this;
	        var self = this;
	        if (!forecastModelIndex) {
	            forecastModelIndex = this.forecastModels.indexOf(this.selectedForecastModel);
	        }
	        var confirm = this.$mdDialog.confirm()
	            .title(this.$translate.instant('DELETE_FORECAST_MODEL'))
	            .textContent(this.$translate.instant('DELETE_CONFIRMATION', { item: this.forecastModels[forecastModelIndex].name }))
	            .ok(this.$translate.instant('DELETE'))
	            .cancel(this.$translate.instant('CANCEL'));
	        this.$mdDialog.show(confirm).then(function () {
	            if (_this.forecastModels[forecastModelIndex].id) {
	                _this.stationApi.deleteForecastModel(_this.stationId, _this.forecastModels[forecastModelIndex].id)
	                    .then(function () {
	                    removeModelFromList();
	                })
	                    .finally(function () {
	                    _this.isEditable = false;
	                    _this.isNew = false;
	                });
	            }
	            else {
	                removeModelFromList();
	                _this.isEditable = false;
	                _this.isNew = false;
	            }
	        });
	        function removeModelFromList() {
	            self.forecastModels.splice(forecastModelIndex, 1);
	            if (self.forecastModels.length) {
	                self.selectedForecastModel = self.forecastModels[self.forecastModels.length - 1];
	            }
	            else {
	                self.selectedForecastModel = null;
	            }
	        }
	    };
	    StationForecastingController.prototype.onForecastModelRadioChange = function () {
	        this.isNew = false;
	        this.onForecastTypeChange();
	    };
	    StationForecastingController.prototype.onSelectedStationsChange = function (stations) {
	        if (this.selectedForecastModel) {
	            this.selectedForecastModel.dataInputs = stations.toArray();
	        }
	    };
	    StationForecastingController.prototype.onHighlightedStationChange = function (station) {
	        //console.log(station);
	    };
	    StationForecastingController.prototype.onForecastTypeChange = function () {
	        var _this = this;
	        // let params:any = {};
	        if (this.selectedForecastModel &&
	            this.forecastTypes &&
	            this.forecastModelParams) {
	            this.selectedForecastType = _.filter(this.forecastTypes, function (forecastType) {
	                return _this.selectedForecastModel.forecastTypeId == forecastType.id;
	            })[0];
	            var forecastTypeFrequency = this.selectedForecastType.frequency;
	            this.selectedForecastModelFrequency = forecastTypeFrequency;
	            this.currentForecastModelParams =
	                this.forecastModelParams[forecastTypeFrequency].params;
	            if (!this.selectedForecastModel.id) {
	                this.isNew = true;
	            }
	            this.refreshTrainingInfo();
	        }
	        // this.currentForecastModelParams.forEach((param) => {
	        //   params[param.name] = param.default;
	        // });
	        // this.selectedForecastModel.parameters = params
	    };
	    StationForecastingController.prototype.onMethodChange = function () {
	        this.selectedForecastModel.methodParameters = {
	            fit_intercept: undefined,
	            alpha: undefined,
	            n_estimators: undefined,
	            random_state: undefined
	        };
	        this.forecastMethodParams =
	            this.forecastingService.getForecastModelMethodParameters(this.selectedForecastModel.method)[0];
	    };
	    StationForecastingController.prototype.onTrainModelClick = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.stationApi.trainForecastModel(this.stationId, this.selectedForecastModel.id)
	            .then(function (forecastModel) {
	            _this.selectedForecastModel.training = forecastModel.training;
	            _this.selectedForecastModelCached.training = forecastModel.training;
	            _this.refreshTrainingInfo();
	            _this.isLoading = false;
	        })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	            _this.isLoading = false;
	        });
	    };
	    StationForecastingController.prototype.onCancelModelTrainingClick = function () {
	        var _this = this;
	        var confirm = this.$mdDialog.confirm()
	            .title(this.$translate.instant('CANCEL_MODEL_TRAINING'))
	            .textContent(this.$translate.instant('CANCEL_MODEL_TRAINING_CONFIRMATION'))
	            .ok(this.$translate.instant('YES'))
	            .cancel(this.$translate.instant('NO'));
	        this.$mdDialog.show(confirm).then(function () {
	            _this.isLoading = true;
	            _this.stationApi.cancelForecastModelTraining(_this.stationId, _this.selectedForecastModel.id)
	                .then(function (forecastModel) {
	                _this.selectedForecastModel.training = forecastModel.training;
	                _this.selectedForecastModelCached.training = forecastModel.training;
	                _this.isLoading = false;
	            })
	                .catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                _this.isLoading = false;
	            });
	        });
	    };
	    StationForecastingController.prototype.onSubmitModelClick = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.selectedForecastModel.dataInputs = this.formatDataInputs();
	        this.stationApi.saveForecastModel(this.stationId, this.selectedForecastModel)
	            .then(function (forecastModel) {
	            _this.selectedForecastModel.id = forecastModel.id;
	            _this.forecastModels = _this.forecastModels.map(function (model) {
	                if (model.id === forecastModel.id) {
	                    return forecastModel;
	                }
	                return model;
	            });
	            _this.isLoading = false;
	            _this.isNew = false;
	            _this.isEditable = false;
	        })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	            _this.isLoading = false;
	        });
	    };
	    StationForecastingController.prototype.formatDataInputs = function () {
	        var _this = this;
	        return _.map(this.selectedForecastModel.dataInputs, function (dataInput) {
	            var formattedDataInput = {
	                siteId: dataInput.id || dataInput.siteId,
	                siteName: dataInput.siteName,
	                siteType: dataInput.siteType,
	                siteCode: dataInput.siteCode,
	                dataValueTypes: _.map(dataInput.dataValueTypes, function (dataValueType) {
	                    if (_this.selectedForecastModelFrequency === 'seasonal') {
	                        delete dataValueType.laglength;
	                        return dataValueType;
	                    }
	                    return dataValueType;
	                })
	            };
	            return formattedDataInput;
	        });
	    };
	    StationForecastingController.prototype.onEditClicked = function ($event) {
	        this.isEditable = true;
	        this.selectedForecastModelCached = angular.copy(this.selectedForecastModel);
	        this.forecastModels = angular.copy(this.forecastModels);
	    };
	    StationForecastingController.prototype.onCancelClick = function ($event) {
	        this.isEditable = false;
	        this.selectedForecastModel = this.selectedForecastModelCached;
	    };
	    StationForecastingController.prototype.refreshTrainingInfo = function () {
	        var _this = this;
	        this.stationApi.getForecastModel(this.stationId, this.selectedForecastModel.id)
	            .then(function (forecastModel) {
	            _this.selectedForecastModel.training = forecastModel.training;
	            if (!_this.selectedForecastModel.training.reportPdfUrl && _this.selectedForecastModel.training.status !== 'error') {
	                _this.$timeout(function () {
	                    _this.refreshTrainingInfo();
	                }, 500);
	            }
	        });
	    };
	    StationForecastingController.prototype.onGeneratePredictionClick = function ($event) {
	        var _this = this;
	        this.$mdDialog.show({
	            targetEvent: $event,
	            template: predictionDateDialogTemplate,
	            controller: prediction_date_dialog_controller_1.PredictionDateDialog,
	            bindToController: true,
	            controllerAs: '$ctrl',
	        })
	            .then(function (predictionDate) {
	            _this.isLoading = true;
	            _this.stationApi.makeForecastPrediction(_this.stationId, _this.selectedForecastModel.id, predictionDate)
	                .then(function () {
	                _this.isLoading = false;
	                _this.$state.go('forecasting');
	            })
	                .catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                _this.isLoading = false;
	            });
	        });
	    };
	    StationForecastingController.$inject = ['stationApi', 'stationSelectorService', 'forecastingService', '$filter',
	        '$stateParams', 'organizationApi', '$window', 'imomoErrorService', '$mdDialog', '$translate', '$q', '$state', '$timeout', '$rootScope'];
	    return StationForecastingController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationForecastingController;


/***/ },
/* 506 */
/***/ function(module, exports) {

	"use strict";
	var PredictionDateDialog = (function () {
	    function PredictionDateDialog($mdDialog) {
	        var _this = this;
	        this.$mdDialog = $mdDialog;
	        this.apply = function () {
	            _this.$mdDialog.hide(_this.predictionDate);
	        };
	        this.cancel = function () {
	            _this.$mdDialog.cancel();
	        };
	        this.predictionDate = new Date();
	    }
	    PredictionDateDialog.$inject = ['$mdDialog'];
	    return PredictionDateDialog;
	}());
	exports.PredictionDateDialog = PredictionDateDialog;


/***/ },
/* 507 */
/***/ function(module, exports) {

	module.exports = "<md-dialog> <div layout-padding> <h2 class=md-title> <span translate>PREDICTION_DATE</span> </h2> <md-datepicker ng-model=$ctrl.predictionDate required></md-datepicker> </div> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply()> <span translate>OK</span> </md-button> </md-dialog-actions> </md-dialog>";

/***/ },
/* 508 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 509 */
/***/ function(module, exports) {

	module.exports = "<section layout=row> <md-progress-linear md-mode=indeterminate ng-disabled=!$ctrl.isLoading> </md-progress-linear> </section> <section layout=row class=forecast-models-container layout-padding> <md-card class=forecast-model-selector-card> <md-card-title class=forecast-model-selector-title> <md-card-title-text> <span class=md-title translate> FORECAST_MODEL_LIST </span> </md-card-title-text> </md-card-title> <md-card-content class=forecast-model-selector-content> <form name=forecastModelForm layout=row class=forecast-model-selector-form> <md-input-container flex> <input type=text name=ForecastModelName required ng-model=$ctrl.newForecastModelName ng-disabled=\"$ctrl.isEditable || $ctrl.isNew\"> </md-input-container> <md-button type=submit class=\"md-icon-button md-primary md-raised\" ng-disabled=\"forecastModelForm.$invalid || $ctrl.isEditable || $ctrl.isNew\" ng-click=$ctrl.addToForecastModelList() style=top:10px> <md-icon class=material-icons>add</md-icon> </md-button> </form> <md-content flex class=md-whiteframe-2dp layout=column ng-if=$ctrl.forecastModels.length> <md-radio-group ng-model=$ctrl.selectedForecastModel ng-change=$ctrl.onForecastModelRadioChange() ng-disabled=\"$ctrl.isEditable || $ctrl.isNew\"> <md-list flex class=forecast-model-selector-list> <md-list-item ng-repeat=\"forecastModel in $ctrl.forecastModels | orderBy: name\"> <md-radio-button ng-value=forecastModel style=top:10px aria-label=\"{{ forecastModel.name }}\"> </md-radio-button> <div class=md-list-item-text> <h3>{{ forecastModel.name }}</h3> </div> <md-icon class=\"material-icons md-secondary md-warn\" ng-click=$ctrl.removeForecastModel($index) ng-disabled=\"$ctrl.isEditable || $ctrl.isNew\"> cancel </md-icon> </md-list-item> </md-list> </md-radio-group> </md-content> <md-content flex class=md-whiteframe-2dp layout=column ng-if=!$ctrl.forecastModels.length layout-padding layout-align=\"center center\"> <span translate>NO_FORECAST_MODELS</span> </md-content> </md-card-content> </md-card> <md-card flex layout-padding ng-if=$ctrl.selectedForecastModel> <div layout=row layout-align=\"space-between center\" style=padding:0> <md-input-container flex style=margin-bottom:0> <input type=text name=ForecastModelName required class=md-title ng-disabled=\"!$ctrl.isEditable && !$ctrl.isNew\" ng-model=$ctrl.selectedForecastModel.name> </md-input-container> <md-button class=md-icon-button ng-click=$ctrl.onEditClicked($event); ng-if=\"$ctrl.selectedForecastModel.id && !$ctrl.isEditable\"> <md-icon>edit</md-icon> <md-tooltip md-direction=down> <span translate>EDIT_FORECAST_MODEL</span> </md-tooltip> </md-button> <md-button class=md-raised ng-click=$ctrl.onCancelClick($event) ng-if=\"$ctrl.isEditable && !$ctrl.isNew\"> <span translate>CANCEL</span> </md-button> </div> <div layout=row> <md-checkbox ng-model=$ctrl.selectedForecastModel.autoAccept ng-disabled=\"!$ctrl.selectedForecastModel || $ctrl.isLoading || (!$ctrl.isEditable && !$ctrl.isNew)\"> <span translate>AUTOMATICALLY_ACCEPT_FORECAST_VALUES</span> </md-checkbox> </div> <div layout=row layout-wrap style=overflow-y:auto> <div layout-padding> <span class=md-title translate>FORECAST_PARAMETERS</span> <form name=forcastParametersForm> <md-input-container layout=row> <label translate>FORECAST_TYPE</label> <md-select required ng-model=$ctrl.selectedForecastModel.forecastTypeId ng-disabled=\"!$ctrl.selectedForecastModel || (!$ctrl.isNew && !$ctrl.isEditable) || $ctrl.selectedForecastModel.id\" ng-change=$ctrl.onForecastTypeChange()> <md-option ng-repeat=\"forecastType in $ctrl.forecastTypes\" value={{forecastType.id}}>{{forecastType.name}} </md-option> </md-select> </md-input-container> <sup ng-if=!$ctrl.forecastTypes.length translate>NO_FORECAST_TYPES</sup> <div ng-if=$ctrl.selectedForecastType> <div layout=row layout-align=\"space-between center\"> <h5 translate>FORECAST_TYPE_DETAILS</h5> <md-button class=md-icon-button ng-if=!$ctrl.isForecastTypeDataExpanded ng-click=\"$ctrl.isForecastTypeDataExpanded = true\"> <md-icon>expand_more</md-icon> </md-button> <md-button class=md-icon-button ng-if=$ctrl.isForecastTypeDataExpanded ng-click=\"$ctrl.isForecastTypeDataExpanded = false\"> <md-icon>expand_less</md-icon> </md-button> </div> <md-list ng-show=$ctrl.isForecastTypeDataExpanded class=forecast-type-details> <md-list-item ng-if=$ctrl.selectedForecastType.issueDate> <span translate>ISSUE_DATE</span>: {{ $ctrl.selectedForecastType.issueDate | momentFormatter:'date' }} </md-list-item> <md-list-item ng-if=\"$ctrl.selectedForecastType.issueDateOffset || $ctrl.selectedForecastType.issueDateOffset === 0\"> <span ng-if=\"$ctrl.selectedForecastType.frequency === 'pentadal'\">{{ 'PENTAD_FORECAST_DETAILS' | translate:{ lag: $ctrl.selectedForecastType.issueDateOffset } }}</span> <span ng-if=\"$ctrl.selectedForecastType.frequency === 'decade'\">{{ 'DECADAL_FORECAST_DETAILS' | translate:{ lag: $ctrl.selectedForecastType.issueDateOffset } }}</span> <span ng-if=\"$ctrl.selectedForecastType.frequency === 'monthly'\">{{ 'MONTHLY_FORECAST_DETAILS' | translate:{ lag: $ctrl.selectedForecastType.issueDateOffset } }}</span> <span ng-if=\"$ctrl.selectedForecastType.frequency === 'seasonal'\"> <span translate>ISSUE_DATE_OFFSET</span>: {{ $ctrl.selectedForecastType.issueDateOffset }} </span> </md-list-item> <md-list-item ng-if=$ctrl.selectedForecastType.targetPeriodStart> <span translate>TARGET_PERIOD_START</span>: {{ $ctrl.selectedForecastType.targetPeriodStart | momentFormatter:'date' }} </md-list-item> <md-list-item ng-if=$ctrl.selectedForecastType.targetPeriodEnd> <span translate>TARGET_PERIOD_END</span>: {{ $ctrl.selectedForecastType.targetPeriodEnd | momentFormatter:'date' }} </md-list-item> </md-list> </div> <md-divider layout-padding ng-if=$ctrl.selectedForecastType></md-divider> <div layout=row> <md-input-container> <label translate>METHOD</label> <md-select ng-model=$ctrl.selectedForecastModel.method ng-disabled=\"!$ctrl.selectedForecastModel || (!$ctrl.isNew && !$ctrl.isEditable)\" ng-change=$ctrl.onMethodChange() required> <md-option ng-repeat=\"method in $ctrl.forecastMethods\" ng-value=method>{{method}}</md-option> </md-select> </md-input-container> </div> <div ng-if=\"$ctrl.selectedForecastModel.method && $ctrl.forecastMethodParams\"> <h5 translate>METHOD_PARAMETERS</h5> <div layout=row> <div ng-if=\"$ctrl.forecastMethodParams.name === 'LinearRegression'\"> <md-input-container> <md-checkbox ng-model=$ctrl.selectedForecastModel.methodParameters.fit_intercept ng-disabled=\"!$ctrl.isNew && !$ctrl.isEditable\"> fitIntercept </md-checkbox> </md-input-container> </div> <div ng-if=\"$ctrl.forecastMethodParams.name === 'Lasso'\"> <md-input-container> <label>alpha</label> <input type=number min=0 max=1 step=0.1 ng-model=$ctrl.selectedForecastModel.methodParameters.alpha ng-disabled=\"!$ctrl.isNew && !$ctrl.isEditable\"> </md-input-container> </div> <div ng-if=\"$ctrl.forecastMethodParams.name === 'ExtraTreesRegressor'\"> <md-input-container> <label>nEstimators</label> <input type=number min=1 max=40 ng-model=$ctrl.selectedForecastModel.methodParameters.n_estimators ng-disabled=\"!$ctrl.isNew && !$ctrl.isEditable\"> </md-input-container> <md-input-container> <label>randomState</label> <input type=number min=1 max=9 ng-model=$ctrl.selectedForecastModel.methodParameters.random_state ng-disabled=\"!$ctrl.isNew && !$ctrl.isEditable\"> </md-input-container> </div> </div> </div> <h5 translate>MODEL_PARAMETERS</h5> <div ng-repeat=\"param in $ctrl.currentForecastModelParams\"> <div ng-if=\"param.type === 'boolean'\" layout=row> <md-checkbox ng-model=$ctrl.selectedForecastModel.modelParameters[param.modelName] ng-disabled=\"!$ctrl.isEditable && !$ctrl.isNew\" class=md-primary>{{param.label}} </md-checkbox> </div> <div ng-if=\"param.type === 'number'\" layout=row> <md-input-container> <label>{{ param.label }}</label> <input type={{param.type}} min={{param.min}} max={{param.max}} ng-model=$ctrl.selectedForecastModel.modelParameters[param.modelName] ng-disabled=\"!$ctrl.isEditable && !$ctrl.isNew\"> </md-input-container> </div> </div> </form> </div> <div layout-padding> <span class=md-title translate>DATASETS_USED</span> <imomo-station-selector is-elevated=false is-disabled=\"!$ctrl.selectedForecastModel || $ctrl.isLoading || (!$ctrl.isEditable && !$ctrl.isNew)\" is-selectable=false is-data-type-selecting-enabled=true is-with-meteostations=true is-list-cached=false highlighted-station-id=$ctrl.highlightedStation.id on-station-highlight-change=$ctrl.onHighlightedStationChange(station) on-select-change=$ctrl.onSelectedStationsChange(selectedStations) stations=$ctrl.selectedForecastModel.dataInputs forecast-model-frequency=$ctrl.selectedForecastModelFrequency> </imomo-station-selector> </div> <div ng-if=$ctrl.selectedForecastModel.training layout-padding> <span class=md-title translate>TRAINING_INFO</span> <md-list> <md-list-item> <strong><span translate>STATUS</span>:</strong>&nbsp;<span> {{$ctrl.selectedForecastModel.training.statusMessage}}</span> </md-list-item> <md-list-item> <strong><span translate>COMPLETION</span>:</strong>&nbsp;<span> {{($ctrl.selectedForecastModel.training.completion * 100 | hydroNumberFormatter) }}%</span> </md-list-item> <md-list-item> <strong><span translate>STARTED</span>:</strong>&nbsp;<span> {{$ctrl.selectedForecastModel.training.started | momentFormatter:'overriddenDate-time'}}</span> </md-list-item> <md-list-item> <strong><span translate>LAST_MODIFIED</span>:</strong>&nbsp;<span> {{$ctrl.selectedForecastModel.training.lastModified | momentFormatter:'overriddenDate-time'}}</span> </md-list-item> </md-list> <div layout=row layout-align=\"space-between center\"> <a class=\"md-button md-raised md-primary\" ng-href={{$ctrl.selectedForecastModel.training.reportPdfUrl}} ng-disabled=!$ctrl.selectedForecastModel.training.reportPdfUrl download> <span translate>PDF_REPORT</span> </a> </div> <div layout=row layout-align=\"space-between center\"> <a class=\"md-button md-raised md-primary\" ng-href={{$ctrl.selectedForecastModel.training.reportXlsxUrl}} ng-disabled=!$ctrl.selectedForecastModel.training.reportXlsxUrl download> <span translate>Xlsx_REPORT</span> </a> </div> <div> <md-button ng-if=$ctrl.selectedForecastModel.training.completion ng-click=$ctrl.onGeneratePredictionClick($event) class=\"md-raised md-primary\"> <span translate>GENERATE_PREDICTION_MANUALLY</span> </md-button> </div> </div> </div> <section layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-warn\" ng-click=$ctrl.removeForecastModel() ng-disabled=\"!$ctrl.isNew && !$ctrl.isEditable\"> <span translate>DELETE</span> </md-button> <md-button class=\"md-raised md-primary\" ng-click=$ctrl.onSubmitModelClick() ng-disabled=\"!$ctrl.isNew && !$ctrl.isEditable\"> <span translate>SAVE</span> </md-button> <md-button class=\"md-raised md-warn\" ng-click=$ctrl.onCancelModelTrainingClick() ng-disabled=\"!$ctrl.selectedForecastModel.id && $ctrl.selectedForecastModel.id !== 0 || \n      !$ctrl.isNew && !$ctrl.isEditable || \n      $ctrl.selectedForecastModel.training.completion === 1 ||\n      $ctrl.selectedForecastModel.training.status === 'canceled' ||\n      $ctrl.selectedForecastModel.training.status === 'error' ||\n      !$ctrl.selectedForecastModel.training\"> <span translate>CANCEL_MODEL_TRAINING</span> </md-button> <md-button class=\"md-raised md-primary\" ng-click=$ctrl.onTrainModelClick() ng-disabled=\"!$ctrl.selectedForecastModel.id && $ctrl.selectedForecastModel.id !== 0 || !$ctrl.isNew && !$ctrl.isEditable\"> <span translate>TRAIN_AND_ASSESS_MODEL</span> </md-button> </section> </md-card> </section>";

/***/ },
/* 510 */
/***/ function(module, exports) {

	"use strict";
	var ForecastingService = (function () {
	    function ForecastingService($filter, stationApi) {
	        this.stationApi = stationApi;
	        this.forecastModelMethods = ['LinearRegression', 'Lasso', 'ExtraTreesRegressor'];
	        this.forecastModelMethod = {
	            modelName: 'method',
	            label: 'Method',
	            type: 'select',
	            options: [
	                {
	                    name: 'LinearRegression',
	                    params: [
	                        {
	                            name: 'fit_intercept',
	                            type: 'boolean'
	                        }
	                    ]
	                },
	                {
	                    name: 'Lasso',
	                    params: [
	                        {
	                            name: 'alpha',
	                            type: 'float',
	                            min: 0,
	                            max: 1
	                        }
	                    ]
	                },
	                {
	                    name: 'ExtraTreesRegressor',
	                    params: [
	                        {
	                            name: 'n_estimators',
	                            type: 'number',
	                            min: 1,
	                            max: 40
	                        },
	                        {
	                            name: 'random_state',
	                            type: 'number',
	                            min: 1,
	                            max: 9
	                        }
	                    ]
	                }
	            ]
	        };
	        this.nonSeasonalParams = [
	            // {
	            //   modelName: 'featureData',
	            //   label: 'Feature data', 
	            //   type: 'multi-select', 
	            //   options: ['discharge', 'precipitation', 'temperature', 'snow data']
	            // },
	            // {
	            //   modelName: 'featureTimelag',
	            //   label: 'Feature timelag',
	            //   type: 'number',
	            //   min: 1,
	            //   max: 10,
	            //   default: 1
	            // },
	            {
	                modelName: 'multimodel',
	                label: 'multimodel',
	                type: 'boolean',
	                default: false
	            }
	        ];
	        this.forecastModelParams = {
	            'pentadal': {
	                params: this.nonSeasonalParams
	            },
	            'decade': {
	                params: this.nonSeasonalParams
	            },
	            'monthly': {
	                params: this.nonSeasonalParams
	            },
	            'seasonal': {
	                params: [
	                    // {
	                    //   modelName: 'ensembleSize',
	                    //   label: 'Ensemble size',
	                    //   type: 'number',
	                    //   min: 1,
	                    //   max: 1000,
	                    //   default: 20
	                    // },
	                    // {
	                    //   modelName: 'featureLimit',
	                    //   label: 'Feature limit per model',
	                    //   type: 'number',
	                    //   min: 1,
	                    //   max: 4,
	                    //   default: 2
	                    // },
	                    // {
	                    //   modelName: 'featureData',
	                    //   label: 'Feature data',
	                    //   subparams: ['Qm','Pm', 'Tm', 'Sm']
	                    // }
	                    {
	                        modelName: 'earliestMonth',
	                        label: 'Earliest month',
	                        type: 'number',
	                        min: 1,
	                        max: 12,
	                        default: 1
	                    },
	                    {
	                        modelName: 'nModel',
	                        label: 'nModel',
	                        type: 'number',
	                        min: 1,
	                        max: 100,
	                        default: 1
	                    },
	                    {
	                        modelName: 'maxFeatures',
	                        label: 'maxFeatures',
	                        type: 'number',
	                        min: 1,
	                        max: 4,
	                        default: 1
	                    }
	                ]
	            }
	        };
	        this.filter = $filter('filter');
	    }
	    ForecastingService.prototype.getForecastModelMethods = function () {
	        return this.forecastModelMethods;
	    };
	    ForecastingService.prototype.getForecastModelMethodParameters = function (method) {
	        return this.filter(this.forecastModelMethod.options, { name: method });
	    };
	    ForecastingService.prototype.getForecastModelParameters = function () {
	        return this.forecastModelParams;
	    };
	    ForecastingService.$inject = ['$filter', 'stationApi'];
	    return ForecastingService;
	}());
	exports.ForecastingService = ForecastingService;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ForecastingService;


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var snow_data_controller_1 = __webpack_require__(512);
	__webpack_require__(513);
	var template = __webpack_require__(514);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: snow_data_controller_1.default,
	    template: template
	};


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var extensions_1 = __webpack_require__(327);
	var moment = __webpack_require__(45);
	var IDataFileState;
	(function (IDataFileState) {
	    IDataFileState[IDataFileState["Unselected"] = 0] = "Unselected";
	    IDataFileState[IDataFileState["Selected"] = 1] = "Selected";
	    IDataFileState[IDataFileState["Validating"] = 2] = "Validating";
	    IDataFileState[IDataFileState["Invalid"] = 3] = "Invalid";
	    IDataFileState[IDataFileState["Valid"] = 4] = "Valid";
	})(IDataFileState || (IDataFileState = {}));
	var SnowDataController = (function () {
	    function SnowDataController($state, organizationApi, $stateParams, stationApi, imomoErrorService, Upload, $rootScope, stationMapService, uiGmapGoogleMapApi, timeseriesService, $translate, $mdDialog, $window) {
	        var _this = this;
	        this.$state = $state;
	        this.organizationApi = organizationApi;
	        this.$stateParams = $stateParams;
	        this.stationApi = stationApi;
	        this.imomoErrorService = imomoErrorService;
	        this.Upload = Upload;
	        this.$rootScope = $rootScope;
	        this.stationMapService = stationMapService;
	        this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
	        this.timeseriesService = timeseriesService;
	        this.$translate = $translate;
	        this.$mdDialog = $mdDialog;
	        this.$window = $window;
	        this.snowDataRows = [];
	        this.isCatchmentMissing = false;
	        this.heatmapValues = {
	            "0": "rgb(255, 0, 0)",
	            "1": "rgb(249, 6, 0)",
	            "2": "rgb(244, 11, 0)",
	            "3": "rgb(239, 16, 0)",
	            "4": "rgb(234, 21, 0)",
	            "5": "rgb(229, 26, 0)",
	            "6": "rgb(224, 31, 0)",
	            "7": "rgb(219, 36, 0)",
	            "8": "rgb(214, 41, 0)",
	            "9": "rgb(209, 46, 0)",
	            "10": "rgb(204, 51, 0)",
	            "11": "rgb(198, 57, 0)",
	            "12": "rgb(193, 62, 0)",
	            "13": "rgb(188, 67, 0)",
	            "14": "rgb(183, 72, 0)",
	            "15": "rgb(178, 77, 0)",
	            "16": "rgb(173, 82, 0)",
	            "17": "rgb(168, 87, 0)",
	            "18": "rgb(163, 92, 0)",
	            "19": "rgb(158, 97, 0)",
	            "20": "rgb(153, 102, 0)",
	            "21": "rgb(147, 108, 0)",
	            "22": "rgb(142, 113, 0)",
	            "23": "rgb(137, 118, 0)",
	            "24": "rgb(132, 123, 0)",
	            "25": "rgb(127, 128, 0)",
	            "26": "rgb(122, 133, 0)",
	            "27": "rgb(117, 138, 0)",
	            "28": "rgb(112, 143, 0)",
	            "29": "rgb(107, 148, 0)",
	            "30": "rgb(102, 153, 0)",
	            "31": "rgb(96, 159, 0)",
	            "32": "rgb(91, 164, 0)",
	            "33": "rgb(86, 169, 0)",
	            "34": "rgb(81, 174, 0)",
	            "35": "rgb(76, 179, 0)",
	            "36": "rgb(71, 184, 0)",
	            "37": "rgb(66, 189, 0)",
	            "38": "rgb(61, 194, 0)",
	            "39": "rgb(56, 199, 0)",
	            "40": "rgb(50, 205, 0)",
	            "41": "rgb(45, 210, 0)",
	            "42": "rgb(40, 215, 0)",
	            "43": "rgb(35, 220, 0)",
	            "44": "rgb(30, 225, 0)",
	            "45": "rgb(25, 230, 0)",
	            "46": "rgb(20, 235, 0)",
	            "47": "rgb(15, 240, 0)",
	            "48": "rgb(10, 245, 0)",
	            "49": "rgb(5, 250, 0)",
	            "50": "rgb(0, 255, 0)",
	            "51": "rgb(0, 250, 5)",
	            "52": "rgb(0, 245, 10)",
	            "53": "rgb(0, 240, 15)",
	            "54": "rgb(0, 235, 20)",
	            "55": "rgb(0, 230, 25)",
	            "56": "rgb(0, 225, 30)",
	            "57": "rgb(0, 220, 35)",
	            "58": "rgb(0, 215, 40)",
	            "59": "rgb(0, 210, 45)",
	            "60": "rgb(0, 205, 50)",
	            "61": "rgb(0, 199, 56)",
	            "62": "rgb(0, 194, 61)",
	            "63": "rgb(0, 189, 66)",
	            "64": "rgb(0, 184, 71)",
	            "65": "rgb(0, 179, 76)",
	            "66": "rgb(0, 174, 81)",
	            "67": "rgb(0, 169, 86)",
	            "68": "rgb(0, 164, 91)",
	            "69": "rgb(0, 159, 96)",
	            "70": "rgb(0, 154, 101)",
	            "71": "rgb(0, 148, 107)",
	            "72": "rgb(0, 143, 112)",
	            "73": "rgb(0, 138, 117)",
	            "74": "rgb(0, 133, 122)",
	            "75": "rgb(0, 128, 127)",
	            "76": "rgb(0, 123, 132)",
	            "77": "rgb(0, 118, 137)",
	            "78": "rgb(0, 113, 142)",
	            "79": "rgb(0, 108, 147)",
	            "80": "rgb(0, 102, 153)",
	            "81": "rgb(0, 97, 158)",
	            "82": "rgb(0, 92, 163)",
	            "83": "rgb(0, 87, 168)",
	            "84": "rgb(0, 82, 173)",
	            "85": "rgb(0, 77, 178)",
	            "86": "rgb(0, 72, 183)",
	            "87": "rgb(0, 67, 188)",
	            "88": "rgb(0, 62, 193)",
	            "89": "rgb(0, 57, 198)",
	            "90": "rgb(0, 51, 204)",
	            "91": "rgb(0, 46, 209)",
	            "92": "rgb(0, 41, 214)",
	            "93": "rgb(0, 36, 219)",
	            "94": "rgb(0, 31, 224)",
	            "95": "rgb(0, 26, 229)",
	            "96": "rgb(0, 21, 234)",
	            "97": "rgb(0, 16, 239)",
	            "98": "rgb(0, 11, 244)",
	            "99": "rgb(0, 6, 249)",
	            "100": "rgb(0, 0, 255)"
	        };
	        this.onDataFileChange = function (files) {
	            if (files && files[0]) {
	                _this.dataFile = files[0];
	                _this.dataFileState = IDataFileState.Selected;
	            }
	            else {
	                _this.dataFileState = IDataFileState.Unselected;
	                _this.dataFile = null;
	            }
	        };
	        this.heatmapValues = Object.keys(this.heatmapValues).map(function (key) { return _this.heatmapValues[key]; }).reverse();
	        this.dataFileState = IDataFileState.Unselected;
	        this.stationId = Number.parseInt(this.$stateParams.stationId);
	        this.years = SnowDataController.JOURNAL_YEARS;
	        this.selectedYear = moment().year();
	        this.map = this.stationMapService.getMapOptions();
	        this.loadingInProgress = true;
	        this.organizationApi
	            .getOrganization(Number.parseInt(this.$window.localStorage.getItem('currentOrgId')))
	            .then(function (org) {
	            _this.yearType = org.yearType;
	        });
	        this.stationApi.getDischargeStation({ stationId: this.stationId })
	            .then(function (station) {
	            _this.station = station;
	            _this.$rootScope.$broadcast('STATION_LOADED', station);
	            _this.onLoadSnowData();
	            if (_this.station) {
	                _this.stationApi.getCatchmentAreaGeojson(_this.station.id, false)
	                    .then(function (geojson) {
	                    _this.isLoadingGeotiff = true;
	                    _this.geojson = geojson;
	                    uiGmapGoogleMapApi.then(function (maps) {
	                        _this.map.options.mapTypeId = maps.MapTypeId.TERRAIN;
	                        var catchmentBounds = _this.stationMapService.loadGeoJson(geojson.url, _this.map, maps, 0).getCatchmentBounds();
	                        _this.stationApi.getSnowCoverGeotiff(_this.station.id)
	                            .then(function (data) {
	                            if (data) {
	                                _this.geoTiffDate = moment(data.date);
	                                _this.stationMapService.setOverlay(catchmentBounds, data.url, _this.map);
	                            }
	                        })
	                            .catch(function (error) {
	                            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                        })
	                            .finally(function () {
	                            _this.isLoadingGeotiff = false;
	                        });
	                    });
	                }, function () {
	                    _this.isCatchmentMissing = true;
	                    _this.loadingInProgress = false;
	                    //this.map.center = this.marker.coords;
	                });
	            }
	        }).finally(function () {
	            _this.loadingInProgress = false;
	        });
	    }
	    Object.defineProperty(SnowDataController.prototype, "isUnselected", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Unselected;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "isValidating", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Validating;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "isInvalid", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Invalid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "isValidated", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Valid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "jsonMimeTypes", {
	        get: function () {
	            return extensions_1.JSON_MIME_TYPE;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnowDataController.prototype, "dataFileStateIcon", {
	        get: function () {
	            switch (this.dataFileState) {
	                case IDataFileState.Selected:
	                    return {
	                        name: 'indeterminate_check_box',
	                        cssClass: ''
	                    };
	                case IDataFileState.Validating:
	                    return {
	                        name: 'cached',
	                        cssClass: ''
	                    };
	                case IDataFileState.Valid:
	                    return {
	                        name: 'check_circle',
	                        cssClass: 'md-accent'
	                    };
	                case IDataFileState.Invalid:
	                    return {
	                        name: 'error_outline',
	                        cssClass: 'md-warn'
	                    };
	                default:
	                    return {
	                        name: '',
	                        cssClass: ''
	                    };
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SnowDataController.prototype.onDataUpload = function () {
	        var _this = this;
	        this.Upload.base64DataUrl(this.dataFile)
	            .then(function (jsonstring) {
	            _this.stationApi.uploadSnowData(_this.stationId, jsonstring)
	                .then(function () {
	                _this.$state.go(_this.$state.current, {}, { reload: true });
	            })
	                .catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	            })
	                .finally(function () {
	                _this.loadingInProgress = false;
	            });
	        });
	    };
	    SnowDataController.prototype.getSnowDataGroupedByYear = function (snowData) {
	        var _this = this;
	        var snowDataSeriesDataList = [];
	        var snowDataSeriesTemplate = {
	            label: null,
	            data: []
	        };
	        var year = 0;
	        snowData.forEach(function (snowDataRow, index) {
	            if (index === 0) {
	                year = moment(snowDataRow.date).year();
	                snowDataSeriesTemplate.label = _this.yearType === "hydro_year" ? year + 1 : year;
	            }
	            else if (index === (snowData.length - 1) ||
	                (_this.yearType === "hydro_year" && (moment(snowDataRow.date).month() === 8 && moment(snowDataRow.date).date() === 30 ||
	                    ((moment(snowDataRow.date).month() !== 11 && moment(snowDataRow.date).date() !== 31) &&
	                        moment(snowDataRow.date).year() !== moment(snowData[index + 1].date).year()))) ||
	                (_this.yearType === "calendar_year" && (moment(snowDataRow.date).month() === 0 && moment(snowDataRow.date).date() === 1 ||
	                    ((moment(snowDataRow.date).month() !== 11 && moment(snowDataRow.date).date() !== 31) &&
	                        moment(snowDataRow.date).year() !== moment(snowData[index + 1].date).year())))) {
	                snowDataSeriesTemplate.data.push({
	                    date: moment(snowDataRow.date),
	                    hydrodata: snowDataRow.value
	                });
	                snowDataSeriesDataList.push(angular.copy(snowDataSeriesTemplate));
	                year = ++year;
	                snowDataSeriesTemplate.label = _this.yearType === "hydro_year" ? year + 1 : year;
	                snowDataSeriesTemplate.data = [];
	            }
	            else {
	                snowDataSeriesTemplate.data.push({
	                    date: moment(snowDataRow.date),
	                    hydrodata: snowDataRow.value
	                });
	            }
	        });
	        snowDataSeriesDataList[snowDataSeriesDataList.length - 1].current = true;
	        snowDataSeriesDataList[snowDataSeriesDataList.length - 1].highlighted = true;
	        return snowDataSeriesDataList;
	    };
	    SnowDataController.prototype.onLoadSnowData = function () {
	        var _this = this;
	        this.snowDataLoadingInProgress = true;
	        this.snowDataPromise = this.stationApi.getSnowData(this.stationId);
	        this.snowDataPromise
	            .then(function (snowData) {
	            var snowDataSeries = [];
	            var snowDataNormSeries;
	            var snowDataNormRangeSeries;
	            if (snowData && snowData.snowData) {
	                _this.stationApi.getSnowDataNorm(_this.stationId)
	                    .then(function (snowDataNorm) {
	                    snowDataNormSeries = {
	                        label: _this.$translate.instant('NDSI_NORM'),
	                        data: _.sortBy(snowDataNorm.snowDataNorm.map(function (snowDataRow) {
	                            return {
	                                date: moment().month(snowDataRow.month - 1).date(snowDataRow.day),
	                                hydrodata: snowDataRow.value
	                            };
	                        }), 'date'),
	                        highlighted: true
	                    };
	                    snowDataNormRangeSeries = {
	                        id: "SD",
	                        label: _this.$translate.instant('NDSI_NORM') + " +-1SD",
	                        data: _.sortBy(snowDataNorm.snowDataNorm.map(function (snowDataRow) {
	                            return {
	                                date: moment().month(snowDataRow.month - 1).date(snowDataRow.day),
	                                hydrodata: [(snowDataRow.value + snowDataRow.std), (snowDataRow.value - snowDataRow.std)]
	                            };
	                        }), 'date'),
	                    };
	                })
	                    .finally(function () {
	                    _this.getSnowDataGroupedByYear(snowData.snowData).forEach(function (list) {
	                        snowDataSeries.push(list);
	                    });
	                    snowDataSeries.push(snowDataNormSeries);
	                    snowDataSeries.push(snowDataNormRangeSeries);
	                    _this.snowDataSeries = snowDataSeries;
	                    _this.snowDataLoadingInProgress = false;
	                });
	            }
	            else {
	                _this.snowDataLoadingInProgress = false;
	            }
	            _this.stationApi.getSnowDataFile(_this.stationId, _this.selectedYear)
	                .then(function (s3url) {
	                _this.isSnowDataFileDownloadEnabled = true;
	                _this.snowDataFileDownloadLink = s3url.url;
	            })
	                .catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	            });
	        })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	            _this.snowDataLoadingInProgress = false;
	        });
	    };
	    SnowDataController.prototype.onDeleteCatchmentArea = function () {
	        var _this = this;
	        var confirm = this.$mdDialog.confirm()
	            .title('')
	            .textContent(this.$translate.instant('DELETE_CATCHMENT_CONFIRM'))
	            .ok(this.$translate.instant('DELETE'))
	            .cancel(this.$translate.instant('CANCEL'));
	        this.$mdDialog.show(confirm).then(function () {
	            _this.stationApi.deleteCatchmentArea(_this.stationId)
	                .then(function () {
	                _this.isCatchmentMissing = true;
	                _this.snowDataFileDownloadLink = null;
	            });
	        });
	    };
	    SnowDataController.$inject = ['$state', 'organizationApi', '$stateParams', 'stationApi', 'imomoErrorService', 'Upload', '$rootScope',
	        'stationMapService', 'uiGmapGoogleMapApi', 'timeseriesService', '$translate', '$mdDialog', '$window'];
	    SnowDataController.YEAR_RANGE_SIZE = 100;
	    SnowDataController.JOURNAL_YEARS = _.range(moment().year() - SnowDataController.YEAR_RANGE_SIZE, moment().year() + 1);
	    return SnowDataController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = SnowDataController;


/***/ },
/* 513 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 514 */
/***/ function(module, exports) {

	module.exports = "<div class=forecasting-container layout=row flex> <md-card flex> <md-progress-linear ng-disabled=\"!$ctrl.loadingInProgress && !$ctrl.snowDataLoadingInProgress\"></md-progress-linear> <md-tabs flex class=full-height-tabs> <md-tab ng-if=!$ctrl.isCatchmentMissing> <md-tab-label> <span translate>SNOW_COVER_DEVELOPMENT</span> </md-tab-label> <md-tab-body> <hydromet-timeseries-new timeseries=$ctrl.snowDataSeries hydrodata-type=\"'snowData'\"></hydromet-timeseries-new> <div layout=row layout-align=\"end center\"> <a class=\"md-button md-primary md-raised\" ng-href={{$ctrl.snowDataFileDownloadLink}} ng-disabled=!$ctrl.isSnowDataFileDownloadEnabled> <span translate>DOWNLOAD_DATA</span> </a> </div> </md-tab-body> </md-tab> <md-tab ng-if=!$ctrl.isCatchmentMissing> <md-tab-label> <span translate>SNOW_COVER_MAP</span> </md-tab-label> <md-tab-body> <div flex layout=row class=fill-tab> <div layout=column flex> <md-progress-linear md-mode=indeterminate ng-show=$ctrl.isLoadingGeotiff> </md-progress-linear> <div layout-padding> <h3><span translate>NORMALIZED_DIFF_SNOW_INDEX_MAP</span>: {{ $ctrl.geoTiffDate | momentFormatter:'date-time' }}</h3> </div> <ui-gmap-google-map flex center=$ctrl.map.center zoom=$ctrl.map.zoom options=$ctrl.map.options events=$ctrl.map.events control=$ctrl.map.control class=edit-details-map layout=column> <ui-gmap-marker idkey=$ctrl.marker.id coords=$ctrl.marker.coords></ui-gmap-marker> </ui-gmap-google-map> <div class=heatmap-legend-container> <div id=heatmap-legend> <div layout=row layout-align=\"space-between center\"> <span translate>LOW_NDSI</span> <span translate>HIGH_NDSI</span> </div> <div class=legend-item ng-repeat=\"(key, value) in $ctrl.heatmapValues\" style=\"left:{{ key }}%;background:{{ value }}\"> <div ng-if=\"key % 10 === 0\" class=legend-item-label>{{ key }}</div> </div> </div> </div> </div> </div> </md-tab-body> </md-tab> <md-tab> <md-tab-label> <span translate>CATCHMENT_AREA_SETUP</span> </md-tab-label> <md-tab-body> <md-card ng-if=$ctrl.snowDataFileDownloadLink layout=row layout-align=\"space-between center\" layout-padding> <strong translate>FILE_UPLOADED</strong> <div> <md-button class=\"md-warn md-raised\" ng-click=$ctrl.onDeleteCatchmentArea()><span translate>DELETE</span></md-button> </div> </md-card> <md-card layout=column layout-padding flex> <md-progress-linear ng-show=$ctrl.isLoading> </md-progress-linear> <section> <h3 ng-show=$ctrl.isUnselected translate> NO_FILE_SELECTED</h3> <h3 ng-hide=$ctrl.isUnselected> {{ $ctrl.dataFile.name }} <md-icon ng-show=$ctrl.isSelected ng-class=$ctrl.dataFileStateIcon.cssClass class=material-icons>{{ $ctrl.dataFileStateIcon.name }} </md-icon> </h3> </section> <form name=fileForm layout=row layout-align=\"start center\"> <md-button ngf-select ngf-multiple=false class=md-raised ng-model=$ctrl.dataFile ngf-change=$ctrl.onDataFileChange($files) ngf-pattern=$ctrl.jsonMimeTypes ngf-accept=$ctrl.jsonMimeTypes required ng-class=\"{'md-accent': $ctrl.isUnselected, 'md-warn': !$ctrl.isUnselected}\"> <span ng-show=$ctrl.isUnselected translate> SELECT_FILE </span> <span ng-hide=$ctrl.isUnselected translate> CHANGE </span> </md-button> <md-button ng-click=$ctrl.onDataUpload() ng-disabled=$ctrl.isUnselected> <span translate>SUBMIT_DATA</span> </md-button> </form> <sub translate>SNOW_DATA_FILE_NOTE</sub> </md-card> </md-tab-body> </md-tab> </md-tabs> </md-card> </div>";

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var creator_module_1 = __webpack_require__(516);
	var manager_component_1 = __webpack_require__(523);
	var meteostation_component_1 = __webpack_require__(526);
	var selector_component_1 = __webpack_require__(529);
	var historic_norm_component_1 = __webpack_require__(533);
	var meteo_data_table_component_1 = __webpack_require__(536);
	var details_component_1 = __webpack_require__(539);
	var edit_component_1 = __webpack_require__(542);
	var meteostation_formatter_1 = __webpack_require__(545);
	var unique_station_code_directive_1 = __webpack_require__(546);
	var meteostation_component_2 = __webpack_require__(526);
	var selector_service_1 = __webpack_require__(547);
	var timeseries_component_1 = __webpack_require__(548);
	var timeseries_graph_component_1 = __webpack_require__(551);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.meteostation', [creator_module_1.default.name])
	    .component('imomoMeteostation', meteostation_component_1.default)
	    .component('imomoMeteostationManager', manager_component_1.default)
	    .component('imomoMeteostationSelector', selector_component_1.default)
	    .component('imomoMeteostationHistoricNorm', historic_norm_component_1.default)
	    .component('imomoMeteostationDataTable', meteo_data_table_component_1.default)
	    .component('imomoMeteostationDetails', details_component_1.default)
	    .component('imomoMeteostationDetailsEdit', edit_component_1.default)
	    .component('imomoMeteostationTimeseries', timeseries_component_1.default)
	    .component('imomoMeteostationTimeseriesGraph', timeseries_graph_component_1.default)
	    .config(meteostation_component_2.configStates)
	    .filter('stationFormatter', meteostation_formatter_1.default)
	    .directive('uniqueMeteoStationCode', unique_station_code_directive_1.uniqueStationCodeFactory)
	    .service('stationSelectorService', selector_service_1.default)
	    .name;


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var creator_component_1 = __webpack_require__(517);
	var data_component_1 = __webpack_require__(520);
	var imomoMeteostationCreatorModule = angular.module('imomo.meteostation.creator', [])
	    .component('imomoMeteostationCreator', creator_component_1.default)
	    .component('imomoMeteostationCreatorData', data_component_1.default);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = imomoMeteostationCreatorModule;


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var creator_controller_1 = __webpack_require__(518);
	var template = __webpack_require__(519);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: creator_controller_1.default,
	    template: template
	};


/***/ },
/* 518 */
/***/ function(module, exports) {

	"use strict";
	var StationCreatorController = (function () {
	    function StationCreatorController($state, stationApi, imomoErrorService) {
	        this.$state = $state;
	        this.stationApi = stationApi;
	        this.imomoErrorService = imomoErrorService;
	    }
	    StationCreatorController.prototype.$onInit = function () {
	        this.isStepOneValid = false;
	        this.isStepTwoValid = true;
	    };
	    Object.defineProperty(StationCreatorController.prototype, "isStepTwoDisabled", {
	        get: function () {
	            return !this.isStepOneValid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isNextButtonDisabled", {
	        get: function () {
	            switch (this.selectedTabIndex) {
	                case 0:
	                    return this.isStepTwoDisabled;
	                default:
	                    return true;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isPrevButtonDisabled", {
	        get: function () {
	            switch (this.selectedTabIndex) {
	                case 0:
	                    return true;
	                default:
	                    return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isSubmitButtonDisabled", {
	        get: function () {
	            return !this.isStepOneValid
	                || !this.isStepTwoValid
	                || this.isLoading;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorController.prototype, "isLastStep", {
	        get: function () {
	            return this.selectedTabIndex == 1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationCreatorController.prototype.onStationDetailsChange = function (station, isValid) {
	        this.isStepOneValid = isValid;
	        this.stationDetails = station;
	    };
	    StationCreatorController.prototype.onHistoricalDataChange = function (dataFile, isValid) {
	        this.isStepTwoValid = isValid;
	        this.historicalDataFile = dataFile;
	    };
	    StationCreatorController.prototype.nextStep = function () {
	        this.selectedTabIndex += 1;
	    };
	    StationCreatorController.prototype.prevStep = function () {
	        this.selectedTabIndex -= 1;
	    };
	    StationCreatorController.prototype.createStation = function () {
	        var _this = this;
	        this.isLoading = true;
	        var stationRequest = {
	            siteName: this.stationDetails.name,
	            siteCode: this.stationDetails.code,
	            country: this.stationDetails.country,
	            basin: this.stationDetails.basin,
	            region: this.stationDetails.region,
	            latitude: this.stationDetails.location.latitude,
	            longitude: this.stationDetails.location.longitude
	        };
	        this.stationApi.createMeteoStation(stationRequest, this.historicalDataFile)
	            .then(function () {
	            _this.$state.go('meteostation.manager');
	        })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	        })
	            .finally(function () {
	            _this.isLoading = false;
	        });
	    };
	    StationCreatorController.$inject = ['$state', 'stationApi', 'imomoErrorService'];
	    return StationCreatorController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationCreatorController;


/***/ },
/* 519 */
/***/ function(module, exports) {

	module.exports = "<div class=station-creator-container layout=column> <md-progress-linear md-mode=indeterminate ng-show=$ctrl.isLoading> </md-progress-linear> <md-tabs class=full-height-tabs md-selected=$ctrl.selectedTabIndex md-border-bottom flex> <md-tab md-on-select=$ctrl.onTabSelect()> <md-tab-label> <span translate>STEP_1_DETAILS</span> </md-tab-label> <md-tab-body> <imomo-meteostation-details-edit class=fill-tab layout=row on-change=\"$ctrl.onStationDetailsChange(station, isValid)\" station-details=$ctrl.stationDetails> </imomo-meteostation-details-edit> </md-tab-body> </md-tab> <md-tab md-on-select=$ctrl.onTabSelect() ng-disabled=$ctrl.isStepTwoDisabled> <md-tab-label> <span translate>STEP_2_HISTORICAL_DATA</span> </md-tab-label> <md-tab-body> <imomo-meteostation-creator-data class=fill-tab layout=row on-change=\"$ctrl.onHistoricalDataChange(dataFile, isValid)\"> </imomo-meteostation-creator-data> </md-tab-body> </md-tab> </md-tabs> <section layout=row flex=none> <md-button ng-disabled=$ctrl.isPrevButtonDisabled ng-click=$ctrl.prevStep()> <span translate>PREVIOUS</span> </md-button> <span flex></span> <md-button ng-disabled=$ctrl.isNextButtonDisabled ng-click=$ctrl.nextStep() ng-hide=$ctrl.isLastStep> <span translate>NEXT</span> </md-button> <md-button class=md-primary ng-show=$ctrl.isLastStep ng-disabled=$ctrl.isSubmitButtonDisabled ng-click=$ctrl.createStation()> <span translate>CREATE</span> </md-button> </section> </div>";

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var data_controller_1 = __webpack_require__(521);
	var template = __webpack_require__(522);
	var bindings = {
	    onChange: '&'
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    bindings: bindings,
	    controller: data_controller_1.default,
	    template: template
	};


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var extensions_1 = __webpack_require__(327);
	var IDataFileState;
	(function (IDataFileState) {
	    IDataFileState[IDataFileState["Unselected"] = 0] = "Unselected";
	    IDataFileState[IDataFileState["Selected"] = 1] = "Selected";
	    IDataFileState[IDataFileState["Validating"] = 2] = "Validating";
	    IDataFileState[IDataFileState["Invalid"] = 3] = "Invalid";
	    IDataFileState[IDataFileState["Valid"] = 4] = "Valid";
	})(IDataFileState || (IDataFileState = {}));
	var StationCreatorDataController = (function () {
	    function StationCreatorDataController(s3UploadService, stationApi, imomoErrorService) {
	        var _this = this;
	        this.s3UploadService = s3UploadService;
	        this.stationApi = stationApi;
	        this.imomoErrorService = imomoErrorService;
	        this.onDataFileChange = function (files) {
	            if (files && files[0]) {
	                _this.dataFile = files[0];
	                _this.dataFileState = IDataFileState.Selected;
	            }
	            else {
	                _this.dataFileState = IDataFileState.Unselected;
	                _this.dataFile = null;
	            }
	            _this.notifyChange(false);
	        };
	        this.dataFileState = IDataFileState.Unselected;
	    }
	    Object.defineProperty(StationCreatorDataController.prototype, "isUnselected", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Unselected;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "isValidating", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Validating;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "isInvalid", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Invalid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "isValidated", {
	        get: function () {
	            return this.dataFileState == IDataFileState.Valid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "excelMimeTypes", {
	        get: function () {
	            return extensions_1.EXCEL_MIME_TYPES;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationCreatorDataController.prototype, "dataFileStateIcon", {
	        get: function () {
	            switch (this.dataFileState) {
	                case IDataFileState.Selected:
	                    return {
	                        name: 'indeterminate_check_box',
	                        cssClass: ''
	                    };
	                case IDataFileState.Validating:
	                    return {
	                        name: 'cached',
	                        cssClass: ''
	                    };
	                case IDataFileState.Valid:
	                    return {
	                        name: 'check_circle',
	                        cssClass: 'md-accent'
	                    };
	                case IDataFileState.Invalid:
	                    return {
	                        name: 'error_outline',
	                        cssClass: 'md-warn'
	                    };
	                default:
	                    return {
	                        name: '',
	                        cssClass: ''
	                    };
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationCreatorDataController.prototype.validate = function () {
	        var _this = this;
	        this.dataFileState = IDataFileState.Validating;
	        return this.stationApi.validateMeteoData(this.dataFile)
	            .then(function () {
	            _this.dataFileState = IDataFileState.Valid;
	            _this.notifyChange(true);
	        })
	            .catch(function (error) {
	            _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	            _this.dataFileState = IDataFileState.Invalid;
	            _this.notifyChange(false);
	        });
	    };
	    ;
	    StationCreatorDataController.prototype.notifyChange = function (valid) {
	        if (this.onChange) {
	            this.onChange({
	                dataFile: this.dataFile,
	                isValid: valid
	            });
	        }
	    };
	    StationCreatorDataController.$inject = ['s3UploadService', 'stationApi', 'imomoErrorService'];
	    return StationCreatorDataController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationCreatorDataController;


/***/ },
/* 522 */
/***/ function(module, exports) {

	module.exports = "<md-card layout=column layout-padding flex> <h2 class=md-headline translate>HISTORICAL_DISCHARGE_DATA_UPLOAD</h2> <p class=md-subhead> <span translate>PLEASE_UPLOAD_HISTORICAL_METEO</span><br> <span translate>DATA_AVAILABLE_FOR_DOWNLOAD</span><br/> <span translate>DATA_MUST_BE_EXCEL</span> </p> <section> <h3 ng-show=$ctrl.isUnselected translate> NO_FILE_SELECTED</h3> <h3 ng-hide=$ctrl.isUnselected> {{ $ctrl.dataFile.name }} <md-icon ng-show=$ctrl.isSelected ng-class=$ctrl.dataFileStateIcon.cssClass class=material-icons>{{ $ctrl.dataFileStateIcon.name }} </md-icon> </h3> </section> <form name=fileForm layout=row layout-align=\"start center\" ng-hide=$ctrl.isValidating> <md-button href=https://s3.eu-central-1.amazonaws.com/imomo-uploads/meteo_template.xlsx download=meteo-template.xlsx> <span translate>DOWNLOAD_EXAMPLE_FILE</span> </md-button> <md-button ngf-select ngf-multiple=false class=md-raised ng-model=$ctrl.dataFile ngf-change=$ctrl.onDataFileChange($files) ngf-pattern=$ctrl.excelMimeTypes ngf-accept=$ctrl.excelMimeTypes required ng-class=\"{'md-accent': $ctrl.isUnselected, 'md-warn': !$ctrl.isUnselected}\"> <span ng-show=$ctrl.isUnselected translate> SELECT_FILE </span> <span ng-hide=$ctrl.isUnselected translate> CHANGE </span> </md-button> <md-button class=\"md-raised md-primary self-align-end\" ng-disabled=\"fileForm.$invalid || $ctrl.isInvalid || $ctrl.isValidated\" ng-click=$ctrl.validate()> <span ng-hide=$ctrl.isValidated translate> VALIDATE </span> <span ng-show=$ctrl.isValidated translate> VALIDATED </span> </md-button> </form> <div> <md-progress-linear ng-show=$ctrl.isValidating></md-progress-linear> </div> </md-card>";

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var manager_controller_1 = __webpack_require__(524);
	var template = __webpack_require__(525);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: manager_controller_1.default,
	    template: template
	};


/***/ },
/* 524 */
/***/ function(module, exports) {

	"use strict";
	var StationManagerController = (function () {
	    function StationManagerController($state, stationApi, $location) {
	        var _this = this;
	        this.$state = $state;
	        this.stationApi = stationApi;
	        this.$location = $location;
	        this.isOpen = false;
	        this.newStation = function () {
	            _this.$state.go('meteostation.creator');
	        };
	        this.onStationsReady = function (stationsPaginated) {
	            _this.stations = stationsPaginated.resources;
	            _this.paginationSettings.count = stationsPaginated.count;
	        };
	        this.selectedStations = [];
	        this.stations = [];
	        this.paginationSettings = {
	            offset: this.$location.search().offset || 0,
	            pageSize: 10,
	            currentPage: this.$location.search().offset ? parseInt(this.$location.search().offset) + 1 : 1
	        };
	        this.order = this.$location.search().order;
	        this.onOrderChange = this.onOrderChange.bind(this);
	        this.getStations();
	    }
	    Object.defineProperty(StationManagerController.prototype, "isStationSelected", {
	        get: function () {
	            return this.selectedStations.length > 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StationManagerController.prototype, "selectedStation", {
	        get: function () {
	            return this.selectedStations[0];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationManagerController.prototype.showHistoricData = function () {
	        this.$state.go('meteostation.historicNorm', { stationId: this.selectedStation.id });
	    };
	    StationManagerController.prototype.showStationTimeseries = function () {
	        this.$state.go('meteostation.timeseries', { stationId: this.selectedStation.id });
	    };
	    StationManagerController.prototype.editStation = function () {
	        this.$state.go('meteostation.details', { stationId: this.selectedStation.id });
	    };
	    StationManagerController.prototype.getStations = function () {
	        this.stationsPromise = this.stationApi.getPaginatedMeteoStations(this.paginationSettings.pageSize, this.paginationSettings.offset, this.order)
	            .then(this.onStationsReady);
	    };
	    StationManagerController.prototype.onOrderChange = function (order) {
	        this.getStations();
	        this.$location.search({
	            offset: this.paginationSettings.offset,
	            order: this.order
	        });
	    };
	    StationManagerController.prototype.onPageChange = function (page) {
	        this.paginationSettings.offset = page - 1;
	        this.getStations();
	        this.$location.search({
	            offset: this.paginationSettings.offset,
	            order: this.order
	        });
	    };
	    StationManagerController.prototype.onSiteSearchTextChange = function () {
	        var _this = this;
	        this.stationApi.searchMeteoStations(this.siteSearchText)
	            .then(function (stations) {
	            _this.stations = stations;
	        });
	    };
	    StationManagerController.$inject = ['$state', 'stationApi', '$location'];
	    return StationManagerController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationManagerController;


/***/ },
/* 525 */
/***/ function(module, exports) {

	module.exports = "<div class=station-manager-container layout=row> <md-card flex> <md-toolbar class=md-table-toolbar ng-class=\"{'md-default': !$ctrl.isStationSelected, 'md-accent': $ctrl.isStationSelected}\"> <div class=md-toolbar-tools> <span ng-hide=$ctrl.isStationSelected translate>HYDROLOGICAL_METEOSTATIONS</span> <span ng-show=$ctrl.isStationSelected> {{ $ctrl.selectedStation | stationFormatter }} </span> <span flex></span> <md-button class=md-icon-button ng-disabled=!$ctrl.isStationSelected ng-click=$ctrl.editStation()> <md-icon>edit</md-icon> <md-tooltip md-direction=down> <span translate>EDIT_METEOSTATION</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=!$ctrl.isStationSelected ng-click=$ctrl.showStationTimeseries()> <md-icon>timeline</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_TIME_SERIES</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=!$ctrl.isStationSelected ng-click=$ctrl.showHistoricData()> <md-icon>history</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_HISTORIC_DATA</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-click=$ctrl.newStation()> <md-icon>add_location</md-icon> <md-tooltip md-direction=down> <span translate>ADD_METEOSTATION</span> </md-tooltip> </md-button> </div> </md-toolbar> <form name=searchForm layout=row class=site-search> <md-input-container> <label translate>SEARCH_STATION_CODE</label> <input type=text pattern=[0-9]* name=siteSearchText maxlength=5 ng-model=$ctrl.siteSearchText ng-change=$ctrl.onSiteSearchTextChange()> <div ng-messages=searchForm.siteSearchText.$error md-auto-hide=false ng-show=searchForm.siteSearchText.$dirty> <div ng-message=pattern translate> INVALID_VALUE </div> </div> </md-input-container> </form> <md-table-container ng-if=$ctrl.stations.length flex> <table md-table md-progress=$ctrl.stationsPromise md-row-select ng-model=$ctrl.selectedStations> <thead md-head md-order=$ctrl.order md-on-reorder=$ctrl.onOrderChange> <tr md-row> <th md-column md-order-by=siteCode><span translate>STATION_CODE</span></th> <th md-column md-order-by=siteName><span translate>STATION_NAME</span></th> <th md-column md-order-by=region><span translate>REGION</span> </th> <th md-column md-order-by=basin><span translate>RIVER_BASIN</span></th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select md-select=station md-select-id=id ng-repeat=\"station in $ctrl.stations\"> <td md-cell>{{ station.siteCode }}</td> <td md-cell>{{ station.siteName }}</td> <td md-cell>{{ station.region }}</td> <td md-cell>{{ station.basin }}</td> </tr> </tbody> </table> </md-table-container> <div flex ng-if=!$ctrl.stations.length layout=column layout-align=\"center center\"> <span translate>NO_STATIONS</span> </div> <div layout=row layout-padding layout-align=\"end center\"> <pagination-controls ng-if=\"!$ctrl.siteSearchText && $ctrl.paginationSettings.count > $ctrl.paginationSettings.pageSize\" on-page-change=$ctrl.onPageChange(page) current-page=$ctrl.paginationSettings.currentPage count=$ctrl.paginationSettings.count page-size=$ctrl.paginationSettings.pageSize></pagination-controls> </div> </md-card> </div>";

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	__webpack_require__(527);
	var auth_guard_1 = __webpack_require__(198);
	var station_controller_1 = __webpack_require__(475);
	var template = __webpack_require__(528);
	exports.configStates = function ($stateProvider) {
	    var stateData = {};
	    stateData[auth_guard_1.AuthGuard.REQUIRES_AUTH_KEY] = true;
	    $stateProvider.state('meteostation', {
	        url: '/meteostation?offset&order',
	        component: 'imomoMeteostation',
	        abstract: true,
	        data: stateData,
	        params: {
	            offset: { dynamic: true },
	            order: { dynamic: true }
	        }
	    });
	    $stateProvider.state('meteostation.manager', {
	        name: 'meteostation.manager',
	        parent: 'meteostation',
	        url: '',
	        component: 'imomoMeteostationManager'
	    });
	    $stateProvider.state('meteostation.creator', {
	        parent: 'meteostation',
	        url: '/new',
	        component: 'imomoMeteostationCreator'
	    });
	    $stateProvider.state('meteostation.historicNorm', {
	        parent: 'meteostation',
	        url: '/norm/:stationId',
	        component: 'imomoMeteostationHistoricNorm'
	    });
	    $stateProvider.state('meteostation.details', {
	        parent: 'meteostation',
	        url: '/edit/:stationId',
	        component: 'imomoMeteostationDetails'
	    });
	    $stateProvider.state('meteostation.timeseries', {
	        parent: 'meteostation',
	        url: '/timeseries/:stationId',
	        component: 'imomoMeteostationTimeseries'
	    });
	};
	exports.configStates.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: station_controller_1.default,
	    template: template
	};


/***/ },
/* 527 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 528 */
/***/ function(module, exports) {

	module.exports = "<md-toolbar class=md-table-toolbar ng-if=\"$ctrl.stateName !== 'meteostation.manager' && $ctrl.stateName !== 'meteostation.creator'\"> <div class=md-toolbar-tools> <span> {{ $ctrl.station | stationFormatter }} </span> <span flex></span> <md-button ui-sref=meteostation.manager><md-icon>keyboard_arrow_left</md-icon><span translate>BACK_TO_STATION_LIST</span></md-button> <span flex></span> <md-button class=md-icon-button ng-disabled=\"$ctrl.stateName === 'meteostation.details'\" ui-sref=\"meteostation.details({stationId: $ctrl.station.id})\" ng-click=$ctrl.editStation()> <md-icon>edit</md-icon> <md-tooltip md-direction=down> <span translate>EDIT_METEO_STATION</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=\"$ctrl.stateName === 'meteostation.timeseries'\" ui-sref=\"meteostation.timeseries({stationId: $ctrl.station.id})\" ng-click=$ctrl.showStationTimeseries()> <md-icon>timeline</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_TIME_SERIES</span> </md-tooltip> </md-button> <md-button class=md-icon-button ng-disabled=\"$ctrl.stateName === 'meteostation.historicNorm'\" ui-sref=\"meteostation.historicNorm({stationId: $ctrl.station.id})\" ng-click=$ctrl.showHistoricData()> <md-icon>history</md-icon> <md-tooltip md-direction=down> <span translate>SHOW_HISTORIC_DATA</span> </md-tooltip> </md-button> </div> </md-toolbar> <ui-view class=\"inner-outlet station-inner-outlet\" ng-class=\"{'meteostation-manager-inner-outlet': $ctrl.stateName === 'meteostation.manager' || $ctrl.stateName === 'meteostation.creator'}\"></ui-view>";

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var selector_controller_1 = __webpack_require__(530);
	__webpack_require__(531);
	var template = __webpack_require__(532);
	var selectorComponent = {
	    bindings: {
	        highlightedStationId: '<',
	        onSelectChange: '&',
	        onStationHighlightChange: '&'
	    },
	    controller: selector_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = selectorComponent;


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var StationSelectorController = (function () {
	    function StationSelectorController(stationApi, $filter, $element, stationSelectorService) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.$element = $element;
	        this.stationSelectorService = stationSelectorService;
	        this.filter = $filter('filter');
	        this.stationsPromise = stationApi.getMeteoStations().then(function (stations) {
	            _this.selectedStations = _this.stationSelectorService.getStoredStations(StationSelectorController.STORAGE_KEY, immutable_1.List(stations));
	            _this.selectedStationsArray = _this.selectedStations
	                .toArray().sort(compareStations);
	            if (!_this.selectedStations.isEmpty()) {
	                _this.highlightedStationId = _this.selectedStationsArray[0].id;
	            }
	            _this.notifyChanges();
	            return stations;
	        });
	    }
	    StationSelectorController.prototype.onChanges = function () {
	        var _this = this;
	        if (!this.selectedStations.find(function (station) { return station.id == _this.highlightedStationId; })) {
	            this.highlightedStationId = null;
	        }
	    };
	    Object.defineProperty(StationSelectorController.prototype, "inputElement", {
	        /**
	         * Input element in the md-autocomplete component.
	         */
	        get: function () {
	            return this.$element[0].querySelector('#station-input');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the stations matching a search text.
	     */
	    StationSelectorController.prototype.getMatchedStations = function (searchText) {
	        var _this = this;
	        return this.stationsPromise.then(function (stations) {
	            return _this.filter(stations, searchText).filter(function (station) {
	                return !_this.selectedStations.contains(station);
	            });
	        });
	    };
	    /**
	     * Add the selected station to the set.
	     */
	    StationSelectorController.prototype.addToSelectedStations = function (station) {
	        if (this.highlightedStationId == null) {
	            this.highlightedStationId = station.id;
	        }
	        this.selectedStations = this.selectedStations.add(station);
	        this.selectedStationsArray = this.selectedStations
	            .toArray().sort(compareStations);
	        this.searchText = '';
	        this.inputElement && this.inputElement.blur();
	        this.notifyChanges();
	    };
	    /**
	     * Remove a selected station from the set.
	     */
	    StationSelectorController.prototype.removeFromSelectedStations = function (station) {
	        this.selectedStations = this.selectedStations.remove(station);
	        this.selectedStationsArray = this.selectedStations
	            .toArray().sort(compareStations);
	        if (station.id == this.highlightedStationId) {
	            this.highlightedStationId = this.selectedStations.isEmpty()
	                ? null
	                : this.selectedStationsArray[0].id;
	        }
	        this.notifyChanges();
	    };
	    /**
	     * Highlight a station in the list.
	     */
	    StationSelectorController.prototype.highlightStation = function (station) {
	        this.highlightedStationId = station.id;
	        this.notifyChanges();
	    };
	    StationSelectorController.prototype.onStationRadioChange = function () {
	        this.notifyChanges();
	    };
	    /**
	     * Notify the callback about changes in the set of selected stations and
	     * store it locally.
	     */
	    StationSelectorController.prototype.notifyChanges = function () {
	        var _this = this;
	        this.stationSelectorService.storeStations(StationSelectorController.STORAGE_KEY, this.selectedStations);
	        if (this.onSelectChange) {
	            this.onSelectChange({
	                selectedStations: this.selectedStations
	            });
	        }
	        if (this.onStationHighlightChange) {
	            this.onStationHighlightChange({
	                station: this.selectedStations.find(function (station) { return station.id == _this.highlightedStationId; })
	            });
	        }
	    };
	    StationSelectorController.$inject = [
	        'stationApi',
	        '$filter',
	        '$element',
	        'stationSelectorService'
	    ];
	    StationSelectorController.STORAGE_KEY = 'selector';
	    return StationSelectorController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationSelectorController;
	function compareStations(a, b) {
	    return a.siteCode.localeCompare(b.siteCode);
	}


/***/ },
/* 531 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 532 */
/***/ function(module, exports) {

	module.exports = "<md-card flex class=station-selector-card> <md-card-title class=station-selector-title> <md-card-title-text> <span class=md-title translate> STATION_LIST </span> </md-card-title-text> </md-card-title> <md-card-content class=station-selector-content> <form name=stationForm layout=row class=station-selector-form> <md-autocomplete required flex md-items=\"station in $ctrl.getMatchedStations($ctrl.searchText)\" md-search-text=$ctrl.searchText md-min-length=0 md-item-text=\"station | stationFormatter\" md-selected-item=selectedStation md-no-cache=true md-input-id=station-input placeholder=\"{{'SELECT_A_STATION' | translate}}\"> <md-item-template> <span md-highlight-text=$ctrl.searchText> {{ station | stationFormatter }} </span> </md-item-template> </md-autocomplete> <md-button type=submit class=\"md-icon-button md-primary md-raised\" ng-disabled=\"stationForm.$invalid || !selectedStation\" ng-click=$ctrl.addToSelectedStations(selectedStation)> <md-icon class=material-icons>add</md-icon> </md-button> </form> <md-content flex class=md-whiteframe-2dp layout=column> <md-radio-group ng-model=$ctrl.highlightedStationId ng-change=$ctrl.onStationRadioChange()> <md-list flex class=station-selector-list> <md-list-item ng-repeat=\"station in $ctrl.selectedStationsArray\" class=md-2-line ng-click=$ctrl.highlightStation(station)> <md-radio-button ng-value=station.id aria-label=\"{{ station | stationFormatter }}\"> </md-radio-button> <div class=md-list-item-text> <h3>{{ station | stationFormatter }}</h3> <h4>{{ station.basin }}</h4> </div> <md-icon class=\"material-icons md-secondary md-warn\" ng-click=$ctrl.removeFromSelectedStations(station)> cancel </md-icon> </md-list-item> </md-list> </md-radio-group> </md-content> </md-card-content> </md-card>";

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var historic_norm_controller_1 = __webpack_require__(534);
	var template = __webpack_require__(535);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: historic_norm_controller_1.default,
	    template: template
	};


/***/ },
/* 534 */
/***/ function(module, exports) {

	"use strict";
	var IMeteostationHistoricNormEvents;
	(function (IMeteostationHistoricNormEvents) {
	    IMeteostationHistoricNormEvents.NEW_DATA_UPLOADED = 'imomo-organization-change';
	})(IMeteostationHistoricNormEvents = exports.IMeteostationHistoricNormEvents || (exports.IMeteostationHistoricNormEvents = {}));
	var StationHistoricNormController = (function () {
	    function StationHistoricNormController(stationApi, s3UploadService, $stateParams, $scope, imomoErrorService, $rootScope) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.s3UploadService = s3UploadService;
	        this.$scope = $scope;
	        this.imomoErrorService = imomoErrorService;
	        this.$rootScope = $rootScope;
	        this.isHistoricalDataLoading = false;
	        var stationId = Number.parseInt($stateParams.stationId);
	        this.stationApi.getMeteoStation({ stationId: stationId }).then(function (station) {
	            _this.station = station;
	            _this.$rootScope.$broadcast('STATION_LOADED', station);
	        }).finally(function () {
	        });
	    }
	    StationHistoricNormController.prototype.uploadNewData = function ($file) {
	        var _this = this;
	        if ($file) {
	            this.isHistoricalDataLoading = true;
	            this.stationApi.uploadHistoricMeteoData(this.station.id, $file)
	                .then(function () {
	                _this.$scope.$broadcast(IMeteostationHistoricNormEvents.NEW_DATA_UPLOADED);
	                _this.isHistoricalDataLoading = false;
	            }).catch(function (error) {
	                _this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	                _this.isHistoricalDataLoading = false;
	            });
	        }
	    };
	    StationHistoricNormController.prototype.downloadHistoricMeteoData = function () {
	        var _this = this;
	        this.isHistoricalDataLoading = true;
	        return this.stationApi.getStationHistoricMeteoDataXLSX(this.station.id)
	            .finally(function () {
	            _this.isHistoricalDataLoading = false;
	        });
	    };
	    StationHistoricNormController.$inject = ['stationApi', 's3UploadService', '$stateParams', '$scope', 'imomoErrorService', '$rootScope'];
	    return StationHistoricNormController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationHistoricNormController;


/***/ },
/* 535 */
/***/ function(module, exports) {

	module.exports = "<section layout=column class=historic-norm-container ng-hide=$ctrl.isLoading layout-padding> <md-card style=overflow:auto flex> <md-tabs flex class=full-height-tabs> <md-tab> <md-tab-label> <span translate>PRECIPITATION_NORM</span> </md-tab-label> <md-tab-body> <imomo-meteostation-data-table type=\"'precipitation'\"></imomo-meteostation-data-table> </md-tab-body> </md-tab> <md-tab> <md-tab-label> <span translate>TEMPERATURE_NORM</span> </md-tab-label> <md-tab-body> <imomo-meteostation-data-table type=\"'temperature'\"></imomo-meteostation-data-table> </md-tab-body> </md-tab> </md-tabs> </md-card> <md-card flex=none class=historic-upload-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-title translate> HISTORICAL_METEOSTATION_DATA </span> </div> </md-toolbar> <p translate> NEW_DATA_MUST_BE_EXCEL </p> <section layout=row layout-align=\"end center\" ng-hide=$ctrl.isHistoricalDataLoading> <md-button ng-href=https://s3.eu-central-1.amazonaws.com/imomo-uploads/meteo_template.xlsx download=meteo-template.xlsx> <span translate>DOWNLOAD_EXAMPLE_FILE</span> </md-button> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.downloadHistoricMeteoData()> <span translate>DOWNLOAD_DATA</span> </md-button> <md-button class=\"md-raised md-primary\" ng-if=!$ctrl.station.isVirtual ngf-select=$ctrl.uploadNewData($file)> <span translate>UPLOAD_NEW_DATA</span> </md-button> </section> <section ng-show=$ctrl.isHistoricalDataLoading class=progress-bar> <md-progress-linear></md-progress-linear> </section> </md-card> </section>";

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var meteo_data_table_controller_1 = __webpack_require__(537);
	var template = __webpack_require__(538);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    controller: meteo_data_table_controller_1.default,
	    bindings: {
	        type: '<'
	    },
	    template: template
	};


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var historic_norm_controller_1 = __webpack_require__(534);
	var StationMeteoDataTableController = (function () {
	    function StationMeteoDataTableController(stationApi, dataValueApi, s3UploadService, $q, $stateParams, $scope) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.dataValueApi = dataValueApi;
	        this.s3UploadService = s3UploadService;
	        this.$q = $q;
	        this.$stateParams = $stateParams;
	        this.$scope = $scope;
	        this.normRows = [];
	        var months = moment.months();
	        for (var i = 0; i < 12; ++i) {
	            this.normRows.push({
	                month: months[i],
	                data: [undefined, undefined, undefined]
	            });
	        }
	        this.$scope.$on(historic_norm_controller_1.IMeteostationHistoricNormEvents.NEW_DATA_UPLOADED, function () {
	            _this.loadData();
	        });
	        this.loadData();
	    }
	    StationMeteoDataTableController.prototype.loadData = function () {
	        var stationId = Number.parseInt(this.$stateParams.stationId);
	        this.loadNorm(stationId);
	    };
	    StationMeteoDataTableController.prototype.loadNorm = function (stationId) {
	        var _this = this;
	        this.clearNormRows();
	        this.normPromise = this.dataValueApi.getStationNorm(stationId, this.type)
	            .then(function (stationNorm) {
	            _this.normStartYear = stationNorm.startYear;
	            _this.normEndYear = stationNorm.endYear;
	            _this.processNorm(stationNorm);
	        });
	    };
	    StationMeteoDataTableController.prototype.clearNormRows = function () {
	        this.normRows.forEach(function (row) {
	            row.data = [undefined, undefined, undefined];
	        });
	    };
	    StationMeteoDataTableController.prototype.processNorm = function (stationNorm) {
	        var currentRow;
	        for (var i = 0; i < stationNorm.normData.length; ++i) {
	            if (i % 3 == 0) {
	                currentRow = this.normRows[Math.floor(i / 3)];
	            }
	            currentRow.data[i % 3] = stationNorm.normData[i];
	        }
	    };
	    StationMeteoDataTableController.$inject = ['stationApi', 'dataValueApi', 's3UploadService', '$q', '$stateParams', '$scope'];
	    return StationMeteoDataTableController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationMeteoDataTableController;


/***/ },
/* 538 */
/***/ function(module, exports) {

	module.exports = "<section layout=column class=historic-norm-container ng-hide=$ctrl.isLoading layout-padding> <div> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-title> <span ng-if=\"$ctrl.type === 'precipitation'\" translate>PRECIPITATION_NORM</span> <span ng-if=\"$ctrl.type === 'temperature'\" translate>TEMPERATURE_NORM</span> <span class=md-subhead> {{$ctrl.normStartYear}} - {{$ctrl.normEndYear}} </span> </span> </div> </md-toolbar> <md-table-container> <table md-table md-progress=$ctrl.normPromise> <thead md-head> <tr md-row> <th md-column></th> <th md-column colspan=3> <span translate>DECADE</span> </th> </tr> <tr md-row> <th md-column> <span translate>MONTH</span> </th> <th md-column md-numeric> <span translate>I</span> </th> <th md-column md-numeric> <span translate>II</span> </th> <th md-column md-numeric> <span translate>III</span> </th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"normRow in $ctrl.normRows\"> <td md-cell>{{ normRow.month }}</td> <td md-cell ng-repeat=\"datum in normRow.data track by $index\"> {{ datum | hydroNumberFormatter }} </td> </tr> </tbody> </table> </md-table-container> </div> </section> <section layout=column class=historic-norm-container ng-show=$ctrl.isLoading layout=row layout-align=\"center center\"> <md-progress-circular></md-progress-circular> </section>";

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var details_controller_1 = __webpack_require__(540);
	var template = __webpack_require__(541);
	var stationDetailsComponent = {
	    controller: details_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = stationDetailsComponent;


/***/ },
/* 540 */
/***/ function(module, exports) {

	"use strict";
	var StationDetailsController = (function () {
	    function StationDetailsController(stationApi, dataValueApi, $q, $stateParams, $state, $mdDialog, $translate, $rootScope) {
	        var _this = this;
	        this.stationApi = stationApi;
	        this.dataValueApi = dataValueApi;
	        this.$q = $q;
	        this.$state = $state;
	        this.$mdDialog = $mdDialog;
	        this.$translate = $translate;
	        this.$rootScope = $rootScope;
	        this.resetDisabled = true;
	        this.saveDisabled = true;
	        var stationId = Number.parseInt($stateParams.stationId);
	        this.loadInProgress = true;
	        var stationPromise = this.stationApi.getMeteoStation({ stationId: stationId });
	        this.$q.all([stationPromise])
	            .then(function (_a) {
	            var station = _a[0];
	            _this.station = station;
	            _this.$rootScope.$broadcast('STATION_LOADED', station);
	            _this.storedStationDetails = {
	                basin: _this.station.basin,
	                code: _this.station.siteCode,
	                country: _this.station.country,
	                location: {
	                    latitude: _this.station.latitude,
	                    longitude: _this.station.longitude
	                },
	                name: _this.station.siteName,
	                region: _this.station.region
	            };
	            _this.resetDetails();
	        }).finally(function () {
	            _this.loadInProgress = false;
	        });
	    }
	    StationDetailsController.prototype.resetDetails = function () {
	        this.stationDetails = this.storedStationDetails;
	        this.resetDisabled = true;
	        this.saveDisabled = true;
	    };
	    StationDetailsController.prototype.onDetailsChange = function (station, isValid) {
	        this.stationDetails = station;
	        this.resetDisabled = angular
	            .equals(this.storedStationDetails, this.stationDetails);
	        this.saveDisabled = this.resetDisabled || !isValid;
	    };
	    StationDetailsController.prototype.saveChanges = function () {
	        var _this = this;
	        this.loadInProgress = true;
	        this.saveDisabled = true;
	        this.resetDisabled = true;
	        this.stationApi.updateMeteoStation(this.station.id, {
	            id: this.station.id,
	            basin: this.stationDetails.basin,
	            country: this.stationDetails.country,
	            latitude: this.stationDetails.location.latitude,
	            longitude: this.stationDetails.location.longitude,
	            region: this.stationDetails.region,
	            siteCode: this.stationDetails.code,
	            siteName: this.stationDetails.name
	        }).then(function () {
	            _this.storedStationDetails = _this.stationDetails;
	            _this.$state.go('meteostation.manager');
	        }).finally(function () {
	            _this.loadInProgress = false;
	        });
	    };
	    StationDetailsController.prototype.delete = function () {
	        var _this = this;
	        var confirm = this.$mdDialog.confirm()
	            .textContent(this.$translate.instant('DELETE_CONFIRMATION', { item: this.station.siteName }))
	            .ok(this.$translate.instant('DELETE'))
	            .cancel(this.$translate.instant('CANCEL'));
	        this.$mdDialog.show(confirm).then(function () {
	            _this.stationApi.deleteMeteoStation(_this.station.id)
	                .then(function () {
	                _this.$state.go('meteostation.manager');
	            });
	        });
	    };
	    StationDetailsController.$inject = ['stationApi', 'dataValueApi', '$q', '$stateParams', '$state', '$mdDialog', '$translate', '$rootScope'];
	    return StationDetailsController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationDetailsController;


/***/ },
/* 541 */
/***/ function(module, exports) {

	module.exports = "<div class=station-details-container layout=column> <md-progress-linear md-mode=indeterminate ng-disabled=!$ctrl.loadInProgress> </md-progress-linear> <imomo-meteostation-details-edit flex layout=row station-details=$ctrl.stationDetails on-change=\"$ctrl.onDetailsChange(station, isValid)\"> </imomo-meteostation-details-edit> <section layout=row layout-align=\"end center\" flex=none> <md-button class=\"md-raised md-warn\" ng-click=$ctrl.delete()> <span translate>DELETE</span> </md-button> <span flex></span> <md-button class=md-raised ng-click=$ctrl.resetDetails() ng-disabled=$ctrl.resetDisabled> <span translate>RESET</span> </md-button> <md-button class=\"md-raised md-primary\" ng-click=$ctrl.saveChanges() ng-disabled=$ctrl.saveDisabled> <span translate>SAVE_CHANGES</span> </md-button> </section> </div>";

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var edit_controller_1 = __webpack_require__(543);
	var template = __webpack_require__(544);
	var detailsEditComponent = {
	    bindings: {
	        stationDetails: '<',
	        onChange: '&'
	    },
	    controller: edit_controller_1.default,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = detailsEditComponent;


/***/ },
/* 543 */
/***/ function(module, exports) {

	"use strict";
	var StationDetailsEditController = (function () {
	    function StationDetailsEditController($scope) {
	        var _this = this;
	        this.$scope = $scope;
	        this.preventMapRefresh = false;
	        this.map = {
	            center: StationDetailsEditController.DEFAULT_CENTER,
	            zoom: StationDetailsEditController.DEFAULT_ZOOM,
	            events: {
	                click: function (map, eventName, _a) {
	                    var mouseEvent = _a[0];
	                    _this.onMapClick(mouseEvent);
	                }
	            },
	            control: {}
	        };
	        this.marker = {
	            id: 'followMarker',
	            coords: this.map.center
	        };
	    }
	    StationDetailsEditController.prototype.$onChanges = function () {
	        this.mutableStation = this.stationDetails
	            ? angular.copy(this.stationDetails)
	            : angular.copy(StationDetailsEditController.DEFAULT_DETAILS);
	        this.marker.coords = this.mutableStation.location;
	        if (this.map.control.refresh && !this.preventMapRefresh) {
	            this.map.control.refresh(this.mutableStation.location);
	        }
	        this.preventMapRefresh = false;
	        if (this.form) {
	            this.form.$setPristine();
	            this.form.$setUntouched();
	        }
	    };
	    StationDetailsEditController.prototype.onLocationInputFieldChange = function () {
	        this.notifyChange();
	        if (this.map.control.refresh) {
	            this.map.control.refresh(this.mutableStation.location);
	        }
	    };
	    StationDetailsEditController.prototype.getMessages = function (formValue) {
	        var errorsCopy = angular.copy(formValue.$error);
	        errorsCopy.$pending = formValue.$pending;
	        return errorsCopy;
	    };
	    Object.defineProperty(StationDetailsEditController.prototype, "form", {
	        get: function () {
	            return this.$scope['stationForm'] || null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StationDetailsEditController.prototype.onMapClick = function (mouseEvent) {
	        var loc = mouseEvent.latLng;
	        this.marker.coords = {
	            latitude: loc.lat(),
	            longitude: loc.lng()
	        };
	        this.mutableStation.location = this.marker.coords;
	        this.preventMapRefresh = true;
	        this.$scope.$applyAsync();
	        this.notifyChange();
	    };
	    ;
	    StationDetailsEditController.prototype.notifyChange = function () {
	        if (this.onChange) {
	            this.onChange({ station: this.mutableStation, isValid: this.form.$valid });
	        }
	    };
	    StationDetailsEditController.$inject = ['$scope'];
	    StationDetailsEditController.DEFAULT_CENTER = { latitude: 42.8746, longitude: 74.5698 };
	    StationDetailsEditController.DEFAULT_ZOOM = 10;
	    StationDetailsEditController.DEFAULT_DETAILS = {
	        code: '',
	        basin: '',
	        region: '',
	        name: '',
	        country: '',
	        location: StationDetailsEditController.DEFAULT_CENTER,
	    };
	    return StationDetailsEditController;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationDetailsEditController;


/***/ },
/* 544 */
/***/ function(module, exports) {

	module.exports = "<div flex layout=row layout-padding> <md-card> <form name=stationForm layout=column> <section layout=row> <md-input-container flex> <label translate>LOCAL_CODE</label> <input name=stationCode unique-meteo-station-code initial-station-code={{::$ctrl.stationDetails.code}} required ng-model=$ctrl.mutableStation.code ng-pattern=\"'[0-9]{5}'\" ng-change=$ctrl.notifyChange()> <div ng-messages=$ctrl.getMessages(stationForm.stationCode) md-auto-hide=false ng-show=stationForm.stationCode.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=pattern translate> INVALID_VALUE </div> <div ng-message=$pending class=pending-form-input translate> VERIFYING </div> <div ng-message=unique translate> CODE_IS_ALREADY_USED </div> </div> </md-input-container> <md-input-container> <label translate>NAME</label> <input name=stationName required ng-model=$ctrl.mutableStation.name ng-change=$ctrl.notifyChange() ng-maxlength=255> <div ng-messages=stationForm.stationName.$error md-auto-hide=false ng-show=stationForm.stationName.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=maxlength translate> VALUE_IS_TOO_LONG </div> </div> </md-input-container> </section> <section layout=row> <md-input-container> <label translate>BASIN</label> <input name=basin required ng-model=$ctrl.mutableStation.basin ng-change=$ctrl.notifyChange() ng-maxlength=255> <div ng-messages=stationForm.basin.$error md-auto-hide=false ng-show=stationForm.basin.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=maxlength translate> VALUE_IS_TOO_LONG </div> </div> </md-input-container> <md-input-container> <label translate>REGION</label> <input name=region ng-model=$ctrl.mutableStation.region required ng-change=$ctrl.notifyChange() ng-maxlength=255> <div ng-messages=stationForm.region.$error md-auto-hide=false ng-show=stationForm.region.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=maxlength translate> VALUE_IS_TOO_LONG </div> </div> </md-input-container> </section> <md-input-container> <label translate>COUNTRY</label> <input name=country required ng-model=$ctrl.mutableStation.country ng-change=$ctrl.notifyChange() ng-maxlength=255> <div ng-messages=stationForm.country.$error md-auto-hide=false ng-show=stationForm.country.$touched> <div ng-message=required translate> VALUE_IS_REQUIRED </div> <div ng-message=maxlength translate> VALUE_IS_TOO_LONG </div> </div> </md-input-container> <div layout=column> <label translate>LOCATION</label> <div layout=row> <md-input-container> <input class=md-input required type=number min=-85 max=85 placeholder=Latitude ng-change=$ctrl.onLocationInputFieldChange() ng-model=$ctrl.mutableStation.location.latitude> </md-input-container> <md-input-container> <input class=md-input required type=number min=-180 max=180 placeholder=Longitude ng-change=$ctrl.onLocationInputFieldChange() ng-model=$ctrl.mutableStation.location.longitude> </md-input-container> </div> </div> </form> </md-card> <div layout=column flex> <ui-gmap-google-map flex center=$ctrl.map.center zoom=$ctrl.map.zoom options=$ctrl.map.options events=$ctrl.map.events control=$ctrl.map.control class=edit-details-map layout=column> <ui-gmap-marker idkey=$ctrl.marker.id coords=$ctrl.marker.coords></ui-gmap-marker> </ui-gmap-google-map> </div> </div>";

/***/ },
/* 545 */
/***/ function(module, exports) {

	"use strict";
	var stationFormatterFactory = function () {
	    return function (station) { return station &&
	        station.siteCode + " - " + station.siteName; };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = stationFormatterFactory;


/***/ },
/* 546 */
/***/ function(module, exports) {

	"use strict";
	function uniqueStationCodeFactory(stationApi, $q, $mdDialog, $translate, imomoErrorService) {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function (scope, el, attrs, ngModel) {
	            ngModel.$asyncValidators.unique = function (stationCode) {
	                var initialCode = attrs['initialStationCode'];
	                var deferred = $q.defer();
	                if (stationCode == initialCode) {
	                    deferred.resolve();
	                }
	                else {
	                    stationApi.isMeteoStationCodeUnique(stationCode)
	                        .then(function (httpData) {
	                        if (httpData.available) {
	                            stationApi.isDischargeStationCodeUnique(stationCode, false)
	                                .then(function (httpData) {
	                                if (!httpData.available) {
	                                    var dialog = $mdDialog.alert()
	                                        .title($translate.instant('STATION_PAIR_NOTIFICATION', { stationCode: stationCode, stationType: 'Discharge' }))
	                                        .textContent($translate.instant('STATION_PAIR_NOTIFICATION_EXTENDED', { stationCode: stationCode, stationType: 'Discharge' }))
	                                        .ok($translate.instant('OK'));
	                                    $mdDialog.show(dialog);
	                                }
	                                deferred.resolve();
	                            });
	                            deferred.resolve();
	                        }
	                        else {
	                            imomoErrorService.showErrorDetailsDialog(httpData.message);
	                            deferred.reject();
	                        }
	                    }).catch(function (errData) {
	                        deferred.reject();
	                    });
	                }
	                return deferred.promise;
	            };
	        }
	    };
	}
	exports.uniqueStationCodeFactory = uniqueStationCodeFactory;
	uniqueStationCodeFactory.$inject = ['stationApi', '$q', '$mdDialog', '$translate', 'imomoErrorService'];


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var immutable_1 = __webpack_require__(195);
	var StationSelectorService = (function () {
	    function StationSelectorService($window, $log) {
	        this.$window = $window;
	        this.$log = $log;
	    }
	    StationSelectorService.prototype.getStoredStations = function (key, availableStations) {
	        var storedObject;
	        try {
	            storedObject = this.$window.localStorage
	                .getItem(StationSelectorService.STORAGE_KEY_PREFIX + "." + key);
	        }
	        catch (error) {
	            this.$log.error('Local storage is not available.', error);
	        }
	        if (!storedObject) {
	            return immutable_1.Set();
	        }
	        try {
	            var parsedObject = JSON.parse(storedObject);
	            if (parsedObject instanceof Array) {
	                var stationIds_1 = immutable_1.Set(parsedObject);
	                return availableStations.filter(function (station) {
	                    return stationIds_1.contains(station.id);
	                }).toSet();
	            }
	            else {
	                this.clearStoredList(key);
	                return immutable_1.Set();
	            }
	        }
	        catch (error) {
	            this.$log.error("Stored object in key " + key + " is not valid.", error);
	            this.clearStoredList(key);
	            return immutable_1.Set();
	        }
	    };
	    StationSelectorService.prototype.storeStations = function (key, stationList) {
	        try {
	            this.$window.localStorage
	                .setItem(StationSelectorService.STORAGE_KEY_PREFIX + "." + key, JSON.stringify(stationList.map(function (station) { return station.id; }).toArray()));
	        }
	        catch (error) {
	            this.$log.error('Could not store station list.');
	        }
	    };
	    StationSelectorService.prototype.clearStoredList = function (key) {
	        try {
	            this.$window.localStorage
	                .removeItem(StationSelectorService.STORAGE_KEY_PREFIX + "." + key);
	        }
	        catch (error) {
	            this.$log.error('Could not clear stored object.', error);
	        }
	    };
	    StationSelectorService.$inject = ['$window', '$log'];
	    StationSelectorService.STORAGE_KEY_PREFIX = 'imomo.stationStorage';
	    return StationSelectorService;
	}());
	exports.StationSelectorService = StationSelectorService;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StationSelectorService;


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var timeseries_controller_1 = __webpack_require__(549);
	var template = __webpack_require__(550);
	var timeseriesComponent = {
	    controller: timeseries_controller_1.TimeseriesController,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = timeseriesComponent;


/***/ },
/* 549 */
/***/ function(module, exports) {

	"use strict";
	var TimeseriesController = (function () {
	    function TimeseriesController() {
	    }
	    return TimeseriesController;
	}());
	exports.TimeseriesController = TimeseriesController;


/***/ },
/* 550 */
/***/ function(module, exports) {

	module.exports = "<div class=station-timeseries-container layout=column flex> <md-card flex> <md-tabs class=full-height-tabs flex md-selected=$ctrl.selectedTabIndex> <md-tab> <md-tab-label> <span translate>PRECIPITATION</span> </md-tab-label> <md-tab-body> <imomo-meteostation-timeseries-graph hydrodata-type=\"'precipitation'\"></imomo-meteostation-timeseries-graph> </md-tab-body> </md-tab> <md-tab> <md-tab-label> <span translate>TEMPERATURE</span> </md-tab-label> <md-tab-body> <imomo-meteostation-timeseries-graph hydrodata-type=\"'temperature'\"></imomo-meteostation-timeseries-graph> </md-tab-body> </md-tab> </md-tabs> </md-card> </div>";

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var timeseries_graph_controller_1 = __webpack_require__(552);
	var template = __webpack_require__(553);
	var timeseriesGraphComponent = {
	    bindings: {
	        hydrodataType: '<'
	    },
	    controller: timeseries_graph_controller_1.TimeseriesGraphController,
	    template: template
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = timeseriesGraphComponent;


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var _ = __webpack_require__(29);
	var TimeseriesGraphController = (function () {
	    function TimeseriesGraphController(dataValueApi, $stateParams, stationApi, $q, $log, $translate, $rootScope) {
	        var _this = this;
	        this.dataValueApi = dataValueApi;
	        this.stationApi = stationApi;
	        this.$q = $q;
	        this.$log = $log;
	        this.$translate = $translate;
	        this.$rootScope = $rootScope;
	        this.stationId = Number.parseInt($stateParams.stationId);
	        this.startYear = moment().year();
	        this.endYear = moment().year();
	        this.loadingInProgress = true;
	        this.stationApi.getMeteoStation({ stationId: this.stationId })
	            .then(function (station) {
	            _this.station = station;
	            _this.$rootScope.$broadcast('STATION_LOADED', station);
	            return _this.loadTimeseries();
	        });
	    }
	    TimeseriesGraphController.prototype.loadTimeseries = function () {
	        var _this = this;
	        this.loadingInProgress = true;
	        this.hydrodataTimeseries = [];
	        var hydrodataPromises = _.range(this.startYear, this.endYear + 1)
	            .map(function (year) { return _this.dataValueApi.getYearDailyAverageData(_this.stationId, year, _this.hydrodataType); });
	        this.$q.all(hydrodataPromises)
	            .then(function (hydrodataSeries) {
	            _this.hydrodataSeries = hydrodataSeries;
	            var hydrodataTimeseries = _this.hydrodataSeries
	                .map(function (hydrodataSeries, index) {
	                if (hydrodataSeries.length == 0) {
	                    return null;
	                }
	                return averageDischargeToDischargeTimeseries(hydrodataSeries, _this.startYear + index);
	            })
	                .filter(function (timeseries) { return timeseries; });
	            return _this.dataValueApi.getStationNorm(_this.stationId, _this.hydrodataType)
	                .then(function (hydrodataNorm) {
	                hydrodataTimeseries.push(_this.hydrodataNormToDischargeTimeseries(hydrodataNorm));
	                _this.hydrodataTimeseries = hydrodataTimeseries;
	                _this.loadingInProgress = false;
	            });
	        })
	            .catch(function (error) {
	            _this.$log.error('Error loading ' + _this.hydrodataType + ' data.', error);
	            _this.loadingInProgress = false;
	        });
	    };
	    TimeseriesGraphController.prototype.hydrodataNormToDischargeTimeseries = function (hydrodataNorm) {
	        return {
	            data: hydrodataNorm.normData.map(function (datum, index) {
	                var month = Math.floor(index / 3);
	                var year = month >= 9 ? moment().year() - 1 : moment().year();
	                return {
	                    hydrodata: datum,
	                    date: moment()
	                        .year(year)
	                        .month(month)
	                        .date((index % 3) * 10 + 5)
	                        .startOf('day')
	                };
	            }).sort(function (datumA, datumB) {
	                if (datumA.date.isBefore(datumB.date)) {
	                    return -1;
	                }
	                else if (datumA.date.isAfter(datumB.date)) {
	                    return 1;
	                }
	                return 0;
	            }),
	            label: this.$translate.instant('HISTORICAL_NORM')
	        };
	    };
	    TimeseriesGraphController.$inject = ['dataValueApi', '$stateParams',
	        'stationApi', '$q', '$log', '$translate', '$rootScope'];
	    return TimeseriesGraphController;
	}());
	exports.TimeseriesGraphController = TimeseriesGraphController;
	function averageDischargeToDischargeTimeseries(hydrodataSeries, year) {
	    return {
	        data: hydrodataSeries.map(function (avarageHydrodataData) {
	            return {
	                hydrodata: avarageHydrodataData.dataValue,
	                date: moment.unix(avarageHydrodataData.localDateTime)
	            };
	        }),
	        label: "" + year
	    };
	}


/***/ },
/* 553 */
/***/ function(module, exports) {

	module.exports = "<div class=station-timeseries-container layout=column flex> <md-progress-linear ng-disabled=!$ctrl.loadingInProgress> </md-progress-linear> <div layout=row class=station-timeseries-header-bar> <div layout=column> <span class=md-title translate ng-if=\"$ctrl.hydrodataType === 'precipitation'\"> MEASURED_PRECIPITATION_TIME_SERIES </span> <span class=md-title translate ng-if=\"$ctrl.hydrodataType === 'temperature'\"> MEASURED_TEMPERATURE_TIME_SERIES </span> <span class=md-subhead> {{ $ctrl.station | stationFormatter }} </span> </div> <div flex></div> <form name=$ctrl.yearForm layout=row> <md-input-container> <label translate> INITIAL_YEAR </label> <input name=startYear required max={{$ctrl.endYear}} ng-disabled=$ctrl.loadingInProgress type=number step=1 ng-model=$ctrl.startYear> </md-input-container> <md-input-container> <label translate> FINAL_YEAR </label> <input name=endYear required min={{$ctrl.startYear}} ng-disabled=$ctrl.loadingInProgress type=number step=1 ng-model=$ctrl.endYear> </md-input-container> <div> <md-button class=\"md-raised md-primary\" type=submit ng-disabled=\"$ctrl.yearForm.$invalid || $ctrl.loadingInProgress\" ng-click=$ctrl.loadTimeseries()> <span translate> LOAD_GRAPH </span> </md-button> </div> </form> </div> <md-divider></md-divider> <hydromet-timeseries-new ng-if=$ctrl.hydrodataTimeseries.length timeseries=$ctrl.hydrodataTimeseries hydrodata-type=$ctrl.hydrodataType></hydromet-timeseries-new> </div>";

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var moment_formatter_1 = __webpack_require__(555);
	var location_formatter_1 = __webpack_require__(556);
	var hydrological_number_formatter_1 = __webpack_require__(557);
	var hydrological_discharge_number_formatter_1 = __webpack_require__(558);
	var s3_upload_service_1 = __webpack_require__(559);
	var moment_formatter_2 = __webpack_require__(555);
	var chart_color_service_1 = __webpack_require__(356);
	var debug_interceptor_1 = __webpack_require__(560);
	var imomo_visible_directive_1 = __webpack_require__(561);
	var ice_phenomena_formatter_1 = __webpack_require__(562);
	var user_permissions_directive_1 = __webpack_require__(563);
	var number_range_formatter_1 = __webpack_require__(564);
	var ordinal_number_formatter_1 = __webpack_require__(565);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('imomo.utils', [])
	    .config(debug_interceptor_1.default)
	    .directive('imomoVisible', imomo_visible_directive_1.default)
	    .directive('userPermissions', user_permissions_directive_1.default)
	    .filter('momentFormatter', moment_formatter_1.default)
	    .filter('unixTimestampFormatter', moment_formatter_2.UnixTimestampFormatter)
	    .filter('locationFormatter', location_formatter_1.default)
	    .filter('hydroDischargeNumberFormatter', hydrological_discharge_number_formatter_1.default)
	    .filter('hydroNumberFormatter', hydrological_number_formatter_1.default)
	    .filter('icePhenomenaFormatter', ice_phenomena_formatter_1.default)
	    .filter('numberRangeFormatter', number_range_formatter_1.default)
	    .filter('ordinalNumberFormatter', ordinal_number_formatter_1.default)
	    .service('s3UploadService', s3_upload_service_1.default)
	    .service('chartColorService', chart_color_service_1.default)
	    .name;
	// Modification to the moment library to facilitate JSON transmission.
	moment.fn.toJSON = function () {
	    return this.format();
	};


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	function MomentFormatter() {
	    return function (input, formatType) {
	        if (!input) {
	            return '∞';
	        }
	        input = moment(input);
	        if (input && (moment.isMoment(input) || moment.isDate(input))) {
	            var momentInput = moment(input);
	            switch (formatType) {
	                case 'overriddenDate-time':
	                    return momentInput.format('lll');
	                case 'date':
	                    return momentInput.format('LL');
	                case 'time':
	                    return momentInput.format('LT');
	                case 'month':
	                    return momentInput.format('MMM YYYY');
	                case 'month-long':
	                    return momentInput.format('MMMM YYYY');
	                case 'year':
	                    return momentInput.format('YYYY');
	                case 'roman':
	                    return momentInput.locale('en-roman-months').format('D.MMM');
	                case 'day':
	                    return momentInput.format('Do, dddd');
	                default:
	                    return momentInput.format('LL');
	            }
	        }
	        return null;
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = MomentFormatter;
	function UnixTimestampFormatter() {
	    return function (input) {
	        if (input) {
	            return moment.unix(input);
	        }
	        return null;
	    };
	}
	exports.UnixTimestampFormatter = UnixTimestampFormatter;
	moment.locale('en-roman-months', {
	    monthsShort: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII',
	        'VIII', 'IX', 'X', 'XI', 'XII'
	    ]
	});
	moment.locale('en');


/***/ },
/* 556 */
/***/ function(module, exports) {

	"use strict";
	function LocationFormatter($filter) {
	    var numberFilter = $filter('number');
	    return function (input) {
	        var lat = numberFilter(input.latitude);
	        var lng = numberFilter(input.longitude);
	        return lat + ", " + lng;
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = LocationFormatter;
	LocationFormatter.$inject = ['$filter'];


/***/ },
/* 557 */
/***/ function(module, exports) {

	"use strict";
	function HydrologicalNumberFormatter() {
	    return function (input, defaultText) {
	        if (defaultText === void 0) { defaultText = '---'; }
	        if (input == null) {
	            return defaultText;
	        }
	        var value = Number.parseFloat(input.toString());
	        if (Number.isNaN(value)) {
	            return defaultText;
	        }
	        if (value > 999) {
	            return Math.round(value).toString();
	        }
	        else {
	            return parseFloat(value.toPrecision(3)).toString();
	        }
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = HydrologicalNumberFormatter;


/***/ },
/* 558 */
/***/ function(module, exports) {

	"use strict";
	function HydrologicalDischargeNumberFormatter() {
	    return function (input, defaultText) {
	        if (defaultText === void 0) { defaultText = '---'; }
	        if (input == null) {
	            return defaultText;
	        }
	        var value = Number.parseFloat(input.toString());
	        if (Number.isNaN(value)) {
	            return defaultText;
	        }
	        var decimals = countDecimals(value);
	        var decimalsForRounding;
	        if ((decimals === 1 || decimals === 0) ||
	            (decimals === 2 && value < 10)) {
	            decimalsForRounding = decimals;
	        }
	        else {
	            decimalsForRounding = decimals - 1;
	        }
	        var tenPowerByDecimalsForRounding = Math.pow(10, decimalsForRounding);
	        if (value >= 1000) {
	            return (Math.round(value / 10) * 10).toString();
	        }
	        else {
	            return (Math.round(value * tenPowerByDecimalsForRounding) / tenPowerByDecimalsForRounding).toPrecision(3);
	        }
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = HydrologicalDischargeNumberFormatter;
	function countDecimals(value) {
	    if (Math.floor(value) !== value)
	        return value.toString().split(".")[1].length || 0;
	    return 0;
	}


/***/ },
/* 559 */
/***/ function(module, exports) {

	"use strict";
	var S3UploadService = (function () {
	    function S3UploadService(accessTokenApi, uploadService) {
	        this.accessTokenApi = accessTokenApi;
	        this.uploadService = uploadService;
	    }
	    S3UploadService.prototype.uploadFileToS3 = function (file) {
	        var _this = this;
	        return this.accessTokenApi.getAwsFormData().then(function (formData) {
	            formData.fields.key = formData.fields.key + "/" + file.name;
	            var uploadData = formData.fields;
	            uploadData.file = file;
	            uploadData['Content-Type'] = file.type;
	            return _this.uploadService.upload({
	                url: formData.action,
	                data: uploadData,
	                method: 'POST'
	            }).then(function () {
	                return file.name;
	            });
	        });
	    };
	    S3UploadService.$inject = ['accessTokenApi', 'Upload'];
	    return S3UploadService;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = S3UploadService;


/***/ },
/* 560 */
/***/ function(module, exports) {

	"use strict";
	var debugInterceptorFactory = function ($timeout) {
	    return {
	        response: function (response) {
	            return $timeout(function () {
	                return response;
	            }, 0);
	        }
	    };
	};
	debugInterceptorFactory.$inject = ['$timeout'];
	var configInterceptor = function ($httpProvider) {
	    $httpProvider.interceptors.push(debugInterceptorFactory);
	};
	configInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = configInterceptor;


/***/ },
/* 561 */
/***/ function(module, exports) {

	"use strict";
	var imomoVisibleFactory = function () {
	    return {
	        restrict: 'A',
	        multiElement: true,
	        link: function (scope, element, attr) {
	            scope.$watch(attr['imomoVisible'], function (visible) {
	                angular.forEach(element, function (node) {
	                    if (node.style) {
	                        node.style
	                            .setProperty('visibility', visible ? 'visible' : 'hidden');
	                    }
	                });
	            });
	        }
	    };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = imomoVisibleFactory;


/***/ },
/* 562 */
/***/ function(module, exports) {

	"use strict";
	function IcePhenomenaFormatter($translate) {
	    return function (input, defaultText) {
	        if (defaultText === void 0) { defaultText = '---'; }
	        if (!input) {
	            return defaultText;
	        }
	        var icePhenomenae = [];
	        angular.forEach(input, function (inputValue) {
	            icePhenomenae.push(parse(inputValue));
	        });
	        function parse(inputValue) {
	            if (inputValue.dataValue === null) {
	                return defaultText;
	            }
	            var value = Number.parseFloat(inputValue.dataValue.toString());
	            if (Number.isNaN(value)) {
	                return defaultText;
	            }
	            var icePhenomenaCode = value.toFixed(0);
	            var icePhenomenaName = $translate.instant("ICE_PHENOMENA_" + icePhenomenaCode);
	            var icePhenomenaIntensity = (value % 1) * 1000;
	            if (inputValue.dataValue.toString().indexOf('.') !== -1) {
	                icePhenomenaIntensity = icePhenomenaIntensity.toFixed(0) + '%';
	            }
	            else {
	                icePhenomenaIntensity = defaultText;
	            }
	            return icePhenomenaName + ' (' + icePhenomenaIntensity + ')';
	        }
	        return icePhenomenae.join(', ');
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = IcePhenomenaFormatter;
	IcePhenomenaFormatter.$inject = ['$translate'];


/***/ },
/* 563 */
/***/ function(module, exports) {

	"use strict";
	function userPermissionsFactory(userApi, $stateParams) {
	    return {
	        restrict: 'A',
	        scope: {
	            userPermissions: '<'
	        },
	        link: function (scope, el, attrs) {
	            scope.$watch(attrs['userPermissions'], function (visible) {
	                var cachedDisplayValue = el.css('display');
	                el.css('display', 'none');
	                userApi.getCurrentUser()
	                    .then(function (data) {
	                    scope['userPermissions'].forEach(function (permission) {
	                        if (permission === data.role ||
	                            permission === 'current_user' &&
	                                (parseInt($stateParams.id, 10) === data.id || $stateParams.id === "me")) {
	                            el.css('display', cachedDisplayValue);
	                            return;
	                        }
	                    });
	                });
	            });
	        }
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = userPermissionsFactory;
	userPermissionsFactory.$inject = ['userApi', '$stateParams'];


/***/ },
/* 564 */
/***/ function(module, exports) {

	"use strict";
	function numberRangeFormatter() {
	    return function (input, start, end) {
	        for (var i = start; i <= end; i++) {
	            input.push(i);
	        }
	        return input;
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = numberRangeFormatter;


/***/ },
/* 565 */
/***/ function(module, exports) {

	"use strict";
	function ordinalNumberFormatter() {
	    return function (input) {
	        var inputString = input.toString();
	        var inputStringEnd = inputString.slice(inputString.length - 1);
	        var ordinalNumber;
	        if (inputStringEnd === '1' && input !== 11) {
	            ordinalNumber = input + 'st';
	        }
	        else if (inputStringEnd === '2' && input !== 12) {
	            ordinalNumber = input + 'nd';
	        }
	        else if (inputStringEnd === '3' && input !== 13) {
	            ordinalNumber = input + 'rd';
	        }
	        else {
	            ordinalNumber = input + 'th';
	        }
	        return ordinalNumber;
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ordinalNumberFormatter;


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(45);
	var localeEn = __webpack_require__(567);
	var localeRu = __webpack_require__(568);
	function translateSources($translateProvider) {
	    $translateProvider
	        .translations('en', localeEn)
	        .translations('ru', localeRu)
	        .preferredLanguage('en').fallbackLanguage('en')
	        .useSanitizeValueStrategy('escapeParameters')
	        .useLocalStorage()
	        .useMessageFormatInterpolation();
	}
	exports.translateSources = translateSources;
	translateSources.$inject = ['$translateProvider'];
	/**
	 * Ensure that the moment locale is always up to date with the language
	 * in angular-translate.
	 * @param $rootScope Event bus to listen to changes in the language.
	 * @param $translate The initial language selection is retrieved from this.
	 * @param $log Logging of debug information..
	 */
	function adjustMomentLocale($rootScope, $translate, $log) {
	    $rootScope.$on('$translateChangeStart', function ($event, args) {
	        // I guess that the following line doesn't work because of:
	        //https://github.com/moment/moment/issues/1797
	        moment.locale(args.language);
	        $log.debug("Language changing to " + args.language + "\n                    from " + $translate.proposedLanguage() + ".");
	    });
	    moment.locale($translate.proposedLanguage());
	}
	exports.adjustMomentLocale = adjustMomentLocale;
	adjustMomentLocale.$inject = ['$rootScope', '$translate', '$log'];


/***/ },
/* 567 */
/***/ function(module, exports) {

	module.exports = {
		"IMOMO_CENTRAL_ASIA": "iEasyHydro",
		"USERNAME_OR_PASSWORD_WRONG": "The username or password is wrong.",
		"USER_NOT_APPROVED_ORGANIZATION": "The user has not been approved by the organization.",
		"H_Q_TABLE": "H/Q Table",
		"MINIMUM_H_CM": "Minimum H (cm)",
		"MAXIMUM_H_CM": "Maximum H (cm)",
		"MINIMUM_Q_M3_S": "Minimum Q (m<sup>3</sup>/s)",
		"MAXIMUM_Q_M3_S": "Maximum Q (m<sup>3</sup>/s)",
		"APPLY": "Apply",
		"DISCHARGE_DATA": "Discharge data",
		"DELETE_SELECTED_ARTIFICIAL_DATA": "Delete selected artificial data",
		"DATE": "Date",
		"WATER_LEVEL": "Water level",
		"DISCHARGE": "Discharge",
		"CM": "cm",
		"M3_S": "m<sup>3</sup>/s",
		"ADD_DISCHARGE_DATA_POINT": "Add discharge data point",
		"H_CM": "H (cm)",
		"Q_M3_S": "Q (m<sup>3</sup>/s)",
		"H_CM_OLD": "H (cm) - old",
		"Q_M3_S_OLD": "Q (m<sup>3</sup>/s) - old",
		"CANCEL": "Cancel",
		"ADD": "Add",
		"DISCHARGE_MODELS": "Discharge models",
		"SHOW_HIDDEN_MODELS": "Show hidden models",
		"DELETE_DISCHARGE_MODEL": "Delete discharge model",
		"DELETE_DISCHARGE_MODEL_EXTENDED": "Deleting a discharge model will recalculate any associated discharge values using the previous model. This action is permanent.",
		"DELETE": "Delete",
		"NON_EXISTENT_STATION_CODE": "Non-existent station code",
		"NON_EXISTENT_STATION_CODE_EXTENDED": "There is no station with code {stationCode} in the system.",
		"FORBIDDEN_STATION_CODE": "Forbidden station code",
		"FORBIDDEN_STATION_CODE_EXTENDED": "The station with code {stationCode} belongs to a different organization.",
		"UNEXPECTED_ERROR": "Unexpected error",
		"UNEXPECTED_ERROR_EXTENDED": "An unexpected error has occurred. Please try again and if the error persists please contact the support person.",
		"OK": "Ok",
		"TRY_AGAIN": "Try again",
		"ACCOUNT": "Account",
		"ORGANIZATION": "Organization",
		"LOG_IN": "Log in",
		"LOG_OUT": "Log out",
		"MENU": "Menu",
		"HOME": "Home",
		"TOOLS": "Tools",
		"OPERATIONAL_HYDROLOGY": "Operational Hydrology",
		"DISCHARGE_FORECASTING": "Discharge Forecasting",
		"STATION_MANAGEMENT": "Station Management",
		"HELP": "Help",
		"FEEDBACK": "Feedback",
		"SETTINGS": "Settings",
		"ABOUT_US": "About us",
		"USERS": "Users",
		"IMOMO_HYDROMETEOROLOGY": "iMoMo Hydrometeorology",
		"WELCOME_BACK": "Welcome back!",
		"CLOUD_AUTOMATED_WORKSTATION_OF_THE_OPERATIONAL_HYDROLOGIST": "Cloud automated workstation of the operational hydrologist",
		"1_PROCESSING_OF_KH_15_TELEGRAMS_WITH_DAILY_HYDROLOGICAL_DATA": "1. Processing of KH-15 telegrams with daily hydrological data.",
		"2_CREATION_AND_MODIFICATION_OF_OPERATIONAL_DISCHARGE_RATION_CURVES": "2. Creation and modification of operational discharge ration curves.",
		"3_CALCULATION_OF_CURRENT_AND_DAILY_AVERAGE_HYDROLOGICAL_VALUES": "3. Calculation of current and daily average hydrological values and storage it in the daily operational journal.",
		"4_RELEASE_OF_THE_DAILY_HYDROLOGICAL_BULLETIN": "4. Release of the daily hydrological bulletin.",
		"5_HYDROLOGICAL_FORECASTING": "5. Hydrological forecasting (daily, pentad, decadal, monthly and seasonal)",
		"NAME": "Name",
		"ADDRESS": "Address",
		"ADMIN_USER": "Admin user",
		"USER_DETAILS": "User details",
		"USERNAME": "Username",
		"PASSWORD": "Password",
		"REPEAT_PASSWORD": "Repeat password",
		"NEW_PASSWORD": "New password",
		"REPEAT_NEW_PASSWORD": "Repeat new password",
		"EMAIL": "Email",
		"EDIT_USER": "Edit user",
		"ADD_USER": "Add user",
		"SAVE": "Save",
		"DELETING": "Deleting",
		"SAVING": "Saving",
		"BACK": "Back",
		"ROLE": "Role",
		"DELETE_USER": "Delete user?",
		"DELETE_ORGANIZATION": "Delete organization?",
		"DELETE_FORECAST_MODEL": "Delete forecast model?",
		"DELETE_CONFIRMATION": "Are you sure you want to delete \"{item}\"?",
		"THIS_FIELD_IS_REQUIRED": "This field is required",
		"THE_VALUE_IS_TOO_LONG": "The value is too long.",
		"THE_VALUE_IS_TOO_SHORT": "The value is too short.",
		"LOGIN": "Login",
		"CREATE_NEW_USER": "Create new user",
		"LOG_IN_AS_GUEST": "Log in as guest",
		"FORGOT_YOUR_PASSWORD": "Forgot your password?",
		"ANNOUNCEMENTS": "Announcements",
		"OPERATIONAL_DATA_INPUT": "Operational Data Input",
		"ENTER_TELEGRAM": "Enter telegram",
		"OPERATIONAL_JOURNAL": "Operational Journal",
		"VIEW_JOURNAL": "View journal",
		"DAILY_OPERATIONAL_BULLETIN": "Daily Operational Bulletin",
		"GENERATE_BULLETIN": "Generate bulletin",
		"TELEGRAM": "Telegram",
		"DISCHARGE_CURVE": "Discharge curve",
		"SAVE_DATA": "Save data",
		"NEXT": "Next",
		"PREVIOUS": "Previous",
		"SUBMIT_DATA": "Submit data",
		"KN15_TELEGRAM": "KN-15 Telegram",
		"STATION": "Station",
		"PROCESS_TELEGRAM": "Process telegram",
		"TELEGRAM_IS_REQUIRED": "Telegram is required.",
		"M2": "m<sup>2</sup>",
		"REPORTED_WATER_LEVEL": "Reported water level",
		"PREVIOUS_DAY": "Previous day",
		"TELEGRAM_DAY": "Telegram day",
		"8_AM": "8:00 AM",
		"8_PM": "8:00 PM",
		"DAILY_AVERAGE": "Daily average",
		"DAILY_CHANGE": "Daily change",
		"WATER_LEVEL_TREND_IS_CORRECT": "Water level trend is correct.",
		"WATER_LEVEL_TREND_WRONG": "Water level trend could not be verified or is wrong.",
		"REPORTED_DISCHARGE": "Reported discharge",
		"CROSS_SECTION_AREA": "Cross-section area",
		"MAXIMUM_DEPTH": "Maximum depth",
		"ICE_PHENOMENA": "Ice phenomena",
		"CODE": "Code",
		"DESCRIPTION": "Description",
		"INTENSITY": "Intensity",
		"DISCHARGE_CALCULATION_DISABLED": "Discharge calculation disabled",
		"ADJUST_DISCHARGE_MODEL": "Adjust discharge model",
		"IDENTIFIER": "Identifier",
		"ADD_DELTA_H": "Add \\u0394H",
		"FIT_TO_SELECTED_DATA": "Fit to selected data",
		"REFERENCE_MODEL": "Reference model",
		"DELTA_H": "\\u0394H",
		"DATA_SELECTED": "{count, plural, =0{No data points selected.} one{Select one more data point.} other{{count} data points selected.} }",
		"NO_NEW_MODEL": "No new model",
		"VALID_FROM": "Valid from",
		"CREATE_MODEL": "Create model",
		"DELETE_MODEL": "Delete model",
		"DISCHARGE_MODEL": "Discharge model",
		"PROCESSED_DATA": "Processed data",
		"AVERAGE": "Average",
		"MONTH": "Month",
		"YEAR": "Year",
		"LOAD_JOURNAL": "Load journal",
		"DAILY_DATA": "Daily data",
		"TREND": "Trend",
		"WATER_CELSIUS": "Water (℃)",
		"AIR_CELSIUS": "Air (℃)",
		"ICE": "Ice",
		"MINIMUM": "Minimum",
		"MAXIMUM": "Maximum",
		"EDIT_SELECTED_ROW": "Edit selected row",
		"EDIT_DAILY_DATA_ROW": "Edit daily data row",
		"APPLY_CHANGES": "Apply changes",
		"H_8_AM": "H (8:00am)",
		"H_8_PM": "H (8:00pm)",
		"H_AVERAGE": "H (Average):",
		"DAILY_DATA_WAS_EDITED": "Daily data was edited.",
		"ERROR_UPDATING_DATA": "An error occurred while updating the data. Please try again.",
		"DELETE_SELECTED_ROW_FROM_DATABASE": "Delete selected row from database",
		"F_M2": "F (m2)",
		"EDIT_METEO_ROW": "Edit meteo row",
		"EDIT_DISCHARGE_ROW": "Edit discharge row",
		"METEO_DATA_WAS_EDITED": "Meteo data was edited.",
		"DISCHARGE_DATA_WAS_EDITED": "Discharge data was edited.",
		"ERROR_UPDATING_DISCHARGE_DATA": "An error occurred while updating the discharge data. Please try again.",
		"DELETE_DISCHARGE_DATA": "Delete discharge data",
		"DELETE_DATA_WARNING": "Are you sure you want to delete this data. This action is permanent.",
		"DISCHARGE_DATA_WAS_DELETED": "Discharge data was deleted.",
		"ERROR_DELETING_DISCHARGE_DATA": "An error occurred with deleting the discharge data. Please try again.",
		"DECADAL_DATA": "Decadal data",
		"DECADE": "Decade",
		"MONTHLY_AVERAGE": "Monthly average",
		"OPERATIONAL_BULLETIN": "Operational Bulletin",
		"BULLETIN_DATE": "Bulletin date",
		"PREPARE_BULLETIN": "Prepare bulletin",
		"DOWNLOAD_BULLETIN": "Download bulletin",
		"HYDROLOGICAL_DISCHARGE_STATIONS": "Hydrological Discharge Stations",
		"STATION_CODE": "Station Code",
		"STATION_NAME": "Station Name",
		"REGION": "Region",
		"RIVER_BASIN": "River Basin",
		"ADD_STATION": "Add station",
		"EDIT_STATION": "Edit station",
		"SHOW_DISCHARGE_CURVES": "Show discharge curves",
		"SHOW_DISCHARGE_TIME_SERIES": "Show discharge time series",
		"SHOW_HISTORIC_DATA": "Show historic data",
		"STEP_1_DETAILS": "Step 1: Details",
		"STATION_DETAILS": "Station details",
		"LOCAL_CODE": "Local Code",
		"BASIN": "Basin",
		"COUNTRY": "Country",
		"LOCATION": "Location",
		"MAXIMUM_DISCHARGE_LEVEL_M3_S": "Dangerous discharge (m3/s)",
		"VALUE_IS_REQUIRED": "Value is required.",
		"INVALID_VALUE": "Invalid value.",
		"VERIFYING": "Verifying...",
		"CODE_IS_ALREADY_USED": "Code is already used.",
		"VALUE_IS_TOO_LONG": "Value is too long.",
		"STEP_2_AGGREGATIONS": "Step 2: Aggregations",
		"STEP_2_DISCHARGE_CURVE": "Step 2: Discharge Curve",
		"DISCHARGE_POINTS": "Discharge points",
		"WATER_LEVEL_CM": "Water level (cm)",
		"DISCHARGE_M3_S": "Discharge (m3/s)",
		"EG_INITIAL_STATION_MODEL": "E.g. Initial station model",
		"SHOW_H_Q_TABLE": "Show H/Q table",
		"AN_IDENTIFIER_IS_REQUIRED": "An identifier is required.",
		"IDENTIFIER_IS_TOO_LONG": "Identifier is too long.",
		"MODEL_H_Q_TABLE": "Model's H-Q table",
		"STEP_3_HISTORICAL_DISCHARGE_DATA": "Step 3: Historical Discharge Data",
		"HISTORICAL_DISCHARGE_DATA_UPLOAD": "Historical data upload",
		"PLEASE_UPLOAD_HISTORICAL_METEO": "Please upload the historical 10-day meteo data for the station.",
		"PLEASE_UPLOAD_HISTORICAL": "Please upload the historical 10-day discharge data for the station.",
		"DATA_AVAILABLE_FOR_DOWNLOAD": "The data will be always available for download and can be updated at any time.",
		"DATA_MUST_BE_EXCEL": "The data must be uploaded as an Excel (.xls/.xlsx) file with the same format as the example file.",
		"NO_FILE_SELECTED": "No file selected",
		"DOWNLOAD_EXAMPLE_FILE": "Download example file",
		"SELECT_FILE": "Select file",
		"CHANGE": "Change",
		"VALIDATE": "Validate",
		"VALIDATED": "Validated",
		"STEP_4_REVIEW_AND_CREATE": "Step 4: Review and Create",
		"CREATE_STATION": "Create station",
		"STATUS": "Status",
		"HISTORICAL_DISCHARGE_DATA": "Historical discharge data",
		"DONE": "Done",
		"PENDING": "Pending",
		"CREATE": "Create",
		"STATION_LIST": "Station list",
		"SELECT_A_STATION": "Select a station",
		"DISCHARGE_NORM": "Discharge norm",
		"I": "I",
		"II": "II",
		"III": "III",
		"NEW_DATA_MUST_BE_EXCEL": "New data must be uploaded as an Excel (.xls/.xlsx) file with the same format as the example file.",
		"DOWNLOAD_DATA": "Download data",
		"UPLOAD_NEW_DATA": "Upload new data",
		"HYDROLOGICAL_YEAR": "Hydrological year",
		"CHANGE_YEAR": "Change year",
		"NEW_DISCHARGE_MODEL": "New discharge model",
		"MODEL_IDENTIFIER": "Model identifier",
		"NEW_MODEL": "New model",
		"SAVE_NEW_MODEL": "Save new model",
		"MEASURED_PRECIPITATION_TIME_SERIES": "Measured precipitation time series",
		"MEASURED_TEMPERATURE_TIME_SERIES": "Measured temperature time series",
		"MEASURED_DISCHARGE_TIME_SERIES": "Measured discharge time series",
		"LOAD_GRAPH": "Load graph",
		"INITIAL_YEAR": "Initial year",
		"FINAL_YEAR": "Final year",
		"HISTORICAL_NORM": "Historical norm",
		"RESET": "Reset",
		"SAVE_CHANGES": "Save changes",
		"PHONE": "Phone",
		"REQUEST_ACCESS": "Request access",
		"ADD_ORGANIZATION": "Add organization",
		"AGGREGATION": "Aggregation",
		"WEIGHTING": "Weighting",
		"ORGANIZATION_NAME": "Organization name",
		"ORGANIZATION_ADDRESS": "Organization address",
		"CITY": "City",
		"ZIP_CODE": "ZIP code",
		"ADMINISTRATORS": "Administrators",
		"NO_ADMINS": "There is no administrators in this organization.",
		"SEND": "Send",
		"RESET_PASSWORD": "Reset password",
		"RESETING": "Reseting",
		"PASSWORDS_NOT_MATCHING": "Passwords do not match.",
		"CHANGE_PASSWORD": "Change password",
		"OLD_PASSWORD": "Old password",
		"PROCESSING": "Processing...",
		"NO_STATIONS": "No stations were found",
		"SEARCH_STATIONS_PLACEHOLDER": "Search stations by 'siteName' or 'siteCode'",
		"ADD_VIRTUAL_STATION": "Add virtual station",
		"VIRTUAL_STATION": "Virtual station",
		"EDIT_ORGANIZATION": "Edit organization",
		"DISCHARGE_STATIONS": "Discharge stations",
		"METEOSTATIONS": "Meteostations",
		"HISTORICAL_DATA": "Historical data",
		"STEP_2_HISTORICAL_DATA": "Step 2: Historical Data",
		"ADD_METEOSTATION": "Add meteostation",
		"SHOW_TIME_SERIES": "Show time series",
		"EDIT_METEOSTATION": "Edit meteostation",
		"HYDROLOGICAL_METEOSTATIONS": "Hydrological Meteostations",
		"HISTORICAL_PRECIPITATION_DATA": "Historical Precipitation Data",
		"HISTORICAL_TEMPERATURE_DATA": "Historical Temperature Data",
		"PRECIPITATION": "Precipitation",
		"TEMPERATURE": "Temperature",
		"NAME_IS_ALREADY_USED": "Name is already used.",
		"STEP": "Step {stepNumber}:",
		"FORECAST_MODEL_LIST": "Forecast model list",
		"TYPE_NEW_FORECAST_MODEL_NAME": "Type in a name of a new model",
		"LEAVE_EMPTY_NO_FORECAST": "Leave empty if no foracst is required",
		"FORECAST_SETTINGS": "Forecast settings",
		"FORECAST_PARAMETERS": "Forecast parameters",
		"FREQUENCY": "Frequency",
		"METHOD": "Method",
		"METHOD_PARAMETERS": "Method parameters",
		"MODEL_PARAMETERS": "Model parameters",
		"DATASETS_USED": "Datasets used",
		"TRAIN_AND_ASSESS_MODEL": "Train & Assess model",
		"CURRENT_FORECASTING_PERIOD": "Current forecasting period",
		"FORECAST_NAME": "Forecast name",
		"FORECAST_ISSUE_DATES": "Forecast Issue Dates",
		"5_DAY": "5-day",
		"DECADAL": "Decadal",
		"MONTHLY": "Monthly",
		"SEASONAL": "Seasonal",
		"1ST_DAY_OF_FORECASTED_PERIOD": "The 1st day of a forecasted period",
		"ONE_DAY_BEFORE_FORECASTED_PERIOD": "One day before a forecasted period",
		"TWO_DAYS_BEFORE_FORECASTED_PERIOD": "Two days before a forecasted period",
		"THREE_DAYS_BEFORE_FORECASTED_PERIOD": "Three days before a forecasted period",
		"RELATIVE": "Relative",
		"START_DATE": "Start date",
		"END_DATE": "End date",
		"ISSUE_DATE": "Issue date",
		"SEASONAL_FREQUENCY_SETTINGS": "Seasonal frequency settings",
		"VALUES": "Values",
		"EVALUATION_STATISTICS": "Evaluation statistics",
		"DISCHARGE_CHARACTERISTICS": "Discharge characteristics",
		"FORECAST_VALUE": "Forecast value",
		"PREVIOUS_VALUE": "Previous value",
		"NUMBER_OF_TRAINING_DATA": "Number of training data",
		"ACCEPT": "Accept",
		"ACCESS": "Access",
		"HYDROLOGICAL_STATIONS_WITH_FORECASTING": "Hydrological stations with forecasting",
		"PERCENTAGE": "Percentage",
		"RELATIVE_ERROR": "Relative error",
		"STANDARD_DEVIATION": "Standard deviation",
		"NORM": "Norm",
		"ICE_PHENOMENA_11": "Salo",
		"ICE_PHENOMENA_12": "Snežura",
		"ICE_PHENOMENA_13": "Zaberegi",
		"ICE_PHENOMENA_14": "Pripaj",
		"ICE_PHENOMENA_15": "Zaberegi navisšie",
		"ICE_PHENOMENA_16": "Ledohod",
		"ICE_PHENOMENA_17": "Ledohod",
		"ICE_PHENOMENA_18": "Ledohod poverh ledjanogo pokrova",
		"ICE_PHENOMENA_19": "Šugohod",
		"ICE_PHENOMENA_20": "Vnutrivodnyj led",
		"ICE_PHENOMENA_21": "Pjatry",
		"ICE_PHENOMENA_22": "Osevšij led",
		"ICE_PHENOMENA_23": "Navaly lʹda na beregah",
		"ICE_PHENOMENA_24": "Ledjanaja peremyčka v stvore posta",
		"ICE_PHENOMENA_25": "Ledjanaja peremyčka vyše posta",
		"ICE_PHENOMENA_26": "Ledjanaja peremyčka niže posta",
		"ICE_PHENOMENA_30": "Zator lʹda vyše posta",
		"ICE_PHENOMENA_31": "Zator lʹda niže posta",
		"ICE_PHENOMENA_32": "Zator lʹda iskusstvenno razrušaetsja",
		"ICE_PHENOMENA_34": "Zažor lʹda vyše posta",
		"ICE_PHENOMENA_35": "Zažor lʹda niže posta",
		"ICE_PHENOMENA_36": "Zažor lʹda iskusstvenno razrušaetsja",
		"ICE_PHENOMENA_37": "Voda na lʹdu",
		"ICE_PHENOMENA_38": "Voda tečet poverh lʹda",
		"ICE_PHENOMENA_39": "Zakraina",
		"ICE_PHENOMENA_40": "Led potemnel",
		"ICE_PHENOMENA_41": "Snežnica",
		"ICE_PHENOMENA_42": "Led podnjalo",
		"ICE_PHENOMENA_43": "Podvižka lʹda",
		"ICE_PHENOMENA_44": "Razvodʹja",
		"ICE_PHENOMENA_45": "Led taet na mesto",
		"ICE_PHENOMENA_46": "Zaberegi ostatočnye",
		"ICE_PHENOMENA_47": "Naslud",
		"ICE_PHENOMENA_48": "Bityj led",
		"ICE_PHENOMENA_49": "Blinčatyj led",
		"ICE_PHENOMENA_50": "Ledjanye polja",
		"ICE_PHENOMENA_51": "Ledjanaja kaša",
		"ICE_PHENOMENA_52": "Stamuha",
		"ICE_PHENOMENA_53": "Led otnosit ot berega",
		"ICE_PHENOMENA_54": "Led prižimaet k beregu",
		"ICE_PHENOMENA_63": "Ledostav nepolnyj",
		"ICE_PHENOMENA_64": "Ledjanoj pokrov s polynʹjami",
		"ICE_PHENOMENA_65": "Ledostav, rovnyj ledjanoj pokrov",
		"ICE_PHENOMENA_66": "Ledostav, ledjanoj pokrov s torosami",
		"ICE_PHENOMENA_67": "Ledjanoj pokrov s grjadami torosov",
		"ICE_PHENOMENA_68": "Šugovaja dorožka",
		"ICE_PHENOMENA_69": "Podo lʹdom šuga",
		"ICE_PHENOMENA_70": "Treŝiny v ledjanom pokrove",
		"ICE_PHENOMENA_71": "Naledʹ",
		"ICE_PHENOMENA_72": "Led navisšij",
		"ICE_PHENOMENA_73": "Led jarusnyj",
		"ICE_PHENOMENA_74": "Led na dne",
		"ICE_PHENOMENA_75": "Reka promerzla",
		"ICE_PHENOMENA_76": "Led iskusstvenno razrušen",
		"ICE_PHENOMENA_77": "Nalednaja voda",
		"KN15_ERRORS_TOO_SHORT_TOKEN": "Telegram parts must have 5 characters.",
		"KN15_ERRORS_NO_STATION_CODE": "No station code is present.",
		"KN15_ERRORS_INVALID_DAY_IN_MONTH": "Day in month must be a number.",
		"KN15_ERRORS_UNSUPPORTED_HOUR_CODE": "Only 08 hour is supported.",
		"KN15_ERRORS_OUT_OF_RANGE_DAY_IN_MONTH": "Day in month is out of range.",
		"KN15_ERRORS_INVALID_SECTION_CODE": "Section code must be a number.",
		"KN15_ERRORS_UNSUPPORTED_SECTION_CODE": "Only section code 1 and 2 are supported",
		"KN15_ERRORS_UNSUPPORTED_SECTION": "Only sections 933, 966 and 988 are supported. Please check that discharge indetifier number is not \"1\".",
		"KN15_ERRORS_INVALID_GROUP_ONE": "Group 1HHHH is not present.",
		"KN15_ERRORS_INVALID_WATER_LEVEL": "Invalid water level.",
		"KN15_ERRORS_INVALID_GROUP_TWO": "Group 2HHHK is not present.",
		"KN15_ERRORS_INVALID_TREND": "Invalid water level trend.",
		"KN15_ERRORS_INVALID_GROUP_THREE": "Group 3HHHH is not present.",
		"KN15_ERRORS_INVALID_TEMPERATURE": "Invalid water and/or air temperature.",
		"KN15_ERRORS_INVALID_ICE_PHENOMENA": "Invalid ice phenomena code and/or intensity.",
		"KN15_ERRORS_INVALID_MONTH": "Invalid month number.",
		"KN15_ERRORS_INVALID_GROUP_TWO_DISCHARGE": "Group 2kQQQ is not present.",
		"KN15_ERRORS_INVALID_DISCHARGE_VALUE": "Invalid discharge value.",
		"KN15_ERRORS_INVALID_FREE_RIVER_AREA_VALUE": "Invalid cross-section area value.",
		"KN15_ERRORS_INVALID_MAXIMUM_DEPTH_VALUE": "Invalid maximum depth value.",
		"KN15_ERRORS_INVALID_GROUP_FIVE": "Group 5YYGG is not present.",
		"KN15_ERRORS_OUT_OF_RANGE_HOUR": "Hour is out of range.",
		"PASTE_MULTIPLE_KN_15_TELEGRAMS": "Paste multiple KN-15 telegrams",
		"ADD_SINGLE_TELEGRAM": "Add single telegram",
		"AUTOMATICALLY_PROCESSED_TELEGRAMS": "Automatically processed telegrams",
		"COMPLETED_TELEGRAMS": "Completed telegrams",
		"TELEGRAMS_REQUIRING_ACTION": "Telegrams requiring action",
		"DATA_OVERVIEW": "Data overview",
		"DATA_PROCESSING": "Data processing",
		"PRECIPITATION_NORM": "Precipitation norm",
		"TEMPERATURE_NORM": "Temperature norm",
		"NO_METEOSTATION_FOR_CODE": "No meteostation",
		"NO_METEOSTATION_FOR_CODE_EXTENDED": "No meteostation corresponding with discharge station with code {stationCode}. If you don't create a meteostation with the same station code, meteo data will be ignored upon submission.",
		"CREATE_METEOSTATION": "Create meteostation",
		"STATION_PAIR_NOTIFICATION": "Existing {stationType} Station ({stationCode})",
		"STATION_PAIR_NOTIFICATION_EXTENDED": "{stationType} station with the same station code ({stationCode}) already exists. Subsequent telegram data with this station code will automatically be submitted for each station separately depending on its type.",
		"MM_DAY": "mm/day",
		"NO_DAILY_DATA": "No daily data",
		"NO_DISCHARGE_DATA": "No discharge data",
		"NO_DECADAL_DATA": "No decadal data",
		"ERROR": "Error",
		"NEW_TELEGRAM_DATA_ENTRY": "New entry",
		"OLD_TELEGRAM_DATA_ENTRY": "Old entry",
		"OVERRIDE_OLD_ENTRY": "Override old entry",
		"MANUAL_INPUT": "Manual input",
		"DISCHARGE_STATIONS_WITH_MISSING_TELEGRAMS": "Discharge stations with missing telegrams",
		"METEO_STATIONS_WITH_MISSING_TELEGRAMS": "Meteo stations with missing telegrams",
		"METEO_DATA": "Meteo data",
		"DISCHARGE_CURVE_ADJUSTMENT": "Current curve adjustment",
		"NO_CURVE_FOR_METEO": "Discharge curve is not available for a station with only meteo data.",
		"CATCHMENT_AREA_FILE_UPLOAD": "Catchment area file upload",
		"STEP_4_SNOW_DATA": "Step 4: Snow Data",
		"SHOW_SNOW_DATA": "Show snow data",
		"SNOW_DATA": "Snow data",
		"LOAD_SNOW_DATA": "Load snow data",
		"FORECAST_TYPE": "Forecast type",
		"FORECAST_TYPE_DETAILS": "Forecast type details",
		"SUBMIT_MODEL": "Submit model",
		"SHOW_FORECAST_MODELS": "Show forecast models",
		"CURRENT_CURVE_ADJUSTMENT": "Current curve adjustment",
		"CURVE_MANAGEMENT": "Curve management",
		"ALL_CURVES": "All curves",
		"COMPLETION": "Completion",
		"STARTED": "Started",
		"LAST_MODIFIED": "Last modified",
		"PDF_REPORT": "PDF report",
		"TRAINING_INFO": "Training info",
		"FEATURE_TIMELAG": "Feature timelag",
		"EDIT_FORECAST_MODEL": "Edit forecast model",
		"FORECAST_MODEL_SETUP": "Forecast model setup",
		"FORECAST_MODEL_SETUP_EXTENDED": "Do you want to set up forecast models for this station now?",
		"NON_REVERTIBLE_ACTION": "This is non-revertible action. Do you wish to proceed?",
		"AUTOMATICALLY_ACCEPT_FORECAST_VALUES": "Automatically accept forecast values",
		"FORECAST_BULLETIN": "Forecast bulletin",
		"CANCEL_MODEL_TRAINING": "Cancel model training",
		"CANCEL_MODEL_TRAINING_CONFIRMATION": "Are you sure you want to cancel model training?",
		"YES": "Yes",
		"NO": "No",
		"VERIFY_PAYMENT": "Verify payment",
		"ENABLED_UNTIL_DATE": "Enabled until {date}",
		"DISABLED": "Disabled",
		"ACCESS_REQUESTED": "Access requested",
		"ACTIONS": "Actions",
		"ACTIVATE_OR_RENEW_SUBSCRIPTIONS": "Activate or renew subscription",
		"PAYMENT_VERIFICATION_CONFIRMATION": "Are you sure you want to verify payment for {organization}?",
		"INVITATIONS": "Invitations",
		"REGISTER": "Register",
		"ISSUE_DATE_OFFSET": "Issue date offset",
		"TARGET_PERIOD_START": "Target period start",
		"TARGET_PERIOD_END": "Target period end",
		"REFRESH_TRAINING_INFO": "Refresh training info",
		"TIMEZONE": "Timezone",
		"SELECT_TIMEZONE": "Select timezone",
		"TEMPLATES": "Templates",
		"TIMEZONE_NOTE": "If your organization operates within multiple timezones leave this field empty.",
		"NO_MATCH": "No match",
		"GENERATE_PREDICTION_MANUALLY": "Generate prediction manually",
		"PREDICTION_DATE": "Prediction date",
		"NO_CONTENT": "No content",
		"BULK_DATA_DOWNLOAD": "Bulk data download",
		"GENERATE_BULK_DATA": "Generate bulk data",
		"REPORTING_TEMPLATES": "Reporting templates",
		"DAILY_BULLETIN": "Daily bulletin",
		"DECADAL_BULLETIN": "Decadal bulletin",
		"TEMPLATE_TAGS": "Template tags",
		"DEFAULT_TEMPLATE": "Default template",
		"CURRENT_TEMPLATE": "Current template",
		"BULK_DATA": "Bulk data",
		"PREPARE_BULK_DATA": "Prepare bulk data",
		"BULK_DATA_DATE": "Bulk data date",
		"DECADAL_OPERATIONAL_BULLETIN": "Decadal operational bulletin",
		"NO_FORECAST_TYPES": "Organization has no forecast types defined.",
		"YEAR_WILL_BE_IGNORED": "Year will be ignored",
		"FORECAST_TYPE_CHANGE_WARNING": "Changing forecast type settings requires a new forecast model training for forecast models which are based on a changed forecast type.",
		"FAILED_TO_LOAD_USER": "Failed to load user",
		"FAILED_TO_LOAD_ORGANIZATIONS": "Failed to load organizations",
		"SAVE_FAILED": "Save failed",
		"NO_STATIONS_WITH_FORECAST": "No stations with forecast",
		"NO_FORECAST_MODELS": "No forecast models",
		"MANUAL_DISCHARGE_INPUT": "Manual discharge input (ice phenomena included)",
		"MANUAL_WATER_LEVEL_INPUT": "Manual water level input (water level trend differs)",
		"MIN_TEMPLATE_TAG_NOTE": "There should be at minimum one header tag and one one body tag.",
		"NO_DISCHARGE_CURVE_FOR_SITE_WITH_CODE": "No discharge curve for site with code {siteCode}",
		"LANGUAGE": "Language",
		"ENGLISH": "English",
		"RUSSIAN": "Russian",
		"LANGUAGE_NOTE": "Used for emails.",
		"WE_WILL_CONTACT_YOU_ASAP": "We will contact you as soon as we can!",
		"WE_ARE_SORRY": "We are sorry",
		"HELP_MESSAGE_ERROR": "Due to an error on our side, we were unable to send your message. Please try again.",
		"THANK_YOU": "Thank you",
		"CONTACT_US_FOR_HELP": "Contact us for help",
		"YOUR_NAME": "Your name",
		"YOUR_EMAIL": "Your email",
		"MESSAGE": "Message",
		"SENDING": "Sending",
		"APP_TITLE": "Modern Operational Hydrometeorology for Mountain Rivers in Central Asia",
		"FILE_UPLOADED": "File uploaded",
		"SNOW_DATA_FILE_NOTE": "Please rename the file extension to '.json' before uploading a file.",
		"HISTORICAL_METEOSTATION_DATA": "Historical Temperature and Precipitation Data",
		"PENTAD_FORECAST_DETAILS": "(Pentad) Recurring pentad forecast. Issue date: 1st day of Pentade +- {lag}",
		"DECADAL_FORECAST_DETAILS": "(Decadal) Recurring decadal forecast. Issue date: 1st day of Decade +- {lag}",
		"MONTHLY_FORECAST_DETAILS": "(Monthly) Recurring monthly forecast. Issue date: 1st day of Month +- {lag}",
		"SEARCH_STATION_CODE": "Search station by station code",
		"BACK_TO_STATION_LIST": "Back to station list",
		"FIRST_PAGE": "First page",
		"PREVIOUS_PAGE": "Previous page",
		"NEXT_PAGE": "Next page",
		"LAST_PAGE": "Last page",
		"PROCESS": "Process",
		"SNOW_COVER_DEVELOPMENT": "Snow cover development",
		"SNOW_COVER_MAP": "Snow cover map",
		"MEAN_CATCHMENT_NDSI": "Mean Catchment NDSI",
		"NDSI_NORM": "NDSI Norm",
		"MONTHLY_VALUES": "Monthly Values",
		"CATCHMENT_AREA_SETUP": "Catchment area setup",
		"DELETE_CATCHMENT_CONFIRM": "Are you sure you want to delete the catchment area file? Please consider exporting the data if you wish to proceed because the current data won't be accessible anymore.",
		"NORMALIZED_DIFF_SNOW_INDEX_MAP": "Normalized-Difference Snow Index (NDSI) Map",
		"RED": "Red",
		"DARK_BLUE": "Dark blue",
		"LOW_NDSI": "Low NDSI",
		"HIGH_NDSI": "High NDSI",
		"NO_DATA": "No data",
		"CURRENT": "Current",
		"SELECT_FORECASTING_PERIOD": "Select forecasting period",
		"YEAR_TYPE": "Year type",
		"HYDRO_YEAR": "Hydrological year",
		"CALENDAR_YEAR": "Calendar year"
	};

/***/ },
/* 568 */
/***/ function(module, exports) {

	module.exports = {
		"IMOMO_CENTRAL_ASIA": "iEasyHydro",
		"USERNAME_OR_PASSWORD_WRONG": "Имя пользователя и пароль неверные.",
		"USER_NOT_APPROVED_ORGANIZATION": "Пользователь не был одобрен организацией.",
		"H_Q_TABLE": "H/Q Таблица",
		"MINIMUM_H_CM": "Минимальный H (см)",
		"MAXIMUM_H_CM": "Максимальный H (см)",
		"MINIMUM_Q_M3_S": "Минимальный Q (м<sup>3</sup>/с)",
		"MAXIMUM_Q_M3_S": "Максимальный Q (м<sup>3</sup>/с)",
		"APPLY": "подать заявление",
		"DISCHARGE_DATA": "Данные расхода воды",
		"DELETE_SELECTED_ARTIFICIAL_DATA": "Удалить искусственный расход воды",
		"DATE": "Дата",
		"WATER_LEVEL": "Уровень воды",
		"DISCHARGE": "Расход воды",
		"CM": "см",
		"M3_S": "м<sup>3</sup>/с",
		"ADD_DISCHARGE_DATA_POINT": "Ввод расхода воды",
		"H_CM": "H (см)",
		"Q_M3_S": "Q (м<sup>3</sup>/с)",
		"H_CM_OLD": "H (см) - старый",
		"Q_M3_S_OLD": "Q (м<sup>3</sup>/с) - старый",
		"CANCEL": "Отмена",
		"ADD": "Добавить",
		"DISCHARGE_MODELS": "Модели кривой расходов воды",
		"SHOW_HIDDEN_MODELS": "Показать скрытые модели",
		"DELETE_DISCHARGE_MODEL": "Удалить модель расходов воды",
		"DELETE_DISCHARGE_MODEL_EXTENDED": "Удаление модели расходов воды будет пересчитывать любые связанные значения расходов воды с использованием предыдущей модели. Это действие является постоянным.",
		"DELETE": "Удалить",
		"NON_EXISTENT_STATION_CODE": "Несуществующий индекс станции",
		"NON_EXISTENT_STATION_CODE_EXTENDED": "В системе нет станции с индексом {stationCode}",
		"FORBIDDEN_STATION_CODE": "Запрещенный индекс станции",
		"FORBIDDEN_STATION_CODE_EXTENDED": "Станция с индексом {stationCode} принадлежит другой организации.",
		"UNEXPECTED_ERROR": "Неожиданная ошибка",
		"UNEXPECTED_ERROR_EXTENDED": "Произошла непредвиденная ошибка. Пожалуйста, попробуйте еще раз, и если ошибка не устранена, обратитесь в службу поддержки.",
		"OK": "OK",
		"TRY_AGAIN": "Попробуйте снова",
		"ACCOUNT": "Аккаунт",
		"ORGANIZATION": "Организация",
		"LOG_IN": "Авторизоваться",
		"LOG_OUT": "Выйти",
		"MENU": "Меню",
		"HOME": "Домой",
		"TOOLS": "Инструменты",
		"OPERATIONAL_HYDROLOGY": "Оперативная гидрология",
		"DISCHARGE_FORECASTING": "Прогноз стока рек",
		"STATION_MANAGEMENT": "Управление гидропостами",
		"HELP": "Помощь",
		"FEEDBACK": "Обратная связь",
		"SETTINGS": "Установки",
		"ABOUT_US": "О нас",
		"USERS": "Пользователи",
		"IMOMO_HYDROMETEOROLOGY": "iMoMo Гидрометеорология",
		"WELCOME_BACK": "Добро пожаловать назад!",
		"CLOUD_AUTOMATED_WORKSTATION_OF_THE_OPERATIONAL_HYDROLOGIST": "Облачное автоматизированное рабочее место (АРМ) оперативного гидролога",
		"1_PROCESSING_OF_KH_15_TELEGRAMS_WITH_DAILY_HYDROLOGICAL_DATA": "1. Обработка ежедневных сводок (телеграммы КН-15).",
		"2_CREATION_AND_MODIFICATION_OF_OPERATIONAL_DISCHARGE_RATION_CURVES": "2. Ведение (построение и изменение) оперативных кривых расходов.",
		"3_CALCULATION_OF_CURRENT_AND_DAILY_AVERAGE_HYDROLOGICAL_VALUES": "3. Ведение ежедневного оперативного журнала.",
		"4_RELEASE_OF_THE_DAILY_HYDROLOGICAL_BULLETIN": "4. Выпуск ежедневного гидрологического бюллетеня.",
		"5_HYDROLOGICAL_FORECASTING": "5. Гидрологическое прогнозирование (ежедневное, пентадное, декадное, месячное и сезонное)",
		"NAME": "Имя",
		"ADDRESS": "Адрес",
		"ADMIN_USER": "Администратор",
		"USER_DETAILS": "Данные пользователя",
		"USERNAME": "Имя пользователя",
		"PASSWORD": "Пароль",
		"REPEAT_PASSWORD": "Повторить пароль",
		"NEW_PASSWORD": "Новый пароль",
		"REPEAT_NEW_PASSWORD": "Повторить новый пароль",
		"EMAIL": "Эл.почта",
		"EDIT_USER": "Редактировать пользователя",
		"ADD_USER": "Добавить пользователя",
		"SAVE": "Сохранить",
		"DELETING": "Удаление",
		"SAVING": "Сохранение",
		"BACK": "Назад",
		"ROLE": "Роль",
		"DELETE_USER": "Удалить пользователя?",
		"DELETE_ORGANIZATION": "Удалить организацию?",
		"DELETE_FORECAST_MODEL": "Удалить прогностическую модель?",
		"DELETE_CONFIRMATION": "Вы уверены, что хотите удалить {item}?",
		"THIS_FIELD_IS_REQUIRED": "Это поле обязательно к заполнению",
		"THE_VALUE_IS_TOO_LONG": "Значение слишком длинное.",
		"THE_VALUE_IS_TOO_SHORT": "Значение слишком короткое.",
		"LOGIN": "Логин",
		"CREATE_NEW_USER": "Создать нового пользователя",
		"LOG_IN_AS_GUEST": "Войти как гость",
		"FORGOT_YOUR_PASSWORD": "Забыли пароль?",
		"ANNOUNCEMENTS": "Уведомление",
		"OPERATIONAL_DATA_INPUT": "Ввод оперативных данных",
		"ENTER_TELEGRAM": "Ввод телеграмм",
		"OPERATIONAL_JOURNAL": "Оперативный журнал",
		"VIEW_JOURNAL": "Просмотр журнала",
		"DAILY_OPERATIONAL_BULLETIN": "Ежедневный гидрологический бюллетень",
		"GENERATE_BULLETIN": "Формирование бюллетеня",
		"TELEGRAM": "Телеграмма",
		"DISCHARGE_CURVE": "Кривая расходов воды",
		"SAVE_DATA": "Сохранить данные",
		"NEXT": "Следующий",
		"PREVIOUS": "предыдущий",
		"SUBMIT_DATA": "Принять данные",
		"KN15_TELEGRAM": "КН-15 телеграмма",
		"STATION": "Гидропост",
		"PROCESS_TELEGRAM": "Обработка телеграммы",
		"TELEGRAM_IS_REQUIRED": "Телеграмма обязательна.",
		"M2": "м<sup>2</sup>",
		"REPORTED_WATER_LEVEL": "Поступивший уровень вода",
		"PREVIOUS_DAY": "За предыдушие сутки",
		"TELEGRAM_DAY": "Текущие сутки",
		"8_AM": "8:00",
		"8_PM": "20:00",
		"DAILY_AVERAGE": "Среднесуточный",
		"DAILY_CHANGE": "Тенденция",
		"WATER_LEVEL_TREND_IS_CORRECT": "Тенденция уровня воды неправильная.",
		"WATER_LEVEL_TREND_WRONG": "Water level trend could not be verified or is wrong.",
		"REPORTED_DISCHARGE": "Поступившый замер расхода воды",
		"CROSS_SECTION_AREA": "Площадь живого сечения",
		"MAXIMUM_DEPTH": "Максимальная глубина",
		"ICE_PHENOMENA": "Ледовые явления",
		"CODE": "Код",
		"DESCRIPTION": "Описание",
		"INTENSITY": "Интенсивность",
		"DISCHARGE_CALCULATION_DISABLED": "Discharge calculation disabled",
		"ADJUST_DISCHARGE_MODEL": "Настройка модели кривой расходов",
		"IDENTIFIER": "Идентификатор",
		"ADD_DELTA_H": "Ввести \\u0394H",
		"FIT_TO_SELECTED_DATA": "Подбор выбранных данных",
		"REFERENCE_MODEL": "Эталонная модель",
		"DELTA_H": "\\u0394H",
		"DATA_SELECTED": "{count, plural, =0{Точки данных не выбраны.} one{Выберите еще одну точку данных.} other{{count} точки данных выбраны.} }",
		"NO_NEW_MODEL": "Нет новой модели кривой",
		"VALID_FROM": "Действителен с",
		"CREATE_MODEL": "Создать модель",
		"DELETE_MODEL": "Удалить модель кривой",
		"DISCHARGE_MODEL": "Модель кривой расходов воды",
		"PROCESSED_DATA": "Обработанные данные",
		"AVERAGE": "Среднее",
		"MONTH": "Месяц",
		"YEAR": "Год",
		"LOAD_JOURNAL": "Загрузить журнал",
		"DAILY_DATA": "Ежедневные данные",
		"TREND": "Тенденция",
		"WATER_CELSIUS": "Вода (℃)",
		"AIR_CELSIUS": "Воздух (℃)",
		"ICE": "Лед",
		"MINIMUM": "Минимальный",
		"MAXIMUM": "Максимальный",
		"EDIT_SELECTED_ROW": "Изменить выбранную строку",
		"EDIT_DAILY_DATA_ROW": "Изменить строку ежедневных данных",
		"APPLY_CHANGES": "Применить изменения",
		"H_8_AM": "H (8:00)",
		"H_8_PM": "H (20:00)",
		"H_AVERAGE": "H (Среднее)",
		"DAILY_DATA_WAS_EDITED": "Ежедневные данные были отредактированы.",
		"ERROR_UPDATING_DATA": "Произошла ошибка при обновлении данных. Пожалуйста, попробуйте еще раз.",
		"DELETE_SELECTED_ROW_FROM_DATABASE": "Удалить выбранную строку из базы данных",
		"F_M2": "F (м2)",
		"EDIT_METEO_ROW": "Edit meteo row",
		"EDIT_DISCHARGE_ROW": "Изменить строку расхода воды",
		"METEO_DATA_WAS_EDITED": "Meteo data was edited.",
		"DISCHARGE_DATA_WAS_EDITED": "Расход воды был отредактирован.",
		"ERROR_UPDATING_DISCHARGE_DATA": "Произошла ошибка при обновлении рахода воды. Пожалуйста, попробуйте еще раз.",
		"DELETE_DISCHARGE_DATA": "Удалить расход воды",
		"DELETE_DATA_WARNING": "Вы уверены, что хотите удалить эти данные? Это действие является постоянным.",
		"DISCHARGE_DATA_WAS_DELETED": "Расход воды был удален",
		"ERROR_DELETING_DISCHARGE_DATA": "Произошла ошибка при удалениирасхода воды. Пожалуйста, попробуйте еще раз.",
		"DECADAL_DATA": "Декадные данные",
		"DECADE": "Декада",
		"MONTHLY_AVERAGE": "Средние месячные",
		"OPERATIONAL_BULLETIN": "Оперативный бюллетень",
		"BULLETIN_DATE": "Дата выпуска бюллетеня",
		"PREPARE_BULLETIN": "Подготовить бюллетень",
		"DOWNLOAD_BULLETIN": "Скачать бюллетень",
		"HYDROLOGICAL_DISCHARGE_STATIONS": "Гидрологические посты",
		"STATION_CODE": "Индекс поста",
		"STATION_NAME": "Название поста",
		"REGION": "Область",
		"RIVER_BASIN": "Речной бассейн",
		"ADD_STATION": "Добавить гидропост",
		"EDIT_STATION": "Редактировать гидропост",
		"SHOW_DISCHARGE_CURVES": "Показать кривую расходов воды",
		"SHOW_DISCHARGE_TIME_SERIES": "Показать исторические расходв воды",
		"SHOW_HISTORIC_DATA": "Проказать исторические данные",
		"STEP_1_DETAILS": "Шаг 1: Детальная информация",
		"STATION_DETAILS": "Детальная информация станции",
		"LOCAL_CODE": "Индекс",
		"BASIN": "Бассейн",
		"COUNTRY": "Страна",
		"LOCATION": "Расположение",
		"MAXIMUM_DISCHARGE_LEVEL_M3_S": "Опасный расход воды (м3/с)",
		"VALUE_IS_REQUIRED": "Требуется значение.",
		"INVALID_VALUE": "Неверное значение.",
		"VERIFYING": "Проверка ...",
		"CODE_IS_ALREADY_USED": "Индекс уже используется.",
		"VALUE_IS_TOO_LONG": "Значение слишком длинное",
		"STEP_2_AGGREGATIONS": "Шаг 2: Агрегации",
		"STEP_2_DISCHARGE_CURVE": "Шаг 2: Кривая расходов воды",
		"DISCHARGE_POINTS": "Точки расходов воды",
		"WATER_LEVEL_CM": "Уровень воды (см)",
		"DISCHARGE_M3_S": "Расход воды (м3/с)",
		"EG_INITIAL_STATION_MODEL": "Например. Начальная модель гидропоста",
		"SHOW_H_Q_TABLE": "Показать H/Q таблицу",
		"AN_IDENTIFIER_IS_REQUIRED": "Требуется идентификатор.",
		"IDENTIFIER_IS_TOO_LONG": "Идентификатор слишком длинный.",
		"MODEL_H_Q_TABLE": "H/Q таблица",
		"STEP_3_HISTORICAL_DISCHARGE_DATA": "Шаг 3: Исторические данные расходов воды",
		"HISTORICAL_DISCHARGE_DATA_UPLOAD": "Загрузка исторических данных",
		"PLEASE_UPLOAD_HISTORICAL_METEO": "Пожалуйста, загрузите исторические декадные метеоданные для станции.",
		"PLEASE_UPLOAD_HISTORICAL": "Пожалуйста, загрузите исторические декадные расходы воды для гидропоста.",
		"DATA_AVAILABLE_FOR_DOWNLOAD": "Данные всегда будут доступны для скачивания и могут быть обновлены в любое время.",
		"DATA_MUST_BE_EXCEL": "Данные должны быть загружены как файл Excel (.xls / .xlsx) в том же формате, что и файл примера.",
		"NO_FILE_SELECTED": "Файл не выбран",
		"DOWNLOAD_EXAMPLE_FILE": "Скачать файл примера",
		"SELECT_FILE": "Выберите файл",
		"CHANGE": "Изменить",
		"VALIDATE": "Утвердить",
		"VALIDATED": "Утвержденный",
		"STEP_4_REVIEW_AND_CREATE": "Шаг 4. Просмотр и создание",
		"CREATE_STATION": "Создать станцию",
		"STATUS": "Статус",
		"HISTORICAL_DISCHARGE_DATA": "Исторические расходы воды",
		"DONE": "Готово",
		"PENDING": "В ожидании",
		"CREATE": "Создать станцию",
		"STATION_LIST": "Список станций",
		"SELECT_A_STATION": "Выбрать станцию",
		"DISCHARGE_NORM": "Нормы расходов воды",
		"I": "I",
		"II": "II",
		"III": "III",
		"NEW_DATA_MUST_BE_EXCEL": "Новые данные должны быть загружены как файл Excel (.xls / .xlsx) в том же формате, что и файл примера.",
		"DOWNLOAD_DATA": "Скачать данные",
		"UPLOAD_NEW_DATA": "Загрузить новые данные",
		"HYDROLOGICAL_YEAR": "Гидрологический год",
		"CHANGE_YEAR": "Сменить год",
		"NEW_DISCHARGE_MODEL": "Новая модель кривой расходов воды",
		"MODEL_IDENTIFIER": "Идентификатор модели",
		"NEW_MODEL": "Новая модель",
		"SAVE_NEW_MODEL": "Сохранить новую модель",
		"MEASURED_PRECIPITATION_TIME_SERIES": "Ряд данных измеренных осадов",
		"MEASURED_TEMPERATURE_TIME_SERIES": "Ряд данных измеренных темепарур воздуха",
		"MEASURED_DISCHARGE_TIME_SERIES": "Ряд данных расходов воды",
		"LOAD_GRAPH": "Загрузить график",
		"INITIAL_YEAR": "Начальный год",
		"FINAL_YEAR": "Конечный год",
		"HISTORICAL_NORM": "Нормы",
		"RESET": "Сброс",
		"SAVE_CHANGES": "Сохранить изменения",
		"PHONE": "Телефон",
		"REQUEST_ACCESS": "Запрос доступа",
		"ADD_ORGANIZATION": "Добавить организацию",
		"AGGREGATION": "Агрегирование",
		"WEIGHTING": "Придать вес",
		"ORGANIZATION_NAME": "Название организации",
		"ORGANIZATION_ADDRESS": "Адрес организации",
		"CITY": "Город",
		"ZIP_CODE": "Почтовый индекс",
		"ADMINISTRATORS": "Администраторы",
		"NO_ADMINS": "В этой организации нет администраторов.",
		"SEND": "Послать",
		"RESET_PASSWORD": "Сброс пароля",
		"RESETING": "Сброс",
		"PASSWORDS_NOT_MATCHING": "Пароли не совпадают.",
		"CHANGE_PASSWORD": "Изменить пароль",
		"OLD_PASSWORD": "Старый пароль",
		"PROCESSING": "Обработка ...",
		"NO_STATIONS": "Гидропосты не найдены",
		"SEARCH_STATIONS_PLACEHOLDER": "Поиск станции по 'siteName' или 'siteCode'",
		"ADD_VIRTUAL_STATION": "Добавить виртуальную станцию",
		"VIRTUAL_STATION": "Виртуальная станция",
		"EDIT_ORGANIZATION": "Редактировать организацию",
		"DISCHARGE_STATIONS": "Гидропосты",
		"METEOSTATIONS": "Метеостанция",
		"HISTORICAL_DATA": "Исторические данные",
		"STEP_2_HISTORICAL_DATA": "Шаг 2: Исторические данные",
		"ADD_METEOSTATION": "Добавить метеостанцию",
		"SHOW_TIME_SERIES": "Показать ряды данных",
		"EDIT_METEOSTATION": "Редактировать метеостанцию",
		"HYDROLOGICAL_METEOSTATIONS": "Гидропосты",
		"HISTORICAL_PRECIPITATION_DATA": "Исторические данные о осадках",
		"HISTORICAL_TEMPERATURE_DATA": "Исторические данные о температуре воздуха",
		"PRECIPITATION": "Осадки",
		"TEMPERATURE": "Температура воздуха",
		"NAME_IS_ALREADY_USED": "Имя уже используется.",
		"STEP": "Шаг {stepNumber}:",
		"FORECAST_MODEL_LIST": "Список моделей прогноза",
		"TYPE_NEW_FORECAST_MODEL_NAME": "Введите имя новой модели",
		"LEAVE_EMPTY_NO_FORECAST": "Оставьте пустым, если прогноз не требуется",
		"FORECAST_SETTINGS": "Настройки прогноза",
		"FORECAST_PARAMETERS": "Параметры прогноза",
		"FREQUENCY": "Частота",
		"METHOD": "Метод",
		"METHOD_PARAMETERS": "Параметры метода",
		"MODEL_PARAMETERS": "Параметры модели",
		"DATASETS_USED": "Используемые наборы данных",
		"TRAIN_AND_ASSESS_MODEL": "Модель Train & Assess",
		"CURRENT_FORECASTING_PERIOD": "Текущий период прогнозирования",
		"FORECAST_NAME": "Название прогноза",
		"FORECAST_ISSUE_DATES": "Даты выпуска прогноза",
		"5_DAY": "Пентада",
		"DECADAL": "Декадные данные",
		"MONTHLY": "Месячные",
		"SEASONAL": "Сезонные",
		"1ST_DAY_OF_FORECASTED_PERIOD": "1-й день прогнозируемого периода",
		"ONE_DAY_BEFORE_FORECASTED_PERIOD": "За день до прогнозируемого периода",
		"TWO_DAYS_BEFORE_FORECASTED_PERIOD": "За два дня до прогнозируемого периода",
		"THREE_DAYS_BEFORE_FORECASTED_PERIOD": "Три дня до прогнозируемого периода",
		"RELATIVE": "Относительный",
		"START_DATE": "Дата начала",
		"END_DATE": "Дата окончания",
		"ISSUE_DATE": "Дата выпуска",
		"SEASONAL_FREQUENCY_SETTINGS": "Настройки сезонной частоты",
		"VALUES": "Значения",
		"EVALUATION_STATISTICS": "Оценка статистики",
		"DISCHARGE_CHARACTERISTICS": "Характеристики расходов воды",
		"FORECAST_VALUE": "Прогнозное значение",
		"PREVIOUS_VALUE": "Предыдущее значение",
		"NUMBER_OF_TRAINING_DATA": "Количество тренировочных данных",
		"ACCEPT": "Принять",
		"ACCESS": "Доступ",
		"HYDROLOGICAL_STATIONS_WITH_FORECASTING": "Гидропосты с прогнозированием",
		"PERCENTAGE": "Процент",
		"RELATIVE_ERROR": "Относительная ошибка",
		"STANDARD_DEVIATION": "Стандартное отклонение",
		"NORM": "Норма",
		"ICE_PHENOMENA_11": "Сало",
		"ICE_PHENOMENA_12": "Снежура",
		"ICE_PHENOMENA_13": "Забереги",
		"ICE_PHENOMENA_14": "Припай",
		"ICE_PHENOMENA_15": "Забереги нависшие",
		"ICE_PHENOMENA_16": "Ледоход",
		"ICE_PHENOMENA_17": "Ледоход",
		"ICE_PHENOMENA_18": "Ледоход поверх ледяного покрова",
		"ICE_PHENOMENA_19": "Шугоход",
		"ICE_PHENOMENA_20": "Внутриводный лед",
		"ICE_PHENOMENA_21": "Пятры",
		"ICE_PHENOMENA_22": "Осевший лед",
		"ICE_PHENOMENA_23": "Навалы льда на берегах",
		"ICE_PHENOMENA_24": "Ледяная перемычка в створе поста",
		"ICE_PHENOMENA_25": "Ледяная перемычка выше поста",
		"ICE_PHENOMENA_26": "Ледяная перемычка ниже поста",
		"ICE_PHENOMENA_30": "Затор льда выше поста",
		"ICE_PHENOMENA_31": "Затор льда ниже поста",
		"ICE_PHENOMENA_32": "Затор льда искусственно разрушается",
		"ICE_PHENOMENA_34": "Зажор льда выше поста",
		"ICE_PHENOMENA_35": "Зажор льда ниже поста",
		"ICE_PHENOMENA_36": "Зажор льда искусственно разрушается",
		"ICE_PHENOMENA_37": "Вода на льду",
		"ICE_PHENOMENA_38": "Вода течет поверх льда",
		"ICE_PHENOMENA_39": "Закраина",
		"ICE_PHENOMENA_40": "Лед потемнел",
		"ICE_PHENOMENA_41": "Снежница",
		"ICE_PHENOMENA_42": "Лед подняло",
		"ICE_PHENOMENA_43": "Подвижка льда",
		"ICE_PHENOMENA_44": "Разводья",
		"ICE_PHENOMENA_45": "Лед тает на место",
		"ICE_PHENOMENA_46": "Забереги остаточные",
		"ICE_PHENOMENA_47": "Наслуд",
		"ICE_PHENOMENA_48": "Битый лед",
		"ICE_PHENOMENA_49": "Блинчатый лед",
		"ICE_PHENOMENA_50": "Ледяные поля",
		"ICE_PHENOMENA_51": "Ледяная каша",
		"ICE_PHENOMENA_52": "Стамуха",
		"ICE_PHENOMENA_53": "Лед относит от берега",
		"ICE_PHENOMENA_54": "Лед прижимает к берегу",
		"ICE_PHENOMENA_63": "Ледостав неполный",
		"ICE_PHENOMENA_64": "Ледяной покров с полыньями",
		"ICE_PHENOMENA_65": "Ледостав, ровный ледяной покров",
		"ICE_PHENOMENA_66": "Ледостав, ледяной покров с торосами",
		"ICE_PHENOMENA_67": "Ледяной покров с грядами торосов",
		"ICE_PHENOMENA_68": "Шуговая дорожка",
		"ICE_PHENOMENA_69": "Подо льдом шуга",
		"ICE_PHENOMENA_70": "Трещины в ледяном покрове",
		"ICE_PHENOMENA_71": "Наледь",
		"ICE_PHENOMENA_72": "Лед нависший",
		"ICE_PHENOMENA_73": "Лед ярусный",
		"ICE_PHENOMENA_74": "Лед на дне",
		"ICE_PHENOMENA_75": "Река промерзла",
		"ICE_PHENOMENA_76": "Лед искусственно разрушен",
		"ICE_PHENOMENA_77": "Наледная вода",
		"KN15_ERRORS_TOO_SHORT_TOKEN": "Группы телеграммы должны иметь 5 символов.",
		"KN15_ERRORS_NO_STATION_CODE": "Код станции отсутствует.",
		"KN15_ERRORS_INVALID_DAY_IN_MONTH": "День в месяце должен быть числом.",
		"KN15_ERRORS_UNSUPPORTED_HOUR_CODE": "Поддерживается только 08 час.",
		"KN15_ERRORS_OUT_OF_RANGE_DAY_IN_MONTH": "День в месяце вне диапазона.",
		"KN15_ERRORS_INVALID_SECTION_CODE": "Код группы должен быть числом.",
		"KN15_ERRORS_UNSUPPORTED_SECTION_CODE": "Поддерживаются только коды групп 1 и 2",
		"KN15_ERRORS_UNSUPPORTED_SECTION": "Поддерживаются только группы 933, 966 и 988. Пожалуйста, убедитесь, что номер  идентификатора расхода воды не \"1\".",
		"KN15_ERRORS_INVALID_GROUP_ONE": "Группа 1HHHH отсутствует",
		"KN15_ERRORS_INVALID_WATER_LEVEL": "Неверный уровень воды.",
		"KN15_ERRORS_INVALID_GROUP_TWO": "Группа 2HHHK отсутствует",
		"KN15_ERRORS_INVALID_TREND": "Неверная  тенденция уровня воды.",
		"KN15_ERRORS_INVALID_GROUP_THREE": "Группа 3HHHH отсутствует",
		"KN15_ERRORS_INVALID_TEMPERATURE": "Неверная температура воды и / или воздуха.",
		"KN15_ERRORS_INVALID_ICE_PHENOMENA": "Неправильный код и / или интенсивность ледяных явлений.",
		"KN15_ERRORS_INVALID_MONTH": "Неверный номер месяца.",
		"KN15_ERRORS_INVALID_GROUP_TWO_DISCHARGE": "Группа 2kQQQ отсутствует",
		"KN15_ERRORS_INVALID_DISCHARGE_VALUE": "Неверное значение расхода воды.",
		"KN15_ERRORS_INVALID_FREE_RIVER_AREA_VALUE": "Неверное значение площади живого сечения",
		"KN15_ERRORS_INVALID_MAXIMUM_DEPTH_VALUE": "Неверное значение максимальной глубины",
		"KN15_ERRORS_INVALID_GROUP_FIVE": "Группа 5YYGG iотсутствует",
		"KN15_ERRORS_OUT_OF_RANGE_HOUR": "Час вне диапазона.",
		"PASTE_MULTIPLE_KN_15_TELEGRAMS": "Вставьте несколько телеграмм KN-15",
		"ADD_SINGLE_TELEGRAM": "Добавить одну телеграмму",
		"AUTOMATICALLY_PROCESSED_TELEGRAMS": "Автоматически обработанные телеграммы",
		"COMPLETED_TELEGRAMS": "Завершенные телеграммы",
		"TELEGRAMS_REQUIRING_ACTION": "Телеграммы, требующие действий",
		"DATA_OVERVIEW": "Обзор данных",
		"DATA_PROCESSING": "Обработка данных",
		"PRECIPITATION_NORM": "Норма осадком",
		"TEMPERATURE_NORM": "Норма температуры воздуха",
		"NO_METEOSTATION_FOR_CODE": "Нет метеостанции",
		"NO_METEOSTATION_FOR_CODE_EXTENDED": "Нет метеостанции, соответствующей гидропосту с кодом {stationCode}. Если вы не создадите метеостанцию с тем же кодом станции, метеоданные будут игнорироваться при отправке.",
		"CREATE_METEOSTATION": "Создать метеостанцию",
		"STATION_PAIR_NOTIFICATION": "Существующая {stationType} Станция ({stationCode})",
		"STATION_PAIR_NOTIFICATION_EXTENDED": "Станция {stationType} с тем же кодом станции ({stationCode}) уже существует. Последующие данные телеграммы с этим кодом станции будут автоматически отправляться для каждой станции отдельно в зависимости от ее типа.",
		"MM_DAY": "мм/день",
		"NO_DAILY_DATA": "Нет ежедневных данных",
		"NO_DISCHARGE_DATA": "Нет данных расходов воды",
		"NO_DECADAL_DATA": "Нет декадных данных",
		"ERROR": "Ошибка",
		"NEW_TELEGRAM_DATA_ENTRY": "Новая запись",
		"OLD_TELEGRAM_DATA_ENTRY": "Старая запись",
		"OVERRIDE_OLD_ENTRY": "Переопределить старую запись",
		"MANUAL_INPUT": "Ручной ввод",
		"DISCHARGE_STATIONS_WITH_MISSING_TELEGRAMS": "Гидропост с отсутствующими телеграммами",
		"METEO_STATIONS_WITH_MISSING_TELEGRAMS": "Метеостанции с отсутствующими телеграммами",
		"METEO_DATA": "Метео данные",
		"DISCHARGE_CURVE_ADJUSTMENT": "Корректировка кривой расходов воды",
		"NO_CURVE_FOR_METEO": "Кривая расходов воды недоступна для станции, имеющей только метеоданные.",
		"CATCHMENT_AREA_FILE_UPLOAD": "Загрузка файла площади бассейна",
		"STEP_4_SNOW_DATA": "Шаг 4. Данные снежного покрова",
		"SHOW_SNOW_DATA": "Показать данные снежного покрова",
		"SNOW_DATA": "Данные снежного покрова",
		"LOAD_SNOW_DATA": "Загружить данные снежного покрова",
		"FORECAST_TYPE": "Тип прогноза",
		"FORECAST_TYPE_DETAILS": "Детали типа прогноза",
		"SUBMIT_MODEL": "Принят модель",
		"SHOW_FORECAST_MODELS": "Показать модель прогноза",
		"CURRENT_CURVE_ADJUSTMENT": "Установка текущей кривой",
		"CURVE_MANAGEMENT": "Управление кривой",
		"ALL_CURVES": "Все кривые",
		"COMPLETION": "Завершение",
		"STARTED": "Начать",
		"LAST_MODIFIED": "Последнее изменение",
		"PDF_REPORT": "PDF отчет",
		"TRAINING_INFO": "Информация об обучении",
		"FEATURE_TIMELAG": "Запаздывание по времени",
		"EDIT_FORECAST_MODEL": "Изменить модель прогноза",
		"FORECAST_MODEL_SETUP": "Настройка модели прогноза",
		"FORECAST_MODEL_SETUP_EXTENDED": "Хотите сейчас настроить прогнозные модели для этой станции?",
		"NON_REVERTIBLE_ACTION": "Это необратимое действие. Вы хотите продолжить?",
		"AUTOMATICALLY_ACCEPT_FORECAST_VALUES": "Автоматически принимать прогнозные значения",
		"FORECAST_BULLETIN": "Прогнозный бюллетень",
		"CANCEL_MODEL_TRAINING": "Прерывание обучения модели",
		"CANCEL_MODEL_TRAINING_CONFIRMATION": "Вы уверены, что хотите отменить обучение модели?",
		"YES": "Да",
		"NO": "Нет",
		"VERIFY_PAYMENT": "Подтвердить платеж",
		"ENABLED_UNTIL_DATE": "Включено до {date}",
		"DISABLED": "Отключен",
		"ACCESS_REQUESTED": "Доступ запрошен",
		"ACTIONS": "Действия",
		"ACTIVATE_OR_RENEW_SUBSCRIPTIONS": "Активировать или продлить подписку",
		"PAYMENT_VERIFICATION_CONFIRMATION": "Вы уверены, что хотите подтвердить платеж  {organization}?",
		"INVITATIONS": "Приглашения",
		"REGISTER": "Регистр",
		"ISSUE_DATE_OFFSET": "Смещение даты выпуска",
		"TARGET_PERIOD_START": "Начало целевого периода",
		"TARGET_PERIOD_END": "окончание целевого периода",
		"REFRESH_TRAINING_INFO": "Обновить информацию о тренировке",
		"TIMEZONE": "Часовой пояс",
		"SELECT_TIMEZONE": "Выбор часовой пояс",
		"TEMPLATES": "Шаблоны",
		"TIMEZONE_NOTE": "Если ваша организация работает в нескольких часовых поясах, оставьте это поле пустым",
		"NO_MATCH": "Не совпадает",
		"GENERATE_PREDICTION_MANUALLY": "Генерация прогноза вручную",
		"PREDICTION_DATE": "Дата прогноза",
		"NO_CONTENT": "Без содержания",
		"BULK_DATA_DOWNLOAD": "Массовая загрузка данных",
		"GENERATE_BULK_DATA": "Генерация массовых данных",
		"REPORTING_TEMPLATES": "Шаблоны отчетов",
		"DAILY_BULLETIN": "Ежедневный бюллетень",
		"DECADAL_BULLETIN": "Декадный бюллетень",
		"TEMPLATE_TAGS": "Теги шаблона",
		"DEFAULT_TEMPLATE": "Шаблон по умолчанию",
		"CURRENT_TEMPLATE": "Текущий шаблон",
		"BULK_DATA": "Массовые данные",
		"PREPARE_BULK_DATA": "Подготовить массовых данных",
		"BULK_DATA_DATE": "Дата массовых данных",
		"DECADAL_OPERATIONAL_BULLETIN": "Декадный оперативный бюллетень",
		"NO_FORECAST_TYPES": "В организации не определены типы прогнозов.",
		"YEAR_WILL_BE_IGNORED": "Год будет игнорироваться",
		"FORECAST_TYPE_CHANGE_WARNING": "Изменение настроек типа прогноза требует обучения новой модели прогноза для тех моделей прогноза, которые основанных на измененном типе прогноза.",
		"FAILED_TO_LOAD_USER": "Не удалось загрузить пользователя",
		"FAILED_TO_LOAD_ORGANIZATIONS": "Не удалось загрузить организацию",
		"SAVE_FAILED": "Сохранить не удалось",
		"NO_STATIONS_WITH_FORECAST": "Нет станций с прогнозом",
		"NO_FORECAST_MODELS": "Нет прогнозных моделей",
		"MANUAL_DISCHARGE_INPUT": "Ручной ввод расхода воды (ледовые явления включены)",
		"MANUAL_WATER_LEVEL_INPUT": "Ручной ввод уровня воды (тенденция уровня воды отличается)",
		"MIN_TEMPLATE_TAG_NOTE": "Должен быть как минимум один тег заголовка и один тег тела.",
		"NO_DISCHARGE_CURVE_FOR_SITE_WITH_CODE": "Нет кривой расходов воды для гидропоста с кодом {siteCode}",
		"LANGUAGE": "Язык",
		"ENGLISH": "Английский",
		"RUSSIAN": "Русский",
		"LANGUAGE_NOTE": "Используется для эл.почты.",
		"WE_WILL_CONTACT_YOU_ASAP": "Мы свяжемся с вами, как только сможем!",
		"WE_ARE_SORRY": "Мы сожалеем",
		"HELP_MESSAGE_ERROR": "Из-за ошибки на нашей стороне мы не смогли отправить Ваше сообщение. Пожалуйста, попробуйте еще раз.",
		"THANK_YOU": "Спасибо",
		"CONTACT_US_FOR_HELP": "Свяжитесь с нами для помощи",
		"YOUR_NAME": "Ваше имя",
		"YOUR_EMAIL": "Ваша эл.почта",
		"MESSAGE": "Сообщение",
		"SENDING": "Отправка",
		"APP_TITLE": "Современная оперативная гидрология горных рек в Центральной Азии",
		"FILE_UPLOADED": "Файл загружен",
		"SNOW_DATA_FILE_NOTE": "Пожалуйста, переименуйте расширение файла в «.json» перед загрузкой файла.",
		"HISTORICAL_METEOSTATION_DATA": "Исторические данные по температуре воздуха и осадкам",
		"PENTAD_FORECAST_DETAILS": "(Pentad) Периодический пентадный прогноз. Дата выпуска: 1-й день Пентады +- {lag}",
		"DECADAL_FORECAST_DETAILS": "(Decadal) Периодический декадный прогноз. Дата выпуска: 1-й день Декады+- {lag}",
		"MONTHLY_FORECAST_DETAILS": "(Monthly) Периодический месячный прогноз. Дата выпуска: 1-й день Месяца +- {lag}",
		"SEARCH_STATION_CODE": "Поиск станции по индексу станции",
		"BACK_TO_STATION_LIST": "Вернуться к списку станций",
		"FIRST_PAGE": "Первая страница",
		"PREVIOUS_PAGE": "Предыдущая страница",
		"NEXT_PAGE": "Следущая страница",
		"LAST_PAGE": "Последняя страница",
		"PROCESS": "Обрабатывать",
		"SNOW_COVER_DEVELOPMENT": "Snow cover development",
		"SNOW_COVER_MAP": "Snow cover map",
		"MEAN_CATCHMENT_NDSI": "Mean Catchment NDSI",
		"NDSI_NORM": "NDSI Norm",
		"MONTHLY_VALUES": "Monthly Values",
		"CATCHMENT_AREA_SETUP": "Catchment area setup",
		"DELETE_CATCHMENT_CONFIRM": "Are you sure you want to delete the catchment area file? Please consider exporting the data if you wish to proceed because the current data won't be accessible anymore.",
		"NORMALIZED_DIFF_SNOW_INDEX_MAP": "Normalized-Difference Snow Index (NDSI) Map",
		"RED": "Red",
		"DARK_BLUE": "Dark blue",
		"LOW_NDSI": "Low NDSI",
		"HIGH_NDSI": "High NDSI",
		"NO_DATA": "нет данных",
		"CURRENT": "ток",
		"SELECT_FORECASTING_PERIOD": "Vyberite period prognozirovaniya",
		"YEAR_TYPE": "тип года",
		"HYDRO_YEAR": "гидрологический год",
		"CALENDAR_YEAR": "календарный год"
	};

/***/ }
]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/